/*
 * International Telephone Input v18.1.4
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

!function(a){"object"==typeof module&&module.exports?module.exports=a():window.intlTelInput=a()}(function(a){"use strict";return function(){function b(a){for(var b=1;b<arguments.length;b++){var d=null!=arguments[b]?Object(arguments[b]):{},e=Object.keys(d);"function"==typeof Object.getOwnPropertySymbols&&e.push.apply(e,Object.getOwnPropertySymbols(d).filter(function(a){return Object.getOwnPropertyDescriptor(d,a).enumerable})),e.forEach(function(b){c(a,b,d[b])})}return a}function c(a,b,c){return b=g(b),b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function d(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function e(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,g(d.key),d)}}function f(a,b,c){return b&&e(a.prototype,b),c&&e(a,c),Object.defineProperty(a,"prototype",{writable:!1}),a}function g(a){var b=h(a,"string");return"symbol"==typeof b?b:String(b)}function h(b,c){if("object"!=typeof b||null===b)return b;var d=b[Symbol.toPrimitive];if(d!==a){var e=d.call(b,c||"default");if("object"!=typeof e)return e;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===c?String:Number)(b)}for(var i=[["Afghanistan (‫افغانستان‬‎)","af","93"],["Albania (Shqipëri)","al","355"],["Algeria (‫الجزائر‬‎)","dz","213"],["American Samoa","as","1",5,["684"]],["Andorra","ad","376"],["Angola","ao","244"],["Anguilla","ai","1",6,["264"]],["Antigua and Barbuda","ag","1",7,["268"]],["Argentina","ar","54"],["Armenia (Հայաստան)","am","374"],["Aruba","aw","297"],["Ascension Island","ac","247"],["Australia","au","61",0],["Austria (Österreich)","at","43"],["Azerbaijan (Azərbaycan)","az","994"],["Bahamas","bs","1",8,["242"]],["Bahrain (‫البحرين‬‎)","bh","973"],["Bangladesh (বাংলাদেশ)","bd","880"],["Barbados","bb","1",9,["246"]],["Belarus (Беларусь)","by","375"],["Belgium (België)","be","32"],["Belize","bz","501"],["Benin (Bénin)","bj","229"],["Bermuda","bm","1",10,["441"]],["Bhutan (འབྲུག)","bt","975"],["Bolivia","bo","591"],["Bosnia and Herzegovina (Босна и Херцеговина)","ba","387"],["Botswana","bw","267"],["Brazil (Brasil)","br","55"],["British Indian Ocean Territory","io","246"],["British Virgin Islands","vg","1",11,["284"]],["Brunei","bn","673"],["Bulgaria (България)","bg","359"],["Burkina Faso","bf","226"],["Burundi (Uburundi)","bi","257"],["Cambodia (កម្ពុជា)","kh","855"],["Cameroon (Cameroun)","cm","237"],["Canada","ca","1",1,["204","226","236","249","250","263","289","306","343","354","365","367","368","382","387","403","416","418","428","431","437","438","450","584","468","474","506","514","519","548","579","581","584","587","604","613","639","647","672","683","705","709","742","753","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde (Kabu Verdi)","cv","238"],["Caribbean Netherlands","bq","599",1,["3","4","7"]],["Cayman Islands","ky","1",12,["345"]],["Central African Republic (République centrafricaine)","cf","236"],["Chad (Tchad)","td","235"],["Chile","cl","56"],["China (中国)","cn","86"],["Christmas Island","cx","61",2,["89164"]],["Cocos (Keeling) Islands","cc","61",1,["89162"]],["Colombia","co","57"],["Comoros (‫جزر القمر‬‎)","km","269"],["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)","cd","243"],["Congo (Republic) (Congo-Brazzaville)","cg","242"],["Cook Islands","ck","682"],["Costa Rica","cr","506"],["Côte d’Ivoire","ci","225"],["Croatia (Hrvatska)","hr","385"],["Cuba","cu","53"],["Curaçao","cw","599",0],["Cyprus (Κύπρος)","cy","357"],["Czech Republic (Česká republika)","cz","420"],["Denmark (Danmark)","dk","45"],["Djibouti","dj","253"],["Dominica","dm","1",13,["767"]],["Dominican Republic (República Dominicana)","do","1",2,["809","829","849"]],["Ecuador","ec","593"],["Egypt (‫مصر‬‎)","eg","20"],["El Salvador","sv","503"],["Equatorial Guinea (Guinea Ecuatorial)","gq","240"],["Eritrea","er","291"],["Estonia (Eesti)","ee","372"],["Eswatini","sz","268"],["Ethiopia","et","251"],["Falkland Islands (Islas Malvinas)","fk","500"],["Faroe Islands (Føroyar)","fo","298"],["Fiji","fj","679"],["Finland (Suomi)","fi","358",0],["France","fr","33"],["French Guiana (Guyane française)","gf","594"],["French Polynesia (Polynésie française)","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia (საქართველო)","ge","995"],["Germany (Deutschland)","de","49"],["Ghana (Gaana)","gh","233"],["Gibraltar","gi","350"],["Greece (Ελλάδα)","gr","30"],["Greenland (Kalaallit Nunaat)","gl","299"],["Grenada","gd","1",14,["473"]],["Guadeloupe","gp","590",0],["Guam","gu","1",15,["671"]],["Guatemala","gt","502"],["Guernsey","gg","44",1,["1481","7781","7839","7911"]],["Guinea (Guinée)","gn","224"],["Guinea-Bissau (Guiné Bissau)","gw","245"],["Guyana","gy","592"],["Haiti","ht","509"],["Honduras","hn","504"],["Hong Kong (香港)","hk","852"],["Hungary (Magyarország)","hu","36"],["Iceland (Ísland)","is","354"],["India (भारत)","in","91"],["Indonesia","id","62"],["Iran (‫ایران‬‎)","ir","98"],["Iraq (‫العراق‬‎)","iq","964"],["Ireland","ie","353"],["Isle of Man","im","44",2,["1624","74576","7524","7924","7624"]],["Israel (‫ישראל‬‎)","il","972"],["Italy (Italia)","it","39",0],["Jamaica","jm","1",4,["876","658"]],["Japan (日本)","jp","81"],["Jersey","je","44",3,["1534","7509","7700","7797","7829","7937"]],["Jordan (‫الأردن‬‎)","jo","962"],["Kazakhstan (Казахстан)","kz","7",1,["33","7"]],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait (‫الكويت‬‎)","kw","965"],["Kyrgyzstan (Кыргызстан)","kg","996"],["Laos (ລາວ)","la","856"],["Latvia (Latvija)","lv","371"],["Lebanon (‫لبنان‬‎)","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya (‫ليبيا‬‎)","ly","218"],["Liechtenstein","li","423"],["Lithuania (Lietuva)","lt","370"],["Luxembourg","lu","352"],["Macau (澳門)","mo","853"],["Madagascar (Madagasikara)","mg","261"],["Malawi","mw","265"],["Malaysia","my","60"],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania (‫موريتانيا‬‎)","mr","222"],["Mauritius (Moris)","mu","230"],["Mayotte","yt","262",1,["269","639"]],["Mexico (México)","mx","52"],["Micronesia","fm","691"],["Moldova (Republica Moldova)","md","373"],["Monaco","mc","377"],["Mongolia (Монгол)","mn","976"],["Montenegro (Crna Gora)","me","382"],["Montserrat","ms","1",16,["664"]],["Morocco (‫المغرب‬‎)","ma","212",0],["Mozambique (Moçambique)","mz","258"],["Myanmar (Burma) (မြန်မာ)","mm","95"],["Namibia (Namibië)","na","264"],["Nauru","nr","674"],["Nepal (नेपाल)","np","977"],["Netherlands (Nederland)","nl","31"],["New Caledonia (Nouvelle-Calédonie)","nc","687"],["New Zealand","nz","64"],["Nicaragua","ni","505"],["Niger (Nijar)","ne","227"],["Nigeria","ng","234"],["Niue","nu","683"],["Norfolk Island","nf","672"],["North Korea (조선 민주주의 인민 공화국)","kp","850"],["North Macedonia (Северна Македонија)","mk","389"],["Northern Mariana Islands","mp","1",17,["670"]],["Norway (Norge)","no","47",0],["Oman (‫عُمان‬‎)","om","968"],["Pakistan (‫پاکستان‬‎)","pk","92"],["Palau","pw","680"],["Palestine (‫فلسطين‬‎)","ps","970"],["Panama (Panamá)","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru (Perú)","pe","51"],["Philippines","ph","63"],["Poland (Polska)","pl","48"],["Portugal","pt","351"],["Puerto Rico","pr","1",3,["787","939"]],["Qatar (‫قطر‬‎)","qa","974"],["Réunion (La Réunion)","re","262",0],["Romania (România)","ro","40"],["Russia (Россия)","ru","7",0],["Rwanda","rw","250"],["Saint Barthélemy","bl","590",1],["Saint Helena","sh","290"],["Saint Kitts and Nevis","kn","1",18,["869"]],["Saint Lucia","lc","1",19,["758"]],["Saint Martin (Saint-Martin (partie française))","mf","590",2],["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)","pm","508"],["Saint Vincent and the Grenadines","vc","1",20,["784"]],["Samoa","ws","685"],["San Marino","sm","378"],["São Tomé and Príncipe (São Tomé e Príncipe)","st","239"],["Saudi Arabia (‫المملكة العربية السعودية‬‎)","sa","966"],["Senegal (Sénégal)","sn","221"],["Serbia (Србија)","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65"],["Sint Maarten","sx","1",21,["721"]],["Slovakia (Slovensko)","sk","421"],["Slovenia (Slovenija)","si","386"],["Solomon Islands","sb","677"],["Somalia (Soomaaliya)","so","252"],["South Africa","za","27"],["South Korea (대한민국)","kr","82"],["South Sudan (‫جنوب السودان‬‎)","ss","211"],["Spain (España)","es","34"],["Sri Lanka (ශ්‍රී ලංකාව)","lk","94"],["Sudan (‫السودان‬‎)","sd","249"],["Suriname","sr","597"],["Svalbard and Jan Mayen","sj","47",1,["79"]],["Sweden (Sverige)","se","46"],["Switzerland (Schweiz)","ch","41"],["Syria (‫سوريا‬‎)","sy","963"],["Taiwan (台灣)","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand (ไทย)","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tokelau","tk","690"],["Tonga","to","676"],["Trinidad and Tobago","tt","1",22,["868"]],["Tunisia (‫تونس‬‎)","tn","216"],["Turkey (Türkiye)","tr","90"],["Turkmenistan","tm","993"],["Turks and Caicos Islands","tc","1",23,["649"]],["Tuvalu","tv","688"],["U.S. Virgin Islands","vi","1",24,["340"]],["Uganda","ug","256"],["Ukraine (Україна)","ua","380"],["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)","ae","971"],["United Kingdom","gb","44",0],["United States","us","1",0],["Uruguay","uy","598"],["Uzbekistan (Oʻzbekiston)","uz","998"],["Vanuatu","vu","678"],["Vatican City (Città del Vaticano)","va","39",1,["06698"]],["Venezuela","ve","58"],["Vietnam (Việt Nam)","vn","84"],["Wallis and Futuna (Wallis-et-Futuna)","wf","681"],["Western Sahara (‫الصحراء الغربية‬‎)","eh","212",1,["5288","5289"]],["Yemen (‫اليمن‬‎)","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"],["Åland Islands","ax","358",1,["18"]]],j=0;j<i.length;j++){var k=i[j];i[j]={name:k[0],iso2:k[1],dialCode:k[2],priority:k[3]||0,areaCodes:k[4]||null}}var l={getInstance:function(a){var b=a.getAttribute("data-intl-tel-input-id");return window.intlTelInputGlobals.instances[b]},instances:{},documentReady:function(){return"complete"===document.readyState}};"object"==typeof window&&(window.intlTelInputGlobals=l);var m=0,n={allowDropdown:!0,autoInsertDialCode:!1,autoPlaceholder:"polite",customContainer:"",customPlaceholder:null,dropdownContainer:null,excludeCountries:[],formatOnDisplay:!0,geoIpLookup:null,hiddenInput:"",initialCountry:"",localizedCountries:null,nationalMode:!0,onlyCountries:[],placeholderNumberType:"MOBILE",preferredCountries:["us","gb"],separateDialCode:!1,showFlags:!0,utilsScript:""},o=["800","822","833","844","855","866","877","880","881","882","883","884","885","886","887","888","889"],p=function(a,b){for(var c=Object.keys(a),d=0;d<c.length;d++)b(c[d],a[c[d]])},q=function(a){p(window.intlTelInputGlobals.instances,function(b){window.intlTelInputGlobals.instances[b][a]()})},r=function(){function c(a,b){var e=this;d(this,c),this.id=m++,this.a=a,this.b=null,this.c=null;var f=b||{};this.d={},p(n,function(a,b){e.d[a]=f.hasOwnProperty(a)?f[a]:b}),this.e=Boolean(a.getAttribute("placeholder"))}return f(c,[{key:"_init",value:function(){var a=this;this.d.nationalMode&&(this.d.autoInsertDialCode=!1),this.d.separateDialCode&&(this.d.autoInsertDialCode=!1);var b=this.d.allowDropdown&&!this.d.separateDialCode;if(!this.d.showFlags&&b&&(this.d.showFlags=!0),this.g=/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),this.g&&(document.body.classList.add("iti-mobile"),this.d.dropdownContainer||(this.d.dropdownContainer=document.body)),"undefined"!=typeof Promise){var c=new Promise(function(b,c){a.h=b,a.i=c}),d=new Promise(function(b,c){a.i0=b,a.i1=c});this.promise=Promise.all([c,d])}else this.h=this.i=function(){},this.i0=this.i1=function(){};this.s={},this._b(),this._f(),this._h(),this._i(),this._i3()}},{key:"_b",value:function(){this._d(),this._d2(),this._e(),this.d.localizedCountries&&this._d0(),(this.d.onlyCountries.length||this.d.localizedCountries)&&this.p.sort(this._d1)}},{key:"_c",value:function(b,c,d){c.length>this.countryCodeMaxLen&&(this.countryCodeMaxLen=c.length),this.q.hasOwnProperty(c)||(this.q[c]=[]);for(var e=0;e<this.q[c].length;e++)if(this.q[c][e]===b)return;var f=d!==a?d:this.q[c].length;this.q[c][f]=b}},{key:"_d",value:function(){if(this.d.onlyCountries.length){var a=this.d.onlyCountries.map(function(a){return a.toLowerCase()});this.p=i.filter(function(b){return a.indexOf(b.iso2)>-1})}else if(this.d.excludeCountries.length){var b=this.d.excludeCountries.map(function(a){return a.toLowerCase()});this.p=i.filter(function(a){return-1===b.indexOf(a.iso2)})}else this.p=i}},{key:"_d0",value:function(){for(var a=0;a<this.p.length;a++){var b=this.p[a].iso2.toLowerCase();this.d.localizedCountries.hasOwnProperty(b)&&(this.p[a].name=this.d.localizedCountries[b])}}},{key:"_d1",value:function(a,b){return a.name<b.name?-1:a.name>b.name?1:0}},{key:"_d2",value:function(){this.countryCodeMaxLen=0,this.dialCodes={},this.q={};for(var a=0;a<this.p.length;a++){var b=this.p[a];this.dialCodes[b.dialCode]||(this.dialCodes[b.dialCode]=!0),this._c(b.iso2,b.dialCode,b.priority)}for(var c=0;c<this.p.length;c++){var d=this.p[c];if(d.areaCodes)for(var e=this.q[d.dialCode][0],f=0;f<d.areaCodes.length;f++){for(var g=d.areaCodes[f],h=1;h<g.length;h++){var i=d.dialCode+g.substr(0,h);this._c(e,i),this._c(d.iso2,i)}this._c(d.iso2,d.dialCode+g)}}}},{key:"_e",value:function(){this.preferredCountries=[];for(var a=0;a<this.d.preferredCountries.length;a++){var b=this.d.preferredCountries[a].toLowerCase(),c=this._y(b,!1,!0);c&&this.preferredCountries.push(c)}}},{key:"_e2",value:function(a,b,c){var d=document.createElement(a);return b&&p(b,function(a,b){return d.setAttribute(a,b)}),c&&c.appendChild(d),d}},{key:"_f",value:function(){this.a.hasAttribute("autocomplete")||this.a.form&&this.a.form.hasAttribute("autocomplete")||this.a.setAttribute("autocomplete","off");var a=this.d,c=a.allowDropdown,d=a.separateDialCode,e=a.showFlags,f=a.customContainer,g=a.hiddenInput,h=a.dropdownContainer,i="iti";c&&(i+=" iti--allow-dropdown"),d&&(i+=" iti--separate-dial-code"),e&&(i+=" iti--show-flags"),f&&(i+=" ".concat(f));var j=this._e2("div",{"class":i});this.a.parentNode.insertBefore(j,this.a);var k=c||e||d;if(k&&(this.k=this._e2("div",{"class":"iti__flag-container"},j)),j.appendChild(this.a),k&&(this.selectedFlag=this._e2("div",b({"class":"iti__selected-flag"},c&&{role:"combobox","aria-haspopup":"listbox","aria-controls":"iti-".concat(this.id,"__country-listbox"),"aria-owns":"iti-".concat(this.id,"__country-listbox"),"aria-expanded":"false","aria-label":"Telephone country code"}),this.k)),e&&(this.l=this._e2("div",{"class":"iti__flag"},this.selectedFlag)),this.selectedFlag&&this.a.disabled&&this.selectedFlag.setAttribute("aria-disabled","true"),d&&(this.t=this._e2("div",{"class":"iti__selected-dial-code"},this.selectedFlag)),c&&(this.a.disabled||this.selectedFlag.setAttribute("tabindex","0"),this.u=this._e2("div",{"class":"iti__arrow"},this.selectedFlag),this.m=this._e2("ul",{"class":"iti__country-list iti__hide",id:"iti-".concat(this.id,"__country-listbox"),role:"listbox","aria-label":"List of countries"}),this.preferredCountries.length&&(this._g(this.preferredCountries,"iti__preferred",!0),this._e2("li",{"class":"iti__divider",role:"separator","aria-disabled":"true"},this.m)),this._g(this.p,"iti__standard"),h?(this.dropdown=this._e2("div",{"class":"iti iti--container"}),this.dropdown.appendChild(this.m)):this.k.appendChild(this.m)),g){var l=g,m=this.a.getAttribute("name");if(m){var n=m.lastIndexOf("[");-1!==n&&(l="".concat(m.substr(0,n),"[").concat(l,"]"))}this.hiddenInput=this._e2("input",{type:"hidden",name:l}),j.appendChild(this.hiddenInput)}}},{key:"_g",value:function(a,b,c){for(var d="",e=0;e<a.length;e++){var f=a[e],g=c?"-preferred":"";d+="<li class='iti__country ".concat(b,"' tabIndex='-1' id='iti-").concat(this.id,"__item-").concat(f.iso2).concat(g,"' role='option' data-dial-code='").concat(f.dialCode,"' data-country-code='").concat(f.iso2,"' aria-selected='false'>"),this.d.showFlags&&(d+="<div class='iti__flag-box'><div class='iti__flag iti__".concat(f.iso2,"'></div></div>")),d+="<span class='iti__country-name'>".concat(f.name,"</span>"),d+="<span class='iti__dial-code'>+".concat(f.dialCode,"</span>"),d+="</li>"}this.m.insertAdjacentHTML("beforeend",d)}},{key:"_h",value:function(){var a=this.a.getAttribute("value"),b=this.a.value,c=a&&"+"===a.charAt(0)&&(!b||"+"!==b.charAt(0)),d=c?a:b,e=this._5(d),f=this._w(d),g=this.d,h=g.initialCountry,i=g.autoInsertDialCode;e&&!f?this._v(d):"auto"!==h&&(h?this._z(h.toLowerCase()):e&&f?this._z("us"):(this.j=this.preferredCountries.length?this.preferredCountries[0].iso2:this.p[0].iso2,d||this._z(this.j)),!d&&i&&(this.a.value="+".concat(this.s.dialCode))),d&&this._u(d)}},{key:"_i",value:function(){this._j(),this.d.autoInsertDialCode&&this._l(),this.d.allowDropdown&&this._i2(),this.hiddenInput&&this._i0()}},{key:"_i0",value:function(){var a=this;this._a14=function(){a.hiddenInput.value=a.getNumber()},this.a.form&&this.a.form.addEventListener("submit",this._a14)}},{key:"_i1",value:function(){for(var a=this.a;a&&"LABEL"!==a.tagName;)a=a.parentNode;return a}},{key:"_i2",value:function(){var a=this;this._a9=function(b){a.m.classList.contains("iti__hide")?a.a.focus():b.preventDefault()};var b=this._i1();b&&b.addEventListener("click",this._a9),this._a10=function(){!a.m.classList.contains("iti__hide")||a.a.disabled||a.a.readOnly||a._n()},this.selectedFlag.addEventListener("click",this._a10),this._a11=function(b){a.m.classList.contains("iti__hide")&&-1!==["ArrowUp","Up","ArrowDown","Down"," ","Enter"].indexOf(b.key)&&(b.preventDefault(),b.stopPropagation(),a._n()),"Tab"===b.key&&a._2()},this.k.addEventListener("keydown",this._a11)}},{key:"_i3",value:function(){var a=this;this.d.utilsScript&&!window.intlTelInputUtils?window.intlTelInputGlobals.documentReady()?window.intlTelInputGlobals.loadUtils(this.d.utilsScript):window.addEventListener("load",function(){window.intlTelInputGlobals.loadUtils(a.d.utilsScript)}):this.i0(),"auto"===this.d.initialCountry?this._i4():this.h()}},{key:"_i4",value:function(){window.intlTelInputGlobals.autoCountry?this.handleAutoCountry():window.intlTelInputGlobals.startedLoadingAutoCountry||(window.intlTelInputGlobals.startedLoadingAutoCountry=!0,"function"==typeof this.d.geoIpLookup&&this.d.geoIpLookup(function(a){window.intlTelInputGlobals.autoCountry=a.toLowerCase(),setTimeout(function(){return q("handleAutoCountry")})},function(){return q("rejectAutoCountryPromise")}))}},{key:"_j",value:function(){var a=this;this._a12=function(){a._v(a.a.value)&&a._m2CountryChange()},this.a.addEventListener("keyup",this._a12),this._a13=function(){setTimeout(a._a12)},this.a.addEventListener("cut",this._a13),this.a.addEventListener("paste",this._a13)}},{key:"_j2",value:function(a){var b=this.a.getAttribute("maxlength");return b&&a.length>b?a.substr(0,b):a}},{key:"_l",value:function(){var a=this;this._a8=function(){a._l2()},this.a.form&&this.a.form.addEventListener("submit",this._a8),this.a.addEventListener("blur",this._a8)}},{key:"_l2",value:function(){if("+"===this.a.value.charAt(0)){var a=this._m(this.a.value);a&&this.s.dialCode!==a||(this.a.value="")}}},{key:"_m",value:function(a){return a.replace(/\D/g,"")}},{key:"_m2",value:function(a){var b=document.createEvent("Event");b.initEvent(a,!0,!0),this.a.dispatchEvent(b)}},{key:"_n",value:function(){this.m.classList.remove("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","true"),this._o(),this.b&&(this._x(this.b,!1),this._3(this.b,!0)),this._p(),this.u.classList.add("iti__arrow--up"),this._m2("open:countrydropdown")}},{key:"_n2",value:function(a,b,c){c&&!a.classList.contains(b)?a.classList.add(b):!c&&a.classList.contains(b)&&a.classList.remove(b)}},{key:"_o",value:function(){var a=this;if(this.d.dropdownContainer&&this.d.dropdownContainer.appendChild(this.dropdown),!this.g){var b=this.a.getBoundingClientRect(),c=window.pageYOffset||document.documentElement.scrollTop,d=b.top+c,e=this.m.offsetHeight,f=d+this.a.offsetHeight+e<c+window.innerHeight,g=d-e>c;if(this._n2(this.m,"iti__country-list--dropup",!f&&g),this.d.dropdownContainer){var h=!f&&g?0:this.a.offsetHeight;this.dropdown.style.top="".concat(d+h,"px"),this.dropdown.style.left="".concat(b.left+document.body.scrollLeft,"px"),this._a4=function(){return a._2()},window.addEventListener("scroll",this._a4)}}}},{key:"_o2",value:function(a){for(var b=a;b&&b!==this.m&&!b.classList.contains("iti__country");)b=b.parentNode;return b===this.m?null:b}},{key:"_p",value:function(){var a=this;this._a0=function(b){var c=a._o2(b.target);c&&a._x(c,!1)},this.m.addEventListener("mouseover",this._a0),this._a1=function(b){var c=a._o2(b.target);c&&a._1(c)},this.m.addEventListener("click",this._a1);var b=!0;this._a2=function(){b||a._2(),b=!1},document.documentElement.addEventListener("click",this._a2);var c="",d=null;this._a3=function(b){b.preventDefault(),"ArrowUp"===b.key||"Up"===b.key||"ArrowDown"===b.key||"Down"===b.key?a._q(b.key):"Enter"===b.key?a._r():"Escape"===b.key?a._2():/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(b.key)&&(d&&clearTimeout(d),c+=b.key.toLowerCase(),a._s(c),d=setTimeout(function(){c=""},1e3))},document.addEventListener("keydown",this._a3)}},{key:"_q",value:function(a){var b="ArrowUp"===a||"Up"===a?this.c.previousElementSibling:this.c.nextElementSibling;b&&(b.classList.contains("iti__divider")&&(b="ArrowUp"===a||"Up"===a?b.previousElementSibling:b.nextElementSibling),this._x(b,!0))}},{key:"_r",value:function(){this.c&&this._1(this.c)}},{key:"_s",value:function(a){for(var b=0;b<this.p.length;b++)if(this._t(this.p[b].name,a)){var c=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(this.p[b].iso2));this._x(c,!1),this._3(c,!0);break}}},{key:"_t",value:function(a,b){return a.substr(0,b.length).toLowerCase()===b}},{key:"_u",value:function(a){var b=a;if(this.d.formatOnDisplay&&window.intlTelInputUtils&&this.s){var c=this.d.nationalMode||"+"!==b.charAt(0)&&!this.d.separateDialCode,d=intlTelInputUtils.numberFormat,e=d.NATIONAL,f=d.INTERNATIONAL,g=c?e:f;b=intlTelInputUtils.formatNumber(b,this.s.iso2,g)}b=this._7(b),this.a.value=b}},{key:"_v",value:function(a){var b=a,c=this.s.dialCode,d="1"===c;b&&d&&"+"!==b.charAt(0)&&("1"!==b.charAt(0)&&(b="1".concat(b)),b="+".concat(b)),this.d.separateDialCode&&c&&"+"!==b.charAt(0)&&(b="+".concat(c).concat(b));var e=this._5(b,!0),f=this._m(b),g=null;if(e){var h=this.q[this._m(e)],i=-1!==h.indexOf(this.s.iso2)&&f.length<=e.length-1;if(!("1"===c&&this._w(f))&&!i)for(var j=0;j<h.length;j++)if(h[j]){g=h[j];break}}else"+"===b.charAt(0)&&f.length?g="":b&&"+"!==b||(g=this.j);return null!==g&&this._z(g)}},{key:"_w",value:function(a){var b=this._m(a);if("1"===b.charAt(0)){var c=b.substr(1,3);return-1!==o.indexOf(c)}return!1}},{key:"_x",value:function(a,b){var c=this.c;c&&c.classList.remove("iti__highlight"),this.c=a,this.c.classList.add("iti__highlight"),this.selectedFlag.setAttribute("aria-activedescendant",a.getAttribute("id")),b&&this.c.focus()}},{key:"_y",value:function(a,b,c){for(var d=b?i:this.p,e=0;e<d.length;e++)if(d[e].iso2===a)return d[e];if(c)return null;throw new Error("No country data for '".concat(a,"'"))}},{key:"_z",value:function(a){var b=this.s.iso2?this.s:{};if(this.s=a?this._y(a,!1,!1):{},this.s.iso2&&(this.j=this.s.iso2),this.d.showFlags&&this.l.setAttribute("class","iti__flag iti__".concat(a)),this.selectedFlag){var c=a?"".concat(this.s.name,": +").concat(this.s.dialCode):"Unknown";this.selectedFlag.setAttribute("title",c)}if(this.d.separateDialCode){var d=this.s.dialCode?"+".concat(this.s.dialCode):"";this.t.innerHTML=d;var e=this.selectedFlag.offsetWidth||this._z2();this.a.style.paddingLeft="".concat(e+6,"px")}if(this._0(),this.d.allowDropdown){var f=this.b;if(f&&(f.classList.remove("iti__active"),f.setAttribute("aria-selected","false")),a){var g=this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a,"-preferred"))||this.m.querySelector("#iti-".concat(this.id,"__item-").concat(a));g.setAttribute("aria-selected","true"),g.classList.add("iti__active"),this.b=g}}return b.iso2!==a}},{key:"_z2",value:function(){var a=this.a.parentNode.cloneNode();a.style.visibility="hidden",document.body.appendChild(a);var b=this.k.cloneNode();a.appendChild(b);var c=this.selectedFlag.cloneNode(!0);b.appendChild(c);var d=c.offsetWidth;return a.parentNode.removeChild(a),d}},{key:"_0",value:function(){var a="aggressive"===this.d.autoPlaceholder||!this.e&&"polite"===this.d.autoPlaceholder;if(window.intlTelInputUtils&&a){var b=intlTelInputUtils.numberType[this.d.placeholderNumberType],c=this.s.iso2?intlTelInputUtils.getExampleNumber(this.s.iso2,this.d.nationalMode,b):"";c=this._7(c),"function"==typeof this.d.customPlaceholder&&(c=this.d.customPlaceholder(c,this.s)),this.a.setAttribute("placeholder",c)}}},{key:"_1",value:function(a){var b=this._z(a.getAttribute("data-country-code"));this._2(),this._4(a.getAttribute("data-dial-code")),this.a.focus();var c=this.a.value.length;this.a.setSelectionRange(c,c),b&&this._m2CountryChange()}},{key:"_2",value:function(){this.m.classList.add("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","false"),this.selectedFlag.removeAttribute("aria-activedescendant"),this.u.classList.remove("iti__arrow--up"),document.removeEventListener("keydown",this._a3),document.documentElement.removeEventListener("click",this._a2),this.m.removeEventListener("mouseover",this._a0),this.m.removeEventListener("click",this._a1),this.d.dropdownContainer&&(this.g||window.removeEventListener("scroll",this._a4),this.dropdown.parentNode&&this.dropdown.parentNode.removeChild(this.dropdown)),this._m2("close:countrydropdown")}},{key:"_3",value:function(a,b){var c=this.m,d=window.pageYOffset||document.documentElement.scrollTop,e=c.offsetHeight,f=c.getBoundingClientRect().top+d,g=f+e,h=a.offsetHeight,i=a.getBoundingClientRect().top+d,j=i+h,k=i-f+c.scrollTop,l=e/2-h/2;if(i<f)b&&(k-=l),c.scrollTop=k;else if(j>g){b&&(k+=l);var m=e-h;c.scrollTop=k-m}}},{key:"_4",value:function(a){var b,c=this.a.value,d="+".concat(a);if("+"===c.charAt(0)){var e=this._5(c);b=e?c.replace(e,d):d,this.a.value=b}else this.d.autoInsertDialCode&&(b=c?d+c:d,this.a.value=b)}},{key:"_5",value:function(a,b){var c="";if("+"===a.charAt(0))for(var d="",e=0;e<a.length;e++){var f=a.charAt(e);if(!isNaN(parseInt(f,10))){if(d+=f,b)this.q[d]&&(c=a.substr(0,e+1));else if(this.dialCodes[d]){c=a.substr(0,e+1);break}if(d.length===this.countryCodeMaxLen)break}}return c}},{key:"_6",value:function(){var a=this.a.value.trim(),b=this.s.dialCode,c=this._m(a);return(this.d.separateDialCode&&"+"!==a.charAt(0)&&b&&c?"+".concat(b):"")+a}},{key:"_7",value:function(a){var b=a;if(this.d.separateDialCode){var c=this._5(b);if(c){c="+".concat(this.s.dialCode);var d=" "===b[c.length]||"-"===b[c.length]?c.length+1:c.length;b=b.substr(d)}}return this._j2(b)}},{key:"_m2CountryChange",value:function(){this._m2("countrychange")}},{key:"handleAutoCountry",value:function(){"auto"===this.d.initialCountry&&(this.j=window.intlTelInputGlobals.autoCountry,this.a.value||this.setCountry(this.j),this.h())}},{key:"handleUtils",value:function(){window.intlTelInputUtils&&(this.a.value&&this._u(this.a.value),this._0()),this.i0()}},{key:"destroy",value:function(){var a=this.a.form;if(this.d.allowDropdown){
this._2(),this.selectedFlag.removeEventListener("click",this._a10),this.k.removeEventListener("keydown",this._a11);var b=this._i1();b&&b.removeEventListener("click",this._a9)}this.hiddenInput&&a&&a.removeEventListener("submit",this._a14),this.d.autoInsertDialCode&&(a&&a.removeEventListener("submit",this._a8),this.a.removeEventListener("blur",this._a8)),this.a.removeEventListener("keyup",this._a12),this.a.removeEventListener("cut",this._a13),this.a.removeEventListener("paste",this._a13),this.a.removeAttribute("data-intl-tel-input-id");var c=this.a.parentNode;c.parentNode.insertBefore(this.a,c),c.parentNode.removeChild(c),delete window.intlTelInputGlobals.instances[this.id]}},{key:"getExtension",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getExtension(this._6(),this.s.iso2):""}},{key:"getNumber",value:function(a){if(window.intlTelInputUtils){var b=this.s.iso2;return intlTelInputUtils.formatNumber(this._6(),b,a)}return""}},{key:"getNumberType",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getNumberType(this._6(),this.s.iso2):-99}},{key:"getSelectedCountryData",value:function(){return this.s}},{key:"getValidationError",value:function(){if(window.intlTelInputUtils){var a=this.s.iso2;return intlTelInputUtils.getValidationError(this._6(),a)}return-99}},{key:"isValidNumber",value:function(){var a=this._6().trim();return window.intlTelInputUtils?intlTelInputUtils.isValidNumber(a,this.s.iso2):null}},{key:"setCountry",value:function(a){var b=a.toLowerCase();this.s.iso2!==b&&(this._z(b),this._4(this.s.dialCode),this._m2CountryChange())}},{key:"setNumber",value:function(a){var b=this._v(a);this._u(a),b&&this._m2CountryChange()}},{key:"setPlaceholderNumberType",value:function(a){this.d.placeholderNumberType=a,this._0()}}]),c}();l.getCountryData=function(){return i};var s=function(a,b,c){var d=document.createElement("script");d.onload=function(){q("handleUtils"),b&&b()},d.onerror=function(){q("rejectUtilsScriptPromise"),c&&c()},d.className="iti-load-utils",d.async=!0,d.src=a,document.body.appendChild(d)};return l.loadUtils=function(a){if(!window.intlTelInputUtils&&!window.intlTelInputGlobals.startedLoadingUtilsScript){if(window.intlTelInputGlobals.startedLoadingUtilsScript=!0,"undefined"!=typeof Promise)return new Promise(function(b,c){return s(a,b,c)});s(a)}return null},l.defaults=n,l.version="18.1.4",function(a,b){var c=new r(a,b);return c._init(),a.setAttribute("data-intl-tel-input-id",c.id),window.intlTelInputGlobals.instances[c.id]=c,c}}()});
/*!
	Autosize 3.0.13
	license: MIT
	http://www.jacklmoore.com/autosize
*/
!function(e,t){if("function"==typeof define&&define.amd)define(["exports","module"],t);else if("undefined"!=typeof exports&&"undefined"!=typeof module)t(exports,module);else{var n={exports:{}};t(n.exports,n),e.autosize=n.exports}}(this,function(e,t){"use strict";function n(e){function t(){var t=window.getComputedStyle(e,null);c=t.overflowY,"vertical"===t.resize?e.style.resize="none":"both"===t.resize&&(e.style.resize="horizontal"),f="content-box"===t.boxSizing?-(parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)):parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth),isNaN(f)&&(f=0),i()}function n(t){var n=e.style.width;e.style.width="0px",e.offsetWidth,e.style.width=n,c=t,u&&(e.style.overflowY=t),o()}function o(){var t=window.pageYOffset,n=document.body.scrollTop,o=e.style.height;e.style.height="auto";var i=e.scrollHeight+f;return 0===e.scrollHeight?void(e.style.height=o):(e.style.height=i+"px",v=e.clientWidth,document.documentElement.scrollTop=t,void(document.body.scrollTop=n))}function i(){var t=e.style.height;o();var i=window.getComputedStyle(e,null);if(i.height!==e.style.height?"visible"!==c&&n("visible"):"hidden"!==c&&n("hidden"),t!==e.style.height){var r=document.createEvent("Event");r.initEvent("autosize:resized",!0,!1),e.dispatchEvent(r)}}var d=void 0===arguments[1]?{}:arguments[1],s=d.setOverflowX,l=void 0===s?!0:s,a=d.setOverflowY,u=void 0===a?!0:a;if(e&&e.nodeName&&"TEXTAREA"===e.nodeName&&!r.has(e)){var f=null,c=null,v=e.clientWidth,p=function(){e.clientWidth!==v&&i()},h=function(t){window.removeEventListener("resize",p),e.removeEventListener("input",i),e.removeEventListener("keyup",i),e.removeEventListener("autosize:destroy",h),r["delete"](e),Object.keys(t).forEach(function(n){e.style[n]=t[n]})}.bind(e,{height:e.style.height,resize:e.style.resize,overflowY:e.style.overflowY,overflowX:e.style.overflowX,wordWrap:e.style.wordWrap});e.addEventListener("autosize:destroy",h),"onpropertychange"in e&&"oninput"in e&&e.addEventListener("keyup",i),window.addEventListener("resize",p),e.addEventListener("input",i),e.addEventListener("autosize:update",i),r.add(e),l&&(e.style.overflowX="hidden",e.style.wordWrap="break-word"),t()}}function o(e){if(e&&e.nodeName&&"TEXTAREA"===e.nodeName){var t=document.createEvent("Event");t.initEvent("autosize:destroy",!0,!1),e.dispatchEvent(t)}}function i(e){if(e&&e.nodeName&&"TEXTAREA"===e.nodeName){var t=document.createEvent("Event");t.initEvent("autosize:update",!0,!1),e.dispatchEvent(t)}}var r="function"==typeof Set?new Set:function(){var e=[];return{has:function(t){return Boolean(e.indexOf(t)>-1)},add:function(t){e.push(t)},"delete":function(t){e.splice(e.indexOf(t),1)}}}(),d=null;"undefined"==typeof window||"function"!=typeof window.getComputedStyle?(d=function(e){return e},d.destroy=function(e){return e},d.update=function(e){return e}):(d=function(e,t){return e&&Array.prototype.forEach.call(e.length?e:[e],function(e){return n(e,t)}),e},d.destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],o),e},d.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],i),e}),t.exports=d});
/*!
 * jQuery Validation Plugin v1.14.0
 *
 * http://jqueryvalidation.org/
 *
 * Copyright (c) 2015 Jörn Zaefferer
 * Released under the MIT license
 */
(function( factory ) {
	if ( typeof define === "function" && define.amd ) {
		define( ["jquery"], factory );
	} else {
		factory( jQuery );
	}
}(function( $ ) {

$.extend($.fn, {
	// http://jqueryvalidation.org/validate/
	validate: function( options ) {

		// if nothing is selected, return nothing; can't chain anyway
		if ( !this.length ) {
			if ( options && options.debug && window.console ) {
				console.warn( "Nothing selected, can't validate, returning nothing." );
			}
			return;
		}

		// check if a validator for this form was already created
		var validator = $.data( this[ 0 ], "validator" );
		if ( validator ) {
			return validator;
		}

		// Add novalidate tag if HTML5.
		this.attr( "novalidate", "novalidate" );

		validator = new $.validator( options, this[ 0 ] );
		$.data( this[ 0 ], "validator", validator );

		if ( validator.settings.onsubmit ) {

			this.on( "click.validate", ":submit", function( event ) {
				if ( validator.settings.submitHandler ) {
					validator.submitButton = event.target;
				}

				// allow suppressing validation by adding a cancel class to the submit button
				if ( $( this ).hasClass( "cancel" ) ) {
					validator.cancelSubmit = true;
				}

				// allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
				if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
					validator.cancelSubmit = true;
				}
			});

			// validate the form on submit
			this.on( "submit.validate", function( event ) {
				if ( validator.settings.debug ) {
					// prevent form submit to be able to see console output
					event.preventDefault();
				}
				function handle() {
					var hidden, result;
					if ( validator.settings.submitHandler ) {
						if ( validator.submitButton ) {
							// insert a hidden input as a replacement for the missing submit button
							hidden = $( "<input type='hidden'/>" )
								.attr( "name", validator.submitButton.name )
								.val( $( validator.submitButton ).val() )
								.appendTo( validator.currentForm );
						}
						result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
						if ( validator.submitButton ) {
							// and clean up afterwards; thanks to no-block-scope, hidden can be referenced
							hidden.remove();
						}
						if ( result !== undefined ) {
							return result;
						}
						return false;
					}
					return true;
				}

				// prevent submit for invalid forms or custom submit handlers
				if ( validator.cancelSubmit ) {
					validator.cancelSubmit = false;
					return handle();
				}
				if ( validator.form() ) {
					if ( validator.pendingRequest ) {
						validator.formSubmitted = true;
						return false;
					}
					return handle();
				} else {
					validator.focusInvalid();
					return false;
				}
			});
		}

		return validator;
	},
	// http://jqueryvalidation.org/valid/
	valid: function() {
		var valid, validator, errorList;

		if ( $( this[ 0 ] ).is( "form" ) ) {
			valid = this.validate().form();
		} else {
			errorList = [];
			valid = true;
			validator = $( this[ 0 ].form ).validate();
			this.each( function() {
				valid = validator.element( this ) && valid;
				errorList = errorList.concat( validator.errorList );
			});
			validator.errorList = errorList;
		}
		return valid;
	},

	// http://jqueryvalidation.org/rules/
	rules: function( command, argument ) {
		var element = this[ 0 ],
			settings, staticRules, existingRules, data, param, filtered;

		if ( command ) {
			settings = $.data( element.form, "validator" ).settings;
			staticRules = settings.rules;
			existingRules = $.validator.staticRules( element );
			switch ( command ) {
			case "add":
				$.extend( existingRules, $.validator.normalizeRule( argument ) );
				// remove messages from rules, but allow them to be set separately
				delete existingRules.messages;
				staticRules[ element.name ] = existingRules;
				if ( argument.messages ) {
					settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
				}
				break;
			case "remove":
				if ( !argument ) {
					delete staticRules[ element.name ];
					return existingRules;
				}
				filtered = {};
				$.each( argument.split( /\s/ ), function( index, method ) {
					filtered[ method ] = existingRules[ method ];
					delete existingRules[ method ];
					if ( method === "required" ) {
						$( element ).removeAttr( "aria-required" );
					}
				});
				return filtered;
			}
		}

		data = $.validator.normalizeRules(
		$.extend(
			{},
			$.validator.classRules( element ),
			$.validator.attributeRules( element ),
			$.validator.dataRules( element ),
			$.validator.staticRules( element )
		), element );

		// make sure required is at front
		if ( data.required ) {
			param = data.required;
			delete data.required;
			data = $.extend( { required: param }, data );
			$( element ).attr( "aria-required", "true" );
		}

		// make sure remote is at back
		if ( data.remote ) {
			param = data.remote;
			delete data.remote;
			data = $.extend( data, { remote: param });
		}

		return data;
	}
});

// Custom selectors
$.extend( $.expr[ ":" ], {
	// http://jqueryvalidation.org/blank-selector/
	blank: function( a ) {
		return !$.trim( "" + $( a ).val() );
	},
	// http://jqueryvalidation.org/filled-selector/
	filled: function( a ) {
		return !!$.trim( "" + $( a ).val() );
	},
	// http://jqueryvalidation.org/unchecked-selector/
	unchecked: function( a ) {
		return !$( a ).prop( "checked" );
	}
});

// constructor for validator
$.validator = function( options, form ) {
	this.settings = $.extend( true, {}, $.validator.defaults, options );
	this.currentForm = form;
	this.init();
};

// http://jqueryvalidation.org/jQuery.validator.format/
$.validator.format = function( source, params ) {
	if ( arguments.length === 1 ) {
		return function() {
			var args = $.makeArray( arguments );
			args.unshift( source );
			return $.validator.format.apply( this, args );
		};
	}
	if ( arguments.length > 2 && params.constructor !== Array  ) {
		params = $.makeArray( arguments ).slice( 1 );
	}
	if ( params.constructor !== Array ) {
		params = [ params ];
	}
	$.each( params, function( i, n ) {
		source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
			return n;
		});
	});
	return source;
};

$.extend( $.validator, {

	defaults: {
		messages: {},
		groups: {},
		rules: {},
		errorClass: "error",
		validClass: "valid",
		errorElement: "label",
		focusCleanup: false,
		focusInvalid: true,
		errorContainer: $( [] ),
		errorLabelContainer: $( [] ),
		onsubmit: true,
		ignore: ":hidden",
		ignoreTitle: false,
		onfocusin: function( element ) {
			this.lastActive = element;

			// Hide error label and remove error class on focus if enabled
			if ( this.settings.focusCleanup ) {
				if ( this.settings.unhighlight ) {
					this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
				}
				this.hideThese( this.errorsFor( element ) );
			}
		},
		onfocusout: function( element, event ) {
			if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
				if ( event && event.relatedTarget && $( event.relatedTarget ).is( ":submit, button[type='submit'], input[type='submit']" ) ) {
					return;
				}
				var validator = this;
				setTimeout(function() {
					validator.element( element );
				}, 0);
			}
		},
		onkeyup: function( element, event ) {
			// Avoid revalidate the field when pressing one of the following keys
			// Shift       => 16
			// Ctrl        => 17
			// Alt         => 18
			// Caps lock   => 20
			// End         => 35
			// Home        => 36
			// Left arrow  => 37
			// Up arrow    => 38
			// Right arrow => 39
			// Down arrow  => 40
			// Insert      => 45
			// Num lock    => 144
			// AltGr key   => 225
			var excludedKeys = [
				16, 17, 18, 20, 35, 36, 37,
				38, 39, 40, 45, 144, 225
			];

			if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
				return;
			} else if ( element.name in this.submitted || element === this.lastElement ) {
				this.element( element );
			}
		},
		onclick: function( element ) {
			// click on selects, radiobuttons and checkboxes
			if ( element.name in this.submitted ) {
				this.element( element );

			// or option elements, check parent select in that case
			} else if ( element.parentNode.name in this.submitted ) {
				this.element( element.parentNode );
			}
		},
		highlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
			} else {
				$( element ).addClass( errorClass ).removeClass( validClass );
			}
		},
		unhighlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
			} else {
				$( element ).removeClass( errorClass ).addClass( validClass );
			}
		}
	},

	// http://jqueryvalidation.org/jQuery.validator.setDefaults/
	setDefaults: function( settings ) {
		$.extend( $.validator.defaults, settings );
	},

	messages: {
		required: "This field is required.",
		remote: "Please fix this field.",
		email: "Please enter a valid email address.",
		url: "Please enter a valid URL.",
		date: "Please enter a valid date.",
		dateISO: "Please enter a valid date ( ISO ).",
		number: "Please enter a valid number.",
		digits: "Please enter only digits.",
		creditcard: "Please enter a valid credit card number.",
		equalTo: "Please enter the same value again.",
		maxlength: $.validator.format( "Please enter no more than {0} characters." ),
		minlength: $.validator.format( "Please enter at least {0} characters." ),
		rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
		range: $.validator.format( "Please enter a value between {0} and {1}." ),
		max: $.validator.format( "Please enter a value less than or equal to {0}." ),
		min: $.validator.format( "Please enter a value greater than or equal to {0}." )
	},

	autoCreateRanges: false,

	prototype: {

		init: function() {
			this.labelContainer = $( this.settings.errorLabelContainer );
			this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
			this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
			this.submitted = {};
			this.valueCache = {};
			this.pendingRequest = 0;
			this.pending = {};
			this.invalid = {};
			this.reset();

			var groups = ( this.groups = {} ),
				rules;
			$.each( this.settings.groups, function( key, value ) {
				if ( typeof value === "string" ) {
					value = value.split( /\s/ );
				}
				$.each( value, function( index, name ) {
					groups[ name ] = key;
				});
			});
			rules = this.settings.rules;
			$.each( rules, function( key, value ) {
				rules[ key ] = $.validator.normalizeRule( value );
			});

			function delegate( event ) {
				var validator = $.data( this.form, "validator" ),
					eventType = "on" + event.type.replace( /^validate/, "" ),
					settings = validator.settings;
				if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
                    settings[ eventType ].call( validator, this, event );
				}
			}

			$( this.currentForm )
				.on( "focusin.validate focusout.validate keyup.validate",
					":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
					"[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
					"[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
					"[type='radio'], [type='checkbox']", delegate)
				// Support: Chrome, oldIE
				// "select" is provided as event.target when clicking a option
				.on("click.validate", "select, option, [type='radio'], [type='checkbox']", delegate);

			if ( this.settings.invalidHandler ) {
				$( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
			}

			// Add aria-required to any Static/Data/Class required fields before first validation
			// Screen readers require this attribute to be present before the initial submission http://www.w3.org/TR/WCAG-TECHS/ARIA2.html
			$( this.currentForm ).find( "[required], [data-rule-required], .required" ).attr( "aria-required", "true" );
		},

		// http://jqueryvalidation.org/Validator.form/
		form: function() {
			this.checkForm();
			$.extend( this.submitted, this.errorMap );
			this.invalid = $.extend({}, this.errorMap );
			if ( !this.valid() ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ]);
			}
			this.showErrors();
			return this.valid();
		},

		checkForm: function() {
			this.prepareForm();
			for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
				this.check( elements[ i ] );
			}
			return this.valid();
		},

		// http://jqueryvalidation.org/Validator.element/
		element: function( element ) {
			var cleanElement = this.clean( element ),
				checkElement = this.validationTargetFor( cleanElement ),
				result = true;

			this.lastElement = checkElement;

			if ( checkElement === undefined ) {
				delete this.invalid[ cleanElement.name ];
			} else {
				this.prepareElement( checkElement );
				this.currentElements = $( checkElement );

				result = this.check( checkElement ) !== false;
				if ( result ) {
					delete this.invalid[ checkElement.name ];
				} else {
					this.invalid[ checkElement.name ] = true;
				}
			}
			// Add aria-invalid status for screen readers
			$( element ).attr( "aria-invalid", !result );

			if ( !this.numberOfInvalids() ) {
				// Hide error containers on last error
				this.toHide = this.toHide.add( this.containers );
			}
			this.showErrors();
			return result;
		},

		// http://jqueryvalidation.org/Validator.showErrors/
		showErrors: function( errors ) {
			if ( errors ) {
				// add items to error list and map
				$.extend( this.errorMap, errors );
				this.errorList = [];
				for ( var name in errors ) {
					this.errorList.push({
						message: errors[ name ],
						element: this.findByName( name )[ 0 ]
					});
				}
				// remove items from success list
				this.successList = $.grep( this.successList, function( element ) {
					return !( element.name in errors );
				});
			}
			if ( this.settings.showErrors ) {
				this.settings.showErrors.call( this, this.errorMap, this.errorList );
			} else {
				this.defaultShowErrors();
			}
		},

		// http://jqueryvalidation.org/Validator.resetForm/
		resetForm: function() {
			if ( $.fn.resetForm ) {
				$( this.currentForm ).resetForm();
			}
			this.submitted = {};
			this.lastElement = null;
			this.prepareForm();
			this.hideErrors();
			var i, elements = this.elements()
				.removeData( "previousValue" )
				.removeAttr( "aria-invalid" );

			if ( this.settings.unhighlight ) {
				for ( i = 0; elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ],
						this.settings.errorClass, "" );
				}
			} else {
				elements.removeClass( this.settings.errorClass );
			}
		},

		numberOfInvalids: function() {
			return this.objectLength( this.invalid );
		},

		objectLength: function( obj ) {
			/* jshint unused: false */
			var count = 0,
				i;
			for ( i in obj ) {
				count++;
			}
			return count;
		},

		hideErrors: function() {
			this.hideThese( this.toHide );
		},

		hideThese: function( errors ) {
			errors.not( this.containers ).text( "" );
			this.addWrapper( errors ).hide();
		},

		valid: function() {
			return this.size() === 0;
		},

		size: function() {
			return this.errorList.length;
		},

		focusInvalid: function() {
			if ( this.settings.focusInvalid ) {
				try {
					$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [])
					.filter( ":visible" )
					.focus()
					// manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
					.trigger( "focusin" );
				} catch ( e ) {
					// ignore IE throwing errors when focusing hidden elements
				}
			}
		},

		findLastActive: function() {
			var lastActive = this.lastActive;
			return lastActive && $.grep( this.errorList, function( n ) {
				return n.element.name === lastActive.name;
			}).length === 1 && lastActive;
		},

		elements: function() {
			var validator = this,
				rulesCache = {};

			// select all valid inputs inside the form (no submit or reset buttons)
			return $( this.currentForm )
			.find( "input, select, textarea" )
			.not( ":submit, :reset, :image, :disabled" )
			.not( this.settings.ignore )
			.filter( function() {
				if ( !this.name && validator.settings.debug && window.console ) {
					console.error( "%o has no name assigned", this );
				}

				// select only the first element for each name, and only those with rules specified
				if ( this.name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
					return false;
				}

				rulesCache[ this.name ] = true;
				return true;
			});
		},

		clean: function( selector ) {
			return $( selector )[ 0 ];
		},

		errors: function() {
			var errorClass = this.settings.errorClass.split( " " ).join( "." );
			return $( this.settings.errorElement + "." + errorClass, this.errorContext );
		},

		reset: function() {
			this.successList = [];
			this.errorList = [];
			this.errorMap = {};
			this.toShow = $( [] );
			this.toHide = $( [] );
			this.currentElements = $( [] );
		},

		prepareForm: function() {
			this.reset();
			this.toHide = this.errors().add( this.containers );
		},

		prepareElement: function( element ) {
			this.reset();
			this.toHide = this.errorsFor( element );
		},

		elementValue: function( element ) {
			var val,
				$element = $( element ),
				type = element.type;

			if ( type === "radio" || type === "checkbox" ) {
				return this.findByName( element.name ).filter(":checked").val();
			} else if ( type === "number" && typeof element.validity !== "undefined" ) {
				return element.validity.badInput ? false : $element.val();
			}

			val = $element.val();
			if ( typeof val === "string" ) {
				return val.replace(/\r/g, "" );
			}
			return val;
		},

		check: function( element ) {
			element = this.validationTargetFor( this.clean( element ) );

			var rules = $( element ).rules(),
				rulesCount = $.map( rules, function( n, i ) {
					return i;
				}).length,
				dependencyMismatch = false,
				val = this.elementValue( element ),
				result, method, rule;

			for ( method in rules ) {
				rule = { method: method, parameters: rules[ method ] };
				try {

					result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

					// if a method indicates that the field is optional and therefore valid,
					// don't mark it as valid when there are no other rules
					if ( result === "dependency-mismatch" && rulesCount === 1 ) {
						dependencyMismatch = true;
						continue;
					}
					dependencyMismatch = false;

					if ( result === "pending" ) {
						this.toHide = this.toHide.not( this.errorsFor( element ) );
						return;
					}

					if ( !result ) {
						this.formatAndAdd( element, rule );
						return false;
					}
				} catch ( e ) {
					if ( this.settings.debug && window.console ) {
						console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
					}
					if ( e instanceof TypeError ) {
						e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
					}

					throw e;
				}
			}
			if ( dependencyMismatch ) {
				return;
			}
			if ( this.objectLength( rules ) ) {
				this.successList.push( element );
			}
			return true;
		},

		// return the custom message for the given element and validation method
		// specified in the element's HTML5 data attribute
		// return the generic message if present and no method specific message is present
		customDataMessage: function( element, method ) {
			return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
				method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
		},

		// return the custom message for the given element name and validation method
		customMessage: function( name, method ) {
			var m = this.settings.messages[ name ];
			return m && ( m.constructor === String ? m : m[ method ]);
		},

		// return the first defined argument, allowing empty strings
		findDefined: function() {
			for ( var i = 0; i < arguments.length; i++) {
				if ( arguments[ i ] !== undefined ) {
					return arguments[ i ];
				}
			}
			return undefined;
		},

		defaultMessage: function( element, method ) {
			return this.findDefined(
				this.customMessage( element.name, method ),
				this.customDataMessage( element, method ),
				// title is never undefined, so handle empty string as undefined
				!this.settings.ignoreTitle && element.title || undefined,
				$.validator.messages[ method ],
				"<strong>Warning: No message defined for " + element.name + "</strong>"
			);
		},

		formatAndAdd: function( element, rule ) {
			var message = this.defaultMessage( element, rule.method ),
				theregex = /\$?\{(\d+)\}/g;
			if ( typeof message === "function" ) {
				message = message.call( this, rule.parameters, element );
			} else if ( theregex.test( message ) ) {
				message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
			}
			this.errorList.push({
				message: message,
				element: element,
				method: rule.method
			});

			this.errorMap[ element.name ] = message;
			this.submitted[ element.name ] = message;
		},

		addWrapper: function( toToggle ) {
			if ( this.settings.wrapper ) {
				toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
			}
			return toToggle;
		},

		defaultShowErrors: function() {
			var i, elements, error;
			for ( i = 0; this.errorList[ i ]; i++ ) {
				error = this.errorList[ i ];
				if ( this.settings.highlight ) {
					this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
				}
				this.showLabel( error.element, error.message );
			}
			if ( this.errorList.length ) {
				this.toShow = this.toShow.add( this.containers );
			}
			if ( this.settings.success ) {
				for ( i = 0; this.successList[ i ]; i++ ) {
					this.showLabel( this.successList[ i ] );
				}
			}
			if ( this.settings.unhighlight ) {
				for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
				}
			}
			this.toHide = this.toHide.not( this.toShow );
			this.hideErrors();
			this.addWrapper( this.toShow ).show();
		},

		validElements: function() {
			return this.currentElements.not( this.invalidElements() );
		},

		invalidElements: function() {
			return $( this.errorList ).map(function() {
				return this.element;
			});
		},

		showLabel: function( element, message ) {
			var place, group, errorID,
				error = this.errorsFor( element ),
				elementID = this.idOrName( element ),
				describedBy = $( element ).attr( "aria-describedby" );
			if ( error.length ) {
				// refresh error/success class
				error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );
				// replace message on existing label
				error.html( message );
			} else {
				// create error element
				error = $( "<" + this.settings.errorElement + ">" )
					.attr( "id", elementID + "-error" )
					.addClass( this.settings.errorClass )
					.html( message || "" );

				// Maintain reference to the element to be placed into the DOM
				place = error;
				if ( this.settings.wrapper ) {
					// make sure the element is visible, even in IE
					// actually showing the wrapped element is handled elsewhere
					place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
				}
				if ( this.labelContainer.length ) {
					this.labelContainer.append( place );
				} else if ( this.settings.errorPlacement ) {
					this.settings.errorPlacement( place, $( element ) );
				} else {
					place.insertAfter( element );
				}

				// Link error back to the element
				if ( error.is( "label" ) ) {
					// If the error is a label, then associate using 'for'
					error.attr( "for", elementID );
				} else if ( error.parents( "label[for='" + elementID + "']" ).length === 0 ) {
					// If the element is not a child of an associated label, then it's necessary
					// to explicitly apply aria-describedby

					errorID = error.attr( "id" ).replace( /(:|\.|\[|\]|\$)/g, "\\$1");
					// Respect existing non-error aria-describedby
					if ( !describedBy ) {
						describedBy = errorID;
					} else if ( !describedBy.match( new RegExp( "\\b" + errorID + "\\b" ) ) ) {
						// Add to end of list if not already present
						describedBy += " " + errorID;
					}
					$( element ).attr( "aria-describedby", describedBy );

					// If this element is grouped, then assign to all elements in the same group
					group = this.groups[ element.name ];
					if ( group ) {
						$.each( this.groups, function( name, testgroup ) {
							if ( testgroup === group ) {
								$( "[name='" + name + "']", this.currentForm )
									.attr( "aria-describedby", error.attr( "id" ) );
							}
						});
					}
				}
			}
			if ( !message && this.settings.success ) {
				error.text( "" );
				if ( typeof this.settings.success === "string" ) {
					error.addClass( this.settings.success );
				} else {
					this.settings.success( error, element );
				}
			}
			this.toShow = this.toShow.add( error );
		},

		errorsFor: function( element ) {
			var name = this.idOrName( element ),
				describer = $( element ).attr( "aria-describedby" ),
				selector = "label[for='" + name + "'], label[for='" + name + "'] *";

			// aria-describedby should directly reference the error element
			if ( describer ) {
				selector = selector + ", #" + describer.replace( /\s+/g, ", #" );
			}
			return this
				.errors()
				.filter( selector );
		},

		idOrName: function( element ) {
			return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
		},

		validationTargetFor: function( element ) {

			// If radio/checkbox, validate first element in group instead
			if ( this.checkable( element ) ) {
				element = this.findByName( element.name );
			}

			// Always apply ignore filter
			return $( element ).not( this.settings.ignore )[ 0 ];
		},

		checkable: function( element ) {
			return ( /radio|checkbox/i ).test( element.type );
		},

		findByName: function( name ) {
			return $( this.currentForm ).find( "[name='" + name + "']" );
		},

		getLength: function( value, element ) {
			switch ( element.nodeName.toLowerCase() ) {
			case "select":
				return $( "option:selected", element ).length;
			case "input":
				if ( this.checkable( element ) ) {
					return this.findByName( element.name ).filter( ":checked" ).length;
				}
			}
			return value.length;
		},

		depend: function( param, element ) {
			return this.dependTypes[typeof param] ? this.dependTypes[typeof param]( param, element ) : true;
		},

		dependTypes: {
			"boolean": function( param ) {
				return param;
			},
			"string": function( param, element ) {
				return !!$( param, element.form ).length;
			},
			"function": function( param, element ) {
				return param( element );
			}
		},

		optional: function( element ) {
			var val = this.elementValue( element );
			return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
		},

		startRequest: function( element ) {
			if ( !this.pending[ element.name ] ) {
				this.pendingRequest++;
				this.pending[ element.name ] = true;
			}
		},

		stopRequest: function( element, valid ) {
			this.pendingRequest--;
			// sometimes synchronization fails, make sure pendingRequest is never < 0
			if ( this.pendingRequest < 0 ) {
				this.pendingRequest = 0;
			}
			delete this.pending[ element.name ];
			if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
				$( this.currentForm ).submit();
				this.formSubmitted = false;
			} else if (!valid && this.pendingRequest === 0 && this.formSubmitted ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ]);
				this.formSubmitted = false;
			}
		},

		previousValue: function( element ) {
			return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
				old: null,
				valid: true,
				message: this.defaultMessage( element, "remote" )
			});
		},

		// cleans up all forms and elements, removes validator-specific events
		destroy: function() {
			this.resetForm();

			$( this.currentForm )
				.off( ".validate" )
				.removeData( "validator" );
		}

	},

	classRuleSettings: {
		required: { required: true },
		email: { email: true },
		url: { url: true },
		date: { date: true },
		dateISO: { dateISO: true },
		number: { number: true },
		digits: { digits: true },
		creditcard: { creditcard: true }
	},

	addClassRules: function( className, rules ) {
		if ( className.constructor === String ) {
			this.classRuleSettings[ className ] = rules;
		} else {
			$.extend( this.classRuleSettings, className );
		}
	},

	classRules: function( element ) {
		var rules = {},
			classes = $( element ).attr( "class" );

		if ( classes ) {
			$.each( classes.split( " " ), function() {
				if ( this in $.validator.classRuleSettings ) {
					$.extend( rules, $.validator.classRuleSettings[ this ]);
				}
			});
		}
		return rules;
	},

	normalizeAttributeRule: function( rules, type, method, value ) {

		// convert the value to a number for number inputs, and for text for backwards compability
		// allows type="date" and others to be compared as strings
		if ( /min|max/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
			value = Number( value );

			// Support Opera Mini, which returns NaN for undefined minlength
			if ( isNaN( value ) ) {
				value = undefined;
			}
		}

		if ( value || value === 0 ) {
			rules[ method ] = value;
		} else if ( type === method && type !== "range" ) {

			// exception: the jquery validate 'range' method
			// does not test for the html5 'range' type
			rules[ method ] = true;
		}
	},

	attributeRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {

			// support for <input required> in both html5 and older browsers
			if ( method === "required" ) {
				value = element.getAttribute( method );

				// Some browsers return an empty string for the required attribute
				// and non-HTML5 browsers might have required="" markup
				if ( value === "" ) {
					value = true;
				}

				// force non-HTML5 browsers to return bool
				value = !!value;
			} else {
				value = $element.attr( method );
			}

			this.normalizeAttributeRule( rules, type, method, value );
		}

		// maxlength may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
		if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
			delete rules.maxlength;
		}

		return rules;
	},

	dataRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {
			value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
			this.normalizeAttributeRule( rules, type, method, value );
		}
		return rules;
	},

	staticRules: function( element ) {
		var rules = {},
			validator = $.data( element.form, "validator" );

		if ( validator.settings.rules ) {
			rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
		}
		return rules;
	},

	normalizeRules: function( rules, element ) {
		// handle dependency check
		$.each( rules, function( prop, val ) {
			// ignore rule when param is explicitly false, eg. required:false
			if ( val === false ) {
				delete rules[ prop ];
				return;
			}
			if ( val.param || val.depends ) {
				var keepRule = true;
				switch ( typeof val.depends ) {
				case "string":
					keepRule = !!$( val.depends, element.form ).length;
					break;
				case "function":
					keepRule = val.depends.call( element, element );
					break;
				}
				if ( keepRule ) {
					rules[ prop ] = val.param !== undefined ? val.param : true;
				} else {
					delete rules[ prop ];
				}
			}
		});

		// evaluate parameters
		$.each( rules, function( rule, parameter ) {
			rules[ rule ] = $.isFunction( parameter ) ? parameter( element ) : parameter;
		});

		// clean number parameters
		$.each([ "minlength", "maxlength" ], function() {
			if ( rules[ this ] ) {
				rules[ this ] = Number( rules[ this ] );
			}
		});
		$.each([ "rangelength", "range" ], function() {
			var parts;
			if ( rules[ this ] ) {
				if ( $.isArray( rules[ this ] ) ) {
					rules[ this ] = [ Number( rules[ this ][ 0 ]), Number( rules[ this ][ 1 ] ) ];
				} else if ( typeof rules[ this ] === "string" ) {
					parts = rules[ this ].replace(/[\[\]]/g, "" ).split( /[\s,]+/ );
					rules[ this ] = [ Number( parts[ 0 ]), Number( parts[ 1 ] ) ];
				}
			}
		});

		if ( $.validator.autoCreateRanges ) {
			// auto-create ranges
			if ( rules.min != null && rules.max != null ) {
				rules.range = [ rules.min, rules.max ];
				delete rules.min;
				delete rules.max;
			}
			if ( rules.minlength != null && rules.maxlength != null ) {
				rules.rangelength = [ rules.minlength, rules.maxlength ];
				delete rules.minlength;
				delete rules.maxlength;
			}
		}

		return rules;
	},

	// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
	normalizeRule: function( data ) {
		if ( typeof data === "string" ) {
			var transformed = {};
			$.each( data.split( /\s/ ), function() {
				transformed[ this ] = true;
			});
			data = transformed;
		}
		return data;
	},

	// http://jqueryvalidation.org/jQuery.validator.addMethod/
	addMethod: function( name, method, message ) {
		$.validator.methods[ name ] = method;
		$.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
		if ( method.length < 3 ) {
			$.validator.addClassRules( name, $.validator.normalizeRule( name ) );
		}
	},

	methods: {

		// http://jqueryvalidation.org/required-method/
		required: function( value, element, param ) {
			// check if dependency is met
			if ( !this.depend( param, element ) ) {
				return "dependency-mismatch";
			}
			if ( element.nodeName.toLowerCase() === "select" ) {
				// could be an array for select-multiple or a string, both are fine this way
				var val = $( element ).val();
				return val && val.length > 0;
			}
			if ( this.checkable( element ) ) {
				return this.getLength( value, element ) > 0;
			}
			return value.length > 0;
		},

		// http://jqueryvalidation.org/email-method/
		email: function( value, element ) {
			// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
			// Retrieved 2014-01-14
			// If you have a problem with this implementation, report a bug against the above spec
			// Or use custom methods to implement your own email validation
			return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
		},

		// http://jqueryvalidation.org/url-method/
		url: function( value, element ) {

			// Copyright (c) 2010-2013 Diego Perini, MIT licensed
			// https://gist.github.com/dperini/729294
			// see also https://mathiasbynens.be/demo/url-regex
			// modified to allow protocol-relative URLs
			return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
		},

		// http://jqueryvalidation.org/date-method/
		date: function( value, element ) {
			return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
		},

		// http://jqueryvalidation.org/dateISO-method/
		dateISO: function( value, element ) {
			return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
		},

		// http://jqueryvalidation.org/number-method/
		number: function( value, element ) {
			return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
		},

		// http://jqueryvalidation.org/digits-method/
		digits: function( value, element ) {
			return this.optional( element ) || /^\d+$/.test( value );
		},

		// http://jqueryvalidation.org/creditcard-method/
		// based on http://en.wikipedia.org/wiki/Luhn_algorithm
		creditcard: function( value, element ) {
			if ( this.optional( element ) ) {
				return "dependency-mismatch";
			}
			// accept only spaces, digits and dashes
			if ( /[^0-9 \-]+/.test( value ) ) {
				return false;
			}
			var nCheck = 0,
				nDigit = 0,
				bEven = false,
				n, cDigit;

			value = value.replace( /\D/g, "" );

			// Basing min and max length on
			// http://developer.ean.com/general_info/Valid_Credit_Card_Types
			if ( value.length < 13 || value.length > 19 ) {
				return false;
			}

			for ( n = value.length - 1; n >= 0; n--) {
				cDigit = value.charAt( n );
				nDigit = parseInt( cDigit, 10 );
				if ( bEven ) {
					if ( ( nDigit *= 2 ) > 9 ) {
						nDigit -= 9;
					}
				}
				nCheck += nDigit;
				bEven = !bEven;
			}

			return ( nCheck % 10 ) === 0;
		},

		// http://jqueryvalidation.org/minlength-method/
		minlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length >= param;
		},

		// http://jqueryvalidation.org/maxlength-method/
		maxlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length <= param;
		},

		// http://jqueryvalidation.org/rangelength-method/
		rangelength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
		},

		// http://jqueryvalidation.org/min-method/
		min: function( value, element, param ) {
			return this.optional( element ) || value >= param;
		},

		// http://jqueryvalidation.org/max-method/
		max: function( value, element, param ) {
			return this.optional( element ) || value <= param;
		},

		// http://jqueryvalidation.org/range-method/
		range: function( value, element, param ) {
			return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
		},

		// http://jqueryvalidation.org/equalTo-method/
		equalTo: function( value, element, param ) {
			// bind to the blur event of the target in order to revalidate whenever the target field is updated
			// TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
			var target = $( param );
			if ( this.settings.onfocusout ) {
				target.off( ".validate-equalTo" ).on( "blur.validate-equalTo", function() {
					$( element ).valid();
				});
			}
			return value === target.val();
		},

		// http://jqueryvalidation.org/remote-method/
		remote: function( value, element, param ) {
			if ( this.optional( element ) ) {
				return "dependency-mismatch";
			}

			var previous = this.previousValue( element ),
				validator, data;

			if (!this.settings.messages[ element.name ] ) {
				this.settings.messages[ element.name ] = {};
			}
			previous.originalMessage = this.settings.messages[ element.name ].remote;
			this.settings.messages[ element.name ].remote = previous.message;

			param = typeof param === "string" && { url: param } || param;

			if ( previous.old === value ) {
				return previous.valid;
			}

			previous.old = value;
			validator = this;
			this.startRequest( element );
			data = {};
			data[ element.name ] = value;
			$.ajax( $.extend( true, {
				mode: "abort",
				port: "validate" + element.name,
				dataType: "json",
				data: data,
				context: validator.currentForm,
				success: function( response ) {
					var valid = response === true || response === "true",
						errors, message, submitted;

					validator.settings.messages[ element.name ].remote = previous.originalMessage;
					if ( valid ) {
						submitted = validator.formSubmitted;
						validator.prepareElement( element );
						validator.formSubmitted = submitted;
						validator.successList.push( element );
						delete validator.invalid[ element.name ];
						validator.showErrors();
					} else {
						errors = {};
						message = response || validator.defaultMessage( element, "remote" );
						errors[ element.name ] = previous.message = $.isFunction( message ) ? message( value ) : message;
						validator.invalid[ element.name ] = true;
						validator.showErrors( errors );
					}
					previous.valid = valid;
					validator.stopRequest( element, valid );
				}
			}, param ) );
			return "pending";
		}
	}

});

// ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

var pendingRequests = {},
	ajax;
// Use a prefilter if available (1.5+)
if ( $.ajaxPrefilter ) {
	$.ajaxPrefilter(function( settings, _, xhr ) {
		var port = settings.port;
		if ( settings.mode === "abort" ) {
			if ( pendingRequests[port] ) {
				pendingRequests[port].abort();
			}
			pendingRequests[port] = xhr;
		}
	});
} else {
	// Proxy ajax
	ajax = $.ajax;
	$.ajax = function( settings ) {
		var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
			port = ( "port" in settings ? settings : $.ajaxSettings ).port;
		if ( mode === "abort" ) {
			if ( pendingRequests[port] ) {
				pendingRequests[port].abort();
			}
			pendingRequests[port] = ajax.apply(this, arguments);
			return pendingRequests[port];
		}
		return ajax.apply(this, arguments);
	};
}

}));
// Unobtrusive validation support library for jQuery and jQuery Validate
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// @version v3.2.11

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global document: false, jQuery: false */

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("jquery.validate.unobtrusive", ['jquery-validation'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS-like environments that support module.exports     
        module.exports = factory(require('jquery-validation'));
    } else {
        // Browser global
        jQuery.validator.unobtrusive = factory(jQuery);
    }
}(function ($) {
    var $jQval = $.validator,
        adapters,
        data_validation = "unobtrusiveValidation";

    function setValidationValues(options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    }

    function splitAndTrim(value) {
        return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
    }

    function escapeAttributeValue(value) {
        // As mentioned on http://api.jquery.com/category/selectors/
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
    }

    function getModelPrefix(fieldName) {
        return fieldName.substr(0, fieldName.lastIndexOf(".") + 1);
    }

    function appendModelPrefix(value, prefix) {
        if (value.indexOf("*.") === 0) {
            value = value.replace("*.", prefix);
        }
        return value;
    }

    function onError(error, inputElement) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
            replaceAttrValue = container.attr("data-valmsg-replace"),
            replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) !== false : null;

        container.removeClass("field-validation-valid").addClass("field-validation-error");
        error.data("unobtrusiveContainer", container);

        if (replace) {
            container.empty();
            error.removeClass("input-validation-error").appendTo(container);
        }
        else {
            error.hide();
        }
    }

    function onErrors(event, validator) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-summary=true]"),
            list = container.find("ul");

        if (list && list.length && validator.errorList.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");

            $.each(validator.errorList, function () {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }

    function onSuccess(error) {  // 'this' is the form element
        var container = error.data("unobtrusiveContainer");

        if (container) {
            var replaceAttrValue = container.attr("data-valmsg-replace"),
                replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) : null;

            container.addClass("field-validation-valid").removeClass("field-validation-error");
            error.removeData("unobtrusiveContainer");

            if (replace) {
                container.empty();
            }
        }
    }

    function onReset(event) {  // 'this' is the form element
        var $form = $(this),
            key = '__jquery_unobtrusive_validation_form_reset';
        if ($form.data(key)) {
            return;
        }
        // Set a flag that indicates we're currently resetting the form.
        $form.data(key, true);
        try {
            $form.data("validator").resetForm();
        } finally {
            $form.removeData(key);
        }

        $form.find(".validation-summary-errors")
            .addClass("validation-summary-valid")
            .removeClass("validation-summary-errors");
        $form.find(".field-validation-error")
            .addClass("field-validation-valid")
            .removeClass("field-validation-error")
            .removeData("unobtrusiveContainer")
            .find(">*")  // If we were using valmsg-replace, get the underlying error
            .removeData("unobtrusiveContainer");
    }

    function validationInfo(form) {
        var $form = $(form),
            result = $form.data(data_validation),
            onResetProxy = $.proxy(onReset, form),
            defaultOptions = $jQval.unobtrusive.options || {},
            execInContext = function (name, args) {
                var func = defaultOptions[name];
                func && $.isFunction(func) && func.apply(form, args);
            };

        if (!result) {
            result = {
                options: {  // options structure passed to jQuery Validate's validate() method
                    errorClass: defaultOptions.errorClass || "input-validation-error",
                    errorElement: defaultOptions.errorElement || "span",
                    errorPlacement: function () {
                        onError.apply(form, arguments);
                        execInContext("errorPlacement", arguments);
                    },
                    invalidHandler: function () {
                        onErrors.apply(form, arguments);
                        execInContext("invalidHandler", arguments);
                    },
                    messages: {},
                    rules: {},
                    success: function () {
                        onSuccess.apply(form, arguments);
                        execInContext("success", arguments);
                    }
                },
                attachValidation: function () {
                    $form
                        .off("reset." + data_validation, onResetProxy)
                        .on("reset." + data_validation, onResetProxy)
                        .validate(this.options);
                },
                validate: function () {  // a validation function that is called by unobtrusive Ajax
                    $form.validate();
                    return $form.valid();
                }
            };
            $form.data(data_validation, result);
        }

        return result;
    }

    $jQval.unobtrusive = {
        adapters: [],

        parseElement: function (element, skipAttach) {
            /// <summary>
            /// Parses a single HTML element for unobtrusive validation attributes.
            /// </summary>
            /// <param name="element" domElement="true">The HTML element to be parsed.</param>
            /// <param name="skipAttach" type="Boolean">[Optional] true to skip attaching the
            /// validation to the form. If parsing just this single element, you should specify true.
            /// If parsing several elements, you should specify false, and manually attach the validation
            /// to the form when you are finished. The default is false.</param>
            var $element = $(element),
                form = $element.parents("form")[0],
                valInfo, rules, messages;

            if (!form) {  // Cannot do client-side validation without a form
                return;
            }

            valInfo = validationInfo(form);
            valInfo.options.rules[element.name] = rules = {};
            valInfo.options.messages[element.name] = messages = {};

            $.each(this.adapters, function () {
                var prefix = "data-val-" + this.name,
                    message = $element.attr(prefix),
                    paramValues = {};

                if (message !== undefined) {  // Compare against undefined, because an empty message is legal (and falsy)
                    prefix += "-";

                    $.each(this.params, function () {
                        paramValues[this] = $element.attr(prefix + this);
                    });

                    this.adapt({
                        element: element,
                        form: form,
                        message: message,
                        params: paramValues,
                        rules: rules,
                        messages: messages
                    });
                }
            });

            $.extend(rules, { "__dummy__": true });

            if (!skipAttach) {
                valInfo.attachValidation();
            }
        },

        parse: function (selector) {
            /// <summary>
            /// Parses all the HTML elements in the specified selector. It looks for input elements decorated
            /// with the [data-val=true] attribute value and enables validation according to the data-val-*
            /// attribute values.
            /// </summary>
            /// <param name="selector" type="String">Any valid jQuery selector.</param>

            // $forms includes all forms in selector's DOM hierarchy (parent, children and self) that have at least one
            // element with data-val=true
            var $selector = $(selector),
                $forms = $selector.parents()
                    .addBack()
                    .filter("form")
                    .add($selector.find("form"))
                    .has("[data-val=true]");

            $selector.find("[data-val=true]").each(function () {
                $jQval.unobtrusive.parseElement(this, true);
            });

            $forms.each(function () {
                var info = validationInfo(this);
                if (info) {
                    info.attachValidation();
                }
            });
        }
    };

    adapters = $jQval.unobtrusive.adapters;

    adapters.add = function (adapterName, params, fn) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="params" type="Array" optional="true">[Optional] An array of parameter names (strings) that will
        /// be extracted from the data-val-nnnn-mmmm HTML attributes (where nnnn is the adapter name, and
        /// mmmm is the parameter name).</param>
        /// <param name="fn" type="Function">The function to call, which adapts the values from the HTML
        /// attributes into jQuery Validate rules and/or messages.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        if (!fn) {  // Called with no params, just a function
            fn = params;
            params = [];
        }
        this.push({ name: adapterName, params: params, adapt: fn });
        return this;
    };

    adapters.addBool = function (adapterName, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has no parameter values.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, function (options) {
            setValidationValues(options, ruleName || adapterName, true);
        });
    };

    adapters.addMinMax = function (adapterName, minRuleName, maxRuleName, minMaxRuleName, minAttribute, maxAttribute) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation has three potential rules (one for min-only, one for max-only, and
        /// one for min-and-max). The HTML parameters are expected to be named -min and -max.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="minRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a minimum value.</param>
        /// <param name="maxRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a maximum value.</param>
        /// <param name="minMaxRuleName" type="String">The name of the jQuery Validate rule to be used when you
        /// have both a minimum and maximum value.</param>
        /// <param name="minAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the minimum value. The default is "min".</param>
        /// <param name="maxAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the maximum value. The default is "max".</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [minAttribute || "min", maxAttribute || "max"], function (options) {
            var min = options.params.min,
                max = options.params.max;

            if (min && max) {
                setValidationValues(options, minMaxRuleName, [min, max]);
            }
            else if (min) {
                setValidationValues(options, minRuleName, min);
            }
            else if (max) {
                setValidationValues(options, maxRuleName, max);
            }
        });
    };

    adapters.addSingleVal = function (adapterName, attribute, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has a single value.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute(where nnnn is the adapter name).</param>
        /// <param name="attribute" type="String">[Optional] The name of the HTML attribute that contains the value.
        /// The default is "val".</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [attribute || "val"], function (options) {
            setValidationValues(options, ruleName || adapterName, options.params[attribute]);
        });
    };

    $jQval.addMethod("__dummy__", function (value, element, params) {
        return true;
    });

    $jQval.addMethod("regex", function (value, element, params) {
        var match;
        if (this.optional(element)) {
            return true;
        }

        match = new RegExp(params).exec(value);
        return (match && (match.index === 0) && (match[0].length === value.length));
    });

    $jQval.addMethod("nonalphamin", function (value, element, nonalphamin) {
        var match;
        if (nonalphamin) {
            match = value.match(/\W/g);
            match = match && match.length >= nonalphamin;
        }
        return match;
    });

    if ($jQval.methods.extension) {
        adapters.addSingleVal("accept", "mimtype");
        adapters.addSingleVal("extension", "extension");
    } else {
        // for backward compatibility, when the 'extension' validation method does not exist, such as with versions
        // of JQuery Validation plugin prior to 1.10, we should use the 'accept' method for
        // validating the extension, and ignore mime-type validations as they are not supported.
        adapters.addSingleVal("extension", "extension", "accept");
    }

    adapters.addSingleVal("regex", "pattern");
    adapters.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");
    adapters.addMinMax("length", "minlength", "maxlength", "rangelength").addMinMax("range", "min", "max", "range");
    adapters.addMinMax("minlength", "minlength").addMinMax("maxlength", "minlength", "maxlength");
    adapters.add("equalto", ["other"], function (options) {
        var prefix = getModelPrefix(options.element.name),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(fullOtherName) + "']")[0];

        setValidationValues(options, "equalTo", element);
    });
    adapters.add("required", function (options) {
        // jQuery Validate equates "required" with "mandatory" for checkbox elements
        if (options.element.tagName.toUpperCase() !== "INPUT" || options.element.type.toUpperCase() !== "CHECKBOX") {
            setValidationValues(options, "required", true);
        }
    });
    adapters.add("remote", ["url", "type", "additionalfields"], function (options) {
        var value = {
            url: options.params.url,
            type: options.params.type || "GET",
            data: {}
        },
            prefix = getModelPrefix(options.element.name);

        $.each(splitAndTrim(options.params.additionalfields || options.element.name), function (i, fieldName) {
            var paramName = appendModelPrefix(fieldName, prefix);
            value.data[paramName] = function () {
                var field = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(paramName) + "']");
                // For checkboxes and radio buttons, only pick up values from checked fields.
                if (field.is(":checkbox")) {
                    return field.filter(":checked").val() || field.filter(":hidden").val() || '';
                }
                else if (field.is(":radio")) {
                    return field.filter(":checked").val() || '';
                }
                return field.val();
            };
        });

        setValidationValues(options, "remote", value);
    });
    adapters.add("password", ["min", "nonalphamin", "regex"], function (options) {
        if (options.params.min) {
            setValidationValues(options, "minlength", options.params.min);
        }
        if (options.params.nonalphamin) {
            setValidationValues(options, "nonalphamin", options.params.nonalphamin);
        }
        if (options.params.regex) {
            setValidationValues(options, "regex", options.params.regex);
        }
    });
    adapters.add("fileextensions", ["extensions"], function (options) {
        setValidationValues(options, "extension", options.params.extensions);
    });

    $(function () {
        $jQval.unobtrusive.parse(document);
    });

    return $jQval.unobtrusive;
}));

jQuery.validator.setDefaults({
	highlight: function (element, errorClass, validClass)
	{
		if (element.type === "radio")
		{
			this.findByName(element.name).addClass(errorClass).removeClass(validClass);
		} else
		{
			$(element).addClass(errorClass).removeClass(validClass);
			$(element).closest(".form-group,.form-inline,.file-editor").removeClass("has-success").addClass("has-error");
		}

		// A server warning holds content client rules cannot re-derive, so this hook leaves it alone.
		var $summary = $(element).parents("form").find(".validation-summary-valid, .validation-summary-errors").not("[data-server-warning]");

		if (!this.valid() && $.trim($summary.text()).length > 0)
		    $summary.removeClass("validation-summary-valid").addClass("validation-summary-errors");
	},
	unhighlight: function (element, errorClass, validClass)
	{
		if (element.type === "radio")
		{
			this.findByName(element.name).removeClass(errorClass).addClass(validClass);
		} else
		{
			$(element).removeClass(errorClass).addClass(validClass);
			$(element).closest(".form-group,.form-inline,.file-editor").removeClass("has-error");//.addClass("has-success");
		}

        var $form = $(element).parents("form");
		var $summary = $form.find(".validation-summary-valid, .validation-summary-errors").not("[data-server-warning]");

        if (this.valid() && $.trim($summary.text()).length > 0 && !$form.find(".field-validation-error:visible").length)
		    $summary.removeClass("validation-summary-errors").addClass("validation-summary-valid");
	}
});

$().ready(function ()
{
	// moved to Html.BootstrapValidationSummary()
	// $(".validation-summary-errors").addClass("alert alert-danger");

    $(".input-validation-error").addClass("error");

	//$("span.field-validation-valid, span.field-validation-error").each(function ()
	//{
	//	$(this).addClass("help-block");
	//});
});
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.moment=t()}(this,function(){"use strict";var e,i;function c(){return e.apply(null,arguments)}function o(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function u(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function l(e){return void 0===e}function h(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function d(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function f(e,t){var n,s=[];for(n=0;n<e.length;++n)s.push(t(e[n],n));return s}function m(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function _(e,t){for(var n in t)m(t,n)&&(e[n]=t[n]);return m(t,"toString")&&(e.toString=t.toString),m(t,"valueOf")&&(e.valueOf=t.valueOf),e}function y(e,t,n,s){return Tt(e,t,n,s,!0).utc()}function g(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function v(e){if(null==e._isValid){var t=g(e),n=i.call(t.parsedDateParts,function(e){return null!=e}),s=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n);if(e._strict&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return s;e._isValid=s}return e._isValid}function p(e){var t=y(NaN);return null!=e?_(g(t),e):g(t).userInvalidated=!0,t}i=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1};var r=c.momentProperties=[];function w(e,t){var n,s,i;if(l(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),l(t._i)||(e._i=t._i),l(t._f)||(e._f=t._f),l(t._l)||(e._l=t._l),l(t._strict)||(e._strict=t._strict),l(t._tzm)||(e._tzm=t._tzm),l(t._isUTC)||(e._isUTC=t._isUTC),l(t._offset)||(e._offset=t._offset),l(t._pf)||(e._pf=g(t)),l(t._locale)||(e._locale=t._locale),0<r.length)for(n=0;n<r.length;n++)l(i=t[s=r[n]])||(e[s]=i);return e}var t=!1;function M(e){w(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===t&&(t=!0,c.updateOffset(this),t=!1)}function k(e){return e instanceof M||null!=e&&null!=e._isAMomentObject}function S(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function D(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=S(t)),n}function a(e,t,n){var s,i=Math.min(e.length,t.length),r=Math.abs(e.length-t.length),a=0;for(s=0;s<i;s++)(n&&e[s]!==t[s]||!n&&D(e[s])!==D(t[s]))&&a++;return a+r}function Y(e){!1===c.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function n(i,r){var a=!0;return _(function(){if(null!=c.deprecationHandler&&c.deprecationHandler(null,i),a){for(var e,t=[],n=0;n<arguments.length;n++){if(e="","object"==typeof arguments[n]){for(var s in e+="\n["+n+"] ",arguments[0])e+=s+": "+arguments[0][s]+", ";e=e.slice(0,-2)}else e=arguments[n];t.push(e)}Y(i+"\nArguments: "+Array.prototype.slice.call(t).join("")+"\n"+(new Error).stack),a=!1}return r.apply(this,arguments)},r)}var s,O={};function T(e,t){null!=c.deprecationHandler&&c.deprecationHandler(e,t),O[e]||(Y(t),O[e]=!0)}function b(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function x(e,t){var n,s=_({},e);for(n in t)m(t,n)&&(u(e[n])&&u(t[n])?(s[n]={},_(s[n],e[n]),_(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)m(e,n)&&!m(t,n)&&u(e[n])&&(s[n]=_({},s[n]));return s}function P(e){null!=e&&this.set(e)}c.suppressDeprecationWarnings=!1,c.deprecationHandler=null,s=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)m(e,t)&&n.push(t);return n};var W={};function C(e,t){var n=e.toLowerCase();W[n]=W[n+"s"]=W[t]=e}function H(e){return"string"==typeof e?W[e]||W[e.toLowerCase()]:void 0}function R(e){var t,n,s={};for(n in e)m(e,n)&&(t=H(n))&&(s[t]=e[n]);return s}var U={};function F(e,t){U[e]=t}function L(e,t,n){var s=""+Math.abs(e),i=t-s.length;return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,i)).toString().substr(1)+s}var N=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,G=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,V={},E={};function I(e,t,n,s){var i=s;"string"==typeof s&&(i=function(){return this[s]()}),e&&(E[e]=i),t&&(E[t[0]]=function(){return L(i.apply(this,arguments),t[1],t[2])}),n&&(E[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function A(e,t){return e.isValid()?(t=j(t,e.localeData()),V[t]=V[t]||function(s){var e,i,t,r=s.match(N);for(e=0,i=r.length;e<i;e++)E[r[e]]?r[e]=E[r[e]]:r[e]=(t=r[e]).match(/\[[\s\S]/)?t.replace(/^\[|\]$/g,""):t.replace(/\\/g,"");return function(e){var t,n="";for(t=0;t<i;t++)n+=b(r[t])?r[t].call(e,s):r[t];return n}}(t),V[t](e)):e.localeData().invalidDate()}function j(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(G.lastIndex=0;0<=n&&G.test(e);)e=e.replace(G,s),G.lastIndex=0,n-=1;return e}var Z=/\d/,z=/\d\d/,$=/\d{3}/,q=/\d{4}/,J=/[+-]?\d{6}/,B=/\d\d?/,Q=/\d\d\d\d?/,X=/\d\d\d\d\d\d?/,K=/\d{1,3}/,ee=/\d{1,4}/,te=/[+-]?\d{1,6}/,ne=/\d+/,se=/[+-]?\d+/,ie=/Z|[+-]\d\d:?\d\d/gi,re=/Z|[+-]\d\d(?::?\d\d)?/gi,ae=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,oe={};function ue(e,n,s){oe[e]=b(n)?n:function(e,t){return e&&s?s:n}}function le(e,t){return m(oe,e)?oe[e](t._strict,t._locale):new RegExp(he(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function he(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}var de={};function ce(e,n){var t,s=n;for("string"==typeof e&&(e=[e]),h(n)&&(s=function(e,t){t[n]=D(e)}),t=0;t<e.length;t++)de[e[t]]=s}function fe(e,i){ce(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}var me=0,_e=1,ye=2,ge=3,ve=4,pe=5,we=6,Me=7,ke=8;function Se(e){return De(e)?366:365}function De(e){return e%4==0&&e%100!=0||e%400==0}I("Y",0,0,function(){var e=this.year();return e<=9999?""+e:"+"+e}),I(0,["YY",2],0,function(){return this.year()%100}),I(0,["YYYY",4],0,"year"),I(0,["YYYYY",5],0,"year"),I(0,["YYYYYY",6,!0],0,"year"),C("year","y"),F("year",1),ue("Y",se),ue("YY",B,z),ue("YYYY",ee,q),ue("YYYYY",te,J),ue("YYYYYY",te,J),ce(["YYYYY","YYYYYY"],me),ce("YYYY",function(e,t){t[me]=2===e.length?c.parseTwoDigitYear(e):D(e)}),ce("YY",function(e,t){t[me]=c.parseTwoDigitYear(e)}),ce("Y",function(e,t){t[me]=parseInt(e,10)}),c.parseTwoDigitYear=function(e){return D(e)+(68<D(e)?1900:2e3)};var Ye,Oe=Te("FullYear",!0);function Te(t,n){return function(e){return null!=e?(xe(this,t,e),c.updateOffset(this,n),this):be(this,t)}}function be(e,t){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+t]():NaN}function xe(e,t,n){e.isValid()&&!isNaN(n)&&("FullYear"===t&&De(e.year())&&1===e.month()&&29===e.date()?e._d["set"+(e._isUTC?"UTC":"")+t](n,e.month(),Pe(n,e.month())):e._d["set"+(e._isUTC?"UTC":"")+t](n))}function Pe(e,t){if(isNaN(e)||isNaN(t))return NaN;var n,s=(t%(n=12)+n)%n;return e+=(t-s)/12,1===s?De(e)?29:28:31-s%7%2}Ye=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},I("M",["MM",2],"Mo",function(){return this.month()+1}),I("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),I("MMMM",0,0,function(e){return this.localeData().months(this,e)}),C("month","M"),F("month",8),ue("M",B),ue("MM",B,z),ue("MMM",function(e,t){return t.monthsShortRegex(e)}),ue("MMMM",function(e,t){return t.monthsRegex(e)}),ce(["M","MM"],function(e,t){t[_e]=D(e)-1}),ce(["MMM","MMMM"],function(e,t,n,s){var i=n._locale.monthsParse(e,s,n._strict);null!=i?t[_e]=i:g(n).invalidMonth=e});var We=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ce="January_February_March_April_May_June_July_August_September_October_November_December".split("_");var He="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");function Re(e,t){var n;if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=D(t);else if(!h(t=e.localeData().monthsParse(t)))return e;return n=Math.min(e.date(),Pe(e.year(),t)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](t,n),e}function Ue(e){return null!=e?(Re(this,e),c.updateOffset(this,!0),this):be(this,"Month")}var Fe=ae;var Le=ae;function Ne(){function e(e,t){return t.length-e.length}var t,n,s=[],i=[],r=[];for(t=0;t<12;t++)n=y([2e3,t]),s.push(this.monthsShort(n,"")),i.push(this.months(n,"")),r.push(this.months(n,"")),r.push(this.monthsShort(n,""));for(s.sort(e),i.sort(e),r.sort(e),t=0;t<12;t++)s[t]=he(s[t]),i[t]=he(i[t]);for(t=0;t<24;t++)r[t]=he(r[t]);this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ge(e){var t;if(e<100&&0<=e){var n=Array.prototype.slice.call(arguments);n[0]=e+400,t=new Date(Date.UTC.apply(null,n)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)}else t=new Date(Date.UTC.apply(null,arguments));return t}function Ve(e,t,n){var s=7+t-n;return-((7+Ge(e,0,s).getUTCDay()-t)%7)+s-1}function Ee(e,t,n,s,i){var r,a,o=1+7*(t-1)+(7+n-s)%7+Ve(e,s,i);return a=o<=0?Se(r=e-1)+o:o>Se(e)?(r=e+1,o-Se(e)):(r=e,o),{year:r,dayOfYear:a}}function Ie(e,t,n){var s,i,r=Ve(e.year(),t,n),a=Math.floor((e.dayOfYear()-r-1)/7)+1;return a<1?s=a+Ae(i=e.year()-1,t,n):a>Ae(e.year(),t,n)?(s=a-Ae(e.year(),t,n),i=e.year()+1):(i=e.year(),s=a),{week:s,year:i}}function Ae(e,t,n){var s=Ve(e,t,n),i=Ve(e+1,t,n);return(Se(e)-s+i)/7}I("w",["ww",2],"wo","week"),I("W",["WW",2],"Wo","isoWeek"),C("week","w"),C("isoWeek","W"),F("week",5),F("isoWeek",5),ue("w",B),ue("ww",B,z),ue("W",B),ue("WW",B,z),fe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=D(e)});function je(e,t){return e.slice(t,7).concat(e.slice(0,t))}I("d",0,"do","day"),I("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),I("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),I("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),I("e",0,0,"weekday"),I("E",0,0,"isoWeekday"),C("day","d"),C("weekday","e"),C("isoWeekday","E"),F("day",11),F("weekday",11),F("isoWeekday",11),ue("d",B),ue("e",B),ue("E",B),ue("dd",function(e,t){return t.weekdaysMinRegex(e)}),ue("ddd",function(e,t){return t.weekdaysShortRegex(e)}),ue("dddd",function(e,t){return t.weekdaysRegex(e)}),fe(["dd","ddd","dddd"],function(e,t,n,s){var i=n._locale.weekdaysParse(e,s,n._strict);null!=i?t.d=i:g(n).invalidWeekday=e}),fe(["d","e","E"],function(e,t,n,s){t[s]=D(e)});var Ze="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");var ze="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");var $e="Su_Mo_Tu_We_Th_Fr_Sa".split("_");var qe=ae;var Je=ae;var Be=ae;function Qe(){function e(e,t){return t.length-e.length}var t,n,s,i,r,a=[],o=[],u=[],l=[];for(t=0;t<7;t++)n=y([2e3,1]).day(t),s=this.weekdaysMin(n,""),i=this.weekdaysShort(n,""),r=this.weekdays(n,""),a.push(s),o.push(i),u.push(r),l.push(s),l.push(i),l.push(r);for(a.sort(e),o.sort(e),u.sort(e),l.sort(e),t=0;t<7;t++)o[t]=he(o[t]),u[t]=he(u[t]),l[t]=he(l[t]);this._weekdaysRegex=new RegExp("^("+l.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+u.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+a.join("|")+")","i")}function Xe(){return this.hours()%12||12}function Ke(e,t){I(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function et(e,t){return t._meridiemParse}I("H",["HH",2],0,"hour"),I("h",["hh",2],0,Xe),I("k",["kk",2],0,function(){return this.hours()||24}),I("hmm",0,0,function(){return""+Xe.apply(this)+L(this.minutes(),2)}),I("hmmss",0,0,function(){return""+Xe.apply(this)+L(this.minutes(),2)+L(this.seconds(),2)}),I("Hmm",0,0,function(){return""+this.hours()+L(this.minutes(),2)}),I("Hmmss",0,0,function(){return""+this.hours()+L(this.minutes(),2)+L(this.seconds(),2)}),Ke("a",!0),Ke("A",!1),C("hour","h"),F("hour",13),ue("a",et),ue("A",et),ue("H",B),ue("h",B),ue("k",B),ue("HH",B,z),ue("hh",B,z),ue("kk",B,z),ue("hmm",Q),ue("hmmss",X),ue("Hmm",Q),ue("Hmmss",X),ce(["H","HH"],ge),ce(["k","kk"],function(e,t,n){var s=D(e);t[ge]=24===s?0:s}),ce(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),ce(["h","hh"],function(e,t,n){t[ge]=D(e),g(n).bigHour=!0}),ce("hmm",function(e,t,n){var s=e.length-2;t[ge]=D(e.substr(0,s)),t[ve]=D(e.substr(s)),g(n).bigHour=!0}),ce("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[ge]=D(e.substr(0,s)),t[ve]=D(e.substr(s,2)),t[pe]=D(e.substr(i)),g(n).bigHour=!0}),ce("Hmm",function(e,t,n){var s=e.length-2;t[ge]=D(e.substr(0,s)),t[ve]=D(e.substr(s))}),ce("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[ge]=D(e.substr(0,s)),t[ve]=D(e.substr(s,2)),t[pe]=D(e.substr(i))});var tt,nt=Te("Hours",!0),st={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Ce,monthsShort:He,week:{dow:0,doy:6},weekdays:Ze,weekdaysMin:$e,weekdaysShort:ze,meridiemParse:/[ap]\.?m?\.?/i},it={},rt={};function at(e){return e?e.toLowerCase().replace("_","-"):e}function ot(e){var t=null;if(!it[e]&&"undefined"!=typeof module&&module&&module.exports)try{t=tt._abbr,require("./locale/"+e),ut(t)}catch(e){}return it[e]}function ut(e,t){var n;return e&&((n=l(t)?ht(e):lt(e,t))?tt=n:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),tt._abbr}function lt(e,t){if(null===t)return delete it[e],null;var n,s=st;if(t.abbr=e,null!=it[e])T("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=it[e]._config;else if(null!=t.parentLocale)if(null!=it[t.parentLocale])s=it[t.parentLocale]._config;else{if(null==(n=ot(t.parentLocale)))return rt[t.parentLocale]||(rt[t.parentLocale]=[]),rt[t.parentLocale].push({name:e,config:t}),null;s=n._config}return it[e]=new P(x(s,t)),rt[e]&&rt[e].forEach(function(e){lt(e.name,e.config)}),ut(e),it[e]}function ht(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return tt;if(!o(e)){if(t=ot(e))return t;e=[e]}return function(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=at(e[r]).split("-")).length,n=(n=at(e[r+1]))?n.split("-"):null;0<t;){if(s=ot(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&a(i,n,!0)>=t-1)break;t--}r++}return tt}(e)}function dt(e){var t,n=e._a;return n&&-2===g(e).overflow&&(t=n[_e]<0||11<n[_e]?_e:n[ye]<1||n[ye]>Pe(n[me],n[_e])?ye:n[ge]<0||24<n[ge]||24===n[ge]&&(0!==n[ve]||0!==n[pe]||0!==n[we])?ge:n[ve]<0||59<n[ve]?ve:n[pe]<0||59<n[pe]?pe:n[we]<0||999<n[we]?we:-1,g(e)._overflowDayOfYear&&(t<me||ye<t)&&(t=ye),g(e)._overflowWeeks&&-1===t&&(t=Me),g(e)._overflowWeekday&&-1===t&&(t=ke),g(e).overflow=t),e}function ct(e,t,n){return null!=e?e:null!=t?t:n}function ft(e){var t,n,s,i,r,a=[];if(!e._d){var o,u;for(o=e,u=new Date(c.now()),s=o._useUTC?[u.getUTCFullYear(),u.getUTCMonth(),u.getUTCDate()]:[u.getFullYear(),u.getMonth(),u.getDate()],e._w&&null==e._a[ye]&&null==e._a[_e]&&function(e){var t,n,s,i,r,a,o,u;if(null!=(t=e._w).GG||null!=t.W||null!=t.E)r=1,a=4,n=ct(t.GG,e._a[me],Ie(bt(),1,4).year),s=ct(t.W,1),((i=ct(t.E,1))<1||7<i)&&(u=!0);else{r=e._locale._week.dow,a=e._locale._week.doy;var l=Ie(bt(),r,a);n=ct(t.gg,e._a[me],l.year),s=ct(t.w,l.week),null!=t.d?((i=t.d)<0||6<i)&&(u=!0):null!=t.e?(i=t.e+r,(t.e<0||6<t.e)&&(u=!0)):i=r}s<1||s>Ae(n,r,a)?g(e)._overflowWeeks=!0:null!=u?g(e)._overflowWeekday=!0:(o=Ee(n,s,i,r,a),e._a[me]=o.year,e._dayOfYear=o.dayOfYear)}(e),null!=e._dayOfYear&&(r=ct(e._a[me],s[me]),(e._dayOfYear>Se(r)||0===e._dayOfYear)&&(g(e)._overflowDayOfYear=!0),n=Ge(r,0,e._dayOfYear),e._a[_e]=n.getUTCMonth(),e._a[ye]=n.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=a[t]=s[t];for(;t<7;t++)e._a[t]=a[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[ge]&&0===e._a[ve]&&0===e._a[pe]&&0===e._a[we]&&(e._nextDay=!0,e._a[ge]=0),e._d=(e._useUTC?Ge:function(e,t,n,s,i,r,a){var o;return e<100&&0<=e?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}).apply(null,a),i=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[ge]=24),e._w&&void 0!==e._w.d&&e._w.d!==i&&(g(e).weekdayMismatch=!0)}}var mt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,_t=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,yt=/Z|[+-]\d\d(?::?\d\d)?/,gt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],vt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],pt=/^\/?Date\((\-?\d+)/i;function wt(e){var t,n,s,i,r,a,o=e._i,u=mt.exec(o)||_t.exec(o);if(u){for(g(e).iso=!0,t=0,n=gt.length;t<n;t++)if(gt[t][1].exec(u[1])){i=gt[t][0],s=!1!==gt[t][2];break}if(null==i)return void(e._isValid=!1);if(u[3]){for(t=0,n=vt.length;t<n;t++)if(vt[t][1].exec(u[3])){r=(u[2]||" ")+vt[t][0];break}if(null==r)return void(e._isValid=!1)}if(!s&&null!=r)return void(e._isValid=!1);if(u[4]){if(!yt.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),Yt(e)}else e._isValid=!1}var Mt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;function kt(e,t,n,s,i,r){var a=[function(e){var t=parseInt(e,10);{if(t<=49)return 2e3+t;if(t<=999)return 1900+t}return t}(e),He.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&a.push(parseInt(r,10)),a}var St={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Dt(e){var t,n,s,i=Mt.exec(e._i.replace(/\([^)]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));if(i){var r=kt(i[4],i[3],i[2],i[5],i[6],i[7]);if(t=i[1],n=r,s=e,t&&ze.indexOf(t)!==new Date(n[0],n[1],n[2]).getDay()&&(g(s).weekdayMismatch=!0,!(s._isValid=!1)))return;e._a=r,e._tzm=function(e,t,n){if(e)return St[e];if(t)return 0;var s=parseInt(n,10),i=s%100;return(s-i)/100*60+i}(i[8],i[9],i[10]),e._d=Ge.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),g(e).rfc2822=!0}else e._isValid=!1}function Yt(e){if(e._f!==c.ISO_8601)if(e._f!==c.RFC_2822){e._a=[],g(e).empty=!0;var t,n,s,i,r,a,o,u,l=""+e._i,h=l.length,d=0;for(s=j(e._f,e._locale).match(N)||[],t=0;t<s.length;t++)i=s[t],(n=(l.match(le(i,e))||[])[0])&&(0<(r=l.substr(0,l.indexOf(n))).length&&g(e).unusedInput.push(r),l=l.slice(l.indexOf(n)+n.length),d+=n.length),E[i]?(n?g(e).empty=!1:g(e).unusedTokens.push(i),a=i,u=e,null!=(o=n)&&m(de,a)&&de[a](o,u._a,u,a)):e._strict&&!n&&g(e).unusedTokens.push(i);g(e).charsLeftOver=h-d,0<l.length&&g(e).unusedInput.push(l),e._a[ge]<=12&&!0===g(e).bigHour&&0<e._a[ge]&&(g(e).bigHour=void 0),g(e).parsedDateParts=e._a.slice(0),g(e).meridiem=e._meridiem,e._a[ge]=function(e,t,n){var s;if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):(null!=e.isPM&&((s=e.isPM(n))&&t<12&&(t+=12),s||12!==t||(t=0)),t)}(e._locale,e._a[ge],e._meridiem),ft(e),dt(e)}else Dt(e);else wt(e)}function Ot(e){var t,n,s,i,r=e._i,a=e._f;return e._locale=e._locale||ht(e._l),null===r||void 0===a&&""===r?p({nullInput:!0}):("string"==typeof r&&(e._i=r=e._locale.preparse(r)),k(r)?new M(dt(r)):(d(r)?e._d=r:o(a)?function(e){var t,n,s,i,r;if(0===e._f.length)return g(e).invalidFormat=!0,e._d=new Date(NaN);for(i=0;i<e._f.length;i++)r=0,t=w({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[i],Yt(t),v(t)&&(r+=g(t).charsLeftOver,r+=10*g(t).unusedTokens.length,g(t).score=r,(null==s||r<s)&&(s=r,n=t));_(e,n||t)}(e):a?Yt(e):l(n=(t=e)._i)?t._d=new Date(c.now()):d(n)?t._d=new Date(n.valueOf()):"string"==typeof n?(s=t,null===(i=pt.exec(s._i))?(wt(s),!1===s._isValid&&(delete s._isValid,Dt(s),!1===s._isValid&&(delete s._isValid,c.createFromInputFallback(s)))):s._d=new Date(+i[1])):o(n)?(t._a=f(n.slice(0),function(e){return parseInt(e,10)}),ft(t)):u(n)?function(e){if(!e._d){var t=R(e._i);e._a=f([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),ft(e)}}(t):h(n)?t._d=new Date(n):c.createFromInputFallback(t),v(e)||(e._d=null),e))}function Tt(e,t,n,s,i){var r,a={};return!0!==n&&!1!==n||(s=n,n=void 0),(u(e)&&function(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(e.hasOwnProperty(t))return!1;return!0}(e)||o(e)&&0===e.length)&&(e=void 0),a._isAMomentObject=!0,a._useUTC=a._isUTC=i,a._l=n,a._i=e,a._f=t,a._strict=s,(r=new M(dt(Ot(a))))._nextDay&&(r.add(1,"d"),r._nextDay=void 0),r}function bt(e,t,n,s){return Tt(e,t,n,s,!1)}c.createFromInputFallback=n("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),c.ISO_8601=function(){},c.RFC_2822=function(){};var xt=n("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=bt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:p()}),Pt=n("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=bt.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:p()});function Wt(e,t){var n,s;if(1===t.length&&o(t[0])&&(t=t[0]),!t.length)return bt();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Ct=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ht(e){var t=R(e),n=t.year||0,s=t.quarter||0,i=t.month||0,r=t.week||t.isoWeek||0,a=t.day||0,o=t.hour||0,u=t.minute||0,l=t.second||0,h=t.millisecond||0;this._isValid=function(e){for(var t in e)if(-1===Ye.call(Ct,t)||null!=e[t]&&isNaN(e[t]))return!1;for(var n=!1,s=0;s<Ct.length;++s)if(e[Ct[s]]){if(n)return!1;parseFloat(e[Ct[s]])!==D(e[Ct[s]])&&(n=!0)}return!0}(t),this._milliseconds=+h+1e3*l+6e4*u+1e3*o*60*60,this._days=+a+7*r,this._months=+i+3*s+12*n,this._data={},this._locale=ht(),this._bubble()}function Rt(e){return e instanceof Ht}function Ut(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){I(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+L(~~(e/60),2)+n+L(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),ue("Z",re),ue("ZZ",re),ce(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Nt(re,e)});var Lt=/([\+\-]|\d\d)/gi;function Nt(e,t){var n=(t||"").match(e);if(null===n)return null;var s=((n[n.length-1]||[])+"").match(Lt)||["-",0,0],i=60*s[1]+D(s[2]);return 0===i?0:"+"===s[0]?i:-i}function Gt(e,t){var n,s;return t._isUTC?(n=t.clone(),s=(k(e)||d(e)?e.valueOf():bt(e).valueOf())-n.valueOf(),n._d.setTime(n._d.valueOf()+s),c.updateOffset(n,!1),n):bt(e).local()}function Vt(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Et(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}c.updateOffset=function(){};var It=/^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,At=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function jt(e,t){var n,s,i,r=e,a=null;return Rt(e)?r={ms:e._milliseconds,d:e._days,M:e._months}:h(e)?(r={},t?r[t]=e:r.milliseconds=e):(a=It.exec(e))?(n="-"===a[1]?-1:1,r={y:0,d:D(a[ye])*n,h:D(a[ge])*n,m:D(a[ve])*n,s:D(a[pe])*n,ms:D(Ut(1e3*a[we]))*n}):(a=At.exec(e))?(n="-"===a[1]?-1:1,r={y:Zt(a[2],n),M:Zt(a[3],n),w:Zt(a[4],n),d:Zt(a[5],n),h:Zt(a[6],n),m:Zt(a[7],n),s:Zt(a[8],n)}):null==r?r={}:"object"==typeof r&&("from"in r||"to"in r)&&(i=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Gt(t,e),e.isBefore(t)?n=zt(e,t):((n=zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(bt(r.from),bt(r.to)),(r={}).ms=i.milliseconds,r.M=i.months),s=new Ht(r),Rt(e)&&m(e,"_locale")&&(s._locale=e._locale),s}function Zt(e,t){var n=e&&parseFloat(e.replace(",","."));return(isNaN(n)?0:n)*t}function zt(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function $t(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(T(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),qt(this,jt(e="string"==typeof e?+e:e,t),s),this}}function qt(e,t,n,s){var i=t._milliseconds,r=Ut(t._days),a=Ut(t._months);e.isValid()&&(s=null==s||s,a&&Re(e,be(e,"Month")+a*n),r&&xe(e,"Date",be(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s&&c.updateOffset(e,r||a))}jt.fn=Ht.prototype,jt.invalid=function(){return jt(NaN)};var Jt=$t(1,"add"),Bt=$t(-1,"subtract");function Qt(e,t){var n=12*(t.year()-e.year())+(t.month()-e.month()),s=e.clone().add(n,"months");return-(n+(t-s<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(n+1,"months")-s)))||0}function Xt(e){var t;return void 0===e?this._locale._abbr:(null!=(t=ht(e))&&(this._locale=t),this)}c.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",c.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var Kt=n("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function en(){return this._locale}var tn=126227808e5;function nn(e,t){return(e%t+t)%t}function sn(e,t,n){return e<100&&0<=e?new Date(e+400,t,n)-tn:new Date(e,t,n).valueOf()}function rn(e,t,n){return e<100&&0<=e?Date.UTC(e+400,t,n)-tn:Date.UTC(e,t,n)}function an(e,t){I(0,[e,e.length],0,t)}function on(e,t,n,s,i){var r;return null==e?Ie(this,s,i).year:((r=Ae(e,s,i))<t&&(t=r),function(e,t,n,s,i){var r=Ee(e,t,n,s,i),a=Ge(r.year,0,r.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}.call(this,e,t,n,s,i))}I(0,["gg",2],0,function(){return this.weekYear()%100}),I(0,["GG",2],0,function(){return this.isoWeekYear()%100}),an("gggg","weekYear"),an("ggggg","weekYear"),an("GGGG","isoWeekYear"),an("GGGGG","isoWeekYear"),C("weekYear","gg"),C("isoWeekYear","GG"),F("weekYear",1),F("isoWeekYear",1),ue("G",se),ue("g",se),ue("GG",B,z),ue("gg",B,z),ue("GGGG",ee,q),ue("gggg",ee,q),ue("GGGGG",te,J),ue("ggggg",te,J),fe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=D(e)}),fe(["gg","GG"],function(e,t,n,s){t[s]=c.parseTwoDigitYear(e)}),I("Q",0,"Qo","quarter"),C("quarter","Q"),F("quarter",7),ue("Q",Z),ce("Q",function(e,t){t[_e]=3*(D(e)-1)}),I("D",["DD",2],"Do","date"),C("date","D"),F("date",9),ue("D",B),ue("DD",B,z),ue("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),ce(["D","DD"],ye),ce("Do",function(e,t){t[ye]=D(e.match(B)[0])});var un=Te("Date",!0);I("DDD",["DDDD",3],"DDDo","dayOfYear"),C("dayOfYear","DDD"),F("dayOfYear",4),ue("DDD",K),ue("DDDD",$),ce(["DDD","DDDD"],function(e,t,n){n._dayOfYear=D(e)}),I("m",["mm",2],0,"minute"),C("minute","m"),F("minute",14),ue("m",B),ue("mm",B,z),ce(["m","mm"],ve);var ln=Te("Minutes",!1);I("s",["ss",2],0,"second"),C("second","s"),F("second",15),ue("s",B),ue("ss",B,z),ce(["s","ss"],pe);var hn,dn=Te("Seconds",!1);for(I("S",0,0,function(){return~~(this.millisecond()/100)}),I(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),I(0,["SSS",3],0,"millisecond"),I(0,["SSSS",4],0,function(){return 10*this.millisecond()}),I(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),I(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),I(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),I(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),I(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),C("millisecond","ms"),F("millisecond",16),ue("S",K,Z),ue("SS",K,z),ue("SSS",K,$),hn="SSSS";hn.length<=9;hn+="S")ue(hn,ne);function cn(e,t){t[we]=D(1e3*("0."+e))}for(hn="S";hn.length<=9;hn+="S")ce(hn,cn);var fn=Te("Milliseconds",!1);I("z",0,0,"zoneAbbr"),I("zz",0,0,"zoneName");var mn=M.prototype;function _n(e){return e}mn.add=Jt,mn.calendar=function(e,t){var n=e||bt(),s=Gt(n,this).startOf("day"),i=c.calendarFormat(this,s)||"sameElse",r=t&&(b(t[i])?t[i].call(this,n):t[i]);return this.format(r||this.localeData().calendar(i,this,bt(n)))},mn.clone=function(){return new M(this)},mn.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Gt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=H(t)){case"year":r=Qt(this,s)/12;break;case"month":r=Qt(this,s);break;case"quarter":r=Qt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:S(r)},mn.endOf=function(e){var t;if(void 0===(e=H(e))||"millisecond"===e||!this.isValid())return this;var n=this._isUTC?rn:sn;switch(e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=36e5-nn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":t=this._d.valueOf(),t+=6e4-nn(t,6e4)-1;break;case"second":t=this._d.valueOf(),t+=1e3-nn(t,1e3)-1;break}return this._d.setTime(t),c.updateOffset(this,!0),this},mn.format=function(e){e||(e=this.isUtc()?c.defaultFormatUtc:c.defaultFormat);var t=A(this,e);return this.localeData().postformat(t)},mn.from=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||bt(e).isValid())?jt({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},mn.fromNow=function(e){return this.from(bt(),e)},mn.to=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||bt(e).isValid())?jt({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},mn.toNow=function(e){return this.to(bt(),e)},mn.get=function(e){return b(this[e=H(e)])?this[e]():this},mn.invalidAt=function(){return g(this).overflow},mn.isAfter=function(e,t){var n=k(e)?e:bt(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=H(t)||"millisecond")?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())},mn.isBefore=function(e,t){var n=k(e)?e:bt(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=H(t)||"millisecond")?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())},mn.isBetween=function(e,t,n,s){var i=k(e)?e:bt(e),r=k(t)?t:bt(t);return!!(this.isValid()&&i.isValid()&&r.isValid())&&("("===(s=s||"()")[0]?this.isAfter(i,n):!this.isBefore(i,n))&&(")"===s[1]?this.isBefore(r,n):!this.isAfter(r,n))},mn.isSame=function(e,t){var n,s=k(e)?e:bt(e);return!(!this.isValid()||!s.isValid())&&("millisecond"===(t=H(t)||"millisecond")?this.valueOf()===s.valueOf():(n=s.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))},mn.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},mn.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},mn.isValid=function(){return v(this)},mn.lang=Kt,mn.locale=Xt,mn.localeData=en,mn.max=Pt,mn.min=xt,mn.parsingFlags=function(){return _({},g(this))},mn.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t=[];for(var n in e)t.push({unit:n,priority:U[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}(e=R(e)),s=0;s<n.length;s++)this[n[s].unit](e[n[s].unit]);else if(b(this[e=H(e)]))return this[e](t);return this},mn.startOf=function(e){var t;if(void 0===(e=H(e))||"millisecond"===e||!this.isValid())return this;var n=this._isUTC?rn:sn;switch(e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=nn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":t=this._d.valueOf(),t-=nn(t,6e4);break;case"second":t=this._d.valueOf(),t-=nn(t,1e3);break}return this._d.setTime(t),c.updateOffset(this,!0),this},mn.subtract=Bt,mn.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},mn.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},mn.toDate=function(){return new Date(this.valueOf())},mn.toISOString=function(e){if(!this.isValid())return null;var t=!0!==e,n=t?this.clone().utc():this;return n.year()<0||9999<n.year()?A(n,t?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):b(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",A(n,"Z")):A(n,t?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},mn.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e="moment",t="";this.isLocal()||(e=0===this.utcOffset()?"moment.utc":"moment.parseZone",t="Z");var n="["+e+'("]',s=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",i=t+'[")]';return this.format(n+s+"-MM-DD[T]HH:mm:ss.SSS"+i)},mn.toJSON=function(){return this.isValid()?this.toISOString():null},mn.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},mn.unix=function(){return Math.floor(this.valueOf()/1e3)},mn.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},mn.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},mn.year=Oe,mn.isLeapYear=function(){return De(this.year())},mn.weekYear=function(e){return on.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},mn.isoWeekYear=function(e){return on.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},mn.quarter=mn.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},mn.month=Ue,mn.daysInMonth=function(){return Pe(this.year(),this.month())},mn.week=mn.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},mn.isoWeek=mn.isoWeeks=function(e){var t=Ie(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},mn.weeksInYear=function(){var e=this.localeData()._week;return Ae(this.year(),e.dow,e.doy)},mn.isoWeeksInYear=function(){return Ae(this.year(),1,4)},mn.date=un,mn.day=mn.days=function(e){if(!this.isValid())return null!=e?this:NaN;var t,n,s=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(t=e,n=this.localeData(),e="string"!=typeof t?t:isNaN(t)?"number"==typeof(t=n.weekdaysParse(t))?t:null:parseInt(t,10),this.add(e-s,"d")):s},mn.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")},mn.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null==e)return this.day()||7;var t,n,s=(t=e,n=this.localeData(),"string"==typeof t?n.weekdaysParse(t)%7||7:isNaN(t)?null:t);return this.day(this.day()%7?s:s-7)},mn.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},mn.hour=mn.hours=nt,mn.minute=mn.minutes=ln,mn.second=mn.seconds=dn,mn.millisecond=mn.milliseconds=fn,mn.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?i:Vt(this);if("string"==typeof e){if(null===(e=Nt(re,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Vt(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?qt(this,jt(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,c.updateOffset(this,!0),this._changeInProgress=null)),this},mn.utc=function(e){return this.utcOffset(0,e)},mn.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(Vt(this),"m")),this},mn.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=Nt(ie,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},mn.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?bt(e).utcOffset():0,(this.utcOffset()-e)%60==0)},mn.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},mn.isLocal=function(){return!!this.isValid()&&!this._isUTC},mn.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},mn.isUtc=Et,mn.isUTC=Et,mn.zoneAbbr=function(){return this._isUTC?"UTC":""},mn.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},mn.dates=n("dates accessor is deprecated. Use date instead.",un),mn.months=n("months accessor is deprecated. Use month instead",Ue),mn.years=n("years accessor is deprecated. Use year instead",Oe),mn.zone=n("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}),mn.isDSTShifted=n("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){if(!l(this._isDSTShifted))return this._isDSTShifted;var e={};if(w(e,this),(e=Ot(e))._a){var t=e._isUTC?y(e._a):bt(e._a);this._isDSTShifted=this.isValid()&&0<a(e._a,t.toArray())}else this._isDSTShifted=!1;return this._isDSTShifted});var yn=P.prototype;function gn(e,t,n,s){var i=ht(),r=y().set(s,t);return i[n](r,e)}function vn(e,t,n){if(h(e)&&(t=e,e=void 0),e=e||"",null!=t)return gn(e,t,n,"month");var s,i=[];for(s=0;s<12;s++)i[s]=gn(e,s,n,"month");return i}function pn(e,t,n,s){t=("boolean"==typeof e?h(t)&&(n=t,t=void 0):(t=e,e=!1,h(n=t)&&(n=t,t=void 0)),t||"");var i,r=ht(),a=e?r._week.dow:0;if(null!=n)return gn(t,(n+a)%7,s,"day");var o=[];for(i=0;i<7;i++)o[i]=gn(t,(i+a)%7,s,"day");return o}yn.calendar=function(e,t,n){var s=this._calendar[e]||this._calendar.sameElse;return b(s)?s.call(t,n):s},yn.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])},yn.invalidDate=function(){return this._invalidDate},yn.ordinal=function(e){return this._ordinal.replace("%d",e)},yn.preparse=_n,yn.postformat=_n,yn.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return b(i)?i(e,t,n,s):i.replace(/%d/i,e)},yn.pastFuture=function(e,t){var n=this._relativeTime[0<e?"future":"past"];return b(n)?n(t):n.replace(/%s/i,t)},yn.set=function(e){var t,n;for(n in e)b(t=e[n])?this[n]=t:this["_"+n]=t;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},yn.months=function(e,t){return e?o(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||We).test(t)?"format":"standalone"][e.month()]:o(this._months)?this._months:this._months.standalone},yn.monthsShort=function(e,t){return e?o(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[We.test(t)?"format":"standalone"][e.month()]:o(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},yn.monthsParse=function(e,t,n){var s,i,r;if(this._monthsParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=y([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=Ye.call(this._shortMonthsParse,a))?i:null:-1!==(i=Ye.call(this._longMonthsParse,a))?i:null:"MMM"===t?-1!==(i=Ye.call(this._shortMonthsParse,a))?i:-1!==(i=Ye.call(this._longMonthsParse,a))?i:null:-1!==(i=Ye.call(this._longMonthsParse,a))?i:-1!==(i=Ye.call(this._shortMonthsParse,a))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=y([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(r="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(r.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},yn.monthsRegex=function(e){return this._monthsParseExact?(m(this,"_monthsRegex")||Ne.call(this),e?this._monthsStrictRegex:this._monthsRegex):(m(this,"_monthsRegex")||(this._monthsRegex=Le),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},yn.monthsShortRegex=function(e){return this._monthsParseExact?(m(this,"_monthsRegex")||Ne.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(m(this,"_monthsShortRegex")||(this._monthsShortRegex=Fe),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},yn.week=function(e){return Ie(e,this._week.dow,this._week.doy).week},yn.firstDayOfYear=function(){return this._week.doy},yn.firstDayOfWeek=function(){return this._week.dow},yn.weekdays=function(e,t){var n=o(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"];return!0===e?je(n,this._week.dow):e?n[e.day()]:n},yn.weekdaysMin=function(e){return!0===e?je(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},yn.weekdaysShort=function(e){return!0===e?je(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},yn.weekdaysParse=function(e,t,n){var s,i,r;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=y([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=Ye.call(this._weekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:null:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:"dddd"===t?-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=y([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(r="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(r.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},yn.weekdaysRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Qe.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(m(this,"_weekdaysRegex")||(this._weekdaysRegex=qe),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},yn.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Qe.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(m(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=Je),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},yn.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Qe.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(m(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=Be),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},yn.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},yn.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ut("en",{dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===D(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}}),c.lang=n("moment.lang is deprecated. Use moment.locale instead.",ut),c.langData=n("moment.langData is deprecated. Use moment.localeData instead.",ht);var wn=Math.abs;function Mn(e,t,n,s){var i=jt(t,n);return e._milliseconds+=s*i._milliseconds,e._days+=s*i._days,e._months+=s*i._months,e._bubble()}function kn(e){return e<0?Math.floor(e):Math.ceil(e)}function Sn(e){return 4800*e/146097}function Dn(e){return 146097*e/4800}function Yn(e){return function(){return this.as(e)}}var On=Yn("ms"),Tn=Yn("s"),bn=Yn("m"),xn=Yn("h"),Pn=Yn("d"),Wn=Yn("w"),Cn=Yn("M"),Hn=Yn("Q"),Rn=Yn("y");function Un(e){return function(){return this.isValid()?this._data[e]:NaN}}var Fn=Un("milliseconds"),Ln=Un("seconds"),Nn=Un("minutes"),Gn=Un("hours"),Vn=Un("days"),En=Un("months"),In=Un("years");var An=Math.round,jn={ss:44,s:45,m:45,h:22,d:26,M:11};var Zn=Math.abs;function zn(e){return(0<e)-(e<0)||+e}function $n(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n=Zn(this._milliseconds)/1e3,s=Zn(this._days),i=Zn(this._months);t=S((e=S(n/60))/60),n%=60,e%=60;var r=S(i/12),a=i%=12,o=s,u=t,l=e,h=n?n.toFixed(3).replace(/\.?0+$/,""):"",d=this.asSeconds();if(!d)return"P0D";var c=d<0?"-":"",f=zn(this._months)!==zn(d)?"-":"",m=zn(this._days)!==zn(d)?"-":"",_=zn(this._milliseconds)!==zn(d)?"-":"";return c+"P"+(r?f+r+"Y":"")+(a?f+a+"M":"")+(o?m+o+"D":"")+(u||l||h?"T":"")+(u?_+u+"H":"")+(l?_+l+"M":"")+(h?_+h+"S":"")}var qn=Ht.prototype;return qn.isValid=function(){return this._isValid},qn.abs=function(){var e=this._data;return this._milliseconds=wn(this._milliseconds),this._days=wn(this._days),this._months=wn(this._months),e.milliseconds=wn(e.milliseconds),e.seconds=wn(e.seconds),e.minutes=wn(e.minutes),e.hours=wn(e.hours),e.months=wn(e.months),e.years=wn(e.years),this},qn.add=function(e,t){return Mn(this,e,t,1)},qn.subtract=function(e,t){return Mn(this,e,t,-1)},qn.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=H(e))||"quarter"===e||"year"===e)switch(t=this._days+s/864e5,n=this._months+Sn(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(Dn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},qn.asMilliseconds=On,qn.asSeconds=Tn,qn.asMinutes=bn,qn.asHours=xn,qn.asDays=Pn,qn.asWeeks=Wn,qn.asMonths=Cn,qn.asQuarters=Hn,qn.asYears=Rn,qn.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*D(this._months/12):NaN},qn._bubble=function(){var e,t,n,s,i,r=this._milliseconds,a=this._days,o=this._months,u=this._data;return 0<=r&&0<=a&&0<=o||r<=0&&a<=0&&o<=0||(r+=864e5*kn(Dn(o)+a),o=a=0),u.milliseconds=r%1e3,e=S(r/1e3),u.seconds=e%60,t=S(e/60),u.minutes=t%60,n=S(t/60),u.hours=n%24,o+=i=S(Sn(a+=S(n/24))),a-=kn(Dn(i)),s=S(o/12),o%=12,u.days=a,u.months=o,u.years=s,this},qn.clone=function(){return jt(this)},qn.get=function(e){return e=H(e),this.isValid()?this[e+"s"]():NaN},qn.milliseconds=Fn,qn.seconds=Ln,qn.minutes=Nn,qn.hours=Gn,qn.days=Vn,qn.weeks=function(){return S(this.days()/7)},qn.months=En,qn.years=In,qn.humanize=function(e){if(!this.isValid())return this.localeData().invalidDate();var t,n,s,i,r,a,o,u,l,h,d,c=this.localeData(),f=(n=!e,s=c,i=jt(t=this).abs(),r=An(i.as("s")),a=An(i.as("m")),o=An(i.as("h")),u=An(i.as("d")),l=An(i.as("M")),h=An(i.as("y")),(d=r<=jn.ss&&["s",r]||r<jn.s&&["ss",r]||a<=1&&["m"]||a<jn.m&&["mm",a]||o<=1&&["h"]||o<jn.h&&["hh",o]||u<=1&&["d"]||u<jn.d&&["dd",u]||l<=1&&["M"]||l<jn.M&&["MM",l]||h<=1&&["y"]||["yy",h])[2]=n,d[3]=0<+t,d[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,d));return e&&(f=c.pastFuture(+this,f)),c.postformat(f)},qn.toISOString=$n,qn.toString=$n,qn.toJSON=$n,qn.locale=Xt,qn.localeData=en,qn.toIsoString=n("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",$n),qn.lang=Kt,I("X",0,0,"unix"),I("x",0,0,"valueOf"),ue("x",se),ue("X",/[+-]?\d+(\.\d{1,3})?/),ce("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),ce("x",function(e,t,n){n._d=new Date(D(e))}),c.version="2.24.0",e=bt,c.fn=mn,c.min=function(){return Wt("isBefore",[].slice.call(arguments,0))},c.max=function(){return Wt("isAfter",[].slice.call(arguments,0))},c.now=function(){return Date.now?Date.now():+new Date},c.utc=y,c.unix=function(e){return bt(1e3*e)},c.months=function(e,t){return vn(e,t,"months")},c.isDate=d,c.locale=ut,c.invalid=p,c.duration=jt,c.isMoment=k,c.weekdays=function(e,t,n){return pn(e,t,n,"weekdays")},c.parseZone=function(){return bt.apply(null,arguments).parseZone()},c.localeData=ht,c.isDuration=Rt,c.monthsShort=function(e,t){return vn(e,t,"monthsShort")},c.weekdaysMin=function(e,t,n){return pn(e,t,n,"weekdaysMin")},c.defineLocale=lt,c.updateLocale=function(e,t){if(null!=t){var n,s,i=st;null!=(s=ot(e))&&(i=s._config),(n=new P(t=x(i,t))).parentLocale=it[e],it[e]=n,ut(e)}else null!=it[e]&&(null!=it[e].parentLocale?it[e]=it[e].parentLocale:null!=it[e]&&delete it[e]);return it[e]},c.locales=function(){return s(it)},c.weekdaysShort=function(e,t,n){return pn(e,t,n,"weekdaysShort")},c.normalizeUnits=H,c.relativeTimeRounding=function(e){return void 0===e?An:"function"==typeof e&&(An=e,!0)},c.relativeTimeThreshold=function(e,t){return void 0!==jn[e]&&(void 0===t?jn[e]:(jn[e]=t,"s"===e&&(jn.ss=t-1),!0))},c.calendarFormat=function(e,t){var n=e.diff(t,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"},c.prototype=mn,c.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},c});
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_customParseFormat=t()}(this,function(){"use strict";function e(t){return function(e){this[t]=+e}}function n(e){return(e=m[e])&&(e.indexOf?e:e.s.concat(e.f))}function t(e,t){var n,r=m.meridiem;if(r){for(var i=1;i<=24;i+=1)if(-1<e.indexOf(r(i,0,t))){n=12<i;break}}else n=e===(t?"pm":"PM");return n}var a={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},f=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,r=/\d\d/,i=/\d\d?/,o=/\d*[^-_:/,()\s\d]+/,m={},s=function(e){return(e=+e)+(68<e?1900:2e3)},h=[/[+-]\d\d:?(\d\d)?|Z/,function(n){(this.zone||(this.zone={})).offset=function(){if(!n)return 0;if("Z"===n)return 0;var e=n.match(/([+-]|\d\d)/g),t=60*e[1]+(+e[2]||0);return 0===t?0:"+"===e[0]?-t:t}()}],c={A:[o,function(e){this.afternoon=t(e,!1)}],a:[o,function(e){this.afternoon=t(e,!0)}],S:[/\d/,function(e){this.milliseconds=100*+e}],SS:[r,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[i,e("seconds")],ss:[i,e("seconds")],m:[i,e("minutes")],mm:[i,e("minutes")],H:[i,e("hours")],h:[i,e("hours")],HH:[i,e("hours")],hh:[i,e("hours")],D:[i,e("day")],DD:[r,e("day")],Do:[o,function(e){var t=m.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],M:[i,e("month")],MM:[r,e("month")],MMM:[o,function(e){var t=n("months"),t=(n("monthsShort")||t.map(function(e){return e.slice(0,3)})).indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],MMMM:[o,function(e){e=n("months").indexOf(e)+1;if(e<1)throw new Error;this.month=e%12||e}],Y:[/[+-]?\d+/,e("year")],YY:[r,function(e){this.year=s(e)}],YYYY:[/\d{4}/,e("year")],Z:h,ZZ:h};function y(e){for(var t=e,i=m&&m.formats,u=(e=t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(e,t,n){var r=n&&n.toUpperCase();return t||i[n]||a[n]||i[r].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(e,t,n){return t||n.slice(1)})})).match(f),d=u.length,n=0;n<d;n+=1){var r=u[n],o=c[r],s=o&&o[0],o=o&&o[1];u[n]=o?{regex:s,parser:o}:r.replace(/^\[|\]$/g,"")}return function(e){for(var t,n,r,i={},o=0,s=0;o<d;o+=1){var a,f,h=u[o];"string"==typeof h?s+=h.length:(f=h.regex,h=h.parser,a=e.slice(s),f=f.exec(a)[0],h.call(i,f),e=e.replace(f,""))}return void 0!==(r=(t=i).afternoon)&&(n=t.hours,r?n<12&&(t.hours+=12):12===n&&(t.hours=0),delete t.afternoon),i}}return function(e,t,c){c.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var e=t.prototype,l=e.parse;e.parse=function(e){var t=e.date,n=e.utc,r=e.args,i=(this.$u=n,r[1]);if("string"==typeof i){var o=!0===r[2],s=!0===r[3],a=o||s,f=r[2];s&&(f=r[2]),m=this.$locale(),!o&&f&&(m=c.Ls[f]),this.$d=function(e,t,n){try{if(-1<["x","X"].indexOf(t))return new Date(("X"===t?1e3:1)*e);var r=y(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,c=new Date,l=s||(i||o?1:c.getDate()),m=i||c.getFullYear(),M=0,Y=(i&&!o||(M=0<o?o-1:c.getMonth()),a||0),p=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(m,M,l,Y,p,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(m,M,l,Y,p,D,g)):new Date(m,M,l,Y,p,D,g)}catch(e){return new Date("")}}(t,i,n),this.init(),f&&!0!==f&&(this.$L=this.locale(f).$L),a&&t!=this.format(i)&&(this.$d=new Date("")),m={}}else if(i instanceof Array)for(var h=i.length,u=1;u<=h;u+=1){r[1]=i[u-1];var d=c.apply(this,r);if(d.isValid()){this.$d=d.$d,this.$L=d.$L,this.init();break}u===h&&(this.$d=new Date(""))}else l.call(this,e)}}});
/**
 * bootbox.js 5.5.3
 *
 * http://bootboxjs.com/license.txt
 */
!function(e,t){'use strict';'function'==typeof define&&define.amd?define(['jquery'],t):'object'==typeof exports?module.exports=t(require('jquery')):e.bootbox=t(e.jQuery)}(this,function t(p,u){'use strict';var r,n,i,l;Object.keys||(Object.keys=(r=Object.prototype.hasOwnProperty,n=!{toString:null}.propertyIsEnumerable('toString'),l=(i=['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor']).length,function(e){if('function'!=typeof e&&('object'!=typeof e||null===e))throw new TypeError('Object.keys called on non-object');var t,o,a=[];for(t in e)r.call(e,t)&&a.push(t);if(n)for(o=0;o<l;o++)r.call(e,i[o])&&a.push(i[o]);return a}));var d={};d.VERSION='5.5.3';var b={en:{OK:'OK',CANCEL:'Cancel',CONFIRM:'OK'}},f={dialog:"<div class=\"bootbox modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\"><div class=\"bootbox-body\"></div></div></div></div></div>",header:"<div class=\"modal-header\"><h5 class=\"modal-title\"></h5></div>",footer:'<div class="modal-footer"></div>',closeButton:'<button type="button" class="bootbox-close-button close" aria-hidden="true">&times;</button>',form:'<form class="bootbox-form"></form>',button:'<button type="button" class="btn"></button>',option:'<option></option>',promptMessage:'<div class="bootbox-prompt-message"></div>',inputs:{text:'<input class="bootbox-input bootbox-input-text form-control" autocomplete="off" type="text" />',textarea:'<textarea class="bootbox-input bootbox-input-textarea form-control"></textarea>',email:'<input class="bootbox-input bootbox-input-email form-control" autocomplete="off" type="email" />',select:'<select class="bootbox-input bootbox-input-select form-control"></select>',checkbox:'<div class="form-check checkbox"><label class="form-check-label"><input class="form-check-input bootbox-input bootbox-input-checkbox" type="checkbox" /></label></div>',radio:'<div class="form-check radio"><label class="form-check-label"><input class="form-check-input bootbox-input bootbox-input-radio" type="radio" name="bootbox-radio" /></label></div>',date:'<input class="bootbox-input bootbox-input-date form-control" autocomplete="off" type="date" />',time:'<input class="bootbox-input bootbox-input-time form-control" autocomplete="off" type="time" />',number:'<input class="bootbox-input bootbox-input-number form-control" autocomplete="off" type="number" />',password:'<input class="bootbox-input bootbox-input-password form-control" autocomplete="off" type="password" />',range:'<input class="bootbox-input bootbox-input-range form-control-range" autocomplete="off" type="range" />'}},m={locale:'en',backdrop:'static',animate:!0,className:null,closeButton:!0,show:!0,container:'body',value:'',inputType:'text',swapButtonOrder:!1,centerVertical:!1,multiple:!1,scrollable:!1,reusable:!1,relatedTarget:null};function c(e,t,o){return p.extend(!0,{},e,function(e,t){var o=e.length,a={};if(o<1||2<o)throw new Error('Invalid argument length');return 2===o||'string'==typeof e[0]?(a[t[0]]=e[0],a[t[1]]=e[1]):a=e[0],a}(t,o))}function h(e,t,o,a){var r;a&&a[0]&&(r=a[0].locale||m.locale,(a[0].swapButtonOrder||m.swapButtonOrder)&&(t=t.reverse()));var n,i,l,s={className:'bootbox-'+e,buttons:function(e,t){for(var o={},a=0,r=e.length;a<r;a++){var n=e[a],i=n.toLowerCase(),l=n.toUpperCase();o[i]={label:(s=l,c=t,p=b[c],p?p[s]:b.en[s])}}var s,c,p;return o}(t,r)};return n=c(s,a,o),l={},g(i=t,function(e,t){l[t]=!0}),g(n.buttons,function(e){if(l[e]===u)throw new Error('button key "'+e+'" is not allowed (options are '+i.join(' ')+')')}),n}function w(e){return Object.keys(e).length}function g(e,o){var a=0;p.each(e,function(e,t){o(e,t,a++)})}function v(e){e.data.dialog.find('.bootbox-accept').first().trigger('focus')}function y(e){e.target===e.data.dialog[0]&&e.data.dialog.remove()}function x(e){e.target===e.data.dialog[0]&&(e.data.dialog.off('escape.close.bb'),e.data.dialog.off('click'))}function k(e,t,o){e.stopPropagation(),e.preventDefault(),p.isFunction(o)&&!1===o.call(t,e)||t.modal('hide')}function E(e){return/([01][0-9]|2[0-3]):[0-5][0-9]?:[0-5][0-9]/.test(e)}function O(e){return/(\d{4})-(\d{2})-(\d{2})/.test(e)}return d.locales=function(e){return e?b[e]:b},d.addLocale=function(e,o){return p.each(['OK','CANCEL','CONFIRM'],function(e,t){if(!o[t])throw new Error('Please supply a translation for "'+t+'"')}),b[e]={OK:o.OK,CANCEL:o.CANCEL,CONFIRM:o.CONFIRM},d},d.removeLocale=function(e){if('en'===e)throw new Error('"en" is used as the default and fallback locale and cannot be removed.');return delete b[e],d},d.setLocale=function(e){return d.setDefaults('locale',e)},d.setDefaults=function(){var e={};return 2===arguments.length?e[arguments[0]]=arguments[1]:e=arguments[0],p.extend(m,e),d},d.hideAll=function(){return p('.bootbox').modal('hide'),d},d.init=function(e){return t(e||p)},d.dialog=function(e){if(p.fn.modal===u)throw new Error("\"$.fn.modal\" is not defined; please double check you have included the Bootstrap JavaScript library. See https://getbootstrap.com/docs/4.4/getting-started/javascript/ for more details.");if(e=function(r){var n,i;if('object'!=typeof r)throw new Error('Please supply an object of options');if(!r.message)throw new Error('"message" option must not be null or an empty string.');(r=p.extend({},m,r)).backdrop?r.backdrop='string'!=typeof r.backdrop||'static'!==r.backdrop.toLowerCase()||'static':r.backdrop=!1!==r.backdrop&&0!==r.backdrop&&'static';r.buttons||(r.buttons={});return n=r.buttons,i=w(n),g(n,function(e,t,o){if(p.isFunction(t)&&(t=n[e]={callback:t}),'object'!==p.type(t))throw new Error('button with key "'+e+'" must be an object');if(t.label||(t.label=e),!t.className){var a=!1;a=r.swapButtonOrder?0===o:o===i-1,t.className=i<=2&&a?'btn-primary':'btn-secondary btn-default'}}),r}(e),p.fn.modal.Constructor.VERSION){e.fullBootstrapVersion=p.fn.modal.Constructor.VERSION;var t=e.fullBootstrapVersion.indexOf('.');e.bootstrap=e.fullBootstrapVersion.substring(0,t)}else e.bootstrap='2',e.fullBootstrapVersion='2.3.2',console.warn('Bootbox will *mostly* work with Bootstrap 2, but we do not officially support it. Please upgrade, if possible.');var o=p(f.dialog),a=o.find('.modal-dialog'),r=o.find('.modal-body'),n=p(f.header),i=p(f.footer),l=e.buttons,s={onEscape:e.onEscape};if(r.find('.bootbox-body').html(e.message),0<w(e.buttons)&&(g(l,function(e,t){var o=p(f.button);switch(o.data('bb-handler',e),o.addClass(t.className),e){case'ok':case'confirm':o.addClass('bootbox-accept');break;case'cancel':o.addClass('bootbox-cancel')}o.html(t.label),i.append(o),s[e]=t.callback}),r.after(i)),!0===e.animate&&o.addClass('fade'),e.className&&o.addClass(e.className),e.size)switch(e.fullBootstrapVersion.substring(0,3)<'3.1'&&console.warn('"size" requires Bootstrap 3.1.0 or higher. You appear to be using '+e.fullBootstrapVersion+'. Please upgrade to use this option.'),e.size){case'small':case'sm':a.addClass('modal-sm');break;case'large':case'lg':a.addClass('modal-lg');break;case'extra-large':case'xl':a.addClass('modal-xl'),e.fullBootstrapVersion.substring(0,3)<'4.2'&&console.warn('Using size "xl"/"extra-large" requires Bootstrap 4.2.0 or higher. You appear to be using '+e.fullBootstrapVersion+'. Please upgrade to use this option.')}if(e.scrollable&&(a.addClass('modal-dialog-scrollable'),e.fullBootstrapVersion.substring(0,3)<'4.3'&&console.warn('Using "scrollable" requires Bootstrap 4.3.0 or higher. You appear to be using '+e.fullBootstrapVersion+'. Please upgrade to use this option.')),e.title&&(r.before(n),o.find('.modal-title').html(e.title)),e.closeButton){var c=p(f.closeButton);e.title?3<e.bootstrap?o.find('.modal-header').append(c):o.find('.modal-header').prepend(c):c.prependTo(r)}if(e.centerVertical&&(a.addClass('modal-dialog-centered'),e.fullBootstrapVersion<'4.0.0'&&console.warn('"centerVertical" requires Bootstrap 4.0.0-beta.3 or higher. You appear to be using '+e.fullBootstrapVersion+'. Please upgrade to use this option.')),e.reusable||o.one('hide.bs.modal',{dialog:o},x),e.onHide){if(!p.isFunction(e.onHide))throw new Error('Argument supplied to "onHide" must be a function');o.on('hide.bs.modal',e.onHide)}if(e.reusable||o.one('hidden.bs.modal',{dialog:o},y),e.onHidden){if(!p.isFunction(e.onHidden))throw new Error('Argument supplied to "onHidden" must be a function');o.on('hidden.bs.modal',e.onHidden)}if(e.onShow){if(!p.isFunction(e.onShow))throw new Error('Argument supplied to "onShow" must be a function');o.on('show.bs.modal',e.onShow)}if(o.one('shown.bs.modal',{dialog:o},v),e.onShown){if(!p.isFunction(e.onShown))throw new Error('Argument supplied to "onShown" must be a function');o.on('shown.bs.modal',e.onShown)}return!0===e.backdrop&&o.on('click.dismiss.bs.modal',function(e){o.children('.modal-backdrop').length&&(e.currentTarget=o.children('.modal-backdrop').get(0)),e.target===e.currentTarget&&o.trigger('escape.close.bb')}),o.on('escape.close.bb',function(e){s.onEscape&&k(e,o,s.onEscape)}),o.on('click','.modal-footer button:not(.disabled)',function(e){var t=p(this).data('bb-handler');t!==u&&k(e,o,s[t])}),o.on('click','.bootbox-close-button',function(e){k(e,o,s.onEscape)}),o.on('keyup',function(e){27===e.which&&o.trigger('escape.close.bb')}),p(e.container).append(o),o.modal({backdrop:e.backdrop,keyboard:!1,show:!1}),e.show&&o.modal('show',e.relatedTarget),o},d.alert=function(){var e;if((e=h('alert',['ok'],['message','callback'],arguments)).callback&&!p.isFunction(e.callback))throw new Error('alert requires the "callback" property to be a function when provided');return e.buttons.ok.callback=e.onEscape=function(){return!p.isFunction(e.callback)||e.callback.call(this)},d.dialog(e)},d.confirm=function(){var e;if(e=h('confirm',['cancel','confirm'],['message','callback'],arguments),!p.isFunction(e.callback))throw new Error('confirm requires a callback');return e.buttons.cancel.callback=e.onEscape=function(){return e.callback.call(this,!1)},e.buttons.confirm.callback=function(){return e.callback.call(this,!0)},d.dialog(e)},d.prompt=function(){var r,t,e,n,o,a;if(e=p(f.form),(r=h('prompt',['cancel','confirm'],['title','callback'],arguments)).value||(r.value=m.value),r.inputType||(r.inputType=m.inputType),o=r.show===u?m.show:r.show,r.show=!1,r.buttons.cancel.callback=r.onEscape=function(){return r.callback.call(this,null)},r.buttons.confirm.callback=function(){var e;if('checkbox'===r.inputType)e=n.find('input:checked').map(function(){return p(this).val()}).get();else if('radio'===r.inputType)e=n.find('input:checked').val();else{if(n[0].checkValidity&&!n[0].checkValidity())return!1;e='select'===r.inputType&&!0===r.multiple?n.find('option:selected').map(function(){return p(this).val()}).get():n.val()}return r.callback.call(this,e)},!r.title)throw new Error('prompt requires a title');if(!p.isFunction(r.callback))throw new Error('prompt requires a callback');if(!f.inputs[r.inputType])throw new Error('Invalid prompt type');switch(n=p(f.inputs[r.inputType]),r.inputType){case'text':case'textarea':case'email':case'password':n.val(r.value),r.placeholder&&n.attr('placeholder',r.placeholder),r.pattern&&n.attr('pattern',r.pattern),r.maxlength&&n.attr('maxlength',r.maxlength),r.required&&n.prop({required:!0}),r.rows&&!isNaN(parseInt(r.rows))&&'textarea'===r.inputType&&n.attr({rows:r.rows});break;case'date':case'time':case'number':case'range':if(n.val(r.value),r.placeholder&&n.attr('placeholder',r.placeholder),r.pattern&&n.attr('pattern',r.pattern),r.required&&n.prop({required:!0}),'date'!==r.inputType&&r.step){if(!('any'===r.step||!isNaN(r.step)&&0<parseFloat(r.step)))throw new Error('"step" must be a valid positive number or the value "any". See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-step for more information.');n.attr('step',r.step)}!function(e,t,o){var a=!1,r=!0,n=!0;if('date'===e)t===u||(r=O(t))?o===u||(n=O(o))||console.warn('Browsers which natively support the "date" input type expect date values to be of the form "YYYY-MM-DD" (see ISO-8601 https://www.iso.org/iso-8601-date-and-time-format.html). Bootbox does not enforce this rule, but your max value may not be enforced by this browser.'):console.warn('Browsers which natively support the "date" input type expect date values to be of the form "YYYY-MM-DD" (see ISO-8601 https://www.iso.org/iso-8601-date-and-time-format.html). Bootbox does not enforce this rule, but your min value may not be enforced by this browser.');else if('time'===e){if(t!==u&&!(r=E(t)))throw new Error('"min" is not a valid time. See https://www.w3.org/TR/2012/WD-html-markup-20120315/datatypes.html#form.data.time for more information.');if(o!==u&&!(n=E(o)))throw new Error('"max" is not a valid time. See https://www.w3.org/TR/2012/WD-html-markup-20120315/datatypes.html#form.data.time for more information.')}else{if(t!==u&&isNaN(t))throw r=!1,new Error('"min" must be a valid number. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-min for more information.');if(o!==u&&isNaN(o))throw n=!1,new Error('"max" must be a valid number. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-max for more information.')}if(r&&n){if(o<=t)throw new Error('"max" must be greater than "min". See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-max for more information.');a=!0}return a}(r.inputType,r.min,r.max)||(r.min!==u&&n.attr('min',r.min),r.max!==u&&n.attr('max',r.max));break;case'select':var i={};if(a=r.inputOptions||[],!p.isArray(a))throw new Error('Please pass an array of input options');if(!a.length)throw new Error('prompt with "inputType" set to "select" requires at least one option');r.placeholder&&n.attr('placeholder',r.placeholder),r.required&&n.prop({required:!0}),r.multiple&&n.prop({multiple:!0}),g(a,function(e,t){var o=n;if(t.value===u||t.text===u)throw new Error('each option needs a "value" property and a "text" property');t.group&&(i[t.group]||(i[t.group]=p('<optgroup />').attr('label',t.group)),o=i[t.group]);var a=p(f.option);a.attr('value',t.value).text(t.text),o.append(a)}),g(i,function(e,t){n.append(t)}),n.val(r.value);break;case'checkbox':var l=p.isArray(r.value)?r.value:[r.value];if(!(a=r.inputOptions||[]).length)throw new Error('prompt with "inputType" set to "checkbox" requires at least one option');n=p('<div class="bootbox-checkbox-list"></div>'),g(a,function(e,o){if(o.value===u||o.text===u)throw new Error('each option needs a "value" property and a "text" property');var a=p(f.inputs[r.inputType]);a.find('input').attr('value',o.value),a.find('label').append('\n'+o.text),g(l,function(e,t){t===o.value&&a.find('input').prop('checked',!0)}),n.append(a)});break;case'radio':if(r.value!==u&&p.isArray(r.value))throw new Error('prompt with "inputType" set to "radio" requires a single, non-array value for "value"');if(!(a=r.inputOptions||[]).length)throw new Error('prompt with "inputType" set to "radio" requires at least one option');n=p('<div class="bootbox-radiobutton-list"></div>');var s=!0;g(a,function(e,t){if(t.value===u||t.text===u)throw new Error('each option needs a "value" property and a "text" property');var o=p(f.inputs[r.inputType]);o.find('input').attr('value',t.value),o.find('label').append('\n'+t.text),r.value!==u&&t.value===r.value&&(o.find('input').prop('checked',!0),s=!1),n.append(o)}),s&&n.find('input[type="radio"]').first().prop('checked',!0)}if(e.append(n),e.on('submit',function(e){e.preventDefault(),e.stopPropagation(),t.find('.bootbox-accept').trigger('click')}),''!==p.trim(r.message)){var c=p(f.promptMessage).html(r.message);e.prepend(c),r.message=e}else r.message=e;return(t=d.dialog(r)).off('shown.bs.modal',v),t.on('shown.bs.modal',function(){n.focus()}),!0===o&&t.modal('show'),t},d});
// Accessibility shim for bootbox: dialog naming + focus return.
// Load AFTER bootbox.js / bootbox.min.js. Do not edit vendor bootbox; put a11y here.
(function ($) {
    if (!window.bootbox || bootbox.__orA11y)
        return;

    bootbox.__orA11y = true;

    var labelIdCounter = 0;
    var origDialog = bootbox.dialog;

    function ensureId($element) {
        if (!$element.attr('id'))
            $element.attr('id', 'bootbox-label-' + (++labelIdCounter));

        return $element.attr('id');
    }

    function nameDialog(dialog, options) {
        if (dialog.attr('aria-labelledby') || dialog.attr('aria-label'))
            return;

        // callers pass raw AJAX HTML as message — exclude titles inside nested .modal
        // markup (same contract as wireModalTitleA11y in site.js)
        var $nested = dialog.find('.modal');
        var $title = dialog.find('.modal-title').not($nested.find('.modal-title')).first();

        if ($title.length) {
            dialog.attr('aria-labelledby', ensureId($title));
            return;
        }

        var headingSel = 'h1, h2, h3, h4, h5, h6, [role="heading"], .lead';
        var $messageHeading = dialog.find('.bootbox-body').find(headingSel)
            .not($nested.find(headingSel))
            .first();

        if ($messageHeading.length) {
            dialog.attr('aria-labelledby', ensureId($messageHeading));
            return;
        }

        var buttons = options.buttons || {};
        var fallbackName = dialog.find('.bootbox-form').length ? 'Prompt' :
            buttons.confirm ? 'Confirmation' :
            buttons.ok ? 'Alert' : 'Dialog';

        dialog.attr('aria-label', fallbackName);
    }

    // Keep in sync with the hidden.bs.modal focus restore in site.js $.showModal —
    // same contract, duplicated so this shim stays self-contained.
    function returnFocus(dialog, opener) {
        if (!opener || !document.contains(opener) || !$(opener).is(':visible'))
            return;

        var $openModals = $('.modal.show, .modal.in').not(dialog);

        if ($openModals.length) {
            var openerModal = $(opener).closest('.modal')[0];
            var topModal = $openModals.last()[0];

            if (!openerModal || openerModal !== topModal)
                return;
        }

        opener.focus();
    }

    bootbox.dialog = function (options) {
        options = options || {};

        var shouldShow = options.show !== false;
        var dialogOptions = $.extend({}, options, { show: false });
        var dialog = origDialog.call(this, dialogOptions);
        var opener = null;

        dialog.attr('aria-modal', 'true');
        nameDialog(dialog, options);

        dialog.on('show.bs.modal.orA11y', function (e) {
            if (e.target !== dialog[0])
                return;

            opener = document.activeElement;
        });

        // Vendor bootbox registers destroyModal with .one('hidden.bs.modal'). A nested
        // modal's bubbled hidden event consumes that one-shot even though destroyModal
        // rejects non-self targets — so the outer dialog can survive in the DOM.
        // Re-run removal here under the same e.target guard; double-remove is a no-op.
        // Leave reusable dialogs alone (vendor also skips destroy for those).
        var reusable = !!options.reusable;

        dialog.on('hidden.bs.modal.orA11y', function (e) {
            if (e.target !== dialog[0])
                return;

            returnFocus(dialog, opener);

            if (!reusable)
                dialog.remove();
        });

        if (shouldShow)
            dialog.modal('show', options.relatedTarget);

        return dialog;
    };
})(jQuery);

/*!
 * clipboard.js v1.5.5
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.Clipboard=t()}}(function(){var t,e,n;return function t(e,n,r){function o(a,c){if(!n[a]){if(!e[a]){var s="function"==typeof require&&require;if(!c&&s)return s(a,!0);if(i)return i(a,!0);var u=new Error("Cannot find module '"+a+"'");throw u.code="MODULE_NOT_FOUND",u}var l=n[a]={exports:{}};e[a][0].call(l.exports,function(t){var n=e[a][1][t];return o(n?n:t)},l,l.exports,t,e,n,r)}return n[a].exports}for(var i="function"==typeof require&&require,a=0;a<r.length;a++)o(r[a]);return o}({1:[function(t,e,n){var r=t("matches-selector");e.exports=function(t,e,n){for(var o=n?t:t.parentNode;o&&o!==document;){if(r(o,e))return o;o=o.parentNode}}},{"matches-selector":2}],2:[function(t,e,n){function r(t,e){if(i)return i.call(t,e);for(var n=t.parentNode.querySelectorAll(e),r=0;r<n.length;++r)if(n[r]==t)return!0;return!1}var o=Element.prototype,i=o.matchesSelector||o.webkitMatchesSelector||o.mozMatchesSelector||o.msMatchesSelector||o.oMatchesSelector;e.exports=r},{}],3:[function(t,e,n){function r(t,e,n,r){var i=o.apply(this,arguments);return t.addEventListener(n,i),{destroy:function(){t.removeEventListener(n,i)}}}function o(t,e,n,r){return function(n){n.delegateTarget=i(n.target,e,!0),n.delegateTarget&&r.call(t,n)}}var i=t("closest");e.exports=r},{closest:1}],4:[function(t,e,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.function=function(t){var e=Object.prototype.toString.call(t);return"[object Function]"===e}},{}],5:[function(t,e,n){function r(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.function(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return o(t,e,n);if(c.nodeList(t))return i(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function o(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function i(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return s(document.body,t,e,n)}var c=t("./is"),s=t("delegate");e.exports=r},{"./is":4,delegate:3}],6:[function(t,e,n){function r(t){var e;if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName)t.focus(),t.setSelectionRange(0,t.value.length),e=t.value;else{t.hasAttribute("contenteditable")&&t.focus();var n=window.getSelection(),r=document.createRange();r.selectNodeContents(t),n.removeAllRanges(),n.addRange(r),e=n.toString()}return e}e.exports=r},{}],7:[function(t,e,n){function r(){}r.prototype={on:function(t,e,n){var r=this.e||(this.e={});return(r[t]||(r[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function r(){o.off(t,r),e.apply(n,arguments)}var o=this;return r._=e,this.on(t,r,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),r=0,o=n.length;for(r;o>r;r++)n[r].fn.apply(n[r].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),r=n[t],o=[];if(r&&e)for(var i=0,a=r.length;a>i;i++)r[i].fn!==e&&r[i].fn._!==e&&o.push(r[i]);return o.length?n[t]=o:delete n[t],this}},e.exports=r},{}],8:[function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}n.__esModule=!0;var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=t("select"),c=r(a),s=function(){function t(e){o(this,t),this.resolveOptions(e),this.initSelection()}return t.prototype.resolveOptions=function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.action=e.action,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""},t.prototype.initSelection=function t(){if(this.text&&this.target)throw new Error('Multiple attributes declared, use either "target" or "text"');if(this.text)this.selectFake();else{if(!this.target)throw new Error('Missing required attributes, use either "target" or "text"');this.selectTarget()}},t.prototype.selectFake=function t(){var e=this;this.removeFake(),this.fakeHandler=document.body.addEventListener("click",function(){return e.removeFake()}),this.fakeElem=document.createElement("textarea"),this.fakeElem.style.position="absolute",this.fakeElem.style.left="-9999px",this.fakeElem.style.top=(window.pageYOffset||document.documentElement.scrollTop)+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,document.body.appendChild(this.fakeElem),this.selectedText=c.default(this.fakeElem),this.fakeElem.focus(),this.copyText()},t.prototype.removeFake=function t(){this.fakeHandler&&(document.body.removeEventListener("click"),this.fakeHandler=null),this.fakeElem&&(document.body.removeChild(this.fakeElem),this.fakeElem=null)},t.prototype.selectTarget=function t(){this.selectedText=c.default(this.target),this.copyText()},t.prototype.copyText=function t(){var e=void 0;try{e=document.execCommand(this.action)}catch(n){e=!1}this.handleResult(e)},t.prototype.handleResult=function t(e){e?this.emitter.emit("success",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)}):this.emitter.emit("error",{action:this.action,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})},t.prototype.clearSelection=function t(){this.target&&this.target.blur(),window.getSelection().removeAllRanges()},t.prototype.destroy=function t(){this.removeFake()},i(t,[{key:"action",set:function t(){var e=arguments.length<=0||void 0===arguments[0]?"copy":arguments[0];if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function t(){return this._action}},{key:"target",set:function t(e){if(void 0!==e){if(!e||"object"!=typeof e||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');this._target=e}},get:function t(){return this._target}}]),t}();n.default=s,e.exports=n.default},{select:6}],9:[function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}n.__esModule=!0;var c=t("./clipboard-action"),s=r(c),u=t("tiny-emitter"),l=r(u),f=t("good-listener"),d=r(f),h=function(t){function e(n,r){o(this,e),t.call(this),this.resolveOptions(r),this.listenClick(n)}return i(e,t),e.prototype.resolveOptions=function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText},e.prototype.listenClick=function t(e){var n=this;this.listener=d.default(e,"click",function(t){return n.onClick(t)})},e.prototype.onClick=function t(e){var n=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new s.default({action:this.action(n),target:this.target(n),text:this.text(n),trigger:n,emitter:this})},e.prototype.defaultAction=function t(e){return a("action",e)},e.prototype.defaultTarget=function t(e){var n=a("target",e);return n?document.querySelector(n):void 0},e.prototype.defaultText=function t(e){return a("text",e)},e.prototype.destroy=function t(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)},e}(l.default);n.default=h,e.exports=n.default},{"./clipboard-action":8,"good-listener":5,"tiny-emitter":7}]},{},[9])(9)});
/*!
 * typeahead.js 1.2.0
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2017 Twitter, Inc. and other contributors; Licensed MIT
 */

!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(c){return a.Bloodhound=b(c)}):"object"==typeof exports?module.exports=b(require("jquery")):a.Bloodhound=b(a.jQuery)}(this,function(a){var b=function(){"use strict";return{isMsie:function(){return!!/(msie|trident)/i.test(navigator.userAgent)&&navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]},isBlankString:function(a){return!a||/^\s*$/.test(a)},escapeRegExChars:function(a){return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},isString:function(a){return"string"==typeof a},isNumber:function(a){return"number"==typeof a},isArray:a.isArray,isFunction:a.isFunction,isObject:a.isPlainObject,isUndefined:function(a){return"undefined"==typeof a},isElement:function(a){return!(!a||1!==a.nodeType)},isJQuery:function(b){return b instanceof a},toStr:function(a){return b.isUndefined(a)||null===a?"":a+""},bind:a.proxy,each:function(b,c){function d(a,b){return c(b,a)}a.each(b,d)},map:a.map,filter:a.grep,every:function(b,c){var d=!0;return b?(a.each(b,function(a,e){if(!(d=c.call(null,e,a,b)))return!1}),!!d):d},some:function(b,c){var d=!1;return b?(a.each(b,function(a,e){if(d=c.call(null,e,a,b))return!1}),!!d):d},mixin:a.extend,identity:function(a){return a},clone:function(b){return a.extend(!0,{},b)},getIdGenerator:function(){var a=0;return function(){return a++}},templatify:function(b){function c(){return String(b)}return a.isFunction(b)?b:c},defer:function(a){setTimeout(a,0)},debounce:function(a,b,c){var d,e;return function(){var f,g,h=this,i=arguments;return f=function(){d=null,c||(e=a.apply(h,i))},g=c&&!d,clearTimeout(d),d=setTimeout(f,b),g&&(e=a.apply(h,i)),e}},throttle:function(a,b){var c,d,e,f,g,h;return g=0,h=function(){g=new Date,e=null,f=a.apply(c,d)},function(){var i=new Date,j=b-(i-g);return c=this,d=arguments,j<=0?(clearTimeout(e),e=null,g=i,f=a.apply(c,d)):e||(e=setTimeout(h,j)),f}},stringify:function(a){return b.isString(a)?a:JSON.stringify(a)},guid:function(){function a(a){var b=(Math.random().toString(16)+"000000000").substr(2,8);return a?"-"+b.substr(0,4)+"-"+b.substr(4,4):b}return"tt-"+a()+a(!0)+a(!0)+a()},noop:function(){}}}(),c="1.2.0",d=function(){"use strict";function a(a){return a=b.toStr(a),a?a.split(/\s+/):[]}function c(a){return a=b.toStr(a),a?a.split(/\W+/):[]}function d(a){a=b.toStr(a);var c=[],d="";return b.each(a.split(""),function(a){a.match(/\s+/)?d="":(c.push(d+a),d+=a)}),c}function e(a){return function(c){return c=b.isArray(c)?c:[].slice.call(arguments,0),function(d){var e=[];return b.each(c,function(c){e=e.concat(a(b.toStr(d[c])))}),e}}}return{nonword:c,whitespace:a,ngram:d,obj:{nonword:e(c),whitespace:e(a),ngram:e(d)}}}(),e=function(){"use strict";function c(c){this.maxSize=b.isNumber(c)?c:100,this.reset(),this.maxSize<=0&&(this.set=this.get=a.noop)}function d(){this.head=this.tail=null}function e(a,b){this.key=a,this.val=b,this.prev=this.next=null}return b.mixin(c.prototype,{set:function(a,b){var c,d=this.list.tail;this.size>=this.maxSize&&(this.list.remove(d),delete this.hash[d.key],this.size--),(c=this.hash[a])?(c.val=b,this.list.moveToFront(c)):(c=new e(a,b),this.list.add(c),this.hash[a]=c,this.size++)},get:function(a){var b=this.hash[a];if(b)return this.list.moveToFront(b),b.val},reset:function(){this.size=0,this.hash={},this.list=new d}}),b.mixin(d.prototype,{add:function(a){this.head&&(a.next=this.head,this.head.prev=a),this.head=a,this.tail=this.tail||a},remove:function(a){a.prev?a.prev.next=a.next:this.head=a.next,a.next?a.next.prev=a.prev:this.tail=a.prev},moveToFront:function(a){this.remove(a),this.add(a)}}),c}(),f=function(){"use strict";function c(a,c){this.prefix=["__",a,"__"].join(""),this.ttlKey="__ttl__",this.keyMatcher=new RegExp("^"+b.escapeRegExChars(this.prefix)),this.ls=c||h,!this.ls&&this._noop()}function d(){return(new Date).getTime()}function e(a){return JSON.stringify(b.isUndefined(a)?null:a)}function f(b){return a.parseJSON(b)}function g(a){var b,c,d=[],e=h.length;for(b=0;b<e;b++)(c=h.key(b)).match(a)&&d.push(c.replace(a,""));return d}var h;try{h=window.localStorage,h.setItem("~~~","!"),h.removeItem("~~~")}catch(a){h=null}return b.mixin(c.prototype,{_prefix:function(a){return this.prefix+a},_ttlKey:function(a){return this._prefix(a)+this.ttlKey},_noop:function(){this.get=this.set=this.remove=this.clear=this.isExpired=b.noop},_safeSet:function(a,b){try{this.ls.setItem(a,b)}catch(a){"QuotaExceededError"===a.name&&(this.clear(),this._noop())}},get:function(a){return this.isExpired(a)&&this.remove(a),f(this.ls.getItem(this._prefix(a)))},set:function(a,c,f){return b.isNumber(f)?this._safeSet(this._ttlKey(a),e(d()+f)):this.ls.removeItem(this._ttlKey(a)),this._safeSet(this._prefix(a),e(c))},remove:function(a){return this.ls.removeItem(this._ttlKey(a)),this.ls.removeItem(this._prefix(a)),this},clear:function(){var a,b=g(this.keyMatcher);for(a=b.length;a--;)this.remove(b[a]);return this},isExpired:function(a){var c=f(this.ls.getItem(this._ttlKey(a)));return!!(b.isNumber(c)&&d()>c)}}),c}(),g=function(){"use strict";function c(a){a=a||{},this.maxPendingRequests=a.maxPendingRequests||6,this.cancelled=!1,this.lastReq=null,this._send=a.transport,this._get=a.limiter?a.limiter(this._get):this._get,this._cache=a.cache===!1?new e(0):g}var d=0,f={},g=new e(10);return c.setMaxPendingRequests=function(a){this.maxPendingRequests=a},c.resetCache=function(){g.reset()},b.mixin(c.prototype,{_fingerprint:function(b){return b=b||{},b.url+b.type+a.param(b.data||{})},_get:function(a,b){function c(a){b(null,a),j._cache.set(h,a)}function e(){b(!0)}function g(){d--,delete f[h],j.onDeckRequestArgs&&(j._get.apply(j,j.onDeckRequestArgs),j.onDeckRequestArgs=null)}var h,i,j=this;h=this._fingerprint(a),this.cancelled||h!==this.lastReq||((i=f[h])?i.done(c).fail(e):d<this.maxPendingRequests?(d++,f[h]=this._send(a).done(c).fail(e).always(g)):this.onDeckRequestArgs=[].slice.call(arguments,0))},get:function(c,d){var e,f;d=d||a.noop,c=b.isString(c)?{url:c}:c||{},f=this._fingerprint(c),this.cancelled=!1,this.lastReq=f,(e=this._cache.get(f))?d(null,e):this._get(c,d)},cancel:function(){this.cancelled=!0}}),c}(),h=window.SearchIndex=function(){"use strict";function c(c){c=c||{},c.datumTokenizer&&c.queryTokenizer||a.error("datumTokenizer and queryTokenizer are both required"),this.identify=c.identify||b.stringify,this.datumTokenizer=c.datumTokenizer,this.queryTokenizer=c.queryTokenizer,this.matchAnyQueryToken=c.matchAnyQueryToken,this.reset()}function d(a){return a=b.filter(a,function(a){return!!a}),a=b.map(a,function(a){return a.toLowerCase()})}function e(){var a={};return a[i]=[],a[h]={},a}function f(a){for(var b={},c=[],d=0,e=a.length;d<e;d++)b[a[d]]||(b[a[d]]=!0,c.push(a[d]));return c}function g(a,b){var c=0,d=0,e=[];a=a.sort(),b=b.sort();for(var f=a.length,g=b.length;c<f&&d<g;)a[c]<b[d]?c++:a[c]>b[d]?d++:(e.push(a[c]),c++,d++);return e}var h="c",i="i";return b.mixin(c.prototype,{bootstrap:function(a){this.datums=a.datums,this.trie=a.trie},add:function(a){var c=this;a=b.isArray(a)?a:[a],b.each(a,function(a){var f,g;c.datums[f=c.identify(a)]=a,g=d(c.datumTokenizer(a)),b.each(g,function(a){var b,d,g;for(b=c.trie,d=a.split("");g=d.shift();)b=b[h][g]||(b[h][g]=e()),b[i].push(f)})})},get:function(a){var c=this;return b.map(a,function(a){return c.datums[a]})},search:function(a){var c,e,j=this;return c=d(this.queryTokenizer(a)),b.each(c,function(a){var b,c,d,f;if(e&&0===e.length&&!j.matchAnyQueryToken)return!1;for(b=j.trie,c=a.split("");b&&(d=c.shift());)b=b[h][d];if(b&&0===c.length)f=b[i].slice(0),e=e?g(e,f):f;else if(!j.matchAnyQueryToken)return e=[],!1}),e?b.map(f(e),function(a){return j.datums[a]}):[]},all:function(){var a=[];for(var b in this.datums)a.push(this.datums[b]);return a},reset:function(){this.datums={},this.trie=e()},serialize:function(){return{datums:this.datums,trie:this.trie}}}),c}(),i=function(){"use strict";function a(a){this.url=a.url,this.ttl=a.ttl,this.cache=a.cache,this.prepare=a.prepare,this.transform=a.transform,this.transport=a.transport,this.thumbprint=a.thumbprint,this.storage=new f(a.cacheKey)}var c;return c={data:"data",protocol:"protocol",thumbprint:"thumbprint"},b.mixin(a.prototype,{_settings:function(){return{url:this.url,type:"GET",dataType:"json"}},store:function(a){this.cache&&(this.storage.set(c.data,a,this.ttl),this.storage.set(c.protocol,location.protocol,this.ttl),this.storage.set(c.thumbprint,this.thumbprint,this.ttl))},fromCache:function(){var a,b={};return this.cache?(b.data=this.storage.get(c.data),b.protocol=this.storage.get(c.protocol),b.thumbprint=this.storage.get(c.thumbprint),a=b.thumbprint!==this.thumbprint||b.protocol!==location.protocol,b.data&&!a?b.data:null):null},fromNetwork:function(a){function b(){a(!0)}function c(b){a(null,e.transform(b))}var d,e=this;a&&(d=this.prepare(this._settings()),this.transport(d).fail(b).done(c))},clear:function(){return this.storage.clear(),this}}),a}(),j=function(){"use strict";function a(a){this.url=a.url,this.prepare=a.prepare,this.transform=a.transform,this.indexResponse=a.indexResponse,this.transport=new g({cache:a.cache,limiter:a.limiter,transport:a.transport,maxPendingRequests:a.maxPendingRequests})}return b.mixin(a.prototype,{_settings:function(){return{url:this.url,type:"GET",dataType:"json"}},get:function(a,b){function c(a,c){b(a?[]:e.transform(c))}var d,e=this;if(b)return a=a||"",d=this.prepare(a,this._settings()),this.transport.get(d,c)},cancelLastRequest:function(){this.transport.cancel()}}),a}(),k=function(){"use strict";function d(d){var e;return d?(e={url:null,ttl:864e5,cache:!0,cacheKey:null,thumbprint:"",prepare:b.identity,transform:b.identity,transport:null},d=b.isString(d)?{url:d}:d,d=b.mixin(e,d),!d.url&&a.error("prefetch requires url to be set"),d.transform=d.filter||d.transform,d.cacheKey=d.cacheKey||d.url,d.thumbprint=c+d.thumbprint,d.transport=d.transport?h(d.transport):a.ajax,d):null}function e(c){var d;if(c)return d={url:null,cache:!0,prepare:null,replace:null,wildcard:null,limiter:null,rateLimitBy:"debounce",rateLimitWait:300,transform:b.identity,transport:null},c=b.isString(c)?{url:c}:c,c=b.mixin(d,c),!c.url&&a.error("remote requires url to be set"),c.transform=c.filter||c.transform,c.prepare=f(c),c.limiter=g(c),c.transport=c.transport?h(c.transport):a.ajax,delete c.replace,delete c.wildcard,delete c.rateLimitBy,delete c.rateLimitWait,c}function f(a){function b(a,b){return b.url=f(b.url,a),b}function c(a,b){return b.url=b.url.replace(g,encodeURIComponent(a)),b}function d(a,b){return b}var e,f,g;return e=a.prepare,f=a.replace,g=a.wildcard,e?e:e=f?b:a.wildcard?c:d}function g(a){function c(a){return function(c){return b.debounce(c,a)}}function d(a){return function(c){return b.throttle(c,a)}}var e,f,g;return e=a.limiter,f=a.rateLimitBy,g=a.rateLimitWait,e||(e=/^throttle$/i.test(f)?d(g):c(g)),e}function h(c){return function(d){function e(a){b.defer(function(){g.resolve(a)})}function f(a){b.defer(function(){g.reject(a)})}var g=a.Deferred();return c(d,e,f),g}}return function(c){var f,g;return f={initialize:!0,identify:b.stringify,datumTokenizer:null,queryTokenizer:null,matchAnyQueryToken:!1,sufficient:5,indexRemote:!1,sorter:null,local:[],prefetch:null,remote:null},c=b.mixin(f,c||{}),!c.datumTokenizer&&a.error("datumTokenizer is required"),!c.queryTokenizer&&a.error("queryTokenizer is required"),g=c.sorter,c.sorter=g?function(a){return a.sort(g)}:b.identity,c.local=b.isFunction(c.local)?c.local():c.local,c.prefetch=d(c.prefetch),c.remote=e(c.remote),c}}(),l=function(){"use strict";function c(a){a=k(a),this.sorter=a.sorter,this.identify=a.identify,this.sufficient=a.sufficient,this.indexRemote=a.indexRemote,this.local=a.local,this.remote=a.remote?new j(a.remote):null,this.prefetch=a.prefetch?new i(a.prefetch):null,this.index=new h({identify:this.identify,datumTokenizer:a.datumTokenizer,queryTokenizer:a.queryTokenizer}),a.initialize!==!1&&this.initialize()}var e;return e=window&&window.Bloodhound,c.noConflict=function(){return window&&(window.Bloodhound=e),c},c.tokenizers=d,b.mixin(c.prototype,{__ttAdapter:function(){function a(a,b,d){return c.search(a,b,d)}function b(a,b){return c.search(a,b)}var c=this;return this.remote?a:b},_loadPrefetch:function(){function b(a,b){return a?c.reject():(e.add(b),e.prefetch.store(e.index.serialize()),void c.resolve())}var c,d,e=this;return c=a.Deferred(),this.prefetch?(d=this.prefetch.fromCache())?(this.index.bootstrap(d),c.resolve()):this.prefetch.fromNetwork(b):c.resolve(),c.promise()},_initialize:function(){function a(){b.add(b.local)}var b=this;return this.clear(),(this.initPromise=this._loadPrefetch()).done(a),this.initPromise},initialize:function(a){return!this.initPromise||a?this._initialize():this.initPromise},add:function(a){return this.index.add(a),this},get:function(a){return a=b.isArray(a)?a:[].slice.call(arguments),this.index.get(a)},search:function(a,c,d){function e(a){var c=[];b.each(a,function(a){!b.some(f,function(b){return g.identify(a)===g.identify(b)})&&c.push(a)}),g.indexRemote&&g.add(c),d(c)}var f,g=this;return c=c||b.noop,d=d||b.noop,f=this.sorter(this.index.search(a)),c(this.remote?f.slice():f),this.remote&&f.length<this.sufficient?this.remote.get(a,e):this.remote&&this.remote.cancelLastRequest(),this},all:function(){return this.index.all()},clear:function(){return this.index.reset(),this},clearPrefetchCache:function(){return this.prefetch&&this.prefetch.clear(),this},clearRemoteCache:function(){return g.resetCache(),this},ttAdapter:function(){return this.__ttAdapter()}}),c}();return l}),function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(a.jQuery)}(this,function(a){var b=function(){"use strict";return{isMsie:function(){return!!/(msie|trident)/i.test(navigator.userAgent)&&navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]},isBlankString:function(a){return!a||/^\s*$/.test(a)},escapeRegExChars:function(a){return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},isString:function(a){return"string"==typeof a},isNumber:function(a){return"number"==typeof a},isArray:a.isArray,isFunction:a.isFunction,isObject:a.isPlainObject,isUndefined:function(a){return"undefined"==typeof a},isElement:function(a){return!(!a||1!==a.nodeType)},isJQuery:function(b){return b instanceof a},toStr:function(a){return b.isUndefined(a)||null===a?"":a+""},bind:a.proxy,each:function(b,c){function d(a,b){return c(b,a)}a.each(b,d)},map:a.map,filter:a.grep,every:function(b,c){var d=!0;return b?(a.each(b,function(a,e){if(!(d=c.call(null,e,a,b)))return!1}),!!d):d},some:function(b,c){var d=!1;return b?(a.each(b,function(a,e){if(d=c.call(null,e,a,b))return!1}),!!d):d},mixin:a.extend,identity:function(a){return a},clone:function(b){return a.extend(!0,{},b)},getIdGenerator:function(){var a=0;return function(){return a++}},templatify:function(b){function c(){return String(b)}return a.isFunction(b)?b:c},defer:function(a){setTimeout(a,0)},debounce:function(a,b,c){var d,e;return function(){var f,g,h=this,i=arguments;return f=function(){d=null,c||(e=a.apply(h,i))},g=c&&!d,clearTimeout(d),d=setTimeout(f,b),g&&(e=a.apply(h,i)),e}},throttle:function(a,b){var c,d,e,f,g,h;return g=0,h=function(){g=new Date,e=null,f=a.apply(c,d)},function(){var i=new Date,j=b-(i-g);return c=this,d=arguments,j<=0?(clearTimeout(e),e=null,g=i,f=a.apply(c,d)):e||(e=setTimeout(h,j)),f}},stringify:function(a){return b.isString(a)?a:JSON.stringify(a)},guid:function(){function a(a){var b=(Math.random().toString(16)+"000000000").substr(2,8);return a?"-"+b.substr(0,4)+"-"+b.substr(4,4):b}return"tt-"+a()+a(!0)+a(!0)+a()},noop:function(){}}}(),c=function(){"use strict";function a(a){var g,h;return h=b.mixin({},f,a),g={css:e(),classes:h,html:c(h),selectors:d(h)},{css:g.css,html:g.html,classes:g.classes,selectors:g.selectors,mixin:function(a){b.mixin(a,g)}}}function c(a){return{wrapper:'<span class="'+a.wrapper+'"></span>',menu:'<div role="listbox" class="'+a.menu+'"></div>'}}function d(a){var c={};return b.each(a,function(a,b){c[b]="."+a}),c}function e(){var a={wrapper:{position:"relative",display:"inline-block"},hint:{position:"absolute",top:"0",left:"0",borderColor:"transparent",boxShadow:"none",opacity:"1"},input:{position:"relative",verticalAlign:"top",backgroundColor:"transparent"},inputWithNoHint:{position:"relative",verticalAlign:"top"},menu:{position:"absolute",top:"100%",left:"0",zIndex:"100",display:"none"},ltr:{left:"0",right:"auto"},rtl:{left:"auto",right:" 0"}};return b.isMsie()&&b.mixin(a.input,{backgroundImage:"url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"}),a}var f={wrapper:"twitter-typeahead",input:"tt-input",hint:"tt-hint",menu:"tt-menu",dataset:"tt-dataset",suggestion:"tt-suggestion",selectable:"tt-selectable",empty:"tt-empty",open:"tt-open",cursor:"tt-cursor",highlight:"tt-highlight"};return a}(),d=function(){"use strict";function c(b){b&&b.el||a.error("EventBus initialized without el"),this.$el=a(b.el)}var d,e;return d="typeahead:",e={render:"rendered",cursorchange:"cursorchanged",select:"selected",autocomplete:"autocompleted"},b.mixin(c.prototype,{_trigger:function(b,c){var e=a.Event(d+b);return this.$el.trigger.call(this.$el,e,c||[]),e},before:function(a){var b,c;return b=[].slice.call(arguments,1),c=this._trigger("before"+a,b),c.isDefaultPrevented()},trigger:function(a){var b;this._trigger(a,[].slice.call(arguments,1)),(b=e[a])&&this._trigger(b,[].slice.call(arguments,1))}}),c}(),e=function(){"use strict";function a(a,b,c,d){var e;if(!c)return this;for(b=b.split(i),c=d?h(c,d):c,this._callbacks=this._callbacks||{};e=b.shift();)this._callbacks[e]=this._callbacks[e]||{sync:[],async:[]},this._callbacks[e][a].push(c);return this}function b(b,c,d){return a.call(this,"async",b,c,d)}function c(b,c,d){return a.call(this,"sync",b,c,d)}function d(a){var b;if(!this._callbacks)return this;for(a=a.split(i);b=a.shift();)delete this._callbacks[b];return this}function e(a){var b,c,d,e,g;if(!this._callbacks)return this;for(a=a.split(i),d=[].slice.call(arguments,1);(b=a.shift())&&(c=this._callbacks[b]);)e=f(c.sync,this,[b].concat(d)),g=f(c.async,this,[b].concat(d)),e()&&j(g);return this}function f(a,b,c){function d(){for(var d,e=0,f=a.length;!d&&e<f;e+=1)d=a[e].apply(b,c)===!1;return!d}return d}function g(){var a;return a=window.setImmediate?function(a){setImmediate(function(){a()})}:function(a){setTimeout(function(){a()},0)}}function h(a,b){return a.bind?a.bind(b):function(){a.apply(b,[].slice.call(arguments,0))}}var i=/\s+/,j=g();return{onSync:c,onAsync:b,off:d,trigger:e}}(),f=function(a){"use strict";function c(a){return f[a.toUpperCase()]||a}function d(a,d,e,f){for(var g,h=[],i=0,j=a.length;i<j;i++){var k=b.escapeRegExChars(a[i]);f&&(k=k.replace(/\S/g,c)),h.push(k)}return g=e?"\\b("+h.join("|")+")\\b":"("+h.join("|")+")",d?new RegExp(g):new RegExp(g,"i")}var e={node:null,pattern:null,tagName:"strong",className:null,wordsOnly:!1,caseSensitive:!1,diacriticInsensitive:!1},f={A:"[AaªÀ-Åà-åĀ-ąǍǎȀ-ȃȦȧᴬᵃḀḁẚẠ-ảₐ℀℁℻⒜Ⓐⓐ㍱-㍴㎀-㎄㎈㎉㎩-㎯㏂㏊㏟㏿Ａａ]",B:"[BbᴮᵇḂ-ḇℬ⒝Ⓑⓑ㍴㎅-㎇㏃㏈㏔㏝Ｂｂ]",C:"[CcÇçĆ-čᶜ℀ℂ℃℅℆ℭⅭⅽ⒞Ⓒⓒ㍶㎈㎉㎝㎠㎤㏄-㏇Ｃｃ]",D:"[DdĎďǄ-ǆǱ-ǳᴰᵈḊ-ḓⅅⅆⅮⅾ⒟Ⓓⓓ㋏㍲㍷-㍹㎗㎭-㎯㏅㏈Ｄｄ]",E:"[EeÈ-Ëè-ëĒ-ěȄ-ȇȨȩᴱᵉḘ-ḛẸ-ẽₑ℡ℯℰⅇ⒠Ⓔⓔ㉐㋍㋎Ｅｅ]",F:"[FfᶠḞḟ℉ℱ℻⒡Ⓕⓕ㎊-㎌㎙ﬀ-ﬄＦｆ]",G:"[GgĜ-ģǦǧǴǵᴳᵍḠḡℊ⒢Ⓖⓖ㋌㋍㎇㎍-㎏㎓㎬㏆㏉㏒㏿Ｇｇ]",H:"[HhĤĥȞȟʰᴴḢ-ḫẖℋ-ℎ⒣Ⓗⓗ㋌㍱㎐-㎔㏊㏋㏗Ｈｈ]",I:"[IiÌ-Ïì-ïĨ-İĲĳǏǐȈ-ȋᴵᵢḬḭỈ-ịⁱℐℑℹⅈⅠ-ⅣⅥ-ⅨⅪⅫⅰ-ⅳⅵ-ⅸⅺⅻ⒤Ⓘⓘ㍺㏌㏕ﬁﬃＩｉ]",J:"[JjĲ-ĵǇ-ǌǰʲᴶⅉ⒥ⒿⓙⱼＪｊ]",K:"[KkĶķǨǩᴷᵏḰ-ḵK⒦Ⓚⓚ㎄㎅㎉㎏㎑㎘㎞㎢㎦㎪㎸㎾㏀㏆㏍-㏏Ｋｋ]",L:"[LlĹ-ŀǇ-ǉˡᴸḶḷḺ-ḽℒℓ℡Ⅼⅼ⒧Ⓛⓛ㋏㎈㎉㏐-㏓㏕㏖㏿ﬂﬄＬｌ]",M:"[MmᴹᵐḾ-ṃ℠™ℳⅯⅿ⒨Ⓜⓜ㍷-㍹㎃㎆㎎㎒㎖㎙-㎨㎫㎳㎷㎹㎽㎿㏁㏂㏎㏐㏔-㏖㏘㏙㏞㏟Ｍｍ]",N:"[NnÑñŃ-ŉǊ-ǌǸǹᴺṄ-ṋⁿℕ№⒩Ⓝⓝ㎁㎋㎚㎱㎵㎻㏌㏑Ｎｎ]",O:"[OoºÒ-Öò-öŌ-őƠơǑǒǪǫȌ-ȏȮȯᴼᵒỌ-ỏₒ℅№ℴ⒪Ⓞⓞ㍵㏇㏒㏖Ｏｏ]",P:"[PpᴾᵖṔ-ṗℙ⒫Ⓟⓟ㉐㍱㍶㎀㎊㎩-㎬㎰㎴㎺㏋㏗-㏚Ｐｐ]",Q:"[Qqℚ⒬Ⓠⓠ㏃Ｑｑ]",R:"[RrŔ-řȐ-ȓʳᴿᵣṘ-ṛṞṟ₨ℛ-ℝ⒭Ⓡⓡ㋍㍴㎭-㎯㏚㏛Ｒｒ]",S:"[SsŚ-šſȘșˢṠ-ṣ₨℁℠⒮Ⓢⓢ㎧㎨㎮-㎳㏛㏜ﬆＳｓ]",T:"[TtŢ-ťȚțᵀᵗṪ-ṱẗ℡™⒯Ⓣⓣ㉐㋏㎔㏏ﬅﬆＴｔ]",U:"[UuÙ-Üù-üŨ-ųƯưǓǔȔ-ȗᵁᵘᵤṲ-ṷỤ-ủ℆⒰Ⓤⓤ㍳㍺Ｕｕ]",V:"[VvᵛᵥṼ-ṿⅣ-Ⅷⅳ-ⅷ⒱Ⓥⓥⱽ㋎㍵㎴-㎹㏜㏞Ｖｖ]",W:"[WwŴŵʷᵂẀ-ẉẘ⒲Ⓦⓦ㎺-㎿㏝Ｗｗ]",X:"[XxˣẊ-ẍₓ℻Ⅸ-Ⅻⅸ-ⅻ⒳Ⓧⓧ㏓Ｘｘ]",Y:"[YyÝýÿŶ-ŸȲȳʸẎẏẙỲ-ỹ⒴Ⓨⓨ㏉Ｙｙ]",Z:"[ZzŹ-žǱ-ǳᶻẐ-ẕℤℨ⒵Ⓩⓩ㎐-㎔Ｚｚ]"};return function(c){function f(b){var d,e,f;return(d=h.exec(b.data))&&(f=a.createElement(c.tagName),c.className&&(f.className=c.className),e=b.splitText(d.index),e.splitText(d[0].length),f.appendChild(e.cloneNode(!0)),b.parentNode.replaceChild(f,e)),!!d}function g(a,b){for(var c,d=3,e=0;e<a.childNodes.length;e++)c=a.childNodes[e],c.nodeType===d?e+=b(c)?1:0:g(c,b)}var h;c=b.mixin({},e,c),c.node&&c.pattern&&(c.pattern=b.isArray(c.pattern)?c.pattern:[c.pattern],h=d(c.pattern,c.caseSensitive,c.wordsOnly,c.diacriticInsensitive),g(c.node,f))}}(window.document),g=function(){"use strict";function c(c,e){c=c||{},c.input||a.error("input is missing"),e.mixin(this),this.$hint=a(c.hint),this.$input=a(c.input),this.$input.attr({"aria-activedescendant":"","aria-owns":this.$input.attr("id")+"_listbox",role:"combobox","aria-readonly":"true","aria-autocomplete":"list"}),a(e.menu).attr("id",this.$input.attr("id")+"_listbox"),this.query=this.$input.val(),this.queryWhenFocused=this.hasFocus()?this.query:null,this.$overflowHelper=d(this.$input),this._checkLanguageDirection(),0===this.$hint.length&&(this.setHint=this.getHint=this.clearHint=this.clearHintIfInvalid=b.noop),this.onSync("cursorchange",this._updateDescendent)}function d(b){return a('<pre aria-hidden="true"></pre>').css({position:"absolute",visibility:"hidden",whiteSpace:"pre",fontFamily:b.css("font-family"),fontSize:b.css("font-size"),fontStyle:b.css("font-style"),fontVariant:b.css("font-variant"),fontWeight:b.css("font-weight"),wordSpacing:b.css("word-spacing"),letterSpacing:b.css("letter-spacing"),textIndent:b.css("text-indent"),textRendering:b.css("text-rendering"),textTransform:b.css("text-transform")}).insertAfter(b)}function f(a,b){return c.normalizeQuery(a)===c.normalizeQuery(b)}function g(a){return a.altKey||a.ctrlKey||a.metaKey||a.shiftKey}var h;return h={9:"tab",27:"esc",37:"left",39:"right",13:"enter",38:"up",40:"down"},c.normalizeQuery=function(a){return b.toStr(a).replace(/^\s*/g,"").replace(/\s{2,}/g," ")},b.mixin(c.prototype,e,{_onBlur:function(){this.resetInputValue(),this.trigger("blurred")},_onFocus:function(){this.queryWhenFocused=this.query,this.trigger("focused")},_onKeydown:function(a){var b=h[a.which||a.keyCode];this._managePreventDefault(b,a),b&&this._shouldTrigger(b,a)&&this.trigger(b+"Keyed",a)},_onInput:function(){this._setQuery(this.getInputValue()),this.clearHintIfInvalid(),this._checkLanguageDirection()},_managePreventDefault:function(a,b){var c;switch(a){case"up":case"down":c=!g(b);break;default:c=!1}c&&b.preventDefault()},_shouldTrigger:function(a,b){var c;switch(a){case"tab":c=!g(b);break;default:c=!0}return c},_checkLanguageDirection:function(){var a=(this.$input.css("direction")||"ltr").toLowerCase();this.dir!==a&&(this.dir=a,this.$hint.attr("dir",a),this.trigger("langDirChanged",a))},_setQuery:function(a,b){var c,d;c=f(a,this.query),d=!!c&&this.query.length!==a.length,this.query=a,b||c?!b&&d&&this.trigger("whitespaceChanged",this.query):this.trigger("queryChanged",this.query)},_updateDescendent:function(a,b){this.$input.attr("aria-activedescendant",b)},bind:function(){var a,c,d,e,f=this;return a=b.bind(this._onBlur,this),c=b.bind(this._onFocus,this),d=b.bind(this._onKeydown,this),e=b.bind(this._onInput,this),this.$input.on("blur.tt",a).on("focus.tt",c).on("keydown.tt",d),!b.isMsie()||b.isMsie()>9?this.$input.on("input.tt",e):this.$input.on("keydown.tt keypress.tt cut.tt paste.tt",function(a){h[a.which||a.keyCode]||b.defer(b.bind(f._onInput,f,a))}),this},focus:function(){this.$input.focus()},blur:function(){this.$input.blur()},getLangDir:function(){return this.dir},getQuery:function(){return this.query||""},setQuery:function(a,b){this.setInputValue(a),this._setQuery(a,b)},hasQueryChangedSinceLastFocus:function(){return this.query!==this.queryWhenFocused},getInputValue:function(){return this.$input.val()},setInputValue:function(a){this.$input.val(a),this.clearHintIfInvalid(),this._checkLanguageDirection()},resetInputValue:function(){this.setInputValue(this.query)},getHint:function(){return this.$hint.val()},setHint:function(a){this.$hint.val(a)},clearHint:function(){this.setHint("")},clearHintIfInvalid:function(){var a,b,c,d;a=this.getInputValue(),b=this.getHint(),c=a!==b&&0===b.indexOf(a),d=""!==a&&c&&!this.hasOverflow(),!d&&this.clearHint()},hasFocus:function(){return this.$input.is(":focus")},hasOverflow:function(){var a=this.$input.width()-2;return this.$overflowHelper.text(this.getInputValue()),this.$overflowHelper.width()>=a},isCursorAtEnd:function(){var a,c,d;return a=this.$input.val().length,c=this.$input[0].selectionStart,b.isNumber(c)?c===a:!document.selection||(d=document.selection.createRange(),d.moveStart("character",-a),a===d.text.length)},destroy:function(){this.$hint.off(".tt"),this.$input.off(".tt"),this.$overflowHelper.remove(),this.$hint=this.$input=this.$overflowHelper=a("<div>")}}),c}(),h=function(){"use strict";function c(c,e){c=c||{},c.templates=c.templates||{},c.templates.notFound=c.templates.notFound||c.templates.empty,c.source||a.error("missing source"),c.node||a.error("missing node"),c.name&&!h(c.name)&&a.error("invalid dataset name: "+c.name),e.mixin(this),this.highlight=!!c.highlight,this.name=b.toStr(c.name||j()),this.limit=c.limit||5,this.displayFn=d(c.display||c.displayKey),this.templates=g(c.templates,this.displayFn),this.source=c.source.__ttAdapter?c.source.__ttAdapter():c.source,this.async=b.isUndefined(c.async)?this.source.length>2:!!c.async,this._resetLastSuggestion(),this.$el=a(c.node).attr("role","presentation").addClass(this.classes.dataset).addClass(this.classes.dataset+"-"+this.name)}function d(a){function c(b){return b[a]}return a=a||b.stringify,b.isFunction(a)?a:c}function g(c,d){function e(c){return a('<div role="option">').attr("id",b.guid()).text(d(c))}return{notFound:c.notFound&&b.templatify(c.notFound),pending:c.pending&&b.templatify(c.pending),header:c.header&&b.templatify(c.header),footer:c.footer&&b.templatify(c.footer),suggestion:c.suggestion||e}}function h(a){return/^[_a-zA-Z0-9-]+$/.test(a)}var i,j;return i={dataset:"tt-selectable-dataset",val:"tt-selectable-display",obj:"tt-selectable-object"},j=b.getIdGenerator(),c.extractData=function(b){var c=a(b);return c.data(i.obj)?{dataset:c.data(i.dataset)||"",val:c.data(i.val)||"",obj:c.data(i.obj)||null}:null},b.mixin(c.prototype,e,{_overwrite:function(a,b){b=b||[],b.length?this._renderSuggestions(a,b):this.async&&this.templates.pending?this._renderPending(a):!this.async&&this.templates.notFound?this._renderNotFound(a):this._empty(),this.trigger("rendered",b,!1,this.name)},_append:function(a,b){b=b||[],b.length&&this.$lastSuggestion.length?this._appendSuggestions(a,b):b.length?this._renderSuggestions(a,b):!this.$lastSuggestion.length&&this.templates.notFound&&this._renderNotFound(a),this.trigger("rendered",b,!0,this.name)},_renderSuggestions:function(a,b){var c;c=this._getSuggestionsFragment(a,b),this.$lastSuggestion=c.children().last(),this.$el.html(c).prepend(this._getHeader(a,b)).append(this._getFooter(a,b))},_appendSuggestions:function(a,b){var c,d;c=this._getSuggestionsFragment(a,b),d=c.children().last(),this.$lastSuggestion.after(c),this.$lastSuggestion=d},_renderPending:function(a){var b=this.templates.pending;this._resetLastSuggestion(),b&&this.$el.html(b({query:a,dataset:this.name}))},_renderNotFound:function(a){var b=this.templates.notFound;this._resetLastSuggestion(),b&&this.$el.html(b({query:a,dataset:this.name}))},_empty:function(){this.$el.empty(),this._resetLastSuggestion()},_getSuggestionsFragment:function(c,d){var e,g=this;return e=document.createDocumentFragment(),b.each(d,function(b){var d,f;f=g._injectQuery(c,b),d=a(g.templates.suggestion(f)).data(i.dataset,g.name).data(i.obj,b).data(i.val,g.displayFn(b)).addClass(g.classes.suggestion+" "+g.classes.selectable),e.appendChild(d[0])}),this.highlight&&f({className:this.classes.highlight,node:e,pattern:c}),a(e)},_getFooter:function(a,b){return this.templates.footer?this.templates.footer({query:a,suggestions:b,dataset:this.name}):null},_getHeader:function(a,b){return this.templates.header?this.templates.header({query:a,suggestions:b,dataset:this.name}):null},_resetLastSuggestion:function(){this.$lastSuggestion=a()},_injectQuery:function(a,c){return b.isObject(c)?b.mixin({_query:a},c):c},update:function(b){function c(a){g||(g=!0,a=(a||[]).slice(0,e.limit),h=a.length,e._overwrite(b,a),h<e.limit&&e.async&&e.trigger("asyncRequested",b,e.name))}function d(c){if(c=c||[],!f&&h<e.limit){e.cancel=a.noop;var d=Math.abs(h-e.limit);h+=d,e._append(b,c.slice(0,d)),e.async&&e.trigger("asyncReceived",b,e.name)}}var e=this,f=!1,g=!1,h=0;this.cancel(),this.cancel=function(){f=!0,e.cancel=a.noop,e.async&&e.trigger("asyncCanceled",b,e.name)},this.source(b,c,d),!g&&c([])},cancel:a.noop,clear:function(){this._empty(),this.cancel(),this.trigger("cleared")},isEmpty:function(){return this.$el.is(":empty")},destroy:function(){this.$el=a("<div>")}}),c}(),i=function(){"use strict";function c(c,d){function e(b){var c=f.$node.find(b.node).first();return b.node=c.length?c:a("<div>").appendTo(f.$node),new h(b,d)}var f=this;c=c||{},c.node||a.error("node is required"),d.mixin(this),this.$node=a(c.node),this.query=null,this.datasets=b.map(c.datasets,e)}return b.mixin(c.prototype,e,{_onSelectableClick:function(b){this.trigger("selectableClicked",a(b.currentTarget))},_onRendered:function(a,b,c,d){this.$node.toggleClass(this.classes.empty,this._allDatasetsEmpty()),this.trigger("datasetRendered",b,c,d)},_onCleared:function(){this.$node.toggleClass(this.classes.empty,this._allDatasetsEmpty()),this.trigger("datasetCleared")},_propagate:function(){this.trigger.apply(this,arguments)},_allDatasetsEmpty:function(){return b.every(this.datasets,b.bind(function(a){var b=a.isEmpty();return this.$node.attr("aria-expanded",!b),b},this))},_getSelectables:function(){return this.$node.find(this.selectors.selectable)},_removeCursor:function(){var a=this.getActiveSelectable();a&&a.removeClass(this.classes.cursor)},_ensureVisible:function(a){var b,c,d,e;b=a.position().top,c=b+a.outerHeight(!0),d=this.$node.scrollTop(),e=this.$node.height()+parseInt(this.$node.css("paddingTop"),10)+parseInt(this.$node.css("paddingBottom"),10),b<0?this.$node.scrollTop(d+b):e<c&&this.$node.scrollTop(d+(c-e))},bind:function(){var c,d=this;return c=b.bind(this._onSelectableClick,this),this.$node.on("click.tt",this.selectors.selectable,c),this.$node.on("mouseover",this.selectors.selectable,function(){d.setCursor(a(this))}),this.$node.on("mouseleave",function(){d._removeCursor()}),b.each(this.datasets,function(a){a.onSync("asyncRequested",d._propagate,d).onSync("asyncCanceled",d._propagate,d).onSync("asyncReceived",d._propagate,d).onSync("rendered",d._onRendered,d).onSync("cleared",d._onCleared,d)}),this},isOpen:function(){return this.$node.hasClass(this.classes.open)},open:function(){this.$node.scrollTop(0),this.$node.addClass(this.classes.open)},close:function(){this.$node.attr("aria-expanded",!1),this.$node.removeClass(this.classes.open),this._removeCursor()},setLanguageDirection:function(a){this.$node.attr("dir",a)},selectableRelativeToCursor:function(a){var b,c,d,e;return c=this.getActiveSelectable(),b=this._getSelectables(),d=c?b.index(c):-1,e=d+a,e=(e+1)%(b.length+1)-1,e=e<-1?b.length-1:e,e===-1?null:b.eq(e)},setCursor:function(a){this._removeCursor(),(a=a&&a.first())&&(a.addClass(this.classes.cursor),this._ensureVisible(a))},getSelectableData:function(a){return a&&a.length?h.extractData(a):null},getActiveSelectable:function(){var a=this._getSelectables().filter(this.selectors.cursor).first();return a.length?a:null},getTopSelectable:function(){var a=this._getSelectables().first();return a.length?a:null},update:function(a){function c(b){b.update(a)}var d=a!==this.query;return d&&(this.query=a,b.each(this.datasets,c)),d},empty:function(){function a(a){a.clear()}b.each(this.datasets,a),this.query=null,this.$node.addClass(this.classes.empty)},destroy:function(){function c(a){a.destroy()}this.$node.off(".tt"),this.$node=a("<div>"),b.each(this.datasets,c)}}),c}(),j=function(){
"use strict";function c(c){this.$el=a("<span></span>",{role:"status","aria-live":"polite"}).css({position:"absolute",padding:"0",border:"0",height:"1px",width:"1px","margin-bottom":"-1px","margin-right":"-1px",overflow:"hidden",clip:"rect(0 0 0 0)","white-space":"nowrap"}),c.$input.after(this.$el),b.each(c.menu.datasets,b.bind(function(a){a.onSync&&(a.onSync("rendered",b.bind(this.update,this)),a.onSync("cleared",b.bind(this.cleared,this)))},this))}return b.mixin(c.prototype,{update:function(a,b){var c,d=b.length;c=1===d?{result:"result",is:"is"}:{result:"results",is:"are"},this.$el.text(d+" "+c.result+" "+c.is+" available, use up and down arrow keys to navigate.")},cleared:function(){this.$el.text("")}}),c}(),k=function(){"use strict";function a(){i.apply(this,[].slice.call(arguments,0))}var c=i.prototype;return b.mixin(a.prototype,i.prototype,{open:function(){return!this._allDatasetsEmpty()&&this._show(),c.open.apply(this,[].slice.call(arguments,0))},close:function(){return this._hide(),c.close.apply(this,[].slice.call(arguments,0))},_onRendered:function(){return this._allDatasetsEmpty()?this._hide():this.isOpen()&&this._show(),c._onRendered.apply(this,[].slice.call(arguments,0))},_onCleared:function(){return this._allDatasetsEmpty()?this._hide():this.isOpen()&&this._show(),c._onCleared.apply(this,[].slice.call(arguments,0))},setLanguageDirection:function(a){return this.$node.css("ltr"===a?this.css.ltr:this.css.rtl),c.setLanguageDirection.apply(this,[].slice.call(arguments,0))},_hide:function(){this.$node.hide()},_show:function(){this.$node.css("display","block")}}),a}(),l=function(){"use strict";function c(c,e){var f,g,h,i,j,k,l,m,n,o,p;c=c||{},c.input||a.error("missing input"),c.menu||a.error("missing menu"),c.eventBus||a.error("missing event bus"),e.mixin(this),this.eventBus=c.eventBus,this.minLength=b.isNumber(c.minLength)?c.minLength:1,this.input=c.input,this.menu=c.menu,this.enabled=!0,this.autoselect=!!c.autoselect,this.active=!1,this.input.hasFocus()&&this.activate(),this.dir=this.input.getLangDir(),this._hacks(),this.menu.bind().onSync("selectableClicked",this._onSelectableClicked,this).onSync("asyncRequested",this._onAsyncRequested,this).onSync("asyncCanceled",this._onAsyncCanceled,this).onSync("asyncReceived",this._onAsyncReceived,this).onSync("datasetRendered",this._onDatasetRendered,this).onSync("datasetCleared",this._onDatasetCleared,this),f=d(this,"activate","open","_onFocused"),g=d(this,"deactivate","_onBlurred"),h=d(this,"isActive","isOpen","_onEnterKeyed"),i=d(this,"isActive","isOpen","_onTabKeyed"),j=d(this,"isActive","_onEscKeyed"),k=d(this,"isActive","open","_onUpKeyed"),l=d(this,"isActive","open","_onDownKeyed"),m=d(this,"isActive","isOpen","_onLeftKeyed"),n=d(this,"isActive","isOpen","_onRightKeyed"),o=d(this,"_openIfActive","_onQueryChanged"),p=d(this,"_openIfActive","_onWhitespaceChanged"),this.input.bind().onSync("focused",f,this).onSync("blurred",g,this).onSync("enterKeyed",h,this).onSync("tabKeyed",i,this).onSync("escKeyed",j,this).onSync("upKeyed",k,this).onSync("downKeyed",l,this).onSync("leftKeyed",m,this).onSync("rightKeyed",n,this).onSync("queryChanged",o,this).onSync("whitespaceChanged",p,this).onSync("langDirChanged",this._onLangDirChanged,this)}function d(a){var c=[].slice.call(arguments,1);return function(){var d=[].slice.call(arguments);b.each(c,function(b){return a[b].apply(a,d)})}}return b.mixin(c.prototype,{_hacks:function(){var c,d;c=this.input.$input||a("<div>"),d=this.menu.$node||a("<div>"),c.on("blur.tt",function(a){var e,f,g;e=document.activeElement,f=d.is(e),g=d.has(e).length>0,b.isMsie()&&(f||g)&&(a.preventDefault(),a.stopImmediatePropagation(),b.defer(function(){c.focus()}))}),d.on("mousedown.tt",function(a){a.preventDefault()})},_onSelectableClicked:function(a,b){this.select(b)},_onDatasetCleared:function(){this._updateHint()},_onDatasetRendered:function(a,b,c,d){if(this._updateHint(),this.autoselect){var e=this.selectors.cursor.substr(1);this.menu.$node.find(this.selectors.suggestion).first().addClass(e)}this.eventBus.trigger("render",b,c,d)},_onAsyncRequested:function(a,b,c){this.eventBus.trigger("asyncrequest",c,b)},_onAsyncCanceled:function(a,b,c){this.eventBus.trigger("asynccancel",c,b)},_onAsyncReceived:function(a,b,c){this.eventBus.trigger("asyncreceive",c,b)},_onFocused:function(){this._minLengthMet()&&this.menu.update(this.input.getQuery())},_onBlurred:function(){this.input.hasQueryChangedSinceLastFocus()&&this.eventBus.trigger("change",this.input.getQuery())},_onEnterKeyed:function(a,b){var c;(c=this.menu.getActiveSelectable())?this.select(c)&&(b.preventDefault(),b.stopPropagation()):this.autoselect&&this.select(this.menu.getTopSelectable())&&(b.preventDefault(),b.stopPropagation())},_onTabKeyed:function(a,b){var c;(c=this.menu.getActiveSelectable())?this.select(c)&&b.preventDefault():(c=this.menu.getTopSelectable())&&this.autocomplete(c)&&b.preventDefault()},_onEscKeyed:function(){this.close()},_onUpKeyed:function(){this.moveCursor(-1)},_onDownKeyed:function(){this.moveCursor(1)},_onLeftKeyed:function(){"rtl"===this.dir&&this.input.isCursorAtEnd()&&this.autocomplete(this.menu.getActiveSelectable()||this.menu.getTopSelectable())},_onRightKeyed:function(){"ltr"===this.dir&&this.input.isCursorAtEnd()&&this.autocomplete(this.menu.getActiveSelectable()||this.menu.getTopSelectable())},_onQueryChanged:function(a,b){this._minLengthMet(b)?this.menu.update(b):this.menu.empty()},_onWhitespaceChanged:function(){this._updateHint()},_onLangDirChanged:function(a,b){this.dir!==b&&(this.dir=b,this.menu.setLanguageDirection(b))},_openIfActive:function(){this.isActive()&&this.open()},_minLengthMet:function(a){return a=b.isString(a)?a:this.input.getQuery()||"",a.length>=this.minLength},_updateHint:function(){var a,c,d,e,f,h,i;a=this.menu.getTopSelectable(),c=this.menu.getSelectableData(a),d=this.input.getInputValue(),!c||b.isBlankString(d)||this.input.hasOverflow()?this.input.clearHint():(e=g.normalizeQuery(d),f=b.escapeRegExChars(e),h=new RegExp("^(?:"+f+")(.+$)","i"),i=h.exec(c.val),i&&this.input.setHint(d+i[1]))},isEnabled:function(){return this.enabled},enable:function(){this.enabled=!0},disable:function(){this.enabled=!1},isActive:function(){return this.active},activate:function(){return!!this.isActive()||!(!this.isEnabled()||this.eventBus.before("active"))&&(this.active=!0,this.eventBus.trigger("active"),!0)},deactivate:function(){return!this.isActive()||!this.eventBus.before("idle")&&(this.active=!1,this.close(),this.eventBus.trigger("idle"),!0)},isOpen:function(){return this.menu.isOpen()},open:function(){return this.isOpen()||this.eventBus.before("open")||(this.menu.open(),this._updateHint(),this.eventBus.trigger("open")),this.isOpen()},close:function(){return this.isOpen()&&!this.eventBus.before("close")&&(this.menu.close(),this.input.clearHint(),this.input.resetInputValue(),this.eventBus.trigger("close")),!this.isOpen()},setVal:function(a){this.input.setQuery(b.toStr(a))},getVal:function(){return this.input.getQuery()},select:function(a){var b=this.menu.getSelectableData(a);return!(!b||this.eventBus.before("select",b.obj,b.dataset))&&(this.input.setQuery(b.val,!0),this.eventBus.trigger("select",b.obj,b.dataset),this.close(),!0)},autocomplete:function(a){var b,c,d;return b=this.input.getQuery(),c=this.menu.getSelectableData(a),d=c&&b!==c.val,!(!d||this.eventBus.before("autocomplete",c.obj,c.dataset))&&(this.input.setQuery(c.val),this.eventBus.trigger("autocomplete",c.obj,c.dataset),!0)},moveCursor:function(a){var b,c,d,e,f,g,h;return b=this.input.getQuery(),c=this.menu.selectableRelativeToCursor(a),d=this.menu.getSelectableData(c),e=d?d.obj:null,f=d?d.dataset:null,h=c?c.attr("id"):null,this.input.trigger("cursorchange",h),g=this._minLengthMet()&&this.menu.update(b),!g&&!this.eventBus.before("cursorchange",e,f)&&(this.menu.setCursor(c),d?this.input.setInputValue(d.val):(this.input.resetInputValue(),this._updateHint()),this.eventBus.trigger("cursorchange",e,f),!0)},destroy:function(){this.input.destroy(),this.menu.destroy()}}),c}();!function(){"use strict";function e(b,c){b.each(function(){var b,d=a(this);(b=d.data(q.typeahead))&&c(b,d)})}function f(a,b){return a.clone().addClass(b.classes.hint).removeData().css(b.css.hint).css(m(a)).prop({readonly:!0,required:!1}).removeAttr("id name placeholder").removeClass("required").attr({spellcheck:"false",tabindex:-1})}function h(a,b){a.data(q.attrs,{dir:a.attr("dir"),autocomplete:a.attr("autocomplete"),spellcheck:a.attr("spellcheck"),style:a.attr("style")}),a.addClass(b.classes.input).attr({spellcheck:!1});try{!a.attr("dir")&&a.attr("dir","auto")}catch(a){}return a}function m(a){return{backgroundAttachment:a.css("background-attachment"),backgroundClip:a.css("background-clip"),backgroundColor:a.css("background-color"),backgroundImage:a.css("background-image"),backgroundOrigin:a.css("background-origin"),backgroundPosition:a.css("background-position"),backgroundRepeat:a.css("background-repeat"),backgroundSize:a.css("background-size")}}function n(a){var c,d;c=a.data(q.www),d=a.parent().filter(c.selectors.wrapper),b.each(a.data(q.attrs),function(c,d){b.isUndefined(c)?a.removeAttr(d):a.attr(d,c)}),a.removeData(q.typeahead).removeData(q.www).removeData(q.attr).removeClass(c.classes.input),d.length&&(a.detach().insertAfter(d),d.remove())}function o(c){var d,e;return d=b.isJQuery(c)||b.isElement(c),e=d?a(c).first():[],e.length?e:null}var p,q,r;p=a.fn.typeahead,q={www:"tt-www",attrs:"tt-attrs",typeahead:"tt-typeahead"},r={initialize:function(e,m){function n(){var c,n,r,s,t,u,v,w,x,y,z,A;b.each(m,function(a){a.highlight=!!e.highlight}),c=a(this),n=a(p.html.wrapper),r=o(e.hint),s=o(e.menu),t=e.hint!==!1&&!r,u=e.menu!==!1&&!s,t&&(r=f(c,p)),u&&(s=a(p.html.menu).css(p.css.menu)),r&&r.val(""),c=h(c,p),(t||u)&&(n.css(p.css.wrapper),c.css(t?p.css.input:p.css.inputWithNoHint),c.wrap(n).parent().prepend(t?r:null).append(u?s:null)),A=u?k:i,v=new d({el:c}),w=new g({hint:r,input:c},p),x=new A({node:s,datasets:m},p),y=new j({$input:c,menu:x}),z=new l({input:w,menu:x,eventBus:v,minLength:e.minLength,autoselect:e.autoselect},p),c.data(q.www,p),c.data(q.typeahead,z)}var p;return m=b.isArray(m)?m:[].slice.call(arguments,1),e=e||{},p=c(e.classNames),this.each(n)},isEnabled:function(){var a;return e(this.first(),function(b){a=b.isEnabled()}),a},enable:function(){return e(this,function(a){a.enable()}),this},disable:function(){return e(this,function(a){a.disable()}),this},isActive:function(){var a;return e(this.first(),function(b){a=b.isActive()}),a},activate:function(){return e(this,function(a){a.activate()}),this},deactivate:function(){return e(this,function(a){a.deactivate()}),this},isOpen:function(){var a;return e(this.first(),function(b){a=b.isOpen()}),a},open:function(){return e(this,function(a){a.open()}),this},close:function(){return e(this,function(a){a.close()}),this},select:function(b){var c=!1,d=a(b);return e(this.first(),function(a){c=a.select(d)}),c},autocomplete:function(b){var c=!1,d=a(b);return e(this.first(),function(a){c=a.autocomplete(d)}),c},moveCursor:function(a){var b=!1;return e(this.first(),function(c){b=c.moveCursor(a)}),b},val:function(a){var c;return arguments.length?(e(this,function(c){c.setVal(b.toStr(a))}),this):(e(this.first(),function(a){c=a.getVal()}),c)},destroy:function(){return e(this,function(a,b){n(b),a.destroy()}),this}},a.fn.typeahead=function(a){return r[a]?r[a].apply(this,[].slice.call(arguments,1)):r.initialize.apply(this,arguments)},a.fn.typeahead.noConflict=function(){return a.fn.typeahead=p,this}}()});
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).DOMPurify=t()}(this,(function(){"use strict";const{entries:e,setPrototypeOf:t,isFrozen:n,getPrototypeOf:o,getOwnPropertyDescriptor:r}=Object;let{freeze:i,seal:a,create:l}=Object,{apply:c,construct:s}="undefined"!=typeof Reflect&&Reflect;i||(i=function(e){return e}),a||(a=function(e){return e}),c||(c=function(e,t,n){return e.apply(t,n)}),s||(s=function(e,t){return new e(...t)});const u=R(Array.prototype.forEach),m=R(Array.prototype.lastIndexOf),p=R(Array.prototype.pop),f=R(Array.prototype.push),d=R(Array.prototype.splice),h=R(String.prototype.toLowerCase),g=R(String.prototype.toString),T=R(String.prototype.match),y=R(String.prototype.replace),E=R(String.prototype.indexOf),A=R(String.prototype.trim),_=R(Object.prototype.hasOwnProperty),S=R(RegExp.prototype.test),b=(N=TypeError,function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return s(N,t)});var N;function R(e){return function(t){t instanceof RegExp&&(t.lastIndex=0);for(var n=arguments.length,o=new Array(n>1?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];return c(e,t,o)}}function w(e,o){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:h;t&&t(e,null);let i=o.length;for(;i--;){let t=o[i];if("string"==typeof t){const e=r(t);e!==t&&(n(o)||(o[i]=e),t=e)}e[t]=!0}return e}function O(e){for(let t=0;t<e.length;t++){_(e,t)||(e[t]=null)}return e}function D(t){const n=l(null);for(const[o,r]of e(t)){_(t,o)&&(Array.isArray(r)?n[o]=O(r):r&&"object"==typeof r&&r.constructor===Object?n[o]=D(r):n[o]=r)}return n}function v(e,t){for(;null!==e;){const n=r(e,t);if(n){if(n.get)return R(n.get);if("function"==typeof n.value)return R(n.value)}e=o(e)}return function(){return null}}const L=i(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dialog","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","search","section","select","shadow","slot","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),x=i(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","circle","clippath","defs","desc","ellipse","enterkeyhint","exportparts","filter","font","g","glyph","glyphref","hkern","image","inputmode","line","lineargradient","marker","mask","metadata","mpath","part","path","pattern","polygon","polyline","radialgradient","rect","slot","stop","style","switch","symbol","text","textpath","title","tref","tspan","view","vkern"]),C=i(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),k=i(["animate","color-profile","cursor","discard","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignobject","hatch","hatchpath","mesh","meshgradient","meshpatch","meshrow","missing-glyph","script","set","solidcolor","unknown","use"]),I=i(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover","mprescripts"]),M=i(["maction","maligngroup","malignmark","mlongdiv","mscarries","mscarry","msgroup","mstack","msline","msrow","semantics","annotation","annotation-xml","mprescripts","none"]),U=i(["#text"]),z=i(["accept","action","align","alt","autocapitalize","autocomplete","autopictureinpicture","autoplay","background","bgcolor","border","capture","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","controls","controlslist","coords","crossorigin","datetime","decoding","default","dir","disabled","disablepictureinpicture","disableremoteplayback","download","draggable","enctype","enterkeyhint","exportparts","face","for","headers","height","hidden","high","href","hreflang","id","inert","inputmode","integrity","ismap","kind","label","lang","list","loading","loop","low","max","maxlength","media","method","min","minlength","multiple","muted","name","nonce","noshade","novalidate","nowrap","open","optimum","part","pattern","placeholder","playsinline","popover","popovertarget","popovertargetaction","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","slot","span","srclang","start","src","srcset","step","style","summary","tabindex","title","translate","type","usemap","valign","value","width","wrap","xmlns","slot"]),P=i(["accent-height","accumulate","additive","alignment-baseline","amplitude","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clippathunits","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dur","edgemode","elevation","end","exponent","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","intercept","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","slope","specularconstant","specularexponent","spreadmethod","startoffset","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","systemlanguage","tabindex","tablevalues","targetx","targety","transform","transform-origin","text-anchor","text-decoration","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),H=i(["accent","accentunder","align","bevelled","close","columnsalign","columnlines","columnspan","denomalign","depth","dir","display","displaystyle","encoding","fence","frame","height","href","id","largeop","length","linethickness","lspace","lquote","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),F=i(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),B=a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),W=a(/<%[\w\W]*|[\w\W]*%>/gm),G=a(/\$\{[\w\W]*/gm),Y=a(/^data-[\-\w.\u00B7-\uFFFF]+$/),j=a(/^aria-[\-\w]+$/),X=a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),q=a(/^(?:\w+script|data):/i),$=a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),K=a(/^html$/i),V=a(/^[a-z][.\w]*(-[.\w]+)+$/i);var Z=Object.freeze({__proto__:null,ARIA_ATTR:j,ATTR_WHITESPACE:$,CUSTOM_ELEMENT:V,DATA_ATTR:Y,DOCTYPE_NAME:K,ERB_EXPR:W,IS_ALLOWED_URI:X,IS_SCRIPT_OR_DATA:q,MUSTACHE_EXPR:B,TMPLIT_EXPR:G});const J=1,Q=3,ee=7,te=8,ne=9,oe=function(){return"undefined"==typeof window?null:window};var re=function t(){let n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:oe();const o=e=>t(e);if(o.version="3.2.6",o.removed=[],!n||!n.document||n.document.nodeType!==ne||!n.Element)return o.isSupported=!1,o;let{document:r}=n;const a=r,c=a.currentScript,{DocumentFragment:s,HTMLTemplateElement:N,Node:R,Element:O,NodeFilter:B,NamedNodeMap:W=n.NamedNodeMap||n.MozNamedAttrMap,HTMLFormElement:G,DOMParser:Y,trustedTypes:j}=n,q=O.prototype,$=v(q,"cloneNode"),V=v(q,"remove"),re=v(q,"nextSibling"),ie=v(q,"childNodes"),ae=v(q,"parentNode");if("function"==typeof N){const e=r.createElement("template");e.content&&e.content.ownerDocument&&(r=e.content.ownerDocument)}let le,ce="";const{implementation:se,createNodeIterator:ue,createDocumentFragment:me,getElementsByTagName:pe}=r,{importNode:fe}=a;let de={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]};o.isSupported="function"==typeof e&&"function"==typeof ae&&se&&void 0!==se.createHTMLDocument;const{MUSTACHE_EXPR:he,ERB_EXPR:ge,TMPLIT_EXPR:Te,DATA_ATTR:ye,ARIA_ATTR:Ee,IS_SCRIPT_OR_DATA:Ae,ATTR_WHITESPACE:_e,CUSTOM_ELEMENT:Se}=Z;let{IS_ALLOWED_URI:be}=Z,Ne=null;const Re=w({},[...L,...x,...C,...I,...U]);let we=null;const Oe=w({},[...z,...P,...H,...F]);let De=Object.seal(l(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),ve=null,Le=null,xe=!0,Ce=!0,ke=!1,Ie=!0,Me=!1,Ue=!0,ze=!1,Pe=!1,He=!1,Fe=!1,Be=!1,We=!1,Ge=!0,Ye=!1,je=!0,Xe=!1,qe={},$e=null;const Ke=w({},["annotation-xml","audio","colgroup","desc","foreignobject","head","iframe","math","mi","mn","mo","ms","mtext","noembed","noframes","noscript","plaintext","script","style","svg","template","thead","title","video","xmp"]);let Ve=null;const Ze=w({},["audio","video","img","source","image","track"]);let Je=null;const Qe=w({},["alt","class","for","id","label","name","pattern","placeholder","role","summary","title","value","style","xmlns"]),et="http://www.w3.org/1998/Math/MathML",tt="http://www.w3.org/2000/svg",nt="http://www.w3.org/1999/xhtml";let ot=nt,rt=!1,it=null;const at=w({},[et,tt,nt],g);let lt=w({},["mi","mo","mn","ms","mtext"]),ct=w({},["annotation-xml"]);const st=w({},["title","style","font","a","script"]);let ut=null;const mt=["application/xhtml+xml","text/html"];let pt=null,ft=null;const dt=r.createElement("form"),ht=function(e){return e instanceof RegExp||e instanceof Function},gt=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(!ft||ft!==e){if(e&&"object"==typeof e||(e={}),e=D(e),ut=-1===mt.indexOf(e.PARSER_MEDIA_TYPE)?"text/html":e.PARSER_MEDIA_TYPE,pt="application/xhtml+xml"===ut?g:h,Ne=_(e,"ALLOWED_TAGS")?w({},e.ALLOWED_TAGS,pt):Re,we=_(e,"ALLOWED_ATTR")?w({},e.ALLOWED_ATTR,pt):Oe,it=_(e,"ALLOWED_NAMESPACES")?w({},e.ALLOWED_NAMESPACES,g):at,Je=_(e,"ADD_URI_SAFE_ATTR")?w(D(Qe),e.ADD_URI_SAFE_ATTR,pt):Qe,Ve=_(e,"ADD_DATA_URI_TAGS")?w(D(Ze),e.ADD_DATA_URI_TAGS,pt):Ze,$e=_(e,"FORBID_CONTENTS")?w({},e.FORBID_CONTENTS,pt):Ke,ve=_(e,"FORBID_TAGS")?w({},e.FORBID_TAGS,pt):D({}),Le=_(e,"FORBID_ATTR")?w({},e.FORBID_ATTR,pt):D({}),qe=!!_(e,"USE_PROFILES")&&e.USE_PROFILES,xe=!1!==e.ALLOW_ARIA_ATTR,Ce=!1!==e.ALLOW_DATA_ATTR,ke=e.ALLOW_UNKNOWN_PROTOCOLS||!1,Ie=!1!==e.ALLOW_SELF_CLOSE_IN_ATTR,Me=e.SAFE_FOR_TEMPLATES||!1,Ue=!1!==e.SAFE_FOR_XML,ze=e.WHOLE_DOCUMENT||!1,Fe=e.RETURN_DOM||!1,Be=e.RETURN_DOM_FRAGMENT||!1,We=e.RETURN_TRUSTED_TYPE||!1,He=e.FORCE_BODY||!1,Ge=!1!==e.SANITIZE_DOM,Ye=e.SANITIZE_NAMED_PROPS||!1,je=!1!==e.KEEP_CONTENT,Xe=e.IN_PLACE||!1,be=e.ALLOWED_URI_REGEXP||X,ot=e.NAMESPACE||nt,lt=e.MATHML_TEXT_INTEGRATION_POINTS||lt,ct=e.HTML_INTEGRATION_POINTS||ct,De=e.CUSTOM_ELEMENT_HANDLING||{},e.CUSTOM_ELEMENT_HANDLING&&ht(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck)&&(De.tagNameCheck=e.CUSTOM_ELEMENT_HANDLING.tagNameCheck),e.CUSTOM_ELEMENT_HANDLING&&ht(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)&&(De.attributeNameCheck=e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),e.CUSTOM_ELEMENT_HANDLING&&"boolean"==typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements&&(De.allowCustomizedBuiltInElements=e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),Me&&(Ce=!1),Be&&(Fe=!0),qe&&(Ne=w({},U),we=[],!0===qe.html&&(w(Ne,L),w(we,z)),!0===qe.svg&&(w(Ne,x),w(we,P),w(we,F)),!0===qe.svgFilters&&(w(Ne,C),w(we,P),w(we,F)),!0===qe.mathMl&&(w(Ne,I),w(we,H),w(we,F))),e.ADD_TAGS&&(Ne===Re&&(Ne=D(Ne)),w(Ne,e.ADD_TAGS,pt)),e.ADD_ATTR&&(we===Oe&&(we=D(we)),w(we,e.ADD_ATTR,pt)),e.ADD_URI_SAFE_ATTR&&w(Je,e.ADD_URI_SAFE_ATTR,pt),e.FORBID_CONTENTS&&($e===Ke&&($e=D($e)),w($e,e.FORBID_CONTENTS,pt)),je&&(Ne["#text"]=!0),ze&&w(Ne,["html","head","body"]),Ne.table&&(w(Ne,["tbody"]),delete ve.tbody),e.TRUSTED_TYPES_POLICY){if("function"!=typeof e.TRUSTED_TYPES_POLICY.createHTML)throw b('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');if("function"!=typeof e.TRUSTED_TYPES_POLICY.createScriptURL)throw b('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');le=e.TRUSTED_TYPES_POLICY,ce=le.createHTML("")}else void 0===le&&(le=function(e,t){if("object"!=typeof e||"function"!=typeof e.createPolicy)return null;let n=null;const o="data-tt-policy-suffix";t&&t.hasAttribute(o)&&(n=t.getAttribute(o));const r="dompurify"+(n?"#"+n:"");try{return e.createPolicy(r,{createHTML:e=>e,createScriptURL:e=>e})}catch(e){return console.warn("TrustedTypes policy "+r+" could not be created."),null}}(j,c)),null!==le&&"string"==typeof ce&&(ce=le.createHTML(""));i&&i(e),ft=e}},Tt=w({},[...x,...C,...k]),yt=w({},[...I,...M]),Et=function(e){f(o.removed,{element:e});try{ae(e).removeChild(e)}catch(t){V(e)}},At=function(e,t){try{f(o.removed,{attribute:t.getAttributeNode(e),from:t})}catch(e){f(o.removed,{attribute:null,from:t})}if(t.removeAttribute(e),"is"===e)if(Fe||Be)try{Et(t)}catch(e){}else try{t.setAttribute(e,"")}catch(e){}},_t=function(e){let t=null,n=null;if(He)e="<remove></remove>"+e;else{const t=T(e,/^[\r\n\t ]+/);n=t&&t[0]}"application/xhtml+xml"===ut&&ot===nt&&(e='<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>'+e+"</body></html>");const o=le?le.createHTML(e):e;if(ot===nt)try{t=(new Y).parseFromString(o,ut)}catch(e){}if(!t||!t.documentElement){t=se.createDocument(ot,"template",null);try{t.documentElement.innerHTML=rt?ce:o}catch(e){}}const i=t.body||t.documentElement;return e&&n&&i.insertBefore(r.createTextNode(n),i.childNodes[0]||null),ot===nt?pe.call(t,ze?"html":"body")[0]:ze?t.documentElement:i},St=function(e){return ue.call(e.ownerDocument||e,e,B.SHOW_ELEMENT|B.SHOW_COMMENT|B.SHOW_TEXT|B.SHOW_PROCESSING_INSTRUCTION|B.SHOW_CDATA_SECTION,null)},bt=function(e){return e instanceof G&&("string"!=typeof e.nodeName||"string"!=typeof e.textContent||"function"!=typeof e.removeChild||!(e.attributes instanceof W)||"function"!=typeof e.removeAttribute||"function"!=typeof e.setAttribute||"string"!=typeof e.namespaceURI||"function"!=typeof e.insertBefore||"function"!=typeof e.hasChildNodes)},Nt=function(e){return"function"==typeof R&&e instanceof R};function Rt(e,t,n){u(e,(e=>{e.call(o,t,n,ft)}))}const wt=function(e){let t=null;if(Rt(de.beforeSanitizeElements,e,null),bt(e))return Et(e),!0;const n=pt(e.nodeName);if(Rt(de.uponSanitizeElement,e,{tagName:n,allowedTags:Ne}),Ue&&e.hasChildNodes()&&!Nt(e.firstElementChild)&&S(/<[/\w!]/g,e.innerHTML)&&S(/<[/\w!]/g,e.textContent))return Et(e),!0;if(e.nodeType===ee)return Et(e),!0;if(Ue&&e.nodeType===te&&S(/<[/\w]/g,e.data))return Et(e),!0;if(!Ne[n]||ve[n]){if(!ve[n]&&Dt(n)){if(De.tagNameCheck instanceof RegExp&&S(De.tagNameCheck,n))return!1;if(De.tagNameCheck instanceof Function&&De.tagNameCheck(n))return!1}if(je&&!$e[n]){const t=ae(e)||e.parentNode,n=ie(e)||e.childNodes;if(n&&t){for(let o=n.length-1;o>=0;--o){const r=$(n[o],!0);r.__removalCount=(e.__removalCount||0)+1,t.insertBefore(r,re(e))}}}return Et(e),!0}return e instanceof O&&!function(e){let t=ae(e);t&&t.tagName||(t={namespaceURI:ot,tagName:"template"});const n=h(e.tagName),o=h(t.tagName);return!!it[e.namespaceURI]&&(e.namespaceURI===tt?t.namespaceURI===nt?"svg"===n:t.namespaceURI===et?"svg"===n&&("annotation-xml"===o||lt[o]):Boolean(Tt[n]):e.namespaceURI===et?t.namespaceURI===nt?"math"===n:t.namespaceURI===tt?"math"===n&&ct[o]:Boolean(yt[n]):e.namespaceURI===nt?!(t.namespaceURI===tt&&!ct[o])&&!(t.namespaceURI===et&&!lt[o])&&!yt[n]&&(st[n]||!Tt[n]):!("application/xhtml+xml"!==ut||!it[e.namespaceURI]))}(e)?(Et(e),!0):"noscript"!==n&&"noembed"!==n&&"noframes"!==n||!S(/<\/no(script|embed|frames)/i,e.innerHTML)?(Me&&e.nodeType===Q&&(t=e.textContent,u([he,ge,Te],(e=>{t=y(t,e," ")})),e.textContent!==t&&(f(o.removed,{element:e.cloneNode()}),e.textContent=t)),Rt(de.afterSanitizeElements,e,null),!1):(Et(e),!0)},Ot=function(e,t,n){if(Ge&&("id"===t||"name"===t)&&(n in r||n in dt))return!1;if(Ce&&!Le[t]&&S(ye,t));else if(xe&&S(Ee,t));else if(!we[t]||Le[t]){if(!(Dt(e)&&(De.tagNameCheck instanceof RegExp&&S(De.tagNameCheck,e)||De.tagNameCheck instanceof Function&&De.tagNameCheck(e))&&(De.attributeNameCheck instanceof RegExp&&S(De.attributeNameCheck,t)||De.attributeNameCheck instanceof Function&&De.attributeNameCheck(t,e))||"is"===t&&De.allowCustomizedBuiltInElements&&(De.tagNameCheck instanceof RegExp&&S(De.tagNameCheck,n)||De.tagNameCheck instanceof Function&&De.tagNameCheck(n))))return!1}else if(Je[t]);else if(S(be,y(n,_e,"")));else if("src"!==t&&"xlink:href"!==t&&"href"!==t||"script"===e||0!==E(n,"data:")||!Ve[e]){if(ke&&!S(Ae,y(n,_e,"")));else if(n)return!1}else;return!0},Dt=function(e){return"annotation-xml"!==e&&T(e,Se)},vt=function(e){Rt(de.beforeSanitizeAttributes,e,null);const{attributes:t}=e;if(!t||bt(e))return;const n={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:we,forceKeepAttr:void 0};let r=t.length;for(;r--;){const i=t[r],{name:a,namespaceURI:l,value:c}=i,s=pt(a),m=c;let f="value"===a?m:A(m);if(n.attrName=s,n.attrValue=f,n.keepAttr=!0,n.forceKeepAttr=void 0,Rt(de.uponSanitizeAttribute,e,n),f=n.attrValue,!Ye||"id"!==s&&"name"!==s||(At(a,e),f="user-content-"+f),Ue&&S(/((--!?|])>)|<\/(style|title)/i,f)){At(a,e);continue}if("attributename"===s&&T(f,"href")){At(a,e);continue}if(n.forceKeepAttr)continue;if(!n.keepAttr){At(a,e);continue}if(!Ie&&S(/\/>/i,f)){At(a,e);continue}Me&&u([he,ge,Te],(e=>{f=y(f,e," ")}));const d=pt(e.nodeName);if(Ot(d,s,f)){if(le&&"object"==typeof j&&"function"==typeof j.getAttributeType)if(l);else switch(j.getAttributeType(d,s)){case"TrustedHTML":f=le.createHTML(f);break;case"TrustedScriptURL":f=le.createScriptURL(f)}if(f!==m)try{l?e.setAttributeNS(l,a,f):e.setAttribute(a,f),bt(e)?Et(e):p(o.removed)}catch(t){At(a,e)}}else At(a,e)}Rt(de.afterSanitizeAttributes,e,null)},Lt=function e(t){let n=null;const o=St(t);for(Rt(de.beforeSanitizeShadowDOM,t,null);n=o.nextNode();)Rt(de.uponSanitizeShadowNode,n,null),wt(n),vt(n),n.content instanceof s&&e(n.content);Rt(de.afterSanitizeShadowDOM,t,null)};return o.sanitize=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=null,r=null,i=null,l=null;if(rt=!e,rt&&(e="\x3c!--\x3e"),"string"!=typeof e&&!Nt(e)){if("function"!=typeof e.toString)throw b("toString is not a function");if("string"!=typeof(e=e.toString()))throw b("dirty is not a string, aborting")}if(!o.isSupported)return e;if(Pe||gt(t),o.removed=[],"string"==typeof e&&(Xe=!1),Xe){if(e.nodeName){const t=pt(e.nodeName);if(!Ne[t]||ve[t])throw b("root node is forbidden and cannot be sanitized in-place")}}else if(e instanceof R)n=_t("\x3c!----\x3e"),r=n.ownerDocument.importNode(e,!0),r.nodeType===J&&"BODY"===r.nodeName||"HTML"===r.nodeName?n=r:n.appendChild(r);else{if(!Fe&&!Me&&!ze&&-1===e.indexOf("<"))return le&&We?le.createHTML(e):e;if(n=_t(e),!n)return Fe?null:We?ce:""}n&&He&&Et(n.firstChild);const c=St(Xe?e:n);for(;i=c.nextNode();)wt(i),vt(i),i.content instanceof s&&Lt(i.content);if(Xe)return e;if(Fe){if(Be)for(l=me.call(n.ownerDocument);n.firstChild;)l.appendChild(n.firstChild);else l=n;return(we.shadowroot||we.shadowrootmode)&&(l=fe.call(a,l,!0)),l}let m=ze?n.outerHTML:n.innerHTML;return ze&&Ne["!doctype"]&&n.ownerDocument&&n.ownerDocument.doctype&&n.ownerDocument.doctype.name&&S(K,n.ownerDocument.doctype.name)&&(m="<!DOCTYPE "+n.ownerDocument.doctype.name+">\n"+m),Me&&u([he,ge,Te],(e=>{m=y(m,e," ")})),le&&We?le.createHTML(m):m},o.setConfig=function(){gt(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}),Pe=!0},o.clearConfig=function(){ft=null,Pe=!1},o.isValidAttribute=function(e,t,n){ft||gt({});const o=pt(e),r=pt(t);return Ot(o,r,n)},o.addHook=function(e,t){"function"==typeof t&&f(de[e],t)},o.removeHook=function(e,t){if(void 0!==t){const n=m(de[e],t);return-1===n?void 0:d(de[e],n,1)[0]}return p(de[e])},o.removeHooks=function(e){de[e]=[]},o.removeAllHooks=function(){de={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}},o}();return re}));
//# sourceMappingURL=purify.min.js.map

/**
 * Bootstrap Multiselect (https://github.com/davidstutz/bootstrap-multiselect)
 * 
 * Apache License, Version 2.0:
 * Copyright (c) 2012 - 2015 David Stutz
 * 
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a
 * copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 * 
 * BSD 3-Clause License:
 * Copyright (c) 2012 - 2015 David Stutz
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *    - Redistributions of source code must retain the above copyright notice,
 *      this list of conditions and the following disclaimer.
 *    - Redistributions in binary form must reproduce the above copyright notice,
 *      this list of conditions and the following disclaimer in the documentation
 *      and/or other materials provided with the distribution.
 *    - Neither the name of David Stutz nor the names of its contributors may be
 *      used to endorse or promote products derived from this software without
 *      specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
 * THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
 * PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
 * PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
 * OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
 * OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
!function ($) {
    "use strict";// jshint ;_;

    if (typeof ko !== 'undefined' && ko.bindingHandlers && !ko.bindingHandlers.multiselect) {
        ko.bindingHandlers.multiselect = {
            after: ['options', 'value', 'selectedOptions'],

            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var $element = $(element);
                var config = ko.toJS(valueAccessor());

                $element.multiselect(config);

                if (allBindings.has('options')) {
                    var options = allBindings.get('options');
                    if (ko.isObservable(options)) {
                        ko.computed({
                            read: function() {
                                options();
                                setTimeout(function() {
                                    $element.multiselect('rebuild');
                                }, 1);
                            },
                            disposeWhenNodeIsRemoved: element
                        });
                    }
                }

                //value and selectedOptions are two-way, so these will be triggered even by our own actions.
                //It needs some way to tell if they are triggered because of us or because of outside change.
                //It doesn't loop but it's a waste of processing.
                if (allBindings.has('value')) {
                    var value = allBindings.get('value');
                    if (ko.isObservable(value)) {
                        ko.computed({
                            read: function() {
                                value();
                                setTimeout(function() {
                                    $element.multiselect('refresh');
                                }, 1);
                            },
                            disposeWhenNodeIsRemoved: element
                        }).extend({ rateLimit: 100, notifyWhenChangesStop: true });
                    }
                }

                //Switched from arrayChange subscription to general subscription using 'refresh'.
                //Not sure performance is any better using 'select' and 'deselect'.
                if (allBindings.has('selectedOptions')) {
                    var selectedOptions = allBindings.get('selectedOptions');
                    if (ko.isObservable(selectedOptions)) {
                        ko.computed({
                            read: function() {
                                selectedOptions();
                                setTimeout(function() {
                                    $element.multiselect('refresh');
                                }, 1);
                            },
                            disposeWhenNodeIsRemoved: element
                        }).extend({ rateLimit: 100, notifyWhenChangesStop: true });
                    }
                }

                ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                    $element.multiselect('destroy');
                });
            },

            update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var $element = $(element);
                var config = ko.toJS(valueAccessor());

                $element.multiselect('setOptions', config);
                $element.multiselect('rebuild');
            }
        };
    }

    function forEach(array, callback) {
        for (var index = 0; index < array.length; ++index) {
            callback(array[index], index);
        }
    }

    var FILTERABLE_ITEM_SELECTOR = "li:not(.divider):not(.disabled):not(.multiselect-footer):not(.multiselect-selectbuttons):not(.multiselect-nomatch)";

    var HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

    function escapeHtml(value) {
        return value == null ? '' : String(value).replace(/[&<>"']/g, function (c) { return HTML_ESCAPES[c]; });
    }

    /**
     * Constructor to create a new multiselect using the given select.
     *
     * @param {jQuery} select
     * @param {Object} options
     * @returns {Multiselect}
     */
    function Multiselect(select, options) {

        this.$select = $(select);
        
        // Placeholder via data attributes
        if (this.$select.attr("data-placeholder")) {
            options.nonSelectedText = this.$select.data("placeholder");
        }
        
        this.options = this.mergeOptions($.extend({}, options, this.$select.data()));

        this.query = '';
        this.searchTimeout = null;
        this.filterTimeout = null;
        this.lastToggledInput = null
        this.optionsBuilt = false;

        this.options.multiple = this.$select.attr('multiple') === "multiple";
        this.options.onChange = $.proxy(this.options.onChange, this);
        this.options.onDropdownShow = $.proxy(this.options.onDropdownShow, this);
        this.options.onDropdownHide = $.proxy(this.options.onDropdownHide, this);
        this.options.onDropdownShown = $.proxy(this.options.onDropdownShown, this);
        this.options.onDropdownHidden = $.proxy(this.options.onDropdownHidden, this);
        this.options.onSelectAll = $.proxy(this.options.onSelectAll, this);
        
        // Build select all if enabled.
        this.buildContainer();
        this.buildButton();
        this.buildDropdown();
        this.buildSelectAll();
        this.bindDropdownEvents();

        this.updateButtonText();
        this.updateSelectAll();

        if (this.options.disableIfEmpty && $('option', this.$select).length <= 0) {
            this.disable();
        }
        
        this.$select[0].style.display = 'none';
        this.$select.addClass('multiselect-initialized').after(this.$container);
    };

    Multiselect.prototype = {

        defaults: {
            buttonText: function(options, select) {
                return this.renderSelectionLabel(options, select, true);
            },
            buttonTitle: function(options, select) {
                return this.renderSelectionLabel(options, select, false);
            },
            // summarizeWhenMany: collapse to "N selected" when over numberDisplayed; otherwise list every label.
            renderSelectionLabel: function(options, select, summarizeWhenMany) {
                var totalOptions = $(select)[0].options.length;
                var allSelected = options.length === totalOptions;
                var noneAsAll = this.isNoneAll && options.length === 0;

                if (this.allSelectedText
                            && (allSelected || noneAsAll)
                            && (totalOptions !== 1 || this.isNoneAll)
                            && this.multiple) {

                    if (this.selectAllNumber) {
                        return this.allSelectedText + ' (' + (this.isNoneAll ? totalOptions : options.length) + ')';
                    }
                    return this.allSelectedText;
                }

                if (options.length === 0) {
                    return this.nonSelectedText;
                }

                if (summarizeWhenMany && options.length > this.numberDisplayed) {
                    return options.length + ' ' + this.nSelectedText;
                }

                var delimiter = this.delimiterText || '';
                var labels = [];
                options.each(function () {
                    labels.push(($(this).attr('label') !== undefined) ? $(this).attr('label') : $(this).text());
                });
                return labels.join(delimiter);
            },
            /**
             * Create a label.
             *
             * @param {jQuery} element
             * @returns {String}
             */
            optionLabel: function(element){
                return $(element).attr('label') || $(element).text();
            },
            /**
             * Triggered on change of the multiselect.
             * 
             * Not triggered when selecting/deselecting options manually.
             * 
             * @param {jQuery} option
             * @param {Boolean} checked
             */
            onChange : function(option, checked) {

            },
            /**
             * Triggered when the dropdown is shown.
             *
             * @param {jQuery} event
             */
            onDropdownShow: function(event) {

            },
            /**
             * Triggered when the dropdown is hidden.
             *
             * @param {jQuery} event
             */
            onDropdownHide: function(event) {

            },
            /**
             * Triggered after the dropdown is shown.
             * 
             * @param {jQuery} event
             */
            onDropdownShown: function(event) {
                
            },
            /**
             * Triggered after the dropdown is hidden.
             * 
             * @param {jQuery} event
             */
            onDropdownHidden: function(event) {
                
            },
            /**
             * Triggered on select all.
             */
            onSelectAll: function() {

            },
            /**
             * Triggered on deselect all.
             */
            onDeselectAll: function() {

            },
            enableHTML: false,
            buttonClass: 'btn btn-default',
            inheritClass: false,
            buttonWidth: 'auto',
            buttonContainer: '<div class="dropdown has-block-dropdown-btn" />',
            dropRight: false,
            selectedClass: 'active',
            // Maximum height of the dropdown menu.
            // If maximum height is exceeded a scrollbar will be displayed.
            maxHeight: false,
            checkboxName: false,
            includeSelectAllOption: false,
            includeSelectAllIfMoreThan: 0,
            selectAllText: ' Select all',
            selectAllValue: 'multiselect-all',
            selectAllName: false,
            selectAllNumber: true,
            enableFiltering: false,
            enableCaseInsensitiveFiltering: false,
            enableClickableOptGroups: false,
            filterPlaceholder: 'Search',
            // possible options: 'text', 'value', 'both'
            filterBehavior: 'text',
            includeFilterClearBtn: true,
            preventInputChangeEvent: false,
            isNoneAll: false,
            nonSelectedText: 'None selected',
            nSelectedText: 'selected',
            allSelectedText: 'All selected',
            numberDisplayed: 3,
            disableIfEmpty: false,
            delimiterText: ', ',
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" data-bs-toggle="dropdown" role="combobox" aria-haspopup="listbox" aria-expanded="false"><span class="multiselect-selected-text"></span> <b class="caret"></b></button>',
                ul: '<ul class="multiselect-container dropdown-menu" role="listbox"></ul>',
                filter: '<li class="multiselect-item filter"><div class="input-group"><span class="input-group-addon input-group-text"><i class="fa-regular fa-search"></i></span><input class="form-control multiselect-search" type="text"></div></li>',
                filterClearBtn: '<span class="input-group-btn"><button class="btn btn-default multiselect-clear-filter" type="button"><i class="fa-regular fa-circle-xmark"></i></button></span>',
                li: '<li role="option"><a tabindex="0" class="dropdown-item"><label></label></a></li>',
                divider: '<li class="multiselect-item divider dropdown-divider"></li>',
                liGroup: '<li class="multiselect-item multiselect-group"><a tabindex="0" class="dropdown-item"><label></label></a></li>'
            }
        },

        constructor: Multiselect,

        /**
         * Builds the container of the multiselect.
         */
        buildContainer: function() {
            this.$container = $(this.options.buttonContainer);

            if (this.$select.hasClass('filterable-single-select'))
                this.$container.addClass('filterable-single-select');
            else
                this.$container.addClass('btn-group');

            // Bound first so the option list exists by the time the other handlers run.
            this.$container.on('show.bs.dropdown', $.proxy(this.ensureDropdownOptions, this));

            this.$container.on('show.bs.dropdown', this.options.onDropdownShow);
            this.$container.on('hide.bs.dropdown', this.options.onDropdownHide);
            this.$container.on('shown.bs.dropdown', this.options.onDropdownShown);
            this.$container.on('hidden.bs.dropdown', this.options.onDropdownHidden);
        },

        /**
         * Builds the button of the multiselect.
         */
        buildButton: function() {
            this.$button = $(this.options.templates.button).addClass(this.options.buttonClass);

            if (this.$select.is('[data-val-required]')) {
                this.$button.attr('aria-required', 'true');
            }

            // Unique to OwnerRez: Add data-testid for Playwright test automation
            var selectId = this.$select.attr('id');
            if (selectId) {
                this.$button.attr('data-testid', selectId + '-dropdown');
            }

            if (this.$select.attr('class') && this.options.inheritClass) {
                this.$button.addClass(this.$select.attr('class'));
            }
            // Adopt active state.
            if (this.$select.prop('disabled')) {
                this.disable();
            }
            else {
                this.enable();
            }

            // Manually add button width if set.
            if (this.options.buttonWidth && this.options.buttonWidth !== 'auto') {
                this.$button.css({
                    'width' : this.options.buttonWidth,
                    'overflow' : 'hidden',
                    'text-overflow' : 'ellipsis'
                });
                this.$container.css({
                    'width': this.options.buttonWidth
                });
            }

            // Keep the tab index from the select.
            var tabindex = this.$select.attr('tabindex');
            this.$button.attr('tabindex', tabindex || '0');

            this.$container.prepend(this.$button);
        },

        /**
         * Builds the ul representing the dropdown menu.
         */
        buildDropdown: function() {

            // Build ul.
            this.$ul = $(this.options.templates.ul);

            if (this.options.dropRight) {
                this.$ul.addClass('pull-right dropdown-menu-end');    
            }

            // Set max height of dropdown menu to activate auto scrollbar.
            if (this.options.maxHeight) {
                // TODO: Add a class for this option to move the css declarations.
                this.$ul.css({
                    'max-height': this.options.maxHeight + 'px',
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden'
                });
            }

            this.$container.append(this.$ul);

            this.buildSelectButtons();
        },

        buildSelectButtons: function() {
            var isFilterable = this.$select[0].options.length >= (window.SingleFilterMinItems || 15);

            if (this.options.multiple || isFilterable)
            {
                var html = '';
                var hasSelectButtons;

                if (this.options.multiple) {
                    // one container <li> with the filter stacked above a flex "Select all" / "Clear all" row.
                    html = '<li class="multiselect-selectbuttons disabled">';

                    if (isFilterable)
                        html += '<input class="form-control input-sm form-control-sm multiselect-filter mb-2" type="text" placeholder="Filter..." />';

                    if (!this.options.disableSelectAllAndClearOption)
                        html += '<div><label class="multiselect-selectall checkbox text-nowrap fw-normal me-4"><input type="checkbox" class="multiselect-selectall-input" /> Select all</label><a class="multiselect-clear text-nowrap"> Clear all</a></div>';

                    html += '</li>';

                    hasSelectButtons = isFilterable || !this.options.disableSelectAllAndClearOption;
                }
                else {
                    // Single-select is excluded so there is no "Clear all" link and no blank line above the filter.
                    if (isFilterable)
                        html += '<input class="form-control input-sm form-control-sm multiselect-filter" type="text" placeholder="Filter..." />';

                    if (this.options.isSingleClearable)
                        html += '<a class="btn btn-sm btn-default multiselect-clear"><i class="fa fa-ban"></i> Clear</a>';

                    hasSelectButtons = html != '';

                    if (hasSelectButtons)
                        html = '<li class="multiselect-selectbuttons multiselect-single disabled"><div>' + html + '</div></li>';
                }

                if (hasSelectButtons) {
                    $('ul', this.$container).append(html);
                    $('ul', this.$container).append($('<li class="multiselect-nomatch disabled" style="display:none"><a><label>No matching items...</label></a></li>'));
                }

                if (this.options.isNoneAll)
                {
                    var userCleared = false;

                    this.$container.on('show.bs.dropdown', $.proxy(function (event)
                    {
                        if (userCleared)
                            return;

                        if ($('option:checked', this.$select).length === 0)
                        {
                            this.selectAll(false, false);
                            this.updateButtonText();
                            this.updateSelectAll();
                        }
                    }, this));

                    this.$container.on('hide.bs.dropdown', $.proxy(function (event)
                    {
                        var totalCount = $('option', this.$select).length;
                        var checkedCount = $('option:checked', this.$select).length;

                        if (checkedCount === totalCount)
                        {
                            this.clearSelection();
                            userCleared = false;
                        }
                        else if (checkedCount === 0)
                        {
                            userCleared = true;
                        }
                    }, this));
                }

                this.$container.on('shown.bs.dropdown', $.proxy(function (event)
                {
                    var $filter = $('input.multiselect-filter', this.$container);

                    if (this._pendingFilterKey != null)
                    {
                        // A character was typed on the closed button: seed the filter with it
                        // and put the caret at the end so subsequent keystrokes keep filtering.
                        $filter.val(this._pendingFilterKey).focus();
                        this._pendingFilterKey = null;

                        var filterEl = $filter[0];
                        filterEl.setSelectionRange(filterEl.value.length, filterEl.value.length);

                        this.applyFilter();
                    }
                    else
                    {
                        $filter.val("").focus();
                    }

                    $(".multiselect-container", this.$container).css("min-width", $(".multiselect-container", this.$container).width() + "px");
                }, this));

                this.$container.on('hide.bs.dropdown', $.proxy(function (event)
                {
                    clearTimeout(this.filterTimeout);

                    $('input.multiselect-filter', this.$container).val("");

                    this.$container[0].querySelectorAll(FILTERABLE_ITEM_SELECTOR).forEach(function (li)
                    {
                        li.style.display = "";
                        li.classList.remove("filter-hidden");
                    });

                    $('.multiselect-nomatch', this.$container).hide();
                }, this));

                if (isFilterable)
                {
                    $('input.multiselect-filter', this.$container).off('keydown.multiselect').on('keydown.multiselect', $.proxy(function (event)
                    {
                        if (event.keyCode === 27 && this.$container.hasClass('open'))
                        {
                            this.$button.click();

                            event.stopPropagation();
                            event.preventDefault();
                        }
                        else if (event.keyCode === 40)
                        {
                            $(this.$container).find("li:not(.divider):not(.disabled) a").filter(":visible").first().focus();

                            event.stopPropagation();
                            event.preventDefault();
                        }
                        else if (event.keyCode == 13)
                        {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }, this));

                    $('input.multiselect-filter', this.$container).off('input').on('input', $.proxy(function (event)
                    {
                        // A pass touches every item, so coalesce a burst of keystrokes into one.
                        clearTimeout(this.filterTimeout);
                        this.filterTimeout = setTimeout($.proxy(this.applyFilter, this), 100);
                    }, this));

                    $('input.multiselect-filter', this.$container).off('focus').on('focus', $.proxy(function (event)
                    {
                        $('input.multiselect-filter', this.$container).select();
                    }, this));

                    this.$button.off('keydown.singleselectfilter').on('keydown.singleselectfilter', $.proxy(function (event)
                    {
                        // When the closed button has focus, typing a printable character opens
                        // the dropdown and starts filtering immediately (Tab-then-type). Space,
                        // Enter and the arrow keys keep their existing open-the-dropdown
                        // behavior; modifier combos are left to the browser.
                        if (this.$button.attr('aria-expanded') === 'true')
                            return;

                        if (event.ctrlKey || event.altKey || event.metaKey)
                            return;

                        if (event.key && event.key.length === 1 && event.key !== ' ')
                        {
                            this._pendingFilterKey = event.key;
                            this.$button.click();

                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }, this));
                }
            }
        },

        /**
         * Hides the items that don't match the filter box, keeping a group visible when it or
         * one of its items matches.
         */
        applyFilter: function() {
            var matchString = $('input.multiselect-filter', this.$container).val().trim();
            var match = null;

            if (matchString.length)
            {
                // Treat the filter text literally: a typed "(" or "*" is a
                // character to match, not a regex operator (and would otherwise throw).
                var escaped = matchString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                match = new RegExp(escaped, "i");
            }

            var currentGroup = null;
            var currentGroupVisible = false;
            var currentGroupHasMatch = false;
            var hasMatch = false;

            this.$container[0].querySelectorAll(FILTERABLE_ITEM_SELECTOR).forEach(function (li)
            {
                var isMatch = match == null || match.test(li.textContent);

                if (li.classList.contains("multiselect-group")) // reset group tracking
                {
                    currentGroup = li;
                    currentGroupVisible = isMatch;
                    currentGroupHasMatch = false;
                }
                else if (isMatch && currentGroup != null && !currentGroupHasMatch) // if an item in a group matches, show the group
                {
                    currentGroup.style.display = "";
                    currentGroup.classList.remove("filter-hidden");

                    currentGroupHasMatch = true;
                }
                else if (currentGroupVisible) // if a group matches, show all children
                    isMatch = true;

                var display = isMatch ? "" : "none";

                // Writing an unchanged display value still costs a style recalc on a long list.
                if (li.style.display !== display)
                    li.style.display = display;

                li.classList.toggle("filter-hidden", !isMatch);

                if (isMatch)
                    hasMatch = true;
            });

            $('.multiselect-nomatch', this.$container).toggle(!hasMatch);
        },

        /**
         * Builds the option list on first open, so a select nobody opens never pays for one.
         */
        ensureDropdownOptions: function() {
            if (this.optionsBuilt) {
                return;
            }

            this.optionsBuilt = true;

            this.buildDropdownOptions();
            this.buildFilter();
            this.updateSelectAll();
        },

        /**
         * Build the dropdown options.
         *
         * Rendered as one HTML string and inserted once: per-option jQuery construction stalls
         * the main thread on a several-thousand-option select.
         */
        buildDropdownOptions: function() {

            var html = [];
            var sources = [];

            this.$select.children().each($.proxy(function(index, element) {

                var $element = $(element);
                // Support optgroups and options without a group simultaneously.
                var tag = $element.prop('tagName')
                    .toLowerCase();

                if ($element.prop('value') === this.options.selectAllValue) {
                    return;
                }

                if (tag === 'optgroup') {
                    this.renderOptgroup(element, html, sources);
                }
                else if (tag === 'option') {

                    if ($element.data('role') === 'divider') {
                        html.push(this.options.templates.divider);
                        sources.push(null);
                    }
                    else {
                        this.renderOptionValue(element, html, sources);
                    }

                }

                // Other illegal tags will be ignored.
            }, this));

            this.appendDropdownOptions(html, sources);
        },

        /**
         * Binds the dropdown events once per widget. Delegated from the container so they
         * survive both the deferred option build and a rebuild.
         */
        bindDropdownEvents: function() {

            // Bind the change event on the dropdown elements.
            this.$ul.on('change', 'li input', $.proxy(function(event) {
                var $target = $(event.target);

                var checked = $target.prop('checked') || false;
                var isSelectAllOption = $target.val() === this.options.selectAllValue;

                if ($target.prop("type") == "text")
                    return;

                // The header select-all checkbox has its own dedicated handler below.
                if ($target.hasClass("multiselect-selectall-input"))
                    return;

                // Apply or unapply the configured selected class.
                if (this.options.selectedClass) {
                    if (checked) {
                        $target.closest('li')
                            .addClass(this.options.selectedClass);
                    }
                    else {
                        $target.closest('li')
                            .removeClass(this.options.selectedClass);
                    }
                }

                // Get the corresponding option.
                var value = $target.val();
                var $option = this.getOptionByValue(value);

                var $optionsNotThis = $('option', this.$select).not($option);
                var $checkboxesNotThis = $('input', this.$container).not($target);

                if (isSelectAllOption) {
                    if (checked) {
                        this.selectAll();
                    }
                    else {
                        this.deselectAll();
                    }
                }

                if(!isSelectAllOption){
                    if (checked) {
                        $option.prop('selected', true);

                        if (this.options.multiple) {
                            // Simply select additional option.
                            $option.prop('selected', true);
                        }
                        else {
                            // Unselect all other options and corresponding checkboxes.
                            if (this.options.selectedClass) {
                                $($checkboxesNotThis).closest('li').removeClass(this.options.selectedClass);
                            }

                            $($checkboxesNotThis).prop('checked', false);
                            $optionsNotThis.prop('selected', false);

                            // It's a single selection, so close.
                            this.$button.click();
                        }

                        if (this.options.selectedClass === "active") {
                            $optionsNotThis.closest("a").css("outline", "");
                        }
                    }
                    else {
                        // Unselect option.
                        $option.prop('selected', false);
                    }
                }

                this.$select.change();

                this.updateButtonText();
                this.updateSelectAll();

                this.options.onChange($option, checked);

                if(this.options.preventInputChangeEvent) {
                    return false;
                }
            }, this));

            this.$ul.on('mousedown', 'li a', function(e) {
                if (e.shiftKey) {
                    // Prevent selecting text by Shift+click
                    return false;
                }
            });

            // Select-all checkbox change handler (select/deselect visible items).
            this.$container.on('change', 'ul li input.multiselect-selectall-input', $.proxy(function (event)
            {
                if ($(event.target).prop('checked'))
                {
                    this.selectAll(true, true);
                }
                else
                {
                    this.deselectAll(true);
                    this.options.onDeselectAll();
                }

                this.refresh();
                this.$select.change();
            }, this));

            // Keep dropdown open when toggling the select-all checkbox or its label.
            this.$container.on('click', 'ul li label.multiselect-selectall, ul li input.multiselect-selectall-input',
                function (e) { e.stopPropagation(); });

            // Delegated from $ul rather than the container: the generic "li a" handler below
            // stops propagation, so a root outside the list would never see the click.
            this.$ul.on('click', 'li a.multiselect-clear', $.proxy(function (event)
            {
                this.$container.find("li:not(.filter-hidden)").each(function (i, el)
                {
                    if (el.optionEl)
                        el.optionEl.selected = false;
                });

                this.refresh();
                this.$select.change();
                this.options.onDeselectAll();

                if (!this.options.multiple)
                    this.$select.find('option[value=""], option:not([value])').click();
            }, this));

            this.$ul.on('touchstart click', 'li a', $.proxy(function (event)
            {
                var $target = $(event.target);

                if ($target.parents(".multiselect-group").length)
                    return;

                event.stopPropagation();
                
                if (event.shiftKey && this.options.multiple) {
                    if($target.is("label")){ // Handles checkbox selection manually (see https://github.com/davidstutz/bootstrap-multiselect/issues/431)
                        event.preventDefault();
                        $target = $target.find("input");
                        $target.prop("checked", !$target.prop("checked"));
                    }
                    var checked = $target.prop('checked') || false;

                    if (this.lastToggledInput !== null && this.lastToggledInput !== $target) { // Make sure we actually have a range
                        var from = $target.closest("li").index();
                        var to = this.lastToggledInput.closest("li").index();
                        
                        if (from > to) { // Swap the indices
                            var tmp = to;
                            to = from;
                            from = tmp;
                        }
                        
                        // Make sure we grab all elements since slice excludes the last index
                        ++to;
                        
                        // Change the checkboxes and underlying options
                        var range = this.$ul.find("li").slice(from, to).filter(":visible").find("input");
                        
                        range.prop('checked', checked);
                        
                        if (this.options.selectedClass) {
                            range.closest('li')
                                .toggleClass(this.options.selectedClass, checked);
                        }
                        
                        for (var i = 0, j = range.length; i < j; i++) {
                            var $checkbox = $(range[i]);

                            var $option = this.getOptionByValue($checkbox.val());

                            $option.prop('selected', checked);
                        }                   
                    }
                    
                    // Trigger the select "change" event
                    $target.trigger("change");
                }
                else if (!this.options.multiple)
                {
                    var $input = $target;
                    
                    if ($input.is("label"))
                        $input = $input.find("input");

                    if ($input.length && $input.prop("checked"))
                    {
                        // we don't get an input event if it's already selected, so we need to close the dropdown ourselves
                        window.setTimeout(function ()
                        {
                            $input.closest(".btn-group, .dropdown").removeClass("open");
                            $input.closest(".btn-group, .dropdown").find(".show").removeClass("show");
                        }, 1);
                    }
                }

                // Remembers last clicked option
                if($target.is("input") && !$target.closest("li").is(".multiselect-item")){
                    this.lastToggledInput = $target;
                }

                $target.blur();
            }, this));

            // Keyboard support.
            this.$container.off('keydown.multiselect').on('keydown.multiselect', $.proxy(function(event) {
                if ($('input[type="text"]', this.$container).is(':focus')) {
                    return;
                }

                // Bootstrap 5 tracks open state via aria-expanded on the toggle,
                // not a legacy "open" class on the container.
                var isOpen = this.$button.attr('aria-expanded') === 'true';

                // Dropdown is open but focus is on an option (after arrow nav) or the
                // button: route typing and Backspace into the filter so it keeps filtering.
                // Space stays a selection toggle; modifier combos are left to the browser.
                var $filter = $('input.multiselect-filter', this.$container);

                if ($filter.length && isOpen && !event.ctrlKey && !event.altKey && !event.metaKey)
                {
                    var filterEl = $filter[0];
                    var routed = false;

                    if (event.key && event.key.length === 1 && event.key !== ' ')
                    {
                        filterEl.value += event.key;
                        routed = true;
                    }
                    else if (event.key === 'Backspace' && filterEl.value.length)
                    {
                        filterEl.value = filterEl.value.slice(0, -1);
                        routed = true;
                    }

                    if (routed)
                    {
                        $filter.focus();
                        filterEl.setSelectionRange(filterEl.value.length, filterEl.value.length);
                        $filter.trigger('input');

                        event.stopPropagation();
                        event.preventDefault();

                        return;
                    }
                }

                if (event.keyCode === 9 && isOpen) {
                    // Single-select only: commit the highlighted item before leaving
                    // (mirror Enter/Space). Multi-select keeps its plain close behavior.
                    if (!this.options.multiple)
                    {
                        var $focused = $(this.$container).find("li:not(.divider):not(.disabled) a").filter(":visible").filter(':focus');

                        if ($focused.length)
                        {
                            var $tabGroup = $focused.closest(".multiselect-group");

                            if ($tabGroup.length)
                            {
                                $tabGroup.click();
                            }
                            else
                            {
                                var $tabCheckbox = $focused.find('input');

                                $tabCheckbox.prop("checked", true);
                                $tabCheckbox.change();
                            }
                        }
                    }

                    // Single-select auto-closes via the change handler; close here only
                    // if it's still open. Return focus to the field so the browser's
                    // native Tab / Shift+Tab moves on.
                    if (this.$button.attr('aria-expanded') === 'true')
                        this.$button.click();

                    this.$button.focus();
                }
                else {
                    var $items = $(this.$container).find("li:not(.divider):not(.disabled) a").filter(":visible");

                    if (!$items.length) {
                        return;
                    }

                    var index = $items.index($items.filter(':focus'));

                    // Navigation up.
                    if (event.keyCode === 38)
                    {
                        if (index == 0)
                        {
                            if ($('input.multiselect-filter', this.$container).length)
                            {
                                // into the filter box
                                $('input.multiselect-filter', this.$container).focus();

                                event.stopPropagation();
                                event.preventDefault();

                                return;
                            }
                            else // down to the bottom
                                index = $items.length - 1
                        }
                        else
                            index--;
                    }
                    // Navigate down.
                    else if (event.keyCode === 40)
                    {
                        // down one
                        if (index < $items.length - 1)
                            index++;
                        else // up to the top
                            index = 0;
                    }
                    else if (!~index) {
                        index = 0;
                    }

                    var $current = $items.eq(index);
                    $current.focus();

                    if (event.keyCode === 32 || event.keyCode === 13)
                    {
                        var $group = $current.closest(".multiselect-group");

                        if ($group.length)
                        {
                            $group.click();
                        }
                        else
                        {
                            var $checkbox = $current.find('input');

                            if (this.options.multiple)
                                $checkbox.prop("checked", !$checkbox.prop("checked"));
                            else
                                $checkbox.prop("checked", true);

                            $checkbox.change();
                        }
                    }

                    event.stopPropagation();
                    event.preventDefault();
                }
            }, this));

            this.$ul.on('click', 'li.multiselect-group', $.proxy(function(event) {
                // Read at click time rather than bind time: rebuild can flip multiple.
                if (!this.options.enableClickableOptGroups || !this.options.multiple) {
                    return;
                }

                event.stopPropagation();

                var group = $(event.target).closest('.multiselect-group');

                // Search all option in optgroup
                var $options = group.nextUntil('li.multiselect-group');
                var $visibleOptions = $options.filter(":visible:not(.disabled)");

                // check or uncheck items
                var allChecked = true;
                var optionInputs = $visibleOptions.find('input');
                optionInputs.each(function() {
                    allChecked = allChecked && $(this).prop('checked');
                });

                $visibleOptions.each(function (i, el)
                {
                    if (el.optionEl)
                        el.optionEl.selected = !allChecked;
                });

                this.refresh();
                this.$select.change();
            }, this));
        },

        /**
         * Renders one option as an <li> onto the html buffer, pushing the matching entry onto
         * sources so appendDropdownOptions can wire the item back to its <option>.
         *
         * @param {Element} element
         * @param {Array} html
         * @param {Array} sources
         */
        renderOptionValue: function(element, html, sources) {
            var $element = $(element);
            var value = $element.val();

            if ((value == '' || value == null)
                && !this.options.multiple
                && (this.options.isSingleClearable || this.options.isSingleRequired))
            {
                // skip empties, don't need em
                return;
            }

            // Support the label attribute on options.
            var label = this.options.optionLabel(element);
            var inputType = this.options.multiple ? "checkbox" : "radio";
            var isSelectAll = value === this.options.selectAllValue;
            var isDisabled = $element.is(':disabled');
            var isSelected = $element.prop('selected') || false;
            var title = $element.attr('title');

            var liClasses = [];

            // Unique to OwnerRez, but can be ignored on upgrade because "optionClass" was added in a future release: https://github.com/davidstutz/bootstrap-multiselect/blob/master/dist/js/bootstrap-multiselect.js#L331
            if (this.options.optionClass)
            {
                var classes = this.options.optionClass($element);
                if (classes)
                    liClasses.push(classes);
            }

            if (isSelectAll)
                liClasses.push("multiselect-item multiselect-all");

            if (isDisabled)
                liClasses.push("disabled");

            if (isSelected && this.options.selectedClass)
                liClasses.push(this.options.selectedClass);

            html.push(
                '<li role="option"' + (liClasses.length ? ' class="' + escapeHtml(liClasses.join(' ')) + '"' : '') + '>'
                + '<a tabindex="' + (isDisabled ? '-1' : '0') + '" class="dropdown-item' + (isSelectAll ? ' multiselect-all' : '') + '">'
                + '<label class="' + inputType + '"' + (title != null ? ' title="' + escapeHtml(title) + '"' : '') + '>'
                + '<input type="' + inputType + '"'
                // Radio and checkbox value is in default/on mode, so the attribute and the
                // property are the same thing here.
                + ' value="' + escapeHtml(value) + '"'
                + (this.options.checkboxName ? ' name="' + escapeHtml(this.options.checkboxName) + '"' : '')
                + (isDisabled ? ' disabled="disabled"' : '')
                + ' /> '
                + (this.options.enableHTML ? label : escapeHtml(label))
                + '</label></a></li>');

            sources.push({ element: element, value: value, selected: isSelected });
        },

        /**
         * Renders an optgroup header followed by its options.
         *
         * @param {Element} group
         * @param {Array} html
         * @param {Array} sources
         */
        renderOptgroup: function(group, html, sources) {
            var $group = $(group);
            var groupName = $group.prop('label');

            var liClasses = ["multiselect-item", "multiselect-group"];

            if (this.options.enableClickableOptGroups)
                liClasses.push("multiselect-group-clickable");

            if ($group.is(':disabled'))
                liClasses.push("disabled");

            var label = '<label>' + (this.options.enableHTML ? groupName : escapeHtml(groupName)) + '</label>';

            // Without clickable groups a single-select header is inert, so it drops the anchor
            // and keeps the label as the item's only content.
            var body = this.options.enableClickableOptGroups || this.options.multiple
                ? '<a tabindex="0" class="dropdown-item">' + label + '</a>'
                : label;

            html.push('<li class="' + escapeHtml(liClasses.join(' ')) + '">' + body + '</li>');
            sources.push(null);

            $('option', group).each($.proxy(function(index, element) {
                this.renderOptionValue(element, html, sources);
            }, this));
        },

        /**
         * Parses the rendered list in one pass and appends it in a single insert.
         *
         * @param {Array} html
         * @param {Array} sources
         */
        appendDropdownOptions: function(html, sources) {
            var scratch = document.createElement('ul');
            scratch.innerHTML = html.join('');

            var items = scratch.children;

            for (var i = 0; i < items.length; i++) {
                var source = sources[i];

                if (!source) {
                    continue;
                }

                items[i].optionEl = source.element;

                // Checked stays a property so the item's default state still comes from the
                // <select>, and only the selected few cost a lookup.
                if (source.selected) {
                    items[i].getElementsByTagName('input')[0].checked = true;
                }
            }

            var fragment = document.createDocumentFragment();

            while (scratch.firstChild) {
                fragment.appendChild(scratch.firstChild);
            }

            this.$ul[0].appendChild(fragment);
        },

        /**
         * Build the selct all.
         * 
         * Checks if a select all has already been created.
         */
        buildSelectAll: function() {
            if (typeof this.options.selectAllValue === 'number') {
                this.options.selectAllValue = this.options.selectAllValue.toString();
            }
            
            var alreadyHasSelectAll = this.hasSelectAll();

            if (!alreadyHasSelectAll && this.options.includeSelectAllOption && this.options.multiple
                    && $('option', this.$select).length > this.options.includeSelectAllIfMoreThan) {

                // Check whether to add a divider after the select all.
                if (this.options.includeSelectAllDivider) {
                    this.$ul.prepend($(this.options.templates.divider));
                }

                var $li = $(this.options.templates.li);
                $('label', $li).addClass("checkbox");
                
                if (this.options.enableHTML) {
                    $('label', $li).html(" " + this.options.selectAllText);
                }
                else {
                    $('label', $li).text(" " + this.options.selectAllText);
                }
                
                if (this.options.selectAllName) {
                    $('label', $li).prepend('<input type="checkbox" name="' + this.options.selectAllName + '" />');
                }
                else {
                    $('label', $li).prepend('<input type="checkbox" />');
                }
                
                var $checkbox = $('input', $li);
                $checkbox.val(this.options.selectAllValue);

                $li.addClass("multiselect-item multiselect-all");
                $checkbox.parent().parent()
                    .addClass('multiselect-all');

                this.$ul.prepend($li);

                $checkbox.prop('checked', false);
            }
        },

        /**
         * Builds the filter.
         */
        buildFilter: function() {

            // Build filter if filtering OR case insensitive filtering is enabled and the number of options exceeds (or equals) enableFilterLength.
            if (this.options.enableFiltering || this.options.enableCaseInsensitiveFiltering) {
                var enableFilterLength = Math.max(this.options.enableFiltering, this.options.enableCaseInsensitiveFiltering);

                if (this.$select.find('option').length >= enableFilterLength) {

                    this.$filter = $(this.options.templates.filter);
                    $('input', this.$filter).attr('placeholder', this.options.filterPlaceholder);
                    
                    // Adds optional filter clear button
                    if(this.options.includeFilterClearBtn){
                        var clearBtn = $(this.options.templates.filterClearBtn);
                        clearBtn.on('click', $.proxy(function(event){
                            clearTimeout(this.searchTimeout);
                            this.$filter.find('.multiselect-search').val('');
                            $('li', this.$ul).show().removeClass("filter-hidden");
                            this.updateSelectAll();
                        }, this));
                        this.$filter.find('.input-group').append(clearBtn);
                    }
                    
                    this.$ul.prepend(this.$filter);

                    this.$filter.val(this.query).on('click', function(event) {
                        event.stopPropagation();
                    }).on('input keydown', $.proxy(function(event) {
                        // Cancel enter key default behaviour
                        if (event.which === 13) {
                          event.preventDefault();
                        }
                        
                        // This is useful to catch "keydown" events after the browser has updated the control.
                        clearTimeout(this.searchTimeout);

                        this.searchTimeout = this.asyncFunction($.proxy(function() {

                            if (this.query !== event.target.value) {
                                this.query = event.target.value;

                                var currentGroup, currentGroupVisible;
                                $.each($('li', this.$ul), $.proxy(function(index, element) {
                                    var value = $('input', element).length > 0 ? $('input', element).val() : "";
                                    var text = $('label', element).text();

                                    var filterCandidate = '';
                                    if ((this.options.filterBehavior === 'text')) {
                                        filterCandidate = text;
                                    }
                                    else if ((this.options.filterBehavior === 'value')) {
                                        filterCandidate = value;
                                    }
                                    else if (this.options.filterBehavior === 'both') {
                                        filterCandidate = text + '\n' + value;
                                    }

                                    if (value !== this.options.selectAllValue && text) {
                                        // By default lets assume that element is not
                                        // interesting for this search.
                                        var showElement = false;

                                        if (this.options.enableCaseInsensitiveFiltering && filterCandidate.toLowerCase().indexOf(this.query.toLowerCase()) > -1) {
                                            showElement = true;
                                        }
                                        else if (filterCandidate.indexOf(this.query) > -1) {
                                            showElement = true;
                                        }

                                        // Toggle current element (group or group item) according to showElement boolean.
                                        $(element).toggle(showElement).toggleClass('filter-hidden', !showElement);
                                        
                                        // Differentiate groups and group items.
                                        if ($(element).hasClass('multiselect-group')) {
                                            // Remember group status.
                                            currentGroup = element;
                                            currentGroupVisible = showElement;
                                        }
                                        else {
                                            // Show group name when at least one of its items is visible.
                                            if (showElement) {
                                                $(currentGroup).show().removeClass('filter-hidden');
                                            }
                                            
                                            // Show all group items when group name satisfies filter.
                                            if (!showElement && currentGroupVisible) {
                                                $(element).show().removeClass('filter-hidden');
                                            }
                                        }
                                    }
                                }, this));
                            }

                            this.updateSelectAll();
                        }, this), 300, this);
                    }, this));
                }
            }
        },

        /**
         * Unbinds the whole plugin.
         */
        destroy: function() {
            clearTimeout(this.filterTimeout);

            this.$container.remove();
            this.$select[0].style.display = '';
            this.$select.removeClass('multiselect-initialized');
            this.$select.data('multiselect', null);
        },

        /**
         * Refreshs the multiselect based on the selected options of the select.
         */
        refresh: function() {
            // Nothing to sync until the list exists — it is built from the current
            // <select> state whenever the dropdown first opens.
            if (!this.optionsBuilt) {
                this.updateButtonText();

                return;
            }

            $('option', this.$select).each($.proxy(function(index, element) {
                this.syncOption($(element), $('li input[value=\'' + $(element).val() + '\']', this.$ul));
            }, this));

            this.updateButtonText();
            this.updateSelectAll();
        },

        syncOption: function($option, $input) {
            var isSelected = $option.is(':selected');

            $input.prop('checked', isSelected);

            if (this.options.selectedClass) {
                $input.closest('li').toggleClass(this.options.selectedClass, isSelected);
            }

            $input.prop('disabled', $option.is(':disabled'))
                .closest('li')
                .toggleClass('disabled', $option.is(':disabled'));
        },

        refreshOption: function(value) {
            if (!this.optionsBuilt) {
                return;
            }

            var $option = $('option[value="' + value + '"]', this.$select);
            var $input = $('li input[value="' + value + '"]', this.$ul);

            if (!$option.length || !$input.length) {
                return;
            }

            this.syncOption($option, $input);
        },

        /**
         * Select all options of the given values.
         * 
         * If triggerOnChange is set to true, the on change event is triggered if
         * and only if one value is passed.
         * 
         * @param {Array} selectValues
         * @param {Boolean} triggerOnChange
         */
        select: function(selectValues, triggerOnChange) {
            if(!$.isArray(selectValues)) {
                selectValues = [selectValues];
            }

            for (var i = 0; i < selectValues.length; i++) {
                var value = selectValues[i];

                if (value === null || value === undefined) {
                    continue;
                }

                var $option = this.getOptionByValue(value);
                var $checkbox = this.getInputByValue(value);

                if($option === undefined || (this.optionsBuilt && $checkbox === undefined)) {
                    continue;
                }

                if (!this.options.multiple) {
                    this.deselectAll(false);
                }

                if ($checkbox) {
                    if (this.options.selectedClass) {
                        $checkbox.closest('li')
                            .addClass(this.options.selectedClass);
                    }

                    $checkbox.prop('checked', true);
                }

                $option.prop('selected', true);
                
                if (triggerOnChange) {
                    this.options.onChange($option, true);
                }
            }

            this.updateButtonText();
            this.updateSelectAll();
        },

        /**
         * Clears all selected items.
         */
        clearSelection: function () {
            this.deselectAll(false);
            this.updateButtonText();
            this.updateSelectAll();
        },

        /**
         * Deselects all options of the given values.
         * 
         * If triggerOnChange is set to true, the on change event is triggered, if
         * and only if one value is passed.
         * 
         * @param {Array} deselectValues
         * @param {Boolean} triggerOnChange
         */
        deselect: function(deselectValues, triggerOnChange) {
            if(!$.isArray(deselectValues)) {
                deselectValues = [deselectValues];
            }

            for (var i = 0; i < deselectValues.length; i++) {
                var value = deselectValues[i];

                if (value === null || value === undefined) {
                    continue;
                }

                var $option = this.getOptionByValue(value);
                var $checkbox = this.getInputByValue(value);

                if($option === undefined || (this.optionsBuilt && $checkbox === undefined)) {
                    continue;
                }

                if ($checkbox) {
                    if (this.options.selectedClass) {
                        $checkbox.closest('li')
                            .removeClass(this.options.selectedClass);
                    }

                    $checkbox.prop('checked', false);
                }

                $option.prop('selected', false);
                
                if (triggerOnChange) {
                    this.options.onChange($option, false);
                }
            }

            this.updateButtonText();
            this.updateSelectAll();
        },
        
        /**
         * Selects all enabled & visible options.
         *
         * If justVisible is true or not specified, only visible options are selected.
         *
         * @param {Boolean} justVisible
         * @param {Boolean} triggerOnSelectAll
         */
        selectAll: function (justVisible, triggerOnSelectAll) {
            var justVisible = typeof justVisible === 'undefined' ? true : justVisible;
            var allCheckboxes = this.getOptionCheckboxes();
            var visibleCheckboxes = this.getOptionCheckboxes(true);
            var allCheckboxesCount = allCheckboxes.length;
            var visibleCheckboxesCount = visibleCheckboxes.length;
            
            if(justVisible) {
                visibleCheckboxes.prop('checked', true);
                $("li:not(.divider):not(.disabled)", this.$ul).filter(":visible").addClass(this.options.selectedClass);
            }
            else {
                allCheckboxes.prop('checked', true);
                $("li:not(.divider):not(.disabled)", this.$ul).addClass(this.options.selectedClass);
            }
                
            if (allCheckboxesCount === visibleCheckboxesCount || justVisible === false) {
                $("option:enabled", this.$select).prop('selected', true);
            }
            else {
                var values = visibleCheckboxes.map(function() {
                    return $(this).val();
                }).get();
                
                $("option:enabled", this.$select).filter(function(index) {
                    return $.inArray($(this).val(), values) !== -1;
                }).prop('selected', true);
            }
            
            if (triggerOnSelectAll) {
                this.options.onSelectAll();
            }
        },

        /**
         * Deselects all options.
         * 
         * If justVisible is true or not specified, only visible options are deselected.
         * 
         * @param {Boolean} justVisible
         */
        deselectAll: function (justVisible) {
            var justVisible = typeof justVisible === 'undefined' ? true : justVisible;
            
            if(justVisible) {
                var visibleCheckboxes = this.getOptionCheckboxes(true);
                visibleCheckboxes.prop('checked', false);

                var values = visibleCheckboxes.map(function() {
                    return $(this).val();
                }).get();

                $("option:enabled", this.$select).filter(function(index) {
                    return $.inArray($(this).val(), values) !== -1;
                }).prop('selected', false);

                if (this.options.selectedClass) {
                    $("li:not(.divider):not(.disabled)", this.$ul).filter(":visible").removeClass(this.options.selectedClass);
                }
            }
            else {
                this.getOptionCheckboxes().prop('checked', false);
                $("option:enabled", this.$select).prop('selected', false);

                if (this.options.selectedClass) {
                    $("li:not(.divider):not(.disabled)", this.$ul).removeClass(this.options.selectedClass);
                }
            }
        },

        /**
         * Rebuild the plugin.
         * 
         * Rebuilds the dropdown, the filter and the select all option.
         */
        rebuild: function() {
            this.$ul.html('');
            this.optionsBuilt = false;

            this.$button.attr('aria-required', this.$select.is('[data-val-required]') ? 'true' : null);

            // Important to distinguish between radios and checkboxes.
            this.options.multiple = this.$select.attr('multiple') === "multiple";

            this.buildSelectAll();
            this.buildSelectButtons();

            // Only the initial build is deferred. A rebuild is an explicit request from page
            // code that usually reads the resulting items straight away.
            this.ensureDropdownOptions();

            this.updateButtonText();
            this.updateSelectAll();

            if (this.options.disableIfEmpty && $('option', this.$select).length <= 0) {
                this.disable();
            }
            else {
                this.enable();
            }
            
            if (this.options.dropRight) {
                this.$ul.addClass('pull-right dropdown-menu-end');
            }
        },

        /**
         * The provided data will be used to build the dropdown.
         */
        dataprovider: function(dataprovider) {
            
            var groupCounter = 0;
            var $select = this.$select.empty();
            
            $.each(dataprovider, function (index, option) {
                var $tag;
                
                if ($.isArray(option.children)) { // create optiongroup tag
                    groupCounter++;
                    
                    $tag = $('<optgroup/>').attr({
                        label: option.label || 'Group ' + groupCounter,
                        disabled: !!option.disabled
                    });
                    
                    forEach(option.children, function(subOption) { // add children option tags
                        $tag.append($('<option/>').attr({
                            value: subOption.value,
                            label: subOption.label || subOption.value,
                            title: subOption.title,
                            selected: !!subOption.selected,
                            disabled: !!subOption.disabled
                        }));
                    });
                }
                else {
                    $tag = $('<option/>').attr({
                        value: option.value,
                        label: option.label || option.value,
                        title: option.title,
                        selected: !!option.selected,
                        disabled: !!option.disabled
                    });
                }
                
                $select.append($tag);
            });
            
            this.rebuild();
        },

        /**
         * Enable the multiselect.
         */
        enable: function() {
            this.$select.prop('disabled', false);
            this.$button.prop('disabled', false)
                .removeClass('disabled');
        },

        /**
         * Disable the multiselect.
         */
        disable: function() {
            this.$select.prop('disabled', true);
            this.$button.prop('disabled', true)
                .addClass('disabled');
        },

        /**
         * Set the options.
         *
         * @param {Array} options
         */
        setOptions: function(options) {
            this.options = this.mergeOptions(options);
        },

        /**
         * Merges the given options with the default options.
         *
         * @param {Array} options
         * @returns {Array}
         */
        mergeOptions: function(options) {
            return $.extend(true, {}, this.defaults, this.options, options);
        },

        /**
         * Checks whether a select all checkbox is present.
         *
         * @returns {Boolean}
         */
        hasSelectAll: function() {
            return $('li.multiselect-all', this.$ul).length > 0;
        },

        /**
         * Updates the select all checkbox based on the currently displayed and selected checkboxes.
         */
        updateSelectAll: function() {
            const visibleBoxes = this.getOptionCheckboxes(true);
            const allVisibleChecked = visibleBoxes.length > 0
                && visibleBoxes.toArray().every(cb => cb.checked);

            $('input.multiselect-selectall-input', this.$container).prop('checked', allVisibleChecked);

            if (this.hasSelectAll()) {
                const selectAllLi = $("li.multiselect-all", this.$ul);
                const selectAllInput = selectAllLi.find("input");

                if (allVisibleChecked) {
                    selectAllInput.prop("checked", true);
                    selectAllLi.addClass(this.options.selectedClass);
                    this.options.onSelectAll();
                }
                else {
                    selectAllInput.prop("checked", false);
                    selectAllLi.removeClass(this.options.selectedClass);
                }
            }
        },

        /**
         * Update the button text and its title based on the currently selected options.
         */
        updateButtonText: function() {
            var options = this.getSelected();
            
            // First update the displayed button text.
            if (this.options.enableHTML) {
                $('.multiselect .multiselect-selected-text', this.$container).html(this.options.buttonText(options, this.$select));
            }
            else {
                $('.multiselect .multiselect-selected-text', this.$container).text(this.options.buttonText(options, this.$select));
            }
            
            // Now update the title attribute of the button.
            $('.multiselect', this.$container).attr('title', this.options.buttonTitle(options, this.$select));
        },

        /**
         * Get all selected options.
         *
         * @returns {jQUery}
         */
        getSelected: function() {
            // selectedOptions avoids walking every option, which dominates on a long list.
            return $(this.$select[0].selectedOptions);
        },

        /**
         * Get the enabled option checkboxes in the dropdown (excludes the header select-all checkbox).
         *
         * @param {Boolean} visibleOnly - when true, restricts to currently visible checkboxes
         * @returns {jQuery}
         */
        getOptionCheckboxes: function(visibleOnly) {
            var cbs = $("li input[type='checkbox']:enabled", this.$ul).not(".multiselect-selectall-input");
            return visibleOnly ? cbs.filter(":visible") : cbs;
        },

        /**
         * Gets a select option by its value.
         *
         * @param {String} value
         * @returns {jQuery}
         */
        getOptionByValue: function (value) {

            var options = $('option', this.$select);
            var valueToCompare = value.toString();

            for (var i = 0; i < options.length; i = i + 1) {
                var option = options[i];
                if (option.value === valueToCompare) {
                    return $(option);
                }
            }
        },

        /**
         * Get the input (radio/checkbox) by its value.
         *
         * @param {String} value
         * @returns {jQuery}
         */
        getInputByValue: function (value) {

            var checkboxes = $('li input', this.$ul);
            var valueToCompare = value.toString();

            for (var i = 0; i < checkboxes.length; i = i + 1) {
                var checkbox = checkboxes[i];
                if (checkbox.value === valueToCompare) {
                    return $(checkbox);
                }
            }
        },

        asyncFunction: function(callback, timeout, self) {
            var args = Array.prototype.slice.call(arguments, 3);
            return setTimeout(function() {
                callback.apply(self || window, args);
            }, timeout);
        },

        setAllSelectedText: function(allSelectedText) {
            this.options.allSelectedText = allSelectedText;
            this.updateButtonText();
        }
    };

    $.fn.multiselect = function(option, parameter, extraOptions) {
        return this.each(function() {
            var data = $(this).data('multiselect');
            var options = typeof option === 'object' && option;

            // Initialize the multiselect.
            if (!data) {
                data = new Multiselect(this, options);
                $(this).data('multiselect', data);
            }

            // Call multiselect method.
            if (typeof option === 'string') {
                data[option](parameter, extraOptions);
                
                if (option === 'destroy') {
                    $(this).data('multiselect', false);
                }
            }
        });
    };

    $.fn.multiselect.Constructor = Multiselect;

    $(function() {
        $("select[data-role=multiselect]").multiselect();
    });

}(window.jQuery);

/* =========================================================
 * bootstrap-datepicker.js
 * Repo: https://github.com/uxsolutions/bootstrap-datepicker/
 * Demo: https://eternicode.github.io/bootstrap-datepicker/
 * Docs: https://bootstrap-datepicker.readthedocs.org/
 * =========================================================
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

(function (factory)
{
    if (typeof define === "function" && define.amd)
    {
        define(["jquery"], factory);
    } else if (typeof exports === 'object')
    {
        factory(require('jquery'));
    } else
    {
        factory(jQuery);
    }
}(function ($, undefined)
{
    function UTCDate()
    {
        return new Date(Date.UTC.apply(Date, arguments));
    }
    function UTCToday()
    {
        var today = new Date();
        return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
    }
    function isUTCEquals(date1, date2)
    {
        return (
			date1.getUTCFullYear() === date2.getUTCFullYear() &&
			date1.getUTCMonth() === date2.getUTCMonth() &&
			date1.getUTCDate() === date2.getUTCDate()
		);
    }
    function alias(method, deprecationMsg)
    {
        return function ()
        {
            if (deprecationMsg !== undefined)
            {
                $.fn.datepicker.deprecated(deprecationMsg);
            }

            return this[method].apply(this, arguments);
        };
    }
    function isValidDate(d)
    {
        return d && !isNaN(d.getTime());
    }

    var DateArray = (function ()
    {
        var extras = {
            get: function (i)
            {
                return this.slice(i)[0];
            },
            contains: function (d)
            {
                // Array.indexOf is not cross-browser;
                // $.inArray doesn't work with Dates
                var val = d && d.valueOf();
                for (var i = 0, l = this.length; i < l; i++)
                    // Use date arithmetic to allow dates with different times to match
                    if (0 <= this[i].valueOf() - val && this[i].valueOf() - val < 1000 * 60 * 60 * 24)
                        return i;
                return -1;
            },
            remove: function (i)
            {
                this.splice(i, 1);
            },
            replace: function (new_array)
            {
                if (!new_array)
                    return;
                if (!$.isArray(new_array))
                    new_array = [new_array];
                this.clear();
                this.push.apply(this, new_array);
            },
            clear: function ()
            {
                this.length = 0;
            },
            copy: function ()
            {
                var a = new DateArray();
                a.replace(this);
                return a;
            }
        };

        return function ()
        {
            var a = [];
            a.push.apply(a, arguments);
            $.extend(a, extras);
            return a;
        };
    })();


    // Picker object

    var Datepicker = function (element, options)
    {
        $.data(element, 'datepicker', this);
        this._process_options(options);

        this.dates = new DateArray();
        this.viewDate = this.o.defaultViewDate;
        this.focusDate = null;

        this.element = $(element);
        this.isInput = this.element.is('input');
        this.inputField = this.isInput ? this.element : this.element.find('input');
        this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn, .input-group-text') : false;
        if (this.component && this.component.length === 0)
            this.component = false;
        this.isInline = !this.component && this.element.is('div');

        this.picker = $(DPGlobal.template);

        // Checking templates and inserting
        if (this._check_template(this.o.templates.leftArrow))
        {
            this.picker.find('.prev').html(this.o.templates.leftArrow);
        }

        if (this._check_template(this.o.templates.rightArrow))
        {
            this.picker.find('.next').html(this.o.templates.rightArrow);
        }

        this._buildEvents();
        this._attachEvents();

        if (this.isInline)
        {
            this.picker.addClass('datepicker-inline').appendTo(this.element);
        }
        else
        {
            this.picker.addClass('datepicker-dropdown dropdown-menu');
        }

        if (this.o.rtl)
        {
            this.picker.addClass('datepicker-rtl');
        }

        if (this.o.calendarWeeks)
        {
            this.picker.find('.datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear')
				.attr('colspan', function (i, val)
				{
				    return Number(val) + 1;
				});
        }

        this._process_options({
            startDate: this._o.startDate,
            endDate: this._o.endDate,
            daysOfWeekDisabled: this.o.daysOfWeekDisabled,
            daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
            datesDisabled: this.o.datesDisabled
        });

        this._allow_update = false;
        this.setViewMode(this.o.startView);
        this._allow_update = true;

        this.fillDow();
        this.fillMonths();

        this.update();

        if (this.isInline)
        {
            this.show();
        }
    };

    Datepicker.prototype = {
        constructor: Datepicker,

        _resolveViewName: function (view)
        {
            $.each(DPGlobal.viewModes, function (i, viewMode)
            {
                if (view === i || $.inArray(view, viewMode.names) !== -1)
                {
                    view = i;
                    return false;
                }
            });

            return view;
        },

        _resolveDaysOfWeek: function (daysOfWeek)
        {
            if (!$.isArray(daysOfWeek))
                daysOfWeek = daysOfWeek.split(/[,\s]*/);
            return $.map(daysOfWeek, Number);
        },

        _check_template: function (tmp)
        {
            try
            {
                // If empty
                if (tmp === undefined || tmp === "")
                {
                    return false;
                }
                // If no html, everything ok
                if ((tmp.match(/[<>]/g) || []).length <= 0)
                {
                    return true;
                }
                // Checking if html is fine
                var jDom = $(tmp);
                return jDom.length > 0;
            }
            catch (ex)
            {
                return false;
            }
        },

        _process_options: function (opts)
        {
            // Store raw options for reference
            this._o = $.extend({}, this._o, opts);
            // Processed options
            var o = this.o = $.extend({}, this._o);

            // Check if "de-DE" style date is available, if not language should
            // fallback to 2 letter code eg "de"
            var lang = o.language;
            if (!dates[lang])
            {
                lang = lang.split('-')[0];
                if (!dates[lang])
                    lang = defaults.language;
            }
            o.language = lang;

            // Retrieve view index from any aliases
            o.startView = this._resolveViewName(o.startView);
            o.minViewMode = this._resolveViewName(o.minViewMode);
            o.maxViewMode = this._resolveViewName(o.maxViewMode);

            // Check view is between min and max
            o.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, o.startView));

            // true, false, or Number > 0
            if (o.multidate !== true)
            {
                o.multidate = Number(o.multidate) || false;
                if (o.multidate !== false)
                    o.multidate = Math.max(0, o.multidate);
            }
            o.multidateSeparator = String(o.multidateSeparator);

            o.weekStart %= 7;
            o.weekEnd = (o.weekStart + 6) % 7;

            var format = DPGlobal.parseFormat(o.format);
            if (o.startDate !== -Infinity)
            {
                if (!!o.startDate)
                {
                    if (o.startDate instanceof Date)
                        o.startDate = this._local_to_utc(this._zero_time(o.startDate));
                    else
                        o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
                }
                else
                {
                    o.startDate = -Infinity;
                }
            }
            if (o.endDate !== Infinity)
            {
                if (!!o.endDate)
                {
                    if (o.endDate instanceof Date)
                        o.endDate = this._local_to_utc(this._zero_time(o.endDate));
                    else
                        o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
                }
                else
                {
                    o.endDate = Infinity;
                }
            }

            o.daysOfWeekDisabled = this._resolveDaysOfWeek(o.daysOfWeekDisabled || []);
            o.daysOfWeekHighlighted = this._resolveDaysOfWeek(o.daysOfWeekHighlighted || []);

            o.datesDisabled = o.datesDisabled || [];
            if (!$.isArray(o.datesDisabled))
            {
                o.datesDisabled = o.datesDisabled.split(',');
            }
            o.datesDisabled = $.map(o.datesDisabled, function (d)
            {
                return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
            });

            var plc = String(o.orientation).toLowerCase().split(/\s+/g),
				_plc = o.orientation.toLowerCase();
            plc = $.grep(plc, function (word)
            {
                return /^auto|left|right|top|bottom$/.test(word);
            });
            o.orientation = { x: 'auto', y: 'auto' };
            if (!_plc || _plc === 'auto')
                ; // no action
            else if (plc.length === 1)
            {
                switch (plc[0])
                {
                    case 'top':
                    case 'bottom':
                        o.orientation.y = plc[0];
                        break;
                    case 'left':
                    case 'right':
                        o.orientation.x = plc[0];
                        break;
                }
            }
            else
            {
                _plc = $.grep(plc, function (word)
                {
                    return /^left|right$/.test(word);
                });
                o.orientation.x = _plc[0] || 'auto';

                _plc = $.grep(plc, function (word)
                {
                    return /^top|bottom$/.test(word);
                });
                o.orientation.y = _plc[0] || 'auto';
            }
            if (o.defaultViewDate instanceof Date || typeof o.defaultViewDate === 'string')
            {
                o.defaultViewDate = DPGlobal.parseDate(o.defaultViewDate, format, o.language, o.assumeNearbyYear);
            } else if (o.defaultViewDate)
            {
                var year = o.defaultViewDate.year || new Date().getFullYear();
                var month = o.defaultViewDate.month || 0;
                var day = o.defaultViewDate.day || 1;
                o.defaultViewDate = UTCDate(year, month, day);
            } else
            {
                o.defaultViewDate = UTCToday();
            }
        },
        _events: [],
        _secondaryEvents: [],
        _applyEvents: function (evs)
        {
            for (var i = 0, el, ch, ev; i < evs.length; i++)
            {
                el = evs[i][0];
                if (evs[i].length === 2)
                {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3)
                {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.on(ev, ch);
            }
        },
        _unapplyEvents: function (evs)
        {
            for (var i = 0, el, ev, ch; i < evs.length; i++)
            {
                el = evs[i][0];
                if (evs[i].length === 2)
                {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3)
                {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.off(ev, ch);
            }
        },
        _buildEvents: function ()
        {
            var events = {
                keyup: $.proxy(function (e)
                {
                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
                        this.update();
                }, this),
                keydown: $.proxy(this.keydown, this),
                paste: $.proxy(this.paste, this)
            };

            if (this.o.showOnFocus === true)
            {
                events.focus = $.proxy(this.show, this);
            }

            if (this.isInput)
            { // single input
                this._events = [
                    [this.element, events]
                ];
            }
                // component: input + button
            else if (this.component && this.inputField.length)
            {
                this._events = [
                    // For components that are not readonly, allow keyboard nav
                    [this.inputField, events],
                    [this.component, {
                        click: $.proxy(this.show, this)
                    }]
                ];
            }
            else
            {
                this._events = [
					[this.element, {
					    click: $.proxy(this.show, this),
					    keydown: $.proxy(this.keydown, this)
					}]
                ];
            }
            this._events.push(
				// Component: listen for blur on element descendants
				[this.element, '*', {
				    blur: $.proxy(function (e)
				    {
				        this._focused_from = e.target;
				    }, this)
				}],
				// Input: listen for blur on element
				[this.element, {
				    blur: $.proxy(function (e)
				    {
				        this._focused_from = e.target;
				    }, this)
				}]
			);

            if (this.o.immediateUpdates)
            {
                // Trigger input updates immediately on changed year/month
                this._events.push([this.element, {
                    'changeYear changeMonth': $.proxy(function (e)
                    {
                        this.update(e.date);
                    }, this)
                }]);
            }

            this._secondaryEvents = [
				[this.picker, {
				    click: $.proxy(this.click, this)
				}],
				[this.picker, '.prev, .next', {
				    click: $.proxy(this.navArrowsClick, this)
				}],
				[$(window), {
				    resize: $.proxy(this.place, this)
				}],
				[$(document), {
				    'mousedown touchstart': $.proxy(function (e)
				    {
				        // Clicked outside the datepicker, hide it
				        if (!(
							this.element.is(e.target) ||
							this.element.find(e.target).length ||
							this.picker.is(e.target) ||
							this.picker.find(e.target).length ||
							this.isInline
						))
				        {
				            this.hide();
				        }
				    }, this)
				}]
            ];
        },
        _attachEvents: function ()
        {
            this._detachEvents();
            this._applyEvents(this._events);
        },
        _detachEvents: function ()
        {
            this._unapplyEvents(this._events);
        },
        _attachSecondaryEvents: function ()
        {
            this._detachSecondaryEvents();
            this._applyEvents(this._secondaryEvents);
        },
        _detachSecondaryEvents: function ()
        {
            this._unapplyEvents(this._secondaryEvents);
        },
        _trigger: function (event, altdate)
        {
            var date = altdate || this.dates.get(-1),
				local_date = this._utc_to_local(date);

            this.element.trigger({
                type: event,
                date: local_date,
                viewMode: this.viewMode,
                dates: $.map(this.dates, this._utc_to_local),
                format: $.proxy(function (ix, format)
                {
                    if (arguments.length === 0)
                    {
                        ix = this.dates.length - 1;
                        format = this.o.format;
                    } else if (typeof ix === 'string')
                    {
                        format = ix;
                        ix = this.dates.length - 1;
                    }
                    format = format || this.o.format;
                    var date = this.dates.get(ix);
                    return DPGlobal.formatDate(date, format, this.o.language);
                }, this)
            });
        },

        show: function ()
        {
            if (this.inputField.prop('disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
                return;
            if (!this.isInline)
                this.picker.appendTo(this.o.container);
            this.place();
            this.picker.show();
            this._attachSecondaryEvents();
            this._trigger('show');
            if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard)
            {
                $(this.element).blur();
            }
            return this;
        },

        hide: function ()
        {
            if (this.isInline || !this.picker.is(':visible'))
                return this;
            this.focusDate = null;
            this.picker.hide().detach();
            this._detachSecondaryEvents();
            this.setViewMode(this.o.startView);

            if (this.o.forceParse && this.inputField.val())
                this.setValue();
            this._trigger('hide');
            return this;
        },

        destroy: function ()
        {
            this.hide();
            this._detachEvents();
            this._detachSecondaryEvents();
            this.picker.remove();
            delete this.element.data().datepicker;
            if (!this.isInput)
            {
                delete this.element.data().date;
            }
            return this;
        },

        paste: function (e)
        {
            var dateString;
            if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types
				&& $.inArray('text/plain', e.originalEvent.clipboardData.types) !== -1)
            {
                dateString = e.originalEvent.clipboardData.getData('text/plain');
            } else if (window.clipboardData)
            {
                dateString = window.clipboardData.getData('Text');
            } else
            {
                return;
            }
            this.setDate(dateString);
            this.update();
            e.preventDefault();
        },

        _utc_to_local: function (utc)
        {
            if (!utc)
            {
                return utc;
            }

            var local = new Date(utc.getTime() + (utc.getTimezoneOffset() * 60000));

            if (local.getTimezoneOffset() !== utc.getTimezoneOffset())
            {
                local = new Date(utc.getTime() + (local.getTimezoneOffset() * 60000));
            }

            return local;
        },
        _local_to_utc: function (local)
        {
            return local && new Date(local.getTime() - (local.getTimezoneOffset() * 60000));
        },
        _zero_time: function (local)
        {
            return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
        },
        _zero_utc_time: function (utc)
        {
            return utc && UTCDate(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
        },

        getDates: function ()
        {
            return $.map(this.dates, this._utc_to_local);
        },

        getUTCDates: function ()
        {
            return $.map(this.dates, function (d)
            {
                return new Date(d);
            });
        },

        getDate: function ()
        {
            return this._utc_to_local(this.getUTCDate());
        },

        getUTCDate: function ()
        {
            var selected_date = this.dates.get(-1);
            if (selected_date !== undefined)
            {
                return new Date(selected_date);
            } else
            {
                return null;
            }
        },

        clearDates: function ()
        {
            this.inputField.val('');
            this.update();
            this._trigger('changeDate');

            if (this.o.autoclose)
            {
                this.hide();
            }
        },

        setDates: function ()
        {
            var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
            this.update.apply(this, args);
            this._trigger('changeDate');
            this.setValue();
            return this;
        },

        setUTCDates: function ()
        {
            var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
            this.setDates.apply(this, $.map(args, this._utc_to_local));
            return this;
        },

        setDate: alias('setDates'),
        setUTCDate: alias('setUTCDates'),
        remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead'),

        setValue: function ()
        {
            var formatted = this.getFormattedDate();
            this.inputField.val(formatted);
            return this;
        },

        getFormattedDate: function (format)
        {
            if (format === undefined)
                format = this.o.format;

            var lang = this.o.language;
            return $.map(this.dates, function (d)
            {
                return DPGlobal.formatDate(d, format, lang);
            }).join(this.o.multidateSeparator);
        },

        getStartDate: function ()
        {
            return this.o.startDate;
        },

        setStartDate: function (startDate)
        {
            this._process_options({ startDate: startDate });
            this.update();
            this.updateNavArrows();
            return this;
        },

        getEndDate: function ()
        {
            return this.o.endDate;
        },

        setEndDate: function (endDate)
        {
            this._process_options({ endDate: endDate });
            this.update();
            this.updateNavArrows();
            return this;
        },

        setDaysOfWeekDisabled: function (daysOfWeekDisabled)
        {
            this._process_options({ daysOfWeekDisabled: daysOfWeekDisabled });
            this.update();
            return this;
        },

        setDaysOfWeekHighlighted: function (daysOfWeekHighlighted)
        {
            this._process_options({ daysOfWeekHighlighted: daysOfWeekHighlighted });
            this.update();
            return this;
        },

        setDatesDisabled: function (datesDisabled)
        {
            this._process_options({ datesDisabled: datesDisabled });
            this.update();
            return this;
        },

        place: function ()
        {
            if (this.isInline)
                return this;
            var calendarWidth = this.picker.outerWidth(),
				calendarHeight = this.picker.outerHeight(),
				visualPadding = 10,
				container = $(this.o.container),
				windowWidth = container.width(),
				scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
                scrollHeight = this.o.container === 'body' ? $(document).outerHeight() : container.outerHeight(),
				appendOffset = container.offset();

            var parentsZindex = [0];
            this.element.parents().each(function ()
            {
                var itemZIndex = $(this).css('z-index');
                if (itemZIndex !== 'auto' && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
            });
            var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;

            var referencePoint = this.component ? this.component.parent() : this.element;
            var offset = referencePoint.offset();

            if (!offset.left)
            {
                referencePoint = this.element.parent();

                offset = referencePoint.offset();;
            }

            var height = referencePoint.outerHeight(false);
            var width = referencePoint.outerWidth(false);
            var left = offset.left - appendOffset.left;
            var top = offset.top - appendOffset.top;

            if (this.o.container !== 'body')
            {
                top += scrollTop;
            }

            this.picker.removeClass(
				'datepicker-orient-top datepicker-orient-bottom ' +
				'datepicker-orient-right datepicker-orient-left'
			);

            if (this.o.orientation.x !== 'auto')
            {
                this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
                if (this.o.orientation.x === 'right')
                    left -= calendarWidth - width;
            }
                // auto x orientation is best-placement: if it crosses a window
                // edge, fudge it sideways
            else
            {
                if (offset.left < 0)
                {
                    // component is outside the window on the left side. Move it into visible range
                    this.picker.addClass('datepicker-orient-left');
                    left -= offset.left - visualPadding;
                } else if (left + calendarWidth > windowWidth)
                {
                    // the calendar passes the widow right edge. Align it to component right side
                    this.picker.addClass('datepicker-orient-right');
                    left += width - calendarWidth;
                } else
                {
                    if (this.o.rtl)
                    {
                        // Default to right
                        this.picker.addClass('datepicker-orient-right');
                    } else
                    {
                        // Default to left
                        this.picker.addClass('datepicker-orient-left');
                    }
                }
            }

            // auto y orientation is best-situation: top or bottom, no fudging,
            // decision based on which shows more of the calendar
            var yorient = this.o.orientation.y,
				top_overflow;
            if (yorient === 'auto')
            {
                top_overflow = -scrollTop + top - calendarHeight;
                var bottom_overflow = scrollHeight + scrollTop - top - calendarHeight;

                yorient = bottom_overflow > 0 || top_overflow < 0 ? 'bottom' : 'top';
            }

            this.picker.addClass('datepicker-orient-' + yorient);
            if (yorient === 'top')
                top -= calendarHeight + parseInt(this.picker.css('padding-top'));
            else
                top += height;

            if (this.o.rtl)
            {
                var right = windowWidth - (left + width);
                this.picker.css({
                    top: top,
                    right: right,
                    zIndex: zIndex
                });
            } else
            {
                this.picker.css({
                    top: top,
                    left: left,
                    zIndex: zIndex
                });
            }
            return this;
        },

        _allow_update: true,
        update: function ()
        {
            if (!this._allow_update)
                return this;

            var oldDates = this.dates.copy(),
				dates = [],
                fromArgs = false,
                viewOnly = false;

            if (arguments.length)
            {
                $.each(arguments, $.proxy(function (i, date)
                {
                    if (date === true)
                    {
                        viewOnly = true;
                    }
                    else
                    {
                        if (date instanceof Date)
                            date = this._local_to_utc(date);
                        dates.push(date);
                    }
                }, this));
                fromArgs = true;
            } else
            {
                dates = this.isInput
						? this.element.val()
						: this.element.data('date') || this.inputField.val();
                if (dates && this.o.multidate)
                    dates = dates.split(this.o.multidateSeparator);
                else
                    dates = [dates];
                delete this.element.data().date;
            }

            dates = $.map(dates, $.proxy(function (date)
            {
                return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
            }, this));
            dates = $.grep(dates, $.proxy(function (date)
            {
                return (
					!this.dateWithinRange(date) ||
					!date
				);
            }, this), true);
            this.dates.replace(dates);

            if (this.o.updateViewDate && (this.dates.length || this.o.keepEmptyValues))
            {
                if (this.dates.length)
                    this.viewDate = new Date(this.dates.get(-1));
                else if (this.viewDate < this.o.startDate)
                    this.viewDate = new Date(this.o.startDate);
                else if (this.viewDate > this.o.endDate)
                    this.viewDate = new Date(this.o.endDate);
                else
                    this.viewDate = this.o.defaultViewDate;
            }

            if (viewOnly != true)
            {
                if (fromArgs)
                {
                    // setting date by clicking
                    this.setValue();
                    this.element.change();
                }
                else if (this.dates.length)
                {
                    // setting date by typing
                    if (String(oldDates) !== String(this.dates) && fromArgs)
                    {
                        this._trigger('changeDate');
                        this.element.change();
                    }
                }
                if (!this.dates.length && oldDates.length && !this.o.keepEmptyValues)
                {
                    this._trigger('clearDate');
                    this.element.change();
                }
            }

            this.fill();
            return this;
        },

        fillDow: function ()
        {
            if (this.o.showWeekDays)
            {
                var dowCnt = this.o.weekStart,
                    html = '<tr>';
                if (this.o.calendarWeeks)
                {
                    html += '<th class="cw">&#160;</th>';
                }
                while (dowCnt < this.o.weekStart + 7)
                {
                    html += '<th class="dow';
                    if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) !== -1)
                        html += ' disabled';
                    html += '">' + dates[this.o.language].daysMin[(dowCnt++) % 7] + '</th>';
                }
                html += '</tr>';
                this.picker.find('.datepicker-days thead').append(html);
            }
        },

        fillMonths: function ()
        {
            var localDate = this._utc_to_local(this.viewDate);
            var html = '';
            var focused;
            var today = UTCToday();
            
            for (var i = 0; i < 12; i++)
            {
                focused = localDate && localDate.getMonth() === i ? ' focused' : '';

                if (this.o.todayHighlight && localDate.getUTCFullYear() == today.getUTCFullYear() && i == today.getUTCMonth())
                    focused += " today";

                html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i] + '</span>';
            }
            this.picker.find('.datepicker-months td').html(html);
        },

        setRange: function (range)
        {
            if (!range || !range.length)
                delete this.range;
            else
                this.range = $.map(range, function (d)
                {
                    return d.valueOf();
                });
            this.fill();
        },

        getClassNames: function (date)
        {
            var cls = [],
				year = this.viewDate.getUTCFullYear(),
				month = this.viewDate.getUTCMonth(),
				today = UTCToday();
            if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month))
            {
                cls.push('old');
            } else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month))
            {
                cls.push('new');
            }
            if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
                cls.push('focused');
            // Compare internal UTC date with UTC today, not local today
            if (this.o.todayHighlight && isUTCEquals(date, today))
            {
                cls.push('today');
            }
            if (this.dates.contains(date) !== -1)
                cls.push('active');
            if (!this.dateWithinRange(date))
            {
                cls.push('disabled');
            }
            if (this.dateIsDisabled(date))
            {
                cls.push('disabled', 'disabled-date');
            }
            if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1)
            {
                cls.push('highlighted');
            }

            if (this.range)
            {
                if (date > this.range[0] && date < this.range[this.range.length - 1])
                {
                    cls.push('range');
                }
                if ($.inArray(date.valueOf(), this.range) !== -1)
                {
                    cls.push('selected');
                }
                if (date.valueOf() === this.range[0])
                {
                    cls.push('range-start');
                }
                if (date.valueOf() === this.range[this.range.length - 1])
                {
                    cls.push('range-end');
                }
            }
            return cls;
        },

        _fill_yearsView: function (selector, cssClass, factor, year, startYear, endYear, beforeFn)
        {
            var html = '';
            var step = factor / 10;
            var view = this.picker.find(selector);
            var startVal = Math.floor(year / factor) * factor;
            var endVal = startVal + step * 9;
            var focusedVal = Math.floor(this.viewDate.getFullYear() / step) * step;
            var todayVal = Math.floor(UTCToday().getUTCFullYear() / step) * step;

            var selected = $.map(this.dates, function (d)
            {
                return Math.floor(d.getUTCFullYear() / step) * step;
            });

            var classes, tooltip, before;
            for (var currVal = startVal - step; currVal <= endVal + step; currVal += step)
            {
                classes = [cssClass];
                tooltip = null;

                if (currVal === startVal - step)
                {
                    classes.push('old');
                } else if (currVal === endVal + step)
                {
                    classes.push('new');
                }
                if ($.inArray(currVal, selected) !== -1)
                {
                    classes.push('active');
                }
                if (currVal < startYear || currVal > endYear)
                {
                    classes.push('disabled');
                }
                if (currVal === focusedVal)
                {
                    classes.push('focused');
                }
                if (this.o.todayHighlight && currVal === todayVal)
                {
                    classes.push('today');
                }

                if (beforeFn !== $.noop)
                {
                    before = beforeFn(new Date(currVal, 0, 1));
                    if (before === undefined)
                    {
                        before = {};
                    } else if (typeof before === 'boolean')
                    {
                        before = { enabled: before };
                    } else if (typeof before === 'string')
                    {
                        before = { classes: before };
                    }
                    if (before.enabled === false)
                    {
                        classes.push('disabled');
                    }
                    if (before.classes)
                    {
                        classes = classes.concat(before.classes.split(/\s+/));
                    }
                    if (before.tooltip)
                    {
                        tooltip = before.tooltip;
                    }
                }

                html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + currVal + '</span>';
            }

            view.find('.datepicker-switch').text(startVal + '-' + endVal);
            view.find('td').html(html);
        },

        fill: function ()
        {
            var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				todaytxt = dates[this.o.language].today || dates['en'].today || '',
				cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
				titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
				tooltip,
				before;
            if (isNaN(year) || isNaN(month))
                return;
            this.picker.find('.datepicker-days .datepicker-switch')
						.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
            this.picker.find('tfoot .today')
						.text(todaytxt)
						.toggle(this.o.todayBtn !== false);
            this.picker.find('tfoot .clear')
						.text(cleartxt)
						.toggle(this.o.clearBtn !== false);
            this.picker.find('thead .datepicker-title')
						.text(this.o.title)
						.toggle(this.o.title !== '');
            this.updateNavArrows();
            this.fillMonths();
            var prevMonth = UTCDate(year, month, 0),
				day = prevMonth.getUTCDate();
            prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
            var nextMonth = new Date(prevMonth);
            if (prevMonth.getUTCFullYear() < 100)
            {
                nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
            }
            nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
            nextMonth = nextMonth.valueOf();
            var html = [];
            var weekDay, clsName;
            while (prevMonth.valueOf() < nextMonth)
            {
                weekDay = prevMonth.getUTCDay();
                if (weekDay === this.o.weekStart)
                {
                    html.push('<tr>');
                    if (this.o.calendarWeeks)
                    {
                        // ISO 8601: First week contains first thursday.
                        // ISO also states week starts on Monday, but we can be more abstract here.
                        var
							// Start of current week: based on weekstart/current date
							ws = new Date(+prevMonth + (this.o.weekStart - weekDay - 7) % 7 * 864e5),
							// Thursday of this week
							th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
							// First Thursday of year, year from thursday
							yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
							// Calendar week: ms between thursdays, div ms per day, div 7 days
							calWeek = (th - yth) / 864e5 / 7 + 1;
                        html.push('<td class="cw">' + calWeek + '</td>');
                    }
                }
                clsName = this.getClassNames(prevMonth);
                clsName.push('day');

                var content = prevMonth.getUTCDate();

                if (this.o.beforeShowDay !== $.noop)
                {
                    before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
                    if (before === undefined)
                        before = {};
                    else if (typeof before === 'boolean')
                        before = { enabled: before };
                    else if (typeof before === 'string')
                        before = { classes: before };
                    if (before.enabled === false)
                        clsName.push('disabled');
                    if (before.classes)
                        clsName = clsName.concat(before.classes.split(/\s+/));
                    if (before.tooltip)
                        tooltip = before.tooltip;
                    if (before.content)
                        content = before.content;
                }

                //Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
                //Fallback to unique function for older jquery versions
                if ($.isFunction($.uniqueSort))
                {
                    clsName = $.uniqueSort(clsName);
                } else
                {
                    clsName = $.unique(clsName);
                }

                html.push('<td class="' + clsName.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + (this.o.dateCells ? ' data-date="' + (prevMonth.getTime().toString()) + '"' : '') + '>' + content + '</td>');
                tooltip = null;
                if (weekDay === this.o.weekEnd)
                {
                    html.push('</tr>');
                }
                prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
            }
            this.picker.find('.datepicker-days tbody').html(html.join(''));

            var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
            var months = this.picker.find('.datepicker-months')
						.find('.datepicker-switch')
							.text(this.o.maxViewMode < 2 ? monthsTitle : year)
							.end()
						.find('tbody span').removeClass('active');

            $.each(this.dates, function (i, d)
            {
                if (d.getUTCFullYear() === year)
                    months.eq(d.getUTCMonth()).addClass('active');
            });

            if (year < startYear || year > endYear)
            {
                months.addClass('disabled');
            }
            if (year === startYear)
            {
                months.slice(0, startMonth).addClass('disabled');
            }
            if (year === endYear)
            {
                months.slice(endMonth + 1).addClass('disabled');
            }

            if (this.o.beforeShowMonth !== $.noop)
            {
                var that = this;
                $.each(months, function (i, month)
                {
                    var moDate = new Date(year, i, 1);
                    var before = that.o.beforeShowMonth(moDate);
                    if (before === undefined)
                        before = {};
                    else if (typeof before === 'boolean')
                        before = { enabled: before };
                    else if (typeof before === 'string')
                        before = { classes: before };
                    if (before.enabled === false && !$(month).hasClass('disabled'))
                        $(month).addClass('disabled');
                    if (before.classes)
                        $(month).addClass(before.classes);
                    if (before.tooltip)
                        $(month).prop('title', before.tooltip);
                });
            }

            // Generating decade/years picker
            this._fill_yearsView(
				'.datepicker-years',
				'year',
				10,
				year,
				startYear,
				endYear,
				this.o.beforeShowYear
			);

            // Generating century/decades picker
            this._fill_yearsView(
				'.datepicker-decades',
				'decade',
				100,
				year,
				startYear,
				endYear,
				this.o.beforeShowDecade
			);

            // Generating millennium/centuries picker
            this._fill_yearsView(
				'.datepicker-centuries',
				'century',
				1000,
				year,
				startYear,
				endYear,
				this.o.beforeShowCentury
			);
        },

        updateNavArrows: function ()
        {
            if (!this._allow_update)
                return;

            var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				prevIsDisabled,
				nextIsDisabled,
				factor = 1;
            switch (this.viewMode)
            {
                case 0:
                    prevIsDisabled = year <= startYear && month <= startMonth;
                    nextIsDisabled = year >= endYear && month >= endMonth;
                    break;
                case 4:
                    factor *= 10;
                    /* falls through */
                case 3:
                    factor *= 10;
                    /* falls through */
                case 2:
                    factor *= 10;
                    /* falls through */
                case 1:
                    prevIsDisabled = Math.floor(year / factor) * factor <= startYear;
                    nextIsDisabled = Math.floor(year / factor) * factor + factor >= endYear;
                    break;
            }

            this.picker.find('.prev').toggleClass('disabled', prevIsDisabled);
            this.picker.find('.next').toggleClass('disabled', nextIsDisabled);
        },

        click: function (e)
        {
            e.preventDefault();
            e.stopPropagation();

            var target, dir, day, year, month;
            target = $(e.target);

            // Clicked on the switch
            if (target.hasClass('datepicker-switch') && this.viewMode !== this.o.maxViewMode)
            {
                this.setViewMode(this.viewMode + 1);
            }

            // Clicked on today button (in footer, not a today-highlighted month/year/decade/century span)
            if (target.hasClass('today') && !target.hasClass('day') && !target.hasClass('month')
                && !target.hasClass('year') && !target.hasClass('decade') && !target.hasClass('century')
                && this.o.minViewMode == 0)
            {
                this.setViewMode(0);
                this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
            }

            // Clicked on clear button
            if (target.hasClass('clear'))
            {
                this.clearDates();
            }

            // Allow clicking on elements inside a day
            var findOuter = target.closest('.day');

            if (findOuter.length)
                target = findOuter;

            if (!target.hasClass('disabled'))
            {
                // Clicked on a day
                if (target.hasClass('day'))
                {
                    day = Number(target.text());
                    year = this.viewDate.getUTCFullYear();
                    month = this.viewDate.getUTCMonth();

                    if (target.hasClass('old') || target.hasClass('new'))
                    {
                        dir = target.hasClass('old') ? -1 : 1;
                        month = (month + dir + 12) % 12;
                        if ((dir === -1 && month === 11) || (dir === 1 && month === 0))
                        {
                            year += dir;
                            if (this.o.updateViewDate)
                            {
                                this._trigger('changeYear', this.viewDate);
                            }
                        }
                        if (this.o.updateViewDate)
                        {
                            this._trigger('changeMonth', this.viewDate);
                        }
                    }
                    this._setDate(UTCDate(year, month, day));
                }

                // Clicked on a month, year, decade, century
                if (target.hasClass('month')
						|| target.hasClass('year')
						|| target.hasClass('decade')
						|| target.hasClass('century'))
                {
                    this.viewDate.setUTCDate(1);

                    day = 1;
                    if (this.viewMode === 1)
                    {
                        month = target.parent().find('span').index(target);
                        year = this.viewDate.getUTCFullYear();
                        this.viewDate.setUTCMonth(month);
                    } else
                    {
                        month = 0;
                        year = Number(target.text());
                        this.viewDate.setUTCFullYear(year);
                    }

                    this._trigger(DPGlobal.viewModes[this.viewMode - 1].e, this.viewDate);

                    if (this.viewMode === this.o.minViewMode)
                    {
                        this._setDate(UTCDate(year, month, day));
                    } else
                    {
                        this.setViewMode(this.viewMode - 1);
                        this.fill();
                    }
                }
            }

            if (this.picker.is(':visible') && this._focused_from)
            {
                this._focused_from.focus();
            }
            delete this._focused_from;
        },

        // Clicked on prev or next
        navArrowsClick: function (e)
        {
            var target = $(e.target);

            if (target.hasClass('disabled'))
                return;

            var dir = target.hasClass('prev') ? -1 : 1;
            if (this.viewMode !== 0)
            {
                dir *= DPGlobal.viewModes[this.viewMode].navStep * 12;
            }
            this.viewDate = this.moveMonth(this.viewDate, dir);
            this._trigger(DPGlobal.viewModes[this.viewMode].e, this.viewDate);
            this.fill();
        },

        _toggle_multidate: function (date)
        {
            var ix = this.dates.contains(date);
            if (!date)
            {
                this.dates.clear();
            }

            if (ix !== -1)
            {
                if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive)
                {
                    this.dates.remove(ix);
                }
            } else if (this.o.multidate === false)
            {
                this.dates.clear();
                this.dates.push(date);
            }
            else
            {
                this.dates.push(date);
            }

            if (typeof this.o.multidate === 'number')
                while (this.dates.length > this.o.multidate)
                    this.dates.remove(0);
        },

        _setDate: function (date, which)
        {
            if (!which || which === 'date')
                this._toggle_multidate(date && new Date(date));
            if ((!which && this.o.updateViewDate) || which === 'view')
                this.viewDate = date && new Date(date);

            this.fill();
            this.setValue();
            if (!which || which !== 'view')
            {
                this._trigger('changeDate');
            }
            this.inputField.trigger('change');
            if (this.o.autoclose && (!which || which === 'date'))
            {
                this.hide();
            }
        },

        moveDay: function (date, dir)
        {
            var newDate = new Date(date);
            newDate.setUTCDate(date.getUTCDate() + dir);

            return newDate;
        },

        moveWeek: function (date, dir)
        {
            return this.moveDay(date, dir * 7);
        },

        moveMonth: function (date, dir)
        {
            if (!isValidDate(date))
                return this.o.defaultViewDate;
            if (!dir)
                return date;
            var new_date = new Date(date.valueOf()),
				day = new_date.getUTCDate(),
				month = new_date.getUTCMonth(),
				mag = Math.abs(dir),
				new_month, test;
            dir = dir > 0 ? 1 : -1;
            if (mag === 1)
            {
                test = dir === -1
					// If going back one month, make sure month is not current month
					// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
					? function ()
					{
					    return new_date.getUTCMonth() === month;
					}
					// If going forward one month, make sure month is as expected
					// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
					: function ()
					{
					    return new_date.getUTCMonth() !== new_month;
					};
                new_month = month + dir;
                new_date.setUTCMonth(new_month);
                // Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
                new_month = (new_month + 12) % 12;
            }
            else
            {
                // For magnitudes >1, move one month at a time...
                for (var i = 0; i < mag; i++)
                    // ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
                    new_date = this.moveMonth(new_date, dir);
                // ...then reset the day, keeping it in the new month
                new_month = new_date.getUTCMonth();
                new_date.setUTCDate(day);
                test = function ()
                {
                    return new_month !== new_date.getUTCMonth();
                };
            }
            // Common date-resetting loop -- if date is beyond end of month, make it
            // end of month
            while (test())
            {
                new_date.setUTCDate(--day);
                new_date.setUTCMonth(new_month);
            }
            return new_date;
        },

        moveYear: function (date, dir)
        {
            return this.moveMonth(date, dir * 12);
        },

        moveAvailableDate: function (date, dir, fn)
        {
            do
            {
                date = this[fn](date, dir);

                if (!this.dateWithinRange(date))
                    return false;

                fn = 'moveDay';
            }
            while (this.dateIsDisabled(date));

            return date;
        },

        weekOfDateIsDisabled: function (date)
        {
            return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
        },

        dateIsDisabled: function (date)
        {
            return (
				this.weekOfDateIsDisabled(date) ||
				$.grep(this.o.datesDisabled, function (d)
				{
				    return isUTCEquals(date, d);
				}).length > 0
			);
        },

        dateWithinRange: function (date)
        {
            return date >= this.o.startDate && date <= this.o.endDate;
        },

        keydown: function (e)
        {
            if (!this.picker.is(':visible'))
            {
                if (e.keyCode === 40 || e.keyCode === 27)
                { // allow down to re-show picker
                    this.show();
                    e.stopPropagation();
                }
                return;
            }
            var dateChanged = false,
				dir, newViewDate,
				focusDate = this.focusDate || this.viewDate;
            switch (e.keyCode)
            {
                case 27: // escape
                    if (this.focusDate)
                    {
                        this.focusDate = null;
                        this.viewDate = this.dates.get(-1) || this.viewDate;
                        this.fill();
                    }
                    else
                        this.hide();
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case 37: // left
                case 38: // up
                case 39: // right
                case 40: // down
                    if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
                        break;
                    dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
                    if (this.viewMode === 0)
                    {
                        if (e.ctrlKey)
                        {
                            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');

                            if (newViewDate)
                                this._trigger('changeYear', this.viewDate);
                        } else if (e.shiftKey)
                        {
                            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');

                            if (newViewDate)
                                this._trigger('changeMonth', this.viewDate);
                        } else if (e.keyCode === 37 || e.keyCode === 39)
                        {
                            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
                        } else if (!this.weekOfDateIsDisabled(focusDate))
                        {
                            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
                        }
                    } else if (this.viewMode === 1)
                    {
                        if (e.keyCode === 38 || e.keyCode === 40)
                        {
                            dir = dir * 4;
                        }
                        newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
                    } else if (this.viewMode === 2)
                    {
                        if (e.keyCode === 38 || e.keyCode === 40)
                        {
                            dir = dir * 4;
                        }
                        newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
                    }
                    if (newViewDate)
                    {
                        this.focusDate = this.viewDate = newViewDate;
                        this.setValue();
                        this.fill();
                        e.preventDefault();
                    }
                    break;
                case 13: // enter
                    if (!this.o.forceParse)
                        break;
                    focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
                    if (this.o.keyboardNavigation)
                    {
                        this._toggle_multidate(focusDate);
                        dateChanged = true;
                    }
                    this.focusDate = null;
                    this.viewDate = this.dates.get(-1) || this.viewDate;
                    this.setValue();
                    this.fill();
                    if (this.picker.is(':visible'))
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.o.autoclose)
                            this.hide();
                    }
                    break;
                case 9: // tab
                    this.focusDate = null;
                    this.viewDate = this.dates.get(-1) || this.viewDate;
                    this.fill();
                    this.hide();
                    break;
            }
            if (dateChanged)
            {
                if (this.dates.length)
                    this._trigger('changeDate');
                else
                    this._trigger('clearDate');
                this.inputField.trigger('change');
            }
        },

        setViewMode: function (viewMode)
        {
            this.viewMode = viewMode;
            this.picker
				.children('div')
				.hide()
				.filter('.datepicker-' + DPGlobal.viewModes[this.viewMode].clsName)
					.show();
            this.updateNavArrows();
            this._trigger('changeViewMode', new Date(this.viewDate));
        }
    };

    var DateRangePicker = function (element, options)
    {
        $.data(element, 'datepicker', this);
        this.element = $(element);
        this.inputs = $.map(options.inputs, function (i)
        {
            return i.jquery ? i[0] : i;
        });
        delete options.inputs;

        this.keepEmptyValues = options.keepEmptyValues;
        delete options.keepEmptyValues;

        datepickerPlugin.call($(this.inputs), options)
			.on('changeDate', $.proxy(this.dateUpdated, this));

        this.pickers = $.map(this.inputs, function (i)
        {
            return $.data(i, 'datepicker');
        });
        this.updateDates();
    };
    DateRangePicker.prototype = {
        updateDates: function ()
        {
            this.dates = $.map(this.pickers, function (i)
            {
                return i.getUTCDate();
            });
            this.updateRanges();
        },
        updateRanges: function ()
        {
            var range = $.map(this.dates, function (d)
            {
                return d.valueOf();
            });
            $.each(this.pickers, function (i, p)
            {
                p.setRange(range);
            });
        },
        dateUpdated: function (e)
        {
            // `this.updating` is a workaround for preventing infinite recursion
            // between `changeDate` triggering and `setUTCDate` calling.  Until
            // there is a better mechanism.
            if (this.updating)
                return;
            this.updating = true;

            var dp = $.data(e.target, 'datepicker');

            if (dp === undefined)
            {
                return;
            }

            var new_date = dp.getUTCDate(),
				keep_empty_values = this.keepEmptyValues,
				i = $.inArray(e.target, this.inputs),
				j = i - 1,
				k = i + 1,
				l = this.inputs.length;
            if (i === -1)
                return;

            $.each(this.pickers, function (i, p)
            {
                if (!p.getUTCDate() && (p === dp || !keep_empty_values))
                    p.setUTCDate(new_date);
            });

            if (new_date < this.dates[j])
            {
                // Date being moved earlier/left
                while (j >= 0 && new_date < this.dates[j])
                {
                    this.pickers[j--].setUTCDate(new_date);
                }
            } else if (new_date > this.dates[k])
            {
                // Date being moved later/right
                while (k < l && new_date > this.dates[k])
                {
                    this.pickers[k++].setUTCDate(new_date);
                }
            }
            this.updateDates();

            delete this.updating;
        },
        destroy: function ()
        {
            $.map(this.pickers, function (p) { p.destroy(); });
            $(this.inputs).off('changeDate', this.dateUpdated);
            delete this.element.data().datepicker;
        },
        remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead')
    };

    function opts_from_el(el, prefix)
    {
        // Derive options from element data-attrs
        var data = $(el).data(),
			out = {}, inkey,
			replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
        prefix = new RegExp('^' + prefix.toLowerCase());
        function re_lower(_, a)
        {
            return a.toLowerCase();
        }
        for (var key in data)
            if (prefix.test(key))
            {
                inkey = key.replace(replace, re_lower);
                out[inkey] = data[key];
            }
        return out;
    }

    function opts_from_locale(lang)
    {
        // Derive options from locale plugins
        var out = {};
        // Check if "de-DE" style date is available, if not language should
        // fallback to 2 letter code eg "de"
        if (!dates[lang])
        {
            lang = lang.split('-')[0];
            if (!dates[lang])
                return;
        }
        var d = dates[lang];
        $.each(locale_opts, function (i, k)
        {
            if (k in d)
                out[k] = d[k];
        });
        return out;
    }

    var old = $.fn.datepicker;
    var datepickerPlugin = function (option)
    {
        var args = Array.apply(null, arguments);
        args.shift();
        var internal_return;
        this.each(function ()
        {
            var $this = $(this),
				data = $this.data('datepicker'),
				options = typeof option === 'object' && option;
            if (!data)
            {
                var elopts = opts_from_el(this, 'date'),
					// Preliminary otions
					xopts = $.extend({}, defaults, elopts, options),
					locopts = opts_from_locale(xopts.language),
					// Options priority: js args, data-attrs, locales, defaults
					opts = $.extend({}, defaults, locopts, elopts, options);
                if ($this.hasClass('input-daterange') || opts.inputs)
                {
                    $.extend(opts, {
                        inputs: opts.inputs || $this.find('input').toArray()
                    });
                    data = new DateRangePicker(this, opts);
                }
                else
                {
                    data = new Datepicker(this, opts);
                }
                $this.data('datepicker', data);
            }
            if (typeof option === 'string' && typeof data[option] === 'function')
            {
                internal_return = data[option].apply(data, args);
            }
        });

        if (
			internal_return === undefined ||
			internal_return instanceof Datepicker ||
			internal_return instanceof DateRangePicker
		)
            return this;

        if (this.length > 1)
            throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
        else
            return internal_return;
    };
    $.fn.datepicker = datepickerPlugin;

    var defaults = $.fn.datepicker.defaults = {
        assumeNearbyYear: false,
        autoclose: false,
        beforeShowDay: $.noop,
        beforeShowMonth: $.noop,
        beforeShowYear: $.noop,
        beforeShowDecade: $.noop,
        beforeShowCentury: $.noop,
        calendarWeeks: false,
        clearBtn: false,
        toggleActive: false,
        daysOfWeekDisabled: [],
        daysOfWeekHighlighted: [],
        datesDisabled: [],
        endDate: Infinity,
        forceParse: true,
        format: 'mm/dd/yyyy',
        keepEmptyValues: false,
        keyboardNavigation: true,
        language: 'en',
        minViewMode: 0,
        maxViewMode: 4,
        multidate: false,
        multidateSeparator: ',',
        orientation: "auto",
        rtl: false,
        startDate: -Infinity,
        startView: 0,
        todayBtn: false,
        todayHighlight: false,
        updateViewDate: true,
        weekStart: 0,
        disableTouchKeyboard: false,
        enableOnReadonly: true,
        showOnFocus: true,
        zIndexOffset: 10,
        container: 'body',
        immediateUpdates: false,
        dateCells: false,
        title: '',
        templates: {
            leftArrow: '&#x00AB;',
            rightArrow: '&#x00BB;'
        },
        showWeekDays: true
    };
    var locale_opts = $.fn.datepicker.locale_opts = [
		'format',
		'rtl',
		'weekStart'
    ];
    $.fn.datepicker.Constructor = Datepicker;
    var dates = $.fn.datepicker.dates = {
        en: {
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            today: "Today",
            clear: "Clear",
            titleFormat: "MM yyyy"
        }
    };

    var DPGlobal = {
        viewModes: [
			{
			    names: ['days', 'month'],
			    clsName: 'days',
			    e: 'changeMonth'
			},
			{
			    names: ['months', 'year'],
			    clsName: 'months',
			    e: 'changeYear',
			    navStep: 1
			},
			{
			    names: ['years', 'decade'],
			    clsName: 'years',
			    e: 'changeDecade',
			    navStep: 10
			},
			{
			    names: ['decades', 'century'],
			    clsName: 'decades',
			    e: 'changeCentury',
			    navStep: 100
			},
			{
			    names: ['centuries', 'millennium'],
			    clsName: 'centuries',
			    e: 'changeMillennium',
			    navStep: 1000
			}
        ],
        validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
        nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
        parseFormat: function (format)
        {
            if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
                return format;
            // IE treats \0 as a string end in inputs (truncating the value),
            // so it's a bad format delimiter, anyway
            var separators = format.replace(this.validParts, '\0').split('\0'),
				parts = format.match(this.validParts);
            if (!separators || !separators.length || !parts || parts.length === 0)
            {
                throw new Error("Invalid date format.");
            }
            return { separators: separators, parts: parts };
        },
        parseDate: function (date, format, language, assumeNearby)
        {
            if (!date)
                return undefined;
            if (date instanceof Date)
                return date;
            if (typeof format === 'string')
                format = DPGlobal.parseFormat(format);
            if (format.toValue)
                return format.toValue(date, format, language);
            var fn_map = {
                d: 'moveDay',
                m: 'moveMonth',
                w: 'moveWeek',
                y: 'moveYear'
            },
				dateAliases = {
				    yesterday: '-1d',
				    today: '+0d',
				    tomorrow: '+1d'
				},
				parts, part, dir, i, fn;
            if (date in dateAliases)
            {
                date = dateAliases[date];
            }
            if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(date))
            {
                parts = date.match(/([\-+]\d+)([dmwy])/gi);
                date = new Date();
                for (i = 0; i < parts.length; i++)
                {
                    part = parts[i].match(/([\-+]\d+)([dmwy])/i);
                    dir = Number(part[1]);
                    fn = fn_map[part[2].toLowerCase()];
                    date = Datepicker.prototype[fn](date, dir);
                }
                return Datepicker.prototype._zero_utc_time(date);
            }

            parts = date && date.match(this.nonpunctuation) || [];
            if(parts.length > 0 && parts[parts.length - 1] == "г")
                parts.pop(); // This library is broken with some cyrillic characters

            function applyNearbyYear(year, threshold)
            {
                if (threshold === true)
                    threshold = 10;

                // if year is 2 digits or less, than the user most likely is trying to get a recent century
                if (year < 100)
                {
                    year += 2000;
                    // if the new year is more than threshold years in advance, use last century
                    if (year > ((new Date()).getFullYear() + threshold))
                    {
                        year -= 100;
                    }
                }

                return year;
            }

            var parsed = {},
				setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
				setters_map = {
				    yyyy: function (d, v)
				    {
				        return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
				    },
				    m: function (d, v)
				    {
				        if (isNaN(d))
				            return d;
				        v -= 1;
				        while (v < 0) v += 12;
				        v %= 12;
				        d.setUTCMonth(v);
				        while (d.getUTCMonth() !== v)
				            d.setUTCDate(d.getUTCDate() - 1);
				        return d;
				    },
				    d: function (d, v)
				    {
				        return d.setUTCDate(v);
				    }
				},
				val, filtered;
            setters_map['yy'] = setters_map['yyyy'];
            setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
            setters_map['dd'] = setters_map['d'];
            date = UTCToday();
            var fparts = format.parts.slice();
            // Remove noop parts
            if (parts.length !== fparts.length)
            {
                fparts = $(fparts).filter(function (i, p)
                {
                    return $.inArray(p, setters_order) !== -1;
                }).toArray();
            }
            // Process remainder
            function match_part()
            {
                var m = this.slice(0, parts[i].length),
					p = parts[i].slice(0, m.length);
                return m.toLowerCase() === p.toLowerCase();
            }
            if (parts.length === fparts.length)
            {
                var cnt;
                for (i = 0, cnt = fparts.length; i < cnt; i++)
                {
                    val = parseInt(parts[i], 10);
                    part = fparts[i];
                    if (isNaN(val))
                    {
                        switch (part)
                        {
                            case 'MM':
                                filtered = $(dates[language].months).filter(match_part);
                                val = $.inArray(filtered[0], dates[language].months) + 1;
                                break;
                            case 'M':
                                filtered = $(dates[language].monthsShort).filter(match_part);
                                val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
                                break;
                        }
                    }
                    parsed[part] = val;
                }
                var _date, s;
                for (i = 0; i < setters_order.length; i++)
                {
                    s = setters_order[i];
                    if (s in parsed && !isNaN(parsed[s]))
                    {
                        _date = new Date(date);
                        setters_map[s](_date, parsed[s]);
                        if (!isNaN(_date))
                            date = _date;
                    }
                }
            }
            return date;
        },
        formatDate: function (date, format, language)
        {
            if (!date)
                return '';
            if (typeof format === 'string')
                format = DPGlobal.parseFormat(format);
            if (format.toDisplay)
                return format.toDisplay(date, format, language);
            var val = {
                d: date.getUTCDate(),
                D: dates[language].daysShort[date.getUTCDay()],
                DD: dates[language].days[date.getUTCDay()],
                m: date.getUTCMonth() + 1,
                M: dates[language].monthsShort[date.getUTCMonth()],
                MM: dates[language].months[date.getUTCMonth()],
                yy: date.getUTCFullYear().toString().substring(2),
                yyyy: date.getUTCFullYear()
            };
            val.dd = (val.d < 10 ? '0' : '') + val.d;
            val.mm = (val.m < 10 ? '0' : '') + val.m;
            date = [];
            var seps = $.extend([], format.separators);
            for (var i = 0, cnt = format.parts.length; i <= cnt; i++)
            {
                if (seps.length)
                    date.push(seps.shift());
                date.push(val[format.parts[i]]);
            }
            return date.join('');
        },
        headTemplate: '<thead>' +
			              '<tr>' +
			                '<th colspan="7" class="datepicker-title"></th>' +
			              '</tr>' +
							'<tr>' +
								'<th class="prev">&laquo;</th>' +
								'<th colspan="5" class="datepicker-switch"></th>' +
								'<th class="next">&raquo;</th>' +
							'</tr>' +
						'</thead>',
        contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
        footTemplate: '<tfoot>' +
							'<tr>' +
								'<th colspan="7" class="today"></th>' +
							'</tr>' +
							'<tr>' +
								'<th colspan="7" class="clear"></th>' +
							'</tr>' +
						'</tfoot>'
    };
    DPGlobal.template = '<div class="datepicker">' +
							'<div class="datepicker-days">' +
								'<table class="table-condensed">' +
									DPGlobal.headTemplate +
									'<tbody></tbody>' +
									DPGlobal.footTemplate +
								'</table>' +
							'</div>' +
							'<div class="datepicker-months">' +
								'<table class="table-condensed">' +
									DPGlobal.headTemplate +
									DPGlobal.contTemplate +
									DPGlobal.footTemplate +
								'</table>' +
							'</div>' +
							'<div class="datepicker-years">' +
								'<table class="table-condensed">' +
									DPGlobal.headTemplate +
									DPGlobal.contTemplate +
									DPGlobal.footTemplate +
								'</table>' +
							'</div>' +
							'<div class="datepicker-decades">' +
								'<table class="table-condensed">' +
									DPGlobal.headTemplate +
									DPGlobal.contTemplate +
									DPGlobal.footTemplate +
								'</table>' +
							'</div>' +
							'<div class="datepicker-centuries">' +
								'<table class="table-condensed">' +
									DPGlobal.headTemplate +
									DPGlobal.contTemplate +
									DPGlobal.footTemplate +
								'</table>' +
							'</div>' +
						'</div>';

    $.fn.datepicker.DPGlobal = DPGlobal;


    /* DATEPICKER NO CONFLICT
	* =================== */

    $.fn.datepicker.noConflict = function ()
    {
        $.fn.datepicker = old;
        return this;
    };

    /* DATEPICKER VERSION
	 * =================== */
    $.fn.datepicker.version = '1.7.0-RC1';

    $.fn.datepicker.deprecated = function (msg)
    {
        var console = window.console;
        if (console && console.warn)
        {
            console.warn('DEPRECATED: ' + msg);
        }
    };


    /* DATEPICKER DATA-API
	* ================== */

    $(document).on(
		'focus.datepicker.data-api click.datepicker.data-api',
		'[data-provide="datepicker"]',
		function (e)
		{
		    var $this = $(this);
		    if ($this.data('datepicker'))
		        return;
		    e.preventDefault();
		    // component click requires us to explicitly show it
		    datepickerPlugin.call($this, 'show');
		}
	);
    $(function ()
    {
        datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
    });

}));

/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.4
  * @homepage https://bttstrp.github.io/bootstrap-switch
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license Apache-2.0
  */

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== "undefined") {
    factory(require('jquery'));
  } else {
    var mod = {
      exports: {}
    };
    factory(global.jquery);
    global.bootstrapSwitch = mod.exports;
  }
})(this, function (_jquery) {
  'use strict';

  var _jquery2 = _interopRequireDefault(_jquery);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var $ = _jquery2.default || window.jQuery || window.$;

  function getClasses(options, id) {
    var state = options.state,
        size = options.size,
        disabled = options.disabled,
        readonly = options.readonly,
        indeterminate = options.indeterminate,
        inverse = options.inverse;

    return [state ? 'on' : 'off', size, disabled ? 'disabled' : undefined, readonly ? 'readonly' : undefined, indeterminate ? 'indeterminate' : undefined, inverse ? 'inverse' : undefined, id ? 'id-' + id : undefined].filter(function (v) {
      return v == null;
    });
  }

  function prvgetElementOptions() {
    return {
      state: this.$element.is(':checked'),
      size: this.$element.data('size'),
      animate: this.$element.data('animate'),
      disabled: this.$element.is(':disabled'),
      readonly: this.$element.is('[readonly]'),
      indeterminate: this.$element.data('indeterminate'),
      inverse: this.$element.data('inverse'),
      radioAllOff: this.$element.data('radio-all-off'),
      onColor: this.$element.data('on-color'),
      offColor: this.$element.data('off-color'),
      onText: this.$element.data('on-text'),
      offText: this.$element.data('off-text'),
      labelText: this.$element.data('label-text'),
      handleWidth: this.$element.data('handle-width'),
      labelWidth: this.$element.data('label-width'),
      baseClass: this.$element.data('base-class'),
      wrapperClass: this.$element.data('wrapper-class')
    };
  }

  function prvwidth() {
    var _this = this;

    var $handles = this.$on.add(this.$off).add(this.$label).css('width', '');
    var handleWidth = this.options.handleWidth === 'auto' ? Math.round(Math.max(this.$on.width(), this.$off.width())) : this.options.handleWidth;
    $handles.width(handleWidth);
    this.$label.width(function (index, width) {
      if (_this.options.labelWidth !== 'auto') {
        return _this.options.labelWidth;
      }
      if (width < handleWidth) {
        return handleWidth;
      }
      return width;
    });
    this.privateHandleWidth = this.$on.outerWidth();
    this.privateLabelWidth = this.$label.outerWidth();
    this.$container.width(this.privateHandleWidth * 2 + this.privateLabelWidth);
    return this.$wrapper.width(this.privateHandleWidth + this.privateLabelWidth);
  }

  function prvcontainerPosition() {
    var _this2 = this;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.ope;

    this.$container.css('margin-left', function () {
      var values = [0, '-' + _this2.privateHandleWidth + 'px'];
      if (_this2.options.indeterminate) {
        return '-' + _this2.privateHandleWidth / 2 + 'px';
      }
      if (state) {
        if (_this2.options.inverse) {
          return values[1];
        }
        return values[0];
      }
      if (_this2.options.inverse) {
        return values[0];
      }
      return values[1];
    });
  }

  function prvgetClass(name) {
    return this.options.baseClass + '-' + name;
  }

  function prvinit() {
    var _this3 = this;

    var init = function init() {
      _this3.setPrevOptions();
      prvwidth.call(_this3);
      prvcontainerPosition.call(_this3);
      setTimeout(function () {
        return _this3.options.animate && _this3.$wrapper.addClass(prvgetClass.call(_this3, 'animate'));
      }, 50);
    };
    if (this.$wrapper.is(':visible')) {
      init();
      return;
    }
    var initInterval = window.setInterval(function () {
      return _this3.$wrapper.is(':visible') && (init() || true) && window.clearInterval(initInterval);
    }, 50);
  }

  function prvelementHandlers() {
    var _this4 = this;

    return this.$element.on({
      'setPreviousOptions.bootstrapSwitch': function setPreviousOptionsBootstrapSwitch() {
        return _this4.setPrevOptions();
      },

      'previousState.bootstrapSwitch': function previousStateBootstrapSwitch() {
        _this4.options = _this4.prevOptions;
        if (_this4.options.indeterminate) {
          _this4.$wrapper.addClass(prvgetClass.call(_this4, 'indeterminate'));
        }
        _this4.$element.prop('checked', _this4.options.state).trigger('change.bootstrapSwitch', true);
      },

      'change.bootstrapSwitch': function changeBootstrapSwitch(event, skip) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var state = _this4.$element.is(':checked');
        prvcontainerPosition.call(_this4, state);
        if (state === _this4.options.state) {
          return;
        }
        _this4.options.state = state;
        _this4.$wrapper.toggleClass(prvgetClass.call(_this4, 'off')).toggleClass(prvgetClass.call(_this4, 'on'));
        if (!skip) {
          if (_this4.$element.is(':radio')) {
            $('[name="' + _this4.$element.attr('name') + '"]').not(_this4.$element).prop('checked', false).trigger('change.bootstrapSwitch', true);
          }
          _this4.$element.trigger('switchChange.bootstrapSwitch', [state]);
        }
      },

      'focus.bootstrapSwitch': function focusBootstrapSwitch(event) {
        event.preventDefault();
        _this4.$wrapper.addClass(prvgetClass.call(_this4, 'focused'));
      },

      'blur.bootstrapSwitch': function blurBootstrapSwitch(event) {
        event.preventDefault();
        _this4.$wrapper.removeClass(prvgetClass.call(_this4, 'focused'));
      },

      'keydown.bootstrapSwitch': function keydownBootstrapSwitch(event) {
        if (!event.which || _this4.options.disabled || _this4.options.readonly) {
          return;
        }
        if (event.which === 37 || event.which === 39) {
          event.preventDefault();
          event.stopImmediatePropagation();
          _this4.state(event.which === 39);
        }
      }
    });
  }

  function prvhandleHandlers() {
    var _this5 = this;

    this.$on.on('click.bootstrapSwitch', function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this5.state(false);
      return _this5.$element.trigger('focus.bootstrapSwitch');
    });
    return this.$off.on('click.bootstrapSwitch', function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this5.state(true);
      return _this5.$element.trigger('focus.bootstrapSwitch');
    });
  }

  function prvlabelHandlers() {
    var _this6 = this;

    var dragStart = void 0;
    var dragEnd = void 0;
    var handlers = {
      click: function click(event) {
        event.stopPropagation();
      },


      'mousedown.bootstrapSwitch touchstart.bootstrapSwitch': function mousedownBootstrapSwitchTouchstartBootstrapSwitch(event) {
        if (dragStart || _this6.options.disabled || _this6.options.readonly) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        dragStart = (event.pageX || event.originalEvent.touches[0].pageX) - parseInt(_this6.$container.css('margin-left'), 10);
        if (_this6.options.animate) {
          _this6.$wrapper.removeClass(prvgetClass.call(_this6, 'animate'));
        }
        _this6.$element.trigger('focus.bootstrapSwitch');
      },

      'mousemove.bootstrapSwitch touchmove.bootstrapSwitch': function mousemoveBootstrapSwitchTouchmoveBootstrapSwitch(event) {
        if (dragStart == null) {
          return;
        }
        var difference = (event.pageX || event.originalEvent.touches[0].pageX) - dragStart;
        event.preventDefault();
        if (difference < -_this6.privateHandleWidth || difference > 0) {
          return;
        }
        dragEnd = difference;
        _this6.$container.css('margin-left', dragEnd + 'px');
      },

      'mouseup.bootstrapSwitch touchend.bootstrapSwitch': function mouseupBootstrapSwitchTouchendBootstrapSwitch(event) {
        if (!dragStart) {
          return;
        }
        event.preventDefault();
        if (_this6.options.animate) {
          _this6.$wrapper.addClass(prvgetClass.call(_this6, 'animate'));
        }
        if (dragEnd) {
          var state = dragEnd > -(_this6.privateHandleWidth / 2);
          dragEnd = false;
          _this6.state(_this6.options.inverse ? !state : state);
        } else {
          _this6.state(!_this6.options.state);
        }
        dragStart = false;
      },

      'mouseleave.bootstrapSwitch': function mouseleaveBootstrapSwitch() {
        _this6.$label.trigger('mouseup.bootstrapSwitch');
      }
    };
    this.$label.on(handlers);
  }

  function prvexternalLabelHandler() {
    var _this7 = this;

    var $externalLabel = this.$element.closest('label');
    $externalLabel.on('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.target === $externalLabel[0]) {
        _this7.toggleState();
      }
    });
  }

  function prvformHandler() {
    function isBootstrapSwitch() {
      return $(this).data('bootstrap-switch');
    }

    function performReset() {
      return $(this).bootstrapSwitch('state', this.checked);
    }

    var $form = this.$element.closest('form');
    if ($form.data('bootstrap-switch')) {
      return;
    }
    $form.on('reset.bootstrapSwitch', function () {
      window.setTimeout(function () {
        $form.find('input').filter(isBootstrapSwitch).each(performReset);
      }, 1);
    }).data('bootstrap-switch', true);
  }

  function prvgetClasses(classes) {
    var _this8 = this;

    if (!$.isArray(classes)) {
      return [prvgetClass.call(this, classes)];
    }
    return classes.map(function (v) {
      return prvgetClass.call(_this8, v);
    });
  }

  var BootstrapSwitch = function () {
    function BootstrapSwitch(element) {
      var _this9 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, BootstrapSwitch);

      this.$element = $(element);
      this.options = $.extend({}, $.fn.bootstrapSwitch.defaults, prvgetElementOptions.call(this), options);
      this.prevOptions = {};
      this.$wrapper = $('<div>', {
        class: function _class() {
          return getClasses(_this9.options, _this9.$element.attr('id')).map(function (v) {
            return prvgetClass.call(_this9, v);
          }).concat([_this9.options.baseClass], prvgetClasses.call(_this9, _this9.options.wrapperClass)).join(' ');
        }
      });
      this.$container = $('<div>', { class: prvgetClass.call(this, 'container') });
      this.$on = $('<span>', {
        html: this.options.onText,
        class: prvgetClass.call(this, 'handle-on') + ' ' + prvgetClass.call(this, this.options.onColor)
      });
      this.$off = $('<span>', {
        html: this.options.offText,
        class: prvgetClass.call(this, 'handle-off') + ' ' + prvgetClass.call(this, this.options.offColor)
      });
      this.$label = $('<span>', {
        html: this.options.labelText,
        class: prvgetClass.call(this, 'label')
      });

      this.$element.on('init.bootstrapSwitch', function () {
        return _this9.options.onInit(element);
      });
      this.$element.on('switchChange.bootstrapSwitch', function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (_this9.options.onSwitchChange.apply(element, args) === false) {
          if (_this9.$element.is(':radio')) {
            $('[name="' + _this9.$element.attr('name') + '"]').trigger('previousState.bootstrapSwitch', true);
          } else {
            _this9.$element.trigger('previousState.bootstrapSwitch', true);
          }
        }
      });

      this.$container = this.$element.wrap(this.$container).parent();
      this.$wrapper = this.$container.wrap(this.$wrapper).parent();
      this.$element.before(this.options.inverse ? this.$off : this.$on).before(this.$label).before(this.options.inverse ? this.$on : this.$off);

      if (this.options.indeterminate) {
        this.$element.prop('indeterminate', true);
      }

      prvinit.call(this);
      prvelementHandlers.call(this);
      prvhandleHandlers.call(this);
      prvlabelHandlers.call(this);
      prvformHandler.call(this);
      prvexternalLabelHandler.call(this);
      this.$element.trigger('init.bootstrapSwitch', this.options.state);
    }

    _createClass(BootstrapSwitch, [{
      key: 'setPrevOptions',
      value: function setPrevOptions() {
        this.prevOptions = _extends({}, this.options);
      }
    }, {
      key: 'state',
      value: function state(value, skip) {
        if (typeof value === 'undefined') {
          return this.options.state;
        }
        if (this.options.disabled || this.options.readonly || this.options.state && !this.options.radioAllOff && this.$element.is(':radio')) {
          return this.$element;
        }
        if (this.$element.is(':radio')) {
          $('[name="' + this.$element.attr('name') + '"]').trigger('setPreviousOptions.bootstrapSwitch');
        } else {
          this.$element.trigger('setPreviousOptions.bootstrapSwitch');
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
        }
        this.$element.prop('checked', Boolean(value)).trigger('change.bootstrapSwitch', skip);
        return this.$element;
      }
    }, {
      key: 'toggleState',
      value: function toggleState(skip) {
        if (this.options.disabled || this.options.readonly) {
          return this.$element;
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
          return this.state(true);
        }
        return this.$element.prop('checked', !this.options.state).trigger('change.bootstrapSwitch', skip);
      }
    }, {
      key: 'size',
      value: function size(value) {
        if (typeof value === 'undefined') {
          return this.options.size;
        }
        if (this.options.size != null) {
          this.$wrapper.removeClass(prvgetClass.call(this, this.options.size));
        }
        if (value) {
          this.$wrapper.addClass(prvgetClass.call(this, value));
        }
        prvwidth.call(this);
        prvcontainerPosition.call(this);
        this.options.size = value;
        return this.$element;
      }
    }, {
      key: 'animate',
      value: function animate(value) {
        if (typeof value === 'undefined') {
          return this.options.animate;
        }
        if (this.options.animate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleAnimate();
      }
    }, {
      key: 'toggleAnimate',
      value: function toggleAnimate() {
        this.options.animate = !this.options.animate;
        this.$wrapper.toggleClass(prvgetClass.call(this, 'animate'));
        return this.$element;
      }
    }, {
      key: 'disabled',
      value: function disabled(value) {
        if (typeof value === 'undefined') {
          return this.options.disabled;
        }
        if (this.options.disabled === Boolean(value)) {
          return this.$element;
        }
        return this.toggleDisabled();
      }
    }, {
      key: 'toggleDisabled',
      value: function toggleDisabled() {
        this.options.disabled = !this.options.disabled;
        this.$element.prop('disabled', this.options.disabled);
        this.$wrapper.toggleClass(prvgetClass.call(this, 'disabled'));
        return this.$element;
      }
    }, {
      key: 'readonly',
      value: function readonly(value) {
        if (typeof value === 'undefined') {
          return this.options.readonly;
        }
        if (this.options.readonly === Boolean(value)) {
          return this.$element;
        }
        return this.toggleReadonly();
      }
    }, {
      key: 'toggleReadonly',
      value: function toggleReadonly() {
        this.options.readonly = !this.options.readonly;
        this.$element.prop('readonly', this.options.readonly);
        this.$wrapper.toggleClass(prvgetClass.call(this, 'readonly'));
        return this.$element;
      }
    }, {
      key: 'indeterminate',
      value: function indeterminate(value) {
        if (typeof value === 'undefined') {
          return this.options.indeterminate;
        }
        if (this.options.indeterminate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleIndeterminate();
      }
    }, {
      key: 'toggleIndeterminate',
      value: function toggleIndeterminate() {
        this.options.indeterminate = !this.options.indeterminate;
        this.$element.prop('indeterminate', this.options.indeterminate);
        this.$wrapper.toggleClass(prvgetClass.call(this, 'indeterminate'));
        prvcontainerPosition.call(this);
        return this.$element;
      }
    }, {
      key: 'inverse',
      value: function inverse(value) {
        if (typeof value === 'undefined') {
          return this.options.inverse;
        }
        if (this.options.inverse === Boolean(value)) {
          return this.$element;
        }
        return this.toggleInverse();
      }
    }, {
      key: 'toggleInverse',
      value: function toggleInverse() {
        this.$wrapper.toggleClass(prvgetClass.call(this, 'inverse'));
        var $on = this.$on.clone(true);
        var $off = this.$off.clone(true);
        this.$on.replaceWith($off);
        this.$off.replaceWith($on);
        this.$on = $off;
        this.$off = $on;
        this.options.inverse = !this.options.inverse;
        return this.$element;
      }
    }, {
      key: 'onColor',
      value: function onColor(value) {
        if (typeof value === 'undefined') {
          return this.options.onColor;
        }
        if (this.options.onColor) {
          this.$on.removeClass(prvgetClass.call(this, this.options.onColor));
        }
        this.$on.addClass(prvgetClass.call(this, value));
        this.options.onColor = value;
        return this.$element;
      }
    }, {
      key: 'offColor',
      value: function offColor(value) {
        if (typeof value === 'undefined') {
          return this.options.offColor;
        }
        if (this.options.offColor) {
          this.$off.removeClass(prvgetClass.call(this, this.options.offColor));
        }
        this.$off.addClass(prvgetClass.call(this, value));
        this.options.offColor = value;
        return this.$element;
      }
    }, {
      key: 'onText',
      value: function onText(value) {
        if (typeof value === 'undefined') {
          return this.options.onText;
        }
        this.$on.html(value);
        prvwidth.call(this);
        prvcontainerPosition.call(this);
        this.options.onText = value;
        return this.$element;
      }
    }, {
      key: 'offText',
      value: function offText(value) {
        if (typeof value === 'undefined') {
          return this.options.offText;
        }
        this.$off.html(value);
        prvwidth.call(this);
        prvcontainerPosition.call(this);
        this.options.offText = value;
        return this.$element;
      }
    }, {
      key: 'labelText',
      value: function labelText(value) {
        if (typeof value === 'undefined') {
          return this.options.labelText;
        }
        this.$label.html(value);
        prvwidth.call(this);
        this.options.labelText = value;
        return this.$element;
      }
    }, {
      key: 'handleWidth',
      value: function handleWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.handleWidth;
        }
        this.options.handleWidth = value;
        prvwidth.call(this);
        prvcontainerPosition.call(this);
        return this.$element;
      }
    }, {
      key: 'labelWidth',
      value: function labelWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.labelWidth;
        }
        this.options.labelWidth = value;
        prvwidth.call(this);
        prvcontainerPosition.call(this);
        return this.$element;
      }
    }, {
      key: 'baseClass',
      value: function baseClass() {
        return this.options.baseClass;
      }
    }, {
      key: 'wrapperClass',
      value: function wrapperClass(value) {
        if (typeof value === 'undefined') {
          return this.options.wrapperClass;
        }
        var wrapperClass = value || $.fn.bootstrapSwitch.defaults.wrapperClass;
        this.$wrapper.removeClass(prvgetClasses.call(this, this.options.wrapperClass).join(' '));
        this.$wrapper.addClass(prvgetClasses.call(this, wrapperClass).join(' '));
        this.options.wrapperClass = wrapperClass;
        return this.$element;
      }
    }, {
      key: 'radioAllOff',
      value: function radioAllOff(value) {
        if (typeof value === 'undefined') {
          return this.options.radioAllOff;
        }
        var val = Boolean(value);
        if (this.options.radioAllOff === val) {
          return this.$element;
        }
        this.options.radioAllOff = val;
        return this.$element;
      }
    }, {
      key: 'onInit',
      value: function onInit(value) {
        if (typeof value === 'undefined') {
          return this.options.onInit;
        }
        this.options.onInit = value || $.fn.bootstrapSwitch.defaults.onInit;
        return this.$element;
      }
    }, {
      key: 'onSwitchChange',
      value: function onSwitchChange(value) {
        if (typeof value === 'undefined') {
          return this.options.onSwitchChange;
        }
        this.options.onSwitchChange = value || $.fn.bootstrapSwitch.defaults.onSwitchChange;
        return this.$element;
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        var $form = this.$element.closest('form');
        if ($form.length) {
          $form.off('reset.bootstrapSwitch').removeData('bootstrap-switch');
        }
        this.$container.children().not(this.$element).remove();
        this.$element.unwrap().unwrap().off('.bootstrapSwitch').removeData('bootstrap-switch');
        return this.$element;
      }
    }]);

    return BootstrapSwitch;
  }();

  function bootstrapSwitch(option) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    function reducer(ret, next) {
      var $this = $(next);
      var existingData = $this.data('bootstrap-switch');
      var data = existingData || new BootstrapSwitch(next, option);
      if (!existingData) {
        $this.data('bootstrap-switch', data);
      }
      if (typeof option === 'string') {
        return data[option].apply(data, args);
      }
      return ret;
    }
    return Array.prototype.reduce.call(this, reducer, this);
  }

  $.fn.bootstrapSwitch = bootstrapSwitch;
  $.fn.bootstrapSwitch.Constructor = BootstrapSwitch;
  $.fn.bootstrapSwitch.defaults = {
    state: true,
    size: null,
    animate: true,
    disabled: false,
    readonly: false,
    indeterminate: false,
    inverse: false,
    radioAllOff: false,
    onColor: 'primary',
    offColor: 'default',
    onText: 'ON',
    offText: 'OFF',
    labelText: '&nbsp',
    handleWidth: 'auto',
    labelWidth: 'auto',
    baseClass: 'bootstrap-switch',
    wrapperClass: 'wrapper',
    onInit: function onInit() {},
    onSwitchChange: function onSwitchChange() {}
  };
});

/* flatpickr v4.6.13,, @license MIT */
!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(e="undefined"!=typeof globalThis?globalThis:e||self).flatpickr=n()}(this,(function(){"use strict";var e=function(){return(e=Object.assign||function(e){for(var n,t=1,a=arguments.length;t<a;t++)for(var i in n=arguments[t])Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);return e}).apply(this,arguments)};function n(){for(var e=0,n=0,t=arguments.length;n<t;n++)e+=arguments[n].length;var a=Array(e),i=0;for(n=0;n<t;n++)for(var o=arguments[n],r=0,l=o.length;r<l;r++,i++)a[i]=o[r];return a}var t=["onChange","onClose","onDayCreate","onDestroy","onKeyDown","onMonthChange","onOpen","onParseConfig","onReady","onValueUpdate","onYearChange","onPreCalendarPosition"],a={_disable:[],allowInput:!1,allowInvalidPreload:!1,altFormat:"F j, Y",altInput:!1,altInputClass:"form-control input",animate:"object"==typeof window&&-1===window.navigator.userAgent.indexOf("MSIE"),ariaDateFormat:"F j, Y",autoFillDefaultTime:!0,clickOpens:!0,closeOnSelect:!0,conjunction:", ",dateFormat:"Y-m-d",defaultHour:12,defaultMinute:0,defaultSeconds:0,disable:[],disableMobile:!1,enableSeconds:!1,enableTime:!1,errorHandler:function(e){return"undefined"!=typeof console&&console.warn(e)},getWeek:function(e){var n=new Date(e.getTime());n.setHours(0,0,0,0),n.setDate(n.getDate()+3-(n.getDay()+6)%7);var t=new Date(n.getFullYear(),0,4);return 1+Math.round(((n.getTime()-t.getTime())/864e5-3+(t.getDay()+6)%7)/7)},hourIncrement:1,ignoredFocusElements:[],inline:!1,locale:"default",minuteIncrement:5,mode:"single",monthSelectorType:"dropdown",nextArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",noCalendar:!1,now:new Date,onChange:[],onClose:[],onDayCreate:[],onDestroy:[],onKeyDown:[],onMonthChange:[],onOpen:[],onParseConfig:[],onReady:[],onValueUpdate:[],onYearChange:[],onPreCalendarPosition:[],plugins:[],position:"auto",positionElement:void 0,prevArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",shorthandCurrentMonth:!1,showMonths:1,static:!1,time_24hr:!1,weekNumbers:!1,wrap:!1},i={weekdays:{shorthand:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],longhand:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},months:{shorthand:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],longhand:["January","February","March","April","May","June","July","August","September","October","November","December"]},daysInMonth:[31,28,31,30,31,30,31,31,30,31,30,31],firstDayOfWeek:0,ordinal:function(e){var n=e%100;if(n>3&&n<21)return"th";switch(n%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th"}},rangeSeparator:" to ",weekAbbreviation:"Wk",scrollTitle:"Scroll to increment",toggleTitle:"Click to toggle",amPM:["AM","PM"],yearAriaLabel:"Year",monthAriaLabel:"Month",hourAriaLabel:"Hour",minuteAriaLabel:"Minute",time_24hr:!1},o=function(e,n){return void 0===n&&(n=2),("000"+e).slice(-1*n)},r=function(e){return!0===e?1:0};function l(e,n){var t;return function(){var a=this,i=arguments;clearTimeout(t),t=setTimeout((function(){return e.apply(a,i)}),n)}}var c=function(e){return e instanceof Array?e:[e]};function s(e,n,t){if(!0===t)return e.classList.add(n);e.classList.remove(n)}function d(e,n,t){var a=window.document.createElement(e);return n=n||"",t=t||"",a.className=n,void 0!==t&&(a.textContent=t),a}function u(e){for(;e.firstChild;)e.removeChild(e.firstChild)}function f(e,n){return n(e)?e:e.parentNode?f(e.parentNode,n):void 0}function m(e,n){var t=d("div","numInputWrapper"),a=d("input","numInput "+e),i=d("span","arrowUp"),o=d("span","arrowDown");if(-1===navigator.userAgent.indexOf("MSIE 9.0")?a.type="number":(a.type="text",a.pattern="\\d*"),void 0!==n)for(var r in n)a.setAttribute(r,n[r]);return t.appendChild(a),t.appendChild(i),t.appendChild(o),t}function g(e){try{return"function"==typeof e.composedPath?e.composedPath()[0]:e.target}catch(n){return e.target}}var p=function(){},h=function(e,n,t){return t.months[n?"shorthand":"longhand"][e]},v={D:p,F:function(e,n,t){e.setMonth(t.months.longhand.indexOf(n))},G:function(e,n){e.setHours((e.getHours()>=12?12:0)+parseFloat(n))},H:function(e,n){e.setHours(parseFloat(n))},J:function(e,n){e.setDate(parseFloat(n))},K:function(e,n,t){e.setHours(e.getHours()%12+12*r(new RegExp(t.amPM[1],"i").test(n)))},M:function(e,n,t){e.setMonth(t.months.shorthand.indexOf(n))},S:function(e,n){e.setSeconds(parseFloat(n))},U:function(e,n){return new Date(1e3*parseFloat(n))},W:function(e,n,t){var a=parseInt(n),i=new Date(e.getFullYear(),0,2+7*(a-1),0,0,0,0);return i.setDate(i.getDate()-i.getDay()+t.firstDayOfWeek),i},Y:function(e,n){e.setFullYear(parseFloat(n))},Z:function(e,n){return new Date(n)},d:function(e,n){e.setDate(parseFloat(n))},h:function(e,n){e.setHours((e.getHours()>=12?12:0)+parseFloat(n))},i:function(e,n){e.setMinutes(parseFloat(n))},j:function(e,n){e.setDate(parseFloat(n))},l:p,m:function(e,n){e.setMonth(parseFloat(n)-1)},n:function(e,n){e.setMonth(parseFloat(n)-1)},s:function(e,n){e.setSeconds(parseFloat(n))},u:function(e,n){return new Date(parseFloat(n))},w:p,y:function(e,n){e.setFullYear(2e3+parseFloat(n))}},D={D:"",F:"",G:"(\\d\\d|\\d)",H:"(\\d\\d|\\d)",J:"(\\d\\d|\\d)\\w+",K:"",M:"",S:"(\\d\\d|\\d)",U:"(.+)",W:"(\\d\\d|\\d)",Y:"(\\d{4})",Z:"(.+)",d:"(\\d\\d|\\d)",h:"(\\d\\d|\\d)",i:"(\\d\\d|\\d)",j:"(\\d\\d|\\d)",l:"",m:"(\\d\\d|\\d)",n:"(\\d\\d|\\d)",s:"(\\d\\d|\\d)",u:"(.+)",w:"(\\d\\d|\\d)",y:"(\\d{2})"},w={Z:function(e){return e.toISOString()},D:function(e,n,t){return n.weekdays.shorthand[w.w(e,n,t)]},F:function(e,n,t){return h(w.n(e,n,t)-1,!1,n)},G:function(e,n,t){return o(w.h(e,n,t))},H:function(e){return o(e.getHours())},J:function(e,n){return void 0!==n.ordinal?e.getDate()+n.ordinal(e.getDate()):e.getDate()},K:function(e,n){return n.amPM[r(e.getHours()>11)]},M:function(e,n){return h(e.getMonth(),!0,n)},S:function(e){return o(e.getSeconds())},U:function(e){return e.getTime()/1e3},W:function(e,n,t){return t.getWeek(e)},Y:function(e){return o(e.getFullYear(),4)},d:function(e){return o(e.getDate())},h:function(e){return e.getHours()%12?e.getHours()%12:12},i:function(e){return o(e.getMinutes())},j:function(e){return e.getDate()},l:function(e,n){return n.weekdays.longhand[e.getDay()]},m:function(e){return o(e.getMonth()+1)},n:function(e){return e.getMonth()+1},s:function(e){return e.getSeconds()},u:function(e){return e.getTime()},w:function(e){return e.getDay()},y:function(e){return String(e.getFullYear()).substring(2)}},b=function(e){var n=e.config,t=void 0===n?a:n,o=e.l10n,r=void 0===o?i:o,l=e.isMobile,c=void 0!==l&&l;return function(e,n,a){var i=a||r;return void 0===t.formatDate||c?n.split("").map((function(n,a,o){return w[n]&&"\\"!==o[a-1]?w[n](e,i,t):"\\"!==n?n:""})).join(""):t.formatDate(e,n,i)}},C=function(e){var n=e.config,t=void 0===n?a:n,o=e.l10n,r=void 0===o?i:o;return function(e,n,i,o){if(0===e||e){var l,c=o||r,s=e;if(e instanceof Date)l=new Date(e.getTime());else if("string"!=typeof e&&void 0!==e.toFixed)l=new Date(e);else if("string"==typeof e){var d=n||(t||a).dateFormat,u=String(e).trim();if("today"===u)l=new Date,i=!0;else if(t&&t.parseDate)l=t.parseDate(e,d);else if(/Z$/.test(u)||/GMT$/.test(u))l=new Date(e);else{for(var f=void 0,m=[],g=0,p=0,h="";g<d.length;g++){var w=d[g],b="\\"===w,C="\\"===d[g-1]||b;if(D[w]&&!C){h+=D[w];var M=new RegExp(h).exec(e);M&&(f=!0)&&m["Y"!==w?"push":"unshift"]({fn:v[w],val:M[++p]})}else b||(h+=".")}l=t&&t.noCalendar?new Date((new Date).setHours(0,0,0,0)):new Date((new Date).getFullYear(),0,1,0,0,0,0),m.forEach((function(e){var n=e.fn,t=e.val;return l=n(l,t,c)||l})),l=f?l:void 0}}if(l instanceof Date&&!isNaN(l.getTime()))return!0===i&&l.setHours(0,0,0,0),l;t.errorHandler(new Error("Invalid date provided: "+s))}}};function M(e,n,t){return void 0===t&&(t=!0),!1!==t?new Date(e.getTime()).setHours(0,0,0,0)-new Date(n.getTime()).setHours(0,0,0,0):e.getTime()-n.getTime()}var y=function(e,n,t){return 3600*e+60*n+t},x=864e5;function E(e){var n=e.defaultHour,t=e.defaultMinute,a=e.defaultSeconds;if(void 0!==e.minDate){var i=e.minDate.getHours(),o=e.minDate.getMinutes(),r=e.minDate.getSeconds();n<i&&(n=i),n===i&&t<o&&(t=o),n===i&&t===o&&a<r&&(a=e.minDate.getSeconds())}if(void 0!==e.maxDate){var l=e.maxDate.getHours(),c=e.maxDate.getMinutes();(n=Math.min(n,l))===l&&(t=Math.min(c,t)),n===l&&t===c&&(a=e.maxDate.getSeconds())}return{hours:n,minutes:t,seconds:a}}"function"!=typeof Object.assign&&(Object.assign=function(e){for(var n=[],t=1;t<arguments.length;t++)n[t-1]=arguments[t];if(!e)throw TypeError("Cannot convert undefined or null to object");for(var a=function(n){n&&Object.keys(n).forEach((function(t){return e[t]=n[t]}))},i=0,o=n;i<o.length;i++){var r=o[i];a(r)}return e});function k(p,v){var w={config:e(e({},a),I.defaultConfig),l10n:i};function k(){var e;return(null===(e=w.calendarContainer)||void 0===e?void 0:e.getRootNode()).activeElement||document.activeElement}function T(e){return e.bind(w)}function S(){var e=w.config;!1===e.weekNumbers&&1===e.showMonths||!0!==e.noCalendar&&window.requestAnimationFrame((function(){if(void 0!==w.calendarContainer&&(w.calendarContainer.style.visibility="hidden",w.calendarContainer.style.display="block"),void 0!==w.daysContainer){var n=(w.days.offsetWidth+1)*e.showMonths;w.daysContainer.style.width=n+"px",w.calendarContainer.style.width=n+(void 0!==w.weekWrapper?w.weekWrapper.offsetWidth:0)+"px",w.calendarContainer.style.removeProperty("visibility"),w.calendarContainer.style.removeProperty("display")}}))}function _(e){if(0===w.selectedDates.length){var n=void 0===w.config.minDate||M(new Date,w.config.minDate)>=0?new Date:new Date(w.config.minDate.getTime()),t=E(w.config);n.setHours(t.hours,t.minutes,t.seconds,n.getMilliseconds()),w.selectedDates=[n],w.latestSelectedDateObj=n}void 0!==e&&"blur"!==e.type&&function(e){e.preventDefault();var n="keydown"===e.type,t=g(e),a=t;void 0!==w.amPM&&t===w.amPM&&(w.amPM.textContent=w.l10n.amPM[r(w.amPM.textContent===w.l10n.amPM[0])]);var i=parseFloat(a.getAttribute("min")),l=parseFloat(a.getAttribute("max")),c=parseFloat(a.getAttribute("step")),s=parseInt(a.value,10),d=e.delta||(n?38===e.which?1:-1:0),u=s+c*d;if(void 0!==a.value&&2===a.value.length){var f=a===w.hourElement,m=a===w.minuteElement;u<i?(u=l+u+r(!f)+(r(f)&&r(!w.amPM)),m&&L(void 0,-1,w.hourElement)):u>l&&(u=a===w.hourElement?u-l-r(!w.amPM):i,m&&L(void 0,1,w.hourElement)),w.amPM&&f&&(1===c?u+s===23:Math.abs(u-s)>c)&&(w.amPM.textContent=w.l10n.amPM[r(w.amPM.textContent===w.l10n.amPM[0])]),a.value=o(u)}}(e);var a=w._input.value;O(),ye(),w._input.value!==a&&w._debouncedChange()}function O(){if(void 0!==w.hourElement&&void 0!==w.minuteElement){var e,n,t=(parseInt(w.hourElement.value.slice(-2),10)||0)%24,a=(parseInt(w.minuteElement.value,10)||0)%60,i=void 0!==w.secondElement?(parseInt(w.secondElement.value,10)||0)%60:0;void 0!==w.amPM&&(e=t,n=w.amPM.textContent,t=e%12+12*r(n===w.l10n.amPM[1]));var o=void 0!==w.config.minTime||w.config.minDate&&w.minDateHasTime&&w.latestSelectedDateObj&&0===M(w.latestSelectedDateObj,w.config.minDate,!0),l=void 0!==w.config.maxTime||w.config.maxDate&&w.maxDateHasTime&&w.latestSelectedDateObj&&0===M(w.latestSelectedDateObj,w.config.maxDate,!0);if(void 0!==w.config.maxTime&&void 0!==w.config.minTime&&w.config.minTime>w.config.maxTime){var c=y(w.config.minTime.getHours(),w.config.minTime.getMinutes(),w.config.minTime.getSeconds()),s=y(w.config.maxTime.getHours(),w.config.maxTime.getMinutes(),w.config.maxTime.getSeconds()),d=y(t,a,i);if(d>s&&d<c){var u=function(e){var n=Math.floor(e/3600),t=(e-3600*n)/60;return[n,t,e-3600*n-60*t]}(c);t=u[0],a=u[1],i=u[2]}}else{if(l){var f=void 0!==w.config.maxTime?w.config.maxTime:w.config.maxDate;(t=Math.min(t,f.getHours()))===f.getHours()&&(a=Math.min(a,f.getMinutes())),a===f.getMinutes()&&(i=Math.min(i,f.getSeconds()))}if(o){var m=void 0!==w.config.minTime?w.config.minTime:w.config.minDate;(t=Math.max(t,m.getHours()))===m.getHours()&&a<m.getMinutes()&&(a=m.getMinutes()),a===m.getMinutes()&&(i=Math.max(i,m.getSeconds()))}}A(t,a,i)}}function F(e){var n=e||w.latestSelectedDateObj;n&&n instanceof Date&&A(n.getHours(),n.getMinutes(),n.getSeconds())}function A(e,n,t){void 0!==w.latestSelectedDateObj&&w.latestSelectedDateObj.setHours(e%24,n,t||0,0),w.hourElement&&w.minuteElement&&!w.isMobile&&(w.hourElement.value=o(w.config.time_24hr?e:(12+e)%12+12*r(e%12==0)),w.minuteElement.value=o(n),void 0!==w.amPM&&(w.amPM.textContent=w.l10n.amPM[r(e>=12)]),void 0!==w.secondElement&&(w.secondElement.value=o(t)))}function N(e){var n=g(e),t=parseInt(n.value)+(e.delta||0);(t/1e3>1||"Enter"===e.key&&!/[^\d]/.test(t.toString()))&&ee(t)}function P(e,n,t,a){return n instanceof Array?n.forEach((function(n){return P(e,n,t,a)})):e instanceof Array?e.forEach((function(e){return P(e,n,t,a)})):(e.addEventListener(n,t,a),void w._handlers.push({remove:function(){return e.removeEventListener(n,t,a)}}))}function Y(){De("onChange")}function j(e,n){var t=void 0!==e?w.parseDate(e):w.latestSelectedDateObj||(w.config.minDate&&w.config.minDate>w.now?w.config.minDate:w.config.maxDate&&w.config.maxDate<w.now?w.config.maxDate:w.now),a=w.currentYear,i=w.currentMonth;try{void 0!==t&&(w.currentYear=t.getFullYear(),w.currentMonth=t.getMonth())}catch(e){e.message="Invalid date supplied: "+t,w.config.errorHandler(e)}n&&w.currentYear!==a&&(De("onYearChange"),q()),!n||w.currentYear===a&&w.currentMonth===i||De("onMonthChange"),w.redraw()}function H(e){var n=g(e);~n.className.indexOf("arrow")&&L(e,n.classList.contains("arrowUp")?1:-1)}function L(e,n,t){var a=e&&g(e),i=t||a&&a.parentNode&&a.parentNode.firstChild,o=we("increment");o.delta=n,i&&i.dispatchEvent(o)}function R(e,n,t,a){var i=ne(n,!0),o=d("span",e,n.getDate().toString());return o.dateObj=n,o.$i=a,o.setAttribute("aria-label",w.formatDate(n,w.config.ariaDateFormat)),-1===e.indexOf("hidden")&&0===M(n,w.now)&&(w.todayDateElem=o,o.classList.add("today"),o.setAttribute("aria-current","date")),i?(o.tabIndex=-1,be(n)&&(o.classList.add("selected"),w.selectedDateElem=o,"range"===w.config.mode&&(s(o,"startRange",w.selectedDates[0]&&0===M(n,w.selectedDates[0],!0)),s(o,"endRange",w.selectedDates[1]&&0===M(n,w.selectedDates[1],!0)),"nextMonthDay"===e&&o.classList.add("inRange")))):o.classList.add("flatpickr-disabled"),"range"===w.config.mode&&function(e){return!("range"!==w.config.mode||w.selectedDates.length<2)&&(M(e,w.selectedDates[0])>=0&&M(e,w.selectedDates[1])<=0)}(n)&&!be(n)&&o.classList.add("inRange"),w.weekNumbers&&1===w.config.showMonths&&"prevMonthDay"!==e&&a%7==6&&w.weekNumbers.insertAdjacentHTML("beforeend","<span class='flatpickr-day'>"+w.config.getWeek(n)+"</span>"),De("onDayCreate",o),o}function W(e){e.focus(),"range"===w.config.mode&&oe(e)}function B(e){for(var n=e>0?0:w.config.showMonths-1,t=e>0?w.config.showMonths:-1,a=n;a!=t;a+=e)for(var i=w.daysContainer.children[a],o=e>0?0:i.children.length-1,r=e>0?i.children.length:-1,l=o;l!=r;l+=e){var c=i.children[l];if(-1===c.className.indexOf("hidden")&&ne(c.dateObj))return c}}function J(e,n){var t=k(),a=te(t||document.body),i=void 0!==e?e:a?t:void 0!==w.selectedDateElem&&te(w.selectedDateElem)?w.selectedDateElem:void 0!==w.todayDateElem&&te(w.todayDateElem)?w.todayDateElem:B(n>0?1:-1);void 0===i?w._input.focus():a?function(e,n){for(var t=-1===e.className.indexOf("Month")?e.dateObj.getMonth():w.currentMonth,a=n>0?w.config.showMonths:-1,i=n>0?1:-1,o=t-w.currentMonth;o!=a;o+=i)for(var r=w.daysContainer.children[o],l=t-w.currentMonth===o?e.$i+n:n<0?r.children.length-1:0,c=r.children.length,s=l;s>=0&&s<c&&s!=(n>0?c:-1);s+=i){var d=r.children[s];if(-1===d.className.indexOf("hidden")&&ne(d.dateObj)&&Math.abs(e.$i-s)>=Math.abs(n))return W(d)}w.changeMonth(i),J(B(i),0)}(i,n):W(i)}function K(e,n){for(var t=(new Date(e,n,1).getDay()-w.l10n.firstDayOfWeek+7)%7,a=w.utils.getDaysInMonth((n-1+12)%12,e),i=w.utils.getDaysInMonth(n,e),o=window.document.createDocumentFragment(),r=w.config.showMonths>1,l=r?"prevMonthDay hidden":"prevMonthDay",c=r?"nextMonthDay hidden":"nextMonthDay",s=a+1-t,u=0;s<=a;s++,u++)o.appendChild(R("flatpickr-day "+l,new Date(e,n-1,s),0,u));for(s=1;s<=i;s++,u++)o.appendChild(R("flatpickr-day",new Date(e,n,s),0,u));for(var f=i+1;f<=42-t&&(1===w.config.showMonths||u%7!=0);f++,u++)o.appendChild(R("flatpickr-day "+c,new Date(e,n+1,f%i),0,u));var m=d("div","dayContainer");return m.appendChild(o),m}function U(){if(void 0!==w.daysContainer){u(w.daysContainer),w.weekNumbers&&u(w.weekNumbers);for(var e=document.createDocumentFragment(),n=0;n<w.config.showMonths;n++){var t=new Date(w.currentYear,w.currentMonth,1);t.setMonth(w.currentMonth+n),e.appendChild(K(t.getFullYear(),t.getMonth()))}w.daysContainer.appendChild(e),w.days=w.daysContainer.firstChild,"range"===w.config.mode&&1===w.selectedDates.length&&oe()}}function q(){if(!(w.config.showMonths>1||"dropdown"!==w.config.monthSelectorType)){var e=function(e){return!(void 0!==w.config.minDate&&w.currentYear===w.config.minDate.getFullYear()&&e<w.config.minDate.getMonth())&&!(void 0!==w.config.maxDate&&w.currentYear===w.config.maxDate.getFullYear()&&e>w.config.maxDate.getMonth())};w.monthsDropdownContainer.tabIndex=-1,w.monthsDropdownContainer.innerHTML="";for(var n=0;n<12;n++)if(e(n)){var t=d("option","flatpickr-monthDropdown-month");t.value=new Date(w.currentYear,n).getMonth().toString(),t.textContent=h(n,w.config.shorthandCurrentMonth,w.l10n),t.tabIndex=-1,w.currentMonth===n&&(t.selected=!0),w.monthsDropdownContainer.appendChild(t)}}}function $(){var e,n=d("div","flatpickr-month"),t=window.document.createDocumentFragment();w.config.showMonths>1||"static"===w.config.monthSelectorType?e=d("span","cur-month"):(w.monthsDropdownContainer=d("select","flatpickr-monthDropdown-months"),w.monthsDropdownContainer.setAttribute("aria-label",w.l10n.monthAriaLabel),P(w.monthsDropdownContainer,"change",(function(e){var n=g(e),t=parseInt(n.value,10);w.changeMonth(t-w.currentMonth),De("onMonthChange")})),q(),e=w.monthsDropdownContainer);var a=m("cur-year",{tabindex:"-1"}),i=a.getElementsByTagName("input")[0];i.setAttribute("aria-label",w.l10n.yearAriaLabel),w.config.minDate&&i.setAttribute("min",w.config.minDate.getFullYear().toString()),w.config.maxDate&&(i.setAttribute("max",w.config.maxDate.getFullYear().toString()),i.disabled=!!w.config.minDate&&w.config.minDate.getFullYear()===w.config.maxDate.getFullYear());var o=d("div","flatpickr-current-month");return o.appendChild(e),o.appendChild(a),t.appendChild(o),n.appendChild(t),{container:n,yearElement:i,monthElement:e}}function V(){u(w.monthNav),w.monthNav.appendChild(w.prevMonthNav),w.config.showMonths&&(w.yearElements=[],w.monthElements=[]);for(var e=w.config.showMonths;e--;){var n=$();w.yearElements.push(n.yearElement),w.monthElements.push(n.monthElement),w.monthNav.appendChild(n.container)}w.monthNav.appendChild(w.nextMonthNav)}function z(){w.weekdayContainer?u(w.weekdayContainer):w.weekdayContainer=d("div","flatpickr-weekdays");for(var e=w.config.showMonths;e--;){var n=d("div","flatpickr-weekdaycontainer");w.weekdayContainer.appendChild(n)}return G(),w.weekdayContainer}function G(){if(w.weekdayContainer){var e=w.l10n.firstDayOfWeek,t=n(w.l10n.weekdays.shorthand);e>0&&e<t.length&&(t=n(t.splice(e,t.length),t.splice(0,e)));for(var a=w.config.showMonths;a--;)w.weekdayContainer.children[a].innerHTML="\n      <span class='flatpickr-weekday'>\n        "+t.join("</span><span class='flatpickr-weekday'>")+"\n      </span>\n      "}}function Z(e,n){void 0===n&&(n=!0);var t=n?e:e-w.currentMonth;t<0&&!0===w._hidePrevMonthArrow||t>0&&!0===w._hideNextMonthArrow||(w.currentMonth+=t,(w.currentMonth<0||w.currentMonth>11)&&(w.currentYear+=w.currentMonth>11?1:-1,w.currentMonth=(w.currentMonth+12)%12,De("onYearChange"),q()),U(),De("onMonthChange"),Ce())}function Q(e){return w.calendarContainer.contains(e)}function X(e){if(w.isOpen&&!w.config.inline){var n=g(e),t=Q(n),a=!(n===w.input||n===w.altInput||w.element.contains(n)||e.path&&e.path.indexOf&&(~e.path.indexOf(w.input)||~e.path.indexOf(w.altInput)))&&!t&&!Q(e.relatedTarget),i=!w.config.ignoredFocusElements.some((function(e){return e.contains(n)}));a&&i&&(w.config.allowInput&&w.setDate(w._input.value,!1,w.config.altInput?w.config.altFormat:w.config.dateFormat),void 0!==w.timeContainer&&void 0!==w.minuteElement&&void 0!==w.hourElement&&""!==w.input.value&&void 0!==w.input.value&&_(),w.close(),w.config&&"range"===w.config.mode&&1===w.selectedDates.length&&w.clear(!1))}}function ee(e){if(!(!e||w.config.minDate&&e<w.config.minDate.getFullYear()||w.config.maxDate&&e>w.config.maxDate.getFullYear())){var n=e,t=w.currentYear!==n;w.currentYear=n||w.currentYear,w.config.maxDate&&w.currentYear===w.config.maxDate.getFullYear()?w.currentMonth=Math.min(w.config.maxDate.getMonth(),w.currentMonth):w.config.minDate&&w.currentYear===w.config.minDate.getFullYear()&&(w.currentMonth=Math.max(w.config.minDate.getMonth(),w.currentMonth)),t&&(w.redraw(),De("onYearChange"),q())}}function ne(e,n){var t;void 0===n&&(n=!0);var a=w.parseDate(e,void 0,n);if(w.config.minDate&&a&&M(a,w.config.minDate,void 0!==n?n:!w.minDateHasTime)<0||w.config.maxDate&&a&&M(a,w.config.maxDate,void 0!==n?n:!w.maxDateHasTime)>0)return!1;if(!w.config.enable&&0===w.config.disable.length)return!0;if(void 0===a)return!1;for(var i=!!w.config.enable,o=null!==(t=w.config.enable)&&void 0!==t?t:w.config.disable,r=0,l=void 0;r<o.length;r++){if("function"==typeof(l=o[r])&&l(a))return i;if(l instanceof Date&&void 0!==a&&l.getTime()===a.getTime())return i;if("string"==typeof l){var c=w.parseDate(l,void 0,!0);return c&&c.getTime()===a.getTime()?i:!i}if("object"==typeof l&&void 0!==a&&l.from&&l.to&&a.getTime()>=l.from.getTime()&&a.getTime()<=l.to.getTime())return i}return!i}function te(e){return void 0!==w.daysContainer&&(-1===e.className.indexOf("hidden")&&-1===e.className.indexOf("flatpickr-disabled")&&w.daysContainer.contains(e))}function ae(e){var n=e.target===w._input,t=w._input.value.trimEnd()!==Me();!n||!t||e.relatedTarget&&Q(e.relatedTarget)||w.setDate(w._input.value,!0,e.target===w.altInput?w.config.altFormat:w.config.dateFormat)}function ie(e){var n=g(e),t=w.config.wrap?p.contains(n):n===w._input,a=w.config.allowInput,i=w.isOpen&&(!a||!t),o=w.config.inline&&t&&!a;if(13===e.keyCode&&t){if(a)return w.setDate(w._input.value,!0,n===w.altInput?w.config.altFormat:w.config.dateFormat),w.close(),n.blur();w.open()}else if(Q(n)||i||o){var r=!!w.timeContainer&&w.timeContainer.contains(n);switch(e.keyCode){case 13:r?(e.preventDefault(),_(),fe()):me(e);break;case 27:e.preventDefault(),fe();break;case 8:case 46:t&&!w.config.allowInput&&(e.preventDefault(),w.clear());break;case 37:case 39:if(r||t)w.hourElement&&w.hourElement.focus();else{e.preventDefault();var l=k();if(void 0!==w.daysContainer&&(!1===a||l&&te(l))){var c=39===e.keyCode?1:-1;e.ctrlKey?(e.stopPropagation(),Z(c),J(B(1),0)):J(void 0,c)}}break;case 38:case 40:e.preventDefault();var s=40===e.keyCode?1:-1;w.daysContainer&&void 0!==n.$i||n===w.input||n===w.altInput?e.ctrlKey?(e.stopPropagation(),ee(w.currentYear-s),J(B(1),0)):r||J(void 0,7*s):n===w.currentYearElement?ee(w.currentYear-s):w.config.enableTime&&(!r&&w.hourElement&&w.hourElement.focus(),_(e),w._debouncedChange());break;case 9:if(r){var d=[w.hourElement,w.minuteElement,w.secondElement,w.amPM].concat(w.pluginElements).filter((function(e){return e})),u=d.indexOf(n);if(-1!==u){var f=d[u+(e.shiftKey?-1:1)];e.preventDefault(),(f||w._input).focus()}}else!w.config.noCalendar&&w.daysContainer&&w.daysContainer.contains(n)&&e.shiftKey&&(e.preventDefault(),w._input.focus())}}if(void 0!==w.amPM&&n===w.amPM)switch(e.key){case w.l10n.amPM[0].charAt(0):case w.l10n.amPM[0].charAt(0).toLowerCase():w.amPM.textContent=w.l10n.amPM[0],O(),ye();break;case w.l10n.amPM[1].charAt(0):case w.l10n.amPM[1].charAt(0).toLowerCase():w.amPM.textContent=w.l10n.amPM[1],O(),ye()}(t||Q(n))&&De("onKeyDown",e)}function oe(e,n){if(void 0===n&&(n="flatpickr-day"),1===w.selectedDates.length&&(!e||e.classList.contains(n)&&!e.classList.contains("flatpickr-disabled"))){for(var t=e?e.dateObj.getTime():w.days.firstElementChild.dateObj.getTime(),a=w.parseDate(w.selectedDates[0],void 0,!0).getTime(),i=Math.min(t,w.selectedDates[0].getTime()),o=Math.max(t,w.selectedDates[0].getTime()),r=!1,l=0,c=0,s=i;s<o;s+=x)ne(new Date(s),!0)||(r=r||s>i&&s<o,s<a&&(!l||s>l)?l=s:s>a&&(!c||s<c)&&(c=s));Array.from(w.rContainer.querySelectorAll("*:nth-child(-n+"+w.config.showMonths+") > ."+n)).forEach((function(n){var i,o,s,d=n.dateObj.getTime(),u=l>0&&d<l||c>0&&d>c;if(u)return n.classList.add("notAllowed"),void["inRange","startRange","endRange"].forEach((function(e){n.classList.remove(e)}));r&&!u||(["startRange","inRange","endRange","notAllowed"].forEach((function(e){n.classList.remove(e)})),void 0!==e&&(e.classList.add(t<=w.selectedDates[0].getTime()?"startRange":"endRange"),a<t&&d===a?n.classList.add("startRange"):a>t&&d===a&&n.classList.add("endRange"),d>=l&&(0===c||d<=c)&&(o=a,s=t,(i=d)>Math.min(o,s)&&i<Math.max(o,s))&&n.classList.add("inRange")))}))}}function re(){!w.isOpen||w.config.static||w.config.inline||de()}function le(e){return function(n){var t=w.config["_"+e+"Date"]=w.parseDate(n,w.config.dateFormat),a=w.config["_"+("min"===e?"max":"min")+"Date"];void 0!==t&&(w["min"===e?"minDateHasTime":"maxDateHasTime"]=t.getHours()>0||t.getMinutes()>0||t.getSeconds()>0),w.selectedDates&&(w.selectedDates=w.selectedDates.filter((function(e){return ne(e)})),w.selectedDates.length||"min"!==e||F(t),ye()),w.daysContainer&&(ue(),void 0!==t?w.currentYearElement[e]=t.getFullYear().toString():w.currentYearElement.removeAttribute(e),w.currentYearElement.disabled=!!a&&void 0!==t&&a.getFullYear()===t.getFullYear())}}function ce(){return w.config.wrap?p.querySelector("[data-input]"):p}function se(){"object"!=typeof w.config.locale&&void 0===I.l10ns[w.config.locale]&&w.config.errorHandler(new Error("flatpickr: invalid locale "+w.config.locale)),w.l10n=e(e({},I.l10ns.default),"object"==typeof w.config.locale?w.config.locale:"default"!==w.config.locale?I.l10ns[w.config.locale]:void 0),D.D="("+w.l10n.weekdays.shorthand.join("|")+")",D.l="("+w.l10n.weekdays.longhand.join("|")+")",D.M="("+w.l10n.months.shorthand.join("|")+")",D.F="("+w.l10n.months.longhand.join("|")+")",D.K="("+w.l10n.amPM[0]+"|"+w.l10n.amPM[1]+"|"+w.l10n.amPM[0].toLowerCase()+"|"+w.l10n.amPM[1].toLowerCase()+")",void 0===e(e({},v),JSON.parse(JSON.stringify(p.dataset||{}))).time_24hr&&void 0===I.defaultConfig.time_24hr&&(w.config.time_24hr=w.l10n.time_24hr),w.formatDate=b(w),w.parseDate=C({config:w.config,l10n:w.l10n})}function de(e){if("function"!=typeof w.config.position){if(void 0!==w.calendarContainer){De("onPreCalendarPosition");var n=e||w._positionElement,t=Array.prototype.reduce.call(w.calendarContainer.children,(function(e,n){return e+n.offsetHeight}),0),a=w.calendarContainer.offsetWidth,i=w.config.position.split(" "),o=i[0],r=i.length>1?i[1]:null,l=n.getBoundingClientRect(),c=window.innerHeight-l.bottom,d="above"===o||"below"!==o&&c<t&&l.top>t,u=window.pageYOffset+l.top+(d?-t-2:n.offsetHeight+2);if(s(w.calendarContainer,"arrowTop",!d),s(w.calendarContainer,"arrowBottom",d),!w.config.inline){var f=window.pageXOffset+l.left,m=!1,g=!1;"center"===r?(f-=(a-l.width)/2,m=!0):"right"===r&&(f-=a-l.width,g=!0),s(w.calendarContainer,"arrowLeft",!m&&!g),s(w.calendarContainer,"arrowCenter",m),s(w.calendarContainer,"arrowRight",g);var p=window.document.body.offsetWidth-(window.pageXOffset+l.right),h=f+a>window.document.body.offsetWidth,v=p+a>window.document.body.offsetWidth;if(s(w.calendarContainer,"rightMost",h),!w.config.static)if(w.calendarContainer.style.top=u+"px",h)if(v){var D=function(){for(var e=null,n=0;n<document.styleSheets.length;n++){var t=document.styleSheets[n];if(t.cssRules){try{t.cssRules}catch(e){continue}e=t;break}}return null!=e?e:(a=document.createElement("style"),document.head.appendChild(a),a.sheet);var a}();if(void 0===D)return;var b=window.document.body.offsetWidth,C=Math.max(0,b/2-a/2),M=D.cssRules.length,y="{left:"+l.left+"px;right:auto;}";s(w.calendarContainer,"rightMost",!1),s(w.calendarContainer,"centerMost",!0),D.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after"+y,M),w.calendarContainer.style.left=C+"px",w.calendarContainer.style.right="auto"}else w.calendarContainer.style.left="auto",w.calendarContainer.style.right=p+"px";else w.calendarContainer.style.left=f+"px",w.calendarContainer.style.right="auto"}}}else w.config.position(w,e)}function ue(){w.config.noCalendar||w.isMobile||(q(),Ce(),U())}function fe(){w._input.focus(),-1!==window.navigator.userAgent.indexOf("MSIE")||void 0!==navigator.msMaxTouchPoints?setTimeout(w.close,0):w.close()}function me(e){e.preventDefault(),e.stopPropagation();var n=f(g(e),(function(e){return e.classList&&e.classList.contains("flatpickr-day")&&!e.classList.contains("flatpickr-disabled")&&!e.classList.contains("notAllowed")}));if(void 0!==n){var t=n,a=w.latestSelectedDateObj=new Date(t.dateObj.getTime()),i=(a.getMonth()<w.currentMonth||a.getMonth()>w.currentMonth+w.config.showMonths-1)&&"range"!==w.config.mode;if(w.selectedDateElem=t,"single"===w.config.mode)w.selectedDates=[a];else if("multiple"===w.config.mode){var o=be(a);o?w.selectedDates.splice(parseInt(o),1):w.selectedDates.push(a)}else"range"===w.config.mode&&(2===w.selectedDates.length&&w.clear(!1,!1),w.latestSelectedDateObj=a,w.selectedDates.push(a),0!==M(a,w.selectedDates[0],!0)&&w.selectedDates.sort((function(e,n){return e.getTime()-n.getTime()})));if(O(),i){var r=w.currentYear!==a.getFullYear();w.currentYear=a.getFullYear(),w.currentMonth=a.getMonth(),r&&(De("onYearChange"),q()),De("onMonthChange")}if(Ce(),U(),ye(),i||"range"===w.config.mode||1!==w.config.showMonths?void 0!==w.selectedDateElem&&void 0===w.hourElement&&w.selectedDateElem&&w.selectedDateElem.focus():W(t),void 0!==w.hourElement&&void 0!==w.hourElement&&w.hourElement.focus(),w.config.closeOnSelect){var l="single"===w.config.mode&&!w.config.enableTime,c="range"===w.config.mode&&2===w.selectedDates.length&&!w.config.enableTime;(l||c)&&fe()}Y()}}w.parseDate=C({config:w.config,l10n:w.l10n}),w._handlers=[],w.pluginElements=[],w.loadedPlugins=[],w._bind=P,w._setHoursFromDate=F,w._positionCalendar=de,w.changeMonth=Z,w.changeYear=ee,w.clear=function(e,n){void 0===e&&(e=!0);void 0===n&&(n=!0);w.input.value="",void 0!==w.altInput&&(w.altInput.value="");void 0!==w.mobileInput&&(w.mobileInput.value="");w.selectedDates=[],w.latestSelectedDateObj=void 0,!0===n&&(w.currentYear=w._initialDate.getFullYear(),w.currentMonth=w._initialDate.getMonth());if(!0===w.config.enableTime){var t=E(w.config),a=t.hours,i=t.minutes,o=t.seconds;A(a,i,o)}w.redraw(),e&&De("onChange")},w.close=function(){w.isOpen=!1,w.isMobile||(void 0!==w.calendarContainer&&w.calendarContainer.classList.remove("open"),void 0!==w._input&&w._input.classList.remove("active"));De("onClose")},w.onMouseOver=oe,w._createElement=d,w.createDay=R,w.destroy=function(){void 0!==w.config&&De("onDestroy");for(var e=w._handlers.length;e--;)w._handlers[e].remove();if(w._handlers=[],w.mobileInput)w.mobileInput.parentNode&&w.mobileInput.parentNode.removeChild(w.mobileInput),w.mobileInput=void 0;else if(w.calendarContainer&&w.calendarContainer.parentNode)if(w.config.static&&w.calendarContainer.parentNode){var n=w.calendarContainer.parentNode;if(n.lastChild&&n.removeChild(n.lastChild),n.parentNode){for(;n.firstChild;)n.parentNode.insertBefore(n.firstChild,n);n.parentNode.removeChild(n)}}else w.calendarContainer.parentNode.removeChild(w.calendarContainer);w.altInput&&(w.input.type="text",w.altInput.parentNode&&w.altInput.parentNode.removeChild(w.altInput),delete w.altInput);w.input&&(w.input.type=w.input._type,w.input.classList.remove("flatpickr-input"),w.input.removeAttribute("readonly"));["_showTimeInput","latestSelectedDateObj","_hideNextMonthArrow","_hidePrevMonthArrow","__hideNextMonthArrow","__hidePrevMonthArrow","isMobile","isOpen","selectedDateElem","minDateHasTime","maxDateHasTime","days","daysContainer","_input","_positionElement","innerContainer","rContainer","monthNav","todayDateElem","calendarContainer","weekdayContainer","prevMonthNav","nextMonthNav","monthsDropdownContainer","currentMonthElement","currentYearElement","navigationCurrentMonth","selectedDateElem","config"].forEach((function(e){try{delete w[e]}catch(e){}}))},w.isEnabled=ne,w.jumpToDate=j,w.updateValue=ye,w.open=function(e,n){void 0===n&&(n=w._positionElement);if(!0===w.isMobile){if(e){e.preventDefault();var t=g(e);t&&t.blur()}return void 0!==w.mobileInput&&(w.mobileInput.focus(),w.mobileInput.click()),void De("onOpen")}if(w._input.disabled||w.config.inline)return;var a=w.isOpen;w.isOpen=!0,a||(w.calendarContainer.classList.add("open"),w._input.classList.add("active"),De("onOpen"),de(n));!0===w.config.enableTime&&!0===w.config.noCalendar&&(!1!==w.config.allowInput||void 0!==e&&w.timeContainer.contains(e.relatedTarget)||setTimeout((function(){return w.hourElement.select()}),50))},w.redraw=ue,w.set=function(e,n){if(null!==e&&"object"==typeof e)for(var a in Object.assign(w.config,e),e)void 0!==ge[a]&&ge[a].forEach((function(e){return e()}));else w.config[e]=n,void 0!==ge[e]?ge[e].forEach((function(e){return e()})):t.indexOf(e)>-1&&(w.config[e]=c(n));w.redraw(),ye(!0)},w.setDate=function(e,n,t){void 0===n&&(n=!1);void 0===t&&(t=w.config.dateFormat);if(0!==e&&!e||e instanceof Array&&0===e.length)return w.clear(n);pe(e,t),w.latestSelectedDateObj=w.selectedDates[w.selectedDates.length-1],w.redraw(),j(void 0,n),F(),0===w.selectedDates.length&&w.clear(!1);ye(n),n&&De("onChange")},w.toggle=function(e){if(!0===w.isOpen)return w.close();w.open(e)};var ge={locale:[se,G],showMonths:[V,S,z],minDate:[j],maxDate:[j],positionElement:[ve],clickOpens:[function(){!0===w.config.clickOpens?(P(w._input,"focus",w.open),P(w._input,"click",w.open)):(w._input.removeEventListener("focus",w.open),w._input.removeEventListener("click",w.open))}]};function pe(e,n){var t=[];if(e instanceof Array)t=e.map((function(e){return w.parseDate(e,n)}));else if(e instanceof Date||"number"==typeof e)t=[w.parseDate(e,n)];else if("string"==typeof e)switch(w.config.mode){case"single":case"time":t=[w.parseDate(e,n)];break;case"multiple":t=e.split(w.config.conjunction).map((function(e){return w.parseDate(e,n)}));break;case"range":t=e.split(w.l10n.rangeSeparator).map((function(e){return w.parseDate(e,n)}))}else w.config.errorHandler(new Error("Invalid date supplied: "+JSON.stringify(e)));w.selectedDates=w.config.allowInvalidPreload?t:t.filter((function(e){return e instanceof Date&&ne(e,!1)})),"range"===w.config.mode&&w.selectedDates.sort((function(e,n){return e.getTime()-n.getTime()}))}function he(e){return e.slice().map((function(e){return"string"==typeof e||"number"==typeof e||e instanceof Date?w.parseDate(e,void 0,!0):e&&"object"==typeof e&&e.from&&e.to?{from:w.parseDate(e.from,void 0),to:w.parseDate(e.to,void 0)}:e})).filter((function(e){return e}))}function ve(){w._positionElement=w.config.positionElement||w._input}function De(e,n){if(void 0!==w.config){var t=w.config[e];if(void 0!==t&&t.length>0)for(var a=0;t[a]&&a<t.length;a++)t[a](w.selectedDates,w.input.value,w,n);"onChange"===e&&(w.input.dispatchEvent(we("change")),w.input.dispatchEvent(we("input")))}}function we(e){var n=document.createEvent("Event");return n.initEvent(e,!0,!0),n}function be(e){for(var n=0;n<w.selectedDates.length;n++){var t=w.selectedDates[n];if(t instanceof Date&&0===M(t,e))return""+n}return!1}function Ce(){w.config.noCalendar||w.isMobile||!w.monthNav||(w.yearElements.forEach((function(e,n){var t=new Date(w.currentYear,w.currentMonth,1);t.setMonth(w.currentMonth+n),w.config.showMonths>1||"static"===w.config.monthSelectorType?w.monthElements[n].textContent=h(t.getMonth(),w.config.shorthandCurrentMonth,w.l10n)+" ":w.monthsDropdownContainer.value=t.getMonth().toString(),e.value=t.getFullYear().toString()})),w._hidePrevMonthArrow=void 0!==w.config.minDate&&(w.currentYear===w.config.minDate.getFullYear()?w.currentMonth<=w.config.minDate.getMonth():w.currentYear<w.config.minDate.getFullYear()),w._hideNextMonthArrow=void 0!==w.config.maxDate&&(w.currentYear===w.config.maxDate.getFullYear()?w.currentMonth+1>w.config.maxDate.getMonth():w.currentYear>w.config.maxDate.getFullYear()))}function Me(e){var n=e||(w.config.altInput?w.config.altFormat:w.config.dateFormat);return w.selectedDates.map((function(e){return w.formatDate(e,n)})).filter((function(e,n,t){return"range"!==w.config.mode||w.config.enableTime||t.indexOf(e)===n})).join("range"!==w.config.mode?w.config.conjunction:w.l10n.rangeSeparator)}function ye(e){void 0===e&&(e=!0),void 0!==w.mobileInput&&w.mobileFormatStr&&(w.mobileInput.value=void 0!==w.latestSelectedDateObj?w.formatDate(w.latestSelectedDateObj,w.mobileFormatStr):""),w.input.value=Me(w.config.dateFormat),void 0!==w.altInput&&(w.altInput.value=Me(w.config.altFormat)),!1!==e&&De("onValueUpdate")}function xe(e){var n=g(e),t=w.prevMonthNav.contains(n),a=w.nextMonthNav.contains(n);t||a?Z(t?-1:1):w.yearElements.indexOf(n)>=0?n.select():n.classList.contains("arrowUp")?w.changeYear(w.currentYear+1):n.classList.contains("arrowDown")&&w.changeYear(w.currentYear-1)}return function(){w.element=w.input=p,w.isOpen=!1,function(){var n=["wrap","weekNumbers","allowInput","allowInvalidPreload","clickOpens","time_24hr","enableTime","noCalendar","altInput","shorthandCurrentMonth","inline","static","enableSeconds","disableMobile"],i=e(e({},JSON.parse(JSON.stringify(p.dataset||{}))),v),o={};w.config.parseDate=i.parseDate,w.config.formatDate=i.formatDate,Object.defineProperty(w.config,"enable",{get:function(){return w.config._enable},set:function(e){w.config._enable=he(e)}}),Object.defineProperty(w.config,"disable",{get:function(){return w.config._disable},set:function(e){w.config._disable=he(e)}});var r="time"===i.mode;if(!i.dateFormat&&(i.enableTime||r)){var l=I.defaultConfig.dateFormat||a.dateFormat;o.dateFormat=i.noCalendar||r?"H:i"+(i.enableSeconds?":S":""):l+" H:i"+(i.enableSeconds?":S":"")}if(i.altInput&&(i.enableTime||r)&&!i.altFormat){var s=I.defaultConfig.altFormat||a.altFormat;o.altFormat=i.noCalendar||r?"h:i"+(i.enableSeconds?":S K":" K"):s+" h:i"+(i.enableSeconds?":S":"")+" K"}Object.defineProperty(w.config,"minDate",{get:function(){return w.config._minDate},set:le("min")}),Object.defineProperty(w.config,"maxDate",{get:function(){return w.config._maxDate},set:le("max")});var d=function(e){return function(n){w.config["min"===e?"_minTime":"_maxTime"]=w.parseDate(n,"H:i:S")}};Object.defineProperty(w.config,"minTime",{get:function(){return w.config._minTime},set:d("min")}),Object.defineProperty(w.config,"maxTime",{get:function(){return w.config._maxTime},set:d("max")}),"time"===i.mode&&(w.config.noCalendar=!0,w.config.enableTime=!0);Object.assign(w.config,o,i);for(var u=0;u<n.length;u++)w.config[n[u]]=!0===w.config[n[u]]||"true"===w.config[n[u]];t.filter((function(e){return void 0!==w.config[e]})).forEach((function(e){w.config[e]=c(w.config[e]||[]).map(T)})),w.isMobile=!w.config.disableMobile&&!w.config.inline&&"single"===w.config.mode&&!w.config.disable.length&&!w.config.enable&&!w.config.weekNumbers&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);for(u=0;u<w.config.plugins.length;u++){var f=w.config.plugins[u](w)||{};for(var m in f)t.indexOf(m)>-1?w.config[m]=c(f[m]).map(T).concat(w.config[m]):void 0===i[m]&&(w.config[m]=f[m])}i.altInputClass||(w.config.altInputClass=ce().className+" "+w.config.altInputClass);De("onParseConfig")}(),se(),function(){if(w.input=ce(),!w.input)return void w.config.errorHandler(new Error("Invalid input element specified"));w.input._type=w.input.type,w.input.type="text",w.input.classList.add("flatpickr-input"),w._input=w.input,w.config.altInput&&(w.altInput=d(w.input.nodeName,w.config.altInputClass),w._input=w.altInput,w.altInput.placeholder=w.input.placeholder,w.altInput.disabled=w.input.disabled,w.altInput.required=w.input.required,w.altInput.tabIndex=w.input.tabIndex,w.altInput.type="text",w.input.setAttribute("type","hidden"),!w.config.static&&w.input.parentNode&&w.input.parentNode.insertBefore(w.altInput,w.input.nextSibling));w.config.allowInput||w._input.setAttribute("readonly","readonly");ve()}(),function(){w.selectedDates=[],w.now=w.parseDate(w.config.now)||new Date;var e=w.config.defaultDate||("INPUT"!==w.input.nodeName&&"TEXTAREA"!==w.input.nodeName||!w.input.placeholder||w.input.value!==w.input.placeholder?w.input.value:null);e&&pe(e,w.config.dateFormat);w._initialDate=w.selectedDates.length>0?w.selectedDates[0]:w.config.minDate&&w.config.minDate.getTime()>w.now.getTime()?w.config.minDate:w.config.maxDate&&w.config.maxDate.getTime()<w.now.getTime()?w.config.maxDate:w.now,w.currentYear=w._initialDate.getFullYear(),w.currentMonth=w._initialDate.getMonth(),w.selectedDates.length>0&&(w.latestSelectedDateObj=w.selectedDates[0]);void 0!==w.config.minTime&&(w.config.minTime=w.parseDate(w.config.minTime,"H:i"));void 0!==w.config.maxTime&&(w.config.maxTime=w.parseDate(w.config.maxTime,"H:i"));w.minDateHasTime=!!w.config.minDate&&(w.config.minDate.getHours()>0||w.config.minDate.getMinutes()>0||w.config.minDate.getSeconds()>0),w.maxDateHasTime=!!w.config.maxDate&&(w.config.maxDate.getHours()>0||w.config.maxDate.getMinutes()>0||w.config.maxDate.getSeconds()>0)}(),w.utils={getDaysInMonth:function(e,n){return void 0===e&&(e=w.currentMonth),void 0===n&&(n=w.currentYear),1===e&&(n%4==0&&n%100!=0||n%400==0)?29:w.l10n.daysInMonth[e]}},w.isMobile||function(){var e=window.document.createDocumentFragment();if(w.calendarContainer=d("div","flatpickr-calendar"),w.calendarContainer.tabIndex=-1,!w.config.noCalendar){if(e.appendChild((w.monthNav=d("div","flatpickr-months"),w.yearElements=[],w.monthElements=[],w.prevMonthNav=d("span","flatpickr-prev-month"),w.prevMonthNav.innerHTML=w.config.prevArrow,w.nextMonthNav=d("span","flatpickr-next-month"),w.nextMonthNav.innerHTML=w.config.nextArrow,V(),Object.defineProperty(w,"_hidePrevMonthArrow",{get:function(){return w.__hidePrevMonthArrow},set:function(e){w.__hidePrevMonthArrow!==e&&(s(w.prevMonthNav,"flatpickr-disabled",e),w.__hidePrevMonthArrow=e)}}),Object.defineProperty(w,"_hideNextMonthArrow",{get:function(){return w.__hideNextMonthArrow},set:function(e){w.__hideNextMonthArrow!==e&&(s(w.nextMonthNav,"flatpickr-disabled",e),w.__hideNextMonthArrow=e)}}),w.currentYearElement=w.yearElements[0],Ce(),w.monthNav)),w.innerContainer=d("div","flatpickr-innerContainer"),w.config.weekNumbers){var n=function(){w.calendarContainer.classList.add("hasWeeks");var e=d("div","flatpickr-weekwrapper");e.appendChild(d("span","flatpickr-weekday",w.l10n.weekAbbreviation));var n=d("div","flatpickr-weeks");return e.appendChild(n),{weekWrapper:e,weekNumbers:n}}(),t=n.weekWrapper,a=n.weekNumbers;w.innerContainer.appendChild(t),w.weekNumbers=a,w.weekWrapper=t}w.rContainer=d("div","flatpickr-rContainer"),w.rContainer.appendChild(z()),w.daysContainer||(w.daysContainer=d("div","flatpickr-days"),w.daysContainer.tabIndex=-1),U(),w.rContainer.appendChild(w.daysContainer),w.innerContainer.appendChild(w.rContainer),e.appendChild(w.innerContainer)}w.config.enableTime&&e.appendChild(function(){w.calendarContainer.classList.add("hasTime"),w.config.noCalendar&&w.calendarContainer.classList.add("noCalendar");var e=E(w.config);w.timeContainer=d("div","flatpickr-time"),w.timeContainer.tabIndex=-1;var n=d("span","flatpickr-time-separator",":"),t=m("flatpickr-hour",{"aria-label":w.l10n.hourAriaLabel});w.hourElement=t.getElementsByTagName("input")[0];var a=m("flatpickr-minute",{"aria-label":w.l10n.minuteAriaLabel});w.minuteElement=a.getElementsByTagName("input")[0],w.hourElement.tabIndex=w.minuteElement.tabIndex=-1,w.hourElement.value=o(w.latestSelectedDateObj?w.latestSelectedDateObj.getHours():w.config.time_24hr?e.hours:function(e){switch(e%24){case 0:case 12:return 12;default:return e%12}}(e.hours)),w.minuteElement.value=o(w.latestSelectedDateObj?w.latestSelectedDateObj.getMinutes():e.minutes),w.hourElement.setAttribute("step",w.config.hourIncrement.toString()),w.minuteElement.setAttribute("step",w.config.minuteIncrement.toString()),w.hourElement.setAttribute("min",w.config.time_24hr?"0":"1"),w.hourElement.setAttribute("max",w.config.time_24hr?"23":"12"),w.hourElement.setAttribute("maxlength","2"),w.minuteElement.setAttribute("min","0"),w.minuteElement.setAttribute("max","59"),w.minuteElement.setAttribute("maxlength","2"),w.timeContainer.appendChild(t),w.timeContainer.appendChild(n),w.timeContainer.appendChild(a),w.config.time_24hr&&w.timeContainer.classList.add("time24hr");if(w.config.enableSeconds){w.timeContainer.classList.add("hasSeconds");var i=m("flatpickr-second");w.secondElement=i.getElementsByTagName("input")[0],w.secondElement.value=o(w.latestSelectedDateObj?w.latestSelectedDateObj.getSeconds():e.seconds),w.secondElement.setAttribute("step",w.minuteElement.getAttribute("step")),w.secondElement.setAttribute("min","0"),w.secondElement.setAttribute("max","59"),w.secondElement.setAttribute("maxlength","2"),w.timeContainer.appendChild(d("span","flatpickr-time-separator",":")),w.timeContainer.appendChild(i)}w.config.time_24hr||(w.amPM=d("span","flatpickr-am-pm",w.l10n.amPM[r((w.latestSelectedDateObj?w.hourElement.value:w.config.defaultHour)>11)]),w.amPM.title=w.l10n.toggleTitle,w.amPM.tabIndex=-1,w.timeContainer.appendChild(w.amPM));return w.timeContainer}());s(w.calendarContainer,"rangeMode","range"===w.config.mode),s(w.calendarContainer,"animate",!0===w.config.animate),s(w.calendarContainer,"multiMonth",w.config.showMonths>1),w.calendarContainer.appendChild(e);var i=void 0!==w.config.appendTo&&void 0!==w.config.appendTo.nodeType;if((w.config.inline||w.config.static)&&(w.calendarContainer.classList.add(w.config.inline?"inline":"static"),w.config.inline&&(!i&&w.element.parentNode?w.element.parentNode.insertBefore(w.calendarContainer,w._input.nextSibling):void 0!==w.config.appendTo&&w.config.appendTo.appendChild(w.calendarContainer)),w.config.static)){var l=d("div","flatpickr-wrapper");w.element.parentNode&&w.element.parentNode.insertBefore(l,w.element),l.appendChild(w.element),w.altInput&&l.appendChild(w.altInput),l.appendChild(w.calendarContainer)}w.config.static||w.config.inline||(void 0!==w.config.appendTo?w.config.appendTo:window.document.body).appendChild(w.calendarContainer)}(),function(){w.config.wrap&&["open","close","toggle","clear"].forEach((function(e){Array.prototype.forEach.call(w.element.querySelectorAll("[data-"+e+"]"),(function(n){return P(n,"click",w[e])}))}));if(w.isMobile)return void function(){var e=w.config.enableTime?w.config.noCalendar?"time":"datetime-local":"date";w.mobileInput=d("input",w.input.className+" flatpickr-mobile"),w.mobileInput.tabIndex=1,w.mobileInput.type=e,w.mobileInput.disabled=w.input.disabled,w.mobileInput.required=w.input.required,w.mobileInput.placeholder=w.input.placeholder,w.mobileFormatStr="datetime-local"===e?"Y-m-d\\TH:i:S":"date"===e?"Y-m-d":"H:i:S",w.selectedDates.length>0&&(w.mobileInput.defaultValue=w.mobileInput.value=w.formatDate(w.selectedDates[0],w.mobileFormatStr));w.config.minDate&&(w.mobileInput.min=w.formatDate(w.config.minDate,"Y-m-d"));w.config.maxDate&&(w.mobileInput.max=w.formatDate(w.config.maxDate,"Y-m-d"));w.input.getAttribute("step")&&(w.mobileInput.step=String(w.input.getAttribute("step")));w.input.type="hidden",void 0!==w.altInput&&(w.altInput.type="hidden");try{w.input.parentNode&&w.input.parentNode.insertBefore(w.mobileInput,w.input.nextSibling)}catch(e){}P(w.mobileInput,"change",(function(e){w.setDate(g(e).value,!1,w.mobileFormatStr),De("onChange"),De("onClose")}))}();var e=l(re,50);w._debouncedChange=l(Y,300),w.daysContainer&&!/iPhone|iPad|iPod/i.test(navigator.userAgent)&&P(w.daysContainer,"mouseover",(function(e){"range"===w.config.mode&&oe(g(e))}));P(w._input,"keydown",ie),void 0!==w.calendarContainer&&P(w.calendarContainer,"keydown",ie);w.config.inline||w.config.static||P(window,"resize",e);void 0!==window.ontouchstart?P(window.document,"touchstart",X):P(window.document,"mousedown",X);P(window.document,"focus",X,{capture:!0}),!0===w.config.clickOpens&&(P(w._input,"focus",w.open),P(w._input,"click",w.open));void 0!==w.daysContainer&&(P(w.monthNav,"click",xe),P(w.monthNav,["keyup","increment"],N),P(w.daysContainer,"click",me));if(void 0!==w.timeContainer&&void 0!==w.minuteElement&&void 0!==w.hourElement){var n=function(e){return g(e).select()};P(w.timeContainer,["increment", "keyup"],_),P(w.timeContainer,"blur",_,{capture:!0}),P(w.timeContainer,"click",H),P([w.hourElement,w.minuteElement],["focus","click"],n),void 0!==w.secondElement&&P(w.secondElement,"focus",(function(){return w.secondElement&&w.secondElement.select()})),void 0!==w.amPM&&P(w.amPM,"click",(function(e){_(e)}))}w.config.allowInput&&P(w._input,"blur",ae)}(),(w.selectedDates.length||w.config.noCalendar)&&(w.config.enableTime&&F(w.config.noCalendar?w.latestSelectedDateObj:void 0),ye(!1)),S();var n=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);!w.isMobile&&n&&de(),De("onReady")}(),w}function T(e,n){for(var t=Array.prototype.slice.call(e).filter((function(e){return e instanceof HTMLElement})),a=[],i=0;i<t.length;i++){var o=t[i];try{if(null!==o.getAttribute("data-fp-omit"))continue;void 0!==o._flatpickr&&(o._flatpickr.destroy(),o._flatpickr=void 0),o._flatpickr=k(o,n||{}),a.push(o._flatpickr)}catch(e){console.error(e)}}return 1===a.length?a[0]:a}"undefined"!=typeof HTMLElement&&"undefined"!=typeof HTMLCollection&&"undefined"!=typeof NodeList&&(HTMLCollection.prototype.flatpickr=NodeList.prototype.flatpickr=function(e){return T(this,e)},HTMLElement.prototype.flatpickr=function(e){return T([this],e)});var I=function(e,n){return"string"==typeof e?T(window.document.querySelectorAll(e),n):e instanceof Node?T([e],n):T(e,n)};return I.defaultConfig={},I.l10ns={en:e({},i),default:e({},i)},I.localize=function(n){I.l10ns.default=e(e({},I.l10ns.default),n)},I.setDefaults=function(n){I.defaultConfig=e(e({},I.defaultConfig),n)},I.parseDate=C({}),I.formatDate=b({}),I.compareDates=M,"undefined"!=typeof jQuery&&void 0!==jQuery.fn&&(jQuery.fn.flatpickr=function(e){return T(this,e)}),Date.prototype.fp_incr=function(e){return new Date(this.getFullYear(),this.getMonth(),this.getDate()+("string"==typeof e?parseInt(e,10):e))},"undefined"!=typeof window&&(window.flatpickr=I),I}));
!function ($)
{
    "use strict"; // jshint ;_;

    var availabilityPicker = function(element, options)
    {
        this.$element = $(element);
        this.options = options;

        this.create();
    };

    var template =
    '<div class="datepicker">' +
        '<div class="datepicker-days">' +
            '<table class="table-condensed">' +
                $.fn.datepicker.DPGlobal.headTemplate +
                '<tbody></tbody>' +
                $.fn.datepicker.DPGlobal.footTemplate +
                '</table>' +
                '<div style="font-size:80%;border-top:1px solid #ccc;padding:10px 0 5px 5px;margin:0 5px"><span class="daylegend daylegend-booked"></span> Reserved \
                    &nbsp;\
                    <span class="daylegend daylegend-selected"></span> Selected\
                </div>' +
        '</div>' +
        '<div class="datepicker-months">' +
            '<table class="table-condensed">' +
                $.fn.datepicker.DPGlobal.headTemplate +
                $.fn.datepicker.DPGlobal.contTemplate +
                $.fn.datepicker.DPGlobal.footTemplate +
            '</table>' +
        '</div>' +
        '<div class="datepicker-years">' +
            '<table class="table-condensed">' +
                $.fn.datepicker.DPGlobal.headTemplate +
                $.fn.datepicker.DPGlobal.contTemplate +
                $.fn.datepicker.DPGlobal.footTemplate +
            '</table>' +
        '</div>' +
        '<div class="datepicker-decades">' +
            '<table class="table-condensed">' +
                $.fn.datepicker.DPGlobal.headTemplate +
                $.fn.datepicker.DPGlobal.contTemplate +
                $.fn.datepicker.DPGlobal.footTemplate +
            '</table>' +
        '</div>' +
        '<div class="datepicker-centuries">' +
            '<table class="table-condensed">' +
                $.fn.datepicker.DPGlobal.headTemplate +
                $.fn.datepicker.DPGlobal.contTemplate +
                $.fn.datepicker.DPGlobal.footTemplate +
            '</table>' +
        '</div>' +
    '</div>';

    var ticksInDay = 86400000;

    var DateParseIso8601 = function (value)
    {
        var year = parseInt(value.substring(0, 4), 10);
        var month = parseInt(value.substring(5, 7), 10);
        var day = parseInt(value.substring(8, 10), 10);
        var hour = parseInt(value.substring(11, 13), 10);
        var minute = parseInt(value.substring(14, 16), 10);
        var second = parseInt(value.substring(17, 19), 10);

        return new Date(year, month - 1, day, hour, minute, second);
    };

    var parseDateOrNull = function ($el)
    {
        var value = $el.val();
        if (value){
            var parsed = i18n.parseDate(value);
            return parsed.isValid() ? parsed.toDate() : null;
        }
        else
            return null;
    };

    var beforeShowDay = function (date, isArrivalBox, arrivalDate, departureDate, bookings, holidays, canPickUnavailable)
    {
        var content = '<div>' + (new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).getUTCDate()) + '</div>';

        //if ((minDay != null && date.valueOf() < minDay) || (isArrivalBox && maxDay != null && date.valueOf() > maxDay))
        //    return false;

        //for (var i = 0; i < bookings.length; i++)
        //{
        //    if ((isArrivalBox && date.valueOf() >= DateParseIso8601(bookings[i].Arrival).valueOf() && date.valueOf() < DateParseIso8601(bookings[i].Departure).valueOf()) ||
        //        (!isArrivalBox && date.valueOf() > DateParseIso8601(bookings[i].Arrival).valueOf() && date.valueOf() <= DateParseIso8601(bookings[i].Departure).valueOf()))
        //        return false;
        //}

        var prevDate = moment(date).add(-1, "days").toDate().setHours(12, 0, 0, 0).valueOf();
        var nextDate = moment(date).add(1, "days").toDate().setHours(12, 0, 0, 0).valueOf();
        var prevDateKey = new Date(prevDate).toDateString();
        var nextDateKey = new Date(nextDate).toDateString();

        var classes = [];
        var date = date.setHours(12, 0, 0, 0).valueOf();
        //var tomorrow = moment().add(1, "days").toDate().setHours(12, 0, 0, 0).valueOf();
        var dateKey = new Date(date).toDateString();
        //var tomorrowKey = new Date(tomorrow).toDateString();
        var booking = bookings[dateKey];


        //if ((minDay == null && date < tomorrow) || (minDay != null && date < minDay) || (maxDay != null && date > maxDay))
        //{
        //    classes.push("booking-middle");
        //    classes.push("out-of-range");
        //}
        //else if (minDay != null && date == minDay && !booking)
        //{
        //    classes.push("booking-end");
        //}

        if (booking)
        {
            if (booking.isMiddle)
                classes.push("booking-middle");
            else
            {
                if (booking.isStart)
                    classes.push("booking-start");
                if (booking.isEnd)
                    classes.push("booking-end");
            }
        }

        var tooltip = null;

        var holiday = holidays[dateKey];

        if (holiday)
        {
            classes.push("holiday");

            if (holidays[prevDateKey] && holidays[nextDateKey])// || holidays[yesterdayKey] && bookings[tomorrowKey] || bookings[yesterdayKey] && holidays[tomorrowKey])
                classes.push("holiday-middle");

            tooltip = holiday;
        }

        if (arrivalDate > departureDate)
        {
            var swap = arrivalDate;

            arrivalDate = departureDate;
            departureDate = swap;
        }

        if (arrivalDate && arrivalDate.toDateString() == dateKey && (!departureDate || departureDate.toDateString() != dateKey))
            classes.push("first-date-selected");

        if (departureDate && departureDate.toDateString() == dateKey && (!arrivalDate || arrivalDate.toDateString() != dateKey))
            classes.push("last-date-selected");

        if (arrivalDate && departureDate && date >= arrivalDate.setHours(12, 0, 0, 0).valueOf() && date <= departureDate.setHours(12, 0, 0, 0).valueOf())
            classes.push("checked");

        var _class = classes.length ? classes.join(" ") : "";

        // TODO: dedupe classes
        var valid = _class.indexOf("booking-middle") == -1 && !(isArrivalBox && _class.indexOf("booking-start") != -1) && !(!isArrivalBox && _class.indexOf("booking-end") != -1);

        //return [valid, _class, tooltip];

        return { enabled: valid || canPickUnavailable, classes: _class, tooltip: tooltip, content: content };
    };

    availabilityPicker.prototype = {
        constructor: availabilityPicker,

        // create and bind
        create: function ()
        {
            var self = this;

            this.bookings = {};
            this.holidays = {};

            this.$arrival = $(this.options.arrivalElement);
            this.$departure = $(this.options.departureElement);
            this.$pickers = this.$arrival.add(this.$departure);

            this.$arrival.addClass("availability-picker").datepicker({
                autoclose: true,
                assumeNearbyYear: true,
                orientation: "bottom left",
                todayHighlight: true,
                template: template,
                beforeShowDay: function (date)
                {
                    return beforeShowDay(date, true, parseDateOrNull(self.$arrival), parseDateOrNull(self.$departure), self.bookings, self.holidays, self.options.canPickUnavailable);
                }
            });
            this.$departure.addClass("availability-picker").datepicker({
                autoclose: true,
                assumeNearbyYear: true,
                orientation: "bottom right",
                todayHighlight: true,
                template: template,
                beforeShowDay: function (date)
                {
                    return beforeShowDay(date, false, parseDateOrNull(self.$arrival), parseDateOrNull(self.$departure), self.bookings, self.holidays, self.options.canPickUnavailable);
                }
            });

            this.$arrival.on("changeDate", $.proxy(function (e)
            {
                var arrivalDate = this.$arrival.val() ? this.$arrival.datepicker("getDate") : null;
                var departureDate = this.$departure.val() ? this.$departure.datepicker("getDate") : null;

                if (arrivalDate && (!departureDate || arrivalDate > departureDate))
                {
                    this.$departure
                        .datepicker("update", moment(arrivalDate).add(1, 'days').toDate())
                        .find(".day.active").removeClass("active");
                    this.$departure.focus();
                }
            }, this));

            this.$departure.on("show", $.proxy(function (e)
            {
                if (!this.$arrival.val())
                {
                    this.$departure.datepicker("hide");
                    this.$arrival.focus();
                }
            }, this));

            this.$pickers.on("changeDate", $.proxy(function (e)
            {
                this.$pickers.datepicker("update");
            }, this));

            $(window).on("blur", $.proxy(function (e)
            {
                this.$pickers.datepicker("hide");
            }, this));

            this.setAvailability(this.options.bookingData, this.options.holidayData);

            delete this.options.bookingData;
            delete this.options.holidayData;
        },

        setAvailability: function(bookingData, holidayData)
        {
            this.bookings = {};
            this.holidays = {};

            if (bookingData && bookingData.length)
            {
                for (var i = 0; i < bookingData.length; i++)
                {
                    var booking = bookingData[i];

                    var arrival = DateParseIso8601(booking.Arrival).setHours(12, 0, 0, 0).valueOf();
                    var departure = DateParseIso8601(booking.Departure).setHours(12, 0, 0, 0).valueOf();

                    for (var day = arrival + ticksInDay; day < departure && new Date(day).toDateString() != new Date(departure).toDateString() ; day += ticksInDay)
                        this.bookings[new Date(day).toDateString()] = { isMiddle: true };

                    var hash = this.bookings[new Date(arrival).toDateString()] || {};

                    hash.isStart = true;

                    this.bookings[new Date(arrival).toDateString()] = hash;

                    hash = this.bookings[new Date(departure).toDateString()] || {};

                    hash.isEnd = true;

                    this.bookings[new Date(departure).toDateString()] = hash;
                }
            }

            if (holidayData && holidayData.length)
            {
                for (var i = 0; i < holidayData.length; i++)
                {
                    var holiday = holidayData[i];
                    var date = DateParseIso8601(holiday.Date).setHours(12, 0, 0, 0).valueOf();

                    // TODO: multiple holidays on one day... concat or array if exists
                    this.holidays[new Date(date).toDateString()] = holiday.Name;
                }
            }

            this.$pickers.datepicker("update");
        },

        setAvailabilityFromProperty: function (propertyId, excludedBookingId, excludeMutualBlocks)
        {
            if (propertyId)
            {
                var data = {
                    propertyIds: propertyId
                };

                if (excludedBookingId)
                    data.excludedBookingId = excludedBookingId;

                if (excludeMutualBlocks)
                    data.excludeMutualBlocks = true;

                $.get(BaseUrl + "/api/bookings/availability", data)
                    .done($.proxy(function (data)
                    {
                        var bookingData = data.Bookings || [];
                        var holidayData = data.Holidays || [];

                        this.setAvailability(bookingData, holidayData);
                    }, this));
            }
            else
            {
                this.bookings = {};

                this.$pickers.datepicker("update");
            }
        },
        
        // destroy and unbind
        destroy: function ()
        {

        }
    };

    $.fn.availabilityPicker = function (option)
    {
        var value;
        var args = arguments;

        this.each(function ()
        {
            var data = $(this).data('availabilityPicker'),
                options = typeof option == 'object' && option;

            // initialize availabilityPicker
            if (!data)
            {
                var instanceOptions = $.extend({}, $.fn.availabilityPicker.defaults, options);

                $(this).data('availabilityPicker', (data = new availabilityPicker(this, instanceOptions)));
            }

            // call availabilityPicker method
            if (typeof option == 'string')
            {
                value = data[option].apply(data, Array.prototype.slice.call(args, 1));
            }
        });

        if (value !== undefined)
            return value;
        else
            return this;
    };

    $.fn.availabilityPicker.defaults =
    {
        //date: moment(),
        arrivalElement: null,
        departureElement: null,
        bookingData: null,
        holidayData: null,
        canPickUnavailable: false,
        excludeMutualBlocks: false
    };

    $(function()
    {
        //$("[data-role=availability-picker]").availabilityPicker();
    });
}(window.jQuery);
/*
 * Griddly script
 * http://griddly.com
 * Copyright 2013-2025 Chris Hynes and Data Research Group, Inc.
 * Licensed under MIT (https://github.com/programcsharp/griddly/blob/master/LICENSE)
 *
 * WARNING: Don't edit this file -- it'll be overwitten when you upgrade.
 *
 */

!function ($)
{
    "use strict"; // jshint ;_;

    var isNullOrWhiteSpace = function (str)
    {
        return str == null || str.match(/^ *$/) !== null;
    };

    var trimToNull = function (str)
    {
        if (isNullOrWhiteSpace(str))
            return null;
        else
            return str;
    };

    var getCleanedValue = function (val, dataType)
    {
        switch (dataType)
        {
            case "Integer":
                val = String(val).replace(/[^0-9-]/g, "")

                if (val.length > 1)
                    val = val.substr(0, 1) + val.substr(1).replace(/-/g, "");
                else if (val == '-')
                    return null;

                return val;
            case "Decimal":
            case "Currency":
                //case "Percent":
                val = String(val).replace(/[^0-9,.-]/g, "").replace(/,/g, "");

                if (val.length > 1)
                    val = val.substr(0, 1) + val.substr(1).replace(/-/g, "");
                else if (val == '-')
                    return null;

                return val;
            case "Date":
                return $.fn.griddly.defaults.getCleanedDate(val);
            default:
                return val;
        }
    };

    var resetFormElement = function () {
        if (typeof (this.defaultChecked) !== "undefined") {
            this.checked = this.defaultChecked;
        } else if (typeof (this.defaultValue) !== "undefined") {
            this.value = this.defaultValue;
        }
        else if (this.tagName.toLowerCase() == "select") {
            $(this).find("option").each(function () {
                this.selected = this.defaultSelected;
            });
        }
    };

    var getFormattedValue = function (val, dataType, currencySymbol)
    {
        val = getCleanedValue(val, dataType);

        switch (dataType)
        {
            case "Integer":
                val = parseInt(val);

                if (!isFinite(val))
                    val = null;

                return val;
            case "Decimal":
            case "Currency":
                //case "Percent":

                // TODO: filter down to one decimal point
                // TODO: filter out non numerics
                val = parseFloat(val);

                if (!isFinite(val))
                    val = null;
                else
                {
                    val = val.toFixed(2)

                    var x = val.split('.');

                    var x1 = x[0];

                    var x2 = x.length > 1 ? '.' + x[1] : '';

                    var rgx = /(\d+)(\d{3})/;

                    while (rgx.test(x1))
                    {
                        x1 = x1.replace(rgx, '$1' + ',' + '$2');
                    }

                    val = x1 + x2;
                }

                if (dataType == "Currency")
                    val = currencySymbol + val;
                //else if (dataType == "Percent")
                //    val += "%";

                if (val && val.indexOf(".00", val.length - 3) !== -1)
                    val = val.substr(0, val.length - 3);

                return val;
            case "Date":
                return $.fn.griddly.defaults.getFormattedDate(val);
            default:
                return val;
        }
    };

    var serializeObject = function ($elements, skipEmpty, multipleSelects)
    {
        // http://stackoverflow.com/a/1186309/8037
        var data = {};

        $.each($elements.serializeArray(), function ()
        {
            if (this.value == '' && skipEmpty)
                this.value = null;
            else if (this.value == null && !skipEmpty)
                this.value = '';

            var isMultipleSelect = $.inArray(this.name, multipleSelects) != -1;

            if (this.value == null && !isMultipleSelect)
                return;

            if (data[this.name] !== undefined || isMultipleSelect)
            {
                if (data[this.name] == null)
                    data[this.name] = [];
                else if (!data[this.name].push)
                    data[this.name] = [data[this.name]];

                data[this.name].push(this.value);
            }
            else
            {
                data[this.name] = this.value;
            }
        });

        return data;
    };

    // https://stackoverflow.com/a/1144249
    var deepCompare = function ()
    {
        var i, l, leftChain, rightChain;

        function compare2Objects(x, y)
        {
            var p;

            // remember that NaN === NaN returns false
            // and isNaN(undefined) returns true
            if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number')
            {
                return true;
            }

            // Compare primitives and functions.     
            // Check if both arguments link to the same object.
            // Especially useful on the step where we compare prototypes
            if (x === y)
            {
                return true;
            }

            // Works in case when functions are created in constructor.
            // Comparing dates is a common scenario. Another built-ins?
            // We can even handle functions passed across iframes
            if ((typeof x === 'function' && typeof y === 'function') ||
                (x instanceof Date && y instanceof Date) ||
                (x instanceof RegExp && y instanceof RegExp) ||
                (x instanceof String && y instanceof String) ||
                (x instanceof Number && y instanceof Number))
            {
                return x.toString() === y.toString();
            }

            // At last checking prototypes as good as we can
            if (!(x instanceof Object && y instanceof Object))
            {
                return false;
            }

            if (x.isPrototypeOf(y) || y.isPrototypeOf(x))
            {
                return false;
            }

            if (x.constructor !== y.constructor)
            {
                return false;
            }

            if (x.prototype !== y.prototype)
            {
                return false;
            }

            // Check for infinitive linking loops
            if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1)
            {
                return false;
            }

            // Quick checking of one object being a subset of another.
            // todo: cache the structure of arguments[0] for performance
            for (p in y)
            {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p))
                {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p])
                {
                    return false;
                }
            }

            for (p in x)
            {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p))
                {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p])
                {
                    return false;
                }

                if (Array.isArray(x[p]))
                {
                    x[p].sort();
                    y[p].sort();
                }

                switch (typeof (x[p]))
                {
                    case 'object':
                    case 'function':

                        leftChain.push(x);
                        rightChain.push(y);

                        if (!compare2Objects(x[p], y[p]))
                        {
                            return false;
                        }

                        leftChain.pop();
                        rightChain.pop();
                        break;

                    default:
                        if (x[p] !== y[p])
                        {
                            return false;
                        }
                        break;
                }
            }

            return true;
        }

        if (arguments.length < 1)
        {
            return true; //Die silently? Don't know how to handle such case, please help...
            // throw "Need two or more arguments to compare";
        }

        for (i = 1, l = arguments.length; i < l; i++)
        {

            leftChain = []; //Todo: this can be cached
            rightChain = [];

            if (!compare2Objects(arguments[0], arguments[i]))
            {
                return false;
            }
        }

        return true;
    };

    // http://stackoverflow.com/q/8098202
    var parseForValidDate = function (text)
    {
        var date = Date.parse(text);

        if (isNaN(date))
            return null;

        var comp = text.split('/');

        if (comp.length !== 3)
            return null;

        var m = parseInt(comp[0], 10);
        var d = parseInt(comp[1], 10);
        var y = parseInt(comp[2], 10);

        date = new Date(y, m - 1, d);

        if (date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d)
            return date;
        else
            return null;
    };

    var setFilterValueImpl = function (input, value)
    {
        if (value)
        {
            var datatype = input.data("griddly-filter-data-type");

            switch (datatype)
            {
                case "Date":
                    value = $.fn.griddly.defaults.getFilterDate(value);
                    break;
                case "Currency":
                    value = parseFloat(value).toFixed(2);
                    break;
            }
        }

        if (input.data("griddly-filter") && input.data("griddly-filter").data("griddly-filter-isnoneall") &&
            (value === null || (input.data("griddly-filter").data("griddly-filter-ismultiple") && $.isArray(value) && $("input", input.data("griddly-filter").data("griddly-filter-content")).length === value.length)))
        {
            input.prop("checked", false);
        }
        else
        {
            if ((value === null || typeof value === typeof undefined) && input.is("[multiple]"))
                input.find("option:selected").prop("selected", false);
            else if ((value === null || typeof value === typeof undefined) && input.is(".griddly-filters-inline .dropdown-menu :checkbox"))
                input.prop("checked", false);
            else
                input.val([].concat(value));
        }

        $(input[0]).change();
    };

    var setFilterValuesImpl = function (allFilters, newFilters, isPatch, resetContext)
    {
        if (isPatch === true)
            allFilters = allFilters.filter(function (i, e) { return typeof (newFilters[e.name]) !== "undefined"; });

        allFilters.each($.proxy(function (i, e)
        {
            setFilterValueImpl($(e), newFilters[e.name]);
        }, this));

        // clear any none's that were inadvertently reset
        if (resetContext && !isPatch)
        {
            resetContext
                .find("[data-griddly-filter-isnoneall=true] [multiple] option[value='']")
                .each(function ()
                {
                    if (newFilters[$(this).closest("[data-filter-field]").data("filter-field")] == null)
                        $(this).prop("selected", false);
                });   
        }
    };

    var updateFilterDisplayImpl = function (root, filters, renderFilterDisplay, currencySymbol, overrideHasFilter, removeIconCssClass)
    {
        var hasFilter = false;

        if (overrideHasFilter == null)
        {
            root.find(".griddly-filter-values .filter-display").each(function ()
            {
                var field = $(this).data("filter-field");
                var filter = filters.filter("[data-filter-field='" + field + "']");
                var content = filter;
                //var key = $(this).data("griddly-filter-field");
                //var endKey = $(this).data("griddly-filter-fieldend");

                var dataType = filter.data("filter-datatype");
                var displayItems = [];

                // TODO: shove formatted values back into boxes to ensure post is correct?
                // TODO: for numbers, do correctly shredded numeric (no symbols, but numbers and decimals etc.)
                // TODO: for dates, push actual formatted date
                if (!filter.hasClass("griddly-filter-list"))
                {
                    var display = null;
                    var val = trimToNull(getCleanedValue(content.find("input").first().val(), dataType));
                    var valEnd = trimToNull(getCleanedValue(content.find("input").last().val(), dataType));

                    if (val != null || valEnd != null)
                    {
                        display = filter.data("filter-name");

                        if (filter.hasClass("griddly-filter-box") || filter.hasClass("griddly-html-filter"))
                        {
                            if (dataType == "String")
                                display += ': "' + getFormattedValue(val, dataType, currencySymbol) + '"';
                            else
                                display += ': ' + getFormattedValue(val, dataType, currencySymbol);
                        }
                        else if (filter.hasClass("griddly-filter-range"))
                        {
                            if (val != null && valEnd != null)
                                display += ' from ' + getFormattedValue(val, dataType, currencySymbol) + " to " + getFormattedValue(valEnd, dataType, currencySymbol);
                            else if (val != null)
                                display += (dataType == "Date" ? " after " : " >= ") + getFormattedValue(val, dataType, currencySymbol);
                            else if (valEnd != null)
                                display += (dataType == "Date" ? " before " : " <= ") + getFormattedValue(valEnd, dataType, currencySymbol);
                        }
                    }

                    if (display != null)
                        displayItems.push({ content: display });
                }
                else
                {
                    var allItems = content.find("select option");
                    var selectedItems = allItems.filter(":checked");
                    var displayItemCount = parseInt(filter.data("griddly-filter-displayitemcount"));
                    var displayIncludeCaption = filter.data("griddly-filter-displayincludecaption");

                    if (selectedItems.length == allItems.length
                        || (filter.data("griddly-filter-isnoneall") && selectedItems.length == 0)
                        || (!filter.data("griddly-filter-ismultiple") && (content.find("select").val() || "").length == 0))
                    {

                    }
                    else if (selectedItems.length > displayItemCount)
                    {
                        displayItems.push({ content: selectedItems.length + " " + filter.data("filter-name-plural") });
                    }
                    else if (selectedItems.length > 0 && selectedItems.length <= displayItemCount)
                    {
                        for (var i = 0; i < selectedItems.length; i++)
                            displayItems.push({ content: (displayIncludeCaption ? filter.data("filter-name") + ": " : "") + $.trim($(selectedItems[i]).text()), fieldValue: $(selectedItems[i]).val() });
                    }
                }

                if (displayItems.length)
                {
                    $(this).empty();

                    for (var i = 0; i < displayItems.length; i++)
                    {
                        var item = displayItems[i];

                        $(this).append(renderFilterDisplay(item.content, item.fieldValue, removeIconCssClass) + " ");
                    }

                    $(this).show();

                    hasFilter = true;
                }
                else
                    $(this).hide();
            });
        }
        else
            hasFilter = overrideHasFilter;

        root.toggleClass("griddly-filter-statusfiltered", hasFilter);
        root.toggleClass("griddly-filter-statusall", !hasFilter);

        return hasFilter;
    };

    var renderFilterDisplayImpl = function (content, fieldValue, removeIconCssClass)
    {
        return '<span class="filter-display-value" ' + (fieldValue != null ? 'data-filter-fieldvalue="' + fieldValue + '"' : "") + '>' +
            content +
            ' <a href="javascript:void(0)" class="griddly-remove-filter-value"><i class="' + removeIconCssClass + '"></i></a>' +
            '</span>';
    };

    var removeFilterValueImpl = function (event)
    {
        var value = $(event.target).closest(".filter-display-value");
        var fieldValue = value.data("filter-fieldvalue");
        var field = value.closest(".filter-display").data("filter-field");
        var filter = this.getFilterElement(field).closest(".griddly-filter");;

        var values = {};

        if (filter.hasClass("griddly-filter-list") && fieldValue)
        {
            var remainingValues = filter.find("select :checked:not([value='" + fieldValue + "'])");

            if (remainingValues.length)
            {
                var replacementValues = [];

                remainingValues.each(function ()
                {
                    replacementValues.push($(this).val());
                });

                values[field] = replacementValues;
            }
            else
                values[field] = null;
        }
        else
            values[field] = null;

        if (filter.hasClass("griddly-filter-range"))
        {
            var fieldEnd = filter.data("filter-fieldend");

            values[fieldEnd] = null;
        }

        this.setFilterValues(values, true, null, true);
    };

    var hidePopover = function (selector, bootstrapVersion) {
        selector.each(function () {
            var filter = $(this);
            if (filter.attr("aria-describedby")) { //This attribute will be present only when the popover is currently shown
                filter.popover("hide");

                //Workaround for bug introduced in Bootstrap 3.3.5, where hide() doesn't clear out the click state, so toggle() after hide() does not show.
                if (bootstrapVersion < 4 && filter.data("bs.popover").inState) {
                    filter.data("bs.popover").inState.click = false;
                }
            }
        });
    }

    var Griddly = function (element, options)
    {
        this.$element = $(element);
        this.$filterModal = $(".griddly-filter-modal", this.$element);
        this.options = options;
        this.bootstrapVersion = parseInt($.fn.tooltip.Constructor.VERSION.substr(0, 1));
        if (isNaN(this.bootstrapVersion))
            this.bootstrapVersion = 3;

        this.create();
        this.isConstructed = false;
        this.eventQueue = [];
        this.hasHistory = this.$element.prev(".griddly-init-flag").length > 0;
        
        this.triggerOrQueue = function ()
        {
            if (this.isConstructed)
            {
                arguments[0].trigger.apply(arguments[0], Array.prototype.slice.call(arguments, 1));
            }
            else
            {
                this.eventQueue[this.eventQueue.length] = arguments;
            }
        };

        this.clearSelected();

        $(this.$element).find("[data-enable-on-selection=true]").addClass("disabled");

        if (this.options.onRefresh)
            this.options.onRefresh(this, 0, this.options.count > this.options.pageSize ? this.options.pageSize : this.options.count, this.options.count, null);

        this.triggerOrQueue(this.$element, "init.griddly",
        {
            start: 0,
            pageSize: this.options.count > this.options.pageSize ? this.options.pageSize : this.options.count,
            count: this.options.count
        });

        var isLoadingHistory = false;

        if (this.hasHistory && window.history && history.replaceState && history.state && history.state.griddly)
        {
            var state = history.state.griddly[this.options.url];

            if (state && state.filterValues)
            {
                if (this.$element.prev(".griddly-init-flag").val() == "loaded"
                    // Workaround for IE when header cache-control: no-store is present. Form method works in Chrome, window.performance method works in IE and FF.
                    // See https://developer.mozilla.org/en-US/Firefox/Releases/1.5/Using_Firefox_1.5_caching and https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation
                    || (window.performance && window.performance.navigation && window.performance.navigation.type == 2))
                {
                    try
                    {
                        isLoadingHistory = true;

                        this.options.pageNumber = state.pageNumber;
                        this.options.pageSize = state.pageSize;
                        this.setSortFields(state.sortFields);
                        this.setFilterMode(state.filterMode, true);
                        this.setFilterValues(state.filterValues, false, true, true);

                        this.refresh();
                    }
                    catch (e)
                    {
                        isLoadingHistory = false;
                    }
                }
                else
                {
                    // user refreshed page, go back to defaults
                    delete history.state.griddly[this.options.url];

                    history.replaceState(history.state, document.title);
                }
            }
        }

        if (!isLoadingHistory)
        {
            this.$element.removeClass("griddly-init");
            this.$element.prev(".griddly-init-flag").val("loaded");
        }

        $("html").on("click", $.proxy(function (event)
        {
            if (this.options.filterMode == "Inline" && $(event.target).parents('.popover.in, .popover.show').length == 0 && $(event.target).parents(".filter-trigger").length == 0 && !$(event.target).hasClass("filter-trigger"))
            {
                $(".griddly-filters-inline .filter-trigger", this.$element).each(function ()
                {
                    var filter = $(this);

                    if (filter.data('bs.popover'))
                    {
                        var tip;
                        if ($.isFunction(filter.data('bs.popover').tip))
                            tip = filter.data('bs.popover').tip(); /*BS3*/
                        else
                            tip = filter.data('bs.popover').tip; /*BS4*/

                        if ($(tip).hasClass('in') || $(tip).hasClass('show')/*BS4*/) {
                            hidePopover(filter, self.bootstrapVersion);

                            if (!self.options.autoRefreshOnFilter && self.pendingInlineFilterRefresh) {
                                self.refresh(true);
                            }
                        }
                    }
                });
            }
        }, this));

        var self = this;

        this.$filterModal
            .on("show.bs.modal", function ()
            {
                var values = self.getFilterValues();

                $(".griddly-filter-cancel, button.close", this).off("click").on("click", function ()
                {
                    if (self.$element.triggerHandler("beforeclear.griddly") !== false)
                        self.setFilterValues(values, null, true, true);
                });
            })
            .on("shown.bs.modal", function ()
            {
                $(".modal-body :input:visible:not([disabled]):not([data-griddly-filter-data-type=Date]):first", this).focus();
            });

        this.isConstructed = true;
    };

    Griddly.prototype = {
        constructor: Griddly,

        _isUpdatingFilters: false,

        // create and bind
        create: function ()
        {
            var url = this.$element.data("griddly-url");
            var count = this.$element.data("griddly-count");
            var pageSize = this.$element.data("griddly-pagesize");
            var currentSort = this.$element.data("griddly-currentsort");
            var defaultSort = this.$element.data("griddly-defaultsort");
            var defaultRowIds = this.$element.data("griddly-defaultrowids");
            var isMultiSort = this.$element.data("griddly-multisort");
            var onRefresh = this.$element.data("griddly-onrefresh");
            var rowClickModal = this.$element.data("griddly-rowclickmodal");
            var filterMode = this.$element.data("griddly-filtermode");
            var allowedFilterModes = this.$element.data("griddly-allowedfiltermodes");
            var isFilterFormInline = this.$element.data("griddly-isfilterforminline");
            var filterDefaults = this.$element.data("griddly-filter-defaults");
            var currencySymbol = this.$element.data("griddly-currency-symbol");
            var removeIconCssClass = this.$element.data("griddly-remove-icon-css-class");
            var isDeepLink = this.$element.data("griddly-isdeeplink");

            this.additionalRequestValues = {};

            if (isDeepLink)
                this.additionalRequestValues._isDeepLink = true;

            this.options.url = url;
            this.options.defaultRowIds = defaultRowIds;
            this.options.count = parseInt(count);
            if (pageSize)
                this.options.pageSize = parseInt(pageSize);
            this.options.pageCount = this.options.count * this.options.pageSize;
            this.options.rowClickModal = rowClickModal;

            if (!this.options.selectedRows)
            {
                this.options.selectedRows = {};
            }

            if (isMultiSort != null)
                this.options.isMultiSort = isMultiSort == true;

            this.options.sortFields = currentSort && currentSort.length ? currentSort : [];
            this.options.defaultSort = defaultSort && defaultSort.length ? defaultSort : [];

            if (onRefresh && Object.prototype.toString.call(window[onRefresh]) == '[object Function]')
                this.options.onRefresh = window[onRefresh];

            this.options.filterMode = filterMode;
            this.options.allowedFilterModes = allowedFilterModes != null ? allowedFilterModes : null;
            this.options.isFilterFormInline = isFilterFormInline;
            this.options.filterDefaults = filterDefaults;
            this.options.removeIconCssClass = removeIconCssClass;

            if (currencySymbol)
                this.options.currencySymbol = currencySymbol;

            var multipleSelects = [];

            this.$element.find("[data-griddly-filter-ismultiple=true]").each(
                function (el, i)
                {
                    return multipleSelects.push($(this).data("filter-field"));
                });

            this.options.multipleSelects = multipleSelects;

            // TODO: should we do this later on so we handle dynamically added buttons?
            this.$element.find("[data-append-rowids-to-url]").each(function ()
            {
                $(this).data("griddly-href-template", $(this).attr("href"));
            });

            $("form", this.$element).attr("onsubmit", "return false;");

            $("a.next", this.$element).on("click", $.proxy(function (event)
            {
                this.pageNumber(this.options.pageNumber + 1);

                this.refresh();

                event.preventDefault();
            }, this));

            $("a.prev", this.$element).on("click", $.proxy(function (event)
            {
                this.pageNumber(this.options.pageNumber - 1);

                this.refresh();

                event.preventDefault();
            }, this));

            $("input.pageNumber", this.$element).on("change", $.proxy(function (event)
            {
                var value = parseInt($(event.target).val());

                if (value < 1 || this.options.pageCount == 0)
                    value = 1;
                else if (value > this.options.pageCount)
                    value = this.options.pageCount;

                if (this.options.pageNumber != value - 1) {
                    this.options.pageNumber = value - 1;
                    this.refresh();
                }
            }, this));

            $("select.pageSize", this.$element).on("change", $.proxy(function (event)
            {
                var value = parseInt($(event.target).val());

                if (value < 1)
                    value = 1;
                else if (value > 1000)
                    value = 1000;

                this.options.pageNumber = Math.floor(this.options.pageNumber * this.options.pageSize / value);
                this.pageSize(value);

                this.refresh();
            }, this));

            $("form", this.$element).on("submit", $.proxy(function (event)
            {
                this.$filterModal.modal("hide");

                this.refresh(true);

                event.preventDefault();
            }, this));

            $(".griddly-search-reset", this.$element).on("click", $.proxy(function (event)
            {
                var refresh = $(event.currentTarget).closest(".modal").length == 0;

                this.resetFilterValues(refresh);

                event.preventDefault();
            }, this));

            $(".griddly-search-clear", this.$element).on("click", $.proxy(function (event)
            {
                var refresh = $(event.currentTarget).closest(".modal").length == 0;

                this.clearFilterValues(refresh);

                event.preventDefault();
            }, this));

            $(".griddly-filter-invoke, a.btn-search, button.btn-search", this.$element).on("click", $.proxy(function (event) {
                if ($(event.currentTarget).is(".btn-search")) {
                    //M3-specific implementation. Should be refactored out of Griddly
                    if (!this.options.isFilterFormInline) {
                    if (this.options.filterMode == "Inline")
                        this.setFilterMode("Form", true);

                    this.invokeFilterModal();
                }
                else
                    this.toggleFilterMode();
                }
                else {

                    this.invokeFilterModal();

                    event.preventDefault();
                }
            }, this));

            var defaultRowClickHandler = function (e, url, target) {
                if (e.which == 2 || e.ctrlKey || target == "_blank")
                    window.open(url);
                else
                    window.location = url;
            };

            $(this.$element).on("mouseup", "tbody.data tr td:not(:has(input))", $.proxy(function (e)
            {
                if (e.which > 2)
                    return;

                var clickTarget = $(e.target);
                var url = $.trim(clickTarget.parents("tr").data("griddly-url"));
                var target = $.trim(clickTarget.parents("tr").data("griddly-urltarget"));

                if (url && clickTarget.closest("a").length == 0 && clickTarget.closest("td").find("[data-toggle=dropdown],[data-bs-toggle=dropdown]").length == 0)
                {
                    e.preventDefault();

                    if (clickTarget.hasClass("popover-content"))
                        return;

                    if (this.options.rowClickModal)
                    {
                        if (this.options.handleRowClickModal) {
                            this.options.handleRowClickModal($.trim(url), this.options.rowClickModal);
                        } else {
                            $(this.options.rowClickModal).removeData("bs.modal").modal({show: false});
                            $(".modal-content", this.options.rowClickModal).load($.trim(url), $.proxy(function (event) {
                                $(this.options.rowClickModal).modal("show");
                            }, this));
                        }
                    }
                    else
                    {
                        if (this.options.handleRowClick) {
                            this.options.handleRowClick(url, e, function () { defaultRowClickHandler(e, url, target) });
                        } else {
                            defaultRowClickHandler(e, url, target)
                        }
                    }
                }
            }, this));

            $(this.$element).on("mousedown", "tbody.data tr td:not(:has(input))", $.proxy(function (e)
            {
                var url = $.trim($(e.target).parents("tr").data("griddly-url"));

                if (url)
                    e.preventDefault();
            }, this));

            $(this.$element).on("click", "thead tr.columnHeaders th", $.proxy(function (event)
            {
                var sortField = $(event.currentTarget).data("griddly-sortfield");

                if (sortField)
                {
                    var currentPos = -1;

                    for (var i = 0; i < this.options.sortFields.length; i++)
                    {
                        if (this.options.sortFields[i].field == sortField)
                        {
                            currentPos = i;

                            break;
                        }
                    }

                    var currentDirection = currentPos != -1 ? this.options.sortFields[currentPos].direction : "Descending";
                    var newDirection = currentDirection == "Descending" ? "Ascending" : "Descending";

                    var inlineFilters = $("tr.griddly-filters-inline", this.$element);

                    if (!this.options.isMultiSort || !event.ctrlKey)
                    {
                        for (var i = 0; i < this.options.sortFields.length; i++)
                        {
                            var thisSortField = this.options.sortFields[i].field;

                            if (thisSortField != sortField)
                            {
                                var oldSortDisplay = $(event.currentTarget).parents("tr").find("th[data-griddly-sortfield='" + thisSortField + "']");

                                if (inlineFilters.length)
                                    oldSortDisplay = [oldSortDisplay[0], inlineFilters[0].cells[oldSortDisplay[0].cellIndex]];

                                $(oldSortDisplay).removeClass("sorted_a").removeClass("sorted_d");
                            }
                        }

                        this.options.sortFields = [];
                    }

                    if (currentPos != -1 && this.options.sortFields.length)
                        this.options.sortFields[currentPos].direction = newDirection;
                    else
                        this.options.sortFields.push({ field: sortField, direction: newDirection });


                    var newSortDisplay = [event.currentTarget];

                    if (inlineFilters.length)
                        newSortDisplay.push(inlineFilters[0].cells[newSortDisplay[0].cellIndex]);

                    if (newDirection == "Ascending")
                        $(newSortDisplay).removeClass("sorted_d").addClass("sorted_a");
                    else
                        $(newSortDisplay).removeClass("sorted_a").addClass("sorted_d");

                    this.refresh(true);
                }
            }, this));

            var onRowChange = $.proxy(function (event)
            {
                this.setSelectedCount();
                var self = this;

                this.$element.find("[data-append-rowids-to-url]").each(function ()
                {
                    var template = $(this).data("griddly-href-template");

                    if (template)
                    {
                        var selection = self.getSelected($(this).data("rowids"));
                        var query = [];

                        for (var k in selection)
                        {
                            query[query.length] = k + "=" + selection[k].join(",");
                        }

                        $(this).attr("href", template + (template.indexOf("?") > -1 ? "&" : "?") + query.join("&"));
                    }
                });
            }, this);

            var setRowSelect = this.setRowSelect = $.proxy(function ($checkbox, skipRowChange)
            {
                var rowkey = $checkbox.data("rowkey");
                var row = this.options.selectedRows[rowkey];

                if (!row && $checkbox.prop("checked"))
                {
                    var rowvalue = { "value": $checkbox.attr("value") };
                    var data = $checkbox.data();
                    for (var d in data)
                        rowvalue[d] = data[d];

                    this.options.selectedRows[rowkey] = rowvalue;
                }
                else if (row && !$checkbox.prop("checked"))
                {
                    delete this.options.selectedRows[rowkey];
                }

                $checkbox.closest("tr").toggleClass("sel", $checkbox.prop("checked"));

                if (skipRowChange != true)
                    onRowChange();
            }, this);

            $(this.$element).on("click", "input[name=_rowselect]", $.proxy(function (event) {
                var $checkbox = $(event.target);
                $checkbox.closest("tr").toggleClass("sel", $checkbox.prop("checked"));
            }, this));

            $(this.$element).on("click", "td.griddly-select", $.proxy(function (event)
            {
                var $target = $(event.target);

                var $checkbox = $target;
                if (!$target.is("input"))
                {
                    $checkbox = $target.find("input[name=_rowselect]");

                    if (!$checkbox.prop("disabled"))
                    {
                        $checkbox.prop("checked", !$checkbox.prop("checked"));
                    }
                }

                if (event.shiftKey && this.options.lastSelectedRow) {
                    var last = $("tbody tr", this.$element).index(this.options.lastSelectedRow);
                    var first = $("tbody tr", this.$element).index($target.parents("tr"));
                    var newstate = this.options.lastSelectedRow.find("input[name=_rowselect]").prop("checked");

                    var start = Math.min(first, last);
                    var end = Math.max(first, last);

                    $("tbody tr", this.$element).slice(start, end).find("input[name=_rowselect]").each(function () { $(this).prop("checked", newstate); setRowSelect($(this), true) });
                    setRowSelect($checkbox);

                    onRowChange();
                }
                else {
                    setRowSelect($checkbox);
                }

                this.options.lastSelectedRow = $target.parents("tr");
            }, this));

            $(this.$element).on("click", "thead tr.columnHeaders th.select", $.proxy(function (event)
            {
                if (this.$element.find("input[name=_rowselect]:not(:checked):not(:disabled)").length == 0)
                    this.$element.find("input[name=_rowselect]:not(:disabled)").prop("checked", false).each(function () { setRowSelect($(this), true); });
                else
                    this.$element.find("input[name=_rowselect]:not(:disabled)").prop("checked", true).each(function () { setRowSelect($(this), true); });

                onRowChange();
            }, this));

            $(this.$element).on("click", ".griddly-selection-clear", $.proxy(function (event)
            {
                this.clearSelected();
            }, this));

            $("a.export-custom", this.$element).on("click", $.proxy(function (e)
            {
                this.exportFile("custom", this.options.exportCustomFunction, { exportName: $(e.target).data("export-name") });
                e.preventDefault();
            }, this));
            $("a.export-xlsx", this.$element).on("click", $.proxy(function (e)
            {
                this.exportFile("xlsx", this.options.exportFunction, { exportName: $(e.target).data("export-name") });
                e.preventDefault();
            }, this));
            $("a.export-csv", this.$element).on("click", $.proxy(function (e)
            {
                this.exportFile("csv", this.options.exportFunction, { exportName: $(e.target).data("export-name") });
                e.preventDefault();
            }, this));
            $("a.export-tsv", this.$element).on("click", $.proxy(function (e)
            {
                this.exportFile("tsv", this.options.exportFunction, { exportName: $(e.target).data("export-name") });
                e.preventDefault();
            }, this));

            $(".griddly-filters-inline .griddly-filter .griddly-filter-clear", this.$element).click(function (e)
            {
                $(this).parents(".input-group").find("input").val("").focus().triggerHandler("change", [true]);
            });

            this.$inlineFilters = $(".griddly-filters-inline .filter-content input, .griddly-filters-inline .griddly-filter.griddly-html-filter input", this.$element);
            this.pendingInlineFilterRefresh = false;

            $(".griddly-filters-inline .filter-content input", this.$element).on("change", $.proxy(function (event, dontHide)
            {
                var self = this;

                var filter = $(event.currentTarget).data("griddly-filter");
                var content = filter.data("griddly-filter-content");
                var displayEl = filter.data("griddly-filter-display");

                var dataType = filter.data("filter-datatype");
                var display = null;
                var isEmpty = false;


                // TODO: shove formatted values back into boxes to ensure post is correct?
                // TODO: for numbers, do correctly shredded numeric (no symbols, but numbers and decimals etc.)
                // TODO: for dates, push actual formatted date
                if (filter.hasClass("griddly-filter-box"))
                {
                    if (!dontHide && this.options.autoRefreshOnFilter)
                        hidePopover(filter.find(".filter-trigger"), self.bootstrapVersion);

                    var val = trimToNull(getCleanedValue(content.find("input").first().val(), dataType));

                    content.find("input").first().val(val)

                    if (val != null)
                    {
                        display = getFormattedValue(val, dataType, this.options.currencySymbol);
                    }

                    if (display == null)
                    {
                        isEmpty = true;
                        display = "Any " + filter.data("filter-name");

                        content.find("input").first().val("");
                    }
                }
                else if (filter.hasClass("griddly-filter-range"))
                {
                    var val = trimToNull(getCleanedValue(content.find("input").first().val(), dataType));
                    var valEnd = trimToNull(getCleanedValue(content.find("input").last().val(), dataType));

                    content.find("input").first().val(val)
                    content.find("input").last().val(valEnd)

                    if (val != null && valEnd != null)
                        display = getFormattedValue(val, dataType, this.options.currencySymbol) + " - " + getFormattedValue(valEnd, dataType, this.options.currencySymbol);
                    else if (val != null)
                        display = (dataType == "Date" ? "After " : ">= ") + getFormattedValue(val, dataType, this.options.currencySymbol);
                    else if (valEnd != null)
                        display = (dataType == "Date" ? "Before " : "<= ") + getFormattedValue(valEnd, dataType, this.options.currencySymbol);

                    if (display == null || (dataType != "String" && display.indexOf("null") != -1))
                    {
                        isEmpty = true;
                        display = "All " + filter.data("filter-name-plural");

                        content.find("input").first().val("");
                        content.find("input").last().val("");
                    }
                }
                else if (filter.hasClass("griddly-filter-list"))
                {
                    if (!filter.data("griddly-filter-ismultiple") && !dontHide && this.options.autoRefreshOnFilter)
                        hidePopover(filter.find(".filter-trigger"), self.bootstrapVersion);

                    var allItems = content.find("li:not(.griddly-list-group-header), .dropdown-item");
                    var selectedItems = allItems.filter(":has(:checked)");
                    var displayItemCount = parseInt(filter.data("griddly-filter-displayitemcount"));

                    allItems.removeClass("griddly-filter-selected");
                    selectedItems.addClass("griddly-filter-selected");

                    if (selectedItems.length == allItems.length || (selectedItems.length == 0 && filter.data("griddly-filter-isnoneall"))) {
                        isEmpty = true;
                        display = (allItems.length == 2 && !filter.data("griddly-filter-isnullable") ? "Both " : "All ") + filter.data("filter-name-plural");
                    }
                    else if (selectedItems.length > displayItemCount)
                        display = selectedItems.length + " " + filter.data("filter-name-plural");
                    else if (selectedItems.length > 0 && selectedItems.length <= displayItemCount)
                    {
                        var itemTexts = self.bootstrapVersion == 4 || self.bootstrapVersion == 5 ? selectedItems : selectedItems.find("a");
                        var display = $.trim($(itemTexts[0]).text());

                        for (var i = 1; i < selectedItems.length && i < displayItemCount; i++)
                            display += ", " + $.trim($(itemTexts[i]).text());
                    }
                    else
                        display = "No " + filter.data("filter-name-plural");
                }

                if (display)
                    displayEl.text(display);
                displayEl.toggleClass("griddly-filter-display-empty", isEmpty);

            }, this));

            $(".griddly-filters-inline input, .griddly-filters-inline select", this.$element).on("change", $.proxy(function (event)
            {
                this.pendingInlineFilterRefresh = true;

                if (!this._isUpdatingFilters)
                {
                    this.triggerOrQueue(this.$element, "filterchange.griddly", this.$element, event.target);

                    if (this.options.autoRefreshOnFilter)
                        this.refresh(true);
                }
            }, this));

            $(this.$element).on("change", ".griddly-filters-form input, .griddly-filters-form select", $.proxy(function (event)
            {
                if (!this._isUpdatingFilters)
                    this.triggerOrQueue(this.$element, "filterchange.griddly", this.$element, event.target);
            }, this));

            // TODO: exclude this if the modal is still in griddly-filters-form? does it dupe?
            $(this.$filterModal).on("change", "input, select", $.proxy(function (event)
            {
                if (!this._isUpdatingFilters)
                    this.triggerOrQueue(this.$element, "filterchange.griddly", this.$element, event.target);
            }, this));

            $(".griddly-filters-inline .filter-content input", this.$element).keyup($.proxy(function (event)
            {
                if (event.which == 13)
                {
                    var $input = $(event.target);
                    $input.blur();

                    if (!this.options.autoRefreshOnFilter && this.pendingInlineFilterRefresh) {
                        this.refresh(true);
                    }

                    var filter = $input.data("griddly-filter");
                    hidePopover(filter.find(".filter-trigger"), this.bootstrapVersion);
                }
            }, this));

            $(".griddly-filters-inline .filter-trigger", this.$element).each($.proxy(function (i, el)
            {
                var self = this;

                var filter = $(el).parents(".griddly-filter");
                var content = filter.find(".filter-content");

                filter.data("griddly-filter-content", content);
                filter.data("griddly-filter-display", filter.find(".griddly-filter-display"));
                filter.find("input").data("griddly-filter", filter);

                var filterTrigger = $(el);
                filterTrigger.popover({
                    html: true,
                    placement: "bottom",
                    container: $(".griddly-filters-inline", this.$element),
                    template:
                        self.bootstrapVersion == 4 || self.bootstrapVersion == 5 ? '<div class="popover griddly-filter-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                        : '<div class="popover griddly-filter-popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                    content: function ()
                    {
                        return content;
                    }
                }).on("show.bs.popover", function ()
                {
                    hidePopover(self.$element.find(".griddly-filters-inline .filter-trigger").not(this), self.bootstrapVersion);

                    content.find("input:first").select();

                    content.show();
                }).on("shown.bs.popover", function ()
                {
                    content.find("input:first").focus();
                }).on("hide.bs.popover", function ()
                {
                    if (filter.data("griddly-filter-ismultiple") && filter.data("griddly-filter-isnoneall"))
                    {
                        if ($("input", content).length === $("input:checked", content).length)
                        {
                            $(".dropdown-menu li:not(.griddly-list-group-header), .dropdown-menu .dropdown-item", content).removeClass("griddly-filter-selected");
                            $("input", content).prop("checked", false).first().change();
                        }
                    }
                }).on("hidden.bs.popover", function ()
                {
                    content.hide();
                });

                if (this.options.autoRefreshOnFilter) {
                    $(".griddly-inline-filter-update", content).remove();
                }
                else {
                    $(".griddly-inline-filter-update", content).click($.proxy(function (e) {
                        if (this.pendingInlineFilterRefresh) {
                            this.refresh(true);
                        }
                        hidePopover(filterTrigger, this.bootstrapVersion);
                    }, this));
                }

            }, this));

            $(".griddly-filters-inline .filter-content .dropdown-menu", this.$element).each($.proxy(function (i, el)
            {
                var self = this;

                $("a", el).click(function ()
                {
                    var listGroupHeader = $(this).parents(".griddly-list-group-header");

                    if (listGroupHeader.length > 0)
                    {
                        var children = listGroupHeader.nextUntil(".griddly-list-group-header");

                        if (children.length != children.filter(".griddly-filter-selected").length)
                        {
                            item.addClass("griddly-filter-selected");

                            children.addClass("griddly-filter-selected");
                            children.find("input").prop("checked", true).first().change();
                        }
                        else
                        {
                            item.removeClass("griddly-filter-selected");

                            children.removeClass("griddly-filter-selected");
                            children.find("input").prop("checked", false).first().change();
                        }
                    }
                    else
                    {
                        var item = self.bootstrapVersion == 4 || self.bootstrapVersion == 5 ? $(this) : $(this).parents("li");

                        var checkbox = $(this).find("input");

                        var filter = checkbox.data("griddly-filter");

                        if (filter.data("griddly-filter-ismultiple"))
                        {
                            item.toggleClass("griddly-filter-selected");

                            checkbox.prop("checked", item.hasClass("griddly-filter-selected")).change();
                        }
                        else
                        {
                            var content = filter.data("griddly-filter-content");

                            content.find(".dropdown-menu li:not(.griddly-list-group-header), .dropdown-menu .dropdown-item").not(item).removeClass("griddly-filter-selected");
                            content.find("input").not(checkbox).prop("checked", false);

                            item.addClass("griddly-filter-selected");
                            checkbox.prop("checked", true).change();
                        }
                    }
                });
            }, this));

            $(".griddly-filters-inline .filter-content .griddly-select-all", this.$element).each($.proxy(function (i, el)
            {
                var self = this;

                var checkbox = $(el).parents(".filter-content").find("input:first");

                if (checkbox.length)
                {
                    var filter = checkbox.data("griddly-filter");

                    var selector = ".dropdown-menu li" + (!filter.data("griddly-filter-ismultiple") ? ":not(.griddly-list-group-header)" : "")
                        +", .dropdown-menu .dropdown-item";

                    $(el).click(function ()
                    {
                        $(this).parents(".filter-content").find(selector).addClass("griddly-filter-selected");
                        $(this).parents(".filter-content").find("input").prop("checked", true).first().change();
                    });
                }
            }, this));

            $(".griddly-filters-inline .filter-content .griddly-clear", this.$element).each($.proxy(function (i, el)
            {
                var self = this;

                var checkbox = $(el).parents(".filter-content").find("input:first");

                if (checkbox.length)
                {
                    var filter = checkbox.data("griddly-filter");

                    var selector = ".dropdown-menu li" + (!filter.data("griddly-filter-ismultiple") ? ":not(.griddly-list-group-header)" : "")
                        + ", .dropdown-menu .dropdown-item";

                    $(el).click(function ()
                    {
                        $(this).parents(".filter-content").find(selector).removeClass("griddly-filter-selected");
                        $(this).parents(".filter-content").find("input").prop("checked", false).first().change();
                    });
                }
            }, this));

            $(".griddly-filter-values", this.$element).on("click", ".griddly-remove-filter-value", $.proxy(removeFilterValueImpl, this));
        },

        exportFile: function (type, exec, data)
        {
            var params = this.buildRequest();

            params.exportFormat = type;
            $.extend(params, data);
            if (exec)
            {
                exec(this.options.url, params)
            }
            else
            {
                var url = this.options.url + (this.options.url.indexOf("?") == -1 ? "?" : "&") + $.param(params, true);
                window.location = url;
            }
        },

        getFilterMode: function ()
        {
            return this.options.filterMode;
        },

        setFilterMode: function (mode, noRefresh)
        {
            if (this.options.filterMode != mode && this.options.allowedFilterModes.indexOf(mode) > -1)
            {
                var currentFilters = this.getFilterValues();
                var request1 = this.buildRequest();

                this.options.filterMode = mode;

                this.$element.toggleClass("griddly-filter-inline", mode == "Inline");
                this.$element.toggleClass("griddly-filter-form", mode == "Form");

                this.$element.find(".griddly-filters:not(tr.griddly-filters-" + this.options.filterMode.toLowerCase() + ")").hide();
                this.$element.find(".griddly-filters-" + this.options.filterMode.toLowerCase()).show();

                this.setFilterValues(currentFilters, true, true);

                this.triggerOrQueue(this.$element, "setfiltermode.griddly", { mode: mode });

                var request2 = this.buildRequest();

                if (!noRefresh && JSON.stringify(request1) !== JSON.stringify(request2))
                {
                    this.refresh(true);
                }
            }
        },

        toggleFilterMode: function (noRefresh)
        {
            if (this.options.allowedFilterModes.length > 1)
            {
                this.setFilterMode(this.options.filterMode == "Inline" ? "Form" : "Inline", noRefresh);
            }
        },

        invokeFilterModal: function ()
        {
            this.$filterModal.modal("show");
        },

        getAllFilterElements: function ()
        {
            var allFilters;

            if (this.options.filterMode == "Inline")
            {
                allFilters = this.$inlineFilters;
                if (this.$filterModal) {
                    var modalFiltersNotOnInlineFilter = $(this.options.filtersSelector, this.$filterModal)
                        .filter(function () {
                            return $(this).val() && allFilters.filter("[name='" + $(this).attr("name") + "']").length == 0;
                        });
                    allFilters = allFilters.add(modalFiltersNotOnInlineFilter);
                }
            }
            else
            {
                allFilters = $(this.options.filtersSelector, this.$element.find(".griddly-filters-form"))
                    .add($(this.options.filtersSelector, this.$filterModal));
            }

            return allFilters;
        },

        getFilterElement: function (name)
        {
            var filter = "[name='" + name + "']";

            if (this.options.filterMode == "Inline")
                return this.$inlineFilters.filter(filter);
            else
                return $(".griddly-filters-form input" + filter + ", .griddly-filters-form select" + filter, this.$element)
                    .add($("input" + filter + ", select" + filter, this.$filterModal));
        },

        getFilterValues: function ()
        {
            var allFilters = this.getAllFilterElements();

            if (this.options.filterMode == "Inline")
            {
                // Filter out list with ismultiple=true, isnoneall=true and fully selected
                var noneAllSelectedFilters = $(".griddly-filters-inline .filter-content .dropdown-menu", this.$element).map($.proxy(function (i, el)
                {
                    var filter = $(el).parents(".griddly-filter");
                    var content = filter.find(".filter-content");

                    if (filter.data("griddly-filter-ismultiple") && filter.data("griddly-filter-isnoneall"))
                    {
                        if ($("input", content).length === $("input:checked", content).length)
                        {
                            return filter[0];
                        }
                    }

                    return null;
                }, this));

                if (noneAllSelectedFilters.length)
                {
                    allFilters = allFilters.filter(function (i, el)
                    {
                        return !noneAllSelectedFilters.is($(el).data("griddly-filter"));
                    });
                }
            }

            return serializeObject(allFilters, this.options.serializeSkipEmpty, this.options.multipleSelects);
        },

        setFilterValue: function (field, value)
        {
            var input;

            if (typeof (field) === "string")
                input = this.getAllFilterElements().filter(field);
            else
                input = $(field);

            setFilterValueImpl(input, value);
        },

        setFilterValues: function (filters, isPatch, noRefresh, resetNone)
        {
            this._isUpdatingFilters = true;

            var allFilters = this.getAllFilterElements();

            setFilterValuesImpl(allFilters, filters, isPatch, resetNone ? this.$element.find(".griddly-filters-form").add(this.$filterModal) : null);

            this.triggerOrQueue(this.$element, "setfilters.griddly", filters);

            this._isUpdatingFilters = false;

            this.updateFilterDisplay();

            if (!noRefresh)
                this.refresh(true);
        },

        resetFilterValues: function (refresh)
        {
            var form = this.$element.find("form");
            $(this.options.filtersSelector, form).each(resetFormElement);

            this.setSortFields(this.options.defaultSort);
            this.setFilterValues(this.options.filterDefaults, null, true, true);

            this.triggerOrQueue(this.$element, "resetfilters.griddly");

            if (refresh != false)
                this.refresh(true);
        },

        clearFilterValues: function (refresh)
        {
            this.setFilterValues({}, false, true, true);

            this.triggerOrQueue(this.$element, "resetfilters.griddly");

            if (refresh != false)
                this.refresh(true);
        },

        updateFilterDisplay: function ()
        {
            var hasFilter = false;

            if (this.options.filterMode == "Form")
            {
                var filters = this.getAllFilterElements().closest(".griddly-filter");

                hasFilter = updateFilterDisplayImpl(this.$element, filters, this.options.renderFilterDisplay, this.options.currencySymbol, null, this.options.removeIconCssClass);
            }
            else
            {
                var values = this.getFilterValues();

                for (var k in values)
                {
                    if (values[k])
                    {
                        hasFilter = true;

                        break;
                    }
                }

                updateFilterDisplayImpl(this.$element, filters, this.options.renderFilterDisplay, this.options.currencySymbol, hasFilter, this.options.removeIconCssClass);
            }

            this.updateDefaultStatus();

            this.triggerOrQueue(this.$element, "updatefilterdisplay.griddly");
        },

        updateDefaultStatus: function ()
        {
            var values = this.getFilterValues();
            var isDefaultFilter = deepCompare(this.options.filterDefaults, values);
            var isDefaultSort = deepCompare(this.options.defaultSort, this.options.sortFields);

            this.$element.toggleClass("griddly-filter-statuscandefault", (!isDefaultFilter && this.options.filterDefaults != null && Object.keys(this.options.filterDefaults).length > 0) || !isDefaultSort);
        },

        setSortFields: function (sortFields)
        {
            this.options.sortFields = sortFields;

            $("[data-griddly-sortfield], .griddly-filters-inline td", this.$element).removeClass("sorted_a sorted_d");

            if (this.options.sortFields && this.options.sortFields.length)
            {
                var inlineFilters = $(".griddly-filters-inline", this.$element);

                for (var i = 0; i < this.options.sortFields.length; i++)
                {
                    var sort = this.options.sortFields[i];

                    var header = $("th[data-griddly-sortfield='" + sort.field + "']", this.$element);

                    header.addClass(sort.direction == "Ascending" ? "sorted_a" : "sorted_d");

                    if (inlineFilters.length)
                    {
                        var inlineFilter = inlineFilters[0].cells[header[0].cellIndex];

                        $(inlineFilter).addClass(sort.direction == "Ascending" ? "sorted_a" : "sorted_d");
                    }
                }
            }
        },

        getAdditionalRequestValues: function ()
        {
            return this.additionalRequestValues;
        },

        setAdditionalRequestValues: function (values)
        {
            this.additionalRequestValues = values;
        },

        buildRequest: function (paging)
        {
            var postData = this.getFilterValues();

            if (this.options.sortFields.length)
            {
                for (var i = 0; i < this.options.sortFields.length; i++)
                {
                    var field = this.options.sortFields[i];

                    postData["sortFields[" + i + "][" + field.field + "]"] = field.direction;
                }
            }

            if (!paging)
            {
                $.extend(postData,
                {
                    pageNumber: this.options.pageNumber,
                    pageSize: this.options.pageSize
                });
            }

            if (this.additionalRequestValues)
            {
                $.extend(postData, this.additionalRequestValues);
            }

            return postData;
        },

        refresh: function (resetPage)
        {
            if (typeof this.lastRefreshId == 'undefined')
                this.lastRefreshId = 0;

            this.pendingInlineFilterRefresh = false;

            this.triggerOrQueue(this.$element, "beforerefresh.griddly");

            if (!this.options.url)
            {
                window.location = window.location;

                return;
            }

            if (resetPage)
                this.options.pageNumber = 0;

            this.options.lastSelectedRow = null;

            var postData = this.buildRequest();

            if (this.hasHistory && window.history && history.replaceState)
            {
                var state =
                {
                    pageNumber: this.options.pageNumber,
                    pageSize: this.options.pageSize,
                    sortFields: this.options.sortFields,
                    filterMode: this.getFilterMode(),
                    filterValues: this.getFilterValues()
                };

                var globalState = history.state || {};

                if (!globalState.griddly)
                    globalState.griddly = {};

                globalState.griddly[this.options.url] = state;

                history.replaceState(globalState, document.title);
            }

            this.updateFilterDisplay();

            // TODO: cancel any outstanding calls

            this.lastRefreshId = this.lastRefreshId + 1;
            var refreshId = this.lastRefreshId;

            $.ajax(this.options.url,
            {
                type: "post",
                data: postData,
                traditional: true,
                cache: false
            }).done($.proxy(function (data, status, xhr)
            {
                if (this.lastRefreshId == refreshId) //Don't update anything if the refresh request didn't return in order. A subsequent request has already updated the grid.
                {
                    var count = parseInt(xhr.getResponseHeader("X-Griddly-Count"));
                    var currentPageSize = parseInt(xhr.getResponseHeader("X-Griddly-CurrentPageSize"));

                    this.options.count = count;
                    this.options.pageCount = Math.ceil(this.options.count / this.options.pageSize);
                    // TODO: handle smaller count

                    var html = $("<table>" + data + "</table>");

                    // replaceWith is more performant, but using inner html allows us to maintain the tbody element which is potentially important for some other libraries
                    // https://github.com/programcsharp/griddly/issues/79
                    this.$element.find("tbody.data").html(html.children("tbody").html());

                    var tfoot = this.$element.find("tfoot.totals-tfoot");
                    if (tfoot.length && html.children("tfoot.totals-tfoot").length)
                        tfoot.replaceWith(html.children("tfoot.totals-tfoot"));

                    var emptyMessage = this.$element.find("tfoot.empty-grid-message");
                    if (emptyMessage.length && html.children("tfoot.empty-grid-message").length)
                        emptyMessage.replaceWith(html.children("tfoot.empty-grid-message"));

                    var startRecord = this.options.pageNumber * this.options.pageSize;

                    this.$element.find(".griddly-recordstart").html(startRecord + (this.options.count ? 1 : 0));
                    this.$element.find(".griddly-recordend").html(startRecord + currentPageSize);
                    this.$element.find(".griddly-recordtotal").html(this.options.count);

                    this.$element.find(".pageCount").html(this.options.pageCount);

                    this.$element.find("input.pageNumber").val(this.options.pageNumber + 1);

                    if (startRecord >= this.options.count - this.options.pageSize)
                        this.$element.find(".next").hide();
                    else
                        this.$element.find(".next").show();

                    if (startRecord >= this.options.pageSize)
                        this.$element.find(".prev").show();
                    else
                        this.$element.find(".prev").hide();

                    if (this.options.count <= this.options.pageSize)
                        this.$element.find(".griddly-pager").hide();
                    else
                        this.$element.find(".griddly-pager").show();

                    // iterate through table and check rows that are in the selected list and have a checkbox
                    var _this = this;
                    // Filter/sort changes (resetPage) drop selections that no longer match the result set.
                    // Page navigation preserves off-page selections so users can accumulate selections across pages.
                    var remainingRows = resetPage ? { } : $.extend({}, _this.options.selectedRows);

                    $("tbody tr", this.$element).find("input[name=_rowselect]").each(function (index, e) {
                        var rowkey = $(e).data("rowkey");
                        var row = _this.options.selectedRows[rowkey];

                        if (row)
                        {
                            $(e).prop("checked", true);

                            remainingRows[rowkey] = row;
                        }
                    });

                    // update selected rows to only those that are still present, in case an update filtered them away
                    _this.options.selectedRows = remainingRows;
                    this.setSelectedCount();
                    
                    this.triggerOrQueue(this.$element, "refresh.griddly",
                        {
                            start: startRecord,
                            pageSize: currentPageSize,
                            count: count
                        });

                    this.$element.removeClass("griddly-init");
                    this.$element.prev(".griddly-init-flag").val("loaded");
                }
            }, this))
            .fail($.proxy(function (xhr, status, errorThrown)
            {
                if (xhr.status != 0)
                {
                    if (this.options.onError)
                    {
                        this.options.onError(xhr, status, errorThrown);
                    }
                    else
                    {
                        var url = this.options.url + (this.options.url.indexOf('?') == -1 ? "?" : "&");

                        url += $.param(postData);

                        window.location = url;
                    }

                    this.triggerOrQueue(this.$element, "error.griddly", { xhr: xhr, status: status, error: errorThrown });
                }
            }, this));
        },

        toggleColumnVisible: function (columnId, visible) {
            var colElement = $("colgroup col[data-columnid='" + columnId + "']", this.$element);
            var colIdx = colElement.index();

            if (typeof visible === 'undefined')
                visible = colElement.hasClass("column-hidden");

            var prevColspan = $("colgroup:first>col:not(.column-hidden)", this.$element).length;
            colElement.toggleClass("column-hidden", !visible)
            var colspan = $("colgroup:first>col:not(.column-hidden)", this.$element).length;

            $(">table>>tr, >table>>fthtr", this.$element.find(".griddly-scrollable-container")).each(function () {
                $(">:eq(" + colIdx + "):not([colspan])", $(this)).toggleClass("column-hidden", !visible);
                $(">[colspan='" + prevColspan + "']", $(this)).attr("colspan", colspan);
            });

            return visible;
        },

        getSelected: function (arrayIdNames)
        {
            if (arrayIdNames === "all")
                return this.options.selectedRows;

            if (!arrayIdNames)
                arrayIdNames = this.options.defaultRowIds;
            else if (typeof arrayIdNames === "string")
                arrayIdNames = [arrayIdNames];

            var result = {};
            for (var name in arrayIdNames)
                result[arrayIdNames[name]] = $.map(this.options.selectedRows, function (x) { return x[arrayIdNames[name]] });

            return result;
        },

        setSelectedCount: function ()
        {
            var count = Object.keys(this.options.selectedRows).length;

            $(".griddly-selection-count", this.$element).text(count);

            if (!$.isEmptyObject(this.options.selectedRows))
            {
                var el = this.$element.find(".griddly-selection");

                if (el.is(":not(:visible)"))
                {
                    if (el.is("span"))
                        el.animate({ width: "show" }, 350);
                    else
                        el.show(350);
                }

                $(this.$element).find("[data-enable-on-selection=true]").removeClass("disabled");
            }
            else
            {
                var el = this.$element.find(".griddly-selection:visible");

                if (el.is("span"))
                    el.animate({ width: "hide" }, 350);
                else
                    el.hide(350);

                $(this.$element).find("[data-enable-on-selection=true]").addClass("disabled");
            }

            this.$element.find(".griddly-selection-singular").toggle(count == 1);
            this.$element.find(".griddly-selection-plural").toggle(count != 1);

            this.$element.triggerHandler("selectionchanged.griddly", [count, this.options.selectedRows]);
        },

        clearSelected: function ()
        {
            this.options.selectedRows = {};

            $("tbody tr", this.$element).find("input[name=_rowselect]").prop("checked", false);

            this.setSelectedCount();
        },

        pageNumber: function (pageNumber)
        {
            if (pageNumber >= 0 && pageNumber < this.options.pageCount)
                this.options.pageNumber = pageNumber;
            // TODO: refresh auto?
        },

        pageSize: function (pageSize)
        {
            var originalSize = this.options.pageSize;

            this.options.pageSize = pageSize;

            this.triggerOrQueue(this.$element, "pagesizechanged.griddly",
                {
                    originalSize: originalSize,
                    pageSize: pageSize
                });

            // TODO: refresh auto?
        },

        // destroy and unbind
        destroy: function ()
        {

        },

        option: function (options)
        {
            this.options = Object.assign(this.options, options);
        }
    };

    $.fn.griddly = function (option, parameter)
    {
        var value;
        var args = arguments;

        this.each(function ()
        {
            var data = $(this).data('griddly'),
                options = typeof option == 'object' && option;

            // initialize griddly
            if (!data)
            {
                var instanceOptions = $.extend({}, $.fn.griddly.defaults, options);

                $(this).data('griddly', (data = new Griddly(this, instanceOptions)));

                var event = data.eventQueue.pop();
                while (event)
                {
                    event[0].trigger.apply(event[0], Array.prototype.slice.call(event, 1))
                    event = data.eventQueue.pop();
                }
            }

            // call griddly method
            if (typeof option == 'string')
            {
                value = data[option].apply(data, Array.prototype.slice.call(args, 1));
            }
            else if (typeof option == "object")
            {
                data["option"].apply(data, args);
            }
        });

        if (value !== undefined)
            return value;
        else
            return this;
    };

    var defaultCleanedDate = function(str) {return String(str).replace(/[^0-9a-zA-Z-\/]/g, "");};
    var defaultFormatedDate = function(str) {
        var val = parseForValidDate(str);
        return (val == null || !isFinite(val))
            ? null
            : (val.getMonth() + 1) + "/" + val.getDate() + "/" + val.getFullYear();
    };
    var defaultFilterDate = function(strOrDate) {
        var date;
        var pos;

        if (typeof (strOrDate) === "string" && (pos = strOrDate.indexOf("T")) != -1)
        {
            strOrDate = strOrDate.substr(0, pos);

            // Strip time, we only want date
            var parts = strOrDate.split('-');

            // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
            date = new Date(parts[0], parts[1] - 1, parts[2]); // Note: months are 0-based
        }
        else
            date = new Date(strOrDate);

        date.setHours(0, 0, 0, 0);

        return date.toLocaleDateString();
    };

    $.fn.griddly.defaults = $.extend({},
    {
        pageNumber: 0,
        pageSize: 20,
        onError: null,
        isMultiSort: true,
        lastSelectedRow: null,
        rowClickModal: null,
        handleRowClick: null,
        handleRowClickModal: null,
        selectedRows: null,
        autoRefreshOnFilter: true,
        filterMode: null,
        allowedFilterModes: [],
        isFilterFormInline: false,
        currencySymbol: "$",
        confirmPromptFunction: null,
        renderFilterDisplay: renderFilterDisplayImpl,
        serializeSkipEmpty: true,
        filtersSelector: "input[name], select[name]",
        exportCustomFunction: null,
        exportFunction: null,
        getCleanedDate: defaultCleanedDate,
        getFormattedDate: defaultFormatedDate,
        getFilterDate: defaultFilterDate
    }, $.fn.griddlyGlobalDefaults);

    var GriddlyFilterBar = function (element, options)
    {
        this.$element = $(element);
        this.$filterModal = $(".griddly-filter-modal", this.$element);
        this.options = options;
        this.create();

        var self = this;

        this.$filterModal
            .on("show.bs.modal", function ()
            {
                var values = self.getFilterValues();

                $(".griddly-filter-cancel, button.close", this).off("click").on("click", function ()
                {
                    if (self.$element.triggerHandler("beforeclear.griddly") !== false)
                        self.setFilterValues(values, false);
                });
            })
            .on("shown.bs.modal", function ()
            {
                $(".modal-body :input:visible:not([disabled]):not([data-griddly-filter-data-type=Date]):first", this).focus();
            });

        this.isConstructed = true;
    };

    GriddlyFilterBar.prototype = {
        constructor: GriddlyFilterBar,

        _isUpdatingFilters: false,

        // create and bind
        create: function ()
        {
            var filterDefaults = this.$element.data("griddly-filter-defaults");
            var currencySymbol = this.$element.data("griddly-currency-symbol");

            this.options.filterDefaults = filterDefaults;

            if (currencySymbol)
                this.options.currencySymbol = currencySymbol;

            var multipleSelects = [];

            this.$element.find("[data-griddly-filter-ismultiple=true]").each(
                function (el, i)
                {
                    return multipleSelects.push($(this).data("filter-field"));
                });

            this.options.multipleSelects = multipleSelects;

            $("form", this.$element).attr("onsubmit", "return false;");

            $("form", this.$element).on("submit", $.proxy(function (event)
            {
                this.$filterModal.modal("hide");

                this.updateFilterDisplay();

                event.preventDefault();
            }, this));

            $(".griddly-search-reset", this.$element).on("click", $.proxy(function (event)
            {
                this.resetFilterValues();

                event.preventDefault();
            }, this));

            $(".griddly-search-clear", this.$element).on("click", $.proxy(function (event)
            {
                this.clearFilterValues();

                event.preventDefault();
            }, this));

            $(".griddly-filter-invoke", this.$element).on("click", $.proxy(function (event)
            {
                this.invokeFilterModal();

                event.preventDefault();
            }, this));

            $(this.$filterModal).on("change", "input, select", $.proxy(function (event)
            {
                if (!this._isUpdatingFilters)
                    this.$element.triggerHandler("filterchange.griddlyFilterBar", event.target);
            }, this));

            $(".griddly-filter-values", this.$element).on("click", ".griddly-remove-filter-value", $.proxy(removeFilterValueImpl, this));
        },

        invokeFilterModal: function ()
        {
            this.$filterModal.modal("show");
        },

        getAllFilterElements: function ()
        {
            var allFilters = $(this.options.filtersSelector, this.$filterModal);

            return allFilters;
        },

        getFilterElement: function (name)
        {
            var filter = "[name='" + name + "']";

            return $("input" + filter + ", select" + filter, this.$filterModal);
        },

        getFilterValues: function ()
        {
            var allFilters = this.getAllFilterElements();

            return serializeObject(allFilters, this.options.serializeSkipEmpty, this.options.multipleSelects);
        },

        setFilterValue: function (field, value)
        {
            var input;

            if (typeof (field) === "string")
                input = this.getAllFilterElements().filter(field);
            else
                input = $(field);

            setFilterValueImpl(input, value);
        },

        setFilterValues: function (filters, isPatch)
        {
            this._isUpdatingFilters = true;

            var allFilters = this.getAllFilterElements();

            setFilterValuesImpl(allFilters, filters, isPatch, this.$filterModal);

            this.$element.triggerHandler("setfilters.griddlyFilterBar", filters);

            this._isUpdatingFilters = false;

            this.updateFilterDisplay();
        },

        resetFilterValues: function (refresh)
        {
            var form = this.$element.find("form");

            $(this.options.filtersSelector, form).each(resetFormElement);

            this.setFilterValues(this.options.filterDefaults);

            this.$element.triggerHandler("resetfilters.griddlyFilterBar");
        },

        clearFilterValues: function (refresh)
        {
            this.setFilterValues({}, false);

            this.$element.triggerHandler("resetfilters.griddlyFilterBar");
        },

        updateFilterDisplay: function ()
        {
            var filters = this.getAllFilterElements().closest(".griddly-filter");

            updateFilterDisplayImpl(this.$element, filters, this.options.renderFilterDisplay, this.options.currencySymbol, null, this.options.removeIconCssClass);

            this.$element.triggerHandler("updatefilterdisplay.griddlyFilterBar");
        },

        // destroy and unbind
        destroy: function ()
        {

        }
    };

    $.fn.griddlyFilterBar = function (option, parameter)
    {
        var value;
        var args = arguments;

        this.each(function ()
        {
            var data = $(this).data('griddlyFilterBar'),
                options = typeof option == 'object' && option;

            // initialize griddly
            if (!data)
            {
                var instanceOptions = $.extend({}, $.fn.griddly.defaults, options);

                $(this).data('griddlyFilterBar', (data = new GriddlyFilterBar(this, instanceOptions)));

            }

            // call griddly method
            if (typeof option == 'string')
            {
                value = data[option].apply(data, Array.prototype.slice.call(args, 1));
            }
        });

        if (value !== undefined)
            return value;
        else
            return this;
    };

    $.fn.griddlyFilterBar.defaults = $.extend({},
        {
            currencySymbol: "$",
            renderFilterDisplay: renderFilterDisplayImpl
        }, $.fn.griddlyFilterBarGlobalDefaults);


    function GriddlyButton()
    { }

    GriddlyButton.handleClick = $.proxy(function (event)
    {
        var button = $(event.currentTarget);

        if (button.hasClass("disabled"))
            return false;

        var griddly = button.closest("[data-role=griddly]");
        var url = button.data("url");
        var toggle = button.data("toggle");
        var onclick = button.data("onclick");
        var confirmMessage = button.data("confirm-message");
        var enableOnSelection = button.data("enable-on-selection");
        var clearSelectionOnAction = button.data("clear-selection-on-action");
        var rowIds = button.data("rowids");
        var confirmPromptFunction = button.data("confirm-prompt-function");

        if (confirmPromptFunction && Object.prototype.toString.call(window[confirmPromptFunction]) == '[object Function]')
            confirmPromptFunction = window[confirmPromptFunction];
        else if ($.fn.griddly.defaults.confirmPromptFunction)
            confirmPromptFunction = $.fn.griddly.defaults.confirmPromptFunction;
        else
        {
            confirmPromptFunction = function (message, callback)
            {
                if (confirm(message))
                    callback();
            }
        }

        var selection = {};

        if (griddly.length)
        {
            selection = griddly.griddly("getSelected", rowIds);

            if (selection.value)
            {
                selection.ids = selection.value;
                delete selection.value;
            }
        }

        var selectedCount = Object.keys(selection).length ? selection[Object.keys(selection)[0]].length : 0;
        var templatedConfirmMessage;

        if (typeof confirmMessage !== "undefined")
        {
            templatedConfirmMessage = confirmMessage.replace("${count}", selectedCount);

            if (selectedCount == 1)
                templatedConfirmMessage = templatedConfirmMessage.replace(/\${plural:.*?}/g, "").replace(/\${singular:(.*?)}/g, "$1");
            else
                templatedConfirmMessage = templatedConfirmMessage.replace(/\${singular:.*?}/g, "").replace(/\${plural:(.*?)}/g, "$1");;
        }

        var execute = $.proxy(function ()
        {
            if (button.triggerHandler("beforeExecute") !== false)
            {
                if (!url)
                    url = button.attr("href");

                if (toggle && ["ajaxbulk", "postcriteria", "ajax", "post"].indexOf(toggle) > -1)
                {
                    if (clearSelectionOnAction && griddly.length)
                        griddly.griddly("clearSelected");

                    switch (toggle)
                    {
                        case "ajaxbulk":
                            if (selectedCount == 0 && enableOnSelection)
                                return;

                            return this.ajaxBulk(url, selection, button, griddly);

                        case "post":
                            if (selectedCount == 0 && enableOnSelection)
                                return;

                            return this.post(url, selection, button, griddly);

                        case "postcriteria":
                            if (!griddly)
                                return;

                            return this.postCriteria(url, griddly.griddly("buildRequest"));

                        case "ajax":
                            if (selectedCount == 0 && enableOnSelection)
                                return;

                            return this.ajax(url, selection, button, griddly);
                    }
                }
                else if (!toggle && url && typeof confirmMessage !== "undefined")
                    window.location = url;

                if (onclick)
                {
                    var f = window[onclick];

                    if ($.isFunction(f))
                    {
                        var result = f.call(button, rowIds, event);

                        if (clearSelectionOnAction && griddly.length)
                        {
                            griddly.griddly("clearSelected");
                        }

                        return result;
                    }

                    throw "onclick must be a global function";
                    // we do not support eval cause it's insecure
                }
            }
        }, this);

        if (typeof confirmMessage === "undefined")
        {
            execute();

            return true;
        }
        else
        {
            confirmPromptFunction(templatedConfirmMessage, execute);

            return false;
        }
    }, GriddlyButton);

    GriddlyButton.ajaxBulk = function (url, selection, button, griddly)
    {
        $.ajax(url,
        {
            data: selection,
            traditional: true,
            type: "POST"
        }).done($.proxy(function (data, status, xhr)
        {
            // TODO: handle errors
            // TODO: go back to first page?
            griddly.griddly("refresh");

            button.trigger("afterExecute", [data, status, xhr]);
        }, this));
    };

    GriddlyButton.post = function (url, selection, button, griddly)
    {
        var inputs = "";

        var token = $("input[name^=__RequestVerificationToken]").first();

        if (token.length)
            inputs += '<input type="hidden" name="' + token.attr("name") + '" value="' + token.val() + '" />';

        for (var idname in selection)
        {
            $.each(selection[idname], function ()
            {
                inputs += "<input name=\"" + idname + "\" value=\"" + this + "\" />";
            });
        }

        $("<form action=\"" + url + "\" method=\"post\">" + inputs + "</form>")
            .appendTo("body").submit().remove();

        return false;
    };

    GriddlyButton.postCriteria = function (url, request, button, griddly)
    {
        var inputs = "";

        var token = $("input[name^=__RequestVerificationToken]").first();

        if (token.length)
            inputs += '<input type="hidden" name="' + token.attr("name") + '" value="' + token.val() + '" />';

        for (var key in request)
        {
            var value = request[key];

            if (value.constructor === Array)
            {
                for (var i = 0; i < value.length; i++)
                    inputs += '<input name="' + key + '" value="' + ("" + value[i]).replaceAll("\"", "&quot;") + '" />';
            }
            else
                inputs += '<input name="' + key + '" value="' + ("" + value).replaceAll("\"", "&quot;") + '" />';
        }

        $("<form action=\"" + url + "\" method=\"post\">" + inputs + "</form>")
            .appendTo("body").submit().remove();
    };

    GriddlyButton.ajax = function (url, selection, button, griddly, clearSelection)
    {
        for (var i = 0; i < selection[Object.keys(selection)[0]].length; i++)
        {
            var postdata = {};
            for (var k in selection)
            {
                postdata[k === "ids" ? "id" : k] = selection[k][i];
            }

            $.ajax(url,
            {
                data: postdata,
                type: "POST"
            }).done($.proxy(function (data, status, xhr)
            {
                // TODO: handle errors
                // TODO: go back to first page?
                griddly.griddly("refresh");

                button.trigger("afterExecute", [data, status, xhr]);
            }, this));
        }
    };

    //$("[data-role=griddly]").griddly();

    $(function ()
    {
        $("[data-role=griddly]").griddly();
        $("[data-role=griddly-filter-bar]").griddlyFilterBar();

        $(document).on("click", "[data-role=griddly-button]:not(.griddly table a[data-toggle=ajax],.griddly table a[data-toggle=post])", GriddlyButton.handleClick);

        // patch bootstrap js so it doesn't .empty() our inline filter dropdowns
        // include if using bootstrap < 3.3.0
        //var setContent = $.fn.popover.Constructor.prototype.setContent;

        //$.fn.popover.Constructor.prototype.setContent = function ()
        //{
        //    var $tip = this.tip();

        //    $tip.find('.popover-content').children().detach();

        //    setContent.call(this);
        //};
    });
}(window.jQuery);
/* =============================================================
 * bootstrap-combobox.js v1.1.7
 * =============================================================
 * Copyright 2012 Daniel Farrell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */

!function ($)
{

    "use strict";

    /* COMBOBOX PUBLIC CLASS DEFINITION
     * ================================ */

    var Combobox = function (element, options)
    {
        this.options = $.extend({}, $.fn.combobox.defaults, options);
        this.template = this.options.template || this.template
        this.$source = $(element);
        this.$container = this.setup();
        this.$element = this.$container.find('input[type=text]');
        this.$target = this.$container.find('input[type=hidden]');
        this.$button = this.$container.find('.dropdown-toggle');
        this.$menu = $(this.options.menu).appendTo('body');
        this.matcher = this.options.matcher || this.matcher;
        this.sorter = this.options.sorter || this.sorter;
        this.highlighter = this.options.highlighter || this.highlighter;
        this.shown = false;
        this.selected = false;
        this.refresh();
        this.transferAttributes();
        this.listen();
    };

    Combobox.prototype = {

        constructor: Combobox

    , setup: function ()
    {
        var combobox = $(this.template());

        this.$source.before(combobox);
        this.$source.hide();

        combobox.parent().find(".combobox-temporary").remove();

        return combobox;
    }

    , disable: function ()
    {
        this.$element.prop('disabled', true);
        this.$button.attr('disabled', true);
        this.disabled = true;
        this.$container.addClass('combobox-disabled');
    }

    , enable: function ()
    {
        this.$element.prop('disabled', false);
        this.$button.attr('disabled', false);
        this.disabled = false;
        this.$container.removeClass('combobox-disabled');
    }
    , parse: function ()
    {
        var that = this
          , map = {}
          , source = []
          , selected = false
          , selectedValue = ''
          , selectedThumbnail = null;
        this.$source.find('option').each(function ()
        {
            var option = $(this);

            if (option.val() === '')
            {
                that.options.placeholder = option.text();
                return;
            }

            map[option.text()] =
            {
                value: option.val(),
                text: option.text(),
                thumbnail: $(option).attr("data-thumbnail") ? $(option).attr("data-thumbnail") : null
            };

            source.push(option.text());

            if (option.prop('selected'))
            {
                selected = option.text();
                selectedValue = option.val();
                selectedThumbnail = $(option).attr("data-thumbnail") ? $(option).attr("data-thumbnail") : null;
            }
        })
        this.map = map;
        if (selected)
        {
            this.$element.val(selected);
            this.$target.val(selectedValue);

            if (this.options.hasThumbnail && selectedThumbnail && selectedThumbnail.length > 0)
                this.$element.css("background-image", "url(" + selectedThumbnail + ")");

            this.$target.attr("data-text", selected);
            this.$container.addClass('combobox-selected');
            this.selected = true;
        }
        return source;
    }

    , transferAttributes: function ()
    {
        this.options.placeholder = this.$source.attr('data-placeholder') || this.options.placeholder
        if (this.options.appendId !== "undefined")
        {
            this.$element.attr('id', this.$source.attr('id') + this.options.appendId);
        }
        this.$element.attr('placeholder', this.options.placeholder)
        this.$target.prop('name', this.$source.prop('name'))
        this.$target.val(this.$source.val())
        this.$source.removeAttr('name')  // Remove from source otherwise form will pass parameter twice.
        this.$element.attr('required', this.$source.attr('required'))
        this.$element.attr('rel', this.$source.attr('rel'))
        this.$element.attr('title', this.$source.attr('title'))
        this.$element.attr('class', this.$source.attr('class'))
        this.$element.attr('tabindex', this.$source.attr('tabindex'))
        this.$element.attr('aria-required', this.$source.is('[data-val-required]') ? 'true' : null)
        this.$source.removeAttr('tabindex')
        if (this.$source.attr('disabled') !== undefined)
            this.disable();
    }

    , select: function ()
    {
        var val = this.$menu.find('.active').attr('data-value');
        this.$element.val(this.updater(val)).trigger('change');

        var mapObj = this.map[val];
        var mapValue = "";
        var mapThumbnail = "";

        if (mapObj != null)
        {
            mapValue = this.map[val].value;
            mapThumbnail = this.map[val].thumbnail;
        }

        if (this.options.hasThumbnail && mapThumbnail && mapThumbnail.length > 0)
            this.$element.css("background-image", "url(" + mapThumbnail + ")");

        this.$target.val(mapValue).attr("data-text", val).trigger('change');
        this.$source.val(mapValue).trigger('change');

        this.$container.addClass('combobox-selected');
        this.selected = true;
        return this.hide();
    }

    , updater: function (item)
    {
        return item;
    }

    , show: function ()
    {
        var pos = $.extend({}, this.$element.position(), {
            height: this.$element[0].offsetHeight
        });

        var scrollTop = 0;

        if (this.$element.parents().is(function () { return $(this).css("position") == "fixed"; }))
            scrollTop = $(document).scrollTop();

        this.$menu
          .insertAfter(this.$element)
          .css({
              top: pos.top + pos.height,
              left: pos.left,
              maxHeight: $(window).height() - (this.$element.offset().top - scrollTop + pos.height) * 2
          })
          .show();

        var active = this.$menu.find(".active");

        if (active.length)
            active[0].scrollIntoView();

        $('.dropdown-menu').on('mousedown', $.proxy(this.scrollSafety, this));

        this.shown = true;
        return this;
    }

    , hide: function ()
    {
        this.$menu.hide();
        $('.dropdown-menu').off('mousedown', $.proxy(this.scrollSafety, this));
        this.$element.on('blur', $.proxy(this.blur, this));
        this.shown = false;
        return this;
    }

    , lookup: function (event)
    {
        this.query = this.$element.val();
        return this.process(this.source);
    }

    , process: function (items)
    {
        var that = this;

        items = $.grep(items, function (item)
        {
            return that.matcher(item);
        })

        items = this.sorter(items);

        if (!items.length)
        {
            return this.shown ? this.hide() : this;
        }

        return this.render(items.slice(0, this.options.items)).show();
    }

    , template: function ()
    {
        if (this.options.bsVersion == '2')
        {
            return '<div class="combobox-container"><input type="hidden" /> <div class="input-append"> <input type="text" autocomplete="off" /> <span class="add-on dropdown-toggle" data-dropdown="dropdown"> <span class="caret"/> <i class="icon-remove"/> </span> </div> </div>';
        }
        else
        {
            return '<div class="combobox-container' + (this.options.hasThumbnail ? ' hasThumbnail' : '') + '"><input type="hidden" /> <div class="input-group"> <input type="text" autocomplete="off" spellcheck="false" /> <span class="input-group-btn dropdown-toggle" data-dropdown="dropdown"> <a class="btn btn-default btn-lg"><i class="fa fa-angle-down"></i></a> </span> </div> </div>';
        }
    }

    , matcher: function (item)
    {
        return ~item.toLowerCase().indexOf(this.query.toLowerCase());
    }

    , sorter: function (items)
    {
        var beginswith = []
          , caseSensitive = []
          , caseInsensitive = []
          , item;

        while (item = items.shift())
        {
            if (!item.toLowerCase().indexOf(this.query.toLowerCase())) { beginswith.push(item); }
            else if (~item.indexOf(this.query)) { caseSensitive.push(item); }
            else { caseInsensitive.push(item); }
        }

        return beginswith.concat(caseSensitive, caseInsensitive);
    }

    , highlighter: function (item)
    {
        if (this.query && this.query.length > 0)
        {
            var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');

            return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match)
            {
                return '<strong>' + match + '</strong>';
            });
        }
        else
            return item;
    }

    , render: function (items)
    {
        var that = this;

        items = $(items).map(function (i, item)
        {
            i = $(that.options.item).attr('data-value', item);

            if (that.options.hasThumbnail)
            {
                if (i.find("img").length)
                {
                    var mapObj = that.map[item];

                    if (mapObj && mapObj.thumbnail)
                        i.find('img').attr("src", mapObj.thumbnail)
                }
            }

            if (i.find(".content").length)
                i.find('.content').html(that.highlighter(item));
            else
                i.find('a').html(that.highlighter(item));

            return i[0];
        })

        if (this.query && this.query.length > 0)
            items.first().addClass('active');
        else
        {
            items.removeClass("active");

            var targetText = this.$target.attr("data-text");

            if (targetText && targetText.length > 0)
                items.filter("[data-value='" + this.$target.attr("data-text") + "']").addClass("active");
        }

        this.$menu.html(items);

        return this;
    }

    , next: function (event)
    {
        var active = this.$menu.find('.active').removeClass('active')
          , next = active.next();

        if (!next.length)
        {
            next = $(this.$menu.find('li')[0]);
        }

        next.addClass('active');
    }

    , prev: function (event)
    {
        var active = this.$menu.find('.active').removeClass('active')
          , prev = active.prev();

        if (!prev.length)
        {
            prev = this.$menu.find('li').last();
        }

        prev.addClass('active');
    }

    , toggle: function ()
    {
        if (!this.disabled)
        {
            if (this.shown)
                this.hide();
            else
            {
                this.query = null;
                this.render(this.source).show();
            }
        }
    }

    , scrollSafety: function (e)
    {
        if (e.target.tagName == 'UL')
        {
            this.$element.off('blur');
        }
    }
    , clearElement: function ()
    {
        this.$element.val('').focus();
    }

    , clearTarget: function ()
    {
        this.$source.val('');
        this.$target.val('');
        this.$target.removeAttr("data-text");
        this.$container.removeClass('combobox-selected');
        this.selected = false;
    }

    , triggerChange: function ()
    {
        this.$source.trigger('change');
    }

    , refresh: function ()
    {
        this.source = this.parse();
        this.options.items = this.source.length;
    }

    , listen: function ()
    {
        this.$element
          .on('focus', $.proxy(this.focus, this))
          .on('blur', $.proxy(this.blur, this))
          .on('keypress', $.proxy(this.keypress, this))
          .on('keyup', $.proxy(this.keyup, this));

        if (this.eventSupported('keydown'))
        {
            this.$element.on('keydown', $.proxy(this.keydown, this));
        }

        this.$menu
          .on('click', $.proxy(this.click, this))
          .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
          .on('mouseleave', 'li', $.proxy(this.mouseleave, this));

        this.$button
          .on('click', $.proxy(this.toggle, this));
    }

    , eventSupported: function (eventName)
    {
        var isSupported = eventName in this.$element;
        if (!isSupported)
        {
            this.$element.setAttribute(eventName, 'return;');
            isSupported = typeof this.$element[eventName] === 'function';
        }
        return isSupported;
    }

    , move: function (e)
    {
        if (!this.shown) { return; }

        switch (e.keyCode)
        {
            case 9: // tab
            case 13: // enter
            case 27: // escape
                e.preventDefault();
                break;

            case 38: // up arrow
                e.preventDefault();
                this.prev();
                this.fixMenuScroll();
                break;

            case 40: // down arrow
                e.preventDefault();
                this.next();
                this.fixMenuScroll();
                break;
        }

        e.stopPropagation();
    }

    , fixMenuScroll: function ()
    {
        var active = this.$menu.find('.active');
        if (active.length)
        {
            var top = active.position().top;
            var bottom = top + active.height();
            var scrollTop = this.$menu.scrollTop();
            var menuHeight = this.$menu.height();
            if (bottom > menuHeight)
            {
                this.$menu.scrollTop(scrollTop + bottom - menuHeight);
            } else if (top < 0)
            {
                this.$menu.scrollTop(scrollTop + top);
            }
        }
    }

    , keydown: function (e)
    {
        this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40, 38, 9, 13, 27]);
        this.move(e);
    }

    , keypress: function (e)
    {
        if (this.suppressKeyPressRepeat) { return; }
        this.move(e);
    }

    , keyup: function (e)
    {
        switch (e.keyCode)
        {
            case 40: // down arrow
                if (!this.shown)
                {
                    this.toggle();
                }
                break;
            case 39: // right arrow
            case 38: // up arrow
            case 37: // left arrow
            case 36: // home
            case 35: // end
            case 16: // shift
            case 17: // ctrl
            case 18: // alt
                break;

            case 9: // tab
            case 13: // enter
                if (!this.shown) { return; }
                this.select();
                break;

            case 27: // escape
                if (!this.shown) { return; }
                this.hide();
                break;

            default:
                this.clearTarget();
                this.lookup();
        }

        e.stopPropagation();
        e.preventDefault();
    }

    , focus: function (e)
    {
        this.focused = true;

        this.$element.select();
    }

    , blur: function (e)
    {
        var that = this;
        this.focused = false;
        var val = this.$element.val();
        if (!this.selected)
        {
            this.$element.val('');
            this.$source.val('').trigger('change');
            this.$target.val('').removeAttr("data-text").trigger('change');
        }
        if (!this.mousedover && this.shown) { setTimeout(function () { that.hide(); }, 200); }
    }

    , click: function (e)
    {
        e.stopPropagation();
        e.preventDefault();
        this.select();
        this.$element.focus();
    }

    , mouseenter: function (e)
    {
        this.mousedover = true;
        this.$menu.find('.active').removeClass('active');
        $(e.currentTarget).addClass('active');
    }

    , mouseleave: function (e)
    {
        this.mousedover = false;
    }
    };

    /* COMBOBOX PLUGIN DEFINITION
     * =========================== */
    $.fn.combobox = function (option)
    {
        return this.each(function ()
        {
            var $this = $(this)
              , data = $this.data('combobox')
              , options = typeof option == 'object' && option;
            if (!data) { $this.data('combobox', (data = new Combobox(this, options))); }
            if (typeof option == 'string') data[option];
        });
    };

    $.fn.combobox.defaults = {
        bsVersion: '3'
    , menu: '<ul class="typeahead typeahead-long dropdown-menu"></ul>'
    , item: '<li><a href="#"></a></li>'
    };

    $.fn.combobox.Constructor = Combobox;

}(window.jQuery);


window.typeaheadSources = window.typeaheadSources || {};
window.typeaheadSources.guests = function (el)
{
    return new Bloodhound(
        {
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote:
            {
                url: BaseUrl + "/api/guests",
                prepare: function (query, settings) {
                    let url = settings.url + '?q=' + encodeURIComponent(query);

                    const filter = (el ? el.data('filter') : null) || $("#quick-guest-modal").data('filter');
                    if (filter) {
                        url += '&' + filter;
                    }

                    settings.url = url;
                    return settings;
                }
            }
        });
};

$("input[data-provide=typeahead]").each(function ()
{
    var el = $(this);

    el.on("keydown keypress", function (e)
    {
        var visible = el.parent().find(".typeahead-menu").is(":visible");

        if (visible)
        {
            // Tab (9): move the suggestion cursor (Shift+Tab reverses) instead of leaving the field.
            if (e.keyCode == 9)
            {
                $(el).typeahead("moveCursor", e.shiftKey ? -1 : 1);

                e.stopImmediatePropagation();
                e.preventDefault();

                return false;
            }
            // Escape (27): clear the input (and dismiss suggestions via typeahead).
            else if (e.keyCode == 27)
            {
                $(el).typeahead("val", "");

                e.stopImmediatePropagation();
                e.preventDefault();

                return false;
            }
        }
    });

    el.typeahead(
        {
            minLength: $(el).data('minlength') != null ? $(el).data('minlength') : 1,
            hint: false,
            highlight: false,
            classNames:
            {
                cursor: "typeahead-cursor",
                input: "typeahead-input",
                menu: "typeahead-menu",
                open: "typeahead-open",
                selectable: "typeahead-selectable",
                suggestion: "typeahead-suggestion"
            }
        },
        {
            name: el.attr("data-name"),
            display: el.attr("data-display"),
            source: window.typeaheadSources[el.attr("data-source")](el),
            limit: "Infinity",
            templates:
            {
                suggestion: function (data)
                {
                    var extraContactInfo = "";

                    if (data.EmailAddress != null && data.EmailAddress.length > 0)
                        extraContactInfo = data.EmailAddress;
                    else if (data.PhoneNumberInformal != null && data.PhoneNumberInformal.length > 0)
                        extraContactInfo = data.PhoneNumberInformal;
                    else if (data.Type != null && data.Type.length > 0)
                        extraContactInfo = data.Type;

                    if (extraContactInfo.length > 0 && (data.FullName || data.Name))
                        extraContactInfo = " - " + extraContactInfo;

                    var name;

                    if (el.attr("data-display"))
                        name = data[el.attr("data-display")];

                    if (!name)
                    {
                        if (data.FullName)
                            name = data.FullName;
                        else if (extraContactInfo.length == 0)
                            name = "[unknown]";
                        else
                            name = "";
                    }

                    if (name)
                        name = "<strong>" + name + "</strong>";

                    if (data.IsBanned)
                        extraContactInfo += ' - <span class="badge badge-danger rounded-pill label-tag">Banned</span>';

                    return "<p>" + name + extraContactInfo + "</p>";
                },
                notFound: $(el).data("show-not-found") != false ? function (query)
                {
                    var notFoundText = el.data("not-found-text") || "No records found for these search terms";
                    var $notFound = $('<p class="typeahead-notfound"></p>').text(notFoundText);

                    return $notFound.add(buildAddItemHtml(el, query, true));
                } : null,
                footer: function (query)
                {
                    return el.data("typeahead-footer-text") && !query.query.length ? `<p class=\"typeahead-notfound small\">${el.data("typeahead-footer-text")}</p>` : $(buildAddItemHtml(el, query));
                }
            }
        })
        .on("typeahead:asyncrequest", function ()
        {
            //$(el).addClass("loading");
            $(el).parent().addClass("loading");
        })
        .on("typeahead:asynccancel typeahead:asyncreceive", function ()
        {
            //$(el).removeClass("loading");
            $(el).parent().removeClass("loading");
        });

    // For vendor search, suppress the "Add 'X' as a new vendor" row when a result already matches the query exactly.
    el.on("typeahead:render", function ()
    {
        if (el.data("add-noun") !== "vendor")
            return;

        var $tt = el.closest(".twitter-typeahead");
        var $add = $tt.find(".typeahead-additem");

        if (!$add.length)
            return;

        var query = (el.typeahead("val") || "").trim().toLowerCase();

        if (!query)
            return;

        var hasExactMatch = false;

        $tt.find(".typeahead-suggestion").not($add).find("strong").each(function ()
        {
            if ($(this).text().trim().toLowerCase() === query)
                hasExactMatch = true;
        });

        if (hasExactMatch)
            $add.remove();
    });

    el.on("keypress", function (e)
    {
        var typeahead = el.closest(".twitter-typeahead");
        var results = typeahead.find(".typeahead-menu");

        // Enter (13): if the "add new" row is highlighted, fire addnew instead of default Enter behavior.
        if (e.keyCode == 13 && results.find(".typeahead-additem").is(".typeahead-cursor"))
        {
            el.trigger("typeahead:addnew", { query: el.val() });

            return false;
        }
    });

    //el.on("focus keyup", function ()
    //{
    //    if (!$(this).val())
    //    {
    //        var typeahead = el.closest(".twitter-typeahead");
    //        var results = typeahead.find(".typeahead-menu");

    //        results.find(".tt-dataset").html(buildAddItemHtml(el));

    //        results.show();
    //        el.typeahead("open");
    //    }
    //});
});

var buildAddItemHtml = function (el, query, isSelected)
{
    if (el.data("typeahead-noadd") == true)
        return "";
    
    var addTestId = el.attr("data-testid") ? ' data-testid="' + el.attr("data-testid") + '-add"' : '';
    var html = '<p class="typeahead-additem typeahead-suggestion typeahead-selectable' + (isSelected ? ' typeahead-cursor' : '') + '"><a href="javascript:void(0)"' + addTestId + '>';
    var template = el.attr("data-typeahead-addtemplate");

    if (!template)
    {
        var noun = el.data("add-noun") || "guest";

        if (query)
            template = "<i class=\"fa fa-plus\"></i> Add '<span class=\"typeahead-query\"></span>' as a new " + noun;
        else
            template = "<i class=\"fa fa-plus\"></i> Add new " + noun;
    }

    html += template + "</a></p>";

    if (query)
    {
        var escapeEl = $("<div>" + html + "</div>");

        escapeEl.find(".typeahead-query").text($.trim(query.query));

        html = escapeEl.html();
    }
    return html;
};

$(document).on("click", ".typeahead-additem", function ()
{
    var typeahead = $(this).closest(".twitter-typeahead");
    var el = typeahead.find("input");

    el.trigger("typeahead:addnew", { query: el.val() });
});

$("<img />").attr("src", ContentUrl("images/loading6.gif"));

// Generic AJAX-powered dropdown search plugin.
// Handles debounced search, loading state, keyboard navigation (↑/↓/Enter), and click-outside.
// Fires 'searchDropdown:select' with the active $link when Enter is pressed.
// Callers are responsible for handling item clicks and the selected/cleared state.
//
// Options:
//   results      {string|jQuery}  Selector string or the <ul> results element (use jQuery when IDs contain [ ] etc.)
//   itemSelector {string}   Selector for navigable items (default: 'a.dropdown-item')
//   search       {function} function(q, done) — call done(data) where data is a JSON array or HTML string
//   buildItem    {function} function(item) — return a $li element (required when search returns JSON)
//   empty        {function} function($results) — populate $results when search returns nothing (optional)
//   debounce     {number}   ms delay before searching (default: 500)
$.fn.searchDropdown = function (options)
{
    options = $.extend({ debounce: 500, itemSelector: 'a.dropdown-item' }, options);

    if (!$.fn.searchDropdown._documentClickNs)
        $.fn.searchDropdown._documentClickNs = 0;

    return this.each(function ()
    {
        var $input = $(this);
        var $results = options.results && options.results.jquery ? options.results : $(options.results);
        var searchTimeout;
        var documentClickNs = 'orSd' + (++$.fn.searchDropdown._documentClickNs);

        function runSearch()
        {
            var q = $input.val().trim();
            if (!q)
            {
                $results.dropdown('hide');
                return;
            }

            options.search(q, function (data)
            {
                $results.empty();

                if (typeof data === 'string')
                    $results.append(data);
                else if (data && data.length)
                    $.each(data, function (i, item) { $results.append(options.buildItem(item)); });
                else if (options.empty)
                    options.empty($results);

                $results.dropdown('show');
                setTimeout(function () { $results.css('transform', 'none'); }, 0);
            });
        }

        $input.on('keyup.searchDropdown', function (e)
        {
            var $active, $next;

            // Tab (9), Left/Right (37, 39): skip debounced search so focus and caret behave normally.
            if ([9, 37, 39].indexOf(e.keyCode) > -1)
                return;

            // Up (38) / Down (40): move highlight in the results list.
            if (e.keyCode === 38 || e.keyCode === 40)
            {
                $active = $(options.itemSelector + '.active', $results);
                $next = $active.length
                    ? (e.keyCode === 38
                        ? $active.parent().prev('li').find(options.itemSelector)
                        : $active.parent().next('li').find(options.itemSelector))
                    : $(options.itemSelector + ':first', $results);

                if ($next.length)
                {
                    $active.removeClass('active');
                    $next.addClass('active');
                }
                return;
            }

            // Enter (13): confirm the highlighted item (if any).
            if (e.keyCode === 13)
            {
                $active = $(options.itemSelector + '.active', $results);
                if ($active.length) $input.trigger('searchDropdown:select', [$active]);
                return;
            }

            $results
                .empty()
                .append($('<li>').append($('<span class="d-block text-secondary py-2 px-3 fst-italic">').text('Searching...')))
                .dropdown('show');
            setTimeout(function () { $results.css('transform', 'none'); }, 0);

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(runSearch, options.debounce);
        });

        $(document).on('click.searchDropdown.' + documentClickNs, function (e)
        {
            if (!$(e.target).is($input) && !$(e.target).closest($results).length)
                $results.dropdown('hide');
        });
    });
};

// Snippet typeahead — opens a caret-anchored popover when the user types the trigger character inside an attached textarea.
// Also owns the Create Snippet and See All Snippets modals that the hovercard footer buttons launch.
// Usage: $("textarea").snippetTypeahead({ searchUrl: '/settings/snippets/search', resolveUrl: '/settings/snippets/resolve' });

(function ($)
{
    "use strict";

    var MIRROR_STYLES = [
        "direction", "boxSizing", "width", "height", "overflowX", "overflowY",
        "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth", "borderStyle",
        "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
        "fontStyle", "fontVariant", "fontWeight", "fontStretch", "fontSize", "fontSizeAdjust",
        "lineHeight", "fontFamily",
        "textAlign", "textTransform", "textIndent", "textDecoration",
        "letterSpacing", "wordSpacing", "tabSize"
    ];

    var STAY_ENTITY_KEYS = ["booking", "quote", "inquiry"];

    // Field-resolution priority used to look up an entity id on the surrounding thread/compose container.
    var ENTITY_PRIORITY = STAY_ENTITY_KEYS.concat(["guest"]);

    // Server requirement tokens (SnippetEntityRequirement), most specific first; "stay" takes any of STAY_ENTITY_KEYS.
    var REQUIREMENT_ORDER = STAY_ENTITY_KEYS.concat(["stay", "guest"]);

    var REQUIREMENT_LABELS = {
        booking: "a booking",
        quote: "a quote",
        inquiry: "an inquiry",
        stay: "a booking, quote or inquiry",
        guest: "a contact"
    };

    // FieldTransformer back-fills down the chain (booking -> its quote -> that quote's inquiry) and looks a quote
    // up from its inquiry, so a tier the thread doesn't carry still resolves from a neighbour; nothing reaches a
    // booking. Order is target preference, best first.
    var REQUIREMENT_SOURCES = {
        booking: ["booking"],
        quote: ["quote", "booking", "inquiry"],
        inquiry: ["inquiry", "quote", "booking"],
        stay: STAY_ENTITY_KEYS,
        guest: ["guest"].concat(STAY_ENTITY_KEYS)
    };

    // -----------------------------------------------------------------------------------------------
    // Shared helpers
    // -----------------------------------------------------------------------------------------------

    // Project the textarea's content into a hidden mirror div, drop a span at the caret, measure its offset.
    // Returns viewport-relative top/left/height for the caret position.
    function caretCoords(input, position)
    {
        var computed = window.getComputedStyle(input);
        var div = document.createElement("div");
        document.body.appendChild(div);

        var style = div.style;
        style.whiteSpace = "pre-wrap";
        style.wordWrap = "break-word";
        style.position = "absolute";
        style.visibility = "hidden";
        style.top = "0";
        style.left = "0";

        MIRROR_STYLES.forEach(function (prop)
        {
            style[prop] = computed[prop];
        });

        div.textContent = input.value.substring(0, position);

        var marker = document.createElement("span");
        marker.textContent = input.value.substring(position) || ".";
        div.appendChild(marker);

        var rect = input.getBoundingClientRect();
        var coords = {
            top: rect.top + marker.offsetTop - input.scrollTop,
            left: rect.left + marker.offsetLeft - input.scrollLeft,
            height: parseInt(computed.lineHeight, 10) || Math.round(parseFloat(computed.fontSize) * 1.2)
        };

        document.body.removeChild(div);
        return coords;
    }

    function importTemplate($popover, attributeName)
    {
        return document.importNode($popover.find("template[" + attributeName + "]")[0].content, true);
    }

    function escapeHtml(text)
    {
        return (text || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function escapeRegex(text)
    {
        return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    // Tokenize the query the same way the server does — whitespace-split, drop empties.
    function tokenize(query)
    {
        if (!query)
            return [];

        return query.split(/\s+/).filter(function (t) { return t.length > 0; });
    }

    // Matches on the raw text, escaping each slice as it goes — escaping first would let a token match inside an entity.
    function highlightTokens(text, tokens)
    {
        if (!tokens || !tokens.length)
            return escapeHtml(text);

        var pattern = new RegExp("(" + tokens.map(escapeRegex).join("|") + ")", "gi");
        var html = "";
        var last = 0;
        var match;

        while ((match = pattern.exec(text)) !== null)
        {
            html += escapeHtml(text.slice(last, match.index)) + "<strong>" + escapeHtml(match[0]) + "</strong>";
            last = match.index + match[0].length;

            // A zero-length match would spin forever on the same index.
            if (match[0].length === 0)
                pattern.lastIndex++;
        }

        return html + escapeHtml(text.slice(last));
    }

    function truncate(text, max)
    {
        if (!text)
            return "";
        if (text.length <= max)
            return text;
        return text.substring(0, max - 1) + "…";
    }

    // Walk up to the surrounding thread/compose container and find the highest-priority entity id present.
    // Accepts either a DOM element or a jQuery wrapper.
    function findContextEntity(input)
    {
        if (!input)
            return null;

        var $container = (input.jquery ? input : $(input)).closest(".contact-thread, .compose-form");

        if (!$container.length)
            return null;

        for (var i = 0; i < ENTITY_PRIORITY.length; i++)
        {
            var key = ENTITY_PRIORITY[i];
            var id = $container.data(key + "-id");

            if (id != null && id !== "" && !isNaN(parseInt(id, 10)))
            {
                return {
                    entityType: key.charAt(0).toUpperCase() + key.slice(1),
                    entityId: parseInt(id, 10)
                };
            }
        }

        return null;
    }

    function parseRequirements(requiredEntities)
    {
        if (!requiredEntities)
            return [];

        var tokens = String(requiredEntities).toLowerCase().split(",");

        return REQUIREMENT_ORDER.filter(function (token) { return tokens.indexOf(token) >= 0; });
    }

    function candidate(entityType, entityId)
    {
        return { entityType: entityType.charAt(0).toUpperCase() + entityType.slice(1).toLowerCase(), entityId: entityId };
    }

    function addCandidate(candidates, key, rawId)
    {
        var id = parseInt(rawId, 10);

        if (!candidates[key] || !(id > 0) || candidates[key].some(function (c) { return c.entityId === id; }))
            return;

        candidates[key].push(candidate(key, id));
    }

    // Entities the thread can resolve against, by lowercase type; null on broadcast and compose, which resolve per recipient at send time.
    function contextCandidates(input)
    {
        if (!input)
            return null;

        var $thread = (input.jquery ? input : $(input)).closest(".contact-thread");

        if (!$thread.length)
            return null;

        var candidates = { booking: [], quote: [], inquiry: [], guest: [] };

        // Union, not either/or: the picker omits a quote its booking superseded, while the container still
        // carries that quote's data-quote-id. Either source alone reports a stay the thread has as missing.
        $("#snippet-entity-picker .snippet-entity-radio").each(function ()
        {
            addCandidate(candidates, ($(this).attr("data-entity-type") || "").toLowerCase(), $(this).attr("data-entity-id"));
        });

        ENTITY_PRIORITY.forEach(function (key)
        {
            addCandidate(candidates, key, $thread.data(key + "-id"));
        });

        return candidates;
    }

    // The first source tier the thread actually carries; "stay" stays an aggregate so the picker still offers
    // every tier. Empty means nothing on the thread resolves this requirement.
    function candidatesFor(candidates, requirement)
    {
        if (requirement === "stay")
            return STAY_ENTITY_KEYS.reduce(function (all, key) { return all.concat(candidates[key]); }, []);

        var sources = REQUIREMENT_SOURCES[requirement] || [requirement];

        for (var i = 0; i < sources.length; i++)
        {
            if (candidates[sources[i]] && candidates[sources[i]].length)
                return candidates[sources[i]];
        }

        return [];
    }

    function requirementPhrase(requirements)
    {
        var labels = requirements.map(function (requirement) { return REQUIREMENT_LABELS[requirement] || requirement; });

        return labels.length > 1
            ? labels.slice(0, -1).join(", ") + " and " + labels[labels.length - 1]
            : labels[0];
    }

    function blockedMessage(decision)
    {
        return "This snippet uses field codes that need " + requirementPhrase(decision.missing) + " on the conversation.";
    }

    // One pass over the requirement set, so the block, the prompt and the resolve target can never disagree.
    // Returns { missing, prompt, target }; a blocked decision carries missing and no target.
    function decide(requirements, candidates, canPrompt)
    {
        var none = { missing: [], prompt: null, target: null };

        if (!requirements.length || !candidates)
            return none;

        var missing = requirements.filter(function (r) { return !candidatesFor(candidates, r).length; });

        if (missing.length)
            return { missing: missing, prompt: null, target: null };

        for (var i = 0; i < requirements.length; i++)
        {
            // Guest is last in REQUIREMENT_ORDER, so a stay tier has already claimed the target when one applies.
            if (requirements[i] === "guest")
                break;

            var forRequirement = candidatesFor(candidates, requirements[i]);

            // The tier that answered may not be the one named — the picker offers what it will actually resolve against.
            var promptType = requirements[i] === "stay" ? "stay" : forRequirement[0].entityType.toLowerCase();

            if (forRequirement.length > 1)
                return canPrompt ? { missing: [], prompt: promptType, target: null } : none;

            return { missing: [], prompt: null, target: forRequirement[0] };
        }

        return none;
    }

    // A null target falls back to findContextEntity's priority walk, so a guest-only body still resolves
    // against the stay and {CEMAIL} can reach a booking or inquiry double-blind address.
    function decideInsert(input, requiredEntities)
    {
        var decision = decide(parseRequirements(requiredEntities), contextCandidates(input), $("#snippet-entity-picker").length > 0);

        decision.blocked = decision.missing.length > 0;

        if (!decision.blocked && !decision.prompt && !decision.target)
            decision.target = findContextEntity(input);

        return decision;
    }

    // Replace the trigger-key query segment in `pendingInsert.input` with `body`. Used by the modal flows once the
    // resolved snippet body is in hand.
    function insertIntoSource(pendingInsert, body)
    {
        if (!pendingInsert || !pendingInsert.input)
            return;

        var input = pendingInsert.input;
        var anchor = typeof pendingInsert.anchorIndex === "number" ? pendingInsert.anchorIndex : input.selectionEnd;
        var endRaw = typeof pendingInsert.caretEnd === "number" ? pendingInsert.caretEnd : anchor;

        anchor = Math.max(0, Math.min(anchor, input.value.length));
        var end = Math.max(anchor, Math.min(endRaw, input.value.length));

        var before = input.value.substring(0, anchor);
        var after = input.value.substring(end);

        input.value = before + body + after;
        var caret = before.length + body.length;
        input.setSelectionRange(caret, caret);
        input.focus();
        // Native dispatch (not jQuery .trigger) so autosize's addEventListener("input") fires.
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Resolve a saved snippet's body against the current compose context (if any), then insert it via
    // insertIntoSource. Falls back to the raw body if there's no context or the resolve call fails.
    function resolveAndInsert(pendingInsert, snippetId, rawBody, resolveUrl, onDone, context)
    {

        function finish(bodyText)
        {
            insertIntoSource(pendingInsert, bodyText);
            if (typeof onDone === "function") onDone();
        }

        if (resolveUrl && context && snippetId > 0)
        {
            $.ajax({
                url: resolveUrl,
                type: "POST",
                data: { id: snippetId, entityType: context.entityType, entityId: context.entityId },
                dataType: "json",
                success: function (r) { finish((r && r.body) || rawBody); },
                error: function () { finish(rawBody); }
            });
        }
        else
        {
            finish(rawBody);
        }
    }

    // -----------------------------------------------------------------------------------------------
    // Entity picker (Index.Thread.cshtml #snippet-entity-picker)
    //
    // Prompts which stay entity to resolve against when a thread has more than one; every insert surface routes through here.
    // -----------------------------------------------------------------------------------------------

    var lastPickedEntityByThread = {};
    var pendingPickerResolve = null;

    function threadIdFor(input)
    {
        return (input.jquery ? input : $(input)).closest(".contact-thread").data("thread-id");
    }

    function todayIsoDate()
    {
        var d = new Date();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return d.getFullYear() + "-" + (m < 10 ? "0" + m : m) + "-" + (day < 10 ? "0" + day : day);
    }

    function selectPickerRadio($radio)
    {
        var $modal = $radio.closest(".modal");
        $radio.prop("checked", true);
        $modal.find("[data-snippet-entity-apply]").prop("disabled", false);
    }

    // Default order: last stay chosen on this thread, else the in-progress booking, else the next upcoming
    // arrival, else nothing (all in the past -> the user picks explicitly).
    function applyDefaultEntitySelection($modal, threadId)
    {
        // Clear every radio, not just the offered ones — a pick left checked on a now-hidden option would apply instead.
        $modal.find(".snippet-entity-radio").prop("checked", false);

        var $radios = $modal.find(".snippet-entity-option:not(.d-none) .snippet-entity-radio");

        $modal.find("[data-snippet-entity-apply]").prop("disabled", true);

        if (!$radios.length)
            return;

        var remembered = threadId != null ? lastPickedEntityByThread[threadId] : null;

        if (remembered)
        {
            var $match = $radios.filter('[data-entity-type="' + remembered.entityType + '"][data-entity-id="' + remembered.entityId + '"]');

            if ($match.length)
            {
                selectPickerRadio($match.first());
                return;
            }
        }

        var $inProgress = $radios.filter('[data-in-progress="true"]').first();

        if ($inProgress.length)
        {
            selectPickerRadio($inProgress);
            return;
        }

        var today = todayIsoDate();
        var best = null;
        var bestArrival = null;

        $radios.each(function ()
        {
            var arrival = $(this).attr("data-arrival");

            if (arrival && arrival >= today && (bestArrival === null || arrival < bestArrival))
            {
                bestArrival = arrival;
                best = this;
            }
        });

        if (best)
            selectPickerRadio($(best));
    }

    // Offer only candidates of the type the snippet needs, so a booking-code snippet is never offered a quote.
    function filterPickerOptions($modal, requirement)
    {
        var keys = requirement === "stay" ? STAY_ENTITY_KEYS : [requirement];

        $modal.find(".snippet-entity-option").each(function ()
        {
            var key = ($(this).find(".snippet-entity-radio").attr("data-entity-type") || "").toLowerCase();

            $(this).toggleClass("d-none", keys.indexOf(key) < 0);
        });

        $modal.find("[data-snippet-entity-prompt]").text(
            "This conversation has more than one " + (requirement === "stay" ? "booking, quote or inquiry" : requirement) + ". Which one should this snippet use?");
    }

    // Show the picker and stash how to finish the insert once the user chooses; caller has already closed any parent modal.
    function openEntityPicker(input, snippetId, body, resolveUrl, insertCallback, requirement)
    {
        var $modal = $("#snippet-entity-picker");

        if (!$modal.length)
            return;

        filterPickerOptions($modal, requirement);

        pendingPickerResolve = {
            snippetId: snippetId,
            body: body,
            resolveUrl: resolveUrl,
            insert: insertCallback,
            threadId: threadIdFor(input)
        };

        applyDefaultEntitySelection($modal, pendingPickerResolve.threadId);

        bootstrap.Modal.getOrCreateInstance($modal[0]).show();
    }

    $(document).on("change", "#snippet-entity-picker .snippet-entity-radio", function ()
    {
        var $modal = $(this).closest(".modal");

        $modal.find("[data-snippet-entity-apply]").prop("disabled", !$modal.find(".snippet-entity-radio:checked").length);
    });

    $(document).on("click", "#snippet-entity-picker [data-snippet-entity-apply]", function ()
    {
        var $modal = $(this).closest(".modal");
        var $checked = $modal.find(".snippet-entity-radio:checked");

        if (!$checked.length || !pendingPickerResolve)
            return;

        var pending = pendingPickerResolve;
        pendingPickerResolve = null;

        var entityType = $checked.attr("data-entity-type");
        var entityId = parseInt($checked.attr("data-entity-id"), 10);

        if (pending.threadId != null)
            lastPickedEntityByThread[pending.threadId] = { entityType: entityType, entityId: entityId };

        $(this).prop("disabled", true);

        $.ajax({
            url: pending.resolveUrl,
            type: "POST",
            data: { id: pending.snippetId, entityType: entityType, entityId: entityId },
            dataType: "json",
            complete: function (xhr)
            {
                var resp = xhr && xhr.responseJSON;
                var bodyText = (resp && resp.body) || pending.body;

                // Insert after the modal is gone so focus lands on the compose input, not the closing modal.
                $modal.one("hidden.bs.modal", function () { pending.insert(bodyText); });
                bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
            }
        });
    });

    // Dismissed without applying -> drop the staged insert so the next open starts clean.
    $(document).on("hidden.bs.modal", "#snippet-entity-picker", function ()
    {
        pendingPickerResolve = null;
    });

    // -----------------------------------------------------------------------------------------------
    // FieldsInlineDropdown component (Views/Shared/FieldsInlineDropdown.cshtml)
    //
    // Handlers live here (rather than the partial) because the partial gets AJAX-loaded into the Create
    // Snippet modal, and inline <script> tags injected via innerHTML don't execute.
    // -----------------------------------------------------------------------------------------------

    $(document).on("input", ".fields-inline-search", function ()
    {
        var q = $.trim($(this).val()).toLowerCase();
        var $list = $(this).closest(".fields-inline-dropdown").find(".fields-inline-list");
        var anyVisible = false;

        $list.find(".fields-inline-item").each(function ()
        {
            var hay = ($(this).attr("data-search") || "").toLowerCase();
            var hit = !q || hay.indexOf(q) >= 0;
            $(this).toggleClass("d-none", !hit);
            if (hit) anyVisible = true;
        });

        $list.find(".fields-inline-nomatch").toggleClass("d-none", anyVisible);
    });

    $(document).on("click", ".fields-inline-search-clear", function ()
    {
        $(this).closest(".fields-inline-dropdown")
            .find(".fields-inline-search").val("").trigger("input").trigger("focus");
    });

    // Keep the dropdown open if the user presses Esc while there's text to clear.
    $(document).on("keydown", ".fields-inline-search", function (e)
    {
        if (e.key === "Escape" && $.trim($(this).val()))
        {
            e.stopPropagation();
            $(this).val("").trigger("input");
        }
    });

    $(document).on("shown.bs.dropdown", ".fields-inline-dropdown-wrap", function ()
    {
        $(this).find(".fields-inline-search").val("").trigger("input").trigger("focus");
    });

    $(document).on("click", ".fields-inline-item:not(.disabled)", function (e)
    {
        e.preventDefault();

        var fieldToInsert = $(this).attr("data-field-to-insert");
        var $menu = $(this).closest(".fields-inline-dropdown");
        var targetId = $menu.attr("data-target-input");
        var input = document.getElementById(targetId);

        if (!input || !fieldToInsert)
            return;

        var start = typeof input.selectionStart === "number" ? input.selectionStart : input.value.length;
        var end = typeof input.selectionEnd === "number" ? input.selectionEnd : input.value.length;
        var before = input.value.substring(0, start);
        var after = input.value.substring(end);

        // Match the modal's behavior: if inserting at the very end and there's no trailing space, prepend one.
        if (start === input.value.length && before.length > 0 && before.charAt(before.length - 1) !== " ")
            fieldToInsert = " " + fieldToInsert;

        input.value = before + fieldToInsert + after;
        var caret = before.length + fieldToInsert.length;
        input.setSelectionRange(caret, caret);
        input.focus();
        // Native dispatch (not jQuery .trigger) so autosize's addEventListener("input") fires.
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        $(input).trigger("keypress");

        bootstrap.Dropdown.getOrCreateInstance($menu.siblings("[data-bs-toggle='dropdown']")[0]).hide();
    });

    // -----------------------------------------------------------------------------------------------
    // Modal lazy-loading shared between the Create and See All modals.
    //
    // Each modal element renders as an empty shell with a spinner up front; on first open we AJAX-fetch the
    // real modal-dialog HTML from `data-load-url` and inject it into the shell. We capture the spinner shell
    // once, then restore it after each hide so the next open fetches fresh content.
    // -----------------------------------------------------------------------------------------------

    function captureShell($modal)
    {
        if (!$modal.data("shellHtml"))
            $modal.data("shellHtml", $modal[0].innerHTML);
    }

    function restoreShell($modal)
    {
        var shell = $modal.data("shellHtml");

        if (shell)
            $modal[0].innerHTML = shell;
    }

    function loadModal($modal, extraData, onLoaded)
    {
        var url = $modal.attr("data-load-url");

        if (!url)
            return;

        $.ajax({
            url: url,
            type: "GET",
            data: extraData || {},
            dataType: "html",
            success: function (html)
            {
                $modal[0].innerHTML = html;

                // Griddly only self-inits on document.ready; AJAX-loaded grids need an explicit kick.
                $modal.find("[data-role=griddly]").griddly();
                $modal.find("[data-role=griddly-filter-bar]").griddlyFilterBar();

                // Grid action buttons (e.g. Insert) carry data-bs-toggle="tooltip" and re-render on every
                // filter keystroke; delegate so BS5 tooltips survive each refresh with no re-init. Root the
                // delegate on .modal-content, not the modal element — the modal already holds the bs.modal
                // instance and BS5 forbids a second component instance (bs.tooltip) on the same element.
                var $modalContent = $modal.find(".modal-content");
                if ($modalContent.length)
                    bootstrap.Tooltip.getOrCreateInstance($modalContent[0], { selector: "[data-bs-toggle='tooltip']" });

                if (typeof onLoaded === "function") onLoaded($modal);
            },
            error: function ()
            {
                $modal.find("[data-snippet-modal-loading]").html(
                    '<div class="text-danger">Unable to load. Please close this dialog and try again.</div>'
                );
            }
        });
    }

    $(document).on("show.bs.modal", "#modal-snippet-create, #modal-snippet-see-all", function ()
    {
        var $m = $(this);
        captureShell($m);
        restoreShell($m);

        var onLoaded = null;
        var extraData = $m.data("loadParams");

        if (this.id === "modal-snippet-create")
        {
            onLoaded = function ($modal)
            {
                $modal.find('input[name="Name"]').trigger("focus");
            };
        }
        else if (this.id === "modal-snippet-see-all")
        {
            onLoaded = function ($modal)
            {
                $modal.find("[data-snippet-modal-filter]").trigger("focus");
            };
        }

        loadModal($m, extraData, onLoaded);
    });

    $(document).on("hidden.bs.modal", "#modal-snippet-create, #modal-snippet-see-all", function ()
    {
        var $m = $(this);

        // If pendingInsert is still set, the modal was dismissed without a success action — reopen the
        // typeahead so the user lands back at their original trigger-key segment. Successful paths (Save, Save And
        // Insert, See All Insert) clear pendingInsert before calling .hide().
        var pendingInsert = $m.data("pendingInsert");

        $m.data("pendingInsert", null);
        $m.data("loadParams", null);
        restoreShell($m);

        if (pendingInsert && typeof pendingInsert.reopen === "function")
        {
            // Defer one tick so BS5 finishes its focus-trap teardown / focus restoration before we
            // re-establish typeahead state. Otherwise BS5's cleanup can blur the textarea right after we
            // re-focus it, and the typeahead's own blur handler then closes the popover mid-search.
            setTimeout(pendingInsert.reopen, 0);
        }
    });

    // -----------------------------------------------------------------------------------------------
    // Create Snippet modal
    // -----------------------------------------------------------------------------------------------

    function showCreateErrors($m, errors)
    {
        var $box = $m.find("[data-snippet-create-errors]");
        $box.empty();

        var $ul = $("<ul>", { "class": "mb-0 ps-3" });

        (errors && errors.length ? errors : ["Unable to save snippet."]).forEach(function (e)
        {
            $ul.append($("<li>").text(e));
        });

        $box.append($ul).removeClass("d-none");
    }

    function clearCreateErrors($m)
    {
        $m.find("[data-snippet-create-errors]").addClass("d-none").empty();
    }

    function submitCreate($m, andInsert)
    {
        clearCreateErrors($m);

        var $form = $m.find("[data-snippet-create-form]");
        var $buttons = $m.find("button[data-snippet-create-action]").prop("disabled", true);
        var data = $form.serialize();

        $.ajax({
            url: $form.attr("data-save-url"),
            type: "POST",
            data: data,
            dataType: "json",
            success: function (resp)
            {
                if (!resp || !resp.ok)
                {
                    showCreateErrors($m, resp && resp.errors);
                    return;
                }

                if (!andInsert)
                {
                    // Saved-but-not-inserted is a successful action — don't reopen the typeahead on close.
                    $m.data("pendingInsert", null);
                    bootstrap.Modal.getOrCreateInstance($m[0]).hide();
                    return;
                }

                var pendingInsert = $m.data("pendingInsert");
                $m.data("pendingInsert", null);

                var input = pendingInsert && pendingInsert.input;

                var decision = decideInsert(input, resp.requiredEntities);

                // The snippet saved either way — only the insert is gated, so close on the way out.
                if (decision.blocked)
                {
                    $m.one("hidden.bs.modal", function () { bootbox.alert(blockedMessage(decision)); });
                    bootstrap.Modal.getOrCreateInstance($m[0]).hide();
                    return;
                }

                // Multiple candidates for a required type: close the Create modal first, then open the picker (never stack modals).
                if (decision.prompt)
                {
                    $m.one("hidden.bs.modal", function ()
                    {
                        openEntityPicker(input, resp.id, resp.body, $form.attr("data-resolve-url"), function (bodyText)
                        {
                            insertIntoSource(pendingInsert, bodyText);
                        }, decision.prompt);
                    });
                    bootstrap.Modal.getOrCreateInstance($m[0]).hide();
                    return;
                }

                resolveAndInsert(
                    pendingInsert,
                    resp.id,
                    resp.body,
                    $form.attr("data-resolve-url"),
                    function () { bootstrap.Modal.getOrCreateInstance($m[0]).hide(); },
                    decision.target
                );
            },
            error: function ()
            {
                showCreateErrors($m, ["Unable to save snippet. Please try again."]);
            },
            complete: function ()
            {
                $buttons.prop("disabled", false);
            }
        });
    }

    function openCreateModal(pendingInsert)
    {
        var $modal = $("#modal-snippet-create");

        if (!$modal.length)
            return;

        // The dialog contents are AJAX-loaded on show.bs.modal — no need to reset the form here, it arrives fresh.
        $modal.data("pendingInsert", pendingInsert || null);

        // Pre-populate the Shortcut field with whatever the user typed after the trigger character — server sanitizes to alphanumerics.
        var query = pendingInsert && pendingInsert.query;
        $modal.data("loadParams", query ? { shortcut: query } : null);

        bootstrap.Modal.getOrCreateInstance($modal[0]).show();
    }

    $(document).on("click", "#modal-snippet-create [data-snippet-create-action]", function (e)
    {
        e.preventDefault();

        var $m = $(this).closest(".modal");
        var action = $(this).attr("data-snippet-create-action");

        submitCreate($m, action === "save-and-insert");
    });

    $(document).on("submit", "#modal-snippet-create [data-snippet-create-form]", function (e)
    {
        e.preventDefault();
    });

    // -----------------------------------------------------------------------------------------------
    // See All Snippets modal
    // -----------------------------------------------------------------------------------------------

    function openSeeAllModal(pendingInsert)
    {
        var $modal = $("#modal-snippet-see-all");

        if (!$modal.length)
            return;

        $modal.data("pendingInsert", pendingInsert || null);

        // Don't pre-populate any filter field — See All only shows up when there's no matches anyways
        $modal.data("loadParams", null);

        bootstrap.Modal.getOrCreateInstance($modal[0]).show();
    }

    $(document).on("click", "#modal-snippet-see-all .snippet-modal-insert", function (e)
    {
        e.preventDefault();

        var $btn = $(this);
        var $m = $btn.closest(".modal");
        var pendingInsert = $m.data("pendingInsert");
        var snippetId = parseInt($btn.attr("data-snippet-id"), 10);
        var rawBody = $btn.attr("data-snippet-body") || "";
        var requiredEntities = $btn.attr("data-required-entities");
        var resolveUrl = $m.attr("data-resolve-url");
        var input = pendingInsert && pendingInsert.input;
        var decision = decideInsert(input, requiredEntities);

        if (decision.blocked)
        {
            bootbox.alert(blockedMessage(decision));
            return;
        }

        // Successful insert — drop pendingInsert so the close handler doesn't reopen the typeahead on top of it.
        $m.data("pendingInsert", null);

        // Multiple candidates for a required type: close See All first, then open the picker (never stack modals).
        if (decision.prompt)
        {
            $m.one("hidden.bs.modal", function ()
            {
                openEntityPicker(input, snippetId, rawBody, resolveUrl, function (bodyText)
                {
                    insertIntoSource(pendingInsert, bodyText);
                }, decision.prompt);
            });
            bootstrap.Modal.getOrCreateInstance($m[0]).hide();
            return;
        }

        resolveAndInsert(
            pendingInsert,
            snippetId,
            rawBody,
            resolveUrl,
            function () { bootstrap.Modal.getOrCreateInstance($m[0]).hide(); },
            decision.target
        );
    });

    // Import from Templates — a full modal loaded through $.showModal rather than the spinner shells above, because
    // loadModal injects with innerHTML and never runs the partial's inline filter/validation script.
    function openImportTemplatesModal(pendingInsert)
    {
        var $popover = resolveSharedPopover();
        var url = $popover && $popover.attr("data-import-templates-url");

        if (!url)
            return;

        $.showModal(
            url,
            function (data)
            {
                if (data && data.message)
                    showAlertConfirmation(data.message);

                if (!pendingInsert)
                    return;

                // Clear pendingInsert first so nothing reopens the popover at the trigger key. The showModal dialog
                // has no fade class, so prepModal already hid and removed it synchronously — safe to open See All now.
                var carried = pendingInsert;
                pendingInsert = null;

                openSeeAllModal(carried);
            },
            null,
            "modal-xl",
            function ($modal)
            {
                // $.showModal builds an anonymous dialog, so the shared handler on the two fixed modal ids misses it.
                $modal.one("hidden.bs.modal", function ()
                {
                    // prepModal hides before it calls success, so only a deferred read sees the cleared pendingInsert.
                    setTimeout(function ()
                    {
                        if (pendingInsert && typeof pendingInsert.reopen === "function")
                            pendingInsert.reopen();
                    }, 0);
                });
            },
            null,
            true);
    }

    // Footer "Create Snippet" — hand off to the inline Create modal rather than the settings area. Carry the
    // pendingInsert across so "Save And Insert" still lands at the original caret; clear it first so the See All
    // close handler doesn't reopen the typeahead behind the Create modal. Wait for See All to finish hiding
    // before showing Create so the two BS5 modals don't fight over the backdrop.
    $(document).on("click", "#modal-snippet-see-all [data-snippet-see-all-create]", function (e)
    {
        e.preventDefault();

        var $m = $(this).closest(".modal");
        var pendingInsert = $m.data("pendingInsert");

        $m.data("pendingInsert", null);
        $m.one("hidden.bs.modal", function () { openCreateModal(pendingInsert); });

        bootstrap.Modal.getOrCreateInstance($m[0]).hide();
    });

    // Griddly form-mode only refreshes on submit, so debounce-submit on each keystroke.
    var seeAllFilterTimer = null;

    $(document).on("input", "[data-snippet-modal-filter]", function ()
    {
        var $form = $(this).closest("form");

        if (seeAllFilterTimer)
            clearTimeout(seeAllFilterTimer);

        seeAllFilterTimer = setTimeout(function ()
        {
            $form.trigger("submit");
        }, 250);
    });

    // -----------------------------------------------------------------------------------------------
    // Typeahead popover (the inline trigger-key hovercard)
    // -----------------------------------------------------------------------------------------------

    // Walk `step` rows from `from`, wrapping, until an insertable row turns up. -1 when every row is gated.
    function nextSelectableIndex(results, from, step)
    {
        for (var i = 1; i <= results.length; i++)
        {
            var index = (((from + step * i) % results.length) + results.length) % results.length;

            if (!results[index].blocked)
                return index;
        }

        return -1;
    }

    function renderResults($popover, templates, results, activeIndex, query, anyExist, canImportTemplates)
    {
        var $list = $popover.find("[data-snippet-list]");
        var $footer = $popover.find("[data-snippet-footer]");
        $list.empty();

        if (!results.length)
        {
            var emptyTemplate = anyExist === false ? templates.emptyNoSnippets : templates.emptyNoMatch;

            $list.append(emptyTemplate.cloneNode(true).firstElementChild);
            // Hide See All when the user has no snippets at all — nothing to see.
            $footer.find("[data-action='see-all']").toggleClass("d-none", anyExist === false);
            // The import only belongs on the empty account, and only when there's something left to bring over.
            $footer.find("[data-action='import-templates']").toggleClass("d-none", !(anyExist === false && canImportTemplates));
            $footer.removeClass("d-none");
            return;
        }

        $footer.addClass("d-none");

        var tokens = tokenize(query);

        results.forEach(function (item, i)
        {
            var nameHtml = highlightTokens(item.name || "", tokens);
            var shortcutHtml = highlightTokens(item.shortcut || "", tokens);
            var bodyPreview = truncate((item.body || "").replace(/\s+/g, " ").trim(), 120);
            var bodyHtml = highlightTokens(bodyPreview, tokens);

            var $row = $(templates.item.cloneNode(true).firstElementChild);

            $row.attr("data-index", i);
            $row.find('[data-slot="name"]').html(nameHtml);
            $row.find('[data-slot="shortcut"]').html(shortcutHtml);
            $row.find('[data-slot="body"]').html(bodyHtml);

            if (item.blocked)
            {
                $row.prop("disabled", true).attr("aria-disabled", "true");
                $row.find('[data-slot="unavailable"]').removeClass("d-none");
                $row.find('[data-slot="unavailable-text"]').text("Needs " + requirementPhrase(item.decision.missing));
            }

            if (i === activeIndex)
                $row.addClass("active").attr("aria-selected", "true");

            $list.append($row);
        });
    }

    // Highlight in place instead of rebuilding the list — a rebuild drops the tap's click on iOS so nothing inserts.
    function updateActiveRow($popover, activeIndex)
    {
        $popover.find(".list-group-item[role='option']").each(function ()
        {
            var isActive = parseInt(this.getAttribute("data-index"), 10) === activeIndex;

            this.classList.toggle("active", isActive);

            if (isActive)
                this.setAttribute("aria-selected", "true");
            else
                this.removeAttribute("aria-selected");
        });
    }

    // Surface a search failure inside the popover: clear the list, drop a single red row, hide the footer.
    function renderError($popover, message)
    {
        var $list = $popover.find("[data-snippet-list]");
        var $footer = $popover.find("[data-snippet-footer]");

        $list.empty();
        $list.append($("<li>", { "class": "list-group-item text-center text-danger small py-2" }).text(message));
        $footer.addClass("d-none");
    }

    function positionPopover($popover, anchor)
    {
        var top = anchor.top + anchor.height + window.scrollY + 4;
        var left = anchor.left + window.scrollX;

        // Flip above the line if the popover would overflow the viewport bottom.
        var popHeight = $popover.outerHeight();
        var viewportBottom = window.scrollY + window.innerHeight;
        if (top + popHeight > viewportBottom - 8)
            top = anchor.top + window.scrollY - popHeight - 4;

        // Nudge left if it would overflow the right edge.
        var popWidth = $popover.outerWidth();
        var viewportRight = window.scrollX + window.innerWidth;
        if (left + popWidth > viewportRight - 8)
            left = viewportRight - popWidth - 8;

        $popover.css({ top: top + "px", left: left + "px" });
    }

    // triggerKey is the authoritative value injected server-side from Snippet.TriggerKey via the
    // data-snippet-typeahead-trigger-key attribute; the literal here is only a fallback for textareas
    // attached without that attribute.
    var DEFAULTS = {
        searchUrl: "/settings/snippets/search",
        resolveUrl: "/settings/snippets/resolve",
        triggerKey: "/",
        debounceMs: 120
    };

    // Maps data-snippet-typeahead-* attributes (camelCased by jQuery .data()) to settings keys.
    var DOM_SETTING_KEYS = {
        snippetTypeaheadSearchUrl: "searchUrl",
        snippetTypeaheadResolveUrl: "resolveUrl",
        snippetTypeaheadTriggerKey: "triggerKey",
        snippetTypeaheadDebounceMs: "debounceMs"
    };

    function settingsFromDom($input)
    {
        var data = $input.data();
        var out = {};

        Object.keys(DOM_SETTING_KEYS).forEach(function (k)
        {
            if (data[k] != null) out[DOM_SETTING_KEYS[k]] = data[k];
        });

        return out;
    }

    // The popover, its templates, and all cross-instance handlers are resolved/bound once and shared
    // across every attached textarea — only one typeahead is open at a time, so handlers dispatch to
    // `activeInstance`. Per-textarea handlers (input/keydown/blur) still live in attach().
    var $sharedPopover = null;
    var sharedTemplates = null;
    var globalHandlersBound = false;
    var activeInstance = null;

    function resolveSharedPopover()
    {
        if ($sharedPopover)
            return $sharedPopover;

        var $p = $('#snippet-typeahead-template');

        if (!$p.length)
            return null;

        $sharedPopover = $p;
        sharedTemplates = {
            item: importTemplate($p, "data-snippet-item-template"),
            emptyNoMatch: importTemplate($p, "data-snippet-empty-no-match-template"),
            emptyNoSnippets: importTemplate($p, "data-snippet-empty-no-snippets-template")
        };

        return $sharedPopover;
    }

    function bindGlobalHandlersOnce()
    {
        if (globalHandlersBound)
            return;

        var $p = resolveSharedPopover();

        if (!$p)
            return;

        globalHandlersBound = true;

        // mousedown swallows the textarea's blur so the popover stays open; click does the insert (fires for mouse and touch, so a mobile tap selects too).
        $p.on("mousedown", ".list-group-item[role='option']", function (e)
        {
            e.preventDefault();
        });

        $p.on("click", ".list-group-item[role='option']", function (e)
        {
            e.preventDefault();
            if (activeInstance) activeInstance.selectIndex(parseInt($(this).attr("data-index"), 10));
        });

        $p.on("mousemove", ".list-group-item[role='option']", function ()
        {
            if (activeInstance) activeInstance.setActiveIndex(parseInt($(this).attr("data-index"), 10));
        });

        // mousedown only swallows the textarea's blur so the typeahead stays open until click fires.
        $p.on("mousedown", "[data-action='create'], [data-action='see-all'], [data-action='import-templates']", function (e)
        {
            e.preventDefault();
        });

        // click fires for both mouse and keyboard activation (Enter/Space on a focused button).
        $p.on("click", "[data-action='create'], [data-action='see-all'], [data-action='import-templates']", function (e)
        {
            e.preventDefault();
            if (activeInstance) activeInstance.openFooterAction($(this).attr("data-action"));
        });

        // Close once focus exits the popover entirely (e.g. after tabbing past the Create button).
        $p.on("focusout", function ()
        {
            setTimeout(function ()
            {
                if (!activeInstance) return;
                if (document.activeElement === activeInstance.input) return;
                if ($p[0].contains(document.activeElement)) return;
                activeInstance.close();
            }, 0);
        });

        $(document).on("click.snippetTypeahead", function (e)
        {
            if (!activeInstance) return;
            if ($(e.target).closest($p).length || $(e.target).is(activeInstance.input)) return;
            // The trigger button lives in the compose footer outside the popover and just opened it
            // via openFromButton, so it isn't an inside-click yet — would close immediately otherwise.
            if ($(e.target).closest("[data-snippet-trigger]").length) return;
            activeInstance.close();
        });

        $(window).on("resize.snippetTypeahead scroll.snippetTypeahead", function ()
        {
            if (activeInstance) activeInstance.reposition();
        });
    }

    function attach($input, options)
    {
        if ($input.data("snippet-typeahead-attached"))
            return;

        $input.data("snippet-typeahead-attached", true);

        // Precedence: defaults < DOM attributes < explicit options passed to $.fn.snippetTypeahead.
        var settings = $.extend({}, DEFAULTS, settingsFromDom($input), options || {});

        var input = $input[0];
        var $popover = null;
        var templates = null;

        // Open-state container; null when the typeahead is closed.
        var open = null;

        var searchTimer = null;
        var searchSeq = 0;

        // Exposed to module-scope handlers so they can dispatch without per-attach closures.
        var instance = {
            input: input,
            selectIndex: function (i) { selectIndex(i); },
            setActiveIndex: function (i)
            {
                if (!open || i === open.activeIndex) return;
                open.activeIndex = i;
                updateActiveRow($popover, open.activeIndex);
            },
            openFooterAction: function (action)
            {
                if (!open) return;

                var anchorIndex = open.anchorIndex;
                var caretEnd = input.selectionEnd;

                var pendingInsert = {
                    input: input,
                    anchorIndex: anchorIndex,
                    caretEnd: caretEnd,
                    query: open.query,
                    // Invoked when the modal is dismissed without inserting.
                    reopen: function () { reopenAtSegment(anchorIndex, caretEnd); }
                };

                close();

                if (action === "create") openCreateModal(pendingInsert);
                else if (action === "see-all") openSeeAllModal(pendingInsert);
                else if (action === "import-templates") openImportTemplatesModal(pendingInsert);
            },
            close: function () { close(); },
            // True once the server has confirmed the account has at least one snippet.
            hasAnySnippets: function () { return !!(open && open.anyExist); },
            reposition: function ()
            {
                if (!open || !$popover || !$popover.hasClass("show")) return;
                open.anchor = caretCoords(input, open.anchorIndex);
                positionPopover($popover, open.anchor);
            },
            openFromButton: function ()
            {
                input.focus();

                // Replace any selection with the trigger character so openAtCaret can anchor on it,
                // exactly as if the user had typed the trigger character themselves.
                var start = input.selectionStart;
                var end = input.selectionEnd;
                input.value = input.value.substring(0, start) + settings.triggerKey + input.value.substring(end);

                var caret = start + 1;
                input.setSelectionRange(caret, caret);

                openAtCaret();
            }
        };

        // Exposed so module-scope handlers (e.g. the compose-area trigger button) can dispatch by textarea.
        $input.data("snippet-typeahead-instance", instance);

        function close()
        {
            if (!open)
                return;

            open = null;
            if ($popover)
                $popover.removeClass("show");
            if (activeInstance === instance)
                activeInstance = null;
        }

        function ensurePopover()
        {
            if ($popover)
                return $popover;

            $popover = resolveSharedPopover();

            if (!$popover)
                return null;

            templates = sharedTemplates;
            bindGlobalHandlersOnce();

            return $popover;
        }

        function runSearch(query)
        {
            var mySeq = ++searchSeq;

            $.ajax({
                url: settings.searchUrl,
                type: "GET",
                data: { query: query },
                dataType: "json",
                success: function (data)
                {
                    if (mySeq !== searchSeq || !open)
                        return;

                    open.results = (data && data.results) || [];
                    open.anyExist = !!(data && data.anyExist);
                    open.canImportTemplates = !!(data && data.canImportTemplates);

                    // Flag the gated rows once here so rendering, keyboard nav and insert all agree.
                    open.results.forEach(function (item)
                    {
                        item.decision = decideInsert(input, item.requiredEntities);
                        item.blocked = item.decision.blocked;
                    });

                    open.activeIndex = nextSelectableIndex(open.results, -1, 1);

                    renderResults(ensurePopover(), templates, open.results, open.activeIndex, open.query, open.anyExist, open.canImportTemplates);
                    show();
                },
                error: function (xhr)
                {
                    if (mySeq !== searchSeq || !open)
                        return;

                    var messages = xhr && xhr.responseJSON && xhr.responseJSON.Messages;
                    var message = (messages && messages.length)
                        ? messages.join(" ")
                        : "Something went wrong loading snippets. Please try again.";

                    if (window.console && console.error)
                        console.error("Snippet typeahead search failed:", xhr && xhr.status, xhr && xhr.responseText);

                    renderError(ensurePopover(), message);
                    show();
                }
            });
        }

        function show()
        {
            if (!open)
                return;

            var $pop = ensurePopover();
            $pop.addClass("show");
            positionPopover($pop, open.anchor);
            activeInstance = instance;
        }

        function showRowSpinner(index)
        {
            if (!$popover)
                return;
            $popover.find(".snippet-row[data-index='" + index + "'] .snippet-row-spinner").removeClass("d-none");
        }

        function insertBody(body)
        {
            if (!open)
                return;

            var anchorIndex = open.anchorIndex;
            var caretEnd = input.selectionEnd;

            // Replace the trigger-key query segment with the snippet body.
            var before = input.value.substring(0, anchorIndex);
            var after = input.value.substring(caretEnd);
            input.value = before + body + after;

            var newCaret = before.length + body.length;
            input.setSelectionRange(newCaret, newCaret);
            // Native dispatch (not jQuery .trigger) so autosize's addEventListener("input") fires.
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));

            close();
            input.focus();
        }

        function selectIndex(index)
        {
            if (!open || !open.results[index])
                return;

            var snippet = open.results[index];

            if (snippet.blocked)
                return;

            // More than one candidate for a type the snippet needs -> ask which one before resolving.
            var decision = snippet.decision || decideInsert(input, snippet.requiredEntities);

            if (decision.prompt)
            {
                var pickerInsert = { input: input, anchorIndex: open.anchorIndex, caretEnd: input.selectionEnd };

                close();
                openEntityPicker(input, snippet.id, snippet.body, settings.resolveUrl, function (bodyText)
                {
                    insertIntoSource(pickerInsert, bodyText);
                }, decision.prompt);
                return;
            }

            var context = decision.target;

            if (!settings.resolveUrl || !context)
            {
                insertBody(snippet.body);
                return;
            }

            showRowSpinner(index);

            // Snapshot the open state because the AJAX may resolve after the user has typed more — we still
            // want to insert at the original anchor position they invoked from.
            var capturedOpen = open;

            $.ajax({
                url: settings.resolveUrl,
                type: "POST",
                data: { id: snippet.id, entityType: context.entityType, entityId: context.entityId },
                dataType: "json",
                success: function (data)
                {
                    if (open !== capturedOpen)
                        return;
                    insertBody((data && data.body) || snippet.body);
                },
                error: function ()
                {
                    if (open !== capturedOpen)
                        return;
                    insertBody(snippet.body);
                }
            });
        }

        function scheduleSearch()
        {
            if (searchTimer)
                clearTimeout(searchTimer);

            searchTimer = setTimeout(function ()
            {
                if (!open)
                    return;
                runSearch(open.query);
            }, settings.debounceMs);
        }

        // Reflect the current open state in the popover with a debounced search. An empty query browses
        // (the server returns the most-recently-touched snippets); typing narrows the list from there.
        function refreshOpen()
        {
            if (!open)
                return;

            scheduleSearch();
        }

        function recomputeFromCaret()
        {
            if (!open)
                return;

            var caret = input.selectionEnd;

            if (caret < open.anchorIndex + 1)
            {
                // User deleted past the trigger character — close.
                close();
                return;
            }

            // If the user deleted the trigger character, close.
            if (input.value.charAt(open.anchorIndex) !== settings.triggerKey)
            {
                close();
                return;
            }

            // Spec: only esc, click-out, and enter close the typeahead — spaces/punctuation are part of the query.
            open.query = input.value.substring(open.anchorIndex + 1, caret);
            refreshOpen();
        }

        function openAtCaret(explicitAnchorIndex)
        {
            // Anchor on the trigger's real position, passed explicitly by keydown so fast typing can't move the caret past it before this deferred call runs.
            var anchorIndex = typeof explicitAnchorIndex === "number" ? explicitAnchorIndex : input.selectionEnd - 1;

            // The keydown path and the input fallback can both reach here for the same keystroke — don't reopen.
            if (open && open.anchorIndex === anchorIndex)
                return;

            // If the trigger char isn't actually there (e.g. deleted between keydown and this tick), don't open.
            if (input.value.charAt(anchorIndex) !== settings.triggerKey)
                return;

            var caretEnd = input.selectionEnd;
            var anchor = caretCoords(input, anchorIndex);

            open = {
                anchorIndex: anchorIndex,
                anchor: anchor,
                // Read the query from the live value so text already typed after the trigger still filters.
                query: input.value.substring(anchorIndex + 1, caretEnd),
                results: [],
                anyExist: true,
                canImportTemplates: false,
                activeIndex: -1
            };
            activeInstance = instance;

            refreshOpen();
        }

        // Re-establish typeahead state at a previously-captured trigger-key segment. Used when a modal opened from the
        // hovercard is cancelled — the user should land back exactly where they were.
        function reopenAtSegment(anchorIndex, caretEnd)
        {
            if (typeof anchorIndex !== "number" || anchorIndex < 0 || anchorIndex >= input.value.length)
                return;

            if (input.value.charAt(anchorIndex) !== settings.triggerKey)
                return;

            input.focus();
            var caret = Math.max(anchorIndex + 1, Math.min(caretEnd, input.value.length));
            input.setSelectionRange(caret, caret);

            open = {
                anchorIndex: anchorIndex,
                anchor: caretCoords(input, anchorIndex),
                query: input.value.substring(anchorIndex + 1, caret),
                results: [],
                anyExist: true,
                canImportTemplates: false,
                activeIndex: -1
            };
            activeInstance = instance;

            refreshOpen();
        }

        $input.on("input", function ()
        {
            if (open)
            {
                recomputeFromCaret();
                return;
            }

            // Fallback for keyboards with no usable e.key on keydown (iOS soft keyboard) — open off the landed trigger char.
            var caret = input.selectionEnd;
            if (caret > 0 && input.value.charAt(caret - 1) === settings.triggerKey)
            {
                var atWordStart = caret === 1 || /\s/.test(input.value.charAt(caret - 2));

                if (atWordStart)
                    openAtCaret(caret - 1);
            }
        });

        $input.on("keydown", function (e)
        {
            // Trigger-key press opens the typeahead, but only when it begins a new word — at the very
            // start of the field or right after whitespace. This keeps it from firing inside ordinary
            // text where the trigger character is common (dates like "6/17", URLs like "http://").
            // The character hasn't landed yet on keydown, so defer openAtCaret one tick.
            if (e.key === settings.triggerKey)
            {
                var pos = input.selectionStart;
                var atWordStart = pos === 0 || /\s/.test(input.value.charAt(pos - 1));

                // Capture where the trigger lands and pass it to openAtCaret so the anchor holds no matter how fast the rest is typed.
                if (atWordStart)
                    setTimeout(function () { openAtCaret(pos); }, 0);

                return;
            }

            if (!open)
                return;

            var nextIndex;

            switch (e.key)
            {
                case "Escape":
                    e.preventDefault();
                    close();
                    break;

                case "Enter":
                    // Modifier+Enter (e.g. compose's Ctrl/Cmd+Enter send shortcut) must not fire while the
                    // popover is open — swallow it so the half-typed message isn't sent mid-selection.
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        break;
                    }

                    // Only a clean Enter inserts the highlighted snippet.
                    if (open.results.length > 0 && open.activeIndex >= 0)
                    {
                        e.preventDefault();
                        selectIndex(open.activeIndex);
                    }
                    break;

                case "Tab":
                case "ArrowDown":
                    nextIndex = nextSelectableIndex(open.results, open.activeIndex, 1);

                    if (nextIndex >= 0)
                    {
                        e.preventDefault();
                        open.activeIndex = nextIndex;
                        renderResults($popover, templates, open.results, open.activeIndex, open.query, open.anyExist, open.canImportTemplates);
                    }
                    else if (e.key === "Tab" && !e.shiftKey && $popover)
                    {
                        // No results — first Tab moves into the footer buttons (See All / Create) rather
                        // than escaping to the next form element (e.g. the reply form's Send button).
                        var $first = $popover.find("[data-snippet-footer] button:visible").first();

                        if ($first.length)
                        {
                            e.preventDefault();
                            $first[0].focus();
                        }
                    }
                    break;

                case "ArrowUp":
                    nextIndex = nextSelectableIndex(open.results, open.activeIndex, -1);

                    if (nextIndex >= 0)
                    {
                        e.preventDefault();
                        open.activeIndex = nextIndex;
                        renderResults($popover, templates, open.results, open.activeIndex, open.query, open.anyExist, open.canImportTemplates);
                    }
                    break;
            }
        });

        $input.on("blur", function ()
        {
            // Allow click-on-popover to register before closing. Also skip if the textarea is focused by
            // the time the timer fires — BS5 modal-hide cleanup briefly blurs the textarea before refocusing,
            // which would otherwise tear down a freshly-restored typeahead state.
            setTimeout(function ()
            {
                if (document.activeElement === input)
                    return;
                // Focus moved into the popover (e.g. tabbed to See All / Create) — keep it open; the
                // popover's own focusout handler will close once focus leaves the popover entirely.
                if ($popover && $popover[0].contains(document.activeElement))
                    return;
                if (open && $popover && !$popover.is(":hover"))
                    close();
            }, 100);
        });
    }

    // Auto-attach to [data-snippet-typeahead] textareas added after page load (AJAX, lazy-loaded panels).
    var observer = null;

    function startObserver()
    {
        if (observer || !window.MutationObserver || !document.body)
            return;

        observer = new MutationObserver(function (mutations)
        {
            for (var i = 0; i < mutations.length; i++)
            {
                var added = mutations[i].addedNodes;

                for (var j = 0; j < added.length; j++)
                {
                    var node = added[j];

                    if (node.nodeType !== 1)
                        continue;

                    if (node.matches && node.matches("[data-snippet-typeahead]"))
                        attach($(node));

                    if (node.querySelectorAll)
                    {
                        var nested = node.querySelectorAll("[data-snippet-typeahead]");

                        for (var k = 0; k < nested.length; k++)
                            attach($(nested[k]));
                    }
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    $.fn.snippetTypeahead = function (options)
    {
        return this.each(function ()
        {
            attach($(this), options);
        });
    };

    // Compose-area scroll icon: walks up to the nearest container with a snippet textarea, then opens
    // that instance's typeahead. Bound at module scope (not inside attach) so a single handler serves
    // every compose surface and survives across observer-driven re-attaches.
    $(document).on("click", "[data-snippet-trigger]", function (e)
    {
        e.preventDefault();

        var $trigger = $(this);

        if ($trigger.hasClass("disabled") || $trigger.prop("disabled"))
            return;

        var $textarea = $trigger.closest(":has([data-snippet-typeahead])").find("[data-snippet-typeahead]").first();
        var instance = $textarea.data("snippet-typeahead-instance");

        if (instance) instance.openFromButton();
    });

    // Cog in the popover header: when the account has snippets, open the See All modal inline (it carries its
    // own Create button) rather than jumping to the global settings area. On an empty account, fall through to
    // the link's href so a brand-new user still lands in Settings to get started.
    $(document).on("click", "[data-snippet-cog]", function (e)
    {
        if (!activeInstance || !activeInstance.hasAnySnippets())
            return;

        e.preventDefault();
        activeInstance.openFooterAction("see-all");
    });

    startObserver();

})(jQuery);

$(".admin-dropdown-button").parent().on("shown.bs.dropdown", function (e)
{
    $(this).find("input:text:visible").first().focus();
});

$(".navbar-form, .navbar .form-inline").on("submit", function (e)
{
    $(this).find("input:hidden").prop("disabled", true);
    $(this).addClass("loading");
});

$(".search-button").on("click", function ()
{
    $(this).closest("form").submit();
});

$("[data-impersonate-write]").click(function ()
{
    var isWrite = $(this).data("impersonate-write");
    var button = $(this);

    button.addClass("impersonate-changing disabled").prop("disabled", true);

    $.ajax
        ({
            type: "POST",
            url: BaseUrl + "/switchimpersonatemode?isWrite=" + isWrite
        })
        .fail(function (xhr, status, error)
        {
            showApiErrorsInModal(xhr, "Error Switching To " + (isWrite ? "Write" : "Read Only") + " Mode");
        })
        .done(function (data)
        {
            $(".admin-bar").toggleClass("admin-bar-write", isWrite);
            $("body").toggleClass("readonly", !isWrite);

            $("[data-impersonate-write=" + !isWrite + "]").show();
            $("[data-impersonate-write=" + isWrite + "]").hide();
        })
        .always(function ()
        {
            button.removeClass("impersonate-changing disabled").prop("disabled", false);
        });
});

$(document).on("click", ".tools-menu a, a.invoke-tools-modal", function (e)
{
    if (e.button != 0 || e.ctrlKey || $(this).hasClass("full-page"))
        return true;

    $("#tools-modal").toggleClass("modal-fullscreen", $(this).data("modal-size") == "fullscreen");
    $("#tools-modal .modal-dialog").toggleClass("modal-lg", $(this).data("modal-size") == "lg");
    $("#tools-modal .modal-title").text($(this).data("modal-title") || ($(this).is(".list-group-item") ? $("h4", this).text() : $(this).text()));

    $("#tools-modal-spinner").show();

    var src = $(this).attr("href");

    src += (src.indexOf("?") == -1 ? "?" : "&") + "modal=true";

    $("#tools-modal iframe").attr("src", src);
    $("#tools-modal").modal("show");
    closeRightSidebar();

    return false;
});

$("#tools-modal").on("hidden.bs.modal", function ()
{
    $("#tools-modal iframe")
        .attr("src", "")
        .css("height", "500px")
        .hide();
});

$("#tools-modal").on("shown.bs.modal", function ()
{
    $(".popover").popover("hide");
});

$("#tools-modal iframe").on("load", function ()
{
    if ($(this).attr("src"))
    {
        $("#tools-modal-spinner").hide();

        $(this).show();

        var body = this.contentWindow.document.body;
        var el = this;

        var updateHeight = function ()
        {
            var height = body.scrollHeight;

            if (height < 500)
                height = 500;

            $(el)
                .css("height", height + "px");
        };

        updateHeight();

        // check a couple more times as things re-layout
        // TODO: is this caused by miniprofiler mayhap?
        window.setTimeout(updateHeight, 100);
        window.setTimeout(updateHeight, 200);
    }
});

$(document).on("click", "a.or-premium-owner-required", function (e)
{
    e.preventDefault();

    bootbox.alert({
        title: $(this).data("or-title"),
        message: $("<p class='mb-0' />").text($(this).data("or-message")),
        buttons: { ok: { label: "Close", className: "btn-default" } }
    });
});

$(document).on("click", ".datepicker-open-button", function ()
{
    $(this).parents(".input-group.date").find("input").focus();
});

if ($.fn.datepicker)
{
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.todayHighlight = true;
}

if (window.dayjsLocale)
{
    // Must be called before Griddly and friends, and before the page-load focus below creates the first datepicker
    if ($.fn.datepicker)
    {
        var datePickerCultureDefaults = {
            culture: dayjsLocale.culture,
            format: dayjsLocale.datePickerFormat,
            weekStart: dayjsLocale.weekStart,
            days: dayjsLocale.weekdays,
            daysShort: dayjsLocale.weekdaysShort,
            daysMin: dayjsLocale.weekdaysShort,
            months: dayjsLocale.months,
            monthsShort: dayjsLocale.monthsShort
        };

        $.fn.datepicker.dates[datePickerCultureDefaults.culture] = datePickerCultureDefaults;
        $.fn.datepicker.defaults.language = datePickerCultureDefaults.culture;
    }

    if (window.dayjs)
    {
        dayjs.extend(window.dayjs_plugin_customParseFormat)

        dayjs.locale(dayjsLocale, null, true)
        dayjs.locale(dayjsLocale.name)
    }
}

$(function ()
{
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.todayHighlight = true;
});

$.extend({
    getAntiForgeryToken: function ()
    {
        var token = $("input[name^=__RequestVerificationToken]").first();

        return token.length ? { name: token.attr("name"), value: token.val() } : null;
    },
    addAntiForgeryToken: function ($form)
    {
        var token = $.getAntiForgeryToken();

        if (token && !$("[name='" + token.name + "']", $form).length)
            $form.append("<input type=\"hidden\" name=\"" + token.name + "\" value=\"" + token.value + "\" />");
    },
    getGo: function (url, params)
    {
        document.location = url + '?' + $.param(params);
    },
    postGo: function (url, params)
    {
        var $form = $("<form>")
            .attr("method", "post")
            .attr("action", url);

        $.addAntiForgeryToken($form);

        if (params != null)
        {
            $.each(params, function (name, value)
            {
                if (value instanceof Array)
                {
                    for (var i = 0; i < value.length; i++)
                    {
                        $("<input type='hidden'>")
                            .attr("name", name)
                            .attr("value", value[i])
                            .appendTo($form);
                    }
                }
                else
                {
                    $("<input type='hidden'>")
                        .attr("name", name)
                        .attr("value", value)
                        .appendTo($form);
                }
            });
        }

        $form.appendTo("body");
        $form.submit();
    }
});

// AntiForgery for forms
$(document).on("submit", "form", function ()
{
    var method = $(this).attr("method");

    if (method && method.toUpperCase() === "POST")
        $.addAntiForgeryToken($(this));
});

// AntiForgery for AJAX
$.ajaxPrefilter(function (options, originalOptions, jqXHR)
{
    if (options.type.toUpperCase() != "GET")
    {
        var token = $.getAntiForgeryToken();

        if (token)
        {
            var headers = options.headers = options.headers || {};

            headers[token.name] = token.value;
        }
    }
});

function redirectToLoginIfDenied(status)
{
    if (status === 401 || status === 403)
        window.location.href = "/login?returnUrl=" + encodeURIComponent(window.location.href);
}

window.orFetch = function (url, init)
{
    init = Object.assign({ credentials: "same-origin" }, init);
    init.headers = new Headers(init.headers);

    // Without this header an MVC action answers a signed-out request with a redirect to the login page instead of a 401.
    init.headers.set("X-Requested-With", "XMLHttpRequest");

    if ((init.method || "GET").toUpperCase() != "GET")
    {
        var token = $.getAntiForgeryToken();

        if (token)
            init.headers.set(token.name, token.value);
    }

    return fetch(url, init).then(function (response)
    {
        redirectToLoginIfDenied(response.status);

        return response;
    });
};

// Refresh anti-forgery token when a backgrounded tab wakes (iOS Safari drops session cookies)
(function ()
{
    var lastRefresh = 0;
    var cooldownMs = 5000;

    function refreshToken()
    {
        var now = Date.now();

        if (now - lastRefresh < cooldownMs)
            return;

        lastRefresh = now;

        // global:false keeps a failure here out of the ajaxError login redirect; a background refresh must not navigate the page.
        $.ajax({ url: "/home/refreshtoken", global: false }).done(function (data)
        {
            if (!data || !data.formToken)
                return;

            // An expired session refreshes anonymously, and that token on a page rendered signed in fails
            // anti-forgery on the next post.
            if (!data.isAuthenticated && document.body.classList.contains("signed-in"))
                return;

            $("input[name^=__RequestVerificationToken]").val(data.formToken);
        }).fail(function ()
        {
            lastRefresh = 0;
        });
    }

    window.addEventListener("pageshow", function (e)
    {
        if (e.persisted)
            refreshToken();
    });

    document.addEventListener("visibilitychange", function ()
    {
        if (document.visibilityState === "visible")
            refreshToken();
    });
})();

// Handle 401/403 responses by redirecting to login page
$(document).ajaxError(function (event, xhr)
{
    redirectToLoginIfDenied(xhr.status);
});

$(document.body).on("click", "a[data-toggle=post]:not(.griddly a[data-toggle=post]:not(.non-griddly), [data-role='griddly-button']), .griddly table a[data-toggle=post]", function (e)
{
    var execute = function ()
    {
        var url = $(e.currentTarget).data("url");

        if (url == null || url === undefined)
            url = $(e.currentTarget).attr("href");

        $.postGo(url);
        $(e.currentTarget).filter(":not(.no-disable)").attr("disabled", "disabled");

        if ($(e.currentTarget).attr("data-loading-text"))
            $(e.currentTarget).showWorking($(e.currentTarget));
    };

    var message = $(e.currentTarget).data("confirm-message");
    var title = $(e.currentTarget).data("confirm-title");
    var yesText = $(e.currentTarget).data("confirm-yes");
    var noText = $(e.currentTarget).data("confirm-no");
    var yesClass = $(e.currentTarget).data("confirm-yes-class");

    if (message)
    {
        bootbox.confirm({
            message: (!title ? "" : `<p class='lead'>${title}</p>`) + `<p>${message}</p>`,
            closeButton: false,
            callback: function (result)
            {
                if (result)
                    execute();
            },
            buttons: {
                confirm: {
                    label: yesText || "OK",
                    className: yesClass || 'btn-success'
                },
                cancel: {
                    label: noText || "Cancel",
                    className: 'btn-default'
                }
            },
        });
    }
    else
        execute();

    e.preventDefault();

    return false;
});

// Don't auto-focus on mobile devices to avoid keyboard popup
if (!window.matchMedia('(pointer: coarse)').matches)
{
    $("form").not(".modal form").not(".no-focus").find("input[type=text], textarea, select").not(".no-focus").filter(":visible:first").focus();
}

var animateAlertConfirmation = function ()
{
    $(".alert-confirmation").animate({ top: "80px" }, 600)
        .animate({ marginTop: "-=50px" }, 200)
        .animate({ marginTop: "+=30px" }, 200)
        .animate({ marginTop: "-=10px" }, 200)
        .animate({ marginTop: "+=10px" }, 200)
        .animate({ marginTop: "-=5px" }, 200)
        .animate({ marginTop: "+=5px" }, 200,
            function ()
            {
                $(this).parent().css("height", $(this).position().top + $(this).offset().top + $(this).outerHeight(true) + "px");
            })
        .delay(5000)
        .animate({ right: "-500px", opacity: "0" }, 1000, "linear", function () { $(this).parent().remove(); })
        .on("close.bs.alert", function () { $(this).parent().remove(); });
};

animateAlertConfirmation();

function showAlertConfirmation(message, parent, alertClass)
{
    if (!alertClass)
        alertClass = "alert-success";

    // Failures interrupt whatever the screen reader is saying; confirmations wait their turn.
    var role = alertClass === "alert-danger" || alertClass === "alert-warning" ? "alert" : "status";

    $(parent || document.body).append(
        '<div class="alert-confirmation-wrapper"><div class="alert ' + alertClass + ' alert-dismissible alert-confirmation" role="' + role + '"><button type="button" class="close btn-close btn-close-custom float-end" data-dismiss="alert" data-bs-dismiss="alert" aria-label="Close"></button>' + message + '</div></div>'
    );

    animateAlertConfirmation();
}

if (window.bootbox)
{
    bootbox.setDefaults(
        {
            animate: false
        });
}

$.fn.clearValidation = function ()
{
    if (typeof $(this).validate === "function")
    {
        var v = $(this).validate();

        // PERF: this is slow
        $('[name]:visible', this).each(function ()
        {
            v.successList.push(this);
        });

        v.showErrors();
        v.resetForm();
        v.reset();
    }

    $(this).find(".validation-summary-errors").addClass("validation-summary-valid").removeClass("validation-summary-errors").find("ul").empty();
    $(this).find(".form-group.has-error").removeClass("has-error");
    $(this).find(".form-group.has-success").removeClass("has-success");
    $(this).find(".input-validation-error").removeClass("input-validation-error");
    $(this).find(".field-validation-error").hide();
};

// Stamp the request URL onto the jqXHR so the error path can name the failing call.
$.ajaxPrefilter(function (options, originalOptions, jqXHR)
{
    jqXHR._orUrl = options.url;
});

var getApiErrorMessages = function (xhr, skipGenericFallback)
{
    var messages = [];

    if (xhr)
    {
        if (xhr.status == 401)
            messages[messages.length] = "Your login has expired. Refresh the page to login again.";
        else
        {
            var errorMessage = xhr.getResponseHeader("X-Error-Message");

            if (errorMessage != null && errorMessage.length > 0)
                messages[messages.length] = errorMessage;
            else
            {
                try
                {
                    if (xhr.responseText != null && xhr.responseText.length > 0)
                    {
                        var data = $.parseJSON(xhr.responseText);

                        if (data.hasOwnProperty("Messages") && Object.prototype.toString.call(data.Messages) === "[object Array]"
                            && data.hasOwnProperty("StatusCode"))
                        {
                            for (var i = 0; i < data.Messages.length; i++)
                                messages[messages.length] = data.Messages[i];
                        }
                    }
                }
                catch (err) { }

                if (messages.length == 0 && !skipGenericFallback)
                {
                    if (xhr.statusText != null && xhr.statusText.length > 0 && xhr.statusText != "error")
                        messages[messages.length] = "A '" + xhr.statusText + "' error occurred. Try refreshing the page.";
                    else
                        messages[messages.length] = "An error occurred. Try refreshing the page.";
                }
            }
        }
    }

    return messages;
};

// Never throws — storage failures must not break error display.
var recordApiErrorForRezzy = function (xhr)
{
    try
    {
        // 401 = login expiry, 0 = aborted/timed-out/CORS-blocked — neither is a diagnosable
        // application error, so keep them out.
        if (!xhr || !xhr.status || xhr.status == 401)
            return;

        // Caps (3 msgs × 200 chars) pair with UserSupportPageContext's server-side clamps; the
        // 10-min TTL pairs only with agent-chat.js's _readLastError.
        var messages = getApiErrorMessages(xhr).slice(0, 3).map(function (m) { return (m || '').substring(0, 200); });
        var url = xhr._orUrl || null;
        var status = xhr.status || 0;
        var signature = url + '|' + status + '|' + (messages[0] || '');
        var now = Date.now();
        var maxAgeMs = 10 * 60 * 1000;

        var count = 1;
        try
        {
            var raw = sessionStorage.getItem('or_lastApiError');
            var last = raw ? JSON.parse(raw) : null;

            // Same error repeating within the TTL bumps the count (an escalation signal);
            // a different error replaces the slot outright.
            if (last && (now - last.at) < maxAgeMs
                && signature === (last.url || null) + '|' + (last.status || 0) + '|' + ((last.messages && last.messages[0]) || ''))
                count = (last.count || 1) + 1;
        }
        catch (parseErr) { }

        // pagePath = where the user saw the error; the chip shows only on that exact page.
        sessionStorage.setItem('or_lastApiError', JSON.stringify({
            url: url,
            pagePath: window.location.pathname,
            status: status,
            messages: messages,
            at: now,
            count: count
        }));
    }
    catch (err) { }
};

var showApiErrorsInModal = function (xhr, operation, callback, preamble)
{
    var messages = getApiErrorMessages(xhr);

    if (messages.length > 0)
    {
        var message = '';

        if (preamble)
            message = `<p>${preamble}</p>`;

        if (messages.length == 1)
            message += messages[0];
        else
            message += "<ul><li>" + messages.map(function (m) { return m.replace(/[\r\n]+/g, '<br />'); }).join("</li><li>") + "</li></ul>";

        recordApiErrorForRezzy(xhr);

        // Popup may already be open behind this modal — refresh its context bar so the
        // error chip reflects the error just recorded.
        var rezzyChatEl = document.getElementById('agent-chat-popup');
        if (rezzyChatEl && rezzyChatEl._agentChat)
            rezzyChatEl._agentChat._renderContextBar();

        // Same gate as recordApiErrorForRezzy: status 0 (aborted/timed-out) and 401 aren't
        // diagnosable, so don't offer Rezzy an error it can't see.
        if (document.getElementById('rezzy-popup') && xhr && xhr.status && xhr.status !== 401)
        {
            var rezzyPrefill = messages[0]
                ? 'Why am I getting this error: "' + messages[0].replace(/[\r\n]+/g, ' ').trim().substring(0, 200) + '"?'
                : 'Why am I getting this error?';

            bootbox.dialog({
                title: operation,
                message: message,
                backdrop: true,
                // bootbox.alert fires the callback on ESC/backdrop dismissal; dialog() needs
                // onEscape wired explicitly to keep that contract (callers may reload in it).
                onEscape: callback || true,
                buttons:
                {
                    close:
                    {
                        label: "Close",
                        className: 'btn-default',
                        callback: callback
                    },
                    askRezzy:
                    {
                        label: '<i class="far fa-dragon"></i> Ask Rezzy about this',
                        className: 'btn-primary',
                        callback: function ()
                        {
                            // Keys first: if the caller's callback reloads the page, the popup
                            // and draft restore from sessionStorage on load.
                            try
                            {
                                sessionStorage.setItem('rezzy_open', 'true');
                                sessionStorage.setItem('rezzy_draft', rezzyPrefill);
                                sessionStorage.setItem('rezzy_launch_source', 'errorModal');
                            }
                            catch (err) { }

                            var el = document.getElementById('agent-chat-popup');
                            if (el && el._agentChat)
                                el._agentChat.openFromErrorModal(rezzyPrefill);

                            // Same dismissal contract as Close/ESC/backdrop — callers rely on
                            // the callback for cleanup or reload after a failed action.
                            if (callback)
                                callback();

                            return true;
                        }
                    }
                }
            });
        }
        else
        {
            bootbox.alert({
                title: operation,
                message: message,
                callback: callback,
                backdrop: true
            });
        }
    }
};

$.fn.showApiErrorsInSummary = function (xhr, addendum)
{
    var messages = getApiErrorMessages(xhr);

    $.fn.showErrorsInSummary.call(this, messages, addendum);
};

$.fn.showErrorsInSummary = function (messages, addendum)
{
    if (messages.length > 0)
    {
        var alert = $(this).find(".validation-summary-valid, .validation-summary-errors");

        if (alert && alert.length)
            alert = alert.get(0);

        if (alert)
        {
            $(alert).find("ul").empty();

            for (var i = 0; i < messages.length; i++)
            {
                var li = self.document.createElement("li");

                li.innerHTML = messages[i].replace("  ", "&nbsp; ");

                $(alert).find("ul").append(li);
            }

            if (typeof addendum !== "undefined")
                $(alert).find("ul").after(addendum);

            $(alert).removeClass("validation-summary-valid").addClass("validation-summary-errors");
        }
    }
};

// Geocodes an address given as { street1, street2, city, region, postalCode, country } strings, where region is the
// state code or province name. Calls back with (lat, lng), or (null, null) when Google has no match. Returns false
// without looking anything up when street1, city or country is blank.
function geocodeAddress(address, callback)
{
    var part = function (value) { return $.trim(value || ""); };

    if (!part(address.street1) || !part(address.city) || !part(address.country))
        return false;

    var query = [address.street1, address.street2, address.city, address.region, address.postalCode, address.country]
        .map(part)
        .filter(Boolean)
        .join(", ");

    new google.maps.Geocoder().geocode({ address: query, region: "US", language: "en" }, function (results, status)
    {
        var location = status == google.maps.GeocoderStatus.OK && results && results.length ? results[0].geometry.location : null;

        callback(location ? location.lat() : null, location ? location.lng() : null);
    });

    return true;
}

function shouldUseIconOnlyLoadingForInboxReply($btn)
{
    if (!$btn.closest(".inbox-layout .thread-reply").length)
        return false;

    return window.matchMedia("(max-width: 767.98px), (max-height: 500px)").matches;
}

$.fn.showWorking = function (btn, loadingText)
{
    if (!btn)
    {
        btn = $(this).find(".form-actions .btn-success[data-loading-text], .modal-footer .btn-success[data-loading-text], .page-header .btn-success[data-loading-text], .use-loading-buttons .btn-success[data-loading-text]");

        if (!btn.length)
            btn = $(this).find("[data-loading-text]:submit");
    }
    else
    {
        btn = $(btn);

        if (btn.closest("ul.dropdown-menu").length)
        {
            btn.closest("ul.dropdown-menu").hide();
            btn = btn.closest("ul.dropdown-menu").prev(".btn");
        } else if (btn.closest('div.btn-group').find('.dropdown-menu').length) {
            // In BS5 a disabled button doesn't automatically hide the dropdown menu so manually hide.
            btn.closest('div.btn-group').find('.dropdown-menu').removeClass('show');
        }
    }

    if (btn && btn.length > 0)
    {
        btn = $(btn).get(0);

        $(btn).closest("form").data("isWorking", true);

        loadingText = loadingText || $(btn).data("loading-text");

        if (loadingText)
        {
            if (!$(btn).data("nonloading-text"))
                $(btn).data("nonloading-text", $(btn).html());

            var $b = $(btn);
            var loadingHtml = "<span class=\"fa fa-spin fa-circle-notch\"></span>";
            if (!shouldUseIconOnlyLoadingForInboxReply($b))
                loadingHtml += " " + loadingText;

            $b.html(loadingHtml).addClass("disabled");
            $(this).find(".form-actions .btn-hide-while-loading, .modal-footer .btn-hide-while-loading, .page-header .btn-hide-while-loading, .btn-toolbar .btn-hide-while-loading").not(btn).hide();

            // XXX: should we just do this for all buttons?
            $(this).find(".form-actions .btn-disable-while-loading, .modal-footer .btn-disable-while-loading, .page-header .btn-disable-while-loading, .btn-toolbar .btn-disable-while-loading").not(btn).addClass("disabled");

            $(btn).addClass("form-working-btn");
            $(btn).blur();

            $(btn).next(".dropdown-toggle").addClass("disabled");
        }
    }
};

$.fn.showWorkingTrackDownload = function (downloadTrackId)
{
    var $el = $(this);

    if (!$el.is("[data-loading-text]"))
        $el = $el.parents(".btn-group").find("[data-loading-text]:first");
    var form = $el.closest("form");
    if (!form.length)
        form = $el;

    $el.showWorking.call(form, $el);

    var checkForDownloadComplete = function ()
    {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++)
        {
            if (cookies[i].indexOf(downloadTrackId + "=") != -1)
            {
                removeCookie(downloadTrackId);

                $el.hideWorking.call(form, $el);

                clearInterval(interval);
            }
        }
    };

    var interval = setInterval(checkForDownloadComplete, 500);
};

$.fn.hideWorking = function (btn)
{
    if (!btn)
        btn = $(this).find(".form-actions .btn-success, .modal-footer .btn-success, .form-working-btn");

    if (btn && btn.length > 0)
    {
        // Hotfix: Capture the `this` context to make sure we hide reveal right thing!
        var that = this;
        $(btn).each(function ()
        {
            $btn = $(this);

            $btn.closest("form").data("isWorking", false);

            if ($btn.data("nonloading-text"))
            {
                $btn.html($btn.data("nonloading-text")).removeClass("disabled");
                $(that).find(".form-actions .btn-hide-while-loading, .modal-footer .btn-hide-while-loading, .page-header .btn-hide-while-loading, .btn-toolbar .btn-hide-while-loading").show();

                $btn.next(".dropdown-toggle").removeClass("disabled");

                $btn.removeData("nonloading-text");
            }
        });
    }
};

$.fn.isWorking = function (e, params)
{
    params = params || {};
    return !!$(this).closest("form").data("isWorking") || !!params.showWorking;
};

function ModalConfirmNavigate(message, specialButtons)
{
    var a = event.target || event.srcElement;

    var defaults =
    {
        callback: function (result)
        {
            if (result)
                self.location.href = $(a).attr("href");
        }
    }

    var options = {};

    if (typeof message === 'string')
        options = $.extend(defaults, { message: message });
    else if (typeof message === 'object')
        options = $.extend(defaults, message);
    else
        options = defaults;

    if (specialButtons != null)
        options.buttons = specialButtons;

    bootbox.confirm(options);

    return false;
}

function ModalConfirm(message, successAction, failAction, specialButtons, size)
{
    var options =
    {
        message: message,
        size: size,
        closeButton: false,
        callback: function (result)
        {
            if (result)
            {
                if (successAction)
                    return successAction() !== false;
            }
            else
            {
                if (failAction)
                    failAction();
            }
        }
    }

    if (specialButtons != null)
        options.buttons = specialButtons;

    bootbox.confirm(options);

    return false;
}

var sizeSymbolsNoConflict = ["kB", "MB", "GB", "TB", "PB", "EB"];

function FormatSize(bytes)
{
    if (bytes === 0)
    {
        return bytes + sizeSymbolsNoConflict[0];
    }
    var i = -1;
    do
    {
        bytes = bytes / 1e3;
        i++;
    } while (bytes > 999);
    return Math.max(bytes, .1).toFixed(1) + sizeSymbolsNoConflict[i];
};
$(document).ready(function () {
    $('.select-placeholder').on('change', function () {
        if ($(this).val()) {
            return $(this).css('color', '#212529');
        } else {
            return $(this).css('color', '#595B60');
        }
    });
});

/*!
 * OwnerRez site.js
 */

// Bump bundle hash 260709

// internationalization
(function ()
{
    // https://stackoverflow.com/a/74352853/24277912
    class NumberParser
    {
        constructor(locale)
        {
            const format = new Intl.NumberFormat(locale);
            const parts = format.formatToParts(-12345.6);
            const numerals = Array.from({ length: 10 }).map((_, i) => format.format(i));
            const index = new Map(numerals.map((d, i) => [d, i]));
            this._minusSign = parts[0].value;
            const groupSep = parts.find(d => d.type === "group").value;
            this._group = /\s/.test(groupSep) ? /\s/g : new RegExp(`[${groupSep}]`, "g");
            this._decimal = new RegExp(`[${parts.find(d => d.type === "decimal").value}]`);
            this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
            this._index = d => index.get(d);
        }
        parse(string)
        {
            if (typeof string === "number")
                return string;
            if (string == null)
                return NaN;
            
            return (string = string.trim()
                .replace(this._minusSign, "-")
                .replace(this._group, "")
                .replace(this._decimal, ".")
                .replace(this._numeral, this._index)) ? +string : NaN;
        }
    }

    const floatParser = new NumberParser(window.locale ? window.locale.culture : "en");
    const floatParserUs = new NumberParser("en");

    // https://github.com/ApelegHQ/intl-number-parser/blob/master/src/NumberParser.ts
    const NumberParser2 = (locale, options) => {
        // Fallback for older browsers
        if (
            typeof Intl !== 'object' ||
            typeof Intl.NumberFormat !== 'function' ||
            typeof Intl.NumberFormat.prototype.formatToParts !== 'function'
        ) {
            return Number;
        }

        const formatter = new Intl.NumberFormat(locale, options);

        const parts = [
            ...formatter.formatToParts(123456789.12345679),
            ...formatter.formatToParts(123456789),
            ...formatter.formatToParts(1234),
            ...formatter.formatToParts(0.12345),
        ];
        const numerals = new Array(10)
            .fill(undefined)
            .map((_, i) => formatter.format(i));

        const literalSeparators = Array.from(
            new Set(
                parts
                    .filter((part) => part.type === 'literal')
                    .map((part) => part.value),
            ),
        );
        const currencySeparators = Array.from(
            new Set(
                parts
                    .filter((part) => part.type === 'currency')
                    .map((part) => part.value)
                    .concat(["$", "£", "€"]),
            ),
        );
        const groupSeparators = Array.from(
            new Set(
                parts
                    .filter((part) => part.type === 'group')
                    .map((part) => part.value),
            ),
        );
        const decimalSeparators = Array.from(
            new Set(
                parts
                    .filter((part) => part.type === 'decimal')
                    .map((part) => part.value),
            ),
        );

        return (number) => Number(
            numerals.reduce(
                (acc, cv, i) => acc.split(cv).join(String(i)),
                decimalSeparators.reduce(
                    (acc, cv) => acc.split(cv).join('.'),
                    [literalSeparators, currencySeparators, groupSeparators]
                        .flat()
                        .reduce(
                            (acc, cv) => acc.split(cv).join(''),
                            number.replace(/\s/g, ''),
                        ),
                ),
            ),
        );
    };
    
    window.i18n = {
        parseFloat: function (value)
        {
            return floatParser.parse(value);
        },
        parseFloatUs: function(value){
            return floatParserUs.parse(value);
        },
        maybeParseFloat: function (value)
        {
            if (!value)
                return 0;
            else if (IsNumber(value))
                return value;

            var result = floatParser.parse(value);

            return isNaN(result) ? 0 : result;
        },
        toFixed: function (value, digits = 2)
        {
            var formatterOptions = {
                useGrouping: true,
                minimumFractionDigits: digits,
                maximumFractionDigits: digits
            }

            // TODO: is it worth caching these?
            const formatter = new Intl.NumberFormat(window.locale ? window.locale.culture : "en", formatterOptions);

            return formatter.format(value);
        },
        formatFloat: function (value, options)
        {
            var formatterOptions = {
                useGrouping: true
            }

            if (options)
            {
                if (options.fractionDigits)
                {
                    formatterOptions.minimumFractionDigits = 2;
                    formatterOptions.maximumFractionDigits = 2;
                }

                if (options.isStripIntegerTrailingZero)
                    formatterOptions.trailingZeroDisplay = "stripIfInteger";
            }

            // TODO: is it worth caching these?
            const formatter = new Intl.NumberFormat(window.locale ? window.locale.culture : "en", formatterOptions);

            return formatter.format(value);
        },
        _getCurrencyOptions: function(currency){
            return {
                minimumFractionDigits: window.locale ? window.locale.currencyDecimalDigits : 2,
                maximumFractionDigits: window.locale ? window.locale.currencyDecimalDigits : 2,
                useGrouping: true,
                style: "currency",
                currency: currency,
                currencyDisplay: "narrowSymbol"
            };
        },
        roundCurrency: function (value)
        {
            // Round to cents, half away from zero (matches the server's MidpointRounding.AwayFromZero).
            // The epsilon corrects float error so a value exactly on a half-cent rounds up like C# decimals.
            const rounded = Math.round((Math.abs(value) + 1e-9) * 100) / 100;
            return value < 0 ? -rounded : rounded;
        },
        formatCurrency: function (value, currency)
        {
            if(!currency || currency.trim() === "")
               currency = (window.locale ? window.locale.isoCurrency : "USD");
            
            const currencyOptions = this._getCurrencyOptions(currency);
            const currencyFormatter = new Intl.NumberFormat(window.locale ? window.locale.culture : "en", currencyOptions);

            return currencyFormatter.format(value);
        },
        parseCurrency: function(str, locale, currency) {
            if(locale == null) 
                locale = window.locale;
            if(currency == null)
                currency = (window.locale ? window.locale.isoCurrency : "USD");

            let culture = locale == null ? "en-US" : locale.culture;
            if(culture == null)
                culture = "en-US";
            
            const currencyOptions = this._getCurrencyOptions(currency);
            const currencyParser = NumberParser2(culture, currencyOptions)
            return currencyParser(str);
        },
        parseDate: function (value)
        {
            return dayjs(value, window.dayjsLocale.format);
        },
        formatDate: function (value)
        {
            return dayjs(value).format(window.dayjsLocale.format);
        },
        formatTime: function (value)
        {
            return dayjs(value).format(window.dayjsLocale.timeFormat);
        },
        isValidDate: function (value)
        {
            return dayjs(value, window.dayjsLocale.format).isValid();
        }
    };

    // https://github.com/johnnyreilly/jquery-validation-globalize/blob/master/jquery.validate.globalize.js
    (function ($)
    {
        // clone original methods we want to call into
        var originalMethods = {
            min: $.validator.methods.min,
            max: $.validator.methods.max,
            range: $.validator.methods.range
        };

        function parseNumberStandard(value, element){
            var val = i18n.parseFloat(value);
            if(element == null)
                return val;
            
            // We always want to use periods for Lat/Lon figures, rather than degrees minutes seconds, or locale based formatting.
            var isLatLon = element.name === "Latitude" || element.name === "Longitude";
            return isLatLon ? i18n.parseFloatUs(value) : val;
        }
        
        // check for valid numbers and dates using our culture based logic instead of the default implementation
        $.validator.methods.number = function (value, element)
        {
            if(value === "")
                return true;
            
            var val = parseNumberStandard(value, element);
            return this.optional(element) || ($.isNumeric(val));
        };
        $.validator.methods.date = function (value, element)
        {
            var isValid = i18n.isValidDate(value);

            return this.optional(element) || isValid;
        };

        // for numeric comparisons, parse using our culture based logic and then pass that value into the default implementation
        $.validator.methods.min = function (value, element, param)
        {
            var val = parseNumberStandard(value, element);
            if(value === "" || value == null)
                val = 0;

            return originalMethods.min.call(this, val, element, param);
        };

        $.validator.methods.max = function (value, element, param)
        {
            var val = parseNumberStandard(value, element);
            if(value === "" || value == null)
                val = 0;

            return originalMethods.max.call(this, val, element, param);
        };

        $.validator.methods.range = function (value, element, param)
        {
            var val = parseNumberStandard(value, element);
            if(value === "" || value == null)
                val = 0;

            return originalMethods.range.call(this, val, element, param);
        };

    }(jQuery));
})();

$.ajaxSetup({ cache: false });

$.fn.griddlyGlobalDefaults = { isMultiSort: false };

// Review: The above is called AFTER Griddly performs it's initialization,
// and so has no effect.
$.fn.griddly.defaults = $.extend($.fn.griddly.defaults, {
    getCleanedDate: str => String(str),
    getFormattedDate: str => {
        const val = window.i18n.parseDate(str);
        return (val == null || !isFinite(val))
            ? null
            : i18n.formatDate(val);
    },
    getFilterDate: str => str
});

if ($.fn.griddly)
    $.fn.griddly.defaults.removeIconCssClass = "far fa-xmark fa-sm";

$.fn.multiselect.Constructor.prototype.defaults.selectedClass = null;
//$.fn.multiselect.Constructor.prototype.defaults.includeSelectAllDivider = true;
//$.fn.multiselect.Constructor.prototype.defaults.includeSelectAllOption = true;
//$.fn.multiselect.Constructor.prototype.defaults.enableFiltering = true;
//$.fn.multiselect.Constructor.prototype.defaults.enableCaseInsensitiveFiltering = true;
$.fn.multiselect.Constructor.prototype.defaults.maxHeight = 450;
$.fn.multiselect.Constructor.prototype.defaults.optionClass = function (element) {
    if (element.data("admin-only"))
        return "admin-only-block";
    else
        return null;
};
$.fn.multiselect.Constructor.prototype.defaults.enableHTML = true;
$.fn.multiselect.Constructor.prototype.defaults.optionLabel = function (element)
{
    var text = $(element).attr('label') || $(element).text();
    var title = $(element).data("title");

    if (title)
    {
        if ($(element).prop("disabled"))
            text = `<span data-toggle="tooltip" data-bs-toggle="tooltip" title="${title}" data-bs-title="${title}">${text}</span>`;
        else
            text += ` <i class="fa fa-question-circle" data-toggle="tooltip" data-bs-toggle="tooltip" title="${title}" data-bs-title="${title}"></i>`;
    }
    else
    {
        text = `<span>${text}</span>`;
    }

    return text;
};

//$.fn.tooltip.Constructor.DEFAULTS.sanitize = false;
//$.fn.popover.Constructor.DEFAULTS.sanitize = false;
const whiteList = useBs5
    ? $.fn.tooltip.Constructor.Default.allowList
    : $.fn.tooltip.Constructor.DEFAULTS.whiteList;

whiteList['*'].push('style');
whiteList['dl'] = [];
whiteList['dd'] = [];
whiteList['dt'] = [];

$.fn.resetValidation = function () {
    $(this).each(function (i, e) {
        $(e).trigger('reset.unobtrusiveValidation');
        let next = $(e).next();
        if (next.is('span') && !next.hasClass('symbol-percent')) {
            $(e).next().empty();
        }
    });
};

$(".griddly").on("refresh.griddly init.griddly", function (e, data) {
    if (data.count == 0)
        $(".btn-group.export").hide();
    else
        $(".btn-group.export").css("display", "inline-block");

    $(".inside-popover").popover();
    $(".inside-tooltip").tooltip();
    
    var filterValues = $(this).griddly("getFilterValues");

    if (filterValues.saveFilter)
    {
        $(this).addClass("has-saved-filter");
        $("[name=saveFilter]", this).prop("checked", false).change();

        $(this).griddly("setFilterValue", "saveFilter", null);
        delete filterValues.saveFilter;
        $(this).griddly({ filterDefaults: filterValues });
        $(this).griddly("updateDefaultStatus");
    }
});

$(document).on("click", "a[href^='#mp_'][data-toggle='popover'], a[href^='#mp_'][data-bs-toggle='popover'], .popover-content a[href^='#mp_'], .popover-body a[href^='#mp_']", function (e)
{
    e.preventDefault();

    var contentId = $(this).attr("href");
    var contentHtml = $(contentId).html();

    $(this).popover({
        html: true,
        placement: "bottom",
        container: "body",
        trigger: "manual",
        content: contentHtml
    });

    $(this).popover("toggle");
});

$(".griddly").on("init.griddly", function (e, data)
{
    // Initialize Copy Link functionality for grids that have filters
    if ($(this).hasClass("griddly-has-copylink"))
    {
        initializeCopyLinkForGrid($(this));
    }

    if (window.location.search && window.resetQueryScheduled != true)
    {
        // if all query string params are filter params, reset the URL so the query params
        // don't override filter when the user goes away and back.
        window.resetQueryScheduled = true;

        setTimeout(function ()
        {
            const values = Object.assign.apply({}, $(".griddly").map((i, el) => $(el).griddly("getFilterValues")));
            const searchParams = new URLSearchParams(window.location.search);
            let isChanged = false;

            for (const [key, value] of searchParams)
            {
                if (values[key])
                {
                    searchParams.delete(key);

                    isChanged = true;
                }
            }

            // NOTE: if some query string params aren't filter params, we don't reset the URL at all
            // because if anything is in query, server side code will skip the cookie load.
            if (isChanged && searchParams.size == 0)
            {
                //const search = searchParams.toString();                
                const url = window.location.origin + window.location.pathname;// + (search ? "?" + search : "");

                history.replaceState(history.state, document.title, url);
            }
        }, 1);
    }
});

var griddlySpinnerTimeout = null;

$(document).on("beforerefresh.griddly", ".griddly", function () {
    if (griddlySpinnerTimeout)
        window.clearTimeout(griddlySpinnerTimeout);

    var $griddly = $(this);

    griddlySpinnerTimeout = window.setTimeout(function () {
        $griddly.find(".griddly-spinner").fadeIn(300);
    }, 300);
});

$(document).on("refresh.griddly", ".griddly", function () {
    if (griddlySpinnerTimeout)
        window.clearTimeout(griddlySpinnerTimeout);

    $(this).find(".griddly-spinner").stop().hide();
});

$(document).on("pagesizechanged.griddly", ".griddly", function (e, data) {
    removeCookie("GriddlyPageSize", "/", "app.ownerrez.com");
    removeCookie("GriddlyPageSize", "/", "app.dev.ownerrez.com");
    removeCookie("GriddlyPageSize", "/", "dev.ownerrez.com");

    if (data.pageSize != data.originalPageSize)
        document.cookie = "GriddlyPageSize=" + data.pageSize + ";domain=.ownerrez.com;path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/";
});

//$(".griddly").on("shown.bs.popover", ".filter-trigger", function (e)
//{
//    var scrollTop = $(window).scrollTop();
//    var top = $(this).parent().children(".griddly-filter-popover").position().top;

//    $(this).data("scrollOffset", top - scrollTop);
//});

$(".griddly-scrollable-container").on("scroll", function (e) {
    var popover = $(".griddly-filter-popover").prev(".filter-trigger");

    if (popover.length)
        popover.popover("hide");
});

var isCDown = false;

$(window).on("keydown", function (e)
{
    // c
    if (e.which == 67)
        isCDown = true;
    else
        isCDown = false
});

$(window).on("keyup", function (e)
{
    isCDown = false
});

function buildTimeConversion(el)
{
    var table = document.createElement("table");

    table.className = "table table-condensed time-popover-table";

    var tbody = table.createTBody();
    var value = new Date((el || this).dataset.value);

    var addZoneRow = function (timeZone, description)
    {
        var row = tbody.insertRow();

        var zone = row.insertCell();
        var time = row.insertCell();
        var date = row.insertCell();

        zone.style.fontWeight = "bold";
        time.align = "right";
        date.align = "right";

        var zoneFormat = new Intl.DateTimeFormat(navigator.language, { timeZoneName: 'short', timeZone: timeZone });
        var timeFormat = new Intl.DateTimeFormat(navigator.language, { timeStyle: 'short', timeZone: timeZone });
        var dateFormat = new Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium', timeZone: timeZone });

        zone.innerHTML = zoneFormat.formatToParts(value).find((x) => x.type == "timeZoneName").value + (description ? " &bull; " + description : "");
        time.innerText = timeFormat.format(value);
        date.innerText = dateFormat.format(value);
    };

    var userTz = window.UserTimeZone;
    var browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (browserTz != userTz && browserTz != "UTC")
        addZoneRow(browserTz, "Your computer");

    if (userTz != null)
        addZoneRow(userTz, "Your account");
            
    addZoneRow("UTC");

    return table;
}

var timePopoverOptions = {
    selector: '[data-toggle="time-popover"]',
    title: "Time Conversion",
    content: buildTimeConversion,
    customClass: "time-popover", // customClass only exists in bs5, so we add the template below
    html: true,
    trigger: "hover",
    container: "body"
};

if (!useBs5)
{
    timePopoverOptions.template = '<div class="popover time-popover" role="tooltip"><div class="arrow popover-arrow"></div><h3 class="popover-title"></h3><div class="popover-content popover-inner"></div></div>';
}

$('body').popover(timePopoverOptions);

$(document).on("show.bs.popover", "[data-toggle=popover], [data-bs-toggle=popover], .popover-content a[href^='#mp_']", function () {
    $(this).data('someattr', 1);
});

$(document).on("shown.bs.popover", "[data-toggle=popover], [data-bs-toggle=popover], .popover-content a[href^='#mp_']", function ()
{
    $(this).data('someattr', 0);

    if (!$(this).data("popover-content"))
    {
        var trigger = $(this);
        $(".popover-content:visible").each(function ()
        {
            if (!$(this).data("popover-trigger"))
            {
                $(this).data("popover-trigger", trigger);
                trigger.data("popover-content", $(this));
            }
        });
    }
});

function closeOpenPopups(e)
{
    $(".popover-content:visible").each(function ()
    {
        var eventTarget = $(e.target);
        var eventPopoverTarget = eventTarget.closest(".popover-content");

        if (eventPopoverTarget.length == 0 || (!eventPopoverTarget.is(this) && !eventPopoverTarget.data("popover-trigger").closest(".popover-content").is(this)))
        {
            var trigger = $(this).data("popover-trigger");
            if (trigger && trigger.data("someattr") != 1)
                ((trigger.popover('hide').data('bs.popover') || {}).inState || {}).click = false  // fix for BS 3.3.6 (bug requires double click before reshow)
        }
    });
}

$(document).on('click', function (e)
{
    closeOpenPopups(e);
});

$(document).on("contextmenu", ".griddly td", function (e) {
    if (e.ctrlKey && isCDown) {
        var el = e.target;

        if (navigator.clipboard)
            navigator.clipboard.writeText(el.innerText);

        e.preventDefault();

        return false;
    }
});

// Global Key Filter
const _ignoreControls = {
    "INPUT": true,
    "TEXTAREA": true,
    "SELECT": true,
    "OPTION": true,
};

// go-to targets resolve against the sidebar nav, so permission gating is inherited
// from the server-rendered menu: no nav item, no navigation
const _goToNavKeys = {
    "b": "nav-bookings",
    "i": "nav-inbox",
    "q": "nav-quotes",
    "p": "nav-properties",
    "t": "nav-tasks",
    "s": "nav-settings"
};

const _disableSingleKeyShortcutsKey = "or-disable-single-key-shortcuts";
let _goToPendingExpiry = 0;

function isSingleKeyShortcutContext(e) {
    const target = $(e.target);
    const tagName = target.prop("tagName");

    if (_ignoreControls.hasOwnProperty(tagName))
        return false;

    const rawEle = target[0];

    if (rawEle.isContentEditable)
        return false;

    if (rawEle.classList.contains("dropdown-item"))
        return false;

    // any open modal disables single-key shortcuts, regardless of where focus sits
    if (rawEle.classList.contains("modal") || $(".modal.show, .modal.in").length)
        return false;

    return true;
}

function areSingleKeyShortcutsDisabled() {
    try {
        return localStorage.getItem(_disableSingleKeyShortcutsKey) === "1";
    }
    catch (ex) {
        return false;
    }
}

$(document).on("keyup", function (e) {
    if (e.key == "Escape") {
        closeOpenPopups(e);
        return;
    }

    if (e.ctrlKey && e.altKey) {
        if (e.which == 65) // A
        {
            $(".admin-dropdown-button").dropdown("toggle");
        }
        else if (e.which == 67) // C
        {
            var findORCreateGuest = $(".menu-quick-guest");

            if (findORCreateGuest.length)
                findORCreateGuest[0].click();
        }
        else if (e.which == 68) // D
        {
            var dialer = $(".dialer-button");

            if (dialer.length)
                dialer[0].click();
        }
        else if (e.which == 69) // E
        {
            $(".admin-dropdown-button").dropdown("toggle");

            $(".dropdown-menu input[name=q]").focus().select();
        }
        else if (e.which == 70) // F
        {
            $("input.main-filter").focus().select();
        }
        else if (e.which == 76) // L
        {
            var triggerE = $.Event("mouseup", { which: 1 });

            $(".btn-change-history").trigger(triggerE);
        }
        else if (e.which == 81) // Q
        {
            var quickQuote = $(".menu-quick-quote");

            if (quickQuote.length)
                quickQuote[0].click();
        }
        else if (e.which == 83) // S
        {
            $(".navbar-form [name=q]").focus().select();
        }
        else if (e.which == 85) // U
        {
            $(".btn-unimpersonate").click();
        }
        else if (e.which == 88) // X
        {
            var btn = $(".btn-support-chat");

            if (btn.length)
                btn[0].click();
        }
        else if (e.which === 191) // / (Forward Slash)
        {
            $('#search-fly-out').click();
        }
        else
        {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
    }
    else {
        const key = e.key || "";
        const keyLower = key.toLowerCase();
        const hasModifier = e.ctrlKey || e.metaKey || e.altKey;
        const isHelpKey = !hasModifier && key === "?";
        const isSearchKey = !hasModifier && e.which === 191 && !e.shiftKey; // / (Forward Slash); ? shares the keycode, hence the shift guard
        const isGoToTarget = !hasModifier && !e.shiftKey && _goToPendingExpiry > Date.now() && _goToNavKeys.hasOwnProperty(keyLower);
        const isGoToArm = !hasModifier && !e.shiftKey && keyLower === "g";

        if (!isHelpKey && !isSearchKey && !isGoToTarget && !isGoToArm) {
            _goToPendingExpiry = 0;
            return;
        }

        if (!isSingleKeyShortcutContext(e)) {
            _goToPendingExpiry = 0;
            return;
        }

        if (isHelpKey) {
            _goToPendingExpiry = 0;

            const helpModal = $("#keyboard-shortcuts-modal");

            if (helpModal.length) {
                helpModal.modal("show");
                e.preventDefault();
                e.stopPropagation();
            }

            return;
        }

        // ? stays live above so the disable toggle in the help overlay remains reachable
        if (areSingleKeyShortcutsDisabled())
            return;

        if (isGoToTarget) {
            _goToPendingExpiry = 0;

            const navLink = $("[data-testid='" + _goToNavKeys[keyLower] + "']");

            if (navLink.length) {
                navLink[0].click();
                e.preventDefault();
                e.stopPropagation();
            }

            return;
        }

        if (isGoToArm) {
            _goToPendingExpiry = Date.now() + 1500;
            return;
        }

        _goToPendingExpiry = 0;
        $('#search-fly-out').click();
        e.preventDefault();
        e.stopPropagation();
    }
});

$(document).on("show.bs.modal", "#keyboard-shortcuts-modal", function () {
    const modal = $(this);

    // each row names the selector its shortcut acts on; no target on this page means
    // the shortcut is a no-op here, so the row hides rather than lie
    modal.find("[data-shortcut-target]").each(function () {
        const row = $(this);
        row.toggleClass("d-none", !$(row.attr("data-shortcut-target")).length);
    });

    modal.find("[data-shortcut-group]").each(function () {
        const group = $(this);
        group.toggleClass("d-none", !group.find(".shortcut-row:not(.d-none)").length);
    });

    if (navigator.platform.toUpperCase().indexOf("MAC") >= 0)
        modal.find(".kbd-mac-cmd").text("\u2318");

    modal.find("#keyboard-shortcuts-disable-single").prop("checked", areSingleKeyShortcutsDisabled());
});

$(document).on("change", "#keyboard-shortcuts-disable-single", function () {
    try {
        localStorage.setItem(_disableSingleKeyShortcutsKey, this.checked ? "1" : "0");
    }
    catch (ex) {
    }
});

$(window).on("scroll resize", function (e) {
    var popover = $(".griddly-filter-popover").prev(".filter-trigger");

    if (popover.length)
        popover.popover("hide");
    //{
    //    var trigger = popover;

    //    if (trigger.length)
    //    {
    //        var scrollTop = $(window).scrollTop();
    //        var scrollOffset = $(trigger).data("scrollOffset");

    //        popover.css("top", (scrollOffset - scrollTop) + "px");
    //    }
    //}
});

// http://bencoding.com/2013/03/05/generating-guids-in-javascript/
var generateGuid = function () {
    var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    return guid;
};

var removeCookie = function (sKey, sPath, sDomain) {
    document.cookie = encodeURIComponent(sKey) +
        "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "");
};

var getCookie = function (name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

var exportFile = function ($el, type) {
    var grid = $el.closest(".griddly");

    if (grid.length == 0)
        grid = $(".griddly");

    var maxRows = $el.closest(".btn-group").find("[data-max-export-rows]").data("max-export-rows");

    var doExport = function () {
        var downloadTrackId = generateGuid();

        grid.griddly("exportFile", type, null, { downloadTrackId: downloadTrackId });

        if (!$el.is("[data-loading-text]"))
            $el = $el.parents(".btn-group").find("[data-loading-text]:first");

        $el.showWorkingTrackDownload(downloadTrackId);
    };

    if (maxRows && grid.data("griddly").options.count > maxRows) {
        bootbox.confirm(
            "Your export will be limited to " + maxRows.toLocaleString() + " rows. Use filters to narrow results.",
            function (result) { if (result) doExport(); }
        );
    } else {
        doExport();
    }
};

$("a.export-xlsx, a.or-export-xlsx").on("click", function () {
    exportFile($(this), "xlsx");
});

$("a.export-csv, a.or-export-csv").on("click", function () {
    exportFile($(this), "csv");
});

$("a.export-tsv, a.or-export-tsv").on("click", function () {
    exportFile($(this), "tsv");
});

autosize($("textarea.autosize"));

function initializeRequiredFields(container) {
    var selector = "[data-val-required]:not(input[type='hidden'])";
    $(container).find(selector).addBack(selector).filter(function () {
        if (this.type !== "checkbox" && this.type !== "radio") {
            return true;
        }

        if ($(this).attr("aria-required") === "true") {
            return true;
        }

        var id = this.id;
        var name = this.name;
        return $("label.control-label-required").filter(function () {
            var target = $(this).attr("for");
            return target === id || target === name;
        }).length > 0;
    }).attr("aria-required", "true");
}

$(function () {
    initializeRequiredFields(document);
});

$(".pageSize").multiselect({ buttonClass: "btn btn-default btn-sm" });

$(".btn-search-custom").on("click", function () {
    $(".griddly").griddly("toggleFilterMode");
});

$(".griddly-filters-form [multiple], .griddly-filter-modal [multiple]").each(function () {
    $(this).multiselect(
        {
            buttonText: function (options, select) {
                var display = null;
                var filter = $(select).parents(".griddly-filter-form-group");

                var allItems = $(select).find("option");
                var displayItemCount = parseInt(filter.data("griddly-filter-displayitemcount"));

                if (options.length == allItems.length || options.length == 0 && filter.data("griddly-filter-isnoneall")) {
                    if (filter.data("griddly-filter-isnoneall"))
                        display = "Doesn't Matter";
                    else
                        display = select.data("all-selected-text") || (allItems.length == 2 && !filter.data("griddly-filter-isnullable") ? "Both " : "All ") + filter.data("filter-name-plural");
                }
                else if (options.length > displayItemCount)
                    display = options.length + " " + filter.data("filter-name-plural");
                else if (options.length > 0 && options.length <= displayItemCount) {
                    var display = $.trim($(options[0]).text());

                    for (var i = 1; i < options.length && i < displayItemCount; i++)
                        display += ", " + $.trim($(options[i]).text());
                }
                else
                    display = select.data("non-selected-text") || "No " + filter.data("filter-name-plural");

                return display;
            },
            enableClickableOptGroups: true,
            isNoneAll: $(this).parents(".griddly-filter-form-group").data("griddly-filter-isnoneall")
        });
});

$(".griddly-filters-form input[data-griddly-filter-data-type='Date'], .griddly-filter-modal input[data-griddly-filter-data-type='Date']").each(function () {
    $(this).datepicker({ autoclose: true, orientation: "bottom left", todayHighlight: true, assumeNearbyYear: true, container: '.griddly-filter-modal' });

    var group = $(this).parents(".input-group");
    var btnContainer = group.find(".input-group-addon, .input-group-text");

    btnContainer.html('<a class="btn btn-default">' + btnContainer.html() + '</a>');
    btnContainer.removeClass("input-group-addon input-group-text").addClass("input-group-btn");

    btnContainer.find(".btn").click(function () {
        group.find("input").focus();
    });

    // keep the keyboard from popping up on mobile
    if ('ontouchstart' in document.documentElement) {
        $(this)
            .attr("readonly", true)
            .css("background-color", "#fff")
            .css("cursor", "pointer");
    }
});

$(".griddly-filters-form input.griddly-filter-datetime, .griddly-filter-modal input.griddly-filter-datetime").each(function ()
{
    // NOTE: changed ["increment", "keyup"] to ["increment", "keyup"] in minified so that we update input while typing (instead of just blur)
    // remember that if we update flatpickr versions
    flatpickr(this,
        {
            enableTime: true,
            dateFormat: "Y-m-d H:i:S",
            time_24hr: true,
            defaultHour: 0,
            enableSeconds: true,
            allowInput: true
        });
});


var getDatePickerDate = function (id) {
    var el = $(id);

    return el.val() ? el.datepicker("getDate") : null;
};

$(".griddly-filter-range input[data-griddly-filter-data-type='Date'], .filter-date-range input[data-provide='datepicker']").on("changeDate", function () {
    var other = $(this).closest(".griddly-filter-range, .filter-date-range").find("input:last");

    // this fires for all datepickers, but we only want the first in a range
    if (other == $(this))
        return;

    var arrivalDate = getDatePickerDate($(this));
    var departureDate = getDatePickerDate(other);

    if (arrivalDate && (!departureDate || arrivalDate > departureDate)) {
        other
            .val("")
            .datepicker("update", moment(arrivalDate).add(1, 'days').toDate(), true)
            .find(".day.active").removeClass("active");
        other.focus();
    }
});

$(".griddly").on("setfilters.griddly resetfilters.griddly", function () {
    $(".griddly-filters-form [multiple]").multiselect("refresh");
});

$(".griddly-filter-bar").on("updatefilterdisplay.griddlyFilterBar", function () {
    $(".griddly-filter-modal [multiple]").multiselect("refresh");
});

// iOS keeps the keyboard open while a hidden input still has focus
$(document).on("hide.bs.modal", ".griddly-filter-modal", function () {
    $(":focus", this).blur();
});

// and when you show it, move it to the body                                     
$(".griddly table tbody").on('show.bs.dropdown', function (e) {

    // grab the menu        
    var dropdownMenu = $(e.target).find('.dropdown-menu');

    $(e.target)
        .data("outside-holder", dropdownMenu)
        .addClass("dropdown-outside");

    dropdownMenu.data("parent-row", dropdownMenu.closest("tr"));

    // detach it and append it to the body
    $('body').append(dropdownMenu.detach());

    // grab the new offset position
    var eOffset = $(e.target).offset();

    var css = {
        'display': 'block',
        'top': eOffset.top + $(e.target).outerHeight(),
    };

    if ($(e.target).add(dropdownMenu).is(".pull-right, .float-end")) {
        css.right = "auto";
        css.left = (eOffset.left + $(e.target).outerWidth()) - dropdownMenu.outerWidth();
    }
    else {
        css.left = eOffset.left;

    }

    // make sure to place it where it would normally go (this could be improved)
    dropdownMenu.css(css);
});

// and when you hide it, reattach the drop down, and hide it normally                                                   
$(".griddly").on('hide.bs.dropdown', function (e) {
    var dropdownMenu = $(e.target).data("outside-holder");

    if (dropdownMenu) {
        $(e.target).removeClass("dropdown-outside");
        $(e.target).append(dropdownMenu.detach());
        dropdownMenu.hide();
    }
});

$(window).resize(function () {
    $(".dropdown-outside")
        .trigger("hide.bs.dropdown")
        .attr('aria-expanded', 'false')
        .removeClass("open");
    ;
});

$(".griddly .or-batch-invoke").click(function () {
    $(this).closest(".griddly")
        .addClass("or-batch-mode")
        .find(".or-batch-selection .btn:not(.or-batch-cancel)")
        .addClass("disabled");
});

$(".griddly").on("selectionchanged.griddly", function (e, count, rows) {
    $(this).closest(".griddly")
        .find(".or-batch-selection .btn:not(.or-batch-cancel)")
        .toggleClass("disabled", count == 0);

    $(this).closest(".griddly")
        .toggleClass("or-batch-mode", count > 0);
});

$(".griddly .or-batch-cancel").click(function () {
    $(this).closest(".griddly")
        .griddly("clearSelected")
        .removeClass("or-batch-mode");
});

$(".griddly .or-batch-selection [data-role=griddly-button]").on("afterExecute", function (e, count, rows) {
    $(this).closest(".griddly")
        .griddly("clearSelected")
        .removeClass("or-batch-mode");
});

//$(".griddly .griddly-search-clear").click(function (e)
//{
//    var griddly = $(this).closest(".griddly");

//    griddly.griddly("setFilterValues", {}, false, true);

//    // clear any none's that were inadvertently reset
//    $(".griddly-filters-form [data-griddly-filter-isnoneall=true] [multiple] option[value='']", griddly).prop("selected", false);

//    $(".griddly-filters-form [multiple]", griddly).multiselect("refresh");

//    e.preventDefault();
//});

document.body.addEventListener("click", function (e) {
    if (e.target && $(e.target).hasClass("disabled")) {
        e.stopPropagation();
        e.preventDefault();
    }
},
    true);  //useCapture: true -> important or this won't work

$("[data-role='multiselect'][data-enable-html='true']").multiselect(
    {
        enableHTML: true,
        buttonTitle: function () { }
    });

// https://xhalent.wordpress.com/2011/01/24/applying-unobtrusive-validation-to-dynamic-content/
/// <reference path="jquery-1.4.4.js" />
/// <reference path="jquery.validate.js" />
/// <reference path="jquery.validate.unobtrusive.js" />

(function ($) {
    $.validator.unobtrusive.parseDynamicContent = function (selector) {
        //use the normal unobstrusive.parse method
        $.validator.unobtrusive.parse(selector);
        initializeRequiredFields(document);

        //get the relevant form
        var form = $(selector).first().closest('form');

        //get the collections of unobstrusive validators, and jquery validators
        //and compare the two
        var unobtrusiveValidation = form.data('unobtrusiveValidation');
        var validator = form.validate();

        if (unobtrusiveValidation) {
            $.each(unobtrusiveValidation.options.rules, function (elname, elrules) {
                if (validator.settings.rules[elname] == undefined) {
                    var args = {};
                    $.extend(args, elrules);
                    args.messages = unobtrusiveValidation.options.messages[elname];
                    //edit:use quoted strings for the name selector
                    $("[name='" + elname + "']").rules("add", args);
                } else {
                    $.each(elrules, function (rulename, data) {
                        if (validator.settings.rules[elname][rulename] == undefined) {
                            var args = {};
                            args[rulename] = data;
                            args.messages = unobtrusiveValidation.options.messages[elname][rulename];
                            //edit:use quoted strings for the name selector
                            $("[name='" + elname + "']").rules("add", args);
                        }
                    });
                }
            });
        }
    }
})($);

$(".griddly a[data-toggle=post][data-loading-text]").on("beforeExecute", function (e) {
    $(this).showWorking($(this));
});

$.fn.griddlyGlobalDefaults = {
    confirmPromptFunction: function (message, callback) {
        bootbox.confirm(message, function (result) {
            if (result)
                callback();
        });
    }
};

$(document).on("submit", "form:not(.form-no-working)", function (e, params)
{
    params = params || {};
    var f = $(this);

    if (f.valid() && f.data("isWorking") != true) {
        f.showWorking(params.showWorking);
    } else {
        // form.showWorking gets called in a couple of places directly
        // Use a different value to track if the form has been submitted to avoid conflicts with those calls
        if (f.valid() && f.data("hasSubmitted") != true)
            f.data("hasSubmitted", true);
        else
            return false;
    }
});

$(document).on("click", "[data-toggle=api-delete]", function () {
    var entity = $(this).data("entity");
    var id = $(this).data("id");
    var friendlyWord = entity;
    var entityPlural = entity + "s";
    var successUrl = $(this).data("successUrl");

    if ($(this).data("friendlyWord"))
        friendlyWord = $(this).data("friendlyWord");

    if ($(this).data("entityPlural"))
        entityPlural = $(this).data("entityPlural");

    var confirmMessage = "<p class='lead'>Are you sure you want to delete this " + friendlyWord + "?</p><p>This action cannot be undone.</p>";

    if ($(this).data("confirmMessage"))
        confirmMessage = $(this).data("confirmMessage");

    var btn = $(this);

    ModalConfirm(confirmMessage, function () {
        var formSelector = btn.data("formSelector");

        var f = null;

        if (formSelector != null && formSelector.length > 0)
            f = $(formSelector);
        else
            f = btn.closest("form");

        f.showWorking(btn);

        $.ajax
            ({
                type: "DELETE",
                url: BaseUrl + "/api/" + entityPlural + "/" + id,
                contentType: "application/json; charset=utf-8"
            })
            .fail(function (xhr, status, error) {
                if (!f.length) {
                    var messages = getApiErrorMessages(xhr);
                    showAlertConfirmation(messages, null, 'alert-danger');
                }
                else {
                    f.showApiErrorsInSummary(xhr);
                }

                f.hideWorking(btn);
                window.scrollTo(0, 0);
            })
            .done(function (data) {
                self.location.href = BaseUrl + successUrl;
            });
    },
        null,
        {
            confirm:
            {
                label: "Yes, Delete!",
                className: "btn-danger",
            }
        });

    return false;
});

$("[data-toggle=api-action]").click(function (e) {
    e.preventDefault();

    var url = $(this).data("apiUrl");
    var method = $(this).data("apiMethod") || "PATCH";
    var confirmMessage = $(this).data("confirmMessage");
    var confirmMessageTarget = $(this).data("confirmMessageTarget");
    var confirmMessageFunction = $(this).data("confirmMessageFunction");
    var confirmSize = $(this).data("confirmSize");
    var successUrl = $(this).data("successUrl");
    var successToast = $(this).data("successToast");
    var buttonConfirmLabel = $(this).data("buttonConfirmLabel") || "OK";
    var buttonConfirmClass = $(this).data("buttonConfirmClass") || "btn-default";

    if (successUrl)
        successUrl = BaseUrl + successUrl;
    else if (!successToast)
        successUrl = window.location.href;

    if (successToast && successUrl)
        console.error('data-success-url and data-success-toast should not both be set.');

    var btn = $(this);

    var action = function () {
        var formSelector = btn.data("formSelector");

        var f = null;

        if (formSelector != null && formSelector.length > 0)
            f = $(formSelector);
        else
            f = btn.closest("form");

        if (f.length)
            f.showWorking(btn);
        else
            btn.attr('disabled', true).blur();

        $.ajax
            ({
                type: method,
                url: url,
                contentType: "application/json; charset=utf-8"
            })
            .fail(function (xhr, status, error) {
                if (f.length)
                    f.hideWorking(btn);
                else
                    btn.attr('disabled', false);

                var errorDisplay = f.find(".validation-summary-valid, .validation-summary-errors");

                if (errorDisplay.length) {
                    f.showApiErrorsInSummary(xhr);
                    errorDisplay[0].scrollIntoView();
                }
                else {
                    showApiErrorsInModal(xhr);
                }
            })
            .done(function (data) {
                if (successToast) {
                    showAlertConfirmation(successToast);
                    if (f.length == 0)
                        btn.attr('disabled', false);
                } else {
                    self.location.href = successUrl;
                }
            });
    };

    var specialButtons =
    {
        confirm:
        {
            label: buttonConfirmLabel,
            className: buttonConfirmClass,
        }
    };

    if ((confirmMessage == null || confirmMessage.length == 0) && confirmMessageTarget != null && confirmMessageTarget.length > 0)
        confirmMessage = $(confirmMessageTarget).html();

    var doFinal = function (message, overrideButtons) {
        if (confirm && message)
            ModalConfirm(message, action, null, overrideButtons || specialButtons, confirmSize);
        else
            action();
    };

    if ((confirmMessage == null || confirmMessage.length == 0) && confirmMessageFunction != null && confirmMessageFunction.length > 0 && window[confirmMessageFunction])
        window[confirmMessageFunction](doFinal);
    else
        doFinal(confirmMessage);

    return false;
});

$('[data-sorry-app-loader]').each(function (i, target) {
    target = $(".app-helpbar");
    // Can play with these selectors (and the markup) to move the tooltip off the icon
    target.data('widget', $('[data-sorry-app-status]', target));
    target.data('icon', $('.fa-solid[data-sorry-app-status]', target));
}).on('click', e => {
    var target = $(".app-helpbar");

    if (target.attr('data-sorry-app-loader') != 'loading') {
        target.attr('data-sorry-app-loader', 'loading');

        var widget = target.data('widget');
        var icon = target.data('icon');

        icon
            .removeClass('fa-circle-exclamation text-danger')
            .removeClass('fa-circle-check text-success')
            .addClass('fa-circle-notch fa-spin text-muted');

        widget.attr('title', 'Checking status...');
        widget.tooltip({ title: widget.attr('title') });

        $.ajax({
            type: 'GET',
            crossDomain: true,
            dataType: 'json',
            url: 'https://status.ownerrez.com/api/v1/status',
            success: function ({ page }) {                
                widget.tooltip(useBs5 ? 'dispose' : 'destroy');

                // site status states:
                // operational: No current incidents or underway maintenance. Incidents marked as 'recovering' are not considered current.
                // degraded: One or more current incidents are marked as 'investigating' or 'identified'.
                // under_maintenance: One or more current maintenance marked as 'underway'
                // In the event that both a current incident and an underway maintenance are present, 'degraded' takes priority.

                if (page.state != 'operational' || (window.location.hash && window.location.hash.indexOf('sorry-app-fake-error') > -1))
                {
                    icon
                        .removeClass('fa-circle-notch fa-spin text-muted')
                        .removeClass('fa-circle-check text-success')
                        .addClass('fa-circle-exclamation text-danger');
                }
                else
                {
                    icon
                        .removeClass('fa-circle-notch fa-spin text-muted')
                        .removeClass('fa-circle-exclamation text-danger')
                        .addClass('fa-circle-check text-success');
                }


                widget.attr('title', page.state_text);
                widget.attr('data-sorry-app-status', page.state);
                widget.tooltip({ title: widget.attr('title') });

                target.attr('data-sorry-app-loader', 'loaded');
            }
        });
    }
}).on('hide.bs.dropdown', e => {
    var target = $(e.target);
    var widget = target.data('widget');
    var icon = target.data('icon');
    widget.tooltip(useBs5 ? 'dispose' : 'destroy');
});

function GetCreditCardType(cardNumber) {
    if (cardNumber != null && cardNumber.length > 0) {
        if (cardNumber.substring(0, 1) == "4")
            return "Visa";
        else if (cardNumber.substring(0, 4) == "6011" || cardNumber.substring(0, 2) == "65")
            return "Discover";
        else if (cardNumber.substring(0, 2) == "34" || cardNumber.substring(0, 2) == "37")
            return "AmericanExpress";
        else if (cardNumber.substring(0, 2) == "36")
            return "DinersClub";  // Diners Club International
        else {
            var firstSix = parseInt(cardNumber.substring(0, 6), 10);

            if (firstSix >= 622126 && firstSix <= 622925)
                return "Discover";

            var firstFour = parseInt(cardNumber.substring(0, 4), 10);

            if (firstFour >= 3528 && firstFour <= 3589)
                return "JCB";
            else if (firstFour >= 2221 && firstFour <= 2720)
                return "MasterCard";

            var firstThree = parseInt(cardNumber.substring(0, 3), 10);

            if (firstThree >= 644 && firstThree <= 649)
                return "Discover";
            else if (firstThree >= 300 && firstThree <= 305)
                return "DinersClub";  // Diners Club Carte Blanche

            var firstTwo = parseInt(cardNumber.substring(0, 2), 10);

            if (firstTwo >= 51 && firstTwo <= 55)
                return "MasterCard";
        }
    }

    return null;
}

(function ($) {
    $.fn.serializeFiles = function () {
        var form = $(this),
            formData = new FormData(),
            formParams = form.serializeArray();

        $.each(form.find('input[type="file"]'), function (i, tag) {
            $.each($(tag)[0].files, function (i, file) {
                formData.append(tag.name, file);
            });
        });

        $.each(formParams, function (i, val) {
            formData.append(val.name, val.value);
        });

        return formData;
    };
})($);

/**
 * Save spinner management system for AJAX operations
 * 
 * This module provides a stack-based spinner system that shows a loading indicator
 * during AJAX operations. It prevents multiple spinners from appearing simultaneously
 * and handles edge cases like page unload during active operations.
 * 
 * Usage:
 * - Add @Html.AjaxSpinner() to your view (see HtmlHelperExtensions.cs)
 * - Use $.executeAjaxCall() for AJAX operations to automatically manage the spinner
 * - The spinner will show after 200ms delay to avoid flickering on fast operations
 * 
 * Example:
 * $.executeAjaxCall(
 *     $.ajax({ url: '/api/data' }),
 *     function(result) { ... success handler ... },
 *     '.my-spinner', // optional custom selector
 *     function(xhr) { ... error handler ... }
 * ); 
 */
(function ($)
{
    var overallAjaxCount = 0; // Used to block unloading until all actions completed

    function showAjaxSpinner(selector)
    {
        $(selector).fadeIn(250);
    }

    function pushAjaxSpinner(selector)
    {
        selector = selector || ".ajax-spinner";
        
        if ($(selector).length == 0)
        {
            var message = "No .ajax-spinner found on the page. Please add a spinner for better user experience.";

            if (window.location.host.indexOf(".dev.") > -1)
                bootbox.alert(message);
            else
                console.error(message);
        }
        else
        {
            const spinner = $(selector);
            const ajaxTimeout = spinner.data('ajaxTimeout');
            if (ajaxTimeout)
                window.clearTimeout(ajaxTimeout);

            const timeout = window.setTimeout(() => {               
                showAjaxSpinner(selector);
            }, 200);

            overallAjaxCount++;
            spinner.data('ajaxCount', (spinner.data('ajaxCount') || 0) + 1);
            spinner.data('ajaxTimeout', timeout);
        }
    }

    function popAjaxSpinner(selector)
    {
        selector = selector || ".ajax-spinner";
        overallAjaxCount--;

        const spinner = $(selector);
        let ajaxCount = spinner.data('ajaxCount');
        spinner.data('ajaxCount', --ajaxCount);
        if (ajaxCount == 0)
        {           
            $(selector).hide();
            window.clearTimeout(spinner.data('ajaxTimeout'));
        }
    }

    window.addEventListener('beforeunload', function (e)
    {
        if (overallAjaxCount > 0) {
            e.preventDefault();
            e.returnValue = true;
        }
    });

    /**
     * Executes an AJAX call with automatic spinner management
     * 
     * Supports two calling patterns:
     * 
     * 1. Legacy signature:
     *    $.executeAjaxCall(ajaxCall, success, error)
     * 
     * 2. Options object signature:
     *    $.executeAjaxCall({
     *        ajax: $.ajax({...}),
     *        success: function(result) {...},
     *        error: function(xhr) {...},
     *        spinner: '.custom-spinner',
     *        skipErrorModal: false
     *    })
     * 
     * @param {jQuery.ajax|Object} ajaxCallOrOptions - The jQuery AJAX call to execute OR an options object
     * @param {Function} success - Optional success callback function (when using legacy signature)
     * @param {Function} error - Optional error callback function (when using legacy signature)
     * 
     * @param {jQuery.ajax} options.ajax - The jQuery AJAX call to execute (required)
     * @param {Function} options.success - Optional success callback function
     * @param {Function} options.error - Optional error callback function  
     * @param {Function} options.complete - Optional callback function for additional completion logic
     * @param {string} options.spinner - Optional custom spinner selector (or array of selectors) (defaults to ".ajax-spinner"), set to false to skip spinner management
     * @param {boolean} options.allowMultipleSpinners - If true, only hides the selected spinner on completion
     * @param {boolean} options.skipErrorModal - If true, skips showing error modal and calls error directly
     * 
     * @example
     * // Legacy signature
     * $.executeAjaxCall(
     *     $.ajax({ url: '/api/data' }),
     *     function(result) { console.log('Success:', result); },
     *     function(xhr) { console.log('Error:', xhr); }
     * );
     * 
     * @example
     * // Options object signature
     * $.executeAjaxCall({
     *     ajax: $.ajax({ url: '/api/data' }),
     *     success: function(result) { console.log('Success:', result); },
     *     error: function(xhr) { console.log('Error:', xhr); },
     *     complete: function() { console.log('AJAX call complete'); },
     *     spinner: '#custom-spinner',
     *     allowMultipleSpinners: true, 
     *     skipErrorModal: false
     * });
     */
    // Hold a spinner across a sequence of calls: the reference count never reaches zero, so it does not
    // hide and restart its delay between them. Every push needs a matching pop.
    $.pushAjaxSpinner = pushAjaxSpinner;
    $.popAjaxSpinner = popAjaxSpinner;

    $.executeAjaxCall = function (ajaxCallOrOptions, success, error)
    {
        // Check if first parameter is an options object or jQuery ajax call
        var isOptionsObject = typeof ajaxCallOrOptions === 'object' && !ajaxCallOrOptions.promise;
        
        var options;
        
        if (isOptionsObject) {
            options = ajaxCallOrOptions;
        } else {
            options = {
                ajax: ajaxCallOrOptions,
                success: success,
                error: error,
            };
        }
        
        if (!options.ajax) {
            console.error('executeAjaxCall: ajaxCall is required');
            return;
        }

        if (options.spinner !== false) {
            if (Array.isArray(options.spinner)) {
                options.spinner.forEach(spinnerSelector => pushAjaxSpinner(spinnerSelector));
            } else {
                pushAjaxSpinner(options.allowMultipleSpinners ? options.spinner : null);
            }
        }

        options.ajax
            .success(function (result)
            {
                if (options.success)
                {
                    options.success(result);
                }
            })
            .error(function (xhr)
            {
                var handleError = function ()
                {
                    if (options.error)
                        options.error(xhr);
                    else
                        location.reload();
                };

                if (options.skipErrorModal)
                    handleError();
                else
                    showApiErrorsInModal(xhr, "Error", handleError);
            })
            .complete(function ()
            {
                if (options.spinner !== false) {
                    if (Array.isArray(options.spinner)) {
                        options.spinner.forEach(spinnerSelector => popAjaxSpinner(spinnerSelector));
                    } else {
                        popAjaxSpinner(options.allowMultipleSpinners ? options.spinner : null);
                    }
                }

                if (options.complete)
                    options.complete();
            });
    }
})($);

/* modal stuff */
var _modalTitleIdCounter = 0;

// dialogs must announce with a name: point aria-labelledby at a visible title,
// minting an id when the loaded content didn't bring one.
// loaded content can itself contain modal markup — only this dialog's own nodes count
var wireModalTitleA11y = function (modal) {
    var nested = modal.find(".modal");
    var title = modal.find(".modal-title").not(nested.find(".modal-title")).first();

    if (!title.length) {
        title = modal.find("h1, h2, h3, h4, h5, h6, [role='heading'], .lead")
            .not(nested.find("h1, h2, h3, h4, h5, h6, [role='heading'], .lead"))
            .first();
    }

    if (!title.length) {
        modal.removeAttr("aria-labelledby");

        if (!modal.attr("aria-label"))
            modal.attr("aria-label", "Dialog");

        return;
    }

    if (!title.attr("id"))
        title.attr("id", "or-modal-title-" + (++_modalTitleIdCounter));

    modal.removeAttr("aria-label");
    modal.attr("aria-labelledby", title.attr("id"));
};

var prepModal = function (modal, html, success, successHandlesRedirect) {
    modal.find(".modal-content").html(html);

    wireModalTitleA11y(modal);

    initializePhoneNumberInputs(modal);

    $("select[data-role=multiselect]:not(.multiselect-initialized)", modal).multiselect();

    var form = modal.find("form");

    if (!form.is(".no-focus"))
        form.find("input[type=text], textarea, select").not(".no-focus").filter(":visible:first").focus();

    if (form.length) {
        $.validator.unobtrusive.parseDynamicContent(form);

        if (success) {
            wireSubmitHandler(form, function (f) {
                $.ajax({
                    type: "post",
                    url: $(f).attr("action"),
                    data: $(f).serializeFiles(),
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if (data.success) {
                            modal.modal("hide");

                            if (data.redirectUrl && !(successHandlesRedirect && success))
                                window.location = data.redirectUrl;
                            else if (success)
                                success(data);
                        }
                        else
                            prepModal(modal, data, success, successHandlesRedirect);

                        $(f).hideWorking();
                    },
                    error: function (jqXHR) {
                        modal.find(".modal-body").html(extractErrorBlock(jqXHR));

                        $(f).hideWorking();
                        $(f).find(".form-actions .btn-success, .modal-footer .btn-success").hide();
                        $(f).find(".form-actions .btn-hide-while-loading, .modal-footer .btn-hide-while-loading").show();
                    }
                });
            });
        }
    }

    modal.trigger('modal:contentLoaded');
};

var prepFjaxForm = function (form) {
    wireSubmitHandler(form, function (f) {
        var data = new FormData(f);
        
        $(f).trigger("beforesubmit.fjax", [data]);

        $.ajax({
            url: $(f).attr("action"),
            data: data,
            processData: false,
            contentType: false,
            method: "POST"
        })
            .done(function (data, status, xhr) {
                var $new = $(data);

                $(f).hideWorking();

                $(f).trigger("aftersubmit.fjax", [data, xhr]);

                var skipReplace = $(f).data("skip-fjax-form-replace");
                var shouldReplace = typeof skipReplace == typeof undefined || (skipReplace == "form-only" && $new.is("form")) || (skipReplace.toLowerCase() != "true" && skipReplace != "form-only");

                var validationMessages = $new.find(".field-validation-error").map(function () { return $(this).text(); }).get();

                if (shouldReplace)
                {
                    $(f).replaceWith($new);
                }

                if ($new.is("form"))
                {
                    $.validator.unobtrusive.parseDynamicContent($new);

                    prepFjaxForm($new);
                }

                // Fire on the replaced element so downstream modules (inbox-compose, etc.)
                // can re-attach state to the new DOM without a MutationObserver backstop.
                if (shouldReplace)
                {
                    $new.trigger("or-fjax-replaced");
                }

                $(f).trigger("aftersubmit.fjax", [data, xhr, validationMessages]);
            })
            .error(function (jqXHR) {
                $(f).trigger("submiterror.fjax", [data, jqXHR]);

                bootbox.alert({ title: "Error Loading Form", message: $("<div />").append(extractErrorBlock(jqXHR)) });

                $(f).hideWorking();
                $(f).find(".form-actions .btn-success").hide();
                $(f).find(".form-actions .btn-hide-while-loading").show();
            });

        $('.open > .dropdown-toggle').dropdown("toggle");
    });
};

var wireSubmitHandler = function (form, submitHandler) {
    var data = $(form).data("validator");

    if (data && data.settings)
    {
        data.settings.submitHandler = function (f, e)
        {
            var submitter = e.submitter || (e.originalEvent ? e.originalEvent.submitter : null);

            // postpone this till after all other event handlers
            window.setTimeout(function ()
            {
                // custom submit handlers can set an "invalid" class on the form to prevent submission
                if ($(f).is(":not(.invalid)"))
                {
                    if ($.addAntiForgeryToken)
                        $.addAntiForgeryToken($(f));

                    if ($(f).find("input[name=_windowId]").length == 0 && window.name)
                        $('<input type="hidden" name="_windowId" />').attr("value", window.name).appendTo($(f));

                    if ($.connection && $.connection.hub && $.connection.hub.stop && !$(f).is(".or-fjax-form"))
                        $.connection.hub.stop();

                    $(f).showWorking(submitter);

                    submitHandler(f);
                }

                $(f).removeClass("invalid");
            }, 1); // timeout 1 shoves this to the end of the currently executing code
        };
    }
};

// cribbed from Griddly
var serializeObject = function ($elements, skipEmpty) {
    // http://stackoverflow.com/a/1186309/8037
    var data = {};

    $.each($elements.serializeArray(), function () {
        if (this.value == '' && skipEmpty)
            this.value = null;
        else if (this.value == null && !skipEmpty)
            this.value = '';

        if (this.value == null)
            return;

        if (data[this.name] !== undefined || $("[name='" + this.name + "']").is("[multiple]")) {
            if (data[this.name] == null)
                data[this.name] = [];
            else if (!data[this.name].push)
                data[this.name] = [data[this.name]];

            data[this.name].push(this.value);
        }
        else {
            data[this.name] = this.value;
        }
    });

    return data;
};

var wireApiModal = function (modal, success, getData) {
    var form = modal.find("form");

    wireSubmitHandler(form, function (f) {
        f = $(f);

        var data;

        if (getData)
            data = getData(f);
        else
            data = serializeObject(f);

        $.ajax(f.attr("action"),
            {
                data: JSON.stringify(data),
                contentType: "application/json",
                method: f.attr("method") || "POST"
            })
            .success(function (data) {
                modal.modal("hide");

                if (success)
                    success(data);

                f.hideWorking();
            })
            .error(function (xhr) {
                f.hideWorking();

                var errorDisplay = f.find(".validation-summary-valid, .validation-summary-errors");

                if (errorDisplay.length) {
                    f.showApiErrorsInSummary(xhr);
                    errorDisplay[0].scrollIntoView();
                }
                else {
                    showApiErrorsInModal(xhr);
                }
            });
    });
};

var extractErrorBlock = function (jqXHR) {
    var body = jqXHR.responseText;
    var bodyStart = body.indexOf("<body");

    if (bodyStart >= 0)
        bodyStart = body.indexOf(">", bodyStart + 1) + 1;

    var bodyEnd = body.indexOf("</body>", bodyStart);

    if (bodyStart >= 0) {
        if (bodyEnd >= 0)
            body = body.substring(bodyStart, bodyEnd);
        else
            body = body.substring(bodyStart);
    }

    var html = $(body);
    var errorContent = html.find(".error-container");

    return errorContent.length ? errorContent.contents() : html;
};

$.extend({
    showModal: function (url, success, btn, className, loaded, ajaxOptions, successHandlesRedirect) {
        //if (btn)
        //    btn.showWorking(btn);
        if (!url)
            return false;

        if (url.indexOf("embedded") == -1)
            url += (url.indexOf("?") == -1 ? "?" : "&") + "embedded=true";

        if (url.indexOf("bootstrapVersion") == -1)
            url += (url.indexOf("?") == -1 ? "?" : "&") + "bootstrapVersion=" + (window.useBs5 ? 'V5' : 'V3');

        var modal = $('<div class="modal" tabindex="-1" role="dialog"><div class="modal-dialog ' + className + '"><div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close btn-close btn-close-custom float-end order-2" data-dismiss="modal" data-bs-dismiss="modal" aria-label="Close"></button>' +
            '<h4 class="modal-title">Loading...</h4>' +
            '</div>' +
            '<div class="modal-body">' +
            '<div class="or-showmodal-spinner" style="padding:20px;text-align:center;height:400px;line-height:400px;display:none">' +
            '<i class="fa-regular fa-circle-notch fa-spin text-muted fa-5x"></i>' +
            '</div></div></div></div></div>');

        wireModalTitleA11y(modal);

        var opener = document.activeElement;

        modal
            .modal("show")
            .on("hidden.bs.modal", function (e) {
                // nested modal markup in loaded content bubbles hidden.bs.modal —
                // only tear down / restore focus when THIS dialog hid
                if (e.target !== modal[0])
                    return;

                $(this).remove();

                // Keep in sync with returnFocus in bootbox-a11y.js — same contract,
                // duplicated so the bootbox shim stays self-contained.
                if (!opener || !document.contains(opener) || !$(opener).is(":visible"))
                    return;

                var openModals = $(".modal.show, .modal.in");

                if (openModals.length) {
                    var openerModal = $(opener).closest(".modal")[0];

                    if (!openerModal || openerModal !== openModals.last()[0])
                        return;
                }

                opener.focus();
            });

        if (window.closeRightSidebar) {
            closeRightSidebar();
        }

        // only show the spinner if it is slow... feels faster without immediate spinner
        window.setTimeout(function () {
            $(modal).find(".or-showmodal-spinner").slideDown(100);
        }, 200);

        $.ajax(url, ajaxOptions || { cache: false })
            .done(function (html) {
                prepModal(modal, html, success, successHandlesRedirect);

                if (loaded)
                    loaded(modal);
            })
            .error(function (jqXHR) {
                bootbox.alert({ title: "Error Loading Modal", message: $("<div />").append(extractErrorBlock(jqXHR)) });

                modal.modal("hide");
            });
        //.always(function()
        //{
        //    if (btn)
        //        btn.hideWorking(btn);
        //});
    }
});

$(document).on("click", "a.or-showmodal-url", function (e) {
    return false;
});

$(document).on("mouseup", "tr[data-or-showmodal-url] td:not(:has(input)), a.or-showmodal-url", OrShowModalUrl);

function OrShowModalUrl(e)
{
    var url;
    var successFunction;
    var openFunction;
    var griddly = $(this).closest(".griddly");
    
    // https://github.com/ownerrez/orez/issues/8507#issuecomment-1887793415
    $("[data-toggle=popover]").popover('hide');

    if ($(this).data("confirm"))
    {
        if (!confirm($(this).data("confirm")))
            return false;
    }

    if ($(this).is("a.or-showmodal-url")) {
        url = $(this).attr("href");

        if ($(this).data("or-showmodal-success-function") && window[$(this).data("or-showmodal-success-function")])
            successFunction = window[$(this).data("or-showmodal-success-function")];

        if ($(this).data("or-showmodal-open-function") && window[$(this).data("or-showmodal-open-function")])
            openFunction = window[$(this).data("or-showmodal-open-function")];
    }
    else {
        if ($(e.target).closest("a").length || $(e.target).closest("td").find("[data-toggle=dropdown]").length)
            return;

        url = $(this).closest("tr").data("or-showmodal-url");

        if ($(this).closest("tr").data("or-showmodal-success-function") && window[$(this).closest("tr").data("or-showmodal-success-function")])
            successFunction = window[$(this).closest("tr").data("or-showmodal-success-function")];

        if ($(this).closest("tr").data("or-showmodal-open-function") && window[$(this).closest("tr").data("or-showmodal-open-function")])
            openFunction = window[$(this).closest("tr").data("or-showmodal-open-function")];
    }

    $('.open > .dropdown-toggle').dropdown("toggle");

    if (openFunction && typeof openFunction == "function")
        openFunction.call($(this));

    if (e.which == 2 || e.ctrlKey) {
        // griddly already pops up based on this
        if ($(this).closest(".griddly").length > 0 || e.ctrlKey) {
            window.open(url);

            return false;
        }
    }
    else if (e.which == 1 || !e.which)
    {
        var contextEl = $(this);
        var ajaxOptions = null;
        var modalEl = $(this).is("a.or-showmodal-url") ? $(this) : $(this).closest("tr");
        var method = modalEl.data("or-showmodal-method");

        if (method && method.toUpperCase() === "POST") {
            var parts = url.split("?");
            url = parts[0];
            var data = parts[1] || "";
            var extraData = modalEl.data("or-showmodal-data");

            if (extraData) {
                var params = $.param(extraData);
                data = data ? data + "&" + params : params;
            }

            ajaxOptions = { method: "POST", data: data };
        }

        $.showModal(url, function (data) {
            if (successFunction && typeof successFunction == "function")
                successFunction.call(contextEl, data);
            else if (data && data.redirectUrl)
                window.location = data.redirectUrl;
            else if (griddly.length)
                griddly.griddly("refresh");
            else
                window.location = window.location;
        }, $(this), $(this).data("or-showmodal-size") || "modal-lg", null, ajaxOptions, true);
    }
}

$(function () {
    $("form.or-fjax-form").each(function () {
        prepFjaxForm($(this));
    });
});

jQuery.validator.unobtrusive.adapters.add(
    'filesize', ['maxsize'], function (options) {
        options.rules['filesize'] = options.params;
        if (options.message) {
            options.messages['filesize'] = options.message;
        }
    }
);

jQuery.validator.addMethod('filesize', function (value, element, params) {
    if (!element.files || element.files.length < 1 || !element.files[0].size)
        // This browser doesn't support the HTML5 API or No files selected
        return true;

    return element.files[0].size < params.maxsize;
}, '');

// Mirror of StringExtensions.TextLength — a textarea's value uses LF but the browser submits CRLF.
function textLength(value) {
    if (!value)
        return 0;

    var normalized = value.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var length = 0;

    for (var i = 0; i < normalized.length; i++) {
        length++;

        var code = normalized.charCodeAt(i);

        if (code >= 0xD800 && code <= 0xDBFF && i + 1 < normalized.length) {
            var next = normalized.charCodeAt(i + 1);

            if (next >= 0xDC00 && next <= 0xDFFF)
                i++;
        }
    }

    return length;
}

jQuery.validator.unobtrusive.adapters.addSingleVal('textlength', 'max');

jQuery.validator.addMethod('textlength', function (value, element, param) {
    return this.optional(element) || textLength(value) <= parseInt(param, 10);
}, '');

// Override to unhighlight before highlighting, so if a field has child fields it won't clear the error state after setting it
jQuery.validator.setDefaults({
    showErrors: function () {
        var i, elements, error;

        if (this.settings.unhighlight) {
            for (i = 0, elements = this.validElements(); elements[i]; i++) {
                this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
            }
        }

        for (i = 0; this.errorList[i]; i++) {
            error = this.errorList[i];
            if (this.settings.highlight) {
                this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
            }
            this.showLabel(error.element, error.message);
        }
        if (this.errorList.length) {
            this.toShow = this.toShow.add(this.containers);
        }
        if (this.settings.success) {
            for (i = 0; this.successList[i]; i++) {
                this.showLabel(this.successList[i]);
            }
        }

        this.toHide = this.toHide.not(this.toShow);
        this.hideErrors();
        this.addWrapper(this.toShow).show();
    }
});

// https://stackoverflow.com/a/4562936/8037
$.fn.isDirty = function () {
    var dirty = false;

    $(":input:not(:button):not([type=hidden])", this).each(function () {
        if (this.type == "select-one" || this.type == "select-multiple") {
            for (var x = 0; x < this.length; x++) {
                if (this.options[x].selected != this.options[x].defaultSelected) {
                    dirty = true;

                    break;
                }
            }
        }
        else if ((this.type == "text" || this.type == "textarea" || this.type == "hidden") && this.defaultValue != this.value)
            dirty = true;
        else if ((this.type == "radio" || this.type == "checkbox") && this.defaultChecked != this.checked)
            dirty = true;

        if (dirty)
            return false;
    });

    return dirty;
};

$(".inpage-list-toggle").click(function () {
    var boxes = $(this).closest(".inpage-list-group").find("input:checkbox, input:radio");
    var isCheck = boxes.is(":unchecked");

    boxes.prop("checked", isCheck);

    return false;
});

function fallbackMessage(action) {
    var actionMsg = '';
    var actionKey = (action === 'cut' ? 'X' : 'C');

    if (/iPhone|iPad/i.test(navigator.userAgent)) {
        actionMsg = 'No support for copy button. Tap and hold to select the text in the box and copy it instead. :(';
    }
    else if (/Mac/i.test(navigator.userAgent)) {
        actionMsg = 'Press ⌘-' + actionKey + ' to ' + action;
    }
    else {
        actionMsg = 'Press Ctrl-' + actionKey + ' to ' + action;
    }

    return actionMsg;
}

function showClipboardSuccess(trigger) {
    if (useBs5)
    {
        var tooltip = bootstrap.Tooltip.getInstance(trigger);
        var originalTitle = null;

        if (!tooltip)
            tooltip = new bootstrap.Tooltip(trigger, {});
        else
            originalTitle = tooltip._config.title;
        
        tooltip._config.title = "Copied!";
        tooltip.update();
        tooltip.show();

        $(trigger).on('hidden.bs.tooltip', function ()
        {
            if (originalTitle)
                tooltip._config.title = originalTitle;
            else
                tooltip.dispose();
        });
    }
    else
    {
        $(trigger).tooltip({ title: 'Copied!', container: 'body' }).tooltip("show").on('hidden.bs.tooltip', function () { var _this = $(this); setTimeout(function () { _this.tooltip("destroy"); }, 10); });
    }
}

function showClipboardError(trigger, action) {
    if (useBs5)
    {
        var tooltip = bootstrap.Tooltip.getInstance(trigger);
        if (!tooltip)
            tooltip = new bootstrap.Tooltip(trigger, {});

        tooltip._config.title = fallbackMessage(action);
        tooltip.show();
    }
    else
    {
        $(trigger).tooltip({ title: fallbackMessage(action), container: 'body' }).tooltip("show");
    }
}

function fallbackCopyTextToClipboard(text, trigger) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, 99999);
    try {
        var successful = document.execCommand('copy');
        if (successful) {
            showClipboardSuccess(trigger);
        }
        else {
            showClipboardError(trigger, 'copy');
        }
    } catch (err) {
        showClipboardError(trigger, 'copy');
    }
    setTimeout(function() {
        document.body.removeChild(textArea);
    }, 100);
}

// The Insert a Field dialog (Modals/Fields.cshtml) inserts a code at the cursor of an input that has had focus; otherwise it appends.
$(document).on('focusin', ':input[id]', function () {
    if (document.querySelector('[data-input-to-update="' + CSS.escape(this.id) + '"]'))
        $(this).data('has-been-focused', true);
});

$(document).on('click', '[data-clipboard-target], [data-clipboard-text]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $trigger = $(this);
    var textToCopy = null;
    
    var targetSelector = $trigger.attr('data-clipboard-target');
    if (targetSelector) {
        var targetElement = document.querySelector(targetSelector);
        if (targetElement) {
            textToCopy = targetElement.value || targetElement.textContent || targetElement.innerText;
        }
    }
    
    if (!textToCopy) {
        textToCopy = $trigger.attr('data-clipboard-text');
    }
    
    if (!textToCopy) {
        showClipboardError(this, 'copy');
        return;
    }
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(function() {
            showClipboardSuccess($trigger[0]);
        }).catch(function(err) {
            fallbackCopyTextToClipboard(textToCopy, $trigger[0]);
        });
    }
    else {
        fallbackCopyTextToClipboard(textToCopy, $trigger[0]);
    }
});

$('#copy-link-modal').on('show.bs.modal', function (e) {
    var tr = $(e.relatedTarget).closest("tr");

    if (tr == null || tr.length == 0)
        tr = $(e.relatedTarget).closest(".dropdown-menu").data("parent-row");

    var url = tr.data("url");

    $("#copy-link-url").val(url).focus();
}).on('shown.bs.modal', function (e) {
    $("#copy-link-url").focus();
});

$("#copy-link-url").focus(function () {
    $(this).select();
});

// hide tinymce inline editors -- like the table editor -- when modals are shown
$(".modal").on("show.bs.modal", function () { $(".mce-tinymce-inline").hide(); });

var prettifyVideoHtml = function (content) {
    try {
        var sourceContent = $(content);

        var iFrame = sourceContent.find("iframe[src]").addBack("iframe[src]").first();

        if (iFrame.length)
            return $('<iframe src="' + iFrame.attr("src") + '" frameborder="0" allowfullscreen=""></iframe>');

        var video = sourceContent.find("video").addBack("video").first();

        if (video.length)
            return video.removeAttr("width").removeAttr("height").removeAttr("style");
    }
    catch (ex) {
        // https://stackoverflow.com/a/8943487/8037
        var urlRegex = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        var matches = content.match(urlRegex);

        if (matches && matches.length)
            return $('<iframe src="' + matches[0] + '" frameborder="0" allowfullscreen=""></iframe>');
    }
};

$(document).on("blur", "input:text", function () {
    this.value = $.trim(this.value);
});

$(document).ready(function () { $("[data-toggle=switch]").bootstrapSwitch() });

function InitializeFileEditors(el) {
    if (!el)
        el = document;

    $(".file-editor .file-editor-delete", el).on("click", function () {
        var component = $(this).closest(".file-editor");

        component.find("input[type=file]").val("").trigger("change");
        component.find("input[type=hidden]").val("");
        component.find(".file-editor-current").hide();
        component.removeClass("file-editor-has-preview");
        component.find(".file-editor-selected").text("");
    });

    $(".file-editor", el).on("click", ".file-editor-unselect", function ()
    {
        var component = $(this).closest(".file-editor");

        component.find("input[type=file]").val("").trigger("change");
        component.find(".file-editor-selected").text("");
        component.find("input.file-editor-existing-id").val("");
    });

    $(".file-editor .file-editor-preview", el).click(function () {
        var src = $(this).data("src");
        var content = "<img style='max-width:100%;max-height:80vh;' src='" + src + "' />";

        bootbox.alert({
            message: "<div class='sample'>" + content + "</div>",
            className: "modal-fit-content",
            backdrop: true,
            buttons: {
                ok: {
                    label: "Close"
                }
            }
        });
    });

    $(".file-editor input[type=file]", el).change(function () {
        // TODO: we could put a image preview there if we want: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
        var selected = $(this).closest(".file-editor").find(".file-editor-selected");

        if (this.files.length > 0)
            selected.html(`<span class="file-editor-selected-name">${this.files[0].name}</span> <a class=\"file-editor-unselect\" href=\"javascript:;\"><i class=\"fa fa-close fa-sm\"></i></a>`);
        else
            selected.text("");
    });

    $(".file-editor input[type=file]", el).focus(function () {
        $(this).closest(".file-editor").find(".file-editor-picker").addClass("focus");
    });

    $(".file-editor input[type=file]", el).blur(function () {
        $(this).closest(".file-editor").find(".file-editor-picker").removeClass("focus");
    });

    $(".file-editor input[type=file]", el).change(function () {
        //$(this).closest("form").data('validator').element(this); This one just displays the alert for some reason... it doesn't display the validation error.
        $(this).closest("form").valid();
    });
}

InitializeFileEditors();

(function () {
    $(document).on("keypress paste input", "textarea[data-max-length], input[data-max-length-display]", function () {
        updateLengthCounter(this, $(this).val());
    });

    var gsmAutoConvert = {
        "“": "\"",
        "”": "\"",
        "‘": "'",
        "’": "'"
    };

    $(document).on("click", "a.sms-segments-x-ray", function () {
        var textarea = $(this).closest(".form-group, .body-container").find("textarea");
        var text = textarea.val();
        var segmented = new SegmentedMessage(text, "auto");
        var nonGsmChars = segmented.getNonGsmCharacters();

        var totalChars = text.length;
        var cleanText = text;

        for (var c in nonGsmChars) {
            var char = nonGsmChars[c];
            var replacement = gsmAutoConvert[char];

            cleanText = cleanText.replace(new RegExp(char, "gi"), !!replacement ? replacement : "");
            text = text.replace(new RegExp(char, "gi"), "<span class='non-gsm" + (!!replacement ? " smart-replaced" : "") + "'>" + char + "</span>");
        }

        var cleanSegmented = new SegmentedMessage(cleanText, "auto");

        var buttons = {
            help: {
                label: "<a href='https://www.ownerrez.com/support/articles/sms-segments-calculator' target='_blank'><i class='fa fa-question-circle'></i> Learn about SMS segments <i class='far fa-arrow-up-right fa-sm'></i></a>",
                className: "float-start help-button",
                callback: function () {
                    window.open("https://www.ownerrez.com/support/articles/sms-segments-calculator");
                    return false;
                }
            },
            close: {
                label: "Close",
                className: "btn-default"
            }
        };

        if (nonGsmChars.length) {
            buttons.success = {
                label: "Clean Message",
                className: "btn-success",
                callback: function () {
                    textarea.val(cleanText);
                    textarea.keypress();
                }
            };
        }

        var message = `
<div style="margin-top:0;" class="bs-callout bs-callout-noborder bs-callout-condensed bs-callout-${nonGsmChars.length ? "warning" : "info"}">
    ${nonGsmChars.length ? "This message can be cleaned by removing or replacing special characters which have been highlighted below. Use the button at the bottom to automatically clean this message." : "This message is as clean as it can be because there are no special characters."}
</div>
<p class="sms-message-x-ray">${text}</p>
<p>Current count: ${"<strong>" + totalChars + "</strong> character" + (totalChars == 1 ? "" : "s")}, ${"<strong>" + segmented.segmentsCount + "</strong> segment" + (segmented.segmentsCount == 1 ? "" : "s")} ${cleanSegmented.segmentsCount < segmented.segmentsCount ? `(can be ${cleanSegmented.segmentsCount}, if cleaned)` : ``}</p>
<p style="${nonGsmChars.length ? "" : "display:none;"}">Legend:</p>
<p style="${nonGsmChars.length ? "" : "display:none;"}"><span class="non-gsm smart-replaced" style='margin-right:7px;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="small">These characters can be replaced with equivalent smaller characters</span><br />
    <span class="non-gsm" style='margin-right:7px;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="small">These characters cannot be replaced, only removed</span></p>`;

        bootbox.dialog({
            title: "SMS Message X-Ray",
            size: "large",
            html: true,
            buttons: buttons,
            message: message
        });
    });

})();

function updateLengthCounter(textarea, value) {
    var lengthFunc = $(textarea).data('length-function');
    var len = lengthFunc ? window[lengthFunc](value) : value.length;
    var maxLength = parseInt($(textarea).data("maxLength"));
    var display = $(textarea).parent().find(".max-length-display");

    display.toggle(len > 0);

    if (len > 0) {
        display.toggleClass("max-length-display-exceeded", len > maxLength);
        display.find("span.length").text(len);

        var additionalCounterFunc = $(textarea).data("additional-counter-function");
        if (additionalCounterFunc)
        {
            var segmentedMessage = new SegmentedMessage(value, "auto");

            var segs = segmentedMessage.segmentsCount;

            display.find("span.additional-counter").html(`(<span class='hidden-sm'>approx. </span>${segs} <span class='hidden-sm'>segment</span><span class='visible-sm'>seg</span>${segs == 1 ? "" : "s"})`);
        }
    }
}

function bindDialers() {
    if (window.extensionId && window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {
        var dialers = $(".dialer-button");

        if (dialers.length) {
            var linkPort = chrome.runtime.connect(window.extensionId, { name: "ORCBPhoneLink" });
            var phoneLinkEnabled = false;

            linkPort.onMessage.addListener(function (msg) {
                switch (msg.type) {
                    case "SendVersion":
                        if (msg && msg.version >= 1.0)
                            phoneLinkEnabled = true;

                        break;
                }
            });

            linkPort.onDisconnect.addListener(function () {
                phoneLinkEnabled = false;
            });

            linkPort.postMessage({ type: "GetVersion" });

            var baseUrl = window.location.protocol + "//" + window.location.host;

            dialers.click(function () {
                if (phoneLinkEnabled) {
                    linkPort.postMessage({ type: "OpenDialer", target: $(this).prop("href") });

                    return false;
                }
            });

            var defaultDialer = dialers.filter(".default-dialer");

            if (defaultDialer.length) {
                var dialer = $(defaultDialer).prop("href");

                $("document").on("click", "a[href^='tel:']", function () {
                    if (phoneLinkEnabled) {
                        linkPort.postMessage({ type: "OpenDialer", target: dialer, number: $(this).prop("href").replace("tel:", "") });

                        return false;
                    }
                });
            }
        }
    }
}

bindDialers();

function throttle(func, wait) {
    var timeout = null;
    var multiple = false;

    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;

            if (multiple)
                func.apply(context, args);

            multiple = false;
        };

        if (timeout != null) {
            window.clearTimeout(timeout);

            multiple = true;
        }
        else
            func.apply(context, args);

        timeout = window.setTimeout(later, wait);
    };
}

$(function () {
    // push local tab navigation to url state
    $(document).on("click", "a[data-toggle=tab], a[data-toggle=pill]", function (e) {
        history.replaceState(null, null, $(this).attr('href'));
    });

    // navigate to a tab when the history changes
    $(window).on("popstate", function (e) {
        try {
            var activeTab = $(`[href='${location.hash}'][data-toggle=tab]`);
            if (activeTab.length) {
                activeTab.tab("show");
            } else {
                var firstTab = $(".nav-tabs a:first");
                if (firstTab.length) {
                    firstTab.tab("show");
                }
            }
        }
        catch(ex) {
            console.warn(ex);
        }        
    });

    // also navigate when the page is loaded
    if (window.location.hash.length > 0) {
        $(`.nav-tabs [href='${window.location.hash}']`).tab("show");
    }
});

$(".stay-button").on("click", function () {
    $(this).val($(".tab-pane:visible").attr("id") || " ");
});

var flashTimeout;
function showRefund(editor, text) {
    if (text !== $(".cancellation-policy-description", editor).text()) {
        $(".cancellation-policy-description", editor).addClass("flash");
        $(".cancellation-policy-description", editor).text(text);

        if (flashTimeout)
            clearTimeout(flashTimeout);

        flashTimeout = setTimeout(function () { $(".cancellation-policy-description", editor).removeClass("flash"); }, 1000);
    }
};

function getRefundText(policy, editor) {
    orFetch('/settings/cancellationpolicies/policy', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(policy)
    })
        .then((response) => response.json())
        .then((data) => {
            showRefund(editor, data.text);
        })
        .catch((error) => {
            console.error('Error:', error);
            showRefund(editor, "Unable to retrieve policy.  Please contact support for assistance");
        });
};

function describeRefund(editor) {

    // var text = "";
    var mode = $("[name$='.RefundMode']:checked", editor).val();
    var isFeeSelected = $(".has-cancellation-fee :input[value=True]", editor).prop("checked");
    var isGracePeriodSelected = $(".grace-period-group :input[value=True]", editor).prop("checked");

    //var minNights = null;
    //var feeClause = $(".has-cancellation-fee :input[value=True]", editor).prop("checked") ? " (less " + $(".cancellation-fee-group .input-group *", editor).map(function () { return $(this).text().trim() || $(this).val(); }).get().join("") + " cancellation fee)" : "";

    let policyModel = {
        RefundMode: mode,
        HasCancellationFee: isFeeSelected,
        Period1Nights: parseInt($("[name$='.Period1Nights']", editor).val().replace(/[^0-9,]/g, "")) || 1,
        Period1Percent: parseFloat($("[name$='.Period1Percentage']", editor).val().replace(/[^0-9,.]/g, "")) || 0
    };

    if (policyModel.RefundMode == "Complicated") {
        policyModel.Period2Nights = parseInt($("[name$='.Period2Nights']", editor).val().replace(/[^0-9,]/g, "")) || null;
        policyModel.Period2Percent = parseFloat($("[name$='.Period2Percentage']", editor).val().replace(/[^0-9,.]/g, "")) || null;
        policyModel.Period3Nights = parseInt($("[name$='.Period3Nights']", editor).val().replace(/[^0-9,]/g, "")) || null;
        policyModel.Period3Percent = parseFloat($("[name$='.Period3Percentage']", editor).val().replace(/[^0-9,.]/g, "")) || null;
    }

    if (isFeeSelected) {
        policyModel.CancellationFeeSurchargeId = parseInt($("[name$='.CancellationFeeSurchargeId']", editor).val());
    }

    if (isGracePeriodSelected)
    {
        policyModel.GracePeriodHours = parseInt($("[name$='.GracePeriodHours']", editor).val().replace(/[^0-9,]/g, "")) || null;
        policyModel.GracePeriodLastMinuteHours = parseFloat($("[name$='.GracePeriodLastMinuteHours']", editor).val().replace(/[^0-9,.]/g, "")) || null;
    }

    getRefundText(policyModel, editor);
};

$(function () {
    $(".cancellation-policy-editor .cancellation-fee-group :input").on("change", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        describeRefund(editor);
    });

    $(".cancellation-policy-editor .has-cancellation-fee :input").on("change", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        $(".cancellation-fee-group", editor).toggle($(".has-cancellation-fee :input[value=True]", editor).is(":checked"));

        describeRefund(editor);
    });

    $(".cancellation-policy-editor .refund-mode :input").on("change", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        var val = $(".refund-mode :input:checked", editor).val().toLowerCase();

        $(".mode", editor).hide();
        $(".mode-" + val, editor).show();

        if (val === "none") {
            $(".has-cancellation-fee input[value=False]").click();
            $(".has-cancellation-fee input", editor).prop("disabled", true);
        }
        else {
            $(".has-cancellation-fee input", editor).prop("disabled", false);

            if (val === "complicated")
                $(".period-group-add", editor).toggle($(".period-group:not(:visible)", editor).length > 0);
        }

        describeRefund(editor);
    });

    $(".cancellation-policy-editor .btn-and-then").on("click", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        $(".period-group:not(:visible):first", editor).show();
        $(".btn-remove-period", editor).hide();
        $(".period-group:visible .btn-remove-period:last", editor).show();

        if ($(".period-group:not(:visible)", editor).length === 0) {
            $(".period-group-add", editor).hide();
        }

        describeRefund(editor);
    });

    $(".cancellation-policy-editor .btn-remove-period").on("click", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        $(this).closest(".period-group").hide();
        $(this).closest(".period-group").find(":input").val("");

        $(".period-group:visible .btn-remove-period:last", editor).show();
        $(".period-group-add", editor).show();

        describeRefund(editor);
    });
    
    $(".cancellation-policy-editor .period-group :input").on("change", function () {
        var editor = $(this).closest(".cancellation-policy-editor");
        describeRefund(editor);
    });

    $(".cancellation-policy-editor .grace-period-group :input").on("change", function ()
    {
        var editor = $(this).closest(".cancellation-policy-editor");
        describeRefund(editor);
    });

    $(".cancellation-policy-editor").each(function () {
        describeRefund(this);
    });
});

$(function () {
    if ($(".font-input").length && websafeFonts) {
        var fontLoading = function (input, familyName, fvd) {
            input.parents(".form-group").removeClass("has-error");
            input.parents(".form-group").removeClass("has-success");
            input.parents(".font-input").addClass("loading");
            input.nextAll(":hidden").val("false");
        };

        var fontActive = function (input, familyName, fvd) {
            if (input.val() === familyName) {
                input.parents(".font-input").removeClass("loading");
                input.parents(".form-group").addClass("has-success");
                input.nextAll(":hidden").val("true");
                input.parents(".form-group").find(".form-text").removeClass("field-validation-error");
                input.parents(".form-group").find(".form-text").addClass("field-validation-valid");
            }
        };

        var fontInactive = function (input, familyName, fvd) {
            if (input.val() === familyName) {
                input.parents(".font-input").removeClass("loading");
                input.parents(".form-group").addClass("has-error");
                input.parents(".form-group").find(".form-text").text(input.data("val-assertthat"));
                input.parents(".form-group").find(".form-text").addClass("field-validation-error");
                input.parents(".form-group").find(".form-text").removeClass("field-validation-valid");
            }
        };

        $(".font-input input").on("change", function () {
            var input = $(this);
            var fontSearchText = input.val();
            if (input.val()) {
                var match = websafeFonts.find(z => {
                    return z.toLowerCase() === fontSearchText.toLowerCase();
                }) || null;
                if (match !== null) {
                    input.val(match);
                    fontActive(input, input.val());
                }
                else {
                    const titleCased = fontSearchText.split(' ').map(z => `${z[0].toUpperCase()}${(z.length > 1 ? z.substring(1) : '')}`).join(' ');
                    input.val(titleCased);
                    WebFont.load({
                        fontloading: function (familyName, fvd) { fontLoading(input, familyName, fvd); },
                        fontactive: function (familyName, fvd) { fontActive(input, familyName, fvd); },
                        fontinactive: function (familyName, fvd) { fontInactive(input, familyName, fvd); },
                        classes: false,
                        timeout: 1000, // Set the timeout to two seconds
                        google: {
                            families: [input.val()]
                        }
                    });
                }
            }
        });

        // load webfont loader api : https://github.com/typekit/webfontloader
        (function (d) {
            var wf = d.createElement('script'), s = d.scripts[0];
            wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
            wf.async = true;
            s.parentNode.insertBefore(wf, s);
        })(document);
    }
});

$(function () {
    $(".tags-modal .tags-clear-all").on("click", function () {
        var form = $(this).closest("form");

        $("select option:selected", form).each(function () {
            $(this).prop("selected", false);
        });

        form.submit();
    });

    // griddly batch tags
    var batchTagAction = null;
    var batchTagEntityType = null;

    $("#modal-batch-tags").on("show.bs.modal", function (e)
    {
        var selected = $(".griddly").griddly("getSelected", "id").id;

        batchTagAction = e.relatedTarget.id;
        batchTagEntityType = $(this).data("entityType");

        $(this).find("#change-batch-tag-header").html(e.relatedTarget.innerHTML + " for " + selected.length + " " + (selected.length > 1 ? $(this).data("entityNamePlural") : $(this).data("entityName")) + " selected");

        $("#BatchTagId").val("").multiselect("refresh");
    });

    $("#save-batch-tags").click(function ()
    {
        var modal = $(this).closest(".modal");

        modal.showWorking($(this));

        var selectedIds = $(".griddly").griddly("getSelected", "id").id;

        var data = {
            entityIds: selectedIds,
            entityType: batchTagEntityType,
            tagIds: $("#BatchTagId").val(),
            tagAction: batchTagAction
        };

        $.post("/updatetags", data, function ()
        {
            $(".griddly")
                .griddly("clearSelected")
                .removeClass("or-batch-mode")
                .griddly("refresh");

            $("#modal-batch-tags").modal('hide');

            modal.hideWorking();
        }).fail(function (xhr)
        {
            showApiErrorsInModal(xhr, "Failed to update tags.");

            modal.hideWorking();
        });
    });

    // ============================================================
    // TAG DROPDOWN — inline tag selector with search + add-new
    // ============================================================

    var activeTagDropdown = null;

    function closeTagDropdown() {
        if (activeTagDropdown) {
            $(window).off(".tagdropdown");
            activeTagDropdown.remove();
            activeTagDropdown = null;
        }
    }

    function isValidCssColor(val) {
        return /^#[0-9A-Fa-f]{3,8}$/.test(val);
    }

    function disposeTagTooltips(container) {
        if (!window.bootstrap || !window.bootstrap.Tooltip) return;

        container.find('[data-bs-toggle="tooltip"]').each(function () {
            var tip = window.bootstrap.Tooltip.getInstance(this);
            if (tip) tip.dispose();
        });
    }

    function updateTagBadges(entityId, entityType, entityTags, showChangeHistory) {
        var container = $(".tag-badges-container[data-entity-id='" + entityId + "'][data-entity-type='" + entityType + "']");

        if (!entityTags || entityTags.length === 0) {
            disposeTagTooltips(container);
            container.html('<span class="text-secondary no-tags-label">No tags</span>');

            return;
        }

        var html = "";

        for (var i = 0; i < entityTags.length; i++) {
            var tag = entityTags[i];
            var style = "";

            if (tag.color && tag.active && isValidCssColor(tag.color)) {
                style = "background-color: " + tag.color + ";";

                if (isValidCssColor(tag.foregroundColor)) {
                    style += " color: " + tag.foregroundColor + ";";
                }
            }

            var disabledClass = tag.active ? "" : " label-tag-disabled";
            var escapedName = $("<span/>").text(tag.name).html();

            var tooltip = $("<span/>").text(tag.tooltip).html();

            var historyLink = "";

            if (showChangeHistory && tag.entityTagId) {
                var historyStyle = tag.color && isValidCssColor(tag.color) ? "background-color: " + tag.color + "; color: " + (tag.foregroundColor || "") + ";" : "";

                historyLink = ' <a class="admin-only-btn or-showmodal-url btn-change-history" href="/entitychanges?type=148&id=' + tag.entityTagId + '" title="Change History for entity tag ' + tag.entityTagId + '" style="' + historyStyle + '"><i class="far fa-history fa-sm"></i></a>';
            }

            html += '<span data-id="' + tag.tagId + '" class="badge rounded-4 label-tag mb-1' + disabledClass + '" style="' + style + '" data-bs-toggle="tooltip" data-bs-title="' + tooltip.replace(/"/g, "&quot;") + '">' + escapedName + historyLink + '</span>\n';
        }

        disposeTagTooltips(container);
        container.html(html);
        container.find('[data-bs-toggle="tooltip"]').each(function () { new bootstrap.Tooltip(this); });
    }

    function syncCheckboxes(dropdown, entityTags) {
        var assignedIds = {};

        for (var i = 0; i < entityTags.length; i++) {
            assignedIds[entityTags[i].tagId] = true;
        }

        dropdown.find(".tag-dropdown__item:not(.tag-dropdown__item--disabled) input[type=checkbox]").each(function () {
            var id = parseInt($(this).val());

            $(this).prop("checked", !!assignedIds[id]).prop("disabled", false);
        });
    }

    // Fixed, not absolute: every toggle re-renders the badges and resizes the inline-block wrapper the trigger
    // sits in, which would drag an absolutely positioned panel sideways while the user is still picking tags
    function positionTagDropdown(dropdown, triggerBtn) {
        var rect = triggerBtn[0].getBoundingClientRect();
        var viewportWidth = $(window).width();
        var viewportHeight = $(window).height();
        var spaceBelow = viewportHeight - rect.bottom;

        var css = {
            position: "fixed",
            margin: 0,
            left: Math.max(4, Math.min(rect.left, viewportWidth - dropdown.outerWidth() - 4)) + "px"
        };

        if (spaceBelow < dropdown.outerHeight() && rect.top > spaceBelow) {
            css.top = "auto";
            css.bottom = (viewportHeight - rect.top + 2) + "px";
        }
        else {
            css.top = (rect.bottom + 2) + "px";
            css.bottom = "auto";
        }

        dropdown.css(css);
    }

    function openTagDropdown(triggerBtn, entityId, entityType) {
        closeTagDropdown();

        var dropdown = $('<div class="tag-dropdown"></div>')
            .data("entity-id", entityId)
            .data("entity-type", entityType);

        dropdown.html('<div class="tag-dropdown__search"><input type="text" class="tag-dropdown__search-input" placeholder="Search&hellip;" /></div><div class="tag-dropdown__list"><div class="tag-dropdown__empty">Loading&hellip;</div></div><div class="tag-dropdown__footer"><button type="button" class="btn btn-default tag-dropdown__add-btn"><i class="far fa-plus"></i> Add New Tag</button></div>');

        triggerBtn.closest(".position-relative").append(dropdown);
        activeTagDropdown = dropdown;

        positionTagDropdown(dropdown, triggerBtn);

        $(window).on("scroll.tagdropdown resize.tagdropdown", function () {
            positionTagDropdown(dropdown, triggerBtn);
        });

        dropdown.find(".tag-dropdown__search-input").focus();

        $.get("/settings/tags/entitytagdropdowndata", { entityId: entityId, entityType: entityType }).done(function (result) {
            var tags = (result.tags || []);
            var groups = (result.groups || []);
            var assignedTagIds = result.assignedTagIds || [];
            var listEl = dropdown.find(".tag-dropdown__list");

            if (!result.canCreateTags) {
                dropdown.find(".tag-dropdown__footer").remove();
            }

            dropdown.data("show-change-history", !!result.showChangeHistory);
            dropdown.data("can-create-tags", !!result.canCreateTags);

            if (tags.length === 0) {
                var emptyMsg = result.canCreateTags ? "No tags yet &mdash; create one below" : "No tags yet";
                listEl.html('<div class="tag-dropdown__empty">' + emptyMsg + '</div>');

                return;
            }

            var groupMap = {};

            for (var g = 0; g < groups.length; g++) {
                groupMap[groups[g].id] = groups[g].name;
            }

            tags.sort(function (a, b) {
                return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
            });

            var ungrouped = [];
            var grouped = {};
            var groupOrder = [];

            for (var i = 0; i < tags.length; i++) {
                var tag = tags[i];
                var isSelected = assignedTagIds.indexOf(tag.id) >= 0;
                var isDisabled = !tag.active;

                if (isDisabled && !isSelected) {
                    continue;
                }

                if (tag.tagGroupId && groupMap[tag.tagGroupId]) {
                    if (!grouped[tag.tagGroupId]) {
                        grouped[tag.tagGroupId] = [];
                        groupOrder.push(tag.tagGroupId);
                    }

                    grouped[tag.tagGroupId].push(tag);
                }
                else {
                    ungrouped.push(tag);
                }
            }

            groupOrder.sort(function (a, b) {
                return (groupMap[a] || "").toLowerCase().localeCompare((groupMap[b] || "").toLowerCase());
            });

            function renderTagItem(tag) {
                var isSelected = assignedTagIds.indexOf(tag.id) >= 0;
                var isDisabled = !tag.active;
                var style = "";

                if (tag.color && isValidCssColor(tag.color)) {
                    style = "background-color: " + tag.color + ";";

                    if (isValidCssColor(tag.foregroundColor)) {
                        style += " color: " + tag.foregroundColor + ";";
                    }
                }

                var escapedName = $("<span/>").text(tag.name).html().replace(/"/g, "&quot;").replace(/'/g, "&#39;");
                var disabledClass = isDisabled ? " tag-dropdown__item--disabled" : "";
                var checkedAttr = isSelected ? " checked" : "";
                var disabledAttr = isDisabled ? " disabled" : "";

                return '<label class="tag-dropdown__item' + disabledClass + '" data-tag-name="' + escapedName + '"><input type="checkbox" value="' + tag.id + '"' + checkedAttr + disabledAttr + ' /> <span class="badge rounded-4 label-tag" style="' + style + '">' + escapedName + '</span></label>';
            }

            var itemsHtml = "";
            var renderedCount = 0;

            for (var u = 0; u < ungrouped.length; u++) {
                itemsHtml += renderTagItem(ungrouped[u]);
                renderedCount++;
            }

            for (var gi = 0; gi < groupOrder.length; gi++) {
                var gid = groupOrder[gi];
                var escapedGroupName = $("<span/>").text(groupMap[gid]).html();

                itemsHtml += '<div class="tag-dropdown__group-header">' + escapedGroupName + '</div>';

                for (var ti = 0; ti < grouped[gid].length; ti++) {
                    itemsHtml += renderTagItem(grouped[gid][ti]);
                    renderedCount++;
                }
            }

            if (renderedCount >= 10) {
                $('<div class="tag-dropdown__actions"><a href="#" class="tag-dropdown__select-all">Select All</a><a href="#" class="tag-dropdown__clear-all">Clear All</a></div>').insertBefore(listEl);
            }

            listEl.html(itemsHtml);

            positionTagDropdown(dropdown, triggerBtn);
        }).fail(function () {
            var listEl = dropdown.find(".tag-dropdown__list");

            listEl.html('<div class="tag-dropdown__empty">Failed to load tags</div>');
        });
    }

    $(document).on("click", ".tag-dropdown-trigger", function (e) {
        e.stopPropagation();
        e.preventDefault();

        var btn = $(this);
        var entityId = btn.data("entity-id");
        var entityType = btn.data("entity-type");

        if (activeTagDropdown && activeTagDropdown.data("entity-id") === entityId && activeTagDropdown.data("entity-type") === entityType) {
            closeTagDropdown();

            return;
        }

        openTagDropdown(btn, entityId, entityType);
    });

    $(document).on("click", function (e) {
        if (!activeTagDropdown) {
            return;
        }

        if ($(e.target).closest(".tag-dropdown, .tag-dropdown-trigger, .modal").length) {
            return;
        }

        closeTagDropdown();
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape" && activeTagDropdown) {
            closeTagDropdown();
        }
    });

    $(document).on("input", ".tag-dropdown__search-input", function () {
        var query = $(this).val().toLowerCase();
        var dropdown = $(this).closest(".tag-dropdown");

        dropdown.find(".tag-dropdown__item").each(function () {
            var name = ($(this).attr("data-tag-name") || "").toLowerCase();

            if (name.indexOf(query) >= 0) {
                $(this).removeClass("tag-dropdown__item--hidden");
            }
            else {
                $(this).addClass("tag-dropdown__item--hidden");
            }
        });

        dropdown.find(".tag-dropdown__group-header").each(function () {
            var header = $(this);
            var hasVisible = header.nextUntil(".tag-dropdown__group-header").filter(".tag-dropdown__item:not(.tag-dropdown__item--hidden)").length > 0;

            header.toggle(hasVisible);
        });

        var visible = dropdown.find(".tag-dropdown__item:not(.tag-dropdown__item--hidden)").length;
        var listEl = dropdown.find(".tag-dropdown__list");
        var emptyMsg = listEl.find(".tag-dropdown__empty");

        if (visible === 0) {
            var totalItems = dropdown.find(".tag-dropdown__item").length;
            var canCreate = !!dropdown.data("can-create-tags");
            var msg = totalItems > 0 ? "No tags found" : (canCreate ? "No tags yet &mdash; create one below" : "No tags yet");

            if (!emptyMsg.length) {
                listEl.append('<div class="tag-dropdown__empty">' + msg + '</div>');
            }
            else {
                emptyMsg.html(msg).show();
            }
        }
        else {
            emptyMsg.remove();
        }
    });

    $(document).on("change", ".tag-dropdown__item input[type=checkbox]", function () {
        var checkbox = $(this);
        var tagId = parseInt(checkbox.val());
        var selected = checkbox.is(":checked");
        var dropdown = checkbox.closest(".tag-dropdown");
        var entityId = dropdown.data("entity-id");
        var entityType = dropdown.data("entity-type");

        checkbox.prop("disabled", true);

        $.post("/settings/tags/entitytagtoggle", {
            entityId: entityId,
            entityType: entityType,
            tagId: tagId,
            selected: selected
        }).done(function (result) {
            if (result.success) {
                updateTagBadges(entityId, entityType, result.entityTags, result.showChangeHistory);
            }

            checkbox.prop("disabled", false);
        }).fail(function () {
            checkbox.prop("checked", !selected);
            checkbox.prop("disabled", false);
        });
    });

    $(document).on("click", ".tag-dropdown__select-all", function (e) {
        e.preventDefault();

        var dropdown = $(this).closest(".tag-dropdown");
        var entityId = dropdown.data("entity-id");
        var entityType = dropdown.data("entity-type");
        var tagIds = [];

        dropdown.find(".tag-dropdown__item input[type=checkbox]").each(function () {
            var item = $(this).closest(".tag-dropdown__item");
            var isHidden = item.hasClass("tag-dropdown__item--hidden");
            var isDisabled = item.hasClass("tag-dropdown__item--disabled");

            if ((!isHidden && !isDisabled) || $(this).is(":checked")) {
                tagIds.push(parseInt($(this).val()));
            }
        });

        dropdown.find(".tag-dropdown__item input[type=checkbox]:not(:disabled)").prop("disabled", true);

        $.ajax({
            url: "/settings/tags/entitytagsetall",
            type: "POST",
            data: { entityId: entityId, entityType: entityType, tagIds: tagIds },
            traditional: true
        }).done(function (result) {
            if (result.success) {
                updateTagBadges(entityId, entityType, result.entityTags, result.showChangeHistory);
                syncCheckboxes(dropdown, result.entityTags);
            }
        }).fail(function () {
            dropdown.find(".tag-dropdown__item:not(.tag-dropdown__item--disabled) input[type=checkbox]").prop("disabled", false);
        });
    });

    $(document).on("click", ".tag-dropdown__clear-all", function (e) {
        e.preventDefault();

        var dropdown = $(this).closest(".tag-dropdown");
        var entityId = dropdown.data("entity-id");
        var entityType = dropdown.data("entity-type");

        dropdown.find(".tag-dropdown__item input[type=checkbox]:not(:disabled)").prop("disabled", true);

        var keepTagIds = [];

        dropdown.find(".tag-dropdown__item--disabled input[type=checkbox]:checked").each(function () {
            keepTagIds.push(parseInt($(this).val()));
        });

        $.ajax({
            url: "/settings/tags/entitytagsetall",
            type: "POST",
            data: { entityId: entityId, entityType: entityType, tagIds: keepTagIds },
            traditional: true
        }).done(function (result) {
            if (result.success) {
                updateTagBadges(entityId, entityType, result.entityTags, result.showChangeHistory);
                syncCheckboxes(dropdown, result.entityTags);
            }
        }).fail(function () {
            dropdown.find(".tag-dropdown__item:not(.tag-dropdown__item--disabled) input[type=checkbox]").prop("disabled", false);
        });
    });

    $(document).on("click", ".tag-dropdown__add-btn", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var dropdown = $(this).closest(".tag-dropdown");
        var entityId = dropdown.data("entity-id");
        var entityType = dropdown.data("entity-type");
        var triggerBtn = dropdown.parent().find(".tag-dropdown-trigger");

        var url = "/settings/tags/edit?entityId=" + entityId + "&entityType=" + entityType + "&embedded=true";

        $.showModal(url, function (data) {
            if (data.success) {
                updateTagBadges(entityId, entityType, data.entityTags, data.showChangeHistory);

                openTagDropdown(triggerBtn, entityId, entityType);
            }
        });
    });


    if ($(".griddly.dynamodb").length) {
        var pageTokens = ['{}', $(".griddly.dynamodb").attr("data-dynamodb-first-page-token")];
        var setPageToken = false;

        $.ajaxSetup({
            complete: function (xhr) {
                if (xhr.getResponseHeader("OR-PaginationToken") && setPageToken) {
                    pageTokens.push(xhr.getResponseHeader("OR-PaginationToken"));
                    setPageToken = false;
                    $(".griddly.dynamodb").griddly("setAdditionalRequestValues", {});
                }
            }
        });

        $(".griddly.dynamodb a.next").on("mousedown", function () {
            $(".griddly.dynamodb").griddly("setAdditionalRequestValues", { "pageToken": pageTokens[pageTokens.length - 1] });
            setPageToken = true;
        });

        $(".griddly.dynamodb a.prev").on("mousedown", function () {
            pageTokens.pop(); // next page
            pageTokens.pop(); // current page
            $(".griddly.dynamodb").griddly("setAdditionalRequestValues", { "pageToken": pageTokens[pageTokens.length - 1] });
            setPageToken = true;
        });

        $(".griddly.dynamodb").on("refresh.griddly", function (e, data) {
            if (data.start == 0) {
                // back on the first page (e.g. filter or page size changed)
                pageTokens = ['{}'];
                setPageToken = true;
            }
        });
    }
});

function register_checkbox_shiftkey_event() {
    $("#property-list, .checkbox-list, .batch-results .table-results").each(function () {
        var isBatchResults = $(this).is(".batch-results .table-results");
        var $chkboxes = $(':checkbox', this);
        var lastChecked;

        var target = isBatchResults ? ":checkbox" : ".checkbox";

        $(this).on("mousedown", target, function (e) {
            var thisChk = isBatchResults ? $(this).get(0) : $(this).find(":checkbox").get(0);

            // if we're about to check some stuff, deselect the text selection caused by holding down the shift key
            if (e.shiftKey && thisChk != lastChecked) {
                var sel = document.getSelection();

                sel.removeAllRanges();
            }
        });

        $(this).on("click", target, function (e) {
            var thisChk = isBatchResults ? $(this).get(0) : $(this).find(":checkbox").get(0);

            if (!lastChecked) {
                lastChecked = thisChk;

                return;
            }

            if (e.shiftKey && thisChk != lastChecked) {
                var start = $chkboxes.index(thisChk);
                var end = $chkboxes.index(lastChecked);
                var checked = lastChecked.checked;

                setTimeout(function () {
                    var toChange = $chkboxes.slice(Math.min(start, end), Math.max(start, end));
                    toChange.prop('checked', checked);
                    toChange.change();
                }, 10);
            }

            lastChecked = thisChk;
        });
    });
}

$(function () 
{
    var toggleEditorOptions = function ()
    {
        var formGroup = $(this).closest(".form-group");
        var parent = $(this).is("select") ? $(this) : $(this).closest(".radio, .radio-inline, .checkbox, .checkbox-inline");
        var relatedCustom = parent.next(".included-custom");

        var hide = (parent.is(".checkbox, .checkbox-inline") && !$(this).prop("checked"))
            || (parent.is("select") && !$("option:selected", parent).data("show-custom"));

        // reset everything
        formGroup.find(".included-custom")
            .hide()
            .find(":input")
            .prop("disabled", true);

        formGroup.find('.included-custom')
            .find('.checkbox, .radio, .btn')
            .addClass('disabled');

        formGroup.find(".selected")
            .removeClass("selected");

        // show the related custom
        parent.toggleClass("selected", !hide);

        if (parent.is("select"))
        {
            $("option[data-show-custom=true]", parent).each(function ()
            {
                var text = $(this).text().replace("... (select to enter)", "");

                if (!$(this).is(":selected"))
                    $(this).text(text + "... (select to enter)");
                else
                    $(this).text(text);
            });
        }

        relatedCustom.toggle(!hide)
            .find(":input")
            .prop("disabled", hide);

        relatedCustom
            .find('.checkbox, .radio, .btn')
            .toggleClass('disabled', hide);

        if (relatedCustom.length && !hide)
        {
            relatedCustom.find(":input:first").focus();
        }
    };

    $("body").on("change click", ":radio.has-editor-option, :checkbox.has-editor-option", toggleEditorOptions);
    $("body").on("change", "select.has-editor-option", toggleEditorOptions);

    register_checkbox_shiftkey_event();

    

    if ($(".batch-results").length)
    {
        if ($(".batch-results #results").length)
            self.location.href = "#results";

        $(".batch-results .table-results :checkbox").on("change", function ()
        {
            $(this).closest("tr").toggleClass("excluded", !$(this).prop("checked"));
        });

        $(".batch-results").prev("form").on("submit", function ()
        {
            $(".batch-results").hide();
        });
    }

    var sidebar = $(".nav-sidebar .active").get(0);

    if (sidebar)
        sidebar.scrollIntoView({ block: "center" });
});

function loadAllScripts(scriptSrcs) {
    scriptSrcs = scriptSrcs || [];
    var scriptCount = scriptSrcs.length;
    var hasErrored = false;
    return new Promise(function(res, rej) {
        for(var i = 0; i < scriptSrcs.length; ++i) {
            var src = scriptSrcs[i]
            var script = document.createElement("script");
            script.src =  src;
            script.onload = function() {
                scriptCount--;
                if(!hasErrored && scriptCount === 0)
                    res();
            }
            script.onerror = function() { 
                hasErrored = true; 
                rej("At least one script failed to load: " + src);
            }
            document.head.appendChild(script);
        }
    });
}

var loadLogViewerDependencies = (function() {
    var logViewerDependenciesPromise = null;
    return function() {
        if (logViewerDependenciesPromise != null)
            return logViewerDependenciesPromise;

        logViewerDependenciesPromise = loadAllScripts([
            '/content-nonversioned/jscript/vkbeautify.js',
            '/content-nonversioned/jscript/ace-src-min-noconflict_1.4.13/ace.js'
        ]);
        return logViewerDependenciesPromise;
    }
})();

function initializeEditor(jqIndex, element, ignoreAceOptions, ignoreBottomOptions)
{
    var scriptPromise = loadLogViewerDependencies();

    var that = this;
    return scriptPromise.then(function() {
        var textarea = $(element == null ? that : element);
        var mode = textarea.data('editor');
        var editDiv = $('<div>', {
            position: 'absolute',
            left: 0,
            right: 0,
            height: textarea.height(),
            'class': textarea.attr('class')
        }).insertBefore(textarea);

        textarea.css({
            position: 'absolute',
            left: '-9999px'
        });

        var aceOptions = ignoreAceOptions 
            ? undefined 
            : {
                maxLines: 20,
                behavioursEnabled: true,
                wrapBehavioursEnabled: true,
                wrap: true
            };
        var editor = ace.edit(editDiv[0], aceOptions);
        editor.renderer.setShowGutter(true);
        editor.setShowPrintMargin(false);
        //editor.getSession().setValue(textarea.val());
        editor.getSession().setMode("ace/mode/" + mode);
        textarea[0].editor = editor;
        // editor.setTheme("ace/theme/idle_fingers");

        if(!ignoreBottomOptions)
        {
            if (mode == "xml" || mode == "json")
                editor.setValue(vkbeautify[mode](textarea[0].value, 2));
            else
                editor.setValue(textarea[0].value);

            editor.clearSelection();
            editor.setReadOnly(true);

        }

        return editor;
    });
}

function initializeLogViewer(parent, loadUrl, loadFileUrl)
{
    var scriptPromise = loadLogViewerDependencies();

    var editors = [];

    parent.on("click", "a.toggle-log-entry", function (e)
    {
        e.preventDefault();

        $(this).find(".fa-caret-right, .fa-caret-down").toggleClass("fa-caret-right fa-caret-down");

        var detail = $(this).next(".log-entry-json");
        detail.toggle();

        if (!$(".panel-collapse.in", detail).length)
            $(".panel-collapse:first", detail).collapse("toggle");

        return false;
    });

    parent.on("show.bs.collapse", ".related-files [data-filename]", function (e)
    {
        var panel = $(this);
        if (!panel.data("loaded"))
        {
            scriptPromise
                .then(_ => $.get(loadFileUrl, { filename: panel.data("filename") }))
                .then(function(result)
                {
                    panel.data("loaded", true);
                    panel.find(".panel-body").html(result);

                    var promises = Array.from(panel.find(".panel-body").find("textarea[data-editor]").map(initializeEditor));
                    Promise
                        .all(promises)
                        .then(function(wrappedEditors) { editors = editors.concat(wrappedEditors) });
                });
        }
    });

    parent.on("change", "[name^='show-raw-']", function ()
    {
        var name = $(this).attr("name");
        var group = $(this).closest(".btn-group");
        var textarea = group.nextAll("textarea");

        scriptPromise.then(function() {
            if ($(`[name='${name}']:checked`, group).val() == "true" && textarea.length > 0)
            {
                if(textarea[0].editor !== null)
                    textarea[0].editor.destroy();
                
                textarea[0].editor = null;
                textarea.css({ position: "relative", left: "0", height: "200px" });
                group.nextAll(".ace_editor").remove();
            }
            else if (textarea.length && (!textarea[0].hasOwnProperty("editor") || textarea[0].editor == null))
            {
                var promises = Array.from(textarea.map(initializeEditor));
                Promise.all(promises)
                    .then(function(wrappedEditors) { editors = editors.concat(wrappedEditors)});
            }
        })
    });

    return {
        load: function ()
        {
            scriptPromise
                .then(function() {
                    return $.get(loadUrl, function(result)  {
                        parent.data("loaded", true);

                        parent.html(result);

                        var initialPromises = Array.from($("textarea[data-editor]", parent).map(initializeEditor));
                        Promise.all(initialPromises)
                            .then(function (newEditors) { editors = editors.concat(newEditors) });

                        $("#log-accordion [data-filename]").on("show.bs.collapse", function () {
                            var panel = $(this);
                            if (!panel.data("loaded")) {
                                $.get(loadFileUrl, {filename: panel.data("filename")})
                                    .then(function(result) {
                                        panel.data("loaded", true);

                                        panel.find(".panel-body").html(result);
                                        var promises = Array.from(panel.find(".panel-body").find("textarea[data-editor]").map(initializeEditor));
                                        return Promise.all(promises);
                                    })
                                    .then(function(newEditors) { editors = editors.concat(newEditors) });
                            }
                        });
                    })
                })
                .catch(function(err) { console.error("Unable to load editors.", err) });
        },
        unload: function () {
            parent.off('click', 'a.toggle-log-entry');
            parent.off('show.bs.collaps', '.related-files [data-filename]');
            parent.off('change', "[name^='show-raw-']");
            jQuery.each(editors, function (i, editor) { editor.destroy(); });
        }
    };
}
    
function pageSearch(filterContainer, updateMatches, searchCallback)
{
    var input = $(".filter-search", filterContainer);
    var clear = $(".filter-search-clear", filterContainer);
    var matchCount = $(".filter-match-count", filterContainer);

    var timeout;

    input.on("keyup", function ()
    {
        clearTimeout(timeout);

        timeout = setTimeout(search, 200);
    });

    clear.on("click", function ()
    {
        input.val("");
        search();

        return false;
    });

    function search(force = false)
    {
        var search = input.val();

        filterContainer.toggleClass("filtered", !!search);

        if (force || search !== input.data("last-search"))
        {
            input.data("last-search", search);

            if (searchCallback)
            {
                searchCallback(search, function ()
                {
                    highlightMatches(search);
                });
            }
            else
            {
                highlightMatches(search);
            }
        }
    }

    function highlightMatches(search)
    {
        if (!search)
            search = $(".filter-search", filterContainer).val();

        if (search)
        {
            var reg = new RegExp(search, "i");

            var matches = $(".filter-item", filterContainer).filter((index, el) => reg.test(el.innerText) || reg.test(el.dataset.fieldNames));

            matchCount.text(matches.length);

            $(".matched", filterContainer).removeClass("matched");

            matches.closest(".filter-group").addClass("matched");
            matches.closest(".filter-highlight").addClass("matched");

            if (updateMatches)
                updateMatches(matches);
        }
    }

    return {
        highlightMatches,
        search
    };
}

$("select[name*=Country]").on("blur", function ()
{
    $(this).data("user-set", true);
});

function register_search_events(searchFormId) {
    $(document).on("change", `#${searchFormId} select`, function () {
        $(`#${searchFormId}`).submit();
    });

    $(document).on("submit", `#${searchFormId}`, function (e) {
        e.preventDefault();

        if ($(`#${searchFormId} input[name=q]`).val()) {
            $(this).addClass("has-search-terms");

            var searchResult = $(`#${searchFormId}`).parents('header').siblings('.search-results');
            
            searchResult.html("<div class='text-center' style='margin-top:30px'><i class='fa fa-spin fa-cog fa-4x'></i></div>");

            var search = $(this).serialize();

            $.ajax({
                type: "get",
                url: "/search/go",
                data: search,
                success: function (result, status, xhr) {
                    var redirect = xhr.getResponseHeader('X-OR-Location');

                    if (redirect) {
                        searchResult.html("Redirecting...");
                        location = redirect;
                    }
                    else {
                        searchResult.html(result);
                    }
                }
            });
        }
        else {
            $(this).removeClass("has-search-terms");
        }

        return false;
    });
}

register_search_events("search-form");
register_search_events("search-form-sidebar");

$(".griddly").on("change", ".modal-footer input[name=saveFilter]", function ()
{
    var btn = $(this).closest(".modal-footer").find(":submit");

    if ($(this).prop("checked"))
        btn.text("Save & Apply");
    else
        btn.text("Apply");
});

$(".griddly").on("click", ".griddly-search-delete", function ()
{
    var grid = $(this).closest(".griddly");

    $.post("/account/deletefilter", { gridId: $(this).data("filter-id") })
        .success(function ()
        {
            var cookies = document.cookie.split(';');

            for (var i = 0; i < cookies.length; i++)
            {
                var name = cookies[i].split('=')[0];

                if (name.substring(0, 3) == "gf_")
                {
                    removeCookie(name, location.pathname, location.hostname);
                }
            }
            
            location.href = location.href;
        })
        .fail(function ()
        {
            alert("Unable to delete your filter!");
        });
});

$(document).on("click", ".btn-switch input", function (e)
{
    e.preventDefault();

    var a = $(this).closest(".btn-switch").find("a");

    if (a.is(".or-showmodal-url"))
        OrShowModalUrl.call(a, e);
    else
        a.click();

    return false;
});

// Copy Link functionality for grids
function initializeCopyLinkForGrid($grid) {
    // Add the copy link button to the grid's filter area
    $grid.find(".griddly-filters").append('<a style="margin-left:5px; padding:4px; cursor: pointer; display:none;" class="admin-only-btn btn-copy-link btn-xm"> <i class="fa fa-copy"></i> Copy Link</a>');
    
    // Initialize clipboard functionality
    var clipboard = new Clipboard($grid.find('.btn-copy-link')[0], {
        text: function () {
            const values = $grid.griddly("getFilterValues");
            const url = buildUrlWithGriddlyFilters(values);
            return url.href;
        }
    });

    clipboard.on('success', function (e) {
        showAlertConfirmation('Link Copied!');
    });

    // Toggle button visibility based on filter status
    toggleCopyButton($grid);

    // Update button visibility when grid refreshes
    $grid.on("refresh.griddly", function (e) {
        toggleCopyButton($grid);
    });
}

function toggleCopyButton($grid) {
    var hasFilter = $grid.hasClass("griddly-filter-statusfiltered");
    $grid.find(".btn-copy-link").toggle(hasFilter);
}

function buildUrlWithGriddlyFilters(data) {
    const url = new URL(window.location);
    const params = new URLSearchParams();
    
    // For bookings view, add view=list parameter
    if (url.pathname.includes('/bookings/')) {
        params.append('view', 'list');
    }

    // For outbound webhooks, include tab parameter if not default
    if (url.pathname.includes('/outboundwebhooks')) {
        const tabParam = url.searchParams.get('tab');
        if (tabParam && tabParam !== 'failed') {
            params.append('tab', tabParam);
        }
    }

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {
                params.append(key, !item ? "" : item);
            });
        } else {
            if (!value) return;
            params.append(key, !value ? "" : value);
        }
    });

    return new URL(`${url.origin}${url.pathname}?${params.toString()}`);
}

(function () {
    var scrollBarWidths = 40;
    var $wrapper = $('.nav-scroller');
    var $list = $wrapper.find('.custom-tabs');
    var $scrollerLeft = $('.scroller-left');
    var $scrollerRight = $('.scroller-right');

    if (!$wrapper.length || !$list.length || !$scrollerLeft.length || !$scrollerRight.length) {
        return;
    }

    if (!$list.css('left') || $list.css('left') === 'auto') {
        $list.css('left', '0px');
    }

    function widthOfList() {
        var sum = 0;
        $list.find('li').each(function () {
            sum += $(this).outerWidth(true);
        });
        return sum;
    }

    function getLeftPosi() {
        return parseFloat($list.css('left')) || 0;
    }

    function maxScrollable() {
        return Math.max(0, widthOfList() - $wrapper[0].clientWidth + scrollBarWidths);
    }

    var rafId = null;
    function animateLeft(target, duration) {
        if (rafId) {
            cancelAnimationFrame(rafId);
        }

        var start = performance.now();
        var from = getLeftPosi();
        var diff = target - from;

        function step(now) {
            var elapsed = now - start;
            var t = Math.min(1, duration === 0 ? 1 : elapsed / duration);
            var eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            var value = from + diff * eased;
            $list.css('left', Math.round(value) + 'px');
            if (t < 1) {
                rafId = requestAnimationFrame(step);
            } else {
                $list.css('left', Math.round(target) + 'px');
                rafId = null;
                reAdjust();
            }
        }

        rafId = requestAnimationFrame(step);
    }

    function reAdjust() {
        var listWidth = widthOfList();
        var wrapWidth = $wrapper[0].clientWidth;
        var leftPos = getLeftPosi();
        var maxScroll = maxScrollable();

        if (wrapWidth < listWidth) {
            $scrollerRight.toggle(leftPos > (-maxScroll + 1));
        } else {
            $scrollerRight.hide();
            if (leftPos < 0) {
                animateLeft(0, 300);
            }
        }

        $scrollerLeft.toggle(leftPos < 0);
    }

    function scrollToActiveTab() {
        var $activeTab = $list.find('li.active').length ? $list.find('li.active') : $list.find('.nav-link.active').closest('li');
        if (!$activeTab.length) {
            return;
        }

        var $items = $list.find('li');
        var activeIndex = $items.index($activeTab);
        if (activeIndex === -1) {
            return;
        }

        var activeLeft = 0;
        $items.slice(0, activeIndex).each(function () {
            activeLeft += $(this).outerWidth(true);
        });

        var activeWidth = $activeTab.outerWidth(true);
        var wrapWidth = $wrapper[0].clientWidth;
        var currentLeft = getLeftPosi();
        var visibleWidth = wrapWidth - scrollBarWidths;
        var visibleLeft = -currentLeft;
        var visibleRight = visibleLeft + visibleWidth;
        var activeRight = activeLeft + activeWidth;

        if (activeLeft >= visibleLeft && activeRight <= visibleRight) {
            return;
        }

        var targetLeft = activeLeft < visibleLeft ? -activeLeft : -(activeRight - visibleWidth);
        targetLeft = Math.max(-maxScrollable(), Math.min(0, Math.round(targetLeft)));
        
        if (Math.abs(targetLeft - currentLeft) > 1) {
            $list.css('left', targetLeft + 'px');
            reAdjust();
        }
    }

    reAdjust();
    
    requestAnimationFrame(function() {
        requestAnimationFrame(scrollToActiveTab);
    });

    var resizeTimer = null;
    $(window).on('resize', function() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(reAdjust, 100);
    });

    window.ownerrez_menu_reAdjust = reAdjust;

    function scroll(direction) {
        var current = getLeftPosi();
        var page = Math.max(100, $wrapper[0].clientWidth - scrollBarWidths);
        var max = maxScrollable();
        var target = direction === 'right' 
            ? Math.trunc(Math.max(current - page, -max))
            : Math.trunc(Math.min(current + page, 0));

        if (target === current) {
            if (direction === 'right') {
                $scrollerRight.hide();
            } else {
                $scrollerLeft.hide();
            }
            return;
        }

        $scrollerLeft.toggle(target < 0);
        $scrollerRight.toggle(target > -max);
        animateLeft(target, 400);
    }

    $scrollerRight.on('click', function () {
        scroll('right');
    });

    $scrollerLeft.on('click', function () {
        scroll('left');
    });

    $list.on('keydown', function (e) {
        if (e.key === 'ArrowRight') {
            $scrollerRight.trigger('click');
        } else if (e.key === 'ArrowLeft') {
            $scrollerLeft.trigger('click');
        }
    });
})();
function isColorTooLight(rgbString)
{
    if (!rgbString) return false;

    // Try rgb/rgba first
    var matches = rgbString.match(/\d+/g);
    if (matches && matches.length >= 3)
    {
        const r = Number(matches[0]);
        const g = Number(matches[1]);
        const b = Number(matches[2]);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 180;
    }

    // Try hex (#rgb or #rrggbb)
    if (rgbString.charAt(0) === '#')
    {
        var hex = rgbString.substring(1);
        if (hex.length === 3) hex = hex.split('').map(function(x){ return x + x; }).join('');
        if (hex.length === 6)
        {
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 180;
        }
    }

    // Unknown format; do not force a color change
    return false;
}

class AjaxQueue {
    constructor(id, debounceTime) {
        this.entityId = id;
        this.storage = [];
        this.isProcessing = false;
        if (debounceTime)
            this.debounceTime = debounceTime;
        else
            this.debounceTime = 250;
        this.debounceTimeout;
    }

    enqueue(item) {
        $(`#${item.spinner}`).fadeIn(250); // start spinner, debounce will delay actual api call so flashing not an issue
        this.storage.push(item);
        this.process();
    }

    dequeueBatch() {
        if (this.isEmpty()) {
            return undefined;
        }

        const currentItems = [...this.storage];
        this.storage = [];
        return currentItems;
    }

    isEmpty() {
        return this.storage.length === 0;
    }

    process() {
        const processItems = () => {
            const items = this.dequeueBatch();
            if (items && items.length > 0) {
                const options = {
                    method: items[0].method,
                    data: {
                        id: this.entityId,
                        features: items.map((item) => item.feature)
                    }
                };

                $.executeAjaxCall({
                    ajax: $.ajax(items[0].action, options),
                    success: () => items.forEach((item) => { if (item.success) item.success() }),
                    error: () => items.forEach((item) => { if (item.fail) item.fail() }),
                    complete: () => {
                        const itemFound = processItems();
                        this.isProcessing = itemFound;
                    },
                    spinner: items.filter(item => item.spinner).map((item) => `#${item.spinner}`),
                    allowMultipleSpinners: true
                });
                return true;
            } else {
                return false;
            }
        };

        clearTimeout(this.debounceTimeout);

        this.debounceTimeout = setTimeout(() => {
            if (!this.isProcessing) {
                this.isProcessing = true;
                const itemFound = processItems();
                this.isProcessing = itemFound;
            }
        }, this.debounceTime);
    }
}

window.WebAuthnHelpers = {
    base64UrlToBuffer: function (b64) {
        var s = b64.replace(/-/g, '+').replace(/_/g, '/');
        while (s.length % 4 !== 0) s += '=';
        var bin = atob(s);
        var buf = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
        return buf.buffer;
    },
    bufferToBase64Url: function (buf) {
        var bytes = new Uint8Array(buf);
        var bin = '';
        for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
        return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }
};

(function () {
    var scrollBarWidths = 40;
    var $wrapper = $('.nav-scroller');
    var $list = $wrapper.find('.custom-tabs');
    var $scrollerLeft = $('.scroller-left');
    var $scrollerRight = $('.scroller-right');

    if (!$wrapper.length || !$list.length || !$scrollerLeft.length || !$scrollerRight.length) {
        return;
    }

    if (!$list.css('left') || $list.css('left') === 'auto') {
        $list.css('left', '0px');
    }

    function widthOfList() {
        var sum = 0;
        $list.find('li').each(function () {
            sum += $(this).outerWidth(true);
        });
        return sum;
    }

    function getLeftPosi() {
        return parseFloat($list.css('left')) || 0;
    }

    function maxScrollable() {
        return Math.max(0, widthOfList() - $wrapper[0].clientWidth + scrollBarWidths);
    }

    var rafId = null;
    function animateLeft(target, duration) {
        if (rafId) {
            cancelAnimationFrame(rafId);
        }

        var start = performance.now();
        var from = getLeftPosi();
        var diff = target - from;

        function step(now) {
            var elapsed = now - start;
            var t = Math.min(1, duration === 0 ? 1 : elapsed / duration);
            var eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            var value = from + diff * eased;
            $list.css('left', Math.round(value) + 'px');
            if (t < 1) {
                rafId = requestAnimationFrame(step);
            } else {
                $list.css('left', Math.round(target) + 'px');
                rafId = null;
                reAdjust();
            }
        }

        rafId = requestAnimationFrame(step);
    }

    function reAdjust() {
        var listWidth = widthOfList();
        var wrapWidth = $wrapper[0].clientWidth;
        var leftPos = getLeftPosi();
        var maxScroll = maxScrollable();

        if (wrapWidth < listWidth) {
            $scrollerRight.toggle(leftPos > (-maxScroll + 1));
        } else {
            $scrollerRight.hide();
            if (leftPos < 0) {
                animateLeft(0, 300);
            }
        }

        $scrollerLeft.toggle(leftPos < 0);
    }

    function scrollToActiveTab() {
        var $activeTab = $list.find('li.active').length ? $list.find('li.active') : $list.find('.nav-link.active').closest('li');
        if (!$activeTab.length) {
            return;
        }

        var $items = $list.find('li');
        var activeIndex = $items.index($activeTab);
        if (activeIndex === -1) {
            return;
        }

        var activeLeft = 0;
        $items.slice(0, activeIndex).each(function () {
            activeLeft += $(this).outerWidth(true);
        });

        var activeWidth = $activeTab.outerWidth(true);
        var wrapWidth = $wrapper[0].clientWidth;
        var currentLeft = getLeftPosi();
        var visibleWidth = wrapWidth - scrollBarWidths;
        var visibleLeft = -currentLeft;
        var visibleRight = visibleLeft + visibleWidth;
        var activeRight = activeLeft + activeWidth;

        if (activeLeft >= visibleLeft && activeRight <= visibleRight) {
            return;
        }

        var targetLeft = activeLeft < visibleLeft ? -activeLeft : -(activeRight - visibleWidth);
        targetLeft = Math.max(-maxScrollable(), Math.min(0, Math.round(targetLeft)));

        if (Math.abs(targetLeft - currentLeft) > 1) {
            $list.css('left', targetLeft + 'px');
            reAdjust();
        }
    }

    reAdjust();

    requestAnimationFrame(function() {
        requestAnimationFrame(scrollToActiveTab);
    });

    var resizeTimer = null;
    $(window).on('resize', function() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(reAdjust, 100);
    });

    window.ownerrez_menu_reAdjust = reAdjust;

    function scroll(direction) {
        var current = getLeftPosi();
        var page = Math.max(100, $wrapper[0].clientWidth - scrollBarWidths);
        var max = maxScrollable();
        var target = direction === 'right'
            ? Math.trunc(Math.max(current - page, -max))
            : Math.trunc(Math.min(current + page, 0));

        if (target === current) {
            if (direction === 'right') {
                $scrollerRight.hide();
            } else {
                $scrollerLeft.hide();
            }
            return;
        }

        $scrollerLeft.toggle(target < 0);
        $scrollerRight.toggle(target > -max);
        animateLeft(target, 400);
    }

    $scrollerRight.on('click', function () {
        scroll('right');
    });

    $scrollerLeft.on('click', function () {
        scroll('left');
    });

    $list.on('keydown', function (e) {
        if (e.key === 'ArrowRight') {
            $scrollerRight.trigger('click');
        } else if (e.key === 'ArrowLeft') {
            $scrollerLeft.trigger('click');
        }
    });
})();

// Announcements
function updateAnnouncementBadge() {
    const listGroupItems = $(".sidebar-util-announcements .list-group-item:not([hidden])").length;
    const dynamicItems = $(".sidebar-util-announcements [data-announcement-pwa]:not([hidden]), .sidebar-util-announcements [data-announcement-subscribe]:not([hidden])").length;
    const remainingAlerts = listGroupItems + dynamicItems;
    const badge = $("#announcements-fly-out .badge");

    if (remainingAlerts === 0) {
        badge.remove();
        $('#announcement-preview').attr('hidden', true);
    } else {
        $('#announcement-preview').removeAttr('hidden');

        if (badge.length === 0) {
            $('#announcements-fly-out').append('<span class="badge badge-important rounded-pill label-info text-bg-info"></span>');
        }

        const updatedBadge = $("#announcements-fly-out .badge");
        updatedBadge.text(remainingAlerts);

        let badgeClasses = 'label-info text-bg-info';
        if ($(".sidebar-util-announcements .list-group-item:not([hidden]) .text-danger").length > 0) {
            badgeClasses = 'label-danger text-bg-danger';
        } else if ($(".sidebar-util-announcements .list-group-item:not([hidden]) .text-warning").length > 0) {
            badgeClasses = 'label-warning text-bg-warning';
        }
        updatedBadge.removeClass('label-danger label-warning label-info label-success text-bg-danger text-bg-warning text-bg-info text-bg-success').addClass(badgeClasses);
    }
}

$(".alert-dismiss").on("click", function () {
    const btn = $(this);
    btn.html('<i class="far fa-spinner fa-spin"></i>');
    btn.addClass('text-muted');
    btn.trigger('blur');

    const alertId = btn.data("alert-id");

    $.ajax({
        method: "POST",
        url: BaseUrl + "/MarkAlertRead?id=" + alertId,
        contentType: "application/json; charset=utf-8"
    })
    .done(() => {
        // Remove from main body area (scoped to avoid removing from sidebar)
        $("#alerts-container #alert-container-" + alertId).remove();
        if ($("#alerts-container").children().length === 0) {
            $("#alerts-container").remove();
        }

        // Remove from sidebar
        $("#sidebar-alert-" + alertId).remove();

        // Remove from carousels
        const carouselItem = $(".carousel-item[data-alert-id='" + alertId + "']");
        if (carouselItem.length) {
            const carousel = carouselItem.closest('.carousel');
            const wasActive = carouselItem.hasClass('active');
            carouselItem.remove();

            const remainingItems = carousel.find('.carousel-item');
            if (wasActive && remainingItems.length > 0) {
                remainingItems.first().addClass('active');
            }

            if (remainingItems.length === 0) {
                carousel.hide();
            }
        }

        updateAnnouncementBadge();
    })
    .fail(() => {
        btn.html('<i class="far fa-xmark"></i>');
        btn.removeClass('text-muted');
        btn.off('blur');
    });
});

$(".alert-modal").on("shown.bs.modal", function () {
    $(this).find(".btn-success").focus();
});

// Allow links inside carousels to work normally
$(".announcement-link").on("click", function (e) {
    e.stopPropagation();
});

// Handle Body-based "Read More" links - open sidebar then show modal
$(".announcement-body-link").on("click", function () {
    const alertId = $(this).data("alert-id");
    const modal = $("#alert-modal-" + alertId);

    if (modal.length) {
        $(document.body).trigger("sidebar-right", ["announcements"]);
        setTimeout(() => modal.modal("show"), 300);
    } else {
        $(document.body).trigger("sidebar-right", ["announcements"]);
    }
});

$('[data-announcement-pwa] .announcement-link, [data-announcement-subscribe] .announcement-link').on('click', function (e) {
    e.stopPropagation();
});

// Dynamic announcement banners (PWA Install + Push Subscribe)
function showDynamicAnnouncement(type) {
    const items = $(`[data-announcement-${type}]`);
    items.removeAttr('hidden');

    // Only apply carousel classes to items inside a carousel
    const carouselItems = items.filter((_, el) => $(el).closest('.carousel-inner').length);
    carouselItems.addClass('carousel-item');

    carouselItems.closest('.carousel-inner').each(function () {
        if ($(this).find('.carousel-item.active').length === 0) {
            $(this).find('.carousel-item').first().addClass('active');
        }
    });

    updateAnnouncementBadge();
}

function hideDynamicAnnouncement(type) {
    const items = $(`[data-announcement-${type}]`);

    items.each(function () {
        const item = $(this);
        const carousel = item.closest('.carousel-inner');

        if (carousel.length && item.hasClass('active')) {
            item.removeClass('active');
            const nextItem = carousel.find('.carousel-item').first();
            if (nextItem.length) {
                nextItem.addClass('active');
            }
        }
    });

    items.attr('hidden', true).removeClass('carousel-item');
    updateAnnouncementBadge();
}

var _announcementDismissalKeys = {
    pwa: { localStorage: 'pwa-install-banner-dismissed', cookie: 'pwaBannerDismissed' },
    subscribe: { localStorage: 'subscribe-banner-dismissed', cookie: 'subscribeBannerDismissed' }
};

async function dismissAnnouncementBanner(type) {
    var keys = _announcementDismissalKeys[type];
    localStorage.setItem(keys.localStorage, 'true');
    if (window.cookieStore) {
        await cookieStore.set(keys.cookie, '1');
    }
}

$('[data-pwa-dismiss]').on('click', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    await dismissAnnouncementBanner('pwa');
    hideDynamicAnnouncement('pwa');
});

$('[data-subscribe-dismiss]').on('click', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    await dismissAnnouncementBanner('subscribe');
    hideDynamicAnnouncement('subscribe');
});

$('[data-subscribe-action]').on('click', () => dismissAnnouncementBanner('subscribe'));

// PWA Install Banner
(async () => {
    if (localStorage.getItem(_announcementDismissalKeys.pwa.localStorage)) {
        await dismissAnnouncementBanner('pwa');
        return;
    }

    try {
        let installPrompt = await new Promise((resolve, reject) => {
            let handler = (e) => {
                e.preventDefault();
                clearTimeout(timeoutId);
                window.removeEventListener('beforeinstallprompt', handler);
                resolve(e);
            };

            window.addEventListener('beforeinstallprompt', handler);

            let timeoutId = setTimeout(() => {
                window.removeEventListener('beforeinstallprompt', handler);
                reject(new Error('beforeinstallprompt timed out'));
            }, 30000);
        });

        showDynamicAnnouncement('pwa');
        let promptUsed = false;

        $('[data-pwa-install]').on('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (promptUsed) {
                location.reload();
                return;
            }

            promptUsed = true;
            let result = await installPrompt.prompt();

            if (result.outcome === 'accepted') {
                await dismissAnnouncementBanner('pwa');
                hideDynamicAnnouncement('pwa');
            }
        });
    } catch (e) {
        // beforeinstallprompt not supported or timed out
    }
})();

// Subscribe Banner
(async () => {
    if (localStorage.getItem(_announcementDismissalKeys.subscribe.localStorage)) {
        await dismissAnnouncementBanner('subscribe');
        return;
    }

    try {
        let serviceWorker = await navigator.serviceWorker.ready;
        let subscription = await serviceWorker.pushManager.getSubscription();

        if (subscription != null) {
            await dismissAnnouncementBanner('subscribe');
            return;
        }

        showDynamicAnnouncement('subscribe');
    } catch (e) {
        // Service worker or push not supported
    }
})();

// Syncing an untouched field rewrites its stored E164 from a guessed country, breaking a save nobody touched.
function syncHiddenPhoneFieldsIfEdited(el)
{
    if (jQuery(el).data("phone-edited"))
        syncHiddenPhoneFields(el);
}

function syncHiddenPhoneFields(el)
{
    var input = jQuery(el);
    var iti = input.data("intlTelInput");

    // utils.js loads async and getNumber throws before it resolves. Blanking the fields here instead
    // would make the server reparse the text as US and mangle a foreign number.
    if (!iti || typeof intlTelInputUtils === "undefined")
        return;

    var name = input.prop("name") || "";
    if (name.indexOf(".Original") < 0)
        return;

    var form = input.closest("form");
    var prefix = name.replace(/\.Original/, "");

    jQuery(`[name='${prefix}.E164']`, form).val(iti.getNumber(intlTelInputUtils.numberFormat.E164));
    jQuery(`[name='${prefix}.Extension']`, form).val(iti.getExtension());
}

function initializePhoneNumberInputs(el)
{
    jQuery("[data-role=phonenumber]", el).each(function ()
    {
        if (!jQuery(this).data("intlTelInput"))
        {
            // Default from server-side
            var initialCountry = jQuery(this).data("initial-country") || "us";

            var x = window.intlTelInput(this, {
                //autoInsertDialCode: false,
                //nationalMode: false,
                //formatOnDisplay: false,
                //separateDialCode: true,
                dropdownContainer: jQuery(this).data("dropdown-container") == "body" ? document.body : null,
                utilsScript: ContentNonversionedUrl + "intl-tel-input-18.5.3/js/utils.js",
                initialCountry: initialCountry,
                preferredCountries : [initialCountry],
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData)
                {
                    return selectedCountryPlaceholder.replace(/[0-9]/g, "x");
                }
            });

            jQuery(this).data("intlTelInput", x);

            if (jQuery(this).data("full"))
            {
                // setNumber dispatches countrychange synchronously. On a modal or any other markup
                // initialized after the handlers bind, that would otherwise register as a user edit.
                jQuery(this).data("phone-initializing", true);
                x.setNumber(jQuery(this).data("full").toString());
                jQuery(this).removeData("phone-initializing");
            }

            var input = this;
            if (x.promise)
                x.promise.then(function () { syncHiddenPhoneFieldsIfEdited(input); }, function () { });

            addPhoneFormatRule(this, x);
        }
    });
}

function isBlank(value) { return jQuery.trim(value) === ""; }

if (jQuery.validator)
{
    jQuery.validator.addMethod("validPhoneFormat", function (value, element)
    {
        if (isBlank(value))
            return true;

        // isValidNumber() is null until utils.js loads; only a definite false fails.
        return jQuery(element).data("intlTelInput").isValidNumber() !== false;
    });
}

// Pages opt in by defining window.phoneInvalidMessage. The host-facing guest forms don't, so a
// channel-supplied number that never dialed stays editable there.
function addPhoneFormatRule(input, iti)
{
    var form = jQuery(input.form);
    var pageOptedIn = !!window.phoneInvalidMessage;
    var formHasValidator = form.data("validator") != null;
    if (!pageOptedIn || !formHasValidator)
        return;

    jQuery(input).rules("add", { validPhoneFormat: true, messages: { validPhoneFormat: window.phoneInvalidMessage } });

    iti.promise.then(function ()
    {
        var isVisibleWithValue = jQuery(input).is(":visible") && !isBlank(input.value);
        if (isVisibleWithValue)
            form.validate().element(input);
    });
}

jQuery(function ()
{
    initializePhoneNumberInputs(document);

    jQuery(document).on("countrychange", "[data-role=phonenumber]", function ()
    {
        if (jQuery(this).data("phone-initializing"))
            return;

        // Flag pick doesn't fire change/input on the visible phone input — mark dirty explicitly.
        var phoneSection = jQuery(this).closest('.accordion-collapse');
        if (phoneSection.length && typeof markSectionDirty === 'function')
            markSectionDirty(phoneSection.prop('id'));

        var validator = jQuery(this.form).data("validator");
        if (validator && !isBlank(this.value))
            validator.element(this);

        if (jQuery(this).data("link-country"))
        {
            var form = jQuery(this).closest("form");

            var country = jQuery("select[name*=Country]", form);

            if (country.length && country.data("user-set") != true)
            {
                var iti = jQuery(this).data("intlTelInput");
                var code = iti.getSelectedCountryData().iso2;

                // No country is selected while the value carries an unrecognized dial code.
                if (!code)
                    return;

                var option = country.find(`option[data-code=${code.toUpperCase()}]`);

                if (option.length)
                {
                    country.val(option.attr("value"));
                    country.trigger("change");
                }
            }
        }
    });

    // Blur alone is not an edit, so the flag comes only from input/change/countrychange.
    jQuery(document).on("input change countrychange", "[data-role=phonenumber]", function ()
    {
        if (!jQuery(this).data("phone-initializing"))
            jQuery(this).data("phone-edited", true);
    });

    jQuery(document).on("blur change", "[data-role=phonenumber]", function ()
    {
        syncHiddenPhoneFieldsIfEdited(this);
    });
});
/*!
 * OwnerRez quick.js
 */
var isQuickQuoteInitialized = false;

var updateTypeDisplay = function (showImmediate) {
    if (!$("#quick-quote-block").is(":checked"))
        $(".quickquote-notblock")[showImmediate == true ? "show" : "slideDown"]();
    else
        $(".quickquote-notblock")[showImmediate == true ? "hide" : "slideUp"]();

    $(".quick-quote-create").show();
    $("#spn-public-link").hide();

    switch ($("#quick-quote-modal [name=type]:checked").val()) {
        case "Quote":
            $("#quick-quote-modal form").prop("action", BaseUrl + "/quotes/add");
            $(".quick-quote-create").text("Create Quote");
            $("#quick-quote-modal .modal-title").text("Create Quote");

            break;
        case "Book":
            $("#quick-quote-modal form").prop("action", BaseUrl + "/bookings/add");
            $(".quick-quote-create").text("Create Booking");
            $("#quick-quote-modal .modal-title").text("Create Booking");

            break;
        case "Block":
            $("#quick-quote-modal form").prop("action", BaseUrl + "/bookings/block");
            $(".quick-quote-create").text("Block Off Time");
            $("#quick-quote-modal .modal-title").text("Block Off Time");

            break;
        case "PublicLink":
            $(".quick-quote-create").hide();
            $("#spn-public-link").show();
            $("#quick-quote-modal .modal-title").text("Create Public Link");

            break;
    }
};

var showQuickQuote = function (options, fnAfterModalShown) {
    if (!window.isQuickQuoteEnabled)
        return;
    if (!options)
        options = {};

    $("#quick-quote-modal input, #quick-quote-modal select").off("change");

    $("#quick-quote-modal input[type=text], #quick-quote-modal select").val("");

    // Rebuild multiselect after clearing - rebuild (not refresh) is required because
    // the .off("change") above destroys the multiselect's internal change handlers
    var $propertySelect = $("#quick-quote-propertyId");
    if ($propertySelect.data('multiselect')) {
        $propertySelect.multiselect('rebuild');
    }

    $("#quick-quote-adults").val(options.adults || "1");

    if (options.guestId)
        $("#quick-quote-guestid").val(options.guestId);
    if (options.children)
        $("#quick-quote-children").val(options.children);
    if (options.pets)
        $("#quick-quote-pets").val(options.pets);

    $("#quick-quote-type-group").toggle(options.hideType != true);

    var focusDeparture = false;
    var updateOnShow = false;

    if (options.arrival) {
        if (options.departure == null) {
            focusDeparture = true;

            options.departure = options.arrival.clone();
        }
        else
            updateOnShow = true;

        $("#quick-quote-arrival").val(i18n.formatDate(options.arrival));

        if (options.departure)
            $("#quick-quote-departure").val(i18n.formatDate(options.departure));
    }

    if (!isQuickQuoteInitialized) {
        $("#quick-quote-arrival").availabilityPicker({
            arrivalElement: $("#quick-quote-arrival")[0],
            departureElement: $("#quick-quote-departure")[0],
            canPickUnavailable: true
        });
    }

    var type = options.type;
    var thisType = $(this).data("quick-quote-type");

    if (thisType && !type)
        type = thisType;

    var showQuickQuoteInternal = function (properties, listingSites) {
        if (properties && $("#quick-quote-propertyId option").length == 1) {
            var propertySelect = $("#quick-quote-propertyId")[0];

            if (properties.length == 1)
                $(propertySelect).empty();

            for (var i = 0; i < properties.length; i++) {
                var option = document.createElement('option');

                option.text = properties[i].SelectorName || properties[i].Name;
                option.value = properties[i].Id;

                propertySelect.appendChild(option);
            }

            if (properties.length >= (window.SingleFilterMinItems || 15))
            {
                $(propertySelect)
                    .addClass("filterable-single-select")
                    .data("is-single-required", true)
                    .multiselect({
                        nonSelectedText: "[select a property]",
                    });
            }
        }

        if (listingSites && $("#quick-quote-listingSiteId option").length == 1) {
            var listingSiteSelect = $("#quick-quote-listingSiteId")[0];

            if (listingSites.length == 1)
                $(listingSiteSelect).empty();

            // Group and sort listing sites to match Quote/Booking Add page
            // Group by Type: null = "My Listing Sites", non-null = "System Listing Sites"
            var myListingSites = listingSites.filter(site => site.Type == null).sort((a, b) => a.Name.localeCompare(b.Name));
            var systemListingSites = listingSites.filter(site => site.Type != null).sort((a, b) => a.Name.localeCompare(b.Name));

            // Add "My Listing Sites" group
            if (myListingSites.length > 0) {
                var myGroup = document.createElement('optgroup');
                myGroup.label = "My Listing Sites";
                myListingSites.forEach(site => {
                    var option = document.createElement('option');
                    option.text = site.Name;
                    option.value = site.Id;
                    myGroup.appendChild(option);
                });
                listingSiteSelect.appendChild(myGroup);
            }

            // Add "System Listing Sites" group
            if (systemListingSites.length > 0) {
                var systemGroup = document.createElement('optgroup');
                systemGroup.label = "System Listing Sites";
                systemListingSites.forEach(site => {
                    var option = document.createElement('option');
                    option.text = site.Name;
                    option.value = site.Id;
                    systemGroup.appendChild(option);
                });
                listingSiteSelect.appendChild(systemGroup);
            }
        }

        if (options.propertyId) {
            var $propertySelect = $("#quick-quote-propertyId");
            $propertySelect.val(options.propertyId);
            
            // Refresh multiselect if it's been initialized
            if ($propertySelect.data('multiselect')) {
                $propertySelect.multiselect('refresh');
            }
        }

        $("#quick-quote-modal [name=type][value='" + (type || "Quote") + "']").prop("checked", true);
        updateTypeDisplay(true);
        $("#quick-quote-modal .quickquote").hide();

        //updateQuickQuote();
        $("#quick-quote-propertyId").on("change", function () {
            $("#quick-quote-arrival").availabilityPicker("setAvailabilityFromProperty", $(this).val());
        });

        $("#quick-quote-propertyId").change();

        var quickquoteautofocus = $("#quick-quote-arrival").on("change", function () {
            if ($(this).val() && !$("#quick-quote-departure").val()) {
                var day = i18n.parseDate($(this).val());

                if (day.isValid())
                    $("#quick-quote-departure").val(day.add(2, "days").format(window.dayjsLocale.format)).focus();
            }
        });

        $("#quick-quote-departure").on("change", function () {
            $("#quick-quote-arrival, #quick-quote-departure").off("change", quickquoteautofocus);
        });

        $("#quick-quote-modal [name=type]").on("change", updateTypeDisplay);

        $("#quick-quote-modal input, #quick-quote-modal select").on("change", updateQuickQuote);

        if (fnAfterModalShown)
            $("#quick-quote-modal").on("shown.bs.modal", function () { if (fnAfterModalShown) fnAfterModalShown(); });
        else
            $("#quick-quote-modal").off("shown.bs.modal");

        $("#quick-quote-modal").modal("show");

        closeRightSidebar();

        if (focusDeparture)
            $("#quick-quote-departure").focus();
        if (updateOnShow)
            updateQuickQuote();
    };

    var stripCal = $(".stripcal.has-quick-quote");

    if ($("#quick-quote-propertyId option").length == 1) {
        if (stripCal.length)
            showQuickQuoteInternal(stripCal.stripcal("getSortedProperties"));
        else {
            $.get(BaseUrl + "/api/properties/lookup", function (data) {
                showQuickQuoteInternal(data);
            });
        }
    }

    if ($("#quick-quote-listingSiteId option").length == 1) {
        $.get(BaseUrl + "/api/listingsites", function (data) {
            showQuickQuoteInternal(null, data);
        });
    }

    showQuickQuoteInternal();

    //return false;
};

var showQuickPublicLink = function (e) {
    showQuickQuote(null, function () {
        $("#quick-public-link").click();
        if (e && e.target) {
            var data = $(e.target).data('public-link-info');
            if (data) {
                var $propertySelect = $("#quick-quote-propertyId");
                $propertySelect.val(data.PropertyId);
                if ($propertySelect.data('multiselect')) {
                    $propertySelect.multiselect('refresh');
                }
                $propertySelect.change();
                if (data.Arrival)
                    $("#quick-quote-arrival").val(i18n.formatDate(data.Arrival));
                if (data.Departure)
                    $("#quick-quote-departure").val(i18n.formatDate(data.Departure));
                $("#quick-quote-adults").val(data.Adults).change();
                $("#quick-quote-children").val(data.Children).change();
                $("#quick-quote-pets").val(data.Pets).change();
                $("#quick-quote-propertyId").focus();
                updateQuickQuote();
            }
        }
    });
};

var lastData = null;

var updateQuickQuote = function () {
    if (
        $("#quick-quote-propertyId").val() 
        && $("#quick-quote-arrival").val() 
        && $("#quick-quote-departure").val() 
        && i18n.isValidDate($("#quick-quote-arrival").val()) 
        && i18n.isValidDate($("#quick-quote-departure").val())
    ) {
        var propertyId = parseInt($("#quick-quote-propertyId option:selected").val());
        var externalId = `orp5b${propertyId.toString(16)}x`;

        var arrival = i18n.parseDate($("#quick-quote-arrival").val());
        var departure = i18n.parseDate($("#quick-quote-departure").val());

        var linkUrl = `${BookingFormsUrl}/request?property=${externalId}&arrival=${arrival.format("YYYY-MM-DD")}&departure=${departure.format("YYYY-MM-DD")}`;

        var listingSiteId = parseInt($("#quick-quote-listingSiteId option:selected").val());
        if (listingSiteId)
            linkUrl += `&channel=${listingSiteId}`;

        if ($("#quick-quote-adults").val())
            linkUrl += `&adults=${$("#quick-quote-adults").val()}`;

        if ($("#quick-quote-children").val())
            linkUrl += `&children=${$("#quick-quote-children").val()}`;

        if ($("#quick-quote-pets").val())
            linkUrl += `&pets=${$("#quick-quote-pets").val()}`;

        $(".btn-quickquote-publiclink-view").attr("href", linkUrl);
        $(".btn-quickquote-publiclink-view").attr("target", "_blank");
        $(".btn-quickquote-publiclink-copy").attr("data-clipboard-text", linkUrl);
        $(".btn-quickquote-publiclink").removeAttr("disabled");
        $(".btn-quickquote-publiclink").removeClass("disabled");
    }
    else {
        $(".btn-quickquote-publiclink").attr("disabled", "disabled");
        $(".btn-quickquote-publiclink-view").removeAttr("href");
        $(".btn-quickquote-publiclink-view").removeAttr("target");
        $(".btn-quickquote-publiclink-copy").removeAttr("data-clipboard-text");
        $(".btn-quickquote-publiclink").addClass("disabled");
    }
    
    if (
        !$("#quick-quote-block").is(":checked") 
        && $("#quick-quote-arrival").val() 
        && $("#quick-quote-departure").val() 
        && $("#quick-quote-propertyId").val() 
        && i18n.isValidDate($("#quick-quote-arrival").val()) 
        && i18n.isValidDate($("#quick-quote-departure").val())
    ) {
        var data = {
            propertyId: $("#quick-quote-propertyId").val(),
            arrival: i18n.parseDate($("#quick-quote-arrival").val()).format("YYYY-MM-DD"),
            departure: i18n.parseDate($("#quick-quote-departure").val()).format("YYYY-MM-DD"),
            listingSiteId: $("#quick-quote-listingSiteId").val(),
            adults: $("#quick-quote-adults").val(),
            children: $("#quick-quote-children").val(),
            pets: $("#quick-quote-pets").val()
        };

        if (JSON.stringify(data) != JSON.stringify(lastData)) {
            lastData = data;

            var timeout = window.setTimeout(function () { $(".quickquote > .spinner").show(); }, 200);

            $.get(BaseUrl + "/bookings/quickquote", data)
                .always(function (data) {
                    // NOTE: data is data on success, but jqXHR on error.
                    if (!$("#quick-quote-block").is(":checked"))
                        $("#quick-quote-modal .quickquote").slideDown();

                    window.clearTimeout(timeout);

                    $(".quickquote > .spinner").hide();

                    if (data.succeeded)
                        $(".quickquote").addClass("alert-info").removeClass("alert-warning alert-danger");
                    else if (data.charges && data.charges.length)
                        $(".quickquote").addClass("alert-warning").removeClass("alert-info alert-danger");
                    else
                        $(".quickquote").addClass("alert-danger").removeClass("alert-info alert-warning");

                    var hasRent = false;

                    if (data.charges && data.charges.length && data.total != null) {
                        var listHtml = "";

                        for (var i = 0; i < data.charges.length; i++) {
                            var charge = data.charges[i];

                            listHtml += '<li>' + charge.type + ' &ndash; ' + $("<div>").text(charge.description).html() + ': ' + charge.amountFormatted;

                            if (charge.type == "Rent" && charge.amount)
                                hasRent = true;
                        }

                        if (hasRent) {
                            $(".quickquote-details ul").html(listHtml);

                            $(".quickquote-details").show();
                        }
                        else
                            $(".quickquote-details").hide();
                    }
                    else
                        $(".quickquote-details").hide();

                    if (data.total != null && data.nights && hasRent) {
                        $(".quickquote-total").text(data.totalFormatted);
                        $(".quickquote-nights").text(data.nights);

                        $(".quickquote-info").show();
                    }
                    else
                        $(".quickquote-info").hide();

                    if (!data.succeeded) {
                        var errorList = null;

                        if (data.errors && data.errors.length)
                            errorList = "<li>" + data.errors.join("</li><li>") + "</li>";

                        if (errorList == null) {
                            errorList = data.succeeded != null ? "Couldn't calculate rates for these dates." : "Error calculating rates.";

                            $(".quickquote-errors span").hide();
                        }
                        else {
                            if (data.charges && data.charges.length)
                                $(".quickquote-errors span").text("If you actually tried to book this, you would have the following problems:");
                            else
                                $(".quickquote-errors span").text("Your input created the following errors:");

                            $(".quickquote-errors span").show();
                        }

                        $(".quickquote-errors ul").html(errorList);

                        if (data.total && hasRent)
                            $(".quickquote-errors hr").show();
                        else
                            $(".quickquote-errors hr").hide();

                        $(".quickquote-errors").show();
                    }
                    else
                        $(".quickquote-errors").hide();
                })
        }
        else
            $("#quick-quote-modal .quickquote").slideDown();
    }
    else {
        $("#quick-quote-modal .quickquote").slideUp();
        //$(".quickquote > div").hide();

        //$(".quickquote").addClass("alert-warning").removeClass("alert-info alert-danger");
    }
};
var _initQuickGuestModal = function (options, successCallback) {
    $("#quick-guest-modal .modal-title").html(options != null ? options.title : "Find or Create Contact");

    $("#quick-guest-modal").data("successCallback", typeof successCallback === "function" ? successCallback : null);

    $("#quick-guest-modal").data('options', options);
    $("#quick-guest-modal").data('filter', options != null ? options.filter : null);

    var $search = $("#quick-guest-search");
    if (options != null && options.isVendor) {
        $search.data('not-found-text', 'No vendors found for these search terms');
        $search.data('add-noun', 'vendor');
    }
    else {
        $search.removeData('not-found-text');
        $search.removeData('add-noun');
    }
};

var _applyQuickGuestVendorStyling = function (modal, options, data, addNew) {
    if (options == null || !options.isVendor)
        return;

    var $modal = $(modal);
    $modal.find('.contact-type-section').hide();
    $modal.find('.btn-reset.menu-quick-guest span').text(' Find a Different Vendor');

    var returnFocusTo = options.returnFocusTo;
    $modal.find('.btn-reset.menu-quick-guest')
        .removeClass('menu-quick-guest')
        .removeAttr('data-dismiss data-bs-dismiss')
        .off('click.vendorReset')
        .on('click.vendorReset', function () {
            $modal.one('hidden.bs.modal', function () {
                if (returnFocusTo)
                    $(returnFocusTo).focus();
                else
                    $("#quick-guest-modal").modal("show");
            });
            $modal.modal('hide');
        });

    if (addNew) {
        var $titleText = $modal.find('.modal-title-custom .modal-title-text');
        if ($titleText.length)
            $titleText.text('Add Vendor');
        else
            $modal.find('.modal-title-custom').contents().filter(function () { return this.nodeType === 3; }).first().each(function () { this.nodeValue = 'Add Vendor'; });
        $modal.find('.alert-guest-new p').html('Use the following fields to create a new <strong>vendor</strong> contact. You can change this information later.');
        $modal.find('#IsVendor').prop('checked', true);
        $modal.find('.btn-create').html('<i class="fa fa-plus"></i> Create Vendor &amp; Use');
    }
    else {
        var $submitBtn = $modal.find('.btn-create');
        var $useBtn = $modal.find('.btn-use-guest');
        var $form = $modal.find('form.edit-guest');

        var hasValidationErrors = $form.find('.field-validation-error, .input-validation-error').length > 0;

        $useBtn.hide();
        $form.data('vendor-dirty', hasValidationErrors);
        $submitBtn.off('click.vendor');

        if (hasValidationErrors) {
            $submitBtn.attr('type', 'submit').text('Update Vendor & Use');
        }
        else {
            $submitBtn.attr('type', 'button').text('Use This Vendor');
            $submitBtn.on('click.vendor', function () {
                if (!$form.data('vendor-dirty')) {
                    $modal.modal('hide');
                    quickGuestCallback({ Id: data.Id, success: true, fullName: data.FullName });
                }
            });
        }

        $form.find(':input').off('change.vendorDirty input.vendorDirty').one('change.vendorDirty input.vendorDirty', function () {
            $form.data('vendor-dirty', true);
            $submitBtn
                .off('click.vendor')
                .attr('type', 'submit')
                .text('Update Vendor & Use');
        });
    }
};

var showQuickGuest = function (options, successCallback, clearCallback) {
    _initQuickGuestModal(options, successCallback);

    $("#quick-guest-search").typeahead("val", "").typeahead("close");

    if (clearCallback != null && typeof clearCallback === "function") {
        $("#quick-guest-modal").data("clearCallback", clearCallback);
        $("#quick-clear-contact").show();
    } else {
        $("#quick-guest-modal").removeData("clearCallback");
        $("#quick-clear-contact").hide();
    }

    $("#quick-guest-modal").modal("show");

    closeRightSidebar();

    $("#quick-guest-search").focus();
};

var loadQuickGuestInfo = function (data, query) {
    $("#quick-guest-modal").modal("hide");

    var addNew = true;
    var url = BaseUrl + "/guests/";

    if (data != null && data.Id) {
        url += data.Id + "/edit";
        addNew = false;
    }
    else {
        url += "add";
    }
    url += "?quickEdit=true&embedded=true"

    var options = $("#quick-guest-modal").data('options');
    var isVendor = options == null ? null : options.isVendor;

    $.showModal(url, quickGuestCallback, null, "modal-bs5-default", function (modal) {
        $('[data-bs-toggle="tooltip"]', modal).tooltip();

        if (options != null) {
            $(modal).find('.btn-create').html(options.goButtonWords);

            if (!addNew && options.getButtonWords && !isVendor)
                $(modal).find('.btn-use-guest').text(options.getButtonWords).show();
        }
        else {
            $(modal).find('.btn-create').text('Create Contact & Close');
        }

        if (addNew) {
            if (query != null && query.length > 0) {
                query = $.trim(query.replace(/[<>]/g, " ").replace(/\s+/g, " "));

                if (isVendor) {
                    $(modal).find("#CompanyName").val(query);
                }
                else {
                    var parts = query.split(" ");
                    var firstName = null;
                    var lastName = [];
                    var email = null;
                    var phone = [];

                    for (var i = 0; i < parts.length; i++) {
                        var part = parts[i];

                        if (part.match(/[\d]/) && !part.match(/[a-zA-Z]/)) {
                            phone.push(part.replace(/[^0-9]/g, ""));
                        }
                        else {
                            if (part.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i))
                                email = part;
                            else if (part.match(/[^\d]/)) {
                                if (firstName == null)
                                    firstName = part;
                                else
                                    lastName.push(part);
                            }
                        }
                    }

                    phone = phone.join("");

                    $(modal).find("#FirstName").val(firstName);
                    $(modal).find("#LastName").val(lastName.join(" "));

                    if (email) {
                        $("#EmailAddresses_0__Address").val(email);
                    }

                    if (phone && phone.length >= 7) {
                        $("#Phones_0__Original").val(phone);
                    }
                }

                $("#quick-guest-search").typeahead("val", "");
            }
        }
        else {
            $(modal).find('.btn-create').html($(modal).find('.btn-create').html().replace('Create', 'Update'));
        }

        if (isVendor) {
            _applyQuickGuestVendorStyling(modal, options, data, addNew);

            $(modal).on('modal:contentLoaded.quickGuestVendor', function () {
                _applyQuickGuestVendorStyling(modal, options, data, addNew);
            });
        }
    });

    return false;
};

var quickGuestCallback = function (data) {
    var successCallback = $("#quick-guest-modal").data('successCallback');
    if (data.success) {
        if (successCallback)
            successCallback(null, data);
        else
            showAlertConfirmation((data.isAdded ? "Contact added!" : "Contact updated!") + ' <a class="btn btn-default btn-xs" href="' + BaseUrl + '/guests/' + data.Id + '/edit">View Contact &gt;&gt;</a>');
    }
};
$("#quick-guest-search").on("typeahead:select", function (e, data) {
    loadQuickGuestInfo(data);
});

$("#quick-guest-search").on("typeahead:addnew", function (e, query) {
    loadQuickGuestInfo(null, query.query);
});

$(".menu-quick-quote").on("click", showQuickQuote);

// Reset inside the contact modal returns to the current picker's search; the Tools sidebar entry starts a new one.
$(document).on("click", ".menu-quick-guest", function () {
    $("#quick-guest-search").typeahead("val", "");

    var $modal = $("#quick-guest-modal");
    if ($(this).hasClass("btn-reset"))
        showQuickGuest($modal.data("options"), $modal.data("successCallback"), $modal.data("clearCallback"));
    else
        showQuickGuest(null, null);
});

$(document).on("click", ".show-quick-public-link", function (e) { showQuickPublicLink(e); });

$("#quick-clear-contact").on("click", function () {
    const clearCallback = $("#quick-guest-modal").data("clearCallback");
    if (clearCallback) {
        clearCallback();
    }

    $("#quick-guest-modal").modal("hide");
});

var loadBulkSetVendor = function () {
    const selectedExpenses = $(".griddly").griddly("getSelected").value;

    showQuickGuest(
        {
            title: `Set Vendor for ${selectedExpenses.length} expenses`,
            filter: 'contactType=4',
            getButtonWords: 'Use',
            goButtonWords: "Create &amp; Use",
            isVendor: true
        },
        function (e, contact) {
            $("#quick-guest-modal").modal("hide");
            $(".modal:has(form.edit-guest)").modal("hide");

            $('#modal-expense-vendor-set')
                .find('input[name="vendorId"]')
                .val(contact.Id);

            $('#modal-expense-vendor-set')
                .modal('show');
        }
    );
};

var loadBulkRemoveVendor = function () {
    $('#modal-expense-vendor-remove').modal('show');
};

var openQuickGuestAdd = function (options, successCallback, query) {
    _initQuickGuestModal(options, successCallback);
    loadQuickGuestInfo(null, query);
};

var loadSetVendor = function (successCallback, clearCallback, returnFocusTo) {
    showQuickGuest(
        {
            title: `Set Vendor`,
            filter: 'contactType=4',
            getButtonWords: 'Use',
            goButtonWords: "Create &amp; Use",
            isVendor: true,
            returnFocusTo: returnFocusTo
        },
        successCallback,
        clearCallback
    )
};
/* Slinky — sheet (mobile) / popover (desktop) wrapper over BS5 Offcanvas.
   Slinky.show({ title, items, layout, anchor, searchable, menuClass?, notice?, content?, focusValue?, onSelect, onHide? }) → { hide() }
   content: a DOM node or fragment shown instead of the menu items, for a detail sheet with ordinary links and buttons; in the
   sheet its top-level elements are rows of the sheet's flex column.
   menuClass: extra class on the popover/sheet root for caller-scoped styling.
   focusValue: the value of the item a non-searchable menu focuses when it opens, when that item is enabled; otherwise the first.
   onHide: called once when the menu closes, whether by a selection or a dismissal.
   notice: trusted HTML, or a DOM node appended as is, rendered between the title and the search box (e.g. a callout).
   Item shape: { icon, label, value, meta?, danger?, full?, section?, hiddenByLimit?, className?, disabled? }
   disabled: keyboard navigation skips it, a click does nothing, and both layouts show it greyed.
   full: item spans its own full-width row in a grid (e.g. an action under a row of icons).
   className: extra class(es) on the item button for caller-scoped styling. */
(function (window, document) {
    'use strict';

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function buildItems(items, layout, searchable) {
        var parent = document.createElement(layout === 'grid' ? 'div' : 'ul');
        parent.className = layout === 'grid' ? 'slinky-grid' : 'slinky-list';
        // searchable = combobox pattern (listbox/option, focus lives on the input);
        // non-searchable = menu pattern (menu/menuitem, roving focus on the items)
        parent.setAttribute('role', searchable ? 'listbox' : 'menu');
        items.forEach(function (item) {
            if (item.section) {
                var h = document.createElement('div');
                h.className = 'slinky-section';
                h.setAttribute('role', 'presentation');
                h.textContent = item.section;
                parent.appendChild(h);
                return;
            }
            var btn = document.createElement('button');
            btn.type = 'button';
            // tabIndex -1 anchors focus to the search input (combobox) or the roving
            // item (menu): arrow keys move the highlight/focus; Tab leaves entirely.
            btn.tabIndex = -1;
            btn.className = 'slinky-item' + (item.danger ? ' slinky-danger' : '') + (item.full ? ' slinky-item--full' : '') + (item.className ? ' ' + item.className : '');
            btn.setAttribute('role', searchable ? 'option' : 'menuitem');
            btn.dataset.value = item.value;
            if (item.hiddenByLimit) btn.dataset.hiddenByLimit = '1';
            if (item.disabled) { btn.disabled = true; btn.classList.add('disabled'); }
            // Icon is trusted HTML (controlled code-side — FontAwesome markup or emoji).
            var ico = item.icon ? '<span class="slinky-ico">' + item.icon + '</span>' : '';
            var meta = item.meta ? '<span class="slinky-meta">' + escapeHtml(item.meta) + '</span>' : '';
            btn.innerHTML = ico + '<span class="slinky-label">' + escapeHtml(item.label) + '</span>' + meta;
            parent.appendChild(btn);
        });
        return parent;
    }

    function buildSearchInput(opts) {
        var wrap = document.createElement('div');
        wrap.className = 'slinky-search';
        var input = document.createElement('input');
        input.type = 'search';
        input.className = 'form-control form-control-sm';
        input.placeholder = opts.searchPlaceholder || 'Search...';
        input.autocomplete = 'off';
        input.autocapitalize = 'none';
        input.spellcheck = false;
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-expanded', 'true');
        wrap.appendChild(input);
        return { wrap: wrap, input: input };
    }

    // aria-activedescendant combobox: focus stays on input, activeIndex tracks
    // the highlighted visible item. Section headers auto-hide when all their
    // items drop out; hiddenByLimit items appear as soon as there's a query.
    function attachFilter(container, input, emptyEl, onSelect, close) {
        var allItems = Array.prototype.slice.call(container.querySelectorAll('.slinky-item'));
        var allSections = Array.prototype.slice.call(container.querySelectorAll('.slinky-section'));
        var activeIndex = -1;
        var activeIdPrefix = 'slinky-item-' + Math.random().toString(36).slice(2, 8) + '-';

        function visibleItems() {
            var out = [];
            for (var i = 0; i < allItems.length; i++) {
                if (allItems[i].style.display !== 'none' && !allItems[i].disabled) {
                    out.push(allItems[i]);
                }
            }
            return out;
        }

        function clearActive() {
            for (var i = 0; i < allItems.length; i++) {
                if (allItems[i].classList.contains('active')) allItems[i].classList.remove('active');
            }
            input.removeAttribute('aria-activedescendant');
        }

        function applyActive() {
            var items = visibleItems();
            clearActive();
            if (!items.length || activeIndex < 0) {
                activeIndex = -1;
                return;
            }
            if (activeIndex >= items.length) activeIndex = items.length - 1;
            var item = items[activeIndex];
            item.classList.add('active');
            if (!item.id) item.id = activeIdPrefix + activeIndex;
            input.setAttribute('aria-activedescendant', item.id);
            if (typeof item.scrollIntoView === 'function') {
                item.scrollIntoView({ block: 'nearest' });
            }
        }

        function filter(q) {
            q = (q || '').toLowerCase().trim();
            for (var i = 0; i < allItems.length; i++) {
                var item = allItems[i];
                var labelEl = item.querySelector('.slinky-label');
                var label = labelEl ? labelEl.textContent.toLowerCase() : '';
                var show = q ? label.indexOf(q) >= 0 : !item.dataset.hiddenByLimit;
                item.style.display = show ? '' : 'none';
            }
            for (var j = 0; j < allSections.length; j++) {
                var sec = allSections[j];
                var hasVisible = false;
                var next = sec.nextElementSibling;
                while (next && !next.classList.contains('slinky-section')) {
                    if (next.classList.contains('slinky-item') && next.style.display !== 'none') {
                        hasVisible = true;
                        break;
                    }
                    next = next.nextElementSibling;
                }
                sec.style.display = hasVisible ? '' : 'none';
            }

            // Auto-select the top match when there's a query so Enter picks it.
            var visible = visibleItems();
            activeIndex = (q && visible.length) ? 0 : -1;
            applyActive();

            if (emptyEl) {
                emptyEl.style.display = (q && visible.length === 0) ? '' : 'none';
            }
        }

        function pickActive() {
            var items = visibleItems();
            if (activeIndex >= 0 && items[activeIndex]) {
                close();
                if (onSelect) onSelect(items[activeIndex].dataset.value);
            } else if (items.length) {
                close();
                if (onSelect) onSelect(items[0].dataset.value);
            }
        }

        input.addEventListener('input', function () { filter(input.value); });

        input.addEventListener('keydown', function (e) {
            var items = visibleItems();
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!items.length) return;
                activeIndex = activeIndex < items.length - 1 ? activeIndex + 1 : items.length - 1;
                applyActive();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!items.length) return;
                activeIndex = activeIndex > 0 ? activeIndex - 1 : -1;
                applyActive();
            } else if (e.key === 'Home') {
                if (!items.length) return;
                e.preventDefault();
                activeIndex = 0;
                applyActive();
            } else if (e.key === 'End') {
                if (!items.length) return;
                e.preventDefault();
                activeIndex = items.length - 1;
                applyActive();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                pickActive();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                close();
            }
        });

        filter('');
    }

    // Roving focus for non-searchable menus: arrows move focus between visible
    // items, Home/End jump, Enter/Space activate via native button semantics
    // (the parent click delegate closes + selects).
    function attachListNav(container) {
        function visibleItems() {
            var out = [];
            var all = container.querySelectorAll('.slinky-item');
            for (var i = 0; i < all.length; i++) {
                if (all[i].style.display !== 'none' && !all[i].disabled) {
                    out.push(all[i]);
                }
            }
            return out;
        }

        function focusItem(items, index) {
            for (var i = 0; i < items.length; i++) {
                items[i].tabIndex = i === index ? 0 : -1;
            }
            items[index].focus();
        }

        container.addEventListener('keydown', function (e) {
            var items = visibleItems();
            if (!items.length) return;
            var idx = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                focusItem(items, idx < 0 ? 0 : Math.min(idx + 1, items.length - 1));
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                focusItem(items, idx < 0 ? items.length - 1 : Math.max(idx - 1, 0));
            } else if (e.key === 'Home') {
                e.preventDefault();
                focusItem(items, 0);
            } else if (e.key === 'End') {
                e.preventDefault();
                focusItem(items, items.length - 1);
            }
        });

        return {
            focusStart: function (value) {
                var items = visibleItems();
                if (!items.length) return;
                var index = 0;
                for (var i = 0; i < items.length; i++) {
                    if (value != null && items[i].dataset.value === String(value)) index = i;
                }
                focusItem(items, index);
            }
        };
    }

    // Shared between showSheet + showPopover: wires title, optional search,
    // items list, item-click delegate, and keyboard filter/nav.
    function populateMenu(parent, opts, closeFn) {
        if (opts.title) {
            var t = document.createElement('div');
            t.className = 'slinky-title';
            t.textContent = opts.title;
            parent.appendChild(t);
        }

        if (opts.content) {
            parent.appendChild(opts.content);
            return {};
        }

        // Notice is trusted HTML (controlled code-side), same convention as item.icon, or a node the caller built from text.
        if (opts.notice) {
            var n = document.createElement('div');
            n.className = 'slinky-notice';
            if (opts.notice instanceof Node) {
                n.appendChild(opts.notice);
            } else {
                n.innerHTML = opts.notice;
            }
            parent.appendChild(n);
        }

        var searchRef = null;
        if (opts.searchable) {
            searchRef = buildSearchInput(opts);
            parent.appendChild(searchRef.wrap);
        }

        var itemsEl = buildItems(opts.items, opts.layout || 'list', !!opts.searchable);
        parent.appendChild(itemsEl);

        // Empty-state placeholder for searchable menus — typeahead miss otherwise
        // leaves dead air with no hint that the filter found nothing.
        var emptyEl = null;
        if (opts.searchable) {
            emptyEl = document.createElement('div');
            emptyEl.className = 'slinky-empty';
            emptyEl.textContent = opts.emptyText || 'No matching items';
            emptyEl.style.display = 'none';
            parent.appendChild(emptyEl);
        }

        parent.addEventListener('click', function (e) {
            var btn = e.target.closest('.slinky-item');
            if (!btn || btn.disabled) return;
            closeFn();
            if (opts.onSelect) opts.onSelect(btn.dataset.value);
        });

        var listNav = null;
        if (searchRef) {
            attachFilter(itemsEl, searchRef.input, emptyEl, opts.onSelect, closeFn);
        } else {
            listNav = attachListNav(itemsEl);
        }

        return { itemsEl: itemsEl, searchRef: searchRef, listNav: listNav };
    }

    function showSheet(opts) {
        var el = document.createElement('div');
        el.className = 'offcanvas offcanvas-bottom slinky-sheet' + (opts.menuClass ? ' ' + opts.menuClass : '');
        el.tabIndex = -1;
        el.setAttribute('aria-modal', 'true');
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-label', opts.title || 'Menu');

        var handle = document.createElement('div');
        handle.className = 'slinky-handle';
        el.appendChild(handle);

        document.body.appendChild(el);
        var oc = bootstrap.Offcanvas.getOrCreateInstance(el);

        // Don't autofocus search on mobile — it pops the keyboard and hides the list.
        var populated = populateMenu(el, opts, function () { oc.hide(); });
        var opener = document.activeElement;

        el.addEventListener('hidden.bs.offcanvas', function () {
            // Capture before removal — dropping the sheet resets activeElement to body.
            var focusWasOurs = el.contains(document.activeElement) || document.activeElement === document.body;

            el.remove();

            if (focusWasOurs && opener && document.contains(opener) && opener.focus) opener.focus();
            if (opts.onHide) opts.onHide();
        });

        // Focusing a button doesn't pop the mobile keyboard, so item focus is safe here.
        el.addEventListener('shown.bs.offcanvas', function () {
            if (populated.listNav) populated.listNav.focusStart(opts.focusValue);
        });

        oc.show();
        return { hide: function () { oc.hide(); } };
    }

    // Tracks the currently-open popover so a second click on the same trigger
    // toggles it closed (dropdown semantics) rather than reopen-with-flicker.
    var activePopover = null;

    function showPopover(opts) {
        // Toggle: same anchor with an open popover → close it.
        if (activePopover && activePopover.anchor === opts.anchor) {
            activePopover.close();
            return null;
        }

        // Different anchor (or stale wrap) → tear down before opening fresh.
        if (activePopover) activePopover.close();
        document.querySelectorAll('.slinky-popover-wrap').forEach(function (e) { e.remove(); });

        var anchor = opts.anchor;
        var rect = anchor.getBoundingClientRect();
        var wrap = document.createElement('div');
        wrap.className = 'slinky-popover-wrap';
        wrap.style.cssText = 'position:absolute;z-index:2000;top:' + (rect.bottom + window.scrollY + 4) + 'px;left:' + (rect.left + window.scrollX) + 'px;';

        // NOT .dropdown-menu — BS5's document keydown handler resolves a sibling
        // [data-bs-toggle="dropdown"] toggle. Slinky's anchor isn't a sibling
        // (popover is body-mounted), so arrow keys throw inside Dropdown.getOrCreateInstance(undefined).
        var menu = document.createElement('div');
        menu.className = 'slinky-popover' + (opts.menuClass ? ' ' + opts.menuClass : '');
        menu.style.position = 'static';
        menu.style.display = 'block';
        wrap.appendChild(menu);
        document.body.appendChild(wrap);

        // Outside dismissals must NOT pull focus back to the trigger — the capturing
        // mousedown handler runs before the browser moves focus for the click, so
        // document.activeElement can't distinguish that case on its own.
        var dismissedFromOutside = false;

        function close() {
            if (!wrap.parentNode) return;

            // Return focus to the trigger only when focus was still ours (Esc/select) —
            // an outside click or Tab-away moved it deliberately, leave it be.
            var focusWasInside = !dismissedFromOutside &&
                (wrap.contains(document.activeElement) || document.activeElement === document.body);

            wrap.remove();
            document.removeEventListener('mousedown', onDocDown, true);
            document.removeEventListener('touchstart', onDocDown, true);
            document.removeEventListener('focusin', onDocFocus, true);
            document.removeEventListener('keydown', onKeyDown);
            if (activePopover && activePopover.anchor === anchor) activePopover = null;

            if (focusWasInside && document.contains(anchor) && anchor.focus) anchor.focus();
            if (opts.onHide) opts.onHide();
        }

        function insideBounds(e) {
            return wrap.contains(e.target) || anchor.contains(e.target);
        }
        function onDocDown(e) { if (!insideBounds(e)) { dismissedFromOutside = true; close(); } }
        function onDocFocus(e) { if (!insideBounds(e)) close(); }
        function onKeyDown(e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } }

        var populated = populateMenu(menu, opts, close);

        var menuRect = menu.getBoundingClientRect();
        if (menuRect.bottom > window.innerHeight - 8) {
            wrap.style.top = Math.max(8, rect.top + window.scrollY - menuRect.height - 4) + 'px';
        }
        if (menuRect.right > window.innerWidth - 8) {
            wrap.style.left = Math.max(8, rect.right + window.scrollX - menuRect.width) + 'px';
        }

        activePopover = { anchor: anchor, close: close };

        // setTimeout defers so the triggering click doesn't fire these immediately.
        setTimeout(function () {
            if (populated.searchRef) populated.searchRef.input.focus();
            else if (populated.listNav) populated.listNav.focusStart(opts.focusValue);
            document.addEventListener('mousedown', onDocDown, true);
            document.addEventListener('touchstart', onDocDown, true);
            document.addEventListener('focusin', onDocFocus, true);
            document.addEventListener('keydown', onKeyDown);
        }, 0);

        return { hide: close };
    }

    var Slinky = {
        show: function (opts) {
            if (!opts || (!opts.content && !opts.items?.length)) return null;
            var isDesktop = window.matchMedia('(min-width: 768px)').matches;
            if (isDesktop && opts.anchor) return showPopover(opts);
            return showSheet(opts);
        }
    };

    window.Slinky = Slinky;
})(window, document);

/* Quiver — reusable attachment UX: upload, drag/drop, paste, tile render,
   progress, remove, LightGallery. DOM rendered by _Quiver.cshtml partial.
   onChange fires only on terminal tile changes, never on upload progress. */
(function ($, window, document) {
    'use strict';

    var CIRCUMFERENCE = 2 * Math.PI * 15;
    var LG_LICENSE_KEY = '5CD6B56C-064145F1-A29A5203-5655C26F';
    var DEFAULT_REMOVE_PROMPT = 'Are you sure you want to remove this file?';

    var DEFAULT_OPTS = {
        entityType: null,
        dropZone: null,
        pasteTarget: null,
        fileInput: null,
        initialFiles: null,
        maxSize: 30000000,
        allowedExtensions: null,
        allowedExtensionsDisplay: null,
        fieldName: 'quiver',
        galleryOnClick: true,
        galleryDuringUpload: true,
        deleteOnRemove: false,
        tempDelete: true,
        readonly: false,
        // true prompts before removing a tile; a string overrides the wording. Set only where
        // removal destroys the file outright and there is no Save to undo it.
        confirmRemove: null,
        // Notes, tasks and expenses suppress lightGallery's tap/swipe-to-close so a stray
        // touch on a photo does not dismiss the viewer. Inbox keeps the library default.
        galleryCloseOnTap: true,
        uploaderTemplateId: null,
        // When set, the drop overlay is re-parented to this element on init so
        // it covers a larger drop target (e.g. entire thread pane) rather than
        // just the Quiver container. The element must be position:relative.
        overlayAppendTo: null,
        uploadEndpoint: '/Settings/Upload/File',
        deleteEndpoint: '/Settings/Upload/Delete',
        licenseKeys: null,
        onChange: null,
        onError: null,
        // Fires as each file is queued, so consumers can scope per-batch state such as
        // "did anything in this batch fail". onChange cannot: it never fires on submit.
        onUploadStart: null,
        // Returns a message to refuse new uploads with (shown as the upload error), or null to allow them. Checked per file at validate.
        blockedReason: null,
        csrfToken: null
    };

    function Quiver(containerEl, opts) {
        if (!containerEl) throw new Error('Quiver: containerEl required');

        this.opts = $.extend({}, DEFAULT_OPTS, opts || {});
        this.container = containerEl;
        this.$container = $(containerEl);
        this.fieldName = this.opts.fieldName || 'quiver';
        this.ns = '.quiver-' + this.fieldName;

        if (!this.opts.csrfToken) {
            this.opts.csrfToken = $("input[name^=__RequestVerificationToken]").first().val() || '';
        }

        if (this.opts.licenseKeys == null) {
            this.opts.licenseKeys = { lightGallery: window.lightGalleryLicenseKey || LG_LICENSE_KEY };
        }

        this.$tiles = this.$container.find('.quiver-tiles');
        if (!this.$tiles.length) {
            this.$tiles = $('<div class="quiver-tiles"></div>').appendTo(this.$container);
        }
        this.$errors = this.$container.find('.quiver-errors');
        if (!this.$errors.length) {
            this.$errors = $('<div class="quiver-errors"></div>').prependTo(this.$container);
        }
        this.$overlay = this.$container.find('.quiver-drop-overlay');
        if (!this.$overlay.length) {
            this.$overlay = $('<div class="quiver-drop-overlay"><span>Drop files to attach</span></div>').appendTo(this.$container);
        }

        if (this.opts.overlayAppendTo) {
            var $appendTo = $(this.opts.overlayAppendTo);
            if ($appendTo.length) {
                this.$overlay.appendTo($appendTo);
                this.$overlay.toggleClass('quiver-drop-overlay--page', $appendTo[0] === document.body);
            }
        }

        this._dragCounter = 0;
        this._uploader = null;
        this._fineUploaderHost = null;

        if (!this.opts.readonly) {
            this._initUploader();
            this._wireEvents();
        } else {
            this._wireReadonlyEvents();
        }

        if (this.opts.initialFiles && this.opts.initialFiles.length) {
            var self = this;
            this.opts.initialFiles.forEach(function (f) {
                self._appendExistingTile(f);
            });
        }

        this._syncTilesVisibility();

        containerEl.__quiver = this;
    }

    Quiver.prototype._initUploader = function () {
        var self = this;
        var opts = this.opts;

        var $button;
        if (opts.fileInput) {
            $button = $(opts.fileInput);
        } else {
            // Visually hidden but still rendered — browsers refuse to open the
            // file picker from an `input.click()` call when the input (or any
            // ancestor) is `display: none`. Keep it in the render tree via
            // absolute-offscreen positioning + opacity 0.
            $button = $('<div class="quiver-file-button" style="position:absolute; width:1px; height:1px; opacity:0; overflow:hidden; pointer-events:none; clip:rect(0,0,0,0);"></div>').appendTo(this.$container);
        }
        this._$button = $button;

        var $host = $('<div class="quiver-uploader-host" style="display:none"></div>').appendTo(this.$container);
        this._fineUploaderHost = $host;

        var parts = [];
        if (opts.entityType != null && opts.uploadEndpoint.indexOf('entityType=') < 0) {
            parts.push('entityType=' + encodeURIComponent(opts.entityType));
        }
        if (opts.tempDelete !== false) {
            parts.push('tempDelete=true');
        }
        var endpoint = opts.uploadEndpoint;
        if (parts.length) {
            var sep = endpoint.indexOf('?') >= 0 ? '&' : '?';
            endpoint += sep + parts.join('&');
        }

        var templateId = opts.uploaderTemplateId || ('quiver-' + opts.fieldName + '-template');

        this._uploader = $host.fineUploader({
            autoUpload: true,
            button: $button[0] || $button,
            multiple: true,
            showMessage: function () {},
            request: {
                endpoint: endpoint,
                customHeaders: { '__RequestVerificationToken': opts.csrfToken }
            },
            validation: {
                sizeLimit: opts.maxSize
            },
            template: templateId
        })
        .on('validate', function (e, fileOrBlob) {
            var blocked = typeof opts.blockedReason === 'function' ? opts.blockedReason() : null;
            if (blocked) {
                self._showError(blocked);
                return false;
            }

            if (!self._isFileAllowed(fileOrBlob)) {
                self._showError('File type not supported. Only ' + opts.allowedExtensionsDisplay + ' files are allowed.');
                return false;
            }
        })
        .on('submit', function (e, id, name) {
            if (typeof self.opts.onUploadStart === 'function') self.opts.onUploadStart();

            var file = self._uploader.fineUploader('getFile', id);
            var $tile = self._createUploadTile(file);
            $tile.attr('data-qq-id', id);
            self.$tiles.append($tile);
            self._syncTilesVisibility();
        })
        .on('error', function (e, id, name, reason) {
            self._showError(reason || 'Upload failed');
        })
        .on('progress', function (e, id, name, loaded, total) {
            var $tile = self.$tiles.find('[data-qq-id="' + id + '"]');
            if ($tile.length) self._updateTileProgress($tile, loaded / total);
        })
        .on('complete', function (e, id, name, result) {
            var $tile = self.$tiles.find('[data-qq-id="' + id + '"]');

            // User removed the tile before upload finished. Server may still have
            // completed the upload — the temp file stays soft-deleted (tempDelete=true)
            // and the sweeper cleans it. Nothing to wire up client-side.
            if (!$tile.length) {
                // Still fire change: a deferred submit waiting on getInProgress() drop
                // needs the chance to retry, even when the terminal state was a remove.
                self._fireChange();
                return;
            }

            if (result && result.success) {
                self._completeTile($tile, result);
            } else {
                self._removeTile($tile);
                self._syncTilesVisibility();
            }

            // Fire on every terminal state — success, failure, or implicit-remove. The
            // submit guard chain in inbox-compose only retries from onChange, so failed
            // uploads must produce a change event or the form sits stuck.
            self._fireChange();
        });

        $button.find('input[type="file"]').attr('title', '');
    };

    Quiver.prototype._wireEvents = function () {
        var self = this;
        var ns = this.ns;

        var dropZone = this.opts.dropZone || this.container;
        var pasteTarget = this.opts.pasteTarget || this.container;
        this._$dropZone = $(dropZone);
        this._$pasteTarget = $(pasteTarget);

        this._$dropZone.on('dragenter' + ns, function (e) {
            e.preventDefault();
            e.stopPropagation();
            self._dragCounter++;
            self.$overlay.addClass('active');
        });

        this._$dropZone.on('dragover' + ns, function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        this._$dropZone.on('dragleave' + ns, function (e) {
            e.preventDefault();
            e.stopPropagation();
            self._dragCounter--;
            if (self._dragCounter <= 0) {
                self._dragCounter = 0;
                self.$overlay.removeClass('active');
            }
        });

        this._$dropZone.on('drop' + ns, function (e) {
            e.preventDefault();
            e.stopPropagation();
            self._dragCounter = 0;
            self.$overlay.removeClass('active');
            var files = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.files : null;
            if (files && files.length) self.addFiles(Array.from(files));
        });

        this._$pasteTarget.on('paste' + ns, function (e) {
            var cb = e.originalEvent && e.originalEvent.clipboardData;
            if (!cb || !cb.items) return;
            var files = [];
            for (var i = 0; i < cb.items.length; i++) {
                if (cb.items[i].kind === 'file') {
                    var f = cb.items[i].getAsFile();
                    if (f) files.push(f);
                }
            }
            if (files.length) {
                e.preventDefault();
                self.addFiles(files);
            }
        });

        this.$container.on('click' + ns, '.tile-remove', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (window.bootstrap && window.bootstrap.Tooltip) {
                var tip = window.bootstrap.Tooltip.getInstance(this);
                if (tip) tip.dispose();
            }
            var $tile = $(this).closest('.quiver-tile');

            if (self.opts.confirmRemove && window.bootbox) {
                var prompt = typeof self.opts.confirmRemove === 'string'
                    ? self.opts.confirmRemove
                    : DEFAULT_REMOVE_PROMPT;

                window.bootbox.confirm(prompt, function (ok) {
                    if (ok) self._removeAndDelete($tile);
                });

                return;
            }

            self._removeAndDelete($tile);
        });

        if (this.opts.galleryOnClick) {
            this.$container.on('click' + ns, '.quiver-tile', function (e) {
                if ($(e.target).closest('.tile-remove').length) return;
                self._openGalleryFor($(this));
            });
        }
    };

    // Readonly mode: no uploader, no drag/drop/paste, no remove — gallery click only.
    Quiver.prototype._wireReadonlyEvents = function () {
        var self = this;
        var ns = this.ns;
        if (this.opts.galleryOnClick) {
            this.$container.on('click' + ns, '.quiver-tile', function () {
                self._openGalleryFor($(this));
            });
        }
    };

    Quiver.prototype._isFileAllowed = function (file) {
        if (!this.opts.allowedExtensions || !this.opts.allowedExtensions.length) return true;
        var name = file && file.name ? file.name : '';
        var ext = name.split('.').pop().toLowerCase();
        return this.opts.allowedExtensions.indexOf(ext) >= 0;
    };

    Quiver.prototype._getFileIcon = function (contentType) {
        if (!contentType) return 'fa-file';
        if (contentType.indexOf('image/') === 0) return 'fa-file-image';
        if (contentType === 'application/pdf') return 'fa-file-pdf';
        if (contentType.indexOf('text/') === 0) return 'fa-file-lines';
        if (contentType.indexOf('excel') >= 0 || contentType.indexOf('spreadsheet') >= 0) return 'fa-file-excel';
        // Every OOXML content type contains "officedocument", so this precedes the word/document check.
        if (contentType.indexOf('powerpoint') >= 0 || contentType.indexOf('presentation') >= 0) return 'fa-file-powerpoint';
        if (contentType.indexOf('word') >= 0 || contentType.indexOf('document') >= 0) return 'fa-file-word';
        if (contentType.indexOf('zip') >= 0 || contentType.indexOf('archive') >= 0) return 'fa-file-archive';
        if (contentType.indexOf('video/') === 0) return 'fa-file-video';
        if (contentType.indexOf('audio/') === 0) return 'fa-file-audio';
        return 'fa-file';
    };

    Quiver.prototype._escapeHtml = function (str) {
        return $('<span>').text(str == null ? '' : str).html();
    };

    Quiver.prototype._truncateFilename = function (name, max) {
        max = max || 12;
        if (!name) return '';
        if (name.length <= max) return this._escapeHtml(name);
        var dotIdx = name.lastIndexOf('.');
        var ext = dotIdx >= 0 ? name.substring(dotIdx) : '';
        var baseLen = max - ext.length - 1;
        if (baseLen <= 0) return this._escapeHtml(name.substring(0, max)) + '&hellip;';
        return this._escapeHtml(name.substring(0, baseLen)) + '&hellip;' + this._escapeHtml(ext);
    };

    Quiver.prototype._showError = function (msg) {
        if (this.opts.onError && !this._inShowError) {
            this._inShowError = true;
            try { this.opts.onError(msg); } finally { this._inShowError = false; }
            return;
        }
        var self = this;
        var $err = $(
            '<div class="quiver-error">' +
            '<i class="far fa-circle-exclamation"></i>' +
            '<span class="quiver-error-text"></span>' +
            '<button type="button" class="quiver-error-close" aria-label="Dismiss"><i class="far fa-xmark"></i></button>' +
            '</div>'
        );
        $err.find('.quiver-error-text').text(msg);
        this.$errors.append($err);
        this.$container.addClass('has-error');

        function removeError() {
            $err.remove();
            if (!self.$errors.find('.quiver-error').length) {
                self.$container.removeClass('has-error');
            }
        }

        var fadeTimer = setTimeout(function () {
            $err.addClass('quiver-error-fadeout');
            setTimeout(removeError, 3000);
        }, 10000);

        $err.find('.quiver-error-close').on('click', function () {
            clearTimeout(fadeTimer);
            removeError();
        });
    };

    Quiver.prototype._buildTile = function (opts) {
        var $tile = $('<div class="quiver-tile"></div>');

        if (opts.attrs) {
            for (var k in opts.attrs) $tile.attr(k, opts.attrs[k] || '');
        }

        // Document tiles truncate the name and image tiles show none, so hover is the only place the full name is readable.
        if (opts.fileName) $tile.attr('title', opts.fileName);

        if (opts.imgSrc) {
            $tile.append($('<img />').attr('src', opts.imgSrc).attr('alt', opts.fileName || ''));
        } else {
            $tile.append(
                '<div class="tile-file-icon">' +
                '<i class="far ' + this._getFileIcon(opts.contentType) + '"></i>' +
                '<span>' + this._truncateFilename(opts.fileName) + '</span>' +
                '</div>'
            );
        }

        if (opts.progress) {
            $tile.append(
                '<div class="tile-progress">' +
                '<svg viewBox="0 0 36 36">' +
                '<circle class="progress-ring-bg" cx="18" cy="18" r="15" />' +
                '<circle class="progress-ring" cx="18" cy="18" r="15" stroke-dasharray="' + CIRCUMFERENCE + '" stroke-dashoffset="' + CIRCUMFERENCE + '" />' +
                '<text class="progress-text" x="18" y="18" text-anchor="middle" dominant-baseline="central">0%</text>' +
                '</svg></div>'
            );
        }

        var removeLabel = opts.fileName ? 'Remove ' + opts.fileName : 'Remove attachment';
        $tile.append(
            $('<button type="button" class="tile-remove" data-bs-toggle="tooltip" title="Remove"><i class="far fa-xmark"></i></button>')
                .attr('aria-label', removeLabel)
        );

        return $tile;
    };

    Quiver.prototype._buildCompletedTile = function (meta) {
        var name = meta.name || meta.fileName || '';
        var isImage = meta.isImage || (meta.contentType && meta.contentType.indexOf('image/') === 0);
        return this._buildTile({
            attrs: {
                'data-file-id': meta.id,
                'data-content-type': meta.contentType || '',
                'data-download-url': meta.downloadUrl || '',
                'data-original-url': meta.originalUrl || '',
                'data-thumb-url': meta.thumbUrl || '',
                'data-file-name': name
            },
            imgSrc: isImage && meta.thumbUrl ? meta.thumbUrl : null,
            fileName: name,
            contentType: meta.contentType
        });
    };

    Quiver.prototype._createUploadTile = function (file) {
        var isImage = !!(file.type && file.type.indexOf('image/') === 0);
        return this._buildTile({
            imgSrc: isImage ? URL.createObjectURL(file) : null,
            fileName: file.name,
            contentType: file.type,
            progress: true
        });
    };

    Quiver.prototype._updateTileProgress = function ($tile, fraction) {
        var offset = CIRCUMFERENCE * (1 - fraction);
        $tile.find('.progress-ring').css('stroke-dashoffset', offset);
        $tile.find('.progress-text').text(Math.round(fraction * 100) + '%');
    };

    Quiver.prototype._completeTile = function ($tile, data) {
        var name = data.fileName || data.name || '';
        $tile.attr('data-file-id', data.id);
        $tile.attr('data-content-type', data.contentType || '');
        $tile.attr('data-download-url', data.downloadUrl || '');
        $tile.attr('data-original-url', data.originalUrl || '');
        $tile.attr('data-file-name', name);
        if (name) $tile.attr('title', name);

        var serverThumb = data.url || data.thumbUrl;
        if (serverThumb) $tile.attr('data-thumb-url', serverThumb);

        // Replace the blob: preview src with the server-side thumb and revoke
        // the blob URL — otherwise the browser holds the decoded image bytes
        // for the entire tab lifetime.
        var $img = $tile.find('img').first();
        if ($img.length) {
            var oldSrc = $img.attr('src') || '';
            if (serverThumb) $img.attr('src', serverThumb);
            if (oldSrc.indexOf('blob:') === 0) {
                try { URL.revokeObjectURL(oldSrc); } catch (e) {}
            }
        }

        // Chromium reports no MIME type for HEIC, so the tile was built as an icon and has no
        // <img> to swap above. isImage is the server's own verdict — a thumbnail URL is not,
        // since the upload response carries one for every content type including documents.
        if (!$img.length && serverThumb && data.isImage) {
            $tile.find('.tile-file-icon').remove();
            $tile.prepend($('<img />').attr('src', serverThumb).attr('alt', name));
        } else if (data.contentType && data.contentType.indexOf('image/') !== 0) {
            var $iconEl = $tile.find('.tile-file-icon i');
            if ($iconEl.length) $iconEl.attr('class', 'far ' + this._getFileIcon(data.contentType));
        }

        $tile.find('.tile-progress').fadeOut(200, function () { $(this).remove(); });
    };

    Quiver.prototype._appendExistingTile = function (meta) {
        var $tile = this._buildCompletedTile(meta);
        this.$tiles.append($tile);
        return $tile;
    };

    // Removal is optimistic; a rejected delete puts the tile back, so the screen never
    // claims a deletion the server refused and then contradicts itself on reload.
    Quiver.prototype._removeAndDelete = function ($tile) {
        var self = this;
        var fileId = $tile.attr('data-file-id');
        var $prev = $tile.prev();

        if (!fileId || !this.opts.deleteOnRemove) {
            this._removeTile($tile);
            this._fireChange();
            return;
        }

        // Detached without revoking its object URL: revoking is irreversible, and a failed
        // delete puts this same node back on screen.
        this._detachTile($tile);
        this._fireChange();

        $.ajax({
            url: this.opts.deleteEndpoint,
            type: 'POST',
            data: { id: fileId, __RequestVerificationToken: this.opts.csrfToken }
        }).done(function () {
            self._revokeTileObjectUrl($tile);
        }).fail(function () {
            // A detached node still reports length 1, and .after() on it silently no-ops —
            // which would drop the tile we are restoring. Only anchor to a prev still in place.
            if ($prev.length && $.contains(self.$tiles[0], $prev[0])) {
                $prev.after($tile);
            } else {
                self.$tiles.prepend($tile);
            }

            self._syncTilesVisibility();
            self._fireChange();
            self._showError('Could not remove the attachment. Please try again.');
        });
    };

    Quiver.prototype._revokeTileObjectUrl = function ($tile) {
        var src = $tile.find('img').first().attr('src') || '';
        if (src.indexOf('blob:') === 0) {
            try { URL.revokeObjectURL(src); } catch (e) {}
        }
    };

    Quiver.prototype._detachTile = function ($tile) {
        $tile.remove();
        this._syncTilesVisibility();
    };

    Quiver.prototype._removeTile = function ($tile) {
        this._revokeTileObjectUrl($tile);
        this._detachTile($tile);
    };

    Quiver.prototype._syncTilesVisibility = function () {
        var hasTile = this.$tiles.find('.quiver-tile').length > 0;
        this.$tiles.toggleClass('quiver-tiles--has-tiles', hasTile);
    };

    Quiver.prototype._fireChange = function () {
        this._syncTilesVisibility();
        if (typeof this.opts.onChange !== 'function') return;
        this.opts.onChange(this.getFileIds(), this.getFileMeta());
    };

    Quiver.prototype.getFileIds = function () {
        var ids = [];
        this.$tiles.find('.quiver-tile[data-file-id]').each(function () {
            var v = $(this).attr('data-file-id');
            if (v) ids.push(parseInt(v, 10));
        });
        return ids;
    };

    Quiver.prototype.getFileMeta = function () {
        var meta = [];
        this.$tiles.find('.quiver-tile[data-file-id]').each(function () {
            var $t = $(this);
            var contentType = $t.attr('data-content-type') || '';
            meta.push({
                id: parseInt($t.attr('data-file-id'), 10),
                name: $t.attr('data-file-name') || '',
                contentType: contentType,
                thumbUrl: $t.attr('data-thumb-url') || ($t.find('img').attr('src') || ''),
                originalUrl: $t.attr('data-original-url') || '',
                downloadUrl: $t.attr('data-download-url') || '',
                isImage: contentType.indexOf('image/') === 0
            });
        });
        return meta;
    };

    Quiver.prototype.addFiles = function (filesArray) {
        if (!this._uploader || !filesArray || !filesArray.length) return;
        this._uploader.fineUploader('addFiles', filesArray);
    };

    Quiver.prototype.addExistingFile = function (id, meta) {
        var full = $.extend({}, meta || {}, { id: id });
        this._appendExistingTile(full);
        this._fireChange();
    };

    Quiver.prototype.setFiles = function (metaArray) {
        // Silent: setFiles is followed by _fireChange below, a single change event
        // per hydration covers both the clear and the append.
        this.silentClear();
        if (metaArray && metaArray.length) {
            var self = this;
            metaArray.forEach(function (m) {
                self._appendExistingTile(m);
            });
        }
        this._fireChange();
    };

    // Removes tiles + hidden inputs + visibility class without firing onChange.
    // Used by setFiles (which fires one change after rehydration) and by resets
    // that intentionally bypass autosave/onChange. keepUploading leaves the tiles of uploads still in flight.
    Quiver.prototype.silentClear = function (keepUploading) {
        var $removed = this.$tiles.find(keepUploading ? '.quiver-tile[data-file-id]' : '.quiver-tile');
        $removed.find('img').each(function () {
            var src = this.getAttribute('src') || '';
            if (src.indexOf('blob:') === 0) {
                try { URL.revokeObjectURL(src); } catch (e) {}
            }
        });
        $removed.remove();
        this._syncTilesVisibility();
    };

    // Clears tiles and notifies consumers via onChange. Use this from user-visible
    // reset paths (template apply clearing attachments, etc.) so autosave sees the
    // empty state and updates the server. Use silentClear for programmatic resets.
    Quiver.prototype.clear = function () {
        this.silentClear();
        this._fireChange();
    };

    // A cancelled file fires no 'complete', so the change event that every terminal tile state produces is fired here.
    Quiver.prototype.cancelQueued = function (reason) {
        if (!this._uploader) return;

        var self = this;
        var queued = this._uploader.fineUploader('getUploads', { status: qq.status.QUEUED });
        if (!queued.length) return;

        queued.forEach(function (upload) {
            self._uploader.fineUploader('cancel', upload.id);
            self._removeTile(self.$tiles.find('[data-qq-id="' + upload.id + '"]'));
        });
        self._showError(reason);
        self._fireChange();
    };

    Quiver.prototype.getInProgress = function () {
        if (!this._uploader) return 0;
        try {
            return this._uploader.fineUploader('getInProgress') || 0;
        } catch (e) {
            return 0;
        }
    };

    Quiver.prototype.triggerFilePicker = function () {
        if (!this._$button || !this._$button.length) return;
        var input = this._$button.find('input[type="file"]')[0];
        if (input) input.click();
    };

    Quiver.prototype.destroy = function () {
        var ns = this.ns;
        if (this._$dropZone) this._$dropZone.off(ns);
        if (this._$pasteTarget) this._$pasteTarget.off(ns);
        this.$container.off(ns);

        this.silentClear();

        if (this._uploader) {
            try { this._uploader.fineUploader('reset'); } catch (e) {}
            this._uploader = null;
        }
        if (this._fineUploaderHost) {
            this._fineUploaderHost.remove();
            this._fineUploaderHost = null;
        }
        this.$errors.empty();
    };

    // LightGallery lazy loader — shared across all Quiver instances.
    Quiver._lgLoaded = false;
    Quiver._lgLoadPromise = null;

    Quiver._ensureLightGallery = function () {
        if (Quiver._lgLoaded) return Promise.resolve();
        if (Quiver._lgLoadPromise) return Quiver._lgLoadPromise;

        Quiver._lgLoadPromise = new Promise(function (resolve, reject) {
            var base = (window.ORContext && window.ORContext.resourceBase) || '/content/';
            var cssUrl = base + 'css/lightgallery.css';
            var jsUrl = base + 'jscript/common/lightgallery.min.js';
            var thumbJsUrl = base + 'jscript/common/lg-thumbnail.min.js';

            if (window.quiverLightGalleryUrls) {
                cssUrl = window.quiverLightGalleryUrls.css || cssUrl;
                jsUrl = window.quiverLightGalleryUrls.main || jsUrl;
                thumbJsUrl = window.quiverLightGalleryUrls.thumb || thumbJsUrl;
            }

            // Without the stylesheet, lightGallery's container renders as a
            // default-flow element (position: static, width: 0) and the image
            // inflates inline. Wait for both CSS and JS so a fast-JS / slow-CSS
            // path doesn't open the modal before its rules apply.
            var cssPromise;
            var existingLink = document.querySelector('link[data-quiver-lg-css]');
            if (existingLink) {
                cssPromise = Promise.resolve();
            } else {
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = cssUrl;
                link.setAttribute('data-quiver-lg-css', '');
                cssPromise = new Promise(function (res) {
                    link.addEventListener('load', res, { once: true });
                    link.addEventListener('error', res, { once: true });
                });
                document.head.appendChild(link);
            }

            Promise.all([cssPromise, $.getScript(jsUrl).then(function () { return $.getScript(thumbJsUrl); })])
                .then(function () { Quiver._lgLoaded = true; resolve(); })
                .catch(reject);
        });

        return Quiver._lgLoadPromise;
    };

    Quiver.prototype._openGalleryFor = function ($tile) {
        Quiver.openGalleryFromTile($tile, {
            galleryDuringUpload: this.opts.galleryDuringUpload,
            galleryCloseOnTap: this.opts.galleryCloseOnTap,
            licenseKey: this.opts.licenseKeys && this.opts.licenseKeys.lightGallery
        });
    };

    Quiver.openGalleryFromTile = function ($tile, opts) {
        opts = opts || {};
        var contentType = $tile.attr('data-content-type') || '';

        // An image/* file the server never gave dimensions to renders as an icon tile with no
        // urls, so content type alone would open an empty lightbox. Renderers disagree on what
        // counts as an image; a usable source is the only thing the gallery actually needs.
        var hasImageSource = !!($tile.attr('data-original-url') || $tile.attr('data-thumb-url'))
            || $tile.find('img').length > 0;

        if (contentType.indexOf('image/') !== 0 || !hasImageSource) {
            var downloadUrl = $tile.attr('data-download-url');
            if (downloadUrl) window.open(downloadUrl, '_blank');
            return;
        }

        var $row = $tile.closest('.quiver-tiles');
        if (!$row.length) $row = $tile.parent();

        var galleryDuringUpload = opts.galleryDuringUpload !== false;

        var $imageTiles = $row.find('.quiver-tile').filter(function () {
            var $t = $(this);
            if (($t.attr('data-content-type') || '').indexOf('image/') === 0) return true;
            if (galleryDuringUpload && $t.attr('data-qq-id') && !$t.attr('data-file-id')) {
                var src = $t.find('img').attr('src');
                if (src && src.indexOf('blob:') === 0) return true;
            }
            return false;
        });

        var items = [];
        var startIndex = 0;
        $imageTiles.each(function (i) {
            var $t = $(this);
            if (this === $tile[0]) startIndex = i;

            var src, thumb;
            if ($t.attr('data-file-id')) {
                src = $t.attr('data-original-url') || $t.attr('data-thumb-url') || $t.find('img').attr('src');
                thumb = $t.attr('data-thumb-url') || $t.find('img').attr('src');
            } else {
                var blobSrc = $t.find('img').attr('src');
                src = blobSrc;
                thumb = blobSrc;
            }
            items.push({ src: src, thumb: thumb });
        });

        Quiver.openImages(items, startIndex, opts.licenseKey, opts.galleryCloseOnTap);
    };

    // items: [{ src, thumb, downloadUrl? }]
    Quiver.openImages = function (items, startIndex, licenseKey, closeOnTap) {
        if (!items.length) return;

        closeOnTap = closeOnTap !== false;

        Quiver._ensureLightGallery().then(function () {
            var tempContainer = document.createElement('div');
            var lgOpts = {
                dynamic: true,
                dynamicEl: items,
                plugins: [window.lgThumbnail],
                preload: 2,
                download: true,
                closeOnTap: closeOnTap,
                swipeToClose: closeOnTap,
                showCloseIcon: true,
                controls: true,
                isMobile: function () { return window.innerWidth < 768; },
                mobileSettings: {
                    controls: true,
                    showCloseIcon: true,
                    download: true,
                    allowMediaOverlap: true,
                    defaultCaptionHeight: 0,
                    thumbHeight: '56px',
                    thumbWidth: 56,
                    thumbMargin: 4
                }
            };
            if (licenseKey) lgOpts.licenseKey = licenseKey;
            else lgOpts.licenseKey = LG_LICENSE_KEY;

            var lg = window.lightGallery(tempContainer, lgOpts);

            tempContainer.addEventListener('lgAfterClose', function () {
                $('body').removeClass('or-lightgallery-open');
                lg.destroy();
            });
            // site.css keys on this class to lift the gallery above Bootstrap modals and hide the sidebars
            $('body').addClass('or-lightgallery-open');
            lg.openGallery(startIndex);
        });
    };

    // Delegate for standalone readonly tiles (Razor-rendered in draft bubbles,
    // no Quiver instance). Skip if the tile belongs to an instance so its
    // scoped handler wins.
    $(document).on('click', '.quiver--readonly .quiver-tile', function () {
        var $root = $(this).closest('.quiver-root');
        if ($root.length && $root[0].__quiver) return;
        Quiver.openGalleryFromTile($(this), { licenseKey: window.lightGalleryLicenseKey || LG_LICENSE_KEY });
    });

    // Customizers let consumers (e.g., inbox-compose) override opts before construction
    // without Quiver knowing anything about their DOM structure. Called with
    // (rootElement, opts) — mutate opts in place.
    Quiver._customizers = [];
    Quiver.addCustomizer = function (fn) {
        if (typeof fn === 'function') Quiver._customizers.push(fn);
    };

    // Walks the DOM, finds every `.quiver-root` with a `script.quiver-config` that
    // isn't already initialized, runs customizers, and instantiates Quiver. Idempotent
    // — safe to call on document-ready + any re-render event.
    Quiver.autoInit = function () {
        $('.quiver-root').each(function () {
            var root = this;

            if (root.__quiver) return;

            var $cfg = $(root).find('script.quiver-config').first();
            if (!$cfg.length) return;

            var cfg;
            try { cfg = JSON.parse($cfg.text()); }
            catch (e) { return; }

            var opts = {
                entityType: cfg.entityType,
                fieldName: cfg.fieldName,
                initialFiles: cfg.initialFiles,
                maxSize: cfg.maxSize,
                allowedExtensions: cfg.allowedExtensions,
                allowedExtensionsDisplay: cfg.allowedExtensionsDisplay,
                readonly: cfg.isReadonly,
                deleteOnRemove: cfg.deleteOnRemove,
                galleryOnClick: cfg.galleryOnClick,
                galleryDuringUpload: cfg.galleryDuringUpload,
                uploaderTemplateId: cfg.uploaderTemplateId
            };

            if (cfg.uploadEndpoint) opts.uploadEndpoint = cfg.uploadEndpoint;
            if (cfg.deleteEndpoint) opts.deleteEndpoint = cfg.deleteEndpoint;

            for (var i = 0; i < Quiver._customizers.length; i++) {
                Quiver._customizers[i](root, opts);
            }

            new Quiver(root, opts);
        });
    };

    $(function () { Quiver.autoInit(); });
    $(document).on('or-fjax-replaced', Quiver.autoInit);

    // Lazy-init Bootstrap tooltips on tile-remove buttons (BS5 requires explicit init)
    $(document).on('mouseenter', '.tile-remove[data-bs-toggle="tooltip"]', function () {
        if (window.bootstrap && !window.bootstrap.Tooltip.getInstance(this)) {
            new window.bootstrap.Tooltip(this);
        }
    });

    // Static helpers so callers don't need prototype-borrow gymnastics
    var _escaper = { _escapeHtml: Quiver.prototype._escapeHtml };
    Quiver.escapeHtml = function (str) { return Quiver.prototype._escapeHtml.call(_escaper, str); };
    Quiver.truncateFilename = function (name, max) { return Quiver.prototype._truncateFilename.call(_escaper, name, max); };
    Quiver.getFileIcon = Quiver.prototype._getFileIcon;

    window.Quiver = Quiver;

})(jQuery, window, document);

/**
 * AgentChat - Reusable AI Assistant Chat Interface
 *
 * OVERALL PROCESS:
 * 1. User types question and submits
 * 2. Question is added to conversation as user message
 * 3. Answer card structure is created and loader is shown
 * 4. EventSource connection is established for streaming response
 * 5. Server sends chunks of data (Delta, ToolUse, ToolResult, etc.)
 * 6. Each chunk type is processed and rendered appropriately
 * 7. When streaming completes, loader is hidden and send button is re-enabled
 *
 * MODES:
 * - inline: Full-page chat (existing behavior on admin chat, gumshoe, sales accounts)
 * - popup: Floating popup in layout, persists across navigation via sessionStorage
 *
 * STREAMING CHUNK TYPES:
 * - Delta: Text content to be converted to markdown and displayed
 * - ToolUse: AI is using a tool, creates tool nugget with loading state
 * - ToolResult: Tool execution completed, updates nugget with success/failure
 * - ThreadId: Conversation thread identifier for persistence
 * - AiAgentLogId: Logging identifier for the AI session
 * - error: Error message from server
 */

class AgentChat
{
    constructor(instanceId, config)
    {
        this.instanceId = instanceId;

        // DOM References — need container first for data attribute reads
        this.dom =
        {
            container: $(`#agent-chat-${instanceId}`),
            conversationInfo: $(`#agent-chat-${instanceId} [data-conversation-info]`),
            threadStatus: $(`#agent-chat-${instanceId} [data-thread-status]`),
            conversation: $(`#agent-chat-${instanceId} [data-conversation]`),
            askBox: $(`#agent-chat-${instanceId} .agent-chat-ask-box`),
            textarea: $(`#agent-chat-${instanceId} .agent-chat-ask-box textarea`),
            sendBtn: $(`#agent-chat-${instanceId} .agent-chat-ask-box button[type=submit]`),
            spacer: $(`#agent-chat-${instanceId} [data-spacer]`),
            newBtn: $(`#agent-chat-${instanceId} .chat-new-btn`),
            historyBtn: $(`#agent-chat-${instanceId} .chat-history-btn`),
            threadDebugBtn: $(`#agent-chat-${instanceId} .chat-thread-debug-btn`),
            contextDebugBtn: $(`#agent-chat-${instanceId} .chat-context-debug-btn`)
        };

        const $c = this.dom.container;

        // Configuration from data attributes, with optional overrides
        this.config =
        {
            supportWebsiteUrl: $c.data('support-url') || '',
            streamUrl: '/agentchat/askstream',
            historyStreamUrl: '/agentchat/askhistorystream',
            baseUrl: $c.data('base-url') || window.location.pathname,
            initialQuestion: $c.data('initial-question') || '',
            rateLogId: $c.data('rate-log-id') || null,
            rating: $c.data('rating') || null,
            isAdmin: $c.data('is-admin') === true,
            canRate: $c.data('can-rate') === true,
            adminLogGetUrl: $c.data('admin-log-url') || '',
            adminThreadGetUrl: $c.data('admin-thread-url') || '',
            debug: $c.data('debug') === true,
            mode: $c.data('mode') || 'inline',
            agentType: $c.data('agent-type') || '',
            docsOnly: $c.data('docs-only') === true,
            placeholder: $c.data('placeholder') || 'Ask me anything...',
            userId: $c.data('user-id') || null,
            entityType: $c.data('entity-type') ?? null,
            entityId: $c.data('entity-id') ?? null,
            entityLabel: $c.data('entity-label') || null,
            childType: $c.data('child-type') ?? null,
            childId: $c.data('child-id') ?? null,
            childLabel: $c.data('child-label') || null,
            scrollContainer: null,
            ...(config || {})
        };

        // Compute derived values
        this.config.historyUrl = encodeURI(`/agentchat/askhistory?userId=${this.config.userId}&agentType=${this.config.agentType}&baseUrl=${this.config.baseUrl}${this.isPopup ? '&isPopup=true' : ''}`);
        this.config.adminIsCrossOrigin = this.config.adminLogGetUrl ? !this.config.adminLogGetUrl.startsWith(window.location.origin) : false;

        // State
        this.state =
        {
            currentThreadId: null,
            sourceThreadId: $c.data('source-thread-id') || null,
            isStreaming: false,
            sourceHeaders: {},
            toolData: {},
            epoch: 0,
            knownMessageCount: null,
            lastQuestion: null
        };

        // Streaming state
        this.streamState =
        {
            currentEventSource: null,
            currentAiAgentLogId: null,
            feedbackRatings: {},
            hasCompleted: false,
            isLoadingHistory: false
        };

        // UI state
        this.uiState =
        {
            loaderShown: false,
            spacerHeight: 0,
            initialSpacerHeight: 0,
            autoScrollActive: false,
            _isAutoScrolling: false
        };

        // Message state
        this.messageState =
        {
            currentAnswerBlock: null,
            currentCardBody: null,
            currentMarkdownBuffer: '',
            currentCitationBuffer: '',
            isInCitation: false
        };

        this.init();

        if (this.state.sourceThreadId)
            this.loadHistory();
    }

    get isInline() { return this.config.mode === 'inline'; }
    get isPopup() { return this.config.mode === 'popup'; }

    // ============================================================================
    // INITIALIZATION
    // ============================================================================
    init()
    {
        // Store reference on DOM element for external access (popup controller, etc.)
        if (this.dom.container[0])
            this.dom.container[0]._agentChat = this;

        this.enableSendButton();
        this.bindEvents();
        this.initAutoGrow();

        if (this.isPopup)
        {
            // Move tool modal to body so it escapes popup overflow clipping
            $(`#toolModal-${this.instanceId}`).appendTo('body');

            // Popup: override new-chat to clear state instead of navigating
            this.dom.newBtn.attr("href", "#").on('click', (e) =>
            {
                e.preventDefault();
                this.resetConversation();
            });

            // Popup: global handler for history thread selection (called from AskHistory modal)
            window.rezzySelectHistory = (threadId) => this.selectHistoryThread(threadId);

            // Popup: global entry point for the chooser's "Ask Rezzy" path (ticket form). Resolves
            // the live popup instance off the container element so it survives instance replacement.
            const containerEl = this.dom.container[0];
            window.rezzyAsk = (question) =>
            {
                const inst = containerEl && containerEl._agentChat;
                if (!inst || !question) return;

                if (inst.popupState && inst.popupState.isMinimized)
                    inst.restorePopup();
                else if (!inst.popupState || !inst.popupState.isOpen)
                    inst.openPopup('rezzyAsk');

                // The chooser frames this as a new question — never append to a live conversation
                inst.resetConversation();
                inst.askQuestion(question);
            };

            // Same-page overlays (Help flyout, history modal, ticket modal) render over the
            // popup and reveal it on close — they never touch popup state. Only a real
            // navigation dismisses it: popup state persists across pages, and arriving at
            // My Support under an open popup would cover the page that lists the same
            // conversations. With an active conversation, minimize so it's easy to get back
            // to; with nothing to preserve, close outright instead of leaving a minimized shell.
            $('.rezzy-my-support-link').on('click', () =>
            {
                if (!this.popupState.isOpen || this.popupState.isMinimized)
                    return;

                if (this.dom.container.hasClass('agent-chat-active'))
                    this.minimizePopup('mySupport');
                else
                    this.closePopup('mySupport');
            });
        }
        else
        {
            this.dom.newBtn.attr("href", this.config.baseUrl);
        }
        this.dom.historyBtn.attr("href", this.config.historyUrl);

        // Admin debug links: open in new tab when cross-origin (www -> app)
        if (this.config.adminIsCrossOrigin && this.dom.threadDebugBtn.length)
        {
            this.dom.threadDebugBtn.removeClass('or-showmodal-url').attr('target', '_blank');
        }

        this.dom.contextDebugBtn.on('click', (e) =>
        {
            e.preventDefault();
            this._showContextDebug();
        });

        // Update thread status if we already have a thread ID
        if (this.state.currentThreadId)
        {
            this.dom.threadStatus.html(`Thread ID: ${this.state.currentThreadId} - This conversation will be preserved for follow-up questions.`);
        }

        if (this.config.initialQuestion)
            this.askQuestion(this.config.initialQuestion);

        this.initTooltips();

        // Inline mode: push content to bottom of viewport
        if (this.isInline)
        {
            $("body").addClass("layout-zerobottom");

            // Recompute spacer when viewport changes (mobile URL bar collapse, orientation, etc.)
            let resizeTimer = null;
            const onViewportResize = () =>
            {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() =>
                {
                    if (this.dom.container.hasClass('agent-chat-active'))
                        this.updateSpacerHeight();
                }, 100);
            };
            $(window).on('resize', onViewportResize);
            if (window.visualViewport)
                window.visualViewport.addEventListener('resize', onViewportResize);

            // After orientation change, reset scroll position to nudge iOS Safari
            // toward its compact toolbar instead of the expanded one
            screen.orientation?.addEventListener('change', () =>
            {
                if (!this.dom.container.hasClass('agent-chat-active')) return;
                window.scrollTo(0, 0);
            });
        }

        // Popup mode: init popup controller, restore state, bind beforeunload, scroll listener
        if (this.isPopup)
        {
            this.initPopupController();
            this._isUnloading = false;
            this.restorePopupState();
            $(window).on('beforeunload', () => { this._isUnloading = true; this.savePopupState(); });

            this.dom.popupScrollContainer = this.config.scrollContainer
                ? $(this.config.scrollContainer)
                : this.dom.container.closest('.rezzy-popup-body');

            if (this.dom.popupScrollContainer.length)
            {
                this.dom.popupScrollContainer.on('scroll', () =>
                {
                    if (!this.state.isStreaming || this.uiState._isAutoScrolling) return;

                    const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
                    if (!$questionBlock.length) return;

                    const targetTop = $questionBlock[0].offsetTop - 15;
                    this.uiState.autoScrollActive = Math.abs(this.dom.popupScrollContainer[0].scrollTop - targetTop) < 30;
                });
            }
        }

        // Set placeholder if there's a source thread
        if (this.state.sourceThreadId)
            this.setPlaceholder();
    }

    initTooltips()
    {
        // Touch-primary devices: a tap fires a synthetic mouseenter but never a
        // mouseleave, pinning the tooltip over whatever the tap opened. Skip entirely.
        if (window.matchMedia('(hover: none)').matches)
            return;

        const $el = this.dom.container.find('[data-toggle="tooltip"], [data-bs-toggle="tooltip"]').filter('[title]');
        if (!$el.length) return;

        this._tooltipEls = $el;

        // trigger: hover only — the default 'hover focus' pins a tooltip to the
        // still-focused button after a click, and shows two at once (one focused,
        // one hovered)
        if (typeof $.fn.tooltip === 'function')
            $el.tooltip({ container: 'body', trigger: 'hover' });
        else if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip)
            $el.each(function() { new bootstrap.Tooltip(this, { trigger: 'hover' }); });

        // A click swaps the UI under the cursor or opens an overlay — the tooltip
        // must not outlive it
        $el.on('click', () => this._hideChatTooltips());
    }

    initAutoGrow()
    {
        const textarea = this.dom.textarea[0];
        if (!textarea) return;

        textarea.addEventListener("input", () => this._autoGrowTextarea());
        this._autoGrowTextarea();
    }

    _autoGrowTextarea()
    {
        const MAX_HEIGHT = 80;
        const el = this.dom.textarea[0];
        if (!el) return;

        el.style.height = "0px";
        const newHeight = Math.min(el.scrollHeight, MAX_HEIGHT);
        el.style.height = newHeight + "px";
        el.style.overflowY = el.scrollHeight > MAX_HEIGHT ? "auto" : "hidden";
    }

    _resetTextarea()
    {
        this.dom.textarea.val("").addClass("agent-chat-textarea-reset");
        const ta = this.dom.textarea[0];
        if (!ta) return;

        if (this.isInline && window.matchMedia('(hover: none) and (pointer: coarse)').matches) ta.blur();

        const applyResetStyles = () =>
        {
            ta.style.setProperty("height", "34px", "important");
            ta.style.setProperty("max-height", "34px", "important");
            ta.style.setProperty("min-height", "34px", "important");
            ta.style.setProperty("overflow-y", "hidden", "important");
        };
        requestAnimationFrame(applyResetStyles);
    }

    setPlaceholder()
    {
        this.dom.textarea.attr("placeholder", this.config.placeholder);
    }

    bindEvents()
    {
        this.dom.textarea.on('input', () =>
        {
            // iOS: keydown fired for Enter, iOS inserted newline anyway
            if (this._enterSending)
            {
                this._enterSending = false;
                const val = this.dom.textarea.val();
                if (val.includes('\n'))
                    this.dom.textarea.val(val.replace(/\n/g, ''));
                return;
            }

            // iOS: Send tapped during composition — keydown never fired
            const val = this.dom.textarea.val();
            if (val.endsWith('\n') && !this._shiftHeld)
            {
                const question = val.replace(/\n+$/, '').trim();
                this._resetTextarea();
                if (question && !this.dom.sendBtn.prop('disabled'))
                    this.askQuestion(question);
                return;
            }

            if (val.trim().length > 0)
            {
                this.dom.textarea.removeClass("agent-chat-textarea-reset");
                const el = this.dom.textarea[0];
                el.style.removeProperty("height");
                el.style.removeProperty("max-height");
                el.style.removeProperty("min-height");
                el.style.removeProperty("overflow-y");
            }
            this.enableSendButton();
        });

        // Popup draft persistence: save on blur (focus out) + savePopupState runs on
        // beforeunload, together covering nav, tab close, and in-page focus changes.
        if (this.isPopup)
        {
            this.dom.textarea.on('blur', () => this._saveDraft());
        }
        this.dom.textarea.on('keydown', (e) =>
        {
            this._shiftHeld = e.shiftKey;
            this.handleKeydown(e);
        });
        this.dom.textarea.on('keyup', (e) => { if (e.key === 'Shift') this._shiftHeld = false; });
        this.dom.sendBtn.on('click', () => this.askQuestion());
        this.dom.conversation.on('click', '.tool-nugget', (e) => this.handleToolClick(e));

        // Delegated so the binding survives a popup html() restore; data-question keeps each
        // bubble's resend tied to the question that failed.
        this.dom.conversation.on('click', '.agent-answer-retryable-error button', (e) =>
        {
            if (this.state.isStreaming)
                return;

            const $bubble = $(e.currentTarget).closest('.agent-answer-retryable-error');
            const question = $bubble.attr('data-question');

            $bubble.remove();
            try { sessionStorage.removeItem('rezzy_retryQuestion'); } catch (err) { }

            if (question)
                this.askQuestion(question);
        });
    }

    // ============================================================================
    // MAIN QUESTION FLOW
    // ============================================================================
    askQuestion(question)
    {
        // Programmatic re-asks (Try again, restored pending questions) pass the question in and must
        // not clear the compose box — the user may have typed a new draft since.
        const fromTextarea = !question;

        if (!question)
            question = this.dom.textarea.val().trim();

        if (!question) return;

        this.state.lastQuestion = question;

        this.dom.conversation.find('.agent-answer-retryable-error').remove();
        try { sessionStorage.removeItem('rezzy_retryQuestion'); } catch (err) { }

        if (fromTextarea)
            this._resetTextarea();

        this.state.isStreaming = true;

        // Popup: mark streaming active in sessionStorage immediately so it survives
        // page teardown (EventSource onerror fires before beforeunload and clears isStreaming)
        if (this.isPopup)
        {
            sessionStorage.setItem('rezzy_streaming', 'true');
            sessionStorage.setItem('rezzy_pendingQuestion', question);
            sessionStorage.setItem('rezzy_threadIdReceived', 'false');

            if (fromTextarea)
                sessionStorage.removeItem('rezzy_draft');

            if (this.state.currentThreadId)
                sessionStorage.setItem('rezzy_pendingThreadId', this.state.currentThreadId);
            else
                sessionStorage.removeItem('rezzy_pendingThreadId');
        }

        this.resetSpacer();
        this.addUserMessage(question);
        this.dom.sendBtn.prop('disabled', true);
        this.showConversation();
        this.setPlaceholder();

        if (!this.state.currentThreadId)
            this.dom.threadStatus.text("Starting new conversation...");

        this.calculateInitialSpacer();
        this.startNewAnswer();

        if (this.isPopup)
        {
            this.uiState.autoScrollActive = true;
            this._popupAutoScroll();
        }

        this.startStream(question);

        // Scroll again after keyboard fully closes (inline)
        if (this.isInline)
            setTimeout(() => this.scrollToBottom(), 500);
    }

    // ============================================================================
    // HISTORY LOADING
    // ============================================================================
    loadHistory()
    {
        this.dom.conversation.empty();
        this.streamState.isLoadingHistory = true;
        this.state.isStreaming = true;
        this.showConversation();
        this.startStream(null, true);

        this.dom.threadStatus.html(`Viewing conversation history for thread ${this.state.sourceThreadId}...`);

        if (this.config.isAdmin && this.dom.threadDebugBtn.length)
        {
            this.dom.threadDebugBtn.attr('href', `${this.config.adminThreadGetUrl}?id=${this.state.sourceThreadId}`);
            this.dom.container.find('[data-thread-log]').show();
        }

        // Show rating modal after history loads if rateLogId is present
        if (this.config.rateLogId && this.config.canRate)
        {
            this.streamState.pendingRateLogId = this.config.rateLogId;
        }
    }

    // ============================================================================
    // STREAMING MANAGEMENT
    // ============================================================================
    startStream(question, isHistory)
    {
        // Close explicitly: past the epoch bump the orphaned source's handlers early-return on the
        // stale-epoch guard, so nothing else closes it and it keeps reconnecting to its URL.
        this.closeStream();

        this.state.epoch++;
        this.resetStreamState();
        this.streamState.isLoadingHistory = isHistory;

        this._openEventSource(question, isHistory);
    }

    _openEventSource(question, isHistory)
    {
        const url = isHistory ? this.config.historyStreamUrl : this.config.streamUrl;
        const params = new URLSearchParams();

        if (this.state.sourceThreadId)
            params.append('sourceThreadId', this.state.sourceThreadId);

        params.append('agentType', this.config.agentType);

        if (isHistory)
        {
            params.append('threadId', this.state.sourceThreadId);
        }
        else
        {
            params.append('question', question);
            params.append('threadId', this.state.currentThreadId || '');
            params.append('userId', this.config.userId);
            params.append('docsOnly', this.config.docsOnly);
            params.append('isPopup', this.isPopup);

            if (this.isPopup)
            {
                params.append('pageUrl', window.location.pathname);
                params.append('pageTitle', document.title.substring(0, 200));

                // Server persists this only at thread creation.
                if (this.state.launchSource)
                {
                    params.append('launchSource', this.state.launchSource);

                    // Left in storage, this key would carry over onto the next page's conversation.
                    try { sessionStorage.removeItem('rezzy_launch_source'); } catch (err) { }
                }

                const context = this._buildContextEnvelope();
                if (context)
                    params.append('context', context);

                // Shed context first when the query string nears IIS's 8192-char cap
                // (maxQueryStringLength / maxQueryString in Web.config); pageUrl/pageTitle
                // still ride as their own params.
                if (params.toString().length > 7500 && params.has('context'))
                    params.delete('context');
            }
        }

        this.streamState.currentEventSource = new EventSource(`${url}?${params.toString()}`);

        const epoch = this.state.epoch;
        this.streamState.currentEventSource.onmessage = (e) =>
        {
            if (this.state.epoch !== epoch) return;

            let chunk;
            try
            {
                chunk = JSON.parse(e.data);
            }
            catch (parseError)
            {
                this.handleError('Unable to connect to Ask Rezzy. Please refresh the page and try again.');
                return;
            }

            this.handleStreamMessage(chunk);
        };
        // EventSource fires no close event - normal completion arrives as the in-band Done chunk
        // in onmessage; a dropped connection surfaces here instead.
        this.streamState.currentEventSource.onerror = (e) =>
        {
            if (this.state.epoch !== epoch) return;
            this.handleStreamError(e);
        };
    }

    // ============================================================================
    // CONTEXT ENVELOPE (Ask Rezzy context injection)
    // ============================================================================

    // Returns null when there's nothing to send; drops message lists to stay under 900 chars.
    _buildContextEnvelope()
    {
        const envelope = {};

        const entityType = this.config.entityType;
        const entityId = this.config.entityId;

        if (entityType && entityId)
        {
            envelope.entity = { type: entityType, id: entityId };

            if (this.config.entityLabel)
                envelope.entity.label = this.config.entityLabel;

            if (this.config.childType && this.config.childId)
            {
                envelope.entity.childType = this.config.childType;
                envelope.entity.childId = this.config.childId;

                if (this.config.childLabel)
                    envelope.entity.childLabel = this.config.childLabel;
            }
        }

        const validation = this._readVisibleValidation();
        if (validation)
            envelope.validation = validation;

        const lastError = this._readLastError();

        // pagePath stays client-side (it drives the chip); the request url is what the
        // agent needs for diagnosis.
        if (lastError)
            envelope.lastError = { url: lastError.url, status: lastError.status, messages: lastError.messages, count: lastError.count };

        if (!Object.keys(envelope).length)
            return null;

        let json = JSON.stringify(envelope);

        // Over budget: drop validation messages first, then lastError messages. Counts stay.
        if (json.length > 900 && envelope.validation && envelope.validation.messages)
        {
            delete envelope.validation.messages;
            json = JSON.stringify(envelope);
        }

        if (json.length > 900 && envelope.lastError && envelope.lastError.messages)
        {
            delete envelope.lastError.messages;
            json = JSON.stringify(envelope);
        }

        return json;
    }

    // Collects visible client-side validation errors: the summary list plus per-field
    // messages. Deduped, trimmed, first 3 each capped at 200 chars. Null when none.
    _readVisibleValidation()
    {
        const texts = [];
        const seen = {};

        const collect = ($els) =>
        {
            $els.each(function ()
            {
                const t = ($(this).text() || '').trim();

                if (t.length && !seen[t])
                {
                    seen[t] = true;
                    texts.push(t);
                }
            });
        };

        // :visible inside the selector bypasses querySelectorAll and makes jQuery match elements by hand
        collect($('.validation-summary-errors li').filter(':visible'));
        collect($('.form-group.has-error .invalid-feedback, .form-group.has-error .help-block, .field-validation-error').filter(':visible'));

        if (!texts.length)
            return null;

        return {
            count: texts.length,
            messages: texts.slice(0, 3).map((m) => m.substring(0, 200))
        };
    }

    // The most recent non-expired API error (written by common.js). Null when none or
    // unreadable. Storage access is try/catch-wrapped for private-mode safety.
    _readLastError()
    {
        try
        {
            const raw = sessionStorage.getItem('or_lastApiError');
            if (!raw)
                return null;

            const e = JSON.parse(raw);

            // TTL pairs with common.js recordApiErrorForRezzy's window — change together.
            if (!e || (Date.now() - e.at) >= 10 * 60 * 1000)
                return null;

            return {
                url: e.url || null,
                pagePath: e.pagePath || null,
                status: e.status || 0,
                messages: Array.isArray(e.messages) ? e.messages.slice(0, 3) : [],
                count: e.count || 1
            };
        }
        catch (err)
        {
            return null;
        }
    }

    handleStreamMessage(chunk)
    {
        this.streamState.hasReceivedData = true;

        // First SSE chunk in popup mode: agent is responding, so pendingQuestion is no longer needed.
        if (this.isPopup && !this.streamState._pendingQuestionCleared)
        {
            this.streamState._pendingQuestionCleared = true;
            sessionStorage.removeItem('rezzy_pendingQuestion');
        }

        // Handle thread ID
        if (chunk.ThreadId)
        {
            if (!this.state.currentThreadId)
            {
                this.state.currentThreadId = chunk.ThreadId;
                this.state.sourceThreadId = null;
                this.dom.threadStatus.html(`Thread ID: ${chunk.ThreadId} - This conversation will be preserved for follow-up questions.`);

                if (this.config.isAdmin && this.dom.threadDebugBtn.length)
                {
                    this.dom.threadDebugBtn.attr('href', `${this.config.adminThreadGetUrl}?id=${chunk.ThreadId}`);
                    this.dom.container.find('[data-thread-log]').show();
                }

                // Inline: update browser URL to reflect the current thread
                // Popup: save to sessionStorage instead
                if (this.isInline)
                {
                    var url = new URL(window.location.href);
                    url.searchParams.set('sourceThreadId', chunk.ThreadId);
                    url.searchParams.delete('rateLogId');
                    url.searchParams.delete('rating');

                    // The thread now holds the question, so a reload replays history; leaving q would
                    // re-ask it and abandon that answer. Before here, q is the retry's only copy.
                    url.searchParams.delete('q');

                    history.replaceState(null, '', url.toString());
                }
                else if (this.isPopup)
                {
                    sessionStorage.setItem('rezzy_activeThreadId', chunk.ThreadId);
                    sessionStorage.removeItem('rezzy_sourceThreadId');
                    sessionStorage.setItem('rezzy_agentType', this.config.agentType);
                }
            }

            if (chunk.MessageCount != null)
            {
                this.state.knownMessageCount = chunk.MessageCount;

                if (this.isPopup)
                {
                    sessionStorage.setItem('rezzy_knownMessageCount', chunk.MessageCount.toString());
                    sessionStorage.setItem('rezzy_threadIdReceived', 'true');
                }
            }
        }

        if (chunk.AiAgentLogId > 0 && !this.streamState.currentAiAgentLogId)
            this.streamState.currentAiAgentLogId = chunk.AiAgentLogId;

        if (chunk.error) return this.handleError(chunk.error, chunk.retryable === true);

        // Server signals stream completed normally — close immediately
        if (chunk.Done)
        {
            this.streamState._serverDone = true;
            this.closeStream();
            this.completeStream();
            return;
        }

        // History replay: whether the thread already produced a ticket (durable escalation state)
        if (chunk.Escalated != null)
        {
            this.streamState.threadEscalated = chunk.Escalated;
            return;
        }

        if (chunk.FeedbackRatings)
        {
            this.streamState.feedbackRatings = chunk.FeedbackRatings;
            return;
        }

        // Handle user messages in history
        if (chunk.IsUserMessage && chunk.Delta)
        {
            // Not rendered: the context chip is the user-facing surface for the same facts.
            // Literal must match PageContextMarker in UserSupportAgent.cs — change both together.
            if (chunk.Delta.startsWith("[User's current page context: "))
                return;

            // If we have a current answer being built, we need to finish it
            if (this.messageState.currentAnswerBlock)
            {
                this.finalizeCurrentAnswer();
            }

            this.addUserMessage(chunk.Delta);
            return;
        }

        // Handle AI response content
        if (chunk.Delta || chunk.ToolUse || chunk.ToolResult)
        {
            // If we don't have a current answer block, start one — will only happen for history
            if (!this.messageState.currentAnswerBlock)
            {
                this.startNewAnswer(true); // true = skip loader for history
            }

            if (chunk.ToolResult) { this.handleToolResult(chunk); this._popupAutoScroll(); return; }
            if (chunk.ToolUse) { this.handleToolUse(chunk); this._popupAutoScroll(); return; }
            if (chunk.Delta)
            {
                this.processContent(chunk.Delta);
                this.updateSpacerHeight();
                this._popupAutoScroll();
                return;
            }
        }
    }

    handleStreamError(error)
    {
        this.closeStream();

        // Handle Event object from EventSource
        let errorMessage = 'Unknown error. Please try again.';

        if (error && typeof error === 'object')
        {
            if (error.target && error.target.readyState === EventSource.CLOSED)
            {
                if (!this.streamState.hasReceivedData)
                {
                    // Closed before any data arrived — likely a redirect to HTML (e.g. billing page)
                    errorMessage = 'Unable to connect to Ask Rezzy. Please refresh the page and try again.';
                }
                else
                {
                    // Normal close after data was received
                    errorMessage = null;
                }
            }
            else if (error.message)
            {
                errorMessage = error.message;
            }
        }
        else if (typeof error === 'string')
        {
            errorMessage = error;
        }

        if (errorMessage)
        {
            this.processContent(errorMessage);
        }

        this.completeStream();
    }

    completeStream()
    {
        this.hideLoader();

        if (this.streamState.hasCompleted) return;

        this.streamState.hasCompleted = true;
        this.state.isStreaming = false;
        this.uiState.autoScrollActive = false;

        // Finalize any current answer
        if (this.messageState.currentAnswerBlock)
        {
            this.finalizeCurrentAnswer();
        }

        this.enableSendButton();

        // If we were loading history, fill the viewport so the sticky askBox lands at the bottom.
        if (this.streamState.isLoadingHistory)
        {
            this.resetSpacer();

            // Re-render a replayed offer only when the server confirmed no ticket exists — an
            // interrupted replay never gets the Escalated chunk, and re-offering risks a duplicate.
            if (this.streamState.pendingEscalateOffer && this.streamState.threadEscalated === false)
            {
                this.dom.conversation.append(this.buildEscalateCard());
            }
            this.streamState.pendingEscalateOffer = null;

            this.updateSpacerHeight();
            this.scrollToBottom();
            this.streamState.isLoadingHistory = false;

            if (this.isPopup)
            {
                try
                {
                    if (sessionStorage.getItem('rezzy_reattachRetry'))
                    {
                        sessionStorage.removeItem('rezzy_reattachRetry');
                        this._reattachRetryBubble();
                    }
                }
                catch (err) { }
            }

            // Show rating prompt if we had a pending rateLogId with rating
            if (this.streamState.pendingRateLogId && this.config.rating != null)
            {
                const rateLogId = this.streamState.pendingRateLogId;
                this.streamState.pendingRateLogId = null;
                setTimeout(() => this.handleRating(null, rateLogId, this.config.rating), 500);
            }
        }
        else
        {
            this.updateSpacerHeight();
            if (this.isInline) this.scrollToBottom();
        }

        // Popup: only clear streaming flag if server sent Done signal (clean finish).
        // If this completeStream was triggered by EventSource onerror during page teardown,
        // _serverDone won't be set — leave rezzy_streaming='true' so the next page polls.
        if (this.isPopup)
        {
            if (this.streamState._serverDone)
                sessionStorage.setItem('rezzy_streaming', 'false');

            this.savePopupState();
        }
    }

    closeStream()
    {
        if (this.streamState.currentEventSource)
        {
            this.streamState.currentEventSource.close();
        }
    }

    resetStreamState()
    {
        this.streamState.hasCompleted = false;
        this.streamState.currentAiAgentLogId = null;
        this.streamState.suppressRating = false;
        this.streamState.feedbackRatings = {};
        this.streamState.isLoadingHistory = false;
        this.streamState._pendingQuestionCleared = false;
        this.streamState._serverDone = false;
        this.streamState.hasReceivedData = false;
        this.streamState.threadEscalated = null;
        this.streamState.pendingEscalateOffer = null;
    }

    // ============================================================================
    // UI STATE MANAGEMENT
    // ============================================================================
    enableSendButton()
    {
        const hasText = this.dom.textarea.val().trim().length > 0;
        this.dom.sendBtn.prop('disabled', !hasText || this.state.isStreaming);
    }

    showLoader()
    {
        if (this.streamState.isLoadingHistory)
            return;

        this.dom.conversation.find('[data-loader]').remove();
        const loader = $('<div class="mb-3" data-loader><div class="w-100"><div class=""><div class="loader"></div></div></div></div>');
        this.dom.conversation.append(loader);
        this.uiState.loaderShown = true;
    }

    hideLoader()
    {
        this.dom.conversation.find('[data-loader]').remove();
        this.uiState.loaderShown = false;
    }

    showConversation()
    {
        this.dom.container.addClass('agent-chat-active');
        if (this.isInline)
            $('html').addClass('--rezzy-inline-active');
        this.dom.conversationInfo.show();
        this.linkHeightChain();
    }

    /**
     * A flex height chain only resolves if every wrapper between .app-body-container and the
     * chat participates, so mark them all rather than guessing the nesting depth in CSS.
     */
    linkHeightChain()
    {
        if (!this.isInline || !this.dom.container.closest('.app-body-container').length) return;

        this.dom.container.parentsUntil('.app-body-container').addClass('agent-chat-height-link');
    }

    resetSpacer()
    {
        this.dom.spacer.css('min-height', '0');
        this.uiState.spacerHeight = 0;
        this.uiState.initialSpacerHeight = 0;
    }

    // Spacer math and scrollToQuestion must subtract the same top-space, or scrollbar grows past it.
    getReservedTopSpace()
    {
        const bodyPad = parseFloat(getComputedStyle(document.body).paddingTop) || 0;
        const convInfoH = this.dom.conversationInfo.is(':visible') ? this.dom.conversationInfo.outerHeight() : 0;
        return bodyPad + convInfoH + 15;
    }

    computeSpacerHeight()
    {
        // Doc must be at least innerHeight so the sticky askBox sits at viewport bottom.
        // If there's a new question, also ensure room to scroll it to top.
        let targetDocHeight = window.innerHeight;
        const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
        if ($questionBlock.length)
            targetDocHeight = Math.max(targetDocHeight, $questionBlock.offset().top - this.getReservedTopSpace() + window.innerHeight);

        const currentSpacer = parseFloat(this.dom.spacer.css('min-height')) || 0;
        // body.scrollHeight is the true content height; html.scrollHeight floors at viewport.
        const delta = targetDocHeight - document.body.scrollHeight;

        return Math.max(0, currentSpacer + delta);
    }

    calculateInitialSpacer()
    {
        // Popup and inline: flex layout handles positioning, no spacer needed
        if (this.isPopup) return;
        if (this.isInline)
        {
            this.scrollToBottom();
            return;
        }

        setTimeout(() =>
        {
            const neededSpacer = this.computeSpacerHeight();
            this.uiState.initialSpacerHeight = neededSpacer;
            this.uiState.spacerHeight = neededSpacer;
            this.dom.spacer.css('min-height', neededSpacer + 'px');
            requestAnimationFrame(() => this.scrollToQuestion());
        }, 10);
    }

    updateSpacerHeight()
    {
        // Popup and inline: flex layout handles positioning, no spacer needed
        if (this.isPopup) return;
        if (this.isInline && this.dom.container.hasClass('agent-chat-active'))
        {
            this.dom.conversation[0].scrollTop = this.dom.conversation[0].scrollHeight;
            return;
        }

        this.dom.spacer.css('min-height', this.computeSpacerHeight() + 'px');

        // Doc grows as the answer fills in, so re-pin the question while streaming.
        if (this.state.isStreaming) this.scrollToQuestion();
    }

    scrollToQuestion()
    {
        if (this.isPopup)
        {
            if (this.dom.popupScrollContainer?.length)
            {
                const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
                if ($questionBlock.length)
                    this.dom.popupScrollContainer[0].scrollTop = $questionBlock[0].offsetTop - 15;
            }
            return;
        }

        // Inline: conversation scrolls internally (flex layout)
        if (this.isInline && this.dom.container.hasClass('agent-chat-active'))
        {
            const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
            if ($questionBlock.length)
                this.dom.conversation[0].scrollTop = $questionBlock[0].offsetTop - 15;
            return;
        }

        const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
        if (!$questionBlock.length) return;

        window.scrollTo(
        {
            top: $questionBlock.offset().top - this.getReservedTopSpace(),
            behavior: 'instant'
        });
    }

    scrollToBottom()
    {
        if (this.isPopup)
        {
            if (this.dom.popupScrollContainer?.length)
            {
                const container = this.dom.popupScrollContainer[0];
                const snap = () => { container.scrollTop = container.scrollHeight; };

                // Two passes: first for already-rendered content, second for
                // late-settling markdown/citation/tool-nugget layout (history load).
                setTimeout(snap, 100);
                setTimeout(() =>
                {
                    snap();
                    this.dom.textarea.focus();
                }, 350);
            }
            return;
        }

        // Inline: scroll conversation to bottom (internal scroll, same as inbox)
        setTimeout(() =>
        {
            this.dom.conversation[0].scrollTop = this.dom.conversation[0].scrollHeight;
            if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) this.dom.textarea.focus();
        }, 100);
    }

    _popupAutoScroll()
    {
        if (!this.isPopup || !this.uiState.autoScrollActive) return;
        if (!this.dom.popupScrollContainer?.length) return;

        const $questionBlock = this.dom.conversation.children('.agent-question-block').last();
        if (!$questionBlock.length) return;

        this.uiState._isAutoScrolling = true;
        this.dom.popupScrollContainer[0].scrollTop = $questionBlock[0].offsetTop - 15;
        requestAnimationFrame(() => { this.uiState._isAutoScrolling = false; });
    }

    // ============================================================================
    // MESSAGE RENDERING
    // ============================================================================
    addUserMessage(message)
    {
        const $userMsg = $('<div class="mb-3 agent-question-block">').append(
            $('<div class="agent-question-question">').append(
                $('<div class="">').text(message)
            )
        );

        this.dom.conversation.append($userMsg);
        this.showConversation();
    }

    createAnswerActions(cardBody, aiAgentLogId, suppressRating)
    {
        const $actions = $('<div class="agent-answer-actions">');

        // Copy button — always show
        $actions.append(
            $('<button type="button" title="Copy HTML (Ctrl+click for Markdown)"><i class="far fa-copy"></i></button>')
                .on('click', (e) => this.handleCopyAnswer(cardBody, e))
        );

        if (aiAgentLogId > 0)
        {
            const savedRating = this.streamState.feedbackRatings[aiAgentLogId];
            if (savedRating)
            {
                $actions.append($('<span class="agent-saved-rating" role="status">')
                    .addClass(savedRating > 0 ? 'text-success' : 'text-danger')
                    .attr('title', savedRating > 0 ? 'Rated good' : 'Rated bad')
                    .append($('<i class="far" aria-hidden="true">').addClass(savedRating > 0 ? 'fa-thumbs-up' : 'fa-thumbs-down'))
                    .append($('<span class="sr-only visually-hidden">').text(savedRating > 0 ? 'Rated good' : 'Rated bad')));
            }
            else if (this.config.canRate && !suppressRating)
            {
                $actions.append(
                    $('<button type="button" title="Thumbs Up" class="btn-rate-yay"><i class="far fa-thumbs-up" ></i></button>')
                        .on('click', () => this.handleRating(cardBody, aiAgentLogId, 1))
                );

                $actions.append(
                    $('<button type="button" title="Thumbs Down" class="btn-rate-boo"><i class="far fa-thumbs-down"></i></button>')
                        .on('click', () => this.handleRating(cardBody, aiAgentLogId, -1))
                );
            }

            $actions.data('aiAgentLogId', aiAgentLogId);

            if (this.config.isAdmin)
            {
                var logUrl = `${this.config.adminLogGetUrl}?id=${aiAgentLogId}`;
                var $logLink = this.config.adminIsCrossOrigin
                    ? $(`<a title="View Log" class="admin-only-btn" href="${logUrl}" target="_blank"><i class="far fa-scroll"></i></a>`)
                    : $(`<a title="View Log" class="admin-only-btn or-showmodal-url" href="${logUrl}"><i class="far fa-scroll"></i></a>`);
                $actions.append($logLink);
            }
        }

        return $actions;
    }

    startNewAnswer(skipLoader)
    {
        this.messageState.currentAnswerBlock = null;
        this.messageState.currentCardBody = null;
        this.messageState.currentMarkdownBuffer = '';
        this.messageState.currentCitationBuffer = '';
        this.messageState.isInCitation = false;
        this.state.escalateShownThisAnswer = false;

        // Create the answer structure upfront
        this.messageState.currentAnswerBlock = $('<div class="mb-3">');
        const card = $('<div class="w-100">');
        this.messageState.currentCardBody = $('<div class="agent-answer-block">');
        this.messageState.currentCardBody.append($('<div class="markdown-content">'));
        card.append(this.messageState.currentCardBody);
        this.messageState.currentAnswerBlock.append(card);
        this.dom.conversation.append(this.messageState.currentAnswerBlock);

        if (!skipLoader) this.showLoader();
    }

    finalizeCurrentAnswer()
    {
        // Ensure any buffered content is rendered
        if (this.messageState.currentMarkdownBuffer)
        {
            this.updateMarkdownContent();
        }

        // Add action buttons (copy always, thumbs only if valid aiAgentLogId)
        if (this.messageState.currentCardBody)
        {
            const $actions = this.createAnswerActions(this.messageState.currentCardBody, this.streamState.currentAiAgentLogId, this.streamState.suppressRating);
            this.messageState.currentCardBody.append($actions);
        }

        // Reset so next message can get its own ID
        this.streamState.currentAiAgentLogId = null;

        // Reset the message state
        this.messageState.currentAnswerBlock = null;
        this.messageState.currentCardBody = null;
        this.messageState.currentMarkdownBuffer = '';
        this.messageState.currentCitationBuffer = '';
        this.messageState.isInCitation = false;
    }

    /**
     * Inserts special content (tool nuggets, citations, etc.) that interrupts markdown flow
     */
    insertSpecialContent($content)
    {
        // Finalize any current markdown
        this.updateMarkdownContent();

        // Clear the buffer
        this.messageState.currentMarkdownBuffer = '';

        // Insert the special content
        this.messageState.currentCardBody.append($content);

        // Create a new markdown content div for any following content
        this.messageState.currentCardBody.append($('<div class="markdown-content">'));

        // Update UI if needed
        this.updateSpacerHeight();
    }

    processContent(content)
    {
        if (!content) return;

        // Add content to appropriate buffer
        if (this.messageState.isInCitation)
        {
            this.messageState.currentCitationBuffer += content;
        }
        else
        {
            this.messageState.currentMarkdownBuffer += content;
        }

        // Process any complete citations in the buffers
        this.extractAndProcessCitations();

        this.updateMarkdownContent();
    }

    extractAndProcessCitations()
    {
        // If we're in citation mode, check if we can complete it
        if (this.messageState.isInCitation)
        {
            const citationHtml = this.tryParseCitation(this.messageState.currentCitationBuffer);
            if (citationHtml)
            {
                // Citation completed
                this.insertSpecialContent(citationHtml.citation);

                // Add any remaining content back to markdown buffer
                this.messageState.currentMarkdownBuffer += citationHtml.remainder;

                this.messageState.isInCitation = false;
                this.messageState.currentCitationBuffer = '';
                this.hideLoader();

                // Process any additional citations in the remainder
                this.extractAndProcessCitations();
            }
            return;
        }

        // Look for citation/tstat starts in markdown buffer
        while (true)
        {
            let saIdx = this.messageState.currentMarkdownBuffer.indexOf('{ "SaId"');
            if (saIdx === -1) saIdx = this.messageState.currentMarkdownBuffer.indexOf('{"SaId"');
            let tstatIdx = this.messageState.currentMarkdownBuffer.indexOf('{ "tstat"');
            if (tstatIdx === -1) tstatIdx = this.messageState.currentMarkdownBuffer.indexOf('{"tstat"');
            let topicsIdx = this.messageState.currentMarkdownBuffer.indexOf('{ "unverifiedTopics"');
            if (topicsIdx === -1) topicsIdx = this.messageState.currentMarkdownBuffer.indexOf('{"unverifiedTopics"');
            let escIdx = this.messageState.currentMarkdownBuffer.indexOf('{ "escalate"');
            if (escIdx === -1) escIdx = this.messageState.currentMarkdownBuffer.indexOf('{"escalate"');

            const startCandidates = [saIdx, tstatIdx, topicsIdx, escIdx].filter(i => i !== -1);
            if (!startCandidates.length) break;
            const citationStartIndex = Math.min(...startCandidates);

            // Extract content before citation
            const beforeCitation = this.messageState.currentMarkdownBuffer.substring(0, citationStartIndex);
            const afterCitationStart = this.messageState.currentMarkdownBuffer.substring(citationStartIndex);

            // Try to parse citation from this point
            const citationResult = this.tryParseCitation(afterCitationStart);

            if (citationResult)
            {
                // Complete citation found
                this.messageState.currentMarkdownBuffer = beforeCitation;
                this.updateMarkdownContent();

                this.insertSpecialContent(citationResult.citation);

                // Continue with remainder
                this.messageState.currentMarkdownBuffer = citationResult.remainder;
                this.hideLoader();
            }
            else
            {
                // Incomplete citation — switch to citation mode
                this.messageState.currentMarkdownBuffer = beforeCitation;
                this.updateMarkdownContent();

                this.messageState.currentCitationBuffer = afterCitationStart;
                this.messageState.isInCitation = true;
                this.showLoader();
                break;
            }
        }
    }

    tryParseCitation(buffer)
    {
        // Find each } and try to parse JSON up to that point
        let braceIndex = 0;
        while ((braceIndex = buffer.indexOf('}', braceIndex)) !== -1)
        {
            const candidateJson = buffer.substring(0, braceIndex + 1);

            try
            {
                JSON.parse(candidateJson);

                // Valid JSON found
                const citationHtml = this.processCitationChunk(candidateJson);
                const remainder = buffer.substring(braceIndex + 1);

                return {
                    citation: citationHtml,
                    remainder: remainder
                };
            }
            catch (e)
            {
                // Not valid JSON yet, try next }
                braceIndex++;
            }
        }

        // No complete citation found
        return null;
    }

    updateMarkdownContent()
    {
        if (this.messageState.currentCardBody)
        {
            let $lastMarkdown = this.messageState.currentCardBody.children('.markdown-content').last();
            if ($lastMarkdown.length === 0)
            {
                $lastMarkdown = $('<div class="markdown-content">').appendTo(this.messageState.currentCardBody);
            }

            let html = marked.parse(this.messageState.currentMarkdownBuffer);

            html = DOMPurify.sanitize(html)

            $lastMarkdown
                .html(html)
                .data("markdown", this.messageState.currentMarkdownBuffer);
        }
    }

    // ============================================================================
    // CITATION PROCESSING
    // ============================================================================
    processCitationChunk(citationJson)
    {
        try
        {
            const citation = JSON.parse(citationJson);
            if (citation.tstat)
            {
                return this.renderTstatNugget(citation);
            }

            if (citation.unverifiedTopics)
            {
                // Telemetry marker persisted server-side; never rendered
                return $('<span>');
            }

            if (citation.escalate)
            {
                return this.renderEscalateCard(citation.escalate);
            }

            if (citation.SaId)
            {
                const article = this.state.sourceHeaders[citation.SaId];
                const title = article?.Title;
                const baseUrl = article?.Url;

                if (!baseUrl)
                {
                    console.warn('No article found for ID:', citation.SaId);
                    return $('<span>');
                }

                const links = [];

                if (citation.Headers?.length == 0 || citation.Headers[0] != title)
                {
                    links.push(`<a href="${this._esc(baseUrl)}" target="_blank">${this._esc(title)}</a>`);
                }

                citation.Headers?.forEach((header, index) =>
                {
                    const anchor = citation.Anchors?.[index] || '';
                    const url = baseUrl + anchor;
                    links.push(`<a href="${this._esc(url)}" target="_blank">${this._esc(header)}</a>`);
                });

                return $(`
                    <div class="citation-badge">
                        <i class="far fa-arrow-up-right-from-square fa-xs"></i>
                        ${links.map((link, idx) =>
                            `<span>` + (idx === 0 ? link : ` <i class="far fa-arrow-right fa-sm" style="margin:0 6px;font-size:0.9em;"></i> ${link}`) + `</span>`
                        ).join('')}
                    </div>`);
            }
        }
        catch (e)
        {
            console.error('Error parsing citation:', e);
        }

        return $('<span>');
    }

    // Quote escapes make this safe in attribute context (title="...") as well as element text.
    _esc(s) { return $('<span>').text(s || '').html().replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }

    renderTstatNugget(tstat)
    {
        const statusMap = { close: 'Resolved', pending: 'Waiting on Customer', none: 'Needs Review' };
        const label = this._esc(statusMap[tstat.tstat] || tstat.tstat);
        const reason = tstat.tstatReason ? `<span class="tool-params">${this._esc(tstat.tstatReason)}</span>` : '';

        return $(`<div class="tool-nugget-line"><span class="tool-nugget-info tool-nugget-spaced"><i class="fa fa-robot"></i>Ticket Agent: ${label}${reason}</span></div>`);
    }

    // ============================================================================
    // ESCALATION OFFER (proactive ticket handoff)
    // ============================================================================
    renderEscalateCard(escalate)
    {
        // Popup-only feature; the popup is the customer surface even under staff impersonation,
        // so no admin-bar gate here.
        if (!this.isPopup) return null;

        // A ticket already exists for this thread — never re-offer.
        if (this.streamState.threadEscalated === true) return null;

        // History replay: stash (last offer wins) for completeStream to re-render beneath the final
        // answer. A replayed openTicket downgrades to the card — never auto-open a form on reload.
        if (this.streamState.isLoadingHistory)
        {
            this.streamState.pendingEscalateOffer = escalate || {};
            return null;
        }

        if (this.state.escalateShownThisAnswer) return null;

        this.state.escalateShownThisAnswer = true;

        // Explicit ticket request -> skip the offer card and open the prefilled form directly.
        if (escalate && escalate.openTicket)
        {
            this.openEscalationTicket('request');
            return null;
        }

        return this.buildEscalateCard();
    }

    buildEscalateCard()
    {
        const $card = $(`
            <div class="rezzy-escalate-card mb-3 p-3 border rounded bg-light">
                <div class="mb-2"><i class="far fa-headset"></i> <strong>Want me to hand this to the support team?</strong></div>
                <div class="text-muted small mb-3">I'll prefill a ticket with a summary of our conversation - you review it before anything sends.</div>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-primary btn-sm" data-escalate-create><i class="far fa-ticket"></i> Create ticket</button>
                    <button type="button" class="btn btn-default btn-sm" data-escalate-dismiss>No thanks</button>
                </div>
            </div>`);

        $card.find('[data-escalate-create]').on('click', () => this.openEscalationTicket());

        // Dismissal removes only this offer — a later model-emitted offer renders again, so the
        // affordance can never diverge from reply text that promises a handoff.
        $card.find('[data-escalate-dismiss]').on('click', () => $card.remove());

        return $card;
    }

    // source: 'offer' = user accepted the offer card, 'request' = user explicitly asked for a ticket
    openEscalationTicket(source = 'offer')
    {
        const tid = this.state.currentThreadId || this.state.sourceThreadId;
        const url = '/submitsupportticket?rezzyThreadId=' + tid + '&escalationSource=' + source;
        $.showModal(url, (data) => this.rezzyTicketSubmitted(data), null, 'modal-lg', null, null, true);
    }

    rezzyTicketSubmitted(data)
    {
        this.streamState.threadEscalated = true;
        this.dom.conversation.find('.rezzy-escalate-card').remove();

        const num = data && data.ticketNumber;
        const message = num
            ? 'Ticket #' + num + ' submitted - support will reply to your account email. They\'ll have our conversation, so no need to re-explain.'
            : 'Your support ticket was submitted - support will reply to your account email.';

        this._appendSystemNote(message);
    }

    _appendSystemNote(text)
    {
        const $note = $('<div class="mb-3 rezzy-system-note">').append(
            $('<div class="agent-answer-block">').append(
                $('<div class="markdown-content">').append(
                    $('<p>').html('<i class="far fa-circle-check"></i> ' + this._esc(text))
                )
            )
        );

        this.dom.conversation.append($note);
        this.scrollToBottom();
    }

    // ============================================================================
    // TOOL MANAGEMENT
    // ============================================================================
    handleToolUse(chunk)
    {
        const toolId = chunk.ToolUse.ToolUseId;

        this.state.toolData[toolId] =
        {
            name: chunk.ToolUse.Name,
            input: chunk.ToolUse.Input,
            result: null,
            succeeded: null,
            json: null
        };

        this.renderToolNugget(toolId, chunk.ToolUse.Name, chunk.ToolUse.Input);
    }

    handleToolResult(chunk)
    {
        const toolId = chunk.ToolUse.ToolUseId;
        const tool = this.state.toolData[toolId];

        if (tool)
        {
            tool.result = chunk.ToolResult.Value;
            tool.succeeded = chunk.ToolResult.Succeeded;

            // Use structured response if available
            if (chunk.ToolUse.StructuredResponse)
            {
                tool.json = chunk.ToolUse.StructuredResponse;

                // Handle SupportArticleIndex type
                if (tool.json.Discriminator == "SupportArticleIndex")
                {
                    for (var article of tool.json.Articles)
                    {
                        this.state.sourceHeaders[article.SaId] = article;
                    }
                }
            }

            this.updateToolNuggetStatus(toolId, tool.succeeded);
            this.showLoader();
        }
    }

    renderToolNugget(toolId, toolName, params)
    {
        const paramsText = this.formatToolParams(params);
        let iconHtml = '<i class="fa fa-wrench"></i>';
        let statusHtml = '<span class="tool-throbber"></span>';

        const $nugget = $(`<div class="tool-nugget-line"><span class="tool-nugget tool-nugget-spaced" data-tool-id="${toolId}">${iconHtml}${this._esc(toolName)}${paramsText}${statusHtml}</span></div>`);

        if (this.messageState.currentCardBody)
        {
            var currentNugget = this.messageState.currentCardBody.find(`[data-tool-id="${toolId}"]`);
            if (currentNugget.length > 0)
            {
                currentNugget.replaceWith($nugget);
                return;
            }
        }

        this.insertSpecialContent($nugget);
    }

    updateToolNuggetStatus(toolId, succeeded)
    {
        const $toolNugget = this.messageState.currentCardBody.find(`[data-tool-id="${toolId}"]`);
        if ($toolNugget.length)
        {
            $toolNugget.find('.tool-throbber').replaceWith(
                `<span class="tool-final-icon" style="margin-left:0.5rem;color:${succeeded ? '#4caf50' : '#f44336'}"><i class="fa fa-${succeeded ? 'check' : 'times'}"></i></span>`
            );
        }
    }

    formatToolParams(params)
    {
        if (!params || Object.keys(params).length === 0) return '';

        const paramEntries = Object.entries(params);
        const paramPairs = paramEntries.map(([key, value]) => `${this._esc(key)}=${this._esc(value)}`).join(', ');

        return `<span class="tool-params">${paramPairs}</span>`;
    }

    showToolModal(toolId)
    {
        const tool = this.state.toolData[toolId];
        if (tool)
        {
            $(`#toolName-${this.instanceId}`).text(tool.name);
            $(`#toolInput-${this.instanceId}`).text(JSON.stringify(tool.input, null, 2));
            $(`#toolOutput-${this.instanceId}`).text(tool.result ? tool.result : 'No result available');

            if (tool.json)
            {
                $(`#toolJson-${this.instanceId}`).text(JSON.stringify(tool.json, null, 2)).parent().show();
            }
            else
            {
                $(`#toolJson-${this.instanceId}`).parent().hide();
            }

            $(`#toolModal-${this.instanceId}`).modal('show');
        }
    }

    // ============================================================================
    // POPUP STATE PERSISTENCE (sessionStorage)
    // ============================================================================
    _saveDraft()
    {
        if (!this.isPopup) return;

        const val = this.dom.textarea.val() || '';
        if (val.length > 0)
            sessionStorage.setItem('rezzy_draft', val);
        else
            sessionStorage.removeItem('rezzy_draft');
    }

    savePopupState()
    {
        if (!this.isPopup) return;

        this._saveDraft();

        if (this.state.currentThreadId)
        {
            sessionStorage.setItem('rezzy_activeThreadId', this.state.currentThreadId);
            sessionStorage.setItem('rezzy_agentType', this.config.agentType);
        }
        else
        {
            sessionStorage.removeItem('rezzy_activeThreadId');
        }

        if (this.state.sourceThreadId)
            sessionStorage.setItem('rezzy_sourceThreadId', this.state.sourceThreadId);
        else
            sessionStorage.removeItem('rezzy_sourceThreadId');

        // Cache the last ~6 Q&A pairs of rendered conversation HTML.
        // Wrapped in try-catch because beforeunload fires during page teardown
        // and DOM cloning can throw if the page is partially destroyed.
        try
        {
            const $conversation = this.dom.conversation;
            const $blocks = $conversation.children('.agent-question-block, .mb-3:has(.agent-answer-block), .agent-answer-retryable-error');
            const lastBlocks = $blocks.slice(Math.max(0, $blocks.length - 12)); // ~6 Q&A pairs

            console.debug('[rezzy:save]', {
                threadId: this.state.currentThreadId,
                isStreaming: this.state.isStreaming,
                totalChildren: $conversation.children().length,
                matchedBlocks: $blocks.length,
                savedBlocks: lastBlocks.length,
                pendingQuestion: sessionStorage.getItem('rezzy_pendingQuestion')
            });

            if (lastBlocks.length > 0)
            {
                const wrapper = $('<div>');
                lastBlocks.each(function() { wrapper.append($(this).clone()); });
                const html = wrapper.html();
                sessionStorage.setItem('rezzy_html', html);
                sessionStorage.setItem('rezzy_htmlTime', Date.now().toString());
                console.debug('[rezzy:save] html length:', html.length);
            }
            else
            {
                console.debug('[rezzy:save] no blocks matched — children classes:', $conversation.children().map(function() { return this.className; }).get());
            }
        }
        catch (e)
        {
            console.debug('[rezzy:save] error during HTML capture:', e.message);
            // Page tearing down — leave whatever's already in sessionStorage
        }

        // Don't overwrite rezzy_streaming here — it's set to 'true' in askQuestion() and
        // cleared to 'false' only in completeStream(). During page teardown, EventSource onerror
        // fires before beforeunload and sets isStreaming=false, which would lose the streaming flag.
        // The sessionStorage value from askQuestion() is the source of truth.
    }

    restorePopupState()
    {
        if (!this.isPopup) return;

        const savedDraft = sessionStorage.getItem('rezzy_draft');
        if (savedDraft)
        {
            this.dom.textarea.val(savedDraft).removeClass("agent-chat-textarea-reset");
            const ta = this.dom.textarea[0];
            if (ta)
            {
                ta.style.removeProperty("height");
                ta.style.removeProperty("max-height");
                ta.style.removeProperty("min-height");
                ta.style.removeProperty("overflow-y");
            }
            this._autoGrowTextarea();
            this.enableSendButton();
        }

        const pendingQuestion = sessionStorage.getItem('rezzy_pendingQuestion');
        const activeThreadId = sessionStorage.getItem('rezzy_activeThreadId');
        const sourceThreadId = sessionStorage.getItem('rezzy_sourceThreadId');
        const threadId = activeThreadId || sourceThreadId;
        const cachedHtml = sessionStorage.getItem('rezzy_html');
        const wasStreaming = sessionStorage.getItem('rezzy_streaming') === 'true';
        const storedMessageCount = sessionStorage.getItem('rezzy_knownMessageCount');

        if (storedMessageCount != null)
            this.state.knownMessageCount = parseInt(storedMessageCount) || 0;

        const popupEl = document.getElementById('rezzy-popup');
        const popupClasses = popupEl ? popupEl.className : 'NOT FOUND';

        console.debug('[rezzy:restore]', {
            pendingQuestion: pendingQuestion ? pendingQuestion.substring(0, 50) + '...' : null,
            threadId,
            cachedHtmlLen: cachedHtml ? cachedHtml.length : 0,
            wasStreaming,
            rezzy_open: sessionStorage.getItem('rezzy_open'),
            popupClasses
        });

        // Priority 1: Pending question — user navigated before agent responded
        if (pendingQuestion)
        {
            sessionStorage.removeItem('rezzy_pendingQuestion');
            const threadIdReceived = sessionStorage.getItem('rezzy_threadIdReceived') === 'true';
            const knownMessageCount = parseInt(sessionStorage.getItem('rezzy_knownMessageCount')) || 0;
            const pendingThreadId = sessionStorage.getItem('rezzy_pendingThreadId');
            sessionStorage.removeItem('rezzy_pendingThreadId');
            sessionStorage.removeItem('rezzy_threadIdReceived');

            if (threadIdReceived && threadId)
            {
                // ThreadId chunk arrived — server is processing. Poll with count threshold.
                console.debug('[rezzy:restore] → Priority 1a: threadId received, polling with count threshold', knownMessageCount);
                this.state.currentThreadId = parseInt(threadId, 10) || threadId;
                this.state.knownMessageCount = knownMessageCount;
                this.showConversation();
                this.setPlaceholder();

                if (cachedHtml)
                {
                    this.dom.conversation.html(cachedHtml);
                    this.dom.conversation.append($('<div class="mb-3" data-stream-status><div class="w-100"><div class=""><div class="loader"></div></div></div></div>'));
                    this.scrollToBottom();
                    this._checkForCompletedThread(threadId);
                }
                else
                {
                    this.pollForCompletion();
                }
                return;
            }

            // ThreadId chunk didn't arrive — re-ask. Background may also process it,
            // but losing the message is worse than a potential duplicate turn.
            console.debug('[rezzy:restore] → Priority 1b: no threadId received, re-asking');

            if (pendingThreadId)
                this.state.currentThreadId = parseInt(pendingThreadId, 10) || pendingThreadId;

            if (cachedHtml)
            {
                this.dom.conversation.html(cachedHtml);

                // Strip the trailing question block — askQuestion will re-add it
                this.dom.conversation.children('.agent-question-block').last().remove();

                this.showConversation();
            }

            this.askQuestion(pendingQuestion);
            return;
        }

        if (!threadId && !cachedHtml) return;

        if (activeThreadId)
        {
            this.state.currentThreadId = parseInt(activeThreadId, 10) || activeThreadId;
            this.dom.threadStatus.html(`Thread ID: ${activeThreadId} - This conversation will be preserved for follow-up questions.`);

            if (this.config.isAdmin && this.dom.threadDebugBtn.length)
            {
                this.dom.threadDebugBtn.attr('href', `${this.config.adminThreadGetUrl}?id=${activeThreadId}`);
                this.dom.container.find('[data-thread-log]').show();
            }
        }
        else if (sourceThreadId)
        {
            this.state.sourceThreadId = parseInt(sourceThreadId, 10) || sourceThreadId;
        }

        // Priority 2: Cached HTML — best data (includes partial deltas S3 doesn't have)
        if (cachedHtml)
        {
            console.debug('[rezzy:restore] → Priority 2: cached HTML' + (wasStreaming ? ' (was streaming, will poll)' : ''));
            this.dom.conversation.html(cachedHtml);
            this.showConversation();
            this.setPlaceholder();

            if (wasStreaming && threadId)
            {
                // Stream was interrupted — show loader and check if background task completed it
                this.dom.conversation.append($('<div class="mb-3" data-stream-status><div class="w-100"><div class=""><div class="loader"></div></div></div></div>'));
                this.scrollToBottom();
                this._checkForCompletedThread(threadId);
            }
            else if (threadId && this.state.knownMessageCount != null)
            {
                // Not streaming — check if server has more messages than our cache
                const epoch = this.state.epoch;
                $.get('/agentchat/threadstatus', { threadId })
                    .done((result) =>
                    {
                        if (this.state.epoch !== epoch) return;

                        if (result.MessageCount > this.state.knownMessageCount)
                        {
                            this.dom.conversation.empty();
                            this.state.sourceThreadId = threadId;
                            try { sessionStorage.setItem('rezzy_reattachRetry', '1'); } catch (err) { }
                            this.loadHistory();
                        }
                        else
                        {
                            this.scrollToBottom();
                        }
                    });
            }
            else
            {
                this.scrollToBottom();
            }
            return;
        }

        // Priority 3: Server reload — threadId but no cache (hard refresh / storage cleared)
        if (threadId)
        {
            console.debug('[rezzy:restore] → Priority 3: polling for completion (no cache)');
            this.showConversation();
            this.pollForCompletion();
        }
    }

    clearPopupState()
    {
        sessionStorage.removeItem('rezzy_activeThreadId');
        sessionStorage.removeItem('rezzy_sourceThreadId');
        sessionStorage.removeItem('rezzy_agentType');
        sessionStorage.removeItem('rezzy_html');
        sessionStorage.removeItem('rezzy_htmlTime');
        sessionStorage.removeItem('rezzy_streaming');
        sessionStorage.removeItem('rezzy_pendingQuestion');
        sessionStorage.removeItem('rezzy_pendingThreadId');
        sessionStorage.removeItem('rezzy_knownMessageCount');
        sessionStorage.removeItem('rezzy_threadIdReceived');
        sessionStorage.removeItem('rezzy_retryQuestion');
        sessionStorage.removeItem('rezzy_reattachRetry');
        sessionStorage.removeItem('rezzy_draft');
        // rezzy_open intentionally preserved — controls popup visibility, not conversation state
    }

    resetConversation()
    {
        this.state.epoch++;
        this.closeStream();
        this.clearPopupState();
        this.state.currentThreadId = null;
        this.state.sourceThreadId = null;
        this.state.knownMessageCount = null;
        this.state.isStreaming = false;
        this.state.lastQuestion = null;
        this.dom.conversation.empty();
        this.dom.conversationInfo.hide();
        this.dom.container.removeClass('agent-chat-active');
        if (this.isInline)
            $('html').removeClass('--rezzy-inline-active');
        // Popup home state has no label above the composer — keep the placeholder as the affordance
        this.dom.textarea.attr('placeholder', this.isPopup ? this.config.placeholder : '');
        this._resetTextarea();
        this.enableSendButton();
    }

    selectHistoryThread(threadId)
    {
        $('.modal').modal('hide');

        // Restore from minimized state if we were minimized for the history modal;
        // open it outright if it's closed (e.g. resuming a conversation from /support).
        if (this.popupState.isMinimized)
            this.restorePopup();
        else if (!this.popupState.isOpen)
            this.openPopup('history');

        this.resetConversation();
        this.state.sourceThreadId = threadId;
        this.showConversation();
        this.loadHistory();

        sessionStorage.setItem('rezzy_sourceThreadId', threadId);
        sessionStorage.removeItem('rezzy_activeThreadId');
        sessionStorage.setItem('rezzy_agentType', this.config.agentType);
    }

    // ============================================================================
    // POPUP CONTROLLER (open/close/toggle, expand/collapse, session restore)
    // ============================================================================
    initPopupController()
    {
        this.dom.popup = $('#rezzy-popup');
        this.dom.popupMinimize = $('#rezzy-minimize');
        this.dom.popupExpand = $('#rezzy-expand');
        this.dom.popupNewChat = $('#rezzy-newchat');
        this.dom.popupClose = $('#rezzy-close');

        this.popupState = { isOpen: false, isExpanded: false, isMinimized: false };

        this.setPlaceholder();
        this.initLauncher();

        // Expand/collapse
        this.dom.popupExpand.on('click', () =>
        {
            this.popupState.isExpanded = !this.popupState.isExpanded;
            this.dom.popup.toggleClass('rezzy-popup-expanded', this.popupState.isExpanded);
            this.dom.popupExpand.find('i').toggleClass('fa-expand', !this.popupState.isExpanded).toggleClass('fa-compress', this.popupState.isExpanded);
            this.dom.popupExpand.attr('title', this.popupState.isExpanded ? 'Collapse' : 'Expand');
            sessionStorage.setItem('rezzy_expanded', this.popupState.isExpanded ? 'true' : 'false');
        });

        // Minimize/Restore toggle
        this.dom.popupMinimize.on('click', (e) =>
        {
            e.stopPropagation();
            if (this.popupState.isMinimized) this.restorePopup();
            else this.minimizePopup();
        });

        // Close — fully closes the popup
        this.dom.popupClose.on('click', (e) =>
        {
            e.stopPropagation();
            this.closePopup('close');
        });

        // Click on header in minimized state restores
        this.dom.popup.find('.rezzy-popup-header').on('click', () =>
        {
            if (this.popupState.isMinimized)
                this.restorePopup();
        });

        // New chat
        this.dom.popupNewChat.on('click', () =>
        {
            this.resetConversation();
            this.dom.textarea.focus();
        });

        // Restore expanded state
        if (sessionStorage.getItem('rezzy_expanded') === 'true')
        {
            this.popupState.isExpanded = true;
            this.dom.popup.addClass('rezzy-popup-expanded');
            this.dom.popupExpand.find('i').removeClass('fa-expand').addClass('fa-compress');
            this.dom.popupExpand.attr('title', 'Collapse');
        }

        // Restore open/minimized state
        if (sessionStorage.getItem('rezzy_minimized') === 'true')
        {
            this.openPopup('sessionRestore');
            this.minimizePopup('sessionRestore');
        }
        else if (sessionStorage.getItem('rezzy_open') === 'true')
        {
            this.openPopup('sessionRestore');
        }

        // One-shot launch-source carryover for the error-modal path whose caller callback
        // reloads the page: the thread hasn't been created yet, so attribution rides here.
        try
        {
            const carriedSource = sessionStorage.getItem('rezzy_launch_source');
            if (carriedSource)
            {
                this.state.launchSource = carriedSource;
                sessionStorage.removeItem('rezzy_launch_source');
            }
        }
        catch (err) { }
    }

    // ============================================================================
    // TOP-BAR LAUNCHER (button, Ctrl/Cmd+K)
    // ============================================================================
    initLauncher()
    {
        this.dom.launcher = $('#rezzy-launcher');

        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        if (isMac)
        {
            this.dom.launcher.closest('.rezzy-launcher-wrap')
                .attr('title', 'Ask Rezzy (⌘K)')
                .attr('data-bs-title', 'Ask Rezzy (⌘K)')
                .attr('data-bs-original-title', 'Ask Rezzy (⌘K)');
        }

        if (this.dom.launcher.length)
        {
            this.dom.launcher.on('click', (e) =>
            {
                e.preventDefault();
                this.togglePopup('topBarButton');
            });
        }

        // Create-ticket links (help flyout + popup footer): carry the active thread
        // so support sees the conversation (staff thread link is prefilled
        // server-side). The modal machinery reads the href as early as mousedown,
        // so rewrite on every activation-precursor event, capture phase.
        document.querySelectorAll('[data-rezzy-ticket-link]').forEach(ticketLink =>
        {
            // Preserve the link's own query (e.g. mode=ticket) when appending the thread params
            const pristine = ticketLink.getAttribute('href');
            const sep = pristine.includes('?') ? '&' : '?';
            const syncTicketHref = () =>
            {
                const tid = this.state.currentThreadId || this.state.sourceThreadId;
                const src = ticketLink.getAttribute('data-escalation-source') || 'footer';
                ticketLink.setAttribute('href', tid ? `${pristine}${sep}rezzyThreadId=${tid}&escalationSource=${src}` : pristine);
            };
            ['mousedown', 'touchstart', 'keydown', 'click'].forEach(ev =>
                ticketLink.addEventListener(ev, syncTicketHref, true));
        });

        // Ctrl/Cmd+K must bind on keydown: Chrome/Edge/Firefox act on the chord at
        // keydown (omnibox focus), so a keyup handler (like site.js's Global Key
        // Filter) loses the race. Esc closes an open popup.
        $(document).on('keydown.rezzyLauncher', (e) =>
        {
            if ((e.ctrlKey || e.metaKey) && !e.altKey && (e.key === 'k' || e.key === 'K'))
            {
                // Modals own the foreground — opening the popup would strand it
                // behind the backdrop.
                if ($('.modal.show, .modal.in').length)
                    return;

                // Fires even with focus in a form field: no input binds Ctrl+K natively,
                // and pages that autofocus a filter (e.g. /bookings) would otherwise eat
                // the chord. Rich editors (TinyMCE/Ace) run in iframes whose keydowns
                // never reach this document listener, so they keep their own Ctrl+K.
                e.preventDefault();
                e.stopPropagation();
                this.togglePopup('shortcut');
            }
            else if (e.key === 'Escape' && this.popupState.isOpen && !this.popupState.isMinimized)
            {
                // Modals own Esc; form fields outside the popup keep their Esc behavior.
                // The target check matters when the popup is open UNDER a modal: Bootstrap's
                // own Esc handler removes .show synchronously before this bubbles to the
                // document, so the class check alone would close both on one keypress.
                if ($('.modal.show, .modal.in').length || $(e.target).closest('.modal').length)
                    return;
                if (this._isFormField(e.target) && !$(e.target).closest('#rezzy-popup').length)
                    return;

                this.closePopup('escape');
            }
        });
    }

    _isFormField(el)
    {
        return /^(INPUT|TEXTAREA|SELECT|OPTION)$/.test(el.tagName) || el.isContentEditable;
    }

    togglePopup(source)
    {
        this._hideLauncherTooltip();

        if (this.popupState.isMinimized)
            this.restorePopup();
        else if (this.popupState.isOpen)
            this.closePopup(source);
        else
        {
            this.state.launchSource = source;
            this.openPopup(source);
        }

        this.dom.launcher.attr('aria-expanded', this.popupState.isOpen ? 'true' : 'false');
    }

    // The launcher click leaves focus on the button, so the default 'hover focus'
    // tooltip trigger keeps its tooltip pinned over the opened popup. Blur + hide.
    _hideLauncherTooltip()
    {
        if (!this.dom.launcher || !this.dom.launcher.length)
            return;

        this.dom.launcher.trigger('blur');

        const wrap = this.dom.launcher.parent()[0];
        if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip)
            bootstrap.Tooltip.getInstance(wrap)?.hide();
        else if (typeof $.fn.tooltip === 'function')
            $(wrap).tooltip('hide');
    }

    _hideChatTooltips()
    {
        const $els = this._tooltipEls;
        if (!$els || !$els.length)
            return;

        if (typeof $.fn.tooltip === 'function')
            $els.tooltip('hide');
        else if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip)
            $els.each(function() { bootstrap.Tooltip.getInstance(this)?.hide(); });
    }

    openPopup(reason)
    {
        console.debug('[rezzy:popup] openPopup called', { reason, wasOpen: this.popupState.isOpen, rezzy_open: sessionStorage.getItem('rezzy_open') });

        // Coexistence check: inline chat on same page
        var $inlineChat = $('.agent-chat-container:not(#agent-chat-popup)');

        if ($inlineChat.length)
        {
            this.dom.popup.addClass('rezzy-popup-coexist');
            if (!this.dom.popup.find('.rezzy-popup-coexist-label').length)
                this.dom.popup.find('.rezzy-popup-title').append('<span class="rezzy-popup-coexist-label">Chat active on this page</span>');
        }
        else
        {
            this.dom.popup.removeClass('rezzy-popup-coexist');
            this.dom.popup.find('.rezzy-popup-coexist-label').remove();
        }

        this.dom.popup.removeClass('rezzy-popup-hidden').addClass('rezzy-popup-visible');
        this.dom.popup[0].offsetHeight; // force reflow
        this.popupState.isOpen = true;
        sessionStorage.setItem('rezzy_open', 'true');
        $('body').addClass('--rezzy-popup-open');

        if (this.dom.launcher)
            this.dom.launcher.attr('aria-expanded', 'true');

        this.dom.textarea.focus();
        this._renderContextBar();
    }

    _setMinimizeButtonState(isMinimized)
    {
        const $icon = this.dom.popupMinimize.find('i');
        $icon.toggleClass('fa-chevron-up', isMinimized).toggleClass('fa-chevron-down', !isMinimized);
        this.dom.popupMinimize.attr('title', isMinimized ? 'Restore' : 'Minimize');
    }

    closePopup(reason)
    {
        console.debug('[rezzy:popup] closePopup called', { reason, wasOpen: this.popupState.isOpen });

        // return focus to the launcher only when it was still ours — a click
        // elsewhere moved it deliberately, leave it be
        var focusWasInside = this.dom.popup.length && this.dom.popup[0].contains(document.activeElement);

        this._hideChatTooltips();

        this.dom.popup.addClass('rezzy-popup-hidden').removeClass('rezzy-popup-visible rezzy-popup-minimized');
        this.popupState.isOpen = false;
        this.popupState.isMinimized = false;
        this._setMinimizeButtonState(false);

        // the launcher lives in the help flyout, which may itself be closed by now
        if (focusWasInside && this.dom.launcher && this.dom.launcher.is(':visible'))
            this.dom.launcher.trigger('focus');

        // Close means "done" — next open starts a fresh chat. Minimize preserves
        // the conversation; History button re-opens past threads.
        this.resetConversation();

        sessionStorage.setItem('rezzy_open', 'false');
        sessionStorage.setItem('rezzy_minimized', 'false');
        $('body').removeClass('--rezzy-popup-open');

        if (this.dom.launcher)
            this.dom.launcher.attr('aria-expanded', 'false');
    }

    minimizePopup(reason)
    {
        console.debug('[rezzy:popup] minimizePopup called', { reason });
        this._hideChatTooltips();
        this.dom.popup.addClass('rezzy-popup-minimized');
        this.popupState.isMinimized = true;
        sessionStorage.setItem('rezzy_minimized', 'true');
        $('body').removeClass('--rezzy-popup-open');

        this._setMinimizeButtonState(true);
    }

    restorePopup()
    {
        console.debug('[rezzy:popup] restorePopup called');
        this.dom.popup.removeClass('rezzy-popup-minimized');
        this.popupState.isMinimized = false;
        sessionStorage.setItem('rezzy_minimized', 'false');
        $('body').addClass('--rezzy-popup-open');

        this._setMinimizeButtonState(false);

        this.dom.textarea.focus();
    }

    // ============================================================================
    // CONTEXT BAR (Ask Rezzy context injection)
    // ============================================================================

    // Prefer the prefill argument: the sessionStorage draft key is only a fallback for the
    // page-reload path, and autosave can clear it between the modal's write and this read.
    openFromErrorModal(prefill)
    {
        if (this.popupState === undefined)
            return;

        // The rezzy_launch_source carryover key stays — the caller's callback may still
        // reload the page after this returns; init() consumes the key either way.
        this.state.launchSource = 'errorModal';

        this.openPopup('errorModal');

        let draft = prefill || null;
        if (!draft)
            try { draft = sessionStorage.getItem('rezzy_draft'); } catch (err) { }

        if (draft && !(this.dom.textarea.val() || '').trim().length)
        {
            this.dom.textarea.val(draft).removeClass("agent-chat-textarea-reset");
            const ta = this.dom.textarea[0];
            if (ta)
            {
                ta.style.removeProperty("height");
                ta.style.removeProperty("max-height");
                ta.style.removeProperty("min-height");
                ta.style.removeProperty("overflow-y");
            }
            this._autoGrowTextarea();
            this.enableSendButton();
        }

        this.dom.textarea.focus();
    }

    // Only the parent entity gets its own chip; the child appears in the popover.
    _renderContextBar()
    {
        if (!this.isPopup)
            return;

        const $bar = $('#rezzy-context-bar');
        if (!$bar.length)
            return;

        const label = this.config.entityLabel || null;
        const lastError = this._readLastError();
        const validation = this._readVisibleValidation();

        // The chip is scoped to the page the error was seen on; the envelope still carries
        // the error until TTL so Rezzy can diagnose after a navigate.
        const errorOnThisPage = lastError && lastError.pagePath === window.location.pathname;

        let html = '';

        if (label)
        {
            let hover = 'On: ' + document.title;
            if (this.config.childLabel)
                hover += ' · ' + this.config.childLabel;

            html += `<button type="button" class="rezzy-context-chip" data-context-chip aria-expanded="false" data-bs-toggle="tooltip" title="${this._esc(hover)}"><i class="far fa-eye"></i> Viewing: ${this._esc(label)}</button>`;
        }

        if (errorOnThisPage)
        {
            const firstMsg = (lastError.messages && lastError.messages[0]) || '';
            let hover = String(lastError.status || '');
            if (firstMsg)
                hover += ': ' + firstMsg;
            if (lastError.count > 1)
                hover += ' (' + lastError.count + 'x)';

            html += `<button type="button" class="rezzy-context-chip rezzy-context-chip-error" data-context-chip aria-expanded="false" data-bs-toggle="tooltip" title="${this._esc(hover)}"><i class="far fa-triangle-exclamation"></i> error on page</button>`;
        }

        if (validation)
            html += `<button type="button" class="rezzy-context-chip rezzy-context-chip-validation" data-context-chip aria-expanded="false" data-bs-toggle="tooltip" title="${this._esc((validation.messages || []).join('; '))}"><i class="far fa-circle-exclamation"></i> ${validation.count} validation error${validation.count === 1 ? '' : 's'}</button>`;

        // Any re-render (populated or empty) replaces the chip nodes — clean up tooltips first
        // or they orphan (tips render into body, not the bar). Native path must dispose, not
        // just hide: BS5 keys instances in an element Map that never releases detached chips.
        // jQuery path is reclaimed by cleanData on removal ('dispose' is BS5-only API, so 'hide').
        if (this._barTipEls)
        {
            if (typeof $.fn.tooltip === 'function')
                this._barTipEls.tooltip('hide');
            else if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip)
                this._barTipEls.each(function() { bootstrap.Tooltip.getInstance(this)?.dispose(); });

            this._barTipEls = null;
        }

        if (!html)
        {
            $(document).off('.rezzyCtxPop');
            $bar.empty().hide();
            return;
        }

        const rows = [];
        rows.push(`<div class="rezzy-context-pop-row"><strong>Page:</strong> ${this._esc(document.title)}</div>`);

        if (label)
            rows.push(`<div class="rezzy-context-pop-row"><strong>Viewing:</strong> ${this._esc(label)}</div>`);

        if (this.config.childLabel)
            rows.push(`<div class="rezzy-context-pop-row"><strong>Item:</strong> ${this._esc(this.config.childLabel)}</div>`);

        if (errorOnThisPage)
        {
            const firstMsg = (lastError.messages && lastError.messages[0]) || '';
            let errText = String(lastError.status || '');
            if (firstMsg)
                errText += ': ' + firstMsg;
            if (lastError.count > 1)
                errText += ' (' + lastError.count + ' times)';

            rows.push(`<div class="rezzy-context-pop-row"><strong>Error:</strong> ${this._esc(errText)}</div>`);
        }

        if (validation)
        {
            const vMsgs = (validation.messages || []).map((m) => this._esc(m)).join('; ');
            rows.push(`<div class="rezzy-context-pop-row"><strong>Validation (${validation.count}):</strong> ${vMsgs}</div>`);
        }

        html += `<div class="rezzy-context-pop" style="display: none;">${rows.join('')}</div>`;

        $bar.html(html).css('display', '');

        const setPopState = (visible) =>
        {
            $bar.find('.rezzy-context-pop').toggle(visible);
            $bar.find('[data-context-chip]').attr('aria-expanded', visible ? 'true' : 'false');
        };

        $bar.find('[data-context-chip]').on('click', (e) =>
        {
            e.stopPropagation();
            setPopState(!$bar.find('.rezzy-context-pop').is(':visible'));
        });

        // Namespaced + off() first so re-renders never stack handlers. Dismiss is unconditional
        // (idempotent: closing an already-closed pop is a no-op) — no :visible guard, which is
        // layout-dependent and unreliable.
        $(document).off('.rezzyCtxPop')
            .on('click.rezzyCtxPop', (e) =>
            {
                if (!$bar[0].contains(e.target))
                    setPopState(false);
            })
            .on('keydown.rezzyCtxPop', (e) =>
            {
                if (e.key === 'Escape')
                    setPopState(false);
            });

        if (!window.matchMedia('(hover: none)').matches)
        {
            const $tips = $bar.find('[data-bs-toggle="tooltip"]');
            this._barTipEls = $tips;

            if (typeof $.fn.tooltip === 'function')
                $tips.tooltip({ container: 'body', trigger: 'hover' });
            else if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip)
                $tips.each(function() { new bootstrap.Tooltip(this, { trigger: 'hover' }); });
        }

        this._renderHomeSuggestion(label, errorOnThisPage, validation);
    }

    // Lives on the popup home screen, which CSS hides once a conversation is active, so this
    // suggestion retires along with it.
    _renderHomeSuggestion(label, errorOnThisPage, validation)
    {
        const $home = this.dom.popup?.find('.rezzy-popup-home');
        if (!$home || !$home.length)
            return;

        $home.find('.rezzy-home-ask').remove();

        if (!label && !errorOnThisPage && !validation)
            return;

        const $btn = $(`<button type="button" class="rezzy-home-ask"><i class="far fa-comments"></i> Ask about this page</button>`);
        $btn.on('click', () => this.askQuestion('What am I looking at?'));
        $home.find('.rezzy-popup-home-greet').after($btn);
    }

    // Staff-only. The server runs the production parse -> sanitize -> pointer -> posture
    // pipe, so this shows the exact strings the model sees.
    _showContextDebug()
    {
        const envelope = this._buildContextEnvelope();

        $.get('/agentchat/contextpreview', {
            userId: this.config.userId,
            pageUrl: window.location.pathname,
            pageTitle: document.title,
            context: envelope,
            docsOnly: this.config.docsOnly
        }).done((r) =>
        {
            const pre = (v) => `<pre class="small p-2 border rounded mb-3">${this._esc(v)}</pre>`;
            const envelopePretty = envelope ? JSON.stringify(JSON.parse(envelope), null, 2) : '(empty)';

            bootbox.dialog({
                title: 'Agent Context Preview',
                size: 'large',
                backdrop: true,
                onEscape: true,
                message:
                    `<h6>Client envelope &mdash; ${envelope ? envelope.length : 0}/900 chars</h6>${pre(envelopePretty)}` +
                    `<h6>Pointer inject (per turn, on change)</h6>${pre(r.pointer || '(none — no page context)')}` +
                    `<h6>ACCOUNT REFERENCE DATA (system prompt)</h6>${pre(r.accountContext || '(none — docsOnly)')}`,
                buttons: { close: { label: 'Close', className: 'btn-default' } }
            });
        }).fail((xhr) =>
        {
            bootbox.alert(`Context preview failed &mdash; ${xhr.status} ${xhr.statusText || 'request failed'}`);
        });
    }

    pollForCompletion()
    {
        const threadId = this.state.currentThreadId;
        const epoch = this.state.epoch;
        const knownCount = this.state.knownMessageCount || 0;
        const POLL_INTERVAL = 3000;
        const MAX_POLL_TIME = 30000;
        const startTime = Date.now();

        console.debug('[rezzy:poll] starting full poll for thread', threadId, 'knownCount:', knownCount);

        this.dom.conversation.html(
            '<div class="mb-3" data-loader><div class="w-100"><div class=""><div class="loader"></div></div></div></div>'
        );
        this.scrollToBottom();

        const poll = () =>
        {
            if (this.state.epoch !== epoch) return;

            $.get('/agentchat/threadstatus', { threadId })
                .done((result) =>
                {
                    if (this.state.epoch !== epoch) return;

                    if (result.MessageCount > knownCount)
                    {
                        this.dom.conversation.empty();
                        this.state.sourceThreadId = threadId;
                        this.loadHistory();
                    }
                    else if (Date.now() - startTime > MAX_POLL_TIME)
                    {
                        this.showReconnectRetryLink();
                    }
                    else
                    {
                        setTimeout(poll, POLL_INTERVAL);
                    }
                })
                .fail(() =>
                {
                    if (this.state.epoch !== epoch) return;

                    if (Date.now() - startTime > MAX_POLL_TIME)
                        this.showReconnectRetryLink();
                    else
                        setTimeout(poll, POLL_INTERVAL);
                });
        };

        poll();
    }

    showReconnectRetryLink()
    {
        this.dom.conversation.html(
            '<div class="text-muted small p-3">Could not load conversation. <a href="#" data-retry-load>Try again</a> or start a new chat.</div>'
        );
        this.dom.conversation.find('[data-retry-load]').on('click', (e) =>
        {
            e.preventDefault();
            this.pollForCompletion();
        });
        this.enableSendButton();
        sessionStorage.setItem('rezzy_streaming', 'false');
    }

    _checkForCompletedThread(threadId)
    {
        const epoch = this.state.epoch;
        const knownCount = this.state.knownMessageCount || 0;
        const POLL_INTERVAL = 2000;
        const MAX_POLL_TIME = 90000;
        const THINKING_MSG_TIME = 10000;
        const startTime = Date.now();
        let thinkingShown = false;

        console.debug('[rezzy:check] starting completion check for thread', threadId, 'knownCount:', knownCount);

        const showThinkingMessage = () =>
        {
            if (thinkingShown) return;
            thinkingShown = true;
            this.dom.conversation.find('[data-stream-status]').html(
                '<div class="w-100 text-center"><div class="loader mb-2"></div><div class="text-muted small" style="font-style:italic">Rezzy is still thinking...</div></div>'
            );
        };

        const poll = () =>
        {
            if (this.state.epoch !== epoch) return;

            const elapsed = Date.now() - startTime;

            if (elapsed > THINKING_MSG_TIME)
                showThinkingMessage();

            $.get('/agentchat/threadstatus', { threadId })
                .done((result) =>
                {
                    if (this.state.epoch !== epoch) return;

                    console.debug('[rezzy:check] poll result:', result.Status, 'messageCount:', result.MessageCount, 'elapsed:', elapsed + 'ms');

                    if (result.MessageCount > knownCount)
                    {
                        this.dom.conversation.empty();
                        this.state.sourceThreadId = threadId;
                        this.loadHistory();
                    }
                    else if (elapsed > MAX_POLL_TIME)
                    {
                        this.dom.conversation.find('[data-stream-status]').remove();
                        this.dom.conversation.append(
                            $('<div class="text-muted small mb-2" style="font-style:italic">Response was interrupted. You can ask a follow-up to continue.</div>')
                        );
                        sessionStorage.setItem('rezzy_streaming', 'false');
                    }
                    else
                    {
                        setTimeout(poll, POLL_INTERVAL);
                    }
                })
                .fail(() =>
                {
                    if (this.state.epoch !== epoch) return;

                    if (elapsed > MAX_POLL_TIME)
                    {
                        this.dom.conversation.find('[data-stream-status]').remove();
                        this.dom.conversation.append(
                            $('<div class="text-muted small mb-2" style="font-style:italic">Response was interrupted. You can ask a follow-up to continue.</div>')
                        );
                        sessionStorage.setItem('rezzy_streaming', 'false');
                    }
                    else
                    {
                        setTimeout(poll, POLL_INTERVAL);
                    }
                });
        };

        poll();
    }

    // ============================================================================
    // EVENT HANDLERS
    // ============================================================================
    handleKeydown(e)
    {
        if (e.key === 'Enter' && !e.shiftKey)
        {
            e.preventDefault();
            if (!this.dom.sendBtn.prop('disabled'))
            {
                this._enterSending = true;
                this.askQuestion();
            }
        }
    }

    handleToolClick(e)
    {
        const toolId = $(e.currentTarget).data('tool-id');
        this.showToolModal(toolId);
    }

    handleCopyAnswer(cardBody, e)
    {
        if (!cardBody) return;

        const isMarkdownOnly = e && e.ctrlKey;

        let markdown = '';
        let html = '';

        cardBody.children().each(function()
        {
            const $element = $(this);

            if ($element.hasClass('markdown-content'))
            {
                const md = $element.data('markdown');
                if (md) markdown += (markdown ? '\n\n' : '') + md;

                if (!isMarkdownOnly)
                {
                    const content = $element.html();
                    if (content) html += (html ? '<br>' : '') + content;
                }
            }
            else if ($element.hasClass('citation-badge'))
            {
                const $lastLink = $element.find('a').last();
                if ($lastLink.length)
                    markdown += (markdown ? '\n\n' : '') + $lastLink.attr('href') + '\n';

                if (!isMarkdownOnly)
                {
                    const links = [];
                    $element.find('a').each(function()
                    {
                        const $link = $(this);
                        links.push(`<a href="${$link.attr('href')}" target="_blank">${$link.text()}</a>`);
                    });

                    if (links.length > 0)
                        html += `<p>${links.join(' &gt; ')}</p>`;
                }
            }
            // Skip tool nuggets and action buttons
        });

        // Copy to clipboard
        const performCopy = async () =>
        {
            if (!markdown) return false;

            try
            {
                if (isMarkdownOnly)
                {
                    await navigator.clipboard.writeText(markdown);
                }
                else
                {
                    const clipboardItem = new ClipboardItem({
                        'text/plain': markdown,
                        'text/html': html
                    });

                    await navigator.clipboard.write([clipboardItem]);
                }

                return true;
            }
            catch (err)
            {
                // Fallback to markdown only
                console.warn('Multi-format copy failed, falling back to text:', err);

                try
                {
                    await navigator.clipboard.writeText(markdown);
                    return true;
                }
                catch (fallbackErr)
                {
                    console.error('Copy failed completely:', fallbackErr);
                    return false;
                }
            }
        };

        // Execute copy and show feedback
        performCopy().then(success =>
        {
            if (success)
            {
                const $copyBtn = cardBody.find('.fa-copy').parent();
                const originalHtml = $copyBtn.html();
                const confirmationText = isMarkdownOnly ? '<i class="fa fa-check"></i> MD' : '<i class="fa fa-check"></i>';
                $copyBtn.html(confirmationText);
                setTimeout(() => $copyBtn.html(originalHtml), 1000);
            }
        });
    }

    handleRating(cardBody, aiAgentLogId, rating)
    {
        cardBody?.find('.btn-rate-yay, .btn-rate-boo').prop('disabled', true);
        var dialog = bootbox.prompt({
            title: rating < 0 ? "Can you elaborate on why it is wrong?" : "Can you elaborate on why it is good?",
            // In popup mode, tag the dialog so CSS can raise it above the Rezzy popup
            // (mobile fullscreen popup z-index sits above the default Bootstrap modal).
            className: this.isPopup ? 'rezzy-feedback-dialog' : '',
            inputType: "textarea",
            rows: 6,
            required: false,
            buttons: {
                cancel: {
                    label: 'Close',
                    className: 'btn-default'
                },
                confirm: {
                    label: 'Add Feedback',
                    className: 'btn-success',
                }
            },
            callback: (feedback) =>
            {
                // Always save the rating, even if user clicks "Close" (feedback will be null)
                this.sendRating(aiAgentLogId, rating, feedback || '', cardBody);
            }
        });

        if (this.isPopup)
        {
            dialog.on('shown.bs.modal', () => $('.modal-backdrop').last().css('z-index', 1099));
        }

        $(".bootbox-input", dialog).on("keypress", function (e)
        {
            if ((e.which == 10 || e.which == 13) && e.ctrlKey)
            {
                e.preventDefault();

                $(".bootbox-accept", dialog).click();
            }
        });
    }

    sendRating(aiAgentLogId, rating, feedback, $container)
    {
        $.executeAjaxCall({
            ajax: $.post('/agentchat/rate', { aiAgentLogId, rating, feedback }),
            // The thumbs buttons are disabled during the save; most pages hosting the chat have no .ajax-spinner, which alerts on dev.
            spinner: false,
            success: (data) =>
            {
                if (!data.Success)
                {
                    showAlertConfirmation("Feedback could not be saved. Try again.", null, "alert-danger");
                    return;
                }

                this.streamState.feedbackRatings[aiAgentLogId] = rating;
                $container?.find('.agent-answer-actions').replaceWith(this.createAnswerActions($container, aiAgentLogId));
            },
            complete: () => $container?.find('.btn-rate-yay, .btn-rate-boo').prop('disabled', false)
        });
    }

    _reattachRetryBubble()
    {
        let question;
        try { question = sessionStorage.getItem('rezzy_retryQuestion'); } catch (err) { }

        if (!question || this.dom.conversation.find('.agent-answer-retryable-error').length)
            return;

        this.state.lastQuestion = question;

        const $bubble = $('<div class="agent-answer-retryable-error">')
            .attr('data-question', question)
            .append(
                $('<i class="far fa-triangle-exclamation"></i>'),
                $('<span>').text('Rezzy lost the AI connection mid-answer. Nothing you did; the provider dropped the stream.'),
                $('<button type="button" class="btn btn-default btn-xs">Try again</button>')
            );

        this.dom.conversation.append($bubble);
    }

    handleError(error, retryable)
    {
        this.closeStream();

        // A server-sent error ends the turn as decisively as Done — without this, the popup's
        // rezzy_streaming flag stays true and a navigation restores into a ghost loader + 90s poll.
        this.streamState._serverDone = true;

        // Retryable provider drops keep the partial answer and offer an in-thread resend.
        if (retryable && this.state.lastQuestion)
        {
            const $bubble = $('<div class="agent-answer-retryable-error">')
                .attr('data-question', this.state.lastQuestion)
                .append(
                    $('<i class="far fa-triangle-exclamation"></i>'),
                    $('<span>').text(error),
                    $('<button type="button" class="btn btn-default btn-xs">Try again</button>')
                );

            // A truncated answer gets copy but never thumbs — a rating on a dropped answer is noise.
            this.streamState.suppressRating = true;

            // Finalize first so the actions row sits under the answer text, with the bubble below it.
            const $card = this.messageState.currentCardBody;

            this.completeStream();

            ($card || this.dom.conversation).append($bubble);

            if (this.isPopup)
            {
                try { sessionStorage.setItem('rezzy_retryQuestion', this.state.lastQuestion); } catch (err) { }
                this.savePopupState();
            }

            return;
        }

        this.processContent(error);
        this.completeStream();
    }
}

/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */
(function(g,f){if(typeof exports=="object"&&typeof module<"u"){module.exports=f()}else if("function"==typeof define && define.amd){define("marked",f)}else {g["marked"]=f()}}(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : this,function(){var exports={};var __exports=exports;var module={exports};
"use strict";var H=Object.defineProperty;var be=Object.getOwnPropertyDescriptor;var Te=Object.getOwnPropertyNames;var we=Object.prototype.hasOwnProperty;var ye=(l,e)=>{for(var t in e)H(l,t,{get:e[t],enumerable:!0})},Re=(l,e,t,n)=>{if(e&&typeof e=="object"||typeof e=="function")for(let s of Te(e))!we.call(l,s)&&s!==t&&H(l,s,{get:()=>e[s],enumerable:!(n=be(e,s))||n.enumerable});return l};var Se=l=>Re(H({},"__esModule",{value:!0}),l);var kt={};ye(kt,{Hooks:()=>L,Lexer:()=>x,Marked:()=>E,Parser:()=>b,Renderer:()=>$,TextRenderer:()=>_,Tokenizer:()=>S,defaults:()=>w,getDefaults:()=>z,lexer:()=>ht,marked:()=>k,options:()=>it,parse:()=>pt,parseInline:()=>ct,parser:()=>ut,setOptions:()=>ot,use:()=>lt,walkTokens:()=>at});module.exports=Se(kt);function z(){return{async:!1,breaks:!1,extensions:null,gfm:!0,hooks:null,pedantic:!1,renderer:null,silent:!1,tokenizer:null,walkTokens:null}}var w=z();function N(l){w=l}var I={exec:()=>null};function h(l,e=""){let t=typeof l=="string"?l:l.source,n={replace:(s,i)=>{let r=typeof i=="string"?i:i.source;return r=r.replace(m.caret,"$1"),t=t.replace(s,r),n},getRegex:()=>new RegExp(t,e)};return n}var m={codeRemoveIndent:/^(?: {1,4}| {0,3}\t)/gm,outputLinkReplace:/\\([\[\]])/g,indentCodeCompensation:/^(\s+)(?:```)/,beginningSpace:/^\s+/,endingHash:/#$/,startingSpaceChar:/^ /,endingSpaceChar:/ $/,nonSpaceChar:/[^ ]/,newLineCharGlobal:/\n/g,tabCharGlobal:/\t/g,multipleSpaceGlobal:/\s+/g,blankLine:/^[ \t]*$/,doubleBlankLine:/\n[ \t]*\n[ \t]*$/,blockquoteStart:/^ {0,3}>/,blockquoteSetextReplace:/\n {0,3}((?:=+|-+) *)(?=\n|$)/g,blockquoteSetextReplace2:/^ {0,3}>[ \t]?/gm,listReplaceTabs:/^\t+/,listReplaceNesting:/^ {1,4}(?=( {4})*[^ ])/g,listIsTask:/^\[[ xX]\] /,listReplaceTask:/^\[[ xX]\] +/,anyLine:/\n.*\n/,hrefBrackets:/^<(.*)>$/,tableDelimiter:/[:|]/,tableAlignChars:/^\||\| *$/g,tableRowBlankLine:/\n[ \t]*$/,tableAlignRight:/^ *-+: *$/,tableAlignCenter:/^ *:-+: *$/,tableAlignLeft:/^ *:-+ *$/,startATag:/^<a /i,endATag:/^<\/a>/i,startPreScriptTag:/^<(pre|code|kbd|script)(\s|>)/i,endPreScriptTag:/^<\/(pre|code|kbd|script)(\s|>)/i,startAngleBracket:/^</,endAngleBracket:/>$/,pedanticHrefTitle:/^([^'"]*[^\s])\s+(['"])(.*)\2/,unicodeAlphaNumeric:/[\p{L}\p{N}]/u,escapeTest:/[&<>"']/,escapeReplace:/[&<>"']/g,escapeTestNoEncode:/[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,escapeReplaceNoEncode:/[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,unescapeTest:/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,caret:/(^|[^\[])\^/g,percentDecode:/%25/g,findPipe:/\|/g,splitPipe:/ \|/,slashPipe:/\\\|/g,carriageReturn:/\r\n|\r/g,spaceLine:/^ +$/gm,notSpaceStart:/^\S*/,endingNewline:/\n$/,listItemRegex:l=>new RegExp(`^( {0,3}${l})((?:[	 ][^\\n]*)?(?:\\n|$))`),nextBulletRegex:l=>new RegExp(`^ {0,${Math.min(3,l-1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),hrRegex:l=>new RegExp(`^ {0,${Math.min(3,l-1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),fencesBeginRegex:l=>new RegExp(`^ {0,${Math.min(3,l-1)}}(?:\`\`\`|~~~)`),headingBeginRegex:l=>new RegExp(`^ {0,${Math.min(3,l-1)}}#`),htmlBeginRegex:l=>new RegExp(`^ {0,${Math.min(3,l-1)}}<(?:[a-z].*>|!--)`,"i")},$e=/^(?:[ \t]*(?:\n|$))+/,_e=/^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/,Le=/^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,O=/^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,ze=/^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,F=/(?:[*+-]|\d{1,9}[.)])/,ie=/^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,oe=h(ie).replace(/bull/g,F).replace(/blockCode/g,/(?: {4}| {0,3}\t)/).replace(/fences/g,/ {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g,/ {0,3}>/).replace(/heading/g,/ {0,3}#{1,6}/).replace(/html/g,/ {0,3}<[^\n>]+>\n/).replace(/\|table/g,"").getRegex(),Me=h(ie).replace(/bull/g,F).replace(/blockCode/g,/(?: {4}| {0,3}\t)/).replace(/fences/g,/ {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g,/ {0,3}>/).replace(/heading/g,/ {0,3}#{1,6}/).replace(/html/g,/ {0,3}<[^\n>]+>\n/).replace(/table/g,/ {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(),Q=/^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,Pe=/^[^\n]+/,U=/(?!\s*\])(?:\\.|[^\[\]\\])+/,Ae=h(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label",U).replace("title",/(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(),Ee=h(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g,F).getRegex(),v="address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul",K=/<!--(?:-?>|[\s\S]*?(?:-->|$))/,Ce=h("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))","i").replace("comment",K).replace("tag",v).replace("attribute",/ +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(),le=h(Q).replace("hr",O).replace("heading"," {0,3}#{1,6}(?:\\s|$)").replace("|lheading","").replace("|table","").replace("blockquote"," {0,3}>").replace("fences"," {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",v).getRegex(),Ie=h(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph",le).getRegex(),X={blockquote:Ie,code:_e,def:Ae,fences:Le,heading:ze,hr:O,html:Ce,lheading:oe,list:Ee,newline:$e,paragraph:le,table:I,text:Pe},re=h("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr",O).replace("heading"," {0,3}#{1,6}(?:\\s|$)").replace("blockquote"," {0,3}>").replace("code","(?: {4}| {0,3}	)[^\\n]").replace("fences"," {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",v).getRegex(),Oe={...X,lheading:Me,table:re,paragraph:h(Q).replace("hr",O).replace("heading"," {0,3}#{1,6}(?:\\s|$)").replace("|lheading","").replace("table",re).replace("blockquote"," {0,3}>").replace("fences"," {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",v).getRegex()},Be={...X,html:h(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment",K).replace(/tag/g,"(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,heading:/^(#{1,6})(.*)(?:\n+|$)/,fences:I,lheading:/^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,paragraph:h(Q).replace("hr",O).replace("heading",` *#{1,6} *[^
]`).replace("lheading",oe).replace("|table","").replace("blockquote"," {0,3}>").replace("|fences","").replace("|list","").replace("|html","").replace("|tag","").getRegex()},qe=/^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,ve=/^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,ae=/^( {2,}|\\)\n(?!\s*$)/,De=/^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,D=/[\p{P}\p{S}]/u,W=/[\s\p{P}\p{S}]/u,ce=/[^\s\p{P}\p{S}]/u,Ze=h(/^((?![*_])punctSpace)/,"u").replace(/punctSpace/g,W).getRegex(),pe=/(?!~)[\p{P}\p{S}]/u,Ge=/(?!~)[\s\p{P}\p{S}]/u,He=/(?:[^\s\p{P}\p{S}]|~)/u,Ne=/\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g,ue=/^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/,je=h(ue,"u").replace(/punct/g,D).getRegex(),Fe=h(ue,"u").replace(/punct/g,pe).getRegex(),he="^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)",Qe=h(he,"gu").replace(/notPunctSpace/g,ce).replace(/punctSpace/g,W).replace(/punct/g,D).getRegex(),Ue=h(he,"gu").replace(/notPunctSpace/g,He).replace(/punctSpace/g,Ge).replace(/punct/g,pe).getRegex(),Ke=h("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)","gu").replace(/notPunctSpace/g,ce).replace(/punctSpace/g,W).replace(/punct/g,D).getRegex(),Xe=h(/\\(punct)/,"gu").replace(/punct/g,D).getRegex(),We=h(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme",/[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email",/[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(),Je=h(K).replace("(?:-->|$)","-->").getRegex(),Ve=h("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment",Je).replace("attribute",/\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(),q=/(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/,Ye=h(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label",q).replace("href",/<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title",/"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(),ke=h(/^!?\[(label)\]\[(ref)\]/).replace("label",q).replace("ref",U).getRegex(),ge=h(/^!?\[(ref)\](?:\[\])?/).replace("ref",U).getRegex(),et=h("reflink|nolink(?!\\()","g").replace("reflink",ke).replace("nolink",ge).getRegex(),J={_backpedal:I,anyPunctuation:Xe,autolink:We,blockSkip:Ne,br:ae,code:ve,del:I,emStrongLDelim:je,emStrongRDelimAst:Qe,emStrongRDelimUnd:Ke,escape:qe,link:Ye,nolink:ge,punctuation:Ze,reflink:ke,reflinkSearch:et,tag:Ve,text:De,url:I},tt={...J,link:h(/^!?\[(label)\]\((.*?)\)/).replace("label",q).getRegex(),reflink:h(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label",q).getRegex()},j={...J,emStrongRDelimAst:Ue,emStrongLDelim:Fe,url:h(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,"i").replace("email",/[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),_backpedal:/(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,del:/^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,text:/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/},nt={...j,br:h(ae).replace("{2,}","*").getRegex(),text:h(j.text).replace("\\b_","\\b_| {2,}\\n").replace(/\{2,\}/g,"*").getRegex()},B={normal:X,gfm:Oe,pedantic:Be},P={normal:J,gfm:j,breaks:nt,pedantic:tt};var st={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},fe=l=>st[l];function R(l,e){if(e){if(m.escapeTest.test(l))return l.replace(m.escapeReplace,fe)}else if(m.escapeTestNoEncode.test(l))return l.replace(m.escapeReplaceNoEncode,fe);return l}function V(l){try{l=encodeURI(l).replace(m.percentDecode,"%")}catch{return null}return l}function Y(l,e){let t=l.replace(m.findPipe,(i,r,o)=>{let a=!1,c=r;for(;--c>=0&&o[c]==="\\";)a=!a;return a?"|":" |"}),n=t.split(m.splitPipe),s=0;if(n[0].trim()||n.shift(),n.length>0&&!n.at(-1)?.trim()&&n.pop(),e)if(n.length>e)n.splice(e);else for(;n.length<e;)n.push("");for(;s<n.length;s++)n[s]=n[s].trim().replace(m.slashPipe,"|");return n}function A(l,e,t){let n=l.length;if(n===0)return"";let s=0;for(;s<n;){let i=l.charAt(n-s-1);if(i===e&&!t)s++;else if(i!==e&&t)s++;else break}return l.slice(0,n-s)}function de(l,e){if(l.indexOf(e[1])===-1)return-1;let t=0;for(let n=0;n<l.length;n++)if(l[n]==="\\")n++;else if(l[n]===e[0])t++;else if(l[n]===e[1]&&(t--,t<0))return n;return t>0?-2:-1}function me(l,e,t,n,s){let i=e.href,r=e.title||null,o=l[1].replace(s.other.outputLinkReplace,"$1");n.state.inLink=!0;let a={type:l[0].charAt(0)==="!"?"image":"link",raw:t,href:i,title:r,text:o,tokens:n.inlineTokens(o)};return n.state.inLink=!1,a}function rt(l,e,t){let n=l.match(t.other.indentCodeCompensation);if(n===null)return e;let s=n[1];return e.split(`
`).map(i=>{let r=i.match(t.other.beginningSpace);if(r===null)return i;let[o]=r;return o.length>=s.length?i.slice(s.length):i}).join(`
`)}var S=class{options;rules;lexer;constructor(e){this.options=e||w}space(e){let t=this.rules.block.newline.exec(e);if(t&&t[0].length>0)return{type:"space",raw:t[0]}}code(e){let t=this.rules.block.code.exec(e);if(t){let n=t[0].replace(this.rules.other.codeRemoveIndent,"");return{type:"code",raw:t[0],codeBlockStyle:"indented",text:this.options.pedantic?n:A(n,`
`)}}}fences(e){let t=this.rules.block.fences.exec(e);if(t){let n=t[0],s=rt(n,t[3]||"",this.rules);return{type:"code",raw:n,lang:t[2]?t[2].trim().replace(this.rules.inline.anyPunctuation,"$1"):t[2],text:s}}}heading(e){let t=this.rules.block.heading.exec(e);if(t){let n=t[2].trim();if(this.rules.other.endingHash.test(n)){let s=A(n,"#");(this.options.pedantic||!s||this.rules.other.endingSpaceChar.test(s))&&(n=s.trim())}return{type:"heading",raw:t[0],depth:t[1].length,text:n,tokens:this.lexer.inline(n)}}}hr(e){let t=this.rules.block.hr.exec(e);if(t)return{type:"hr",raw:A(t[0],`
`)}}blockquote(e){let t=this.rules.block.blockquote.exec(e);if(t){let n=A(t[0],`
`).split(`
`),s="",i="",r=[];for(;n.length>0;){let o=!1,a=[],c;for(c=0;c<n.length;c++)if(this.rules.other.blockquoteStart.test(n[c]))a.push(n[c]),o=!0;else if(!o)a.push(n[c]);else break;n=n.slice(c);let p=a.join(`
`),u=p.replace(this.rules.other.blockquoteSetextReplace,`
    $1`).replace(this.rules.other.blockquoteSetextReplace2,"");s=s?`${s}
${p}`:p,i=i?`${i}
${u}`:u;let d=this.lexer.state.top;if(this.lexer.state.top=!0,this.lexer.blockTokens(u,r,!0),this.lexer.state.top=d,n.length===0)break;let g=r.at(-1);if(g?.type==="code")break;if(g?.type==="blockquote"){let T=g,f=T.raw+`
`+n.join(`
`),y=this.blockquote(f);r[r.length-1]=y,s=s.substring(0,s.length-T.raw.length)+y.raw,i=i.substring(0,i.length-T.text.length)+y.text;break}else if(g?.type==="list"){let T=g,f=T.raw+`
`+n.join(`
`),y=this.list(f);r[r.length-1]=y,s=s.substring(0,s.length-g.raw.length)+y.raw,i=i.substring(0,i.length-T.raw.length)+y.raw,n=f.substring(r.at(-1).raw.length).split(`
`);continue}}return{type:"blockquote",raw:s,tokens:r,text:i}}}list(e){let t=this.rules.block.list.exec(e);if(t){let n=t[1].trim(),s=n.length>1,i={type:"list",raw:"",ordered:s,start:s?+n.slice(0,-1):"",loose:!1,items:[]};n=s?`\\d{1,9}\\${n.slice(-1)}`:`\\${n}`,this.options.pedantic&&(n=s?n:"[*+-]");let r=this.rules.other.listItemRegex(n),o=!1;for(;e;){let c=!1,p="",u="";if(!(t=r.exec(e))||this.rules.block.hr.test(e))break;p=t[0],e=e.substring(p.length);let d=t[2].split(`
`,1)[0].replace(this.rules.other.listReplaceTabs,Z=>" ".repeat(3*Z.length)),g=e.split(`
`,1)[0],T=!d.trim(),f=0;if(this.options.pedantic?(f=2,u=d.trimStart()):T?f=t[1].length+1:(f=t[2].search(this.rules.other.nonSpaceChar),f=f>4?1:f,u=d.slice(f),f+=t[1].length),T&&this.rules.other.blankLine.test(g)&&(p+=g+`
`,e=e.substring(g.length+1),c=!0),!c){let Z=this.rules.other.nextBulletRegex(f),te=this.rules.other.hrRegex(f),ne=this.rules.other.fencesBeginRegex(f),se=this.rules.other.headingBeginRegex(f),xe=this.rules.other.htmlBeginRegex(f);for(;e;){let G=e.split(`
`,1)[0],C;if(g=G,this.options.pedantic?(g=g.replace(this.rules.other.listReplaceNesting,"  "),C=g):C=g.replace(this.rules.other.tabCharGlobal,"    "),ne.test(g)||se.test(g)||xe.test(g)||Z.test(g)||te.test(g))break;if(C.search(this.rules.other.nonSpaceChar)>=f||!g.trim())u+=`
`+C.slice(f);else{if(T||d.replace(this.rules.other.tabCharGlobal,"    ").search(this.rules.other.nonSpaceChar)>=4||ne.test(d)||se.test(d)||te.test(d))break;u+=`
`+g}!T&&!g.trim()&&(T=!0),p+=G+`
`,e=e.substring(G.length+1),d=C.slice(f)}}i.loose||(o?i.loose=!0:this.rules.other.doubleBlankLine.test(p)&&(o=!0));let y=null,ee;this.options.gfm&&(y=this.rules.other.listIsTask.exec(u),y&&(ee=y[0]!=="[ ] ",u=u.replace(this.rules.other.listReplaceTask,""))),i.items.push({type:"list_item",raw:p,task:!!y,checked:ee,loose:!1,text:u,tokens:[]}),i.raw+=p}let a=i.items.at(-1);if(a)a.raw=a.raw.trimEnd(),a.text=a.text.trimEnd();else return;i.raw=i.raw.trimEnd();for(let c=0;c<i.items.length;c++)if(this.lexer.state.top=!1,i.items[c].tokens=this.lexer.blockTokens(i.items[c].text,[]),!i.loose){let p=i.items[c].tokens.filter(d=>d.type==="space"),u=p.length>0&&p.some(d=>this.rules.other.anyLine.test(d.raw));i.loose=u}if(i.loose)for(let c=0;c<i.items.length;c++)i.items[c].loose=!0;return i}}html(e){let t=this.rules.block.html.exec(e);if(t)return{type:"html",block:!0,raw:t[0],pre:t[1]==="pre"||t[1]==="script"||t[1]==="style",text:t[0]}}def(e){let t=this.rules.block.def.exec(e);if(t){let n=t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal," "),s=t[2]?t[2].replace(this.rules.other.hrefBrackets,"$1").replace(this.rules.inline.anyPunctuation,"$1"):"",i=t[3]?t[3].substring(1,t[3].length-1).replace(this.rules.inline.anyPunctuation,"$1"):t[3];return{type:"def",tag:n,raw:t[0],href:s,title:i}}}table(e){let t=this.rules.block.table.exec(e);if(!t||!this.rules.other.tableDelimiter.test(t[2]))return;let n=Y(t[1]),s=t[2].replace(this.rules.other.tableAlignChars,"").split("|"),i=t[3]?.trim()?t[3].replace(this.rules.other.tableRowBlankLine,"").split(`
`):[],r={type:"table",raw:t[0],header:[],align:[],rows:[]};if(n.length===s.length){for(let o of s)this.rules.other.tableAlignRight.test(o)?r.align.push("right"):this.rules.other.tableAlignCenter.test(o)?r.align.push("center"):this.rules.other.tableAlignLeft.test(o)?r.align.push("left"):r.align.push(null);for(let o=0;o<n.length;o++)r.header.push({text:n[o],tokens:this.lexer.inline(n[o]),header:!0,align:r.align[o]});for(let o of i)r.rows.push(Y(o,r.header.length).map((a,c)=>({text:a,tokens:this.lexer.inline(a),header:!1,align:r.align[c]})));return r}}lheading(e){let t=this.rules.block.lheading.exec(e);if(t)return{type:"heading",raw:t[0],depth:t[2].charAt(0)==="="?1:2,text:t[1],tokens:this.lexer.inline(t[1])}}paragraph(e){let t=this.rules.block.paragraph.exec(e);if(t){let n=t[1].charAt(t[1].length-1)===`
`?t[1].slice(0,-1):t[1];return{type:"paragraph",raw:t[0],text:n,tokens:this.lexer.inline(n)}}}text(e){let t=this.rules.block.text.exec(e);if(t)return{type:"text",raw:t[0],text:t[0],tokens:this.lexer.inline(t[0])}}escape(e){let t=this.rules.inline.escape.exec(e);if(t)return{type:"escape",raw:t[0],text:t[1]}}tag(e){let t=this.rules.inline.tag.exec(e);if(t)return!this.lexer.state.inLink&&this.rules.other.startATag.test(t[0])?this.lexer.state.inLink=!0:this.lexer.state.inLink&&this.rules.other.endATag.test(t[0])&&(this.lexer.state.inLink=!1),!this.lexer.state.inRawBlock&&this.rules.other.startPreScriptTag.test(t[0])?this.lexer.state.inRawBlock=!0:this.lexer.state.inRawBlock&&this.rules.other.endPreScriptTag.test(t[0])&&(this.lexer.state.inRawBlock=!1),{type:"html",raw:t[0],inLink:this.lexer.state.inLink,inRawBlock:this.lexer.state.inRawBlock,block:!1,text:t[0]}}link(e){let t=this.rules.inline.link.exec(e);if(t){let n=t[2].trim();if(!this.options.pedantic&&this.rules.other.startAngleBracket.test(n)){if(!this.rules.other.endAngleBracket.test(n))return;let r=A(n.slice(0,-1),"\\");if((n.length-r.length)%2===0)return}else{let r=de(t[2],"()");if(r===-2)return;if(r>-1){let a=(t[0].indexOf("!")===0?5:4)+t[1].length+r;t[2]=t[2].substring(0,r),t[0]=t[0].substring(0,a).trim(),t[3]=""}}let s=t[2],i="";if(this.options.pedantic){let r=this.rules.other.pedanticHrefTitle.exec(s);r&&(s=r[1],i=r[3])}else i=t[3]?t[3].slice(1,-1):"";return s=s.trim(),this.rules.other.startAngleBracket.test(s)&&(this.options.pedantic&&!this.rules.other.endAngleBracket.test(n)?s=s.slice(1):s=s.slice(1,-1)),me(t,{href:s&&s.replace(this.rules.inline.anyPunctuation,"$1"),title:i&&i.replace(this.rules.inline.anyPunctuation,"$1")},t[0],this.lexer,this.rules)}}reflink(e,t){let n;if((n=this.rules.inline.reflink.exec(e))||(n=this.rules.inline.nolink.exec(e))){let s=(n[2]||n[1]).replace(this.rules.other.multipleSpaceGlobal," "),i=t[s.toLowerCase()];if(!i){let r=n[0].charAt(0);return{type:"text",raw:r,text:r}}return me(n,i,n[0],this.lexer,this.rules)}}emStrong(e,t,n=""){let s=this.rules.inline.emStrongLDelim.exec(e);if(!s||s[3]&&n.match(this.rules.other.unicodeAlphaNumeric))return;if(!(s[1]||s[2]||"")||!n||this.rules.inline.punctuation.exec(n)){let r=[...s[0]].length-1,o,a,c=r,p=0,u=s[0][0]==="*"?this.rules.inline.emStrongRDelimAst:this.rules.inline.emStrongRDelimUnd;for(u.lastIndex=0,t=t.slice(-1*e.length+r);(s=u.exec(t))!=null;){if(o=s[1]||s[2]||s[3]||s[4]||s[5]||s[6],!o)continue;if(a=[...o].length,s[3]||s[4]){c+=a;continue}else if((s[5]||s[6])&&r%3&&!((r+a)%3)){p+=a;continue}if(c-=a,c>0)continue;a=Math.min(a,a+c+p);let d=[...s[0]][0].length,g=e.slice(0,r+s.index+d+a);if(Math.min(r,a)%2){let f=g.slice(1,-1);return{type:"em",raw:g,text:f,tokens:this.lexer.inlineTokens(f)}}let T=g.slice(2,-2);return{type:"strong",raw:g,text:T,tokens:this.lexer.inlineTokens(T)}}}}codespan(e){let t=this.rules.inline.code.exec(e);if(t){let n=t[2].replace(this.rules.other.newLineCharGlobal," "),s=this.rules.other.nonSpaceChar.test(n),i=this.rules.other.startingSpaceChar.test(n)&&this.rules.other.endingSpaceChar.test(n);return s&&i&&(n=n.substring(1,n.length-1)),{type:"codespan",raw:t[0],text:n}}}br(e){let t=this.rules.inline.br.exec(e);if(t)return{type:"br",raw:t[0]}}del(e){let t=this.rules.inline.del.exec(e);if(t)return{type:"del",raw:t[0],text:t[2],tokens:this.lexer.inlineTokens(t[2])}}autolink(e){let t=this.rules.inline.autolink.exec(e);if(t){let n,s;return t[2]==="@"?(n=t[1],s="mailto:"+n):(n=t[1],s=n),{type:"link",raw:t[0],text:n,href:s,tokens:[{type:"text",raw:n,text:n}]}}}url(e){let t;if(t=this.rules.inline.url.exec(e)){let n,s;if(t[2]==="@")n=t[0],s="mailto:"+n;else{let i;do i=t[0],t[0]=this.rules.inline._backpedal.exec(t[0])?.[0]??"";while(i!==t[0]);n=t[0],t[1]==="www."?s="http://"+t[0]:s=t[0]}return{type:"link",raw:t[0],text:n,href:s,tokens:[{type:"text",raw:n,text:n}]}}}inlineText(e){let t=this.rules.inline.text.exec(e);if(t){let n=this.lexer.state.inRawBlock;return{type:"text",raw:t[0],text:t[0],escaped:n}}}};var x=class l{tokens;options;state;tokenizer;inlineQueue;constructor(e){this.tokens=[],this.tokens.links=Object.create(null),this.options=e||w,this.options.tokenizer=this.options.tokenizer||new S,this.tokenizer=this.options.tokenizer,this.tokenizer.options=this.options,this.tokenizer.lexer=this,this.inlineQueue=[],this.state={inLink:!1,inRawBlock:!1,top:!0};let t={other:m,block:B.normal,inline:P.normal};this.options.pedantic?(t.block=B.pedantic,t.inline=P.pedantic):this.options.gfm&&(t.block=B.gfm,this.options.breaks?t.inline=P.breaks:t.inline=P.gfm),this.tokenizer.rules=t}static get rules(){return{block:B,inline:P}}static lex(e,t){return new l(t).lex(e)}static lexInline(e,t){return new l(t).inlineTokens(e)}lex(e){e=e.replace(m.carriageReturn,`
`),this.blockTokens(e,this.tokens);for(let t=0;t<this.inlineQueue.length;t++){let n=this.inlineQueue[t];this.inlineTokens(n.src,n.tokens)}return this.inlineQueue=[],this.tokens}blockTokens(e,t=[],n=!1){for(this.options.pedantic&&(e=e.replace(m.tabCharGlobal,"    ").replace(m.spaceLine,""));e;){let s;if(this.options.extensions?.block?.some(r=>(s=r.call({lexer:this},e,t))?(e=e.substring(s.raw.length),t.push(s),!0):!1))continue;if(s=this.tokenizer.space(e)){e=e.substring(s.raw.length);let r=t.at(-1);s.raw.length===1&&r!==void 0?r.raw+=`
`:t.push(s);continue}if(s=this.tokenizer.code(e)){e=e.substring(s.raw.length);let r=t.at(-1);r?.type==="paragraph"||r?.type==="text"?(r.raw+=`
`+s.raw,r.text+=`
`+s.text,this.inlineQueue.at(-1).src=r.text):t.push(s);continue}if(s=this.tokenizer.fences(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.heading(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.hr(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.blockquote(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.list(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.html(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.def(e)){e=e.substring(s.raw.length);let r=t.at(-1);r?.type==="paragraph"||r?.type==="text"?(r.raw+=`
`+s.raw,r.text+=`
`+s.raw,this.inlineQueue.at(-1).src=r.text):this.tokens.links[s.tag]||(this.tokens.links[s.tag]={href:s.href,title:s.title});continue}if(s=this.tokenizer.table(e)){e=e.substring(s.raw.length),t.push(s);continue}if(s=this.tokenizer.lheading(e)){e=e.substring(s.raw.length),t.push(s);continue}let i=e;if(this.options.extensions?.startBlock){let r=1/0,o=e.slice(1),a;this.options.extensions.startBlock.forEach(c=>{a=c.call({lexer:this},o),typeof a=="number"&&a>=0&&(r=Math.min(r,a))}),r<1/0&&r>=0&&(i=e.substring(0,r+1))}if(this.state.top&&(s=this.tokenizer.paragraph(i))){let r=t.at(-1);n&&r?.type==="paragraph"?(r.raw+=`
`+s.raw,r.text+=`
`+s.text,this.inlineQueue.pop(),this.inlineQueue.at(-1).src=r.text):t.push(s),n=i.length!==e.length,e=e.substring(s.raw.length);continue}if(s=this.tokenizer.text(e)){e=e.substring(s.raw.length);let r=t.at(-1);r?.type==="text"?(r.raw+=`
`+s.raw,r.text+=`
`+s.text,this.inlineQueue.pop(),this.inlineQueue.at(-1).src=r.text):t.push(s);continue}if(e){let r="Infinite loop on byte: "+e.charCodeAt(0);if(this.options.silent){console.error(r);break}else throw new Error(r)}}return this.state.top=!0,t}inline(e,t=[]){return this.inlineQueue.push({src:e,tokens:t}),t}inlineTokens(e,t=[]){let n=e,s=null;if(this.tokens.links){let o=Object.keys(this.tokens.links);if(o.length>0)for(;(s=this.tokenizer.rules.inline.reflinkSearch.exec(n))!=null;)o.includes(s[0].slice(s[0].lastIndexOf("[")+1,-1))&&(n=n.slice(0,s.index)+"["+"a".repeat(s[0].length-2)+"]"+n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex))}for(;(s=this.tokenizer.rules.inline.anyPunctuation.exec(n))!=null;)n=n.slice(0,s.index)+"++"+n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);for(;(s=this.tokenizer.rules.inline.blockSkip.exec(n))!=null;)n=n.slice(0,s.index)+"["+"a".repeat(s[0].length-2)+"]"+n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);let i=!1,r="";for(;e;){i||(r=""),i=!1;let o;if(this.options.extensions?.inline?.some(c=>(o=c.call({lexer:this},e,t))?(e=e.substring(o.raw.length),t.push(o),!0):!1))continue;if(o=this.tokenizer.escape(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.tag(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.link(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.reflink(e,this.tokens.links)){e=e.substring(o.raw.length);let c=t.at(-1);o.type==="text"&&c?.type==="text"?(c.raw+=o.raw,c.text+=o.text):t.push(o);continue}if(o=this.tokenizer.emStrong(e,n,r)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.codespan(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.br(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.del(e)){e=e.substring(o.raw.length),t.push(o);continue}if(o=this.tokenizer.autolink(e)){e=e.substring(o.raw.length),t.push(o);continue}if(!this.state.inLink&&(o=this.tokenizer.url(e))){e=e.substring(o.raw.length),t.push(o);continue}let a=e;if(this.options.extensions?.startInline){let c=1/0,p=e.slice(1),u;this.options.extensions.startInline.forEach(d=>{u=d.call({lexer:this},p),typeof u=="number"&&u>=0&&(c=Math.min(c,u))}),c<1/0&&c>=0&&(a=e.substring(0,c+1))}if(o=this.tokenizer.inlineText(a)){e=e.substring(o.raw.length),o.raw.slice(-1)!=="_"&&(r=o.raw.slice(-1)),i=!0;let c=t.at(-1);c?.type==="text"?(c.raw+=o.raw,c.text+=o.text):t.push(o);continue}if(e){let c="Infinite loop on byte: "+e.charCodeAt(0);if(this.options.silent){console.error(c);break}else throw new Error(c)}}return t}};var $=class{options;parser;constructor(e){this.options=e||w}space(e){return""}code({text:e,lang:t,escaped:n}){let s=(t||"").match(m.notSpaceStart)?.[0],i=e.replace(m.endingNewline,"")+`
`;return s?'<pre><code class="language-'+R(s)+'">'+(n?i:R(i,!0))+`</code></pre>
`:"<pre><code>"+(n?i:R(i,!0))+`</code></pre>
`}blockquote({tokens:e}){return`<blockquote>
${this.parser.parse(e)}</blockquote>
`}html({text:e}){return e}heading({tokens:e,depth:t}){return`<h${t}>${this.parser.parseInline(e)}</h${t}>
`}hr(e){return`<hr>
`}list(e){let t=e.ordered,n=e.start,s="";for(let o=0;o<e.items.length;o++){let a=e.items[o];s+=this.listitem(a)}let i=t?"ol":"ul",r=t&&n!==1?' start="'+n+'"':"";return"<"+i+r+`>
`+s+"</"+i+`>
`}listitem(e){let t="";if(e.task){let n=this.checkbox({checked:!!e.checked});e.loose?e.tokens[0]?.type==="paragraph"?(e.tokens[0].text=n+" "+e.tokens[0].text,e.tokens[0].tokens&&e.tokens[0].tokens.length>0&&e.tokens[0].tokens[0].type==="text"&&(e.tokens[0].tokens[0].text=n+" "+R(e.tokens[0].tokens[0].text),e.tokens[0].tokens[0].escaped=!0)):e.tokens.unshift({type:"text",raw:n+" ",text:n+" ",escaped:!0}):t+=n+" "}return t+=this.parser.parse(e.tokens,!!e.loose),`<li>${t}</li>
`}checkbox({checked:e}){return"<input "+(e?'checked="" ':"")+'disabled="" type="checkbox">'}paragraph({tokens:e}){return`<p>${this.parser.parseInline(e)}</p>
`}table(e){let t="",n="";for(let i=0;i<e.header.length;i++)n+=this.tablecell(e.header[i]);t+=this.tablerow({text:n});let s="";for(let i=0;i<e.rows.length;i++){let r=e.rows[i];n="";for(let o=0;o<r.length;o++)n+=this.tablecell(r[o]);s+=this.tablerow({text:n})}return s&&(s=`<tbody>${s}</tbody>`),`<table>
<thead>
`+t+`</thead>
`+s+`</table>
`}tablerow({text:e}){return`<tr>
${e}</tr>
`}tablecell(e){let t=this.parser.parseInline(e.tokens),n=e.header?"th":"td";return(e.align?`<${n} align="${e.align}">`:`<${n}>`)+t+`</${n}>
`}strong({tokens:e}){return`<strong>${this.parser.parseInline(e)}</strong>`}em({tokens:e}){return`<em>${this.parser.parseInline(e)}</em>`}codespan({text:e}){return`<code>${R(e,!0)}</code>`}br(e){return"<br>"}del({tokens:e}){return`<del>${this.parser.parseInline(e)}</del>`}link({href:e,title:t,tokens:n}){let s=this.parser.parseInline(n),i=V(e);if(i===null)return s;e=i;let r='<a href="'+e+'"';return t&&(r+=' title="'+R(t)+'"'),r+=">"+s+"</a>",r}image({href:e,title:t,text:n,tokens:s}){s&&(n=this.parser.parseInline(s,this.parser.textRenderer));let i=V(e);if(i===null)return R(n);e=i;let r=`<img src="${e}" alt="${n}"`;return t&&(r+=` title="${R(t)}"`),r+=">",r}text(e){return"tokens"in e&&e.tokens?this.parser.parseInline(e.tokens):"escaped"in e&&e.escaped?e.text:R(e.text)}};var _=class{strong({text:e}){return e}em({text:e}){return e}codespan({text:e}){return e}del({text:e}){return e}html({text:e}){return e}text({text:e}){return e}link({text:e}){return""+e}image({text:e}){return""+e}br(){return""}};var b=class l{options;renderer;textRenderer;constructor(e){this.options=e||w,this.options.renderer=this.options.renderer||new $,this.renderer=this.options.renderer,this.renderer.options=this.options,this.renderer.parser=this,this.textRenderer=new _}static parse(e,t){return new l(t).parse(e)}static parseInline(e,t){return new l(t).parseInline(e)}parse(e,t=!0){let n="";for(let s=0;s<e.length;s++){let i=e[s];if(this.options.extensions?.renderers?.[i.type]){let o=i,a=this.options.extensions.renderers[o.type].call({parser:this},o);if(a!==!1||!["space","hr","heading","code","table","blockquote","list","html","paragraph","text"].includes(o.type)){n+=a||"";continue}}let r=i;switch(r.type){case"space":{n+=this.renderer.space(r);continue}case"hr":{n+=this.renderer.hr(r);continue}case"heading":{n+=this.renderer.heading(r);continue}case"code":{n+=this.renderer.code(r);continue}case"table":{n+=this.renderer.table(r);continue}case"blockquote":{n+=this.renderer.blockquote(r);continue}case"list":{n+=this.renderer.list(r);continue}case"html":{n+=this.renderer.html(r);continue}case"paragraph":{n+=this.renderer.paragraph(r);continue}case"text":{let o=r,a=this.renderer.text(o);for(;s+1<e.length&&e[s+1].type==="text";)o=e[++s],a+=`
`+this.renderer.text(o);t?n+=this.renderer.paragraph({type:"paragraph",raw:a,text:a,tokens:[{type:"text",raw:a,text:a,escaped:!0}]}):n+=a;continue}default:{let o='Token with "'+r.type+'" type was not found.';if(this.options.silent)return console.error(o),"";throw new Error(o)}}}return n}parseInline(e,t=this.renderer){let n="";for(let s=0;s<e.length;s++){let i=e[s];if(this.options.extensions?.renderers?.[i.type]){let o=this.options.extensions.renderers[i.type].call({parser:this},i);if(o!==!1||!["escape","html","link","image","strong","em","codespan","br","del","text"].includes(i.type)){n+=o||"";continue}}let r=i;switch(r.type){case"escape":{n+=t.text(r);break}case"html":{n+=t.html(r);break}case"link":{n+=t.link(r);break}case"image":{n+=t.image(r);break}case"strong":{n+=t.strong(r);break}case"em":{n+=t.em(r);break}case"codespan":{n+=t.codespan(r);break}case"br":{n+=t.br(r);break}case"del":{n+=t.del(r);break}case"text":{n+=t.text(r);break}default:{let o='Token with "'+r.type+'" type was not found.';if(this.options.silent)return console.error(o),"";throw new Error(o)}}}return n}};var L=class{options;block;constructor(e){this.options=e||w}static passThroughHooks=new Set(["preprocess","postprocess","processAllTokens"]);preprocess(e){return e}postprocess(e){return e}processAllTokens(e){return e}provideLexer(){return this.block?x.lex:x.lexInline}provideParser(){return this.block?b.parse:b.parseInline}};var E=class{defaults=z();options=this.setOptions;parse=this.parseMarkdown(!0);parseInline=this.parseMarkdown(!1);Parser=b;Renderer=$;TextRenderer=_;Lexer=x;Tokenizer=S;Hooks=L;constructor(...e){this.use(...e)}walkTokens(e,t){let n=[];for(let s of e)switch(n=n.concat(t.call(this,s)),s.type){case"table":{let i=s;for(let r of i.header)n=n.concat(this.walkTokens(r.tokens,t));for(let r of i.rows)for(let o of r)n=n.concat(this.walkTokens(o.tokens,t));break}case"list":{let i=s;n=n.concat(this.walkTokens(i.items,t));break}default:{let i=s;this.defaults.extensions?.childTokens?.[i.type]?this.defaults.extensions.childTokens[i.type].forEach(r=>{let o=i[r].flat(1/0);n=n.concat(this.walkTokens(o,t))}):i.tokens&&(n=n.concat(this.walkTokens(i.tokens,t)))}}return n}use(...e){let t=this.defaults.extensions||{renderers:{},childTokens:{}};return e.forEach(n=>{let s={...n};if(s.async=this.defaults.async||s.async||!1,n.extensions&&(n.extensions.forEach(i=>{if(!i.name)throw new Error("extension name required");if("renderer"in i){let r=t.renderers[i.name];r?t.renderers[i.name]=function(...o){let a=i.renderer.apply(this,o);return a===!1&&(a=r.apply(this,o)),a}:t.renderers[i.name]=i.renderer}if("tokenizer"in i){if(!i.level||i.level!=="block"&&i.level!=="inline")throw new Error("extension level must be 'block' or 'inline'");let r=t[i.level];r?r.unshift(i.tokenizer):t[i.level]=[i.tokenizer],i.start&&(i.level==="block"?t.startBlock?t.startBlock.push(i.start):t.startBlock=[i.start]:i.level==="inline"&&(t.startInline?t.startInline.push(i.start):t.startInline=[i.start]))}"childTokens"in i&&i.childTokens&&(t.childTokens[i.name]=i.childTokens)}),s.extensions=t),n.renderer){let i=this.defaults.renderer||new $(this.defaults);for(let r in n.renderer){if(!(r in i))throw new Error(`renderer '${r}' does not exist`);if(["options","parser"].includes(r))continue;let o=r,a=n.renderer[o],c=i[o];i[o]=(...p)=>{let u=a.apply(i,p);return u===!1&&(u=c.apply(i,p)),u||""}}s.renderer=i}if(n.tokenizer){let i=this.defaults.tokenizer||new S(this.defaults);for(let r in n.tokenizer){if(!(r in i))throw new Error(`tokenizer '${r}' does not exist`);if(["options","rules","lexer"].includes(r))continue;let o=r,a=n.tokenizer[o],c=i[o];i[o]=(...p)=>{let u=a.apply(i,p);return u===!1&&(u=c.apply(i,p)),u}}s.tokenizer=i}if(n.hooks){let i=this.defaults.hooks||new L;for(let r in n.hooks){if(!(r in i))throw new Error(`hook '${r}' does not exist`);if(["options","block"].includes(r))continue;let o=r,a=n.hooks[o],c=i[o];L.passThroughHooks.has(r)?i[o]=p=>{if(this.defaults.async)return Promise.resolve(a.call(i,p)).then(d=>c.call(i,d));let u=a.call(i,p);return c.call(i,u)}:i[o]=(...p)=>{let u=a.apply(i,p);return u===!1&&(u=c.apply(i,p)),u}}s.hooks=i}if(n.walkTokens){let i=this.defaults.walkTokens,r=n.walkTokens;s.walkTokens=function(o){let a=[];return a.push(r.call(this,o)),i&&(a=a.concat(i.call(this,o))),a}}this.defaults={...this.defaults,...s}}),this}setOptions(e){return this.defaults={...this.defaults,...e},this}lexer(e,t){return x.lex(e,t??this.defaults)}parser(e,t){return b.parse(e,t??this.defaults)}parseMarkdown(e){return(n,s)=>{let i={...s},r={...this.defaults,...i},o=this.onError(!!r.silent,!!r.async);if(this.defaults.async===!0&&i.async===!1)return o(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));if(typeof n>"u"||n===null)return o(new Error("marked(): input parameter is undefined or null"));if(typeof n!="string")return o(new Error("marked(): input parameter is of type "+Object.prototype.toString.call(n)+", string expected"));r.hooks&&(r.hooks.options=r,r.hooks.block=e);let a=r.hooks?r.hooks.provideLexer():e?x.lex:x.lexInline,c=r.hooks?r.hooks.provideParser():e?b.parse:b.parseInline;if(r.async)return Promise.resolve(r.hooks?r.hooks.preprocess(n):n).then(p=>a(p,r)).then(p=>r.hooks?r.hooks.processAllTokens(p):p).then(p=>r.walkTokens?Promise.all(this.walkTokens(p,r.walkTokens)).then(()=>p):p).then(p=>c(p,r)).then(p=>r.hooks?r.hooks.postprocess(p):p).catch(o);try{r.hooks&&(n=r.hooks.preprocess(n));let p=a(n,r);r.hooks&&(p=r.hooks.processAllTokens(p)),r.walkTokens&&this.walkTokens(p,r.walkTokens);let u=c(p,r);return r.hooks&&(u=r.hooks.postprocess(u)),u}catch(p){return o(p)}}}onError(e,t){return n=>{if(n.message+=`
Please report this to https://github.com/markedjs/marked.`,e){let s="<p>An error occurred:</p><pre>"+R(n.message+"",!0)+"</pre>";return t?Promise.resolve(s):s}if(t)return Promise.reject(n);throw n}}};var M=new E;function k(l,e){return M.parse(l,e)}k.options=k.setOptions=function(l){return M.setOptions(l),k.defaults=M.defaults,N(k.defaults),k};k.getDefaults=z;k.defaults=w;k.use=function(...l){return M.use(...l),k.defaults=M.defaults,N(k.defaults),k};k.walkTokens=function(l,e){return M.walkTokens(l,e)};k.parseInline=M.parseInline;k.Parser=b;k.parser=b.parse;k.Renderer=$;k.TextRenderer=_;k.Lexer=x;k.lexer=x.lex;k.Tokenizer=S;k.Hooks=L;k.parse=k;var it=k.options,ot=k.setOptions,lt=k.use,at=k.walkTokens,ct=k.parseInline,pt=k,ut=b.parse,ht=x.lex;

if(__exports != exports)module.exports = exports;return module.exports}));
